/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/sven/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1007);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(903)();
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(94);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = function (obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
};

exports.__esModule = true;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(253);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(29);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  (function () {
    var printWarning = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning = function warning(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning.apply(undefined, [format].concat(args));
      }
    };
  })();
}

module.exports = warning;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(521), __esModule: true };

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(158);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sheetsManager = undefined;

var _keys = __webpack_require__(53);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(37);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(38);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(39);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(41);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(40);

var _inherits3 = _interopRequireDefault(_inherits2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _map = __webpack_require__(464);

var _map2 = _interopRequireDefault(_map);

var _minSafeInteger = __webpack_require__(465);

var _minSafeInteger2 = _interopRequireDefault(_minSafeInteger);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

var _hoistNonReactStatics = __webpack_require__(727);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _wrapDisplayName = __webpack_require__(123);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _createEagerFactory = __webpack_require__(157);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

var _getDisplayName = __webpack_require__(447);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

var _contextTypes = __webpack_require__(972);

var _contextTypes2 = _interopRequireDefault(_contextTypes);

var _jss = __webpack_require__(437);

var _jss2 = _interopRequireDefault(_jss);

var _ns = __webpack_require__(438);

var ns = _interopRequireWildcard(_ns);

var _createMuiTheme = __webpack_require__(411);

var _createMuiTheme2 = _interopRequireDefault(_createMuiTheme);

var _themeListener = __webpack_require__(412);

var _themeListener2 = _interopRequireDefault(_themeListener);

var _createGenerateClassName = __webpack_require__(881);

var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);

var _getStylesCreator = __webpack_require__(885);

var _getStylesCreator2 = _interopRequireDefault(_getStylesCreator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_ComponentType = __webpack_require__(0).func; //  weak

// Use a singleton or the provided one by the context.
var generateClassName = (0, _createGenerateClassName2.default)();

// Global index counter to preserve source order.
// As we create the style sheet during componentWillMount lifecycle,
// children are handled after the parents, so the order of style elements would
// be parent->child. It is a problem though when a parent passes a className
// which needs to override any childs styles. StyleSheet of the child has a higher
// specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = _minSafeInteger2.default;

var sheetsManager = exports.sheetsManager = new _map2.default();

// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};

// In order to have self-supporting components, we rely on default theme when not provided.
var defaultTheme = void 0;

function getDefaultTheme() {
  if (defaultTheme) {
    return defaultTheme;
  }

  defaultTheme = (0, _createMuiTheme2.default)();
  return defaultTheme;
}

// Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new, with a `classes` property.
function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  function enhance(BaseComponent) {
    var _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === undefined ? false : _options$withTheme,
        name = options.name,
        styleSheetOptions = (0, _objectWithoutProperties3.default)(options, ['withTheme', 'name']);

    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    var stylesCreator = (0, _getStylesCreator2.default)(stylesOrCreator);
    var listenToTheme = stylesCreator.themingEnabled || withTheme || typeof name === 'string';

    if (stylesCreator.options.index === undefined) {
      indexCounter += 1;
      stylesCreator.options.index = indexCounter;
    }

     false ? (0, _warning2.default)(indexCounter < 0, ['Material-UI: you might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join(' ')) : void 0;

    var Style = function (_React$Component) {
      (0, _inherits3.default)(Style, _React$Component);

      function Style(props, context) {
        (0, _classCallCheck3.default)(this, Style);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Style.__proto__ || (0, _getPrototypeOf2.default)(Style)).call(this, props, context));

        _this.state = {};
        _this.unsubscribeId = null;
        _this.jss = null;
        _this.sheetsManager = null;
        _this.stylesCreatorSaved = null;
        _this.theme = null;
        _this.sheetOptions = null;
        _this.theme = null;

        _this.jss = _this.context[ns.jss] || _jss2.default;
        _this.sheetsManager = _this.context.sheetsManager || sheetsManager;
        // Attach the stylesCreator to the instance of the component as in the context
        // of react-hot-loader the hooks can be executed in a different closure context:
        // https://github.com/gaearon/react-hot-loader/blob/master/src/patch.dev.js#L107
        _this.stylesCreatorSaved = stylesCreator;
        _this.sheetOptions = (0, _extends3.default)({
          generateClassName: generateClassName
        }, _this.context[ns.sheetOptions]);
        // We use || as it's lazy evaluated.
        _this.theme = listenToTheme ? _themeListener2.default.initial(context) || getDefaultTheme() : noopTheme;
        return _this;
      }

      // Exposed for test purposes.


      // Exposed for tests purposes


      (0, _createClass3.default)(Style, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          this.attach(this.theme);
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          if (!listenToTheme) {
            return;
          }

          this.unsubscribeId = _themeListener2.default.subscribe(this.context, function (theme) {
            var oldTheme = _this2.theme;
            _this2.theme = theme;
            _this2.attach(_this2.theme);

            // Rerender the component so the underlying component gets the theme update.
            _this2.setState({}, function () {
              _this2.detach(oldTheme);
            });
          });
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.detach(this.theme);

          if (this.unsubscribeId !== null) {
            _themeListener2.default.unsubscribe(this.context, this.unsubscribeId);
          }
        }
      }, {
        key: 'attach',
        value: function attach(theme) {
          var stylesCreatorSaved = this.stylesCreatorSaved;
          var sheetManager = this.sheetsManager.get(stylesCreatorSaved);

          if (!sheetManager) {
            sheetManager = new _map2.default();
            this.sheetsManager.set(stylesCreatorSaved, sheetManager);
          }

          var sheetManagerTheme = sheetManager.get(theme);

          if (!sheetManagerTheme) {
            sheetManagerTheme = {
              refs: 0,
              sheet: null
            };
            sheetManager.set(theme, sheetManagerTheme);
          }

          if (sheetManagerTheme.refs === 0) {
            var styles = stylesCreatorSaved.create(theme, name);
            var _meta = void 0;

            if (false) {
              _meta = name || (0, _getDisplayName2.default)(BaseComponent);
              // Sanitize the string as will be used in development to prefix the generated
              // class name.
              _meta = _meta.replace(new RegExp(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g), '-');
            }

            var sheet = this.jss.createStyleSheet(styles, (0, _extends3.default)({
              meta: _meta,
              link: false
            }, this.sheetOptions, stylesCreatorSaved.options, {
              name: name
            }, styleSheetOptions));

            sheetManagerTheme.sheet = sheet;
            sheet.attach();

            var sheetsRegistry = this.context[ns.sheetsRegistry];
            if (sheetsRegistry) {
              sheetsRegistry.add(sheet);
            }
          }

          sheetManagerTheme.refs += 1;
        }
      }, {
        key: 'detach',
        value: function detach(theme) {
          var stylesCreatorSaved = this.stylesCreatorSaved;
          var sheetManager = this.sheetsManager.get(stylesCreatorSaved);
          var sheetManagerTheme = sheetManager.get(theme);

          sheetManagerTheme.refs -= 1;

          if (sheetManagerTheme.refs === 0) {
            sheetManager.delete(theme);
            this.jss.removeStyleSheet(sheetManagerTheme.sheet);
            var sheetsRegistry = this.context[ns.sheetsRegistry];
            if (sheetsRegistry) {
              sheetsRegistry.remove(sheetManagerTheme.sheet);
            }
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var _props = this.props,
              classesProp = _props.classes,
              innerRef = _props.innerRef,
              other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'innerRef']);


          var classes = void 0;
          var sheetManager = this.sheetsManager.get(this.stylesCreatorSaved);
          var sheetsManagerTheme = sheetManager.get(this.theme);
          var renderedClasses = sheetsManagerTheme.sheet.classes;

          if (classesProp) {
            classes = (0, _extends3.default)({}, renderedClasses, (0, _keys2.default)(classesProp).reduce(function (accumulator, key) {
               false ? (0, _warning2.default)(renderedClasses[key], ['Material-UI: the key `' + key + '` ' + ('provided to the classes property is not implemented in ' + (0, _getDisplayName2.default)(BaseComponent) + '.'), 'You can only override one of the following: ' + (0, _keys2.default)(renderedClasses).join(',')].join('\n')) : void 0;

               false ? (0, _warning2.default)(!classesProp[key] || typeof classesProp[key] === 'string', ['Material-UI: the key `' + key + '` ' + ('provided to the classes property is not valid for ' + (0, _getDisplayName2.default)(BaseComponent) + '.'), 'You need to provide a non empty string instead of: ' + classesProp[key] + '.'].join('\n')) : void 0;

              if (classesProp[key]) {
                accumulator[key] = renderedClasses[key] + ' ' + classesProp[key];
              }

              return accumulator;
            }, {}));
          } else {
            classes = renderedClasses;
          }

          var more = {};

          // Provide the theme to the wrapped component.
          // So we don't have to use the `withTheme()` Higher-order component.
          if (withTheme) {
            more.theme = this.theme;
          }

          return factory((0, _extends3.default)({
            classes: classes,
            ref: innerRef
          }, more, other));
        }
      }]);
      return Style;
    }(_react2.default.Component);

    Style.contextTypes = (0, _extends3.default)({
      sheetsManager: _propTypes2.default.object
    }, _contextTypes2.default, listenToTheme ? _themeListener2.default.contextTypes : {});
    Style.Naked = BaseComponent;


    Style.contextTypes = (0, _extends3.default)({
      sheetsManager: _propTypes2.default.object
    }, _contextTypes2.default, listenToTheme ? _themeListener2.default.contextTypes : {});

    (0, _hoistNonReactStatics2.default)(Style, BaseComponent);

    // Higher specificity
    Style.options = options;

    if (false) {
      Style.displayName = (0, _wrapDisplayName2.default)(BaseComponent, 'withStyles');
    }

    return Style;
  }

  return enhance;
}

exports.default = withStyles;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(520), __esModule: true };

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var DOMProperty = __webpack_require__(92);
var ReactDOMComponentFlags = __webpack_require__(419);

var invariant = __webpack_require__(3);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2)['default'];

var _interopRequireWildcard = __webpack_require__(25)['default'];

var _defaults = __webpack_require__(45)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _Arrays = __webpack_require__(728);

var _Arrays2 = _interopRequireDefault(_Arrays);

var _Map = __webpack_require__(70);

var _Map2 = _interopRequireDefault(_Map);

var _PriorityQueue = __webpack_require__(729);

var _PriorityQueue2 = _interopRequireDefault(_PriorityQueue);

var _Set = __webpack_require__(84);

var _Set2 = _interopRequireDefault(_Set);

var _clone = __webpack_require__(731);

var _clone2 = _interopRequireDefault(_clone);

var _clear = __webpack_require__(341);

var _clear2 = _interopRequireDefault(_clear);

var _deepcopy = __webpack_require__(732);

var _deepcopy2 = _interopRequireDefault(_deepcopy);

var _deepmerge = __webpack_require__(733);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _gcd = __webpack_require__(735);

var _gcd2 = _interopRequireDefault(_gcd);

var _genCombinations = __webpack_require__(736);

var _genCombinations2 = _interopRequireDefault(_genCombinations);

var _genPermutations = __webpack_require__(737);

var _genPermutations2 = _interopRequireDefault(_genPermutations);

var _genRange = __webpack_require__(343);

var _genRange2 = _interopRequireDefault(_genRange);

var _getDefault = __webpack_require__(738);

var _getDefault2 = _interopRequireDefault(_getDefault);

var _fillArray = __webpack_require__(342);

var _fillArray2 = _interopRequireDefault(_fillArray);

var _forEach = __webpack_require__(211);

var _forEach2 = _interopRequireDefault(_forEach);

var _isArrayLike = __webpack_require__(85);

var _isArrayLike2 = _interopRequireDefault(_isArrayLike);

var _isBoolean = __webpack_require__(739);

var _isBoolean2 = _interopRequireDefault(_isBoolean);

var _isGraph = __webpack_require__(212);

var _isGraph2 = _interopRequireDefault(_isGraph);

var _isIterable = __webpack_require__(86);

var _isIterable2 = _interopRequireDefault(_isIterable);

var _isIterator = __webpack_require__(87);

var _isIterator2 = _interopRequireDefault(_isIterator);

var _isMap = __webpack_require__(344);

var _isMap2 = _interopRequireDefault(_isMap);

var _isPlainObject = __webpack_require__(345);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _mapIterator = __webpack_require__(346);

var _mapIterator2 = _interopRequireDefault(_mapIterator);

var _mapSequence = __webpack_require__(741);

var _mapSequence2 = _interopRequireDefault(_mapSequence);

var _max = __webpack_require__(742);

var _max2 = _interopRequireDefault(_max);

var _next = __webpack_require__(744);

var _next2 = _interopRequireDefault(_next);

var _nodesAreEqual = __webpack_require__(745);

var _nodesAreEqual2 = _interopRequireDefault(_nodesAreEqual);

var _range = __webpack_require__(145);

var _range2 = _interopRequireDefault(_range);

var _someIterator = __webpack_require__(747);

var _someIterator2 = _interopRequireDefault(_someIterator);

var _toIterator = __webpack_require__(348);

var _toIterator2 = _interopRequireDefault(_toIterator);

var _tuple = __webpack_require__(748);

var tuple = _interopRequireWildcard(_tuple);

var _size = __webpack_require__(746);

var _size2 = _interopRequireDefault(_size);

var _sprintf = __webpack_require__(347);

var _sprintf2 = _interopRequireDefault(_sprintf);

var _zipIterator = __webpack_require__(349);

var _zipIterator2 = _interopRequireDefault(_zipIterator);

var _zipSequence = __webpack_require__(749);

var _zipSequence2 = _interopRequireDefault(_zipSequence);

exports.Arrays = _Arrays2['default'];
exports.Map = _Map2['default'];
exports.PriorityQueue = _PriorityQueue2['default'];
exports.Set = _Set2['default'];
exports.clone = _clone2['default'];
exports.clear = _clear2['default'];
exports.deepcopy = _deepcopy2['default'];
exports.deepmerge = _deepmerge2['default'];
exports.gcd = _gcd2['default'];
exports.genCombinations = _genCombinations2['default'];
exports.genPermutations = _genPermutations2['default'];
exports.genRange = _genRange2['default'];
exports.getDefault = _getDefault2['default'];
exports.fillArray = _fillArray2['default'];
exports.forEach = _forEach2['default'];
exports.isArrayLike = _isArrayLike2['default'];
exports.isBoolean = _isBoolean2['default'];
exports.isGraph = _isGraph2['default'];
exports.isIterable = _isIterable2['default'];
exports.isIterator = _isIterator2['default'];
exports.isMap = _isMap2['default'];
exports.isPlainObject = _isPlainObject2['default'];
exports.mapIterator = _mapIterator2['default'];
exports.mapSequence = _mapSequence2['default'];
exports.max = _max2['default'];
exports.next = _next2['default'];
exports.nodesAreEqual = _nodesAreEqual2['default'];
exports.range = _range2['default'];
exports.someIterator = _someIterator2['default'];
exports.toIterator = _toIterator2['default'];
exports.tuple = tuple;
exports.size = _size2['default'];
exports.sprintf = _sprintf2['default'];
exports.zipIterator = _zipIterator2['default'];
exports.zipSequence = _zipSequence2['default'];

_defaults(exports, _interopRequireWildcard(_tuple));

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _getIterator = __webpack_require__(8)["default"];

var _isIterable = __webpack_require__(771)["default"];

exports["default"] = (function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = _getIterator(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (_isIterable(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
})();

exports.__esModule = true;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 18 */
/***/ (function(module, exports) {

var $Object = Object;
module.exports = {
  create:     $Object.create,
  getProto:   $Object.getPrototypeOf,
  isEnum:     {}.propertyIsEnumerable,
  getDesc:    $Object.getOwnPropertyDescriptor,
  setDesc:    $Object.defineProperty,
  setDescs:   $Object.defineProperties,
  getKeys:    $Object.keys,
  getNames:   $Object.getOwnPropertyNames,
  getSymbols: $Object.getOwnPropertySymbols,
  each:       [].forEach
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(774);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

module.exports = { "default": module.exports, __esModule: true };

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 20 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newInterval;
var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = new Date(+date)), date;
  }

  interval.floor = interval;

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [];
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(new Date(+start)); while (offseti(start, step), floori(start), start < stop)
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}


/***/ }),
/* 22 */
/***/ (function(module, exports) {

var core = module.exports = {version: '1.2.6'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

exports.__esModule = true;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = function (obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
};

exports.__esModule = true;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var store  = __webpack_require__(280)('wks')
  , uid    = __webpack_require__(183)
  , Symbol = __webpack_require__(44).Symbol;
module.exports = function(name){
  return store[name] || (store[name] =
    Symbol && Symbol[name] || (Symbol || uid)('Symbol.' + name));
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Promise = __webpack_require__(217)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = delegateToWorker;

var _Worker = __webpack_require__(730);

var _Worker2 = _interopRequireDefault(_Worker);

var _WorkerSettings = __webpack_require__(340);

var _WorkerSettings2 = _interopRequireDefault(_WorkerSettings);

var _delegateSync = __webpack_require__(734);

var _delegateSync2 = _interopRequireDefault(_delegateSync);

var _message = __webpack_require__(743);

var delegateImplementation;
if (typeof _Worker2['default'] === 'function') {
  // Workers are supported
  delegateImplementation = function (method, args) {
    var _serializeAll = (0, _message.serializeAll)(args);

    var serializable = _serializeAll.serializable;
    var serializedValues = _serializeAll.serializedValues;

    if (!serializable) {
      console.info('At least one argument can\'t be serialized and sent to the worker. ' + ('We will run ' + method + ' in the same thread instead.'));
      return (0, _delegateSync2['default'])(method, args);
    }

    return new _Promise(function (resolve, reject) {
      var worker = new _Worker2['default'](_WorkerSettings2['default'].workerPath);
      worker.addEventListener('message', function (oEvent) {
        return resolve((0, _message.deserialize)(oEvent.data));
      }, false);
      worker.addEventListener('error', reject, false);
      worker.postMessage({ method: method, args: serializedValues });
    });
  };
} else {
  delegateImplementation = function (method, args) {
    console.info('Workers are not supported in this environment, so "' + method + '" will ' + 'run in the same thread instead. This might block the environment.');
    return (0, _delegateSync2['default'])(method, args);
  };
}

/**
 * DON'T CALL THIS FUNCTION EXPLICITLY. It's inserted by a transform.
 *
 * Tries to create a worker and pass the arguments to it. Copying large graphs
 * is not very fast, but still faster than running most algorithms
 * synchronously.
 *
 * Falls back to synchronous execution if browser doesn't support workers.
 *
 * This returns a promise which gets resolved with the result sent from the
 * worker or the synchronous functions.
 *
 * @param {string} method The name on the root jsnx object to execute.
 * @param {Array} args An array of arguments to send to the worker.
 *    Some types, such as graphs, are converted to a different format first.
 * @return {Promise}
 */

function delegateToWorker(method, args) {
  return delegateImplementation(method, args);
}

module.exports = exports['default'];

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(168)('wks')
  , uid        = __webpack_require__(130)
  , Symbol     = __webpack_require__(43).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(43)
  , core      = __webpack_require__(20)
  , ctx       = __webpack_require__(76)
  , hide      = __webpack_require__(54)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(61)
  , IE8_DOM_DEFINE = __webpack_require__(257)
  , toPrimitive    = __webpack_require__(170)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(42) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_bisect__ = __webpack_require__(285);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["a"]; });
/* unused harmony reexport bisectRight */
/* unused harmony reexport bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_ascending__ = __webpack_require__(83);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_bisector__ = __webpack_require__(286);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__src_bisector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_cross__ = __webpack_require__(570);
/* unused harmony reexport cross */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_descending__ = __webpack_require__(571);
/* unused harmony reexport descending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_deviation__ = __webpack_require__(287);
/* unused harmony reexport deviation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_extent__ = __webpack_require__(288);
/* unused harmony reexport extent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_histogram__ = __webpack_require__(572);
/* unused harmony reexport histogram */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold_freedmanDiaconis__ = __webpack_require__(582);
/* unused harmony reexport thresholdFreedmanDiaconis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_threshold_scott__ = __webpack_require__(583);
/* unused harmony reexport thresholdScott */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_threshold_sturges__ = __webpack_require__(292);
/* unused harmony reexport thresholdSturges */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_max__ = __webpack_require__(574);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_11__src_max__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_mean__ = __webpack_require__(575);
/* unused harmony reexport mean */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_median__ = __webpack_require__(576);
/* unused harmony reexport median */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_merge__ = __webpack_require__(577);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_14__src_merge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_min__ = __webpack_require__(289);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_15__src_min__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_pairs__ = __webpack_require__(290);
/* unused harmony reexport pairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_permute__ = __webpack_require__(578);
/* unused harmony reexport permute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_quantile__ = __webpack_require__(187);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_18__src_quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_range__ = __webpack_require__(291);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_19__src_range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_scan__ = __webpack_require__(579);
/* unused harmony reexport scan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_shuffle__ = __webpack_require__(580);
/* unused harmony reexport shuffle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_sum__ = __webpack_require__(581);
/* unused harmony reexport sum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_ticks__ = __webpack_require__(293);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_transpose__ = __webpack_require__(294);
/* unused harmony reexport transpose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_variance__ = __webpack_require__(295);
/* unused harmony reexport variance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_zip__ = __webpack_require__(584);
/* unused harmony reexport zip */





























/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return root; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Selection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__select__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectAll__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filter__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enter__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__exit__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__merge__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__order__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sort__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__call__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__nodes__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__node__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__size__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__empty__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__each__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__attr__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__property__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__classed__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__text__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__html__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__raise__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lower__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__append__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__insert__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__remove__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__datum__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__on__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__dispatch__ = __webpack_require__(646);






























var root = [null];

function Selection(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection() {
  return new Selection([[document.documentElement]], root);
}

Selection.prototype = selection.prototype = {
  constructor: Selection,
  select: __WEBPACK_IMPORTED_MODULE_0__select__["a" /* default */],
  selectAll: __WEBPACK_IMPORTED_MODULE_1__selectAll__["a" /* default */],
  filter: __WEBPACK_IMPORTED_MODULE_2__filter__["a" /* default */],
  data: __WEBPACK_IMPORTED_MODULE_3__data__["a" /* default */],
  enter: __WEBPACK_IMPORTED_MODULE_4__enter__["a" /* default */],
  exit: __WEBPACK_IMPORTED_MODULE_5__exit__["a" /* default */],
  merge: __WEBPACK_IMPORTED_MODULE_6__merge__["a" /* default */],
  order: __WEBPACK_IMPORTED_MODULE_7__order__["a" /* default */],
  sort: __WEBPACK_IMPORTED_MODULE_8__sort__["a" /* default */],
  call: __WEBPACK_IMPORTED_MODULE_9__call__["a" /* default */],
  nodes: __WEBPACK_IMPORTED_MODULE_10__nodes__["a" /* default */],
  node: __WEBPACK_IMPORTED_MODULE_11__node__["a" /* default */],
  size: __WEBPACK_IMPORTED_MODULE_12__size__["a" /* default */],
  empty: __WEBPACK_IMPORTED_MODULE_13__empty__["a" /* default */],
  each: __WEBPACK_IMPORTED_MODULE_14__each__["a" /* default */],
  attr: __WEBPACK_IMPORTED_MODULE_15__attr__["a" /* default */],
  style: __WEBPACK_IMPORTED_MODULE_16__style__["a" /* default */],
  property: __WEBPACK_IMPORTED_MODULE_17__property__["a" /* default */],
  classed: __WEBPACK_IMPORTED_MODULE_18__classed__["a" /* default */],
  text: __WEBPACK_IMPORTED_MODULE_19__text__["a" /* default */],
  html: __WEBPACK_IMPORTED_MODULE_20__html__["a" /* default */],
  raise: __WEBPACK_IMPORTED_MODULE_21__raise__["a" /* default */],
  lower: __WEBPACK_IMPORTED_MODULE_22__lower__["a" /* default */],
  append: __WEBPACK_IMPORTED_MODULE_23__append__["a" /* default */],
  insert: __WEBPACK_IMPORTED_MODULE_24__insert__["a" /* default */],
  remove: __WEBPACK_IMPORTED_MODULE_25__remove__["a" /* default */],
  datum: __WEBPACK_IMPORTED_MODULE_26__datum__["a" /* default */],
  on: __WEBPACK_IMPORTED_MODULE_27__on__["b" /* default */],
  dispatch: __WEBPACK_IMPORTED_MODULE_28__dispatch__["a" /* default */]
};

/* unused harmony default export */ var _unused_webpack_default_export = (selection);


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _get = __webpack_require__(57)['default'];

var _inherits = __webpack_require__(58)['default'];

var _classCallCheck = __webpack_require__(24)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _JSNetworkXException2 = __webpack_require__(214);

var _JSNetworkXException3 = _interopRequireDefault(_JSNetworkXException2);

var JSNetworkXError = (function (_JSNetworkXException) {
  _inherits(JSNetworkXError, _JSNetworkXException);

  function JSNetworkXError(message) {
    _classCallCheck(this, JSNetworkXError);

    _get(Object.getPrototypeOf(JSNetworkXError.prototype), 'constructor', this).call(this, message);
    this.name = 'JSNetworkXError';
  }

  return JSNetworkXError;
})(_JSNetworkXException3['default']);

exports['default'] = JSNetworkXError;
module.exports = exports['default'];

/***/ }),
/* 35 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(478), __esModule: true };

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(158);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(467);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(466);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(124);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(124);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(62)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 43 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 44 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$getOwnPropertyNames = __webpack_require__(365)["default"];

var _Object$getOwnPropertyDescriptor = __webpack_require__(364)["default"];

var _Object$defineProperty = __webpack_require__(216)["default"];

exports["default"] = function (obj, defaults) {
  var keys = _Object$getOwnPropertyNames(defaults);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];

    var value = _Object$getOwnPropertyDescriptor(defaults, key);

    if (value && value.configurable && obj[key] === undefined) {
      _Object$defineProperty(obj, key, value);
    }
  }

  return obj;
};

exports.__esModule = true;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(12);

var CallbackQueue = __webpack_require__(417);
var PooledClass = __webpack_require__(75);
var ReactFeatureFlags = __webpack_require__(422);
var ReactReconciler = __webpack_require__(93);
var Transaction = __webpack_require__(153);

var invariant = __webpack_require__(3);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(44)
  , core      = __webpack_require__(22)
  , ctx       = __webpack_require__(67)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && key in target;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(param){
        return this instanceof C ? new C(param) : C(param);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    if(IS_PROTO)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
  }
};
// type bitmap
$export.F = 1;  // forced
$export.G = 2;  // global
$export.S = 4;  // static
$export.P = 8;  // proto
$export.B = 16; // bind
$export.W = 32; // wrap
module.exports = $export;

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return durationSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return durationMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return durationHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return durationDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return durationWeek; });
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;


/***/ }),
/* 49 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(378),
    isLength = __webpack_require__(72),
    isObjectLike = __webpack_require__(49);

/** `Object#toString` result references. */
var arrayTag = '[object Array]';

/** Used for native method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative(Array, 'isArray');

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};

module.exports = isArray;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(12);

var PooledClass = __webpack_require__(75);

var emptyFunction = __webpack_require__(29);
var warning = __webpack_require__(6);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(479), __esModule: true };

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(31)
  , createDesc = __webpack_require__(97);
module.exports = __webpack_require__(42) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_color__ = __webpack_require__(189);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_lab__ = __webpack_require__(596);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__ = __webpack_require__(595);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__["a"]; });





/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(216)["default"];

exports["default"] = (function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;

      _Object$defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();

exports.__esModule = true;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$getOwnPropertyDescriptor = __webpack_require__(364)["default"];

exports["default"] = function get(_x, _x2, _x3) {
  var _again = true;

  _function: while (_again) {
    var object = _x,
        property = _x2,
        receiver = _x3;
    _again = false;
    if (object === null) object = Function.prototype;

    var desc = _Object$getOwnPropertyDescriptor(object, property);

    if (desc === undefined) {
      var parent = Object.getPrototypeOf(object);

      if (parent === null) {
        return undefined;
      } else {
        _x = parent;
        _x2 = property;
        _x3 = receiver;
        _again = true;
        desc = parent = undefined;
        continue _function;
      }
    } else if ("value" in desc) {
      return desc.value;
    } else {
      var getter = desc.get;

      if (getter === undefined) {
        return undefined;
      }

      return getter.call(receiver);
    }
  }
};

exports.__esModule = true;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$create = __webpack_require__(115)["default"];

var _Object$setPrototypeOf = __webpack_require__(367)["default"];

exports["default"] = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = _Object$create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _Object$setPrototypeOf ? _Object$setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

exports.__esModule = true;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keys = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = createBreakpoints;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_Breakpoint = __webpack_require__(0).oneOf(['xs', 'sm', 'md', 'lg', 'xl']);

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = exports.keys = ['xs', 'sm', 'md', 'lg', 'xl'];

// Keep in mind that @media is inclusive by the CSS specification.
function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === undefined ? {
    xs: 360,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === undefined ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === undefined ? 1 : _breakpoints$step,
      other = (0, _objectWithoutProperties3.default)(breakpoints, ['values', 'unit', 'step']);


  function up(key) {
    var value = void 0;
    // min-width of xs starts at 0
    if (key === 'xs') {
      value = 0;
    } else {
      value = values[key] || key;
    }
    return '@media (min-width:' + value + unit + ')';
  }

  function down(key) {
    var value = values[key] || key;
    return '@media (max-width:' + (value - step / 100) + unit + ')';
  }

  function between(start, end) {
    var startIndex = keys.indexOf(start);
    var endIndex = keys.indexOf(end);
    return '@media (min-width:' + values[keys[startIndex]] + unit + ') and ' + ('(max-width:' + (values[keys[endIndex + 1]] - step / 100) + unit + ')');
  }

  function only(key) {
    var keyIndex = keys.indexOf(key);
    if (keyIndex === keys.length - 1) {
      return up(key);
    }
    return between(key, key);
  }

  return (0, _extends3.default)({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only
  }, other);
}

/***/ }),
/* 60 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(64);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 63 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(162)
  , defined = __webpack_require__(125);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(80);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(174);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function constant() {
    return x;
  };
});


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = __webpack_require__(56)['default'];

var _classCallCheck = __webpack_require__(24)['default'];

var _slicedToArray = __webpack_require__(16)['default'];

var _Object$create = __webpack_require__(115)['default'];

var _getIterator = __webpack_require__(8)['default'];

var _regeneratorRuntime = __webpack_require__(19)['default'];

var _Symbol$iterator = __webpack_require__(147)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
/**
 * @fileoverview
 * A shim for ES6 maps and support for custom hash functions via toString()
 * and does not accept arrays as keys (just like Python does not accept lists).
 */

var _clear2 = __webpack_require__(341);

var _clear3 = _interopRequireDefault(_clear2);

var _isIterable = __webpack_require__(86);

var _isIterable2 = _interopRequireDefault(_isIterable);

var _lodashLangIsFunction = __webpack_require__(383);

var _lodashLangIsFunction2 = _interopRequireDefault(_lodashLangIsFunction);

var _lodashLangIsObject = __webpack_require__(35);

var _lodashLangIsObject2 = _interopRequireDefault(_lodashLangIsObject);

var _isArrayLike = __webpack_require__(85);

var _isArrayLike2 = _interopRequireDefault(_isArrayLike);

var _lodashCollectionSize = __webpack_require__(369);

var _lodashCollectionSize2 = _interopRequireDefault(_lodashCollectionSize);

var Map = (function () {
  /**
   * @param {Iterable=} opt_data An object, array or iterator to
   *  populate the map with. If 'data' is an array or iterable, each element is
   *  expected to be a 2-tuple. The first element will be the key and second the
   *  value.
   *  If it is an object, the property names will be the keys and the value the
   *  values.
   */

  function Map(optData) {
    _classCallCheck(this, Map);

    // Can't use class syntax because of generator functions
    this._stringValues = _Object$create(null); // strings
    this._numberValues = _Object$create(null); // numbers
    this._values = _Object$create(null); // every other value
    this._keys = _Object$create(null);

    if (optData != null) {
      if ((0, _isIterable2['default'])(optData)) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _getIterator(optData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _step$value = _slicedToArray(_step.value, 2);

            var key = _step$value[0];
            var value = _step$value[1];

            this.set(key, value);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator['return']) {
              _iterator['return']();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else if ((0, _isArrayLike2['default'])(optData)) {
        for (var i = 0; i < optData.length; i++) {
          var _optData$i = _slicedToArray(optData[i], 2);

          var key = _optData$i[0];
          var value = _optData$i[1];

          this.set(key, value);
        }
      } else if ((0, _lodashLangIsObject2['default'])(optData)) {
        for (var key in optData) {
          this.set(isNaN(+key) ? key : +key, optData[key]);
        }
      }
    }
  }

  _createClass(Map, [{
    key: '_getStorage',

    /**
     * Returns the appropriate storage object for a given key.
     *
     * @param {*} key
     * @return {Object}
     * @private
     */
    value: function _getStorage(key) {
      switch (typeof key) {
        case 'number':
          return this._numberValues;
        case 'string':
          return this._stringValues;
        default:
          return this._values;
      }
    }
  }, {
    key: 'get',

    /**
     * Returns the value for the given key.
     *
     * Unlike native ES6 maps, this also accepts a default value which is returned
     * if the map does not contain the value.
     *
     * @param {*} key
     * @param {*=} optDefaultValue
     *
     * @return {*}
     * @export
     */
    value: function get(key, optDefaultValue) {
      var storage = this._getStorage(key);
      return key in storage ? storage[key] : optDefaultValue;
    }
  }, {
    key: 'has',

    /**
     * Returns true if the key is in the map.
     *
     * @param {*} key
     *
     * @return {boolean}
     * @export
     */
    value: function has(key) {
      return key in this._getStorage(key);
    }
  }, {
    key: 'set',

    /**
     * Adds the value and key to the map.
     *
     * @param {*} key
     * @param {*} value
     *
     * @return {Map} the map object itself
     * @export
     */
    value: function set(key, value) {
      var values = this._getStorage(key);
      values[key] = value;

      // save actual key value
      if (values === this._values) {
        this._keys[key] = key;
      }

      return this;
    }
  }, {
    key: 'delete',

    /**
     * Remove value with given key.
     *
     * @param {*} key
     *
     * @return {boolean}
     * @export
     */
    value: function _delete(key) {
      var values = this._getStorage(key);
      if (key in values) {
        delete values[key];
        if (values === this._values) {
          delete this._keys[key];
        }
        return true;
      }
      return false;
    }
  }, {
    key: 'entries',

    /**
     * Returns an array of (key, value) tuples.
     *
     * @return {!Iterator}
     * @export
    */
    value: _regeneratorRuntime.mark(function entries() {
      var key;
      return _regeneratorRuntime.wrap(function entries$(context$2$0) {
        while (1) switch (context$2$0.prev = context$2$0.next) {
          case 0:
            context$2$0.t0 = _regeneratorRuntime.keys(this._numberValues);

          case 1:
            if ((context$2$0.t1 = context$2$0.t0()).done) {
              context$2$0.next = 7;
              break;
            }

            key = context$2$0.t1.value;
            context$2$0.next = 5;
            return [+key, this._numberValues[key]];

          case 5:
            context$2$0.next = 1;
            break;

          case 7:
            context$2$0.t2 = _regeneratorRuntime.keys(this._stringValues);

          case 8:
            if ((context$2$0.t3 = context$2$0.t2()).done) {
              context$2$0.next = 14;
              break;
            }

            key = context$2$0.t3.value;
            context$2$0.next = 12;
            return [key, this._stringValues[key]];

          case 12:
            context$2$0.next = 8;
            break;

          case 14:
            context$2$0.t4 = _regeneratorRuntime.keys(this._values);

          case 15:
            if ((context$2$0.t5 = context$2$0.t4()).done) {
              context$2$0.next = 21;
              break;
            }

            key = context$2$0.t5.value;
            context$2$0.next = 19;
            return [this._keys[key], this._values[key]];

          case 19:
            context$2$0.next = 15;
            break;

          case 21:
          case 'end':
            return context$2$0.stop();
        }
      }, entries, this);
    })
  }, {
    key: 'keys',

    /**
     * Returns an iterator over keys.
     *
     * @return {!Iterator}
     * @export
    */
    value: _regeneratorRuntime.mark(function keys() {
      var key;
      return _regeneratorRuntime.wrap(function keys$(context$2$0) {
        while (1) switch (context$2$0.prev = context$2$0.next) {
          case 0:
            context$2$0.t0 = _regeneratorRuntime.keys(this._numberValues);

          case 1:
            if ((context$2$0.t1 = context$2$0.t0()).done) {
              context$2$0.next = 7;
              break;
            }

            key = context$2$0.t1.value;
            context$2$0.next = 5;
            return +key;

          case 5:
            context$2$0.next = 1;
            break;

          case 7:
            context$2$0.t2 = _regeneratorRuntime.keys(this._stringValues);

          case 8:
            if ((context$2$0.t3 = context$2$0.t2()).done) {
              context$2$0.next = 14;
              break;
            }

            key = context$2$0.t3.value;
            context$2$0.next = 12;
            return key;

          case 12:
            context$2$0.next = 8;
            break;

          case 14:
            context$2$0.t4 = _regeneratorRuntime.keys(this._values);

          case 15:
            if ((context$2$0.t5 = context$2$0.t4()).done) {
              context$2$0.next = 21;
              break;
            }

            key = context$2$0.t5.value;
            context$2$0.next = 19;
            return this._keys[key];

          case 19:
            context$2$0.next = 15;
            break;

          case 21:
          case 'end':
            return context$2$0.stop();
        }
      }, keys, this);
    })
  }, {
    key: 'values',

    /**
     * Returns an array of values.
     *
     * @return {!Array}
     * @export
    */
    value: _regeneratorRuntime.mark(function values() {
      var key;
      return _regeneratorRuntime.wrap(function values$(context$2$0) {
        while (1) switch (context$2$0.prev = context$2$0.next) {
          case 0:
            context$2$0.t0 = _regeneratorRuntime.keys(this._numberValues);

          case 1:
            if ((context$2$0.t1 = context$2$0.t0()).done) {
              context$2$0.next = 7;
              break;
            }

            key = context$2$0.t1.value;
            context$2$0.next = 5;
            return this._numberValues[key];

          case 5:
            context$2$0.next = 1;
            break;

          case 7:
            context$2$0.t2 = _regeneratorRuntime.keys(this._stringValues);

          case 8:
            if ((context$2$0.t3 = context$2$0.t2()).done) {
              context$2$0.next = 14;
              break;
            }

            key = context$2$0.t3.value;
            context$2$0.next = 12;
            return this._stringValues[key];

          case 12:
            context$2$0.next = 8;
            break;

          case 14:
            context$2$0.t4 = _regeneratorRuntime.keys(this._values);

          case 15:
            if ((context$2$0.t5 = context$2$0.t4()).done) {
              context$2$0.next = 21;
              break;
            }

            key = context$2$0.t5.value;
            context$2$0.next = 19;
            return this._values[key];

          case 19:
            context$2$0.next = 15;
            break;

          case 21:
          case 'end':
            return context$2$0.stop();
        }
      }, values, this);
    })
  }, {
    key: 'clear',

    /**
     * Empties the map.
     *
     * @export
    */
    value: function clear() {
      (0, _clear3['default'])(this._stringValues);
      (0, _clear3['default'])(this._numberValues);
      (0, _clear3['default'])(this._values);
      (0, _clear3['default'])(this._keys);
    }
  }, {
    key: 'forEach',

    /**
     * Executes the provided callback for each item in the map.
     *
     * @param {function(*,*)} callback A function which gets the key as first
     *  argument and value as second argument.
     * @param {*=} opt_this Object/value to set this to inside the callback
     * @export
    */
    value: function forEach(callback, optThis) {
      if (!(0, _lodashLangIsFunction2['default'])(callback)) {
        throw new TypeError('callback must be a function');
      }
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = _getIterator(this.entries()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var v = _step2.value;

          callback.call(optThis, v[1], v[0], this);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2['return']) {
            _iterator2['return']();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: _Symbol$iterator,

    /**
    * Returns an iterator for the map object.
    *
    * @return {Iterator}
    */
    value: function value() {
      return this.entries();
    }
  }, {
    key: 'size',

    /**
     * Returns the number of element in the map.
     *
     * @return {number}
     * @export
    */
    get: function get() {
      return (0, _lodashCollectionSize2['default'])(this._values) + (0, _lodashCollectionSize2['default'])(this._numberValues) + (0, _lodashCollectionSize2['default'])(this._stringValues);
    }
  }]);

  return Map;
})();

exports['default'] = Map;
module.exports = exports['default'];

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = __webpack_require__(56)['default'];

var _classCallCheck = __webpack_require__(24)['default'];

var _slicedToArray = __webpack_require__(16)['default'];

var _Object$assign = __webpack_require__(89)['default'];

var _Array$from = __webpack_require__(13)['default'];

var _getIterator = __webpack_require__(8)['default'];

var _regeneratorRuntime = __webpack_require__(19)['default'];

var _Symbol$iterator = __webpack_require__(147)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

var _interopRequireWildcard = __webpack_require__(25)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _exceptionsKeyError = __webpack_require__(362);

var _exceptionsKeyError2 = _interopRequireDefault(_exceptionsKeyError);

var _internalsMap = __webpack_require__(70);

var _internalsMap2 = _interopRequireDefault(_internalsMap);

var _internalsSet = __webpack_require__(84);

var _internalsSet2 = _interopRequireDefault(_internalsSet);

var _exceptionsJSNetworkXError = __webpack_require__(34);

var _exceptionsJSNetworkXError2 = _interopRequireDefault(_exceptionsJSNetworkXError);

var _lodashLangIsBoolean = __webpack_require__(382);

var _lodashLangIsBoolean2 = _interopRequireDefault(_lodashLangIsBoolean);

var _lodashLangIsString = __webpack_require__(808);

var _lodashLangIsString2 = _interopRequireDefault(_lodashLangIsString);

var _convert = __webpack_require__(213);

var convert = _interopRequireWildcard(_convert);

var _internals = __webpack_require__(15);

/*jshint expr:false*/

/*
 * Base class for undirected graphs.
 *
 * A Graph stores nodes and edges with optional data, or attributes.
 *
 * Graphs hold undirected edges.  Self loops are allowed but multiple
 * (parallel) edges are not.
 *
 * Nodes can be strings, numbers or any object with a custom `toString` method.
 *
 * Edges are represented as links between nodes with optional
 * key/value attributes.
 *
 * ### Examples
 *
 * Create an empty graph (a "null graph") with no nodes and no edges.
 *
 * ```
 * var G = new jsnx.Graph();
 * ```
 *
 * G can be grown in several ways.
 *
 * #### Nodes
 *
 * Add one node at a time:
 *
 * ```
 * G.addNode(1);
 * ```
 *
 * Add the nodes from any iterable:
 *
 * ```
 * G.addNodesFrom([2, 3]);
 * G.addNodesFrom(new Set('foo', 'bar'));
 * var H = jsnx.completeGraph(10);
 * G.addNodesFrom(H);
 * ```
 *
 * In addition to strings, numbers and arrays, any object that implements a
 * custom `toString` method can be used as node.
 *
 * #### Edges
 *
 * `G` can also be grown by adding edges.
 *
 * Add one edge,
 *
 * ```
 * G.addEdge(1, 2);
 * ```
 *
 * a list of edges,
 *
 * ```
 * G.addEdgesFrom([[1,2], [1,3]]);
 * ```
 *
 * or a collection of edges,
 *
 * ```
 * G.addEdgesFrom(H.edges);
 * ```
 *
 * If some edges connect nodes not yet in the graph, the nodes are added
 * automatically. There are no errors when adding nodes or edges that already
 * exist.
 *
 * #### Attributes
 *
 * Each graph, node and edge can hold key/value attribute pairs in an associated
 * attribute object (keys must be strings or numbers).
 * By default these are empty, but can added or changed using `addEdge`,
 * `addNode`.
 *
 * ```
 * var G = new jsnx.Graph(null, {day: 'Friday'});
 * G.graph
 * // {day: 'Friday'}
 * ```
 *
 * Add node attributes using `addNode()` or `addNodesFrom()`:
 *
 * ```
 * G.addNode(1, {time: '5pm'});
 * G.addNodesFrom([2, [3, {time: '3pm'}]], {time: '2pm'});
 * G.nodes(true);
 * // [[1, {time: '5pm'}], [2, {time: '2pm'}], [3, {time: '3pm'}]]
 * ```
 *
 * Add edge attributes using `addEdge()`, or `addEdgesFrom()`:
 *
 * ```
 * G.addEdge(1, w, {weight: 4.7});
 * G.addEdgesFrom([[3,4], [4,5]], {color: 'red'});
 * ```
 *
 * @see DiGraph
 * @see MultiGraph
 * @see MultiDiGraph
 */

var Graph = (function () {

  /*
   * @param {Iterable} optData Data to initialize graph.  If `data` is not
   *    provided, an empty graph is created. The data can be an edge list, or
   *    any JSNetworkX graph object.
   * @param {Object=} optAttr (default=no attributes)
   *    Attributes to add to graph as key=value pairs.
   */

  function Graph(optData, optAttr) {
    _classCallCheck(this, Graph);

    // makes it possible to call Graph without new
    if (!(this instanceof Graph)) {
      return new Graph(optData, optAttr);
    }

    this.graph = {}; // dictionary for graph attributes
    this.node = new _internalsMap2['default'](); // empty node dict (created before convert)
    this.adj = new _internalsMap2['default'](); // empty adjacency dict

    // attempt to load graph with data
    if (optData != null) {
      convert.toNetworkxGraph(optData, this);
    }

    // load graph attributes (must be after convert)
    if (optAttr) {
      _Object$assign(this.graph, optAttr);
    }
    this.edge = this.adj;
  }

  _createClass(Graph, [{
    key: 'toString',

    /**
     * Return the graph name
     *
     * @return {string} Graph name.
     */
    value: function toString() {
      return this.name;
    }
  }, {
    key: 'get',

    /**
     * Return a Map of neighbors of node n.
     *
     * @param {Node} n  A node in the graph.
     *
     * @return {!Map} The adjacency dictionary for nodes connected to n.
     */
    value: function get(n) {
      var value = this.adj.get(n);
      if (typeof value === 'undefined') {
        throw new _exceptionsKeyError2['default']('Graph does not contain node ' + n + '.');
      }
      return value;
    }
  }, {
    key: 'addNode',

    /**
     * Add a single node n and update node attributes.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addNode(1);
     * G.addNode('Hello');
     * G.numberOfNodes();
     * 2
     * ```
     *
     * @see #addNodesFrom
     *
     * @param {Node} n Node
     * @param {Object=} opt_attr_dict Dictionary of node attributes.
     *      Key/value pairs will update existing data associated with the node.
     */
    value: function addNode(n) {
      var optAttrDict = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

      if (!(0, _internals.isPlainObject)(optAttrDict)) {
        throw new _exceptionsJSNetworkXError2['default']('The attr_dict argument must be an object.');
      }

      if (!this.node.has(n)) {
        this.adj.set(n, new _internalsMap2['default']());
        this.node.set(n, optAttrDict);
      } else {
        // update attr even if node already exists
        _Object$assign(this.node.get(n), optAttrDict);
      }
    }
  }, {
    key: 'addNodesFrom',

    /**
     * Add multiple nodes.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph(); // or DiGraph, MultiGraph, MultiDiGraph
     * G.addNodesFrom([1,2,3]);
     * G.nodes();
     * // [1,2,3]
     * ```
     *
     * Use the second argument to update specific node attributes for every node.
     *
     * ```
     * G.addNodesFrom([1,2], {size: 10});
     * G.addNodesFrom([2,3], {weight: 0.4});
     * ```
     *
     * Use `(node, object)` tuples to update attributes for specific nodes.
     *
     * ```
     * G.addNodesFrom([[1, {size: 11}], [2, {color: 'blue'}]]);
     * G.node.get(1).size
     * // 11
     * var H = new jsnx.Graph();
     * H.addNodesFrom(G.nodes(true));
     * H.node.get(1).size
     * // 11
     * ```
     *
     * @see #addNode
     *
     * @param {Iterable} nodes
     *      An iterable of nodes
     *      OR
     *      An iterable of (node, object) tuples.
     *
     * @param {Object=} optAttr  Update attributes for all nodes in nodes.
     *       Node attributes specified in nodes as a tuple
     *       take precedence over attributes specified generally.
     */
    value: function addNodesFrom(nodes) {
      var optAttr = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

      (0, _internals.forEach)(nodes, function (node) {
        if (Array.isArray(node) && node.length === 2 && (0, _internals.isPlainObject)(node[1])) {
          var _node = _slicedToArray(node, 2);

          var nn = _node[0];
          var ndict = _node[1];

          if (!this.adj.has(nn)) {
            this.adj.set(nn, new _internalsMap2['default']());
            var newdict = (0, _internals.clone)(optAttr);
            this.node.set(nn, _Object$assign(newdict, ndict));
          } else {
            var olddict = this.node.get(nn);
            _Object$assign(olddict, optAttr, ndict);
          }
          return; // continue next iteration
        }
        var newnode = !this.node.has(node);
        if (newnode) {
          this.adj.set(node, new _internalsMap2['default']());
          this.node.set(node, (0, _internals.clone)(optAttr));
        } else {
          _Object$assign(this.node.get(node), optAttr);
        }
      }, this);
    }
  }, {
    key: 'removeNode',

    /**
     * Remove node n.
     *
     * Removes the node n and all adjacent edges.
     * Attempting to remove a non-existent node will raise an exception.
     *
     * ### Example
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2]);
     * G.edges();
     * // [[0,1], [1,2]]
     * G.removeNode(1);
     * G.edges();
     * // []
     * ```
     *
     * @see #removeNodesFrom
     *
     * @param {Node} n  A node in the graph
     */
    value: function removeNode(n) {
      var adj = this.adj;

      if (this.node['delete'](n)) {
        adj.get(n).forEach(function (_, u) {
          return adj.get(u)['delete'](n) // remove all edges n-u in graph
          ;
        });
        adj['delete'](n); // now remove node
      } else {
        throw new _exceptionsJSNetworkXError2['default']('The node %s is not in the graph', n);
      }
    }
  }, {
    key: 'removeNodesFrom',

    /**
     * Remove multiple nodes.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2]);
     * var e = G.nodes(); // [0,1,2]
     * G.removeNodesFrom(e);
     * G.nodes();
     * // []
     * ```
     *
     * @see #removeNode
     *
     * @param {Iterable} nodes  A container of nodes.
     *      If a node in the container is not in the graph it is silently ignored.
     */
    value: function removeNodesFrom(nodes) {
      var adj = this.adj;
      var node = this.node;

      (0, _internals.forEach)(nodes, function (n) {
        if (node['delete'](n)) {
          adj.get(n).forEach(function (_, u) {
            return adj.get(u)['delete'](n);
          });
          adj['delete'](n);
        }
      });
    }
  }, {
    key: 'nodesIter',

    /**
     * Return an iterator over the nodes.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2]);
     * var data = [];
     * Array.from(G.nodesIter(true)).map(([node, data]) => data);
     * // [{}, {}, {}]
     * ```
     *
     * ### Notes
     *
     * If the node is not required, it is simpler and equivalent to use `G`, e.g.
     * `Array.from(G)` or `for (var node of G)`.
     *
     * @param {boolean=} optData If false the iterator returns
     *   nodes. If true return a two-tuple of node and node data dictionary.
     *
     * @return {Iterator} of nodes If data=true the iterator gives
     *           two-tuples containing (node, node data, dictionary).
     */
    value: function nodesIter() {
      var optData = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];

      if (optData) {
        return (0, _internals.toIterator)(this.node);
      }
      return this.node.keys();
    }
  }, {
    key: 'nodes',

    /**
     * Return a list of the nodes in the graph.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2]);
     * G.nodes();
     * // [0,1,2]
     * G.addNode(1, {time: '5pm'});
     * G.nodes(true);
     * // [[0,{}], [1,{time: '5pm'}], [2,{}]]
     * ```
     *
     * @param {boolean=} optData If false the iterator returns
     *   nodes. If true return a two-tuple of node and node data dictionary.
     *
     * @return {!Array} of nodes If data=true a list of two-tuples containing
     *           (node, node data object).
     */
    value: function nodes() {
      var optData = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];

      return _Array$from(optData ? this.node.entries() : this.node.keys());
    }
  }, {
    key: 'numberOfNodes',

    /**
     * Return the number of nodes in the graph.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2]);
     * G.numberOfNodes();
     * // 3
     * ```
     *
     * @see #order
     *
     * @return {number} The number of nodes in the graph.
     */
    value: function numberOfNodes() {
      return this.node.size;
    }
  }, {
    key: 'order',

    /**
     * Return the number of nodes in the graph.
     *
     * @see #numberOfNodes
     *
     * @return {number} The number of nodes in the graph.
     */
    value: function order() {
      return this.node.size;
    }
  }, {
    key: 'hasNode',

    /**
     * Return true if the graph contains the node n.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2]);
     * G.hasNode(0);
     * // true
     * ```
     *
     * @param {Node} n node.
     * @return {boolean}
     */
    value: function hasNode(n) {
      return this.node.has(n);
    }
  }, {
    key: 'addEdge',

    /**
     * Add an edge between u and v.
     *
     * The nodes u and v will be automatically added if they are
     * not already in the graph.
     *
     * Edge attributes can be specified with keywords or by providing
     * a object with key/value pairs as third argument.
     *
     *
     * ### Examples
     *
     * The following all add the edge `(1,2)` to graph `G`:
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addEdge(1,2);
     * G.addEdgesFrom([[1,2]]);
     * ```
     *
     * Associate data to edges using an object:
     *
     * ```
     * G.addEdge(1, 2, {weight: 3});
     * G.addEdge(1, 3, {weight: 7, capacity: 15, length: 342.7});
     * ```
     *
     * ### Notes
     *
     * Adding an edge that already exists updates the edge data.
     *
     * Many algorithms designed for weighted graphs use as the edge weight a
     * numerical value assigned to an attribute which by default is 'weight'.
     *
     * @see #addEdgesFrom
     *
     * @param {Node} u Node
     * @param {Node} v Node
     * @param {Object=} optAttrDict Object of edge attributes.
     *      Key/value pairs will update existing data associated with the edge.
     */
    value: function addEdge(u, v, optAttrDict) {
      if (optAttrDict && !(0, _internals.isPlainObject)(optAttrDict)) {
        throw new _exceptionsJSNetworkXError2['default']('The attr_dict argument must be an object.');
      }

      // add nodes
      if (!this.node.has(u)) {
        this.adj.set(u, new _internalsMap2['default']());
        this.node.set(u, {});
      }
      if (!this.node.has(v)) {
        this.adj.set(v, new _internalsMap2['default']());
        this.node.set(v, {});
      }

      // add the edge
      var datadict = this.adj.get(u).get(v) || {};
      _Object$assign(datadict, optAttrDict);
      this.adj.get(u).set(v, datadict);
      this.adj.get(v).set(u, datadict);
    }
  }, {
    key: 'addEdgesFrom',

    /**
     * Add all the edges in `ebunch`.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addEdgesFrom([[0,1], [1,2]]); // using a list of edges
     * ```
     *
     * Associate data to edges
     *
     * ```
     * G.addEdgesFrom([[1,2], [2,3]], {weight: 3});
     * G.addEdgesFrom([[3,4], [1,4]], {label: 'WN2898'});
     * ```
     *
     * ### Notes
     *
     * Adding the same edge twice has no effect but any edge data
     * will be updated when each duplicate edge is added.
     *
     * @see #add_edge
     * @see #addWeightedEdgesFrom
     *
     * @param {Iterable} ebunch container of edges
     *      Each edge given in the container will be added to the
     *      graph. The edges must be given as as 2-tuples (u,v) or
     *      3-tuples (u,v,d) where d is a dictionary containing edge data.
     *
     * @param {Object=} optAttrDict Object of edge attributes.
     *      Dictionary of edge attributes.  Key/value pairs will
     *      update existing data associated with each edge.
     */
    value: function addEdgesFrom(ebunch, optAttrDict) {
      if (optAttrDict && !(0, _internals.isPlainObject)(optAttrDict)) {
        throw new _exceptionsJSNetworkXError2['default']('The attr_dict argument must be an object.');
      }

      // process ebunch
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _getIterator(ebunch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var tuple = _step.value;

          if (tuple.length == null) {
            throw new _exceptionsJSNetworkXError2['default']((0, _internals.sprintf)('Edge tuple %j must be a 2-tuple or 3-tuple.', tuple));
          }

          var _tuple = _slicedToArray(tuple, 3);

          var u = _tuple[0];
          var v = _tuple[1];
          var data = _tuple[2];

          if (!(0, _internals.isPlainObject)(data)) {
            data = {};
          }
          if (u == null || v == null || tuple[3] != null) {
            throw new _exceptionsJSNetworkXError2['default']((0, _internals.sprintf)('Edge tuple %j must be a 2-tuple or 3-tuple.', tuple));
          }

          if (!this.node.has(u)) {
            this.adj.set(u, new _internalsMap2['default']());
            this.node.set(u, {});
          }
          if (!this.node.has(v)) {
            this.adj.set(v, new _internalsMap2['default']());
            this.node.set(v, {});
          }

          // add the edge
          var datadict = this.adj.get(u).get(v) || {};
          _Object$assign(datadict, optAttrDict, data);
          this.adj.get(u).set(v, datadict);
          this.adj.get(v).set(u, datadict);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator['return']) {
            _iterator['return']();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: 'addWeightedEdgesFrom',

    /**
     * Add all the edges in `ebunch` as weighted edges with specified weights.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addWeightedEdgesFrom([[0,1,3.0], [1,2,7.5]]);
     * ```
     *
     * ### Note
     *
     * Adding the same edge twice for Graph/DiGraph simply updates
     * the edge data.  For MultiGraph/MultiDiGraph, duplicate edges
     * are stored.
     *
     * @see #addEdge
     * @see #addEdgesFrom
     *
     * @param {Iterable} ebunch  container of edges
     *      Each edge given in the list or container will be added
     *      to the graph. The edges must be given as 3-tuples (u,v,w)
     *      where w is a number.
     * @param {string=} optWeight (default 'weight')
     *      The attribute name for the edge weights to be added.
     * @param {Object=} optAttr Edge attributes to add/update for all edges.
     */
    value: function addWeightedEdgesFrom(ebunch, optWeight, optAttr) {
      optAttr = optAttr || {};
      if (!(0, _lodashLangIsString2['default'])(optWeight)) {
        optAttr = optWeight;
        optWeight = 'weight';
      }

      this.addEdgesFrom((0, _internals.mapSequence)(ebunch, function (e) {
        var attr = {};
        attr[optWeight] = e[2];
        if (attr[optWeight] == null) {
          // simulate too few value to unpack error
          throw new TypeError('Values must consist of three elements: %s.', e);
        }
        return [e[0], e[1], attr];
      }), optAttr);
    }
  }, {
    key: 'removeEdge',

    /**
     * Remove the edge between u and v.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2,3]);
     * G.removeEdge(0,1);
     * ```
     *
     * @see #removeEdgesFrom
     *
     * @param {Node} u Node
     * @param {Node} v Node
     */
    value: function removeEdge(u, v) {
      var node = this.adj.get(u);
      if (node != null) {
        node['delete'](v);
        // self-loop needs only one entry removed
        var vnode = this.adj.get(v);
        if (vnode !== node) {
          vnode['delete'](u);
        }
      } else {
        throw new _exceptionsJSNetworkXError2['default']('The edge %s-%s is not in the graph', u, v);
      }
    }
  }, {
    key: 'removeEdgesFrom',

    /**
     * Remove all edges specified in `ebunch`.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2,3]);
     * var ebunch = [[1,2], [2,3]];
     * G.removeEdgesFrom(ebunch);
     * ```
     *
     * ### Notes
     *
     * Will fail silently if an edge in `ebunch` is not in the graph.
     *
     * @param {Iterable} ebunch Iterable of edge tuples
     *      Each edge given in the list or container will be removed
     *      from the graph. The edges can be:
     *        - 2-tuples (u,v) edge between u and v.
     *        - 3-tuples (u,v,k) where k is ignored.
     */
    value: function removeEdgesFrom(ebunch) {
      var adj = this.adj;
      (0, _internals.forEach)(ebunch, function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2);

        var u = _ref2[0];
        var v = _ref2[1];

        var unode = adj.get(u);
        if (unode != null && unode.has(v)) {
          unode['delete'](v);
          var vnode = adj.get(v);
          if (vnode !== unode) {
            vnode['delete'](u);
          }
        }
      });
    }
  }, {
    key: 'hasEdge',

    /**
     * Return True if the edge (u,v) is in the graph.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2,3]);
     * G.hasEdge(0, 1);
     * // true
     * var edge = [0, 1];
     * G.hasEdge.apply(G, edge);
     * // true
     * ```
     *
     * @param {Node} u Node.
     * @param {Node} v Node.
     *
     * @return {boolean} True if edge is in the graph, False otherwise.
     */
    value: function hasEdge(u, v) {
      var unode = this.adj.get(u);
      return unode && unode.has(v);
    }
  }, {
    key: 'neighbors',

    /**
     * Return a list of the nodes connected to the node n.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2,3]);
     * G.neighbors(0);
     * // [1]
     * ```
     *
     * ### Notes
     *
     * It can be more convenient to access the adjacency map as `G.get(n)`:
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addEdge('a', 'b', {weight: 7});
     * G.get('a');
     * // Map {'b': {weight: 7}}
     * ```
     *
     * @param {!Node} n A node in the graph.
     * @return {!Array} A list of nodes that are adjacent to n.
     */
    value: function neighbors(n) {
      return _Array$from(this.neighborsIter(n));
    }
  }, {
    key: 'neighborsIter',

    /**
     * Return an iterator over all neighbors of node n.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2,3]);
     * Array.from(G.neighborsIter(0));
     * // [1]
     * ```
     *
     * You could also iterate over the adjacency map instead:
     *
     * ```
     * Array.from(G.get(0).keys());
     * ```
     *
     * @param {!Node} n A node in the graph.
     * @return {!Iterator} A list of nodes that are adjacent to n.
     */
    value: function neighborsIter(n) {
      var node = this.adj.get(n);
      if (node != null) {
        return node.keys();
      } else {
        throw new _exceptionsJSNetworkXError2['default']('The node %s is not in the graph.', n);
      }
    }
  }, {
    key: 'edges',

    /**
     * Return a list of edges.
     *
     * Edges are returned as tuples with optional data
     * in the order (node, neighbor, data).
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2]);
     * G.addEdge(2, 3, {weight: 5});
     * G.edges();
     * // [[0,1], [1,2], [2,3]]
     * G.edges(true);
     * // [[0,1,{}], [1,2,{}], [2,3, {weight: 5}]
     * G.edges([0,3]);
     * // [[0,1], [3,2]]
     * G.edges(0);
     * // [[0,1]]
     * ```
     *
     * ### Note
     *
     * Nodes in `nbunch` that are not in the graph will be (quietly) ignored.
     * For directed graphs this returns the out-edges.
     *
     * @param {?(Node|Iterable)=} optNbunch A container of nodes.
     *      The container will be iterated through once.
     * @param {?boolean=} optData Return two tuples (u,v) (False)
     *      or three-tuples (u,v,data) (True).
     * @return {!Array} list of edge tuples
     *      Edges that are adjacent to any node in nbunch, or a list
     *      of all edges if nbunch is not specified.
     */
    value: function edges(optNbunch) {
      var optData = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

      return _Array$from(this.edgesIter(optNbunch, optData));
    }
  }, {
    key: 'edgesIter',

    /**
     * Return an iterator over the edges.
     *
     * Edges are returned as tuples with optional data
     * in the order (node, neighbor, data).
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2]);
     * G.addEdge(2, 3, {weight: 5});
     * Array.from(G.edgesIter());
     * // [[0,1], [1,2], [2,3]]
     * Array.from(G.edgesIter(true));
     * // [[0,1,{}], [1,2,{}], [2,3, {weight: 5}]
     * Array.from(G.edgesIter([0,3]));
     * // [[0,1], [3,2]]
     * Array.from(G.edgesIter(0));
     * // [[0,1]]
     * ```
     *
     * ### Note
     *
     * Nodes in `nbunch` that are not in the graph will be (quietly) ignored.
     * For directed graphs this returns the out-edges.
     *
     * @param {?(Node|Iterable)=} optNbunch A container of nodes.
     *      The container will be iterated through once.
     * @param {?boolean=} optData Return two tuples (u,v) (False)
     *      or three-tuples (u,v,data) (True).
     * @return {!Iterator} iterater if `(u,v)` or `(u,v,d)` edge tuples
     */
    value: _regeneratorRuntime.mark(function edgesIter(optNbunch) {
      var optData = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

      var seen, nodesNbrs, adj, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, nodeData, node, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, neighborsData;

      return _regeneratorRuntime.wrap(function edgesIter$(context$2$0) {
        while (1) switch (context$2$0.prev = context$2$0.next) {
          case 0:

            // handle calls with data being the only argument
            if ((0, _lodashLangIsBoolean2['default'])(optNbunch)) {
              optData = optNbunch;
              optNbunch = null;
            }

            seen = new _internalsSet2['default']();

            if (optNbunch == null) {
              nodesNbrs = this.adj.entries();
            } else {
              adj = this.adj;

              nodesNbrs = (0, _internals.mapIterator)(this.nbunchIter(optNbunch), function (n) {
                return (0, _internals.tuple2)(n, adj.get(n));
              });
            }

            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _iteratorError2 = undefined;
            context$2$0.prev = 6;
            _iterator2 = _getIterator(nodesNbrs);

          case 8:
            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
              context$2$0.next = 49;
              break;
            }

            nodeData = _step2.value;
            node = nodeData[0];
            _iteratorNormalCompletion3 = true;
            _didIteratorError3 = false;
            _iteratorError3 = undefined;
            context$2$0.prev = 14;
            _iterator3 = _getIterator(nodeData[1].entries());

          case 16:
            if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
              context$2$0.next = 30;
              break;
            }

            neighborsData = _step3.value;

            if (seen.has(neighborsData[0])) {
              context$2$0.next = 27;
              break;
            }

            if (!optData) {
              context$2$0.next = 25;
              break;
            }

            neighborsData.unshift(node);
            context$2$0.next = 23;
            return neighborsData;

          case 23:
            context$2$0.next = 27;
            break;

          case 25:
            context$2$0.next = 27;
            return [node, neighborsData[0]];

          case 27:
            _iteratorNormalCompletion3 = true;
            context$2$0.next = 16;
            break;

          case 30:
            context$2$0.next = 36;
            break;

          case 32:
            context$2$0.prev = 32;
            context$2$0.t0 = context$2$0['catch'](14);
            _didIteratorError3 = true;
            _iteratorError3 = context$2$0.t0;

          case 36:
            context$2$0.prev = 36;
            context$2$0.prev = 37;

            if (!_iteratorNormalCompletion3 && _iterator3['return']) {
              _iterator3['return']();
            }

          case 39:
            context$2$0.prev = 39;

            if (!_didIteratorError3) {
              context$2$0.next = 42;
              break;
            }

            throw _iteratorError3;

          case 42:
            return context$2$0.finish(39);

          case 43:
            return context$2$0.finish(36);

          case 44:
            seen.add(node);
            nodeData.length = 0;

          case 46:
            _iteratorNormalCompletion2 = true;
            context$2$0.next = 8;
            break;

          case 49:
            context$2$0.next = 55;
            break;

          case 51:
            context$2$0.prev = 51;
            context$2$0.t1 = context$2$0['catch'](6);
            _didIteratorError2 = true;
            _iteratorError2 = context$2$0.t1;

          case 55:
            context$2$0.prev = 55;
            context$2$0.prev = 56;

            if (!_iteratorNormalCompletion2 && _iterator2['return']) {
              _iterator2['return']();
            }

          case 58:
            context$2$0.prev = 58;

            if (!_didIteratorError2) {
              context$2$0.next = 61;
              break;
            }

            throw _iteratorError2;

          case 61:
            return context$2$0.finish(58);

          case 62:
            return context$2$0.finish(55);

          case 63:
          case 'end':
            return context$2$0.stop();
        }
      }, edgesIter, this, [[6, 51, 55, 63], [14, 32, 36, 44], [37,, 39, 43], [56,, 58, 62]]);
    })
  }, {
    key: 'getEdgeData',

    /**
     * Return the attribute object associated with edge (u,v).
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2,3]);
     * G.getEdgeData(0,1);
     * // {}
     * ```
     *
     * If the edge exists, it may be simpler to access `G.get(0).get(1)`.
     *
     * @param {Node} u Node.
     * @param {Node} v Node.
     * @param {*} optDefault
     *   Value to return if the edge (u,v) is not found.
     * @return {*} The edge attribute object.
     */
    value: function getEdgeData(u, v) {
      var optDefault = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

      var nbrs = this.adj.get(u);
      if (nbrs != null) {
        var data = nbrs.get(v);
        if (data != null) {
          return data;
        }
      }
      return optDefault;
    }
  }, {
    key: 'adjacencyList',

    /**
     * Return an adjacency list representation of the graph.
     *
     * The output adjacency list is in the order of G.nodes().
     * For directed graphs, only outgoing adjacencies are included.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2,3]);
     * G.adjacencyList();
     * // [[1], [0,2], [1,3], [2]]
     * ```
     *
     * @return {!Array.<Array>} The adjacency structure of the graph as a
     *      list of lists.
     */
    value: function adjacencyList() {
      /*eslint no-unused-vars:0*/
      return _Array$from((0, _internals.mapIterator)(this.adjacencyIter(), function (_ref3) {
        var _ref32 = _slicedToArray(_ref3, 2);

        var _ = _ref32[0];
        var adj = _ref32[1];
        return _Array$from(adj.keys());
      }));
    }
  }, {
    key: 'adjacencyIter',

    /**
     * Return an iterator of (node, adjacency map) tuples for all nodes.
     *
     * For directed graphs, only outgoing adjacencies are included.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2,3]);
     * Array.from(G.adjacencyIter());
     * // [
     * //   [0, Map {1: {}}],
     * //   [1, Map {0: {}, 2: {}}],
     * //   [2, Map {1: {}, 3: {}}],
     * //   [3, Map {2: {}]]
     * // ]
     * ```
     *
     * @return {!Iterator} An array of (node, adjacency map) tuples
     *      for all nodes in the graph.
     */
    value: function adjacencyIter() {
      return this.adj.entries();
    }
  }, {
    key: 'degree',

    /**
     * Return the degree of a node or nodes.
     *
     * The node degree is the number of edges adjacent to that node.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph();  // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2,3])
     * G.degree(0)
     * // 1
     * G.degree([0,1])
     * // Map {0: 1, 1: 2}
     * Array.from(G.degree([0,1]).values())
     * // [1, 2]
     * ```
     *
     * @param {(Node|Iterable)=} optNbunch (default=all nodes)
     *      An iterable of nodes.  The iterable will be iterated
     *      through once.
     * @param {string=} optWeight
     *      The edge attribute that holds the numerical value used
     *      as a weight.  If null or not defined, then each edge has weight 1.
     *      The degree is the sum of the edge weights adjacent to the node.
     * @return {!(number|Map)} A dictionary with nodes as keys and
     *      degree as values or a number if a single node is specified.
     */
    value: function degree(optNbunch, optWeight) {
      if (optNbunch != null && this.hasNode(optNbunch)) {
        // return a single node
        return this.degreeIter(optNbunch, optWeight).next().value[1];
      } else {
        return new _internalsMap2['default'](this.degreeIter(optNbunch, optWeight));
      }
    }
  }, {
    key: 'degreeIter',

    /**
     * Return an array for (node, degree).
     *
     * The node degree is the number of edges adjacent to that node.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph();  // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2,3])
     * Array.from(G.degreeIter(0));
     * // [[0, 1]]
     * Array.from(G.degreeIter([0,1]));
     * // [[0, 1], [1, 2]]
     * ```
     *
     * @param {(Node|Iterable)=} optNbunch (default=all nodes)
     *       A container of nodes.  The container will be iterated
     *       through once.
     * @param {string=} optWeight
     *      The edge attribute that holds the numerical value used
     *      as a weight.  If null or not defined, then each edge has weight 1.
     *      The degree is the sum of the edge weights adjacent to the node.
     * @return {!Iterator} of two-tuples of (node, degree).
     *
     * @export
     */
    value: function degreeIter(optNbunch, optWeight) {
      // istanbul ignore next

      var _this = this;

      var nodesNbrs;
      var iterator;

      if (optNbunch == null) {
        nodesNbrs = this.adj.entries();
      } else {
        (function () {
          var adj = _this.adj;
          nodesNbrs = (0, _internals.mapIterator)(_this.nbunchIter(optNbunch), function (n) {
            return (0, _internals.tuple2)(n, adj.get(n));
          });
        })();
      }

      if (!optWeight) {
        iterator = (0, _internals.mapIterator)(nodesNbrs, function (_ref4) {
          var _ref42 = _slicedToArray(_ref4, 2);

          var node = _ref42[0];
          var nbrs = _ref42[1];

          return [node, nbrs.size + +nbrs.has(node)];
        });
      } else {
        iterator = (0, _internals.mapIterator)(nodesNbrs, function (_ref5) {
          var _ref52 = _slicedToArray(_ref5, 2);

          var n = _ref52[0];
          var nbrs = _ref52[1];

          var sum = 0;

          nbrs.forEach(function (data) {
            var weight = data[optWeight];
            sum += +(weight != null ? weight : 1);
          });

          if (nbrs.has(n)) {
            var weight = nbrs.get(n)[optWeight];
            sum += +(weight != null ? weight : 1);
          }

          return [n, sum];
        });
      }

      return iterator;
    }
  }, {
    key: 'clear',

    /**
     * Remove all nodes and edges from the graph.
     *
     * This also removes the name, and all graph, node, and edge attributes.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph(); // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2,3]);
     * G.clear();
     * G.nodes();
     * // []
     * G.edges();
     * // []
     * ```
     */
    value: function clear() {
      this.name = '';
      this.adj.clear();
      this.node.clear();
      (0, _internals.clear)(this.graph);
    }
  }, {
    key: 'copy',

    /**
     * Return a copy of the graph.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph(); // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2,3]);
     * var H = G.copy();
     * ```
     *
     * ### Notes
     *
     * This makes a complete copy of the graph including all of the
     * node or edge attributes.
     *
     * @return {!Graph}
     */
    value: function copy() {
      return (0, _internals.deepcopy)(this);
    }
  }, {
    key: 'isMultigraph',

    /**
     * Return True if graph is a multigraph, False otherwise.
     *
     * @return {boolean} True if graph is a multigraph, False otherwise.
     */
    value: function isMultigraph() {
      return false;
    }
  }, {
    key: 'isDirected',

    /**
     * Return True if graph is directed, False otherwise.
     *
     * @return {boolean}  True if graph is directed, False otherwise.
     */
    value: function isDirected() {
      return false;
    }
  }, {
    key: 'toDirected',

    /**
     * Return a directed representation of the graph.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph(); // or MultiGraph, etc
     * G.addPath([0,1]);
     * var H = G.toDirected();
     * H.edges();
     * // [[0,1], [1,0]]
     * ```
     *
     * If already directed, return a (deep) copy
     *
     * ```
     * var G = new jsnx.DiGraph(); // or MultiDiGraph, etc
     * G.addPath([0,1]);
     * var H = G.toDirected();
     * H.edges();
     * // [[0,1]]
     * ```
     *
     * ### Notes
     *
     * This returns a "deepcopy" of the edge, node, and
     * graph attributes which attempts to completely copy
     * all of the data and references.
     *
     * This is in contrast to the similar `var H = new jsnx.DiGraph(G)` which
     * returns a shallow copy of the data.
     *
     * @return {!DiGraph}
     *   A directed graph with the same name, same nodes, and with
     *   each edge (u,v,data) replaced by two directed edges
     *   (u,v,data) and (v,u,data).
     */
    value: function toDirected() {
      var G = new (__webpack_require__(114))();
      G.name = this.name;
      G.addNodesFrom(this);
      G.addEdgesFrom(_regeneratorRuntime.mark(function callee$2$0() {
        var _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, nd, u, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, nbr;

        return _regeneratorRuntime.wrap(function callee$2$0$(context$3$0) {
          while (1) switch (context$3$0.prev = context$3$0.next) {
            case 0:
              _iteratorNormalCompletion4 = true;
              _didIteratorError4 = false;
              _iteratorError4 = undefined;
              context$3$0.prev = 3;
              _iterator4 = _getIterator(this.adjacencyIter());

            case 5:
              if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                context$3$0.next = 37;
                break;
              }

              nd = _step4.value;
              u = nd[0];
              _iteratorNormalCompletion5 = true;
              _didIteratorError5 = false;
              _iteratorError5 = undefined;
              context$3$0.prev = 11;
              _iterator5 = _getIterator(nd[1]);

            case 13:
              if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
                context$3$0.next = 20;
                break;
              }

              nbr = _step5.value;
              context$3$0.next = 17;
              return (0, _internals.tuple3)(u, nbr[0], (0, _internals.deepcopy)(nbr[1]));

            case 17:
              _iteratorNormalCompletion5 = true;
              context$3$0.next = 13;
              break;

            case 20:
              context$3$0.next = 26;
              break;

            case 22:
              context$3$0.prev = 22;
              context$3$0.t0 = context$3$0['catch'](11);
              _didIteratorError5 = true;
              _iteratorError5 = context$3$0.t0;

            case 26:
              context$3$0.prev = 26;
              context$3$0.prev = 27;

              if (!_iteratorNormalCompletion5 && _iterator5['return']) {
                _iterator5['return']();
              }

            case 29:
              context$3$0.prev = 29;

              if (!_didIteratorError5) {
                context$3$0.next = 32;
                break;
              }

              throw _iteratorError5;

            case 32:
              return context$3$0.finish(29);

            case 33:
              return context$3$0.finish(26);

            case 34:
              _iteratorNormalCompletion4 = true;
              context$3$0.next = 5;
              break;

            case 37:
              context$3$0.next = 43;
              break;

            case 39:
              context$3$0.prev = 39;
              context$3$0.t1 = context$3$0['catch'](3);
              _didIteratorError4 = true;
              _iteratorError4 = context$3$0.t1;

            case 43:
              context$3$0.prev = 43;
              context$3$0.prev = 44;

              if (!_iteratorNormalCompletion4 && _iterator4['return']) {
                _iterator4['return']();
              }

            case 46:
              context$3$0.prev = 46;

              if (!_didIteratorError4) {
                context$3$0.next = 49;
                break;
              }

              throw _iteratorError4;

            case 49:
              return context$3$0.finish(46);

            case 50:
              return context$3$0.finish(43);

            case 51:
            case 'end':
              return context$3$0.stop();
          }
        }, callee$2$0, this, [[3, 39, 43, 51], [11, 22, 26, 34], [27,, 29, 33], [44,, 46, 50]]);
      }).call(this));
      G.graph = (0, _internals.deepcopy)(this.graph);
      G.node = (0, _internals.deepcopy)(this.node);

      return G;
    }
  }, {
    key: 'toUndirected',

    /**
     * Return an undirected copy of the graph.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph(); // or MultiGraph, etc
     * G.addPath([0,1]);
     * var H = G.toDirected();
     * G.edges();
     * // [[0,1], [1,0]]
     * var G2 = H.toUndirected();
     * G2.edges();
     * // [[0,1]]
     * ```
     *
     * ### Notes
     *
     * This returns a "deepcopy" of the edge, node, and
     * graph attributes which attempts to completely copy
     * all of the data and references.
     *
     * This is in contrast to the similar `var H = new jsnx.Graph(G);` which
     * returns a shallow copy of the data.
     *
     * @return {!Graph} A deepcopy of the graph.
     * @export
     */
    value: function toUndirected() {
      return (0, _internals.deepcopy)(this);
    }
  }, {
    key: 'subgraph',

    /**
     * Return the subgraph induced on nodes in nbunch.
     *
     * The induced subgraph of the graph contains the nodes in nbunch
     * and the edges between those nodes.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2,3]);
     * var H = G.subgraph([0,1,2]);
     * H.edges();
     * // [[0,1], [1,2]]
     * ```
     *
     * ### Notes
     *
     * The graph, edge or node attributes just point to the original graph.
     * So changes to the node or edge structure will not be reflected in
     * the original graph while changes to the attributes will.
     *
     * To create a subgraph with its own copy of the edge/node attributes use:
     * `new jsnx.Graph(G.subgraph(nbunch))`.
     *
     * For an inplace reduction of a graph to a subgraph you can remove nodes:
     *
     * ```
     * G.removeNodesFrom(G.nodes().filter(function(n) {
     *      return nbunch.indexOf(n) > -1;
     * }))
     * ```
     *
     * @param {Iterable} nbunch
     *      An iterable of nodes which will be iterated through once.
     * @return {Graph}
     */
    value: function subgraph(nbunch) {
      var bunch = this.nbunchIter(nbunch);
      var n;

      // create new graph and copy subgraph into it
      var H = new this.constructor();
      // copy node and attribute dictionaries
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = _getIterator(bunch), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          n = _step6.value;

          H.node.set(n, this.node.get(n));
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6['return']) {
            _iterator6['return']();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      // namespace shortcuts for speed
      var HAdj = H.adj;
      var thisAdj = this.adj;

      // add nodes and edges (undirected method)
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = _getIterator(H), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          n = _step7.value;

          var Hnbrs = new _internalsMap2['default']();
          HAdj.set(n, Hnbrs);

          var _iteratorNormalCompletion8 = true;
          var _didIteratorError8 = false;
          var _iteratorError8 = undefined;

          try {
            for (var _iterator8 = _getIterator(thisAdj.get(n)), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
              var nbrdata = _step8.value;

              var nbr = nbrdata[0];
              var data = nbrdata[1];
              if (HAdj.has(nbr)) {
                // add both representations of edge: n-nbr and nbr-n
                Hnbrs.set(nbr, data);
                HAdj.get(nbr).set(n, data);
              }
            }
          } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion8 && _iterator8['return']) {
                _iterator8['return']();
              }
            } finally {
              if (_didIteratorError8) {
                throw _iteratorError8;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7['return']) {
            _iterator7['return']();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      H.graph = this.graph;

      return H;
    }
  }, {
    key: 'nodesWithSelfloops',

    /**
     * Return a list of nodes with self loops.
     *
     * A node with a self loop has an edge with both ends adjacent
     * to that node.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph();   // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addEdge(1, 1)
     * G.addEdge(1, 2)
     * G.nodesWithSelfloops()
     * // [1]
     * ```
     *
     * @return {Array} A list of nodes with self loops.
     */
    value: function nodesWithSelfloops() {
      var nodes = [];
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = _getIterator(this.adj.entries()), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var nd = _step9.value;

          if (nd[1].has(nd[0])) {
            nodes.push(nd[0]);
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9['return']) {
            _iterator9['return']();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      return nodes;
    }
  }, {
    key: 'selfloopEdges',

    /**
     * Return a list of selfloop edges.
     *
     * A selfloop edge has the same node at both ends.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph();   // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addEdge(1,1)
     * G.addEdge(1,2)
     * G.selfloopEdges()
     * // [(1, 1)]
     * G.selfloop_edges(true)
     * // [(1, 1, {})]
     * ```
     *
     * @param {boolean=} optData
     *      Return selfloop edges as two tuples (u,v) (data=False)
     *      or three-tuples (u,v,data) (data=True).
     *
     * @return {Array}  A list of all selfloop edges.
     */
    value: function selfloopEdges() {
      var optData = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];

      var edges = [];

      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = _getIterator(this.adj.entries()), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var nd = _step10.value;

          var _nd = _slicedToArray(nd, 2);

          var node = _nd[0];
          var nbrs = _nd[1];

          if (nbrs.has(node)) {
            if (optData) {
              edges.push((0, _internals.tuple3c)(node, node, nbrs.get(node), nd));
            } else {
              edges.push((0, _internals.tuple2c)(node, node, nd));
            }
          }
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10['return']) {
            _iterator10['return']();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }

      return edges;
    }
  }, {
    key: 'numberOfSelfloops',

    /**
     * Return the number of selfloop edges.
     *
     * A selfloop edge has the same node at both ends.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph();   // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.add_edge(1,1)
     * G.add_edge(1,2)
     * G.number_of_selfloops()
     * // 1
     * ```
     *
     * @return {number} The number of selfloops.
     */
    value: function numberOfSelfloops() {
      return this.selfloopEdges().length;
    }
  }, {
    key: 'size',

    /**
     * Return the number of edges.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph();   // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2,3])
     * G.size()
     * // 3
     *
     * var G = new jsnx.Graph();   // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addEdge('a',' b', {weight: 2});
     * G.addEdge('b', 'c', {weight: 4});
     * G.size()
     * // 2
     * G.size('weight');
     * // 6.0
     * ```
     *
     * @param {string=} optWeight The edge attribute that holds the numerical
     *      value used as a weight.  If not defined, then each edge has weight 1.
     * @return {number} The number of edges or sum of edge weights in the graph.
     */
    value: function size(optWeight) {
      var s = 0;
      var _iteratorNormalCompletion11 = true;
      var _didIteratorError11 = false;
      var _iteratorError11 = undefined;

      try {
        for (var _iterator11 = _getIterator(this.degree(null, optWeight).values()), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
          var v = _step11.value;

          s += v;
        }
      } catch (err) {
        _didIteratorError11 = true;
        _iteratorError11 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion11 && _iterator11['return']) {
            _iterator11['return']();
          }
        } finally {
          if (_didIteratorError11) {
            throw _iteratorError11;
          }
        }
      }

      s = s / 2;

      if (optWeight == null) {
        return Math.floor(s); // int(s)
      } else {
        return s; // no need to cast to float
      }
    }
  }, {
    key: 'numberOfEdges',

    /**
     * Return the number of edges between two nodes.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph();   // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2,3]);
     * G.numberOfEdges();
     * // 3
     * G.number_of_edges(0,1);
     * // 1
     * ```
     *
     * @param {!Node=} u node.
     * @param {!Node=} v node
     *       If u and v are both specified, return the number of edges between
     *       u and v. Otherwise return the total number of all edges.
     * @return {number} The number of edges in the graph.
     *      If nodes u and v are specified return the number of edges between
     *      those nodes.
     */
    value: function numberOfEdges(u, v) {
      if (u == null) {
        return Math.floor(this.size());
      }
      if (this.adj.get(u).has(v)) {
        return 1;
      } else {
        return 0;
      }
    }
  }, {
    key: 'addStar',

    /**
     * Add a star.
     *
     * ### Examples
     * ```
     * var G = new jsnx.Graph();   // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addStar([0,1,2,3]);
     * G.addStar([10,11,12], {weight: 2});
     * ```
     *
     * The first node in nodes is the middle of the star.  It is connected
     * to all other nodes.
     *
     * @param {Iterable} nodes A container of nodes.
     * @param {Object=} optAttr  Attributes to add to every edge in the star.
     */
    value: function addStar(nodes, optAttr) {
      var niter = (0, _internals.toIterator)(nodes);
      var v = niter.next().value;
      var edges = (0, _internals.mapIterator)(niter, function (n) {
        return (0, _internals.tuple2)(v, n);
      });
      this.addEdgesFrom(edges, optAttr);
    }
  }, {
    key: 'addPath',

    /**
     * Add a path.
     *
     * ### Examples
     *
     * ```
     * var G= new jsnx.Graph();   // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2,3]);
     * G.addPath([10,11,12], {weight: 7});
     * ```
     *
     * @param {Iterable} nodes A container of nodes.
     *      A path will be constructed from the nodes (in order)
     *      and added to the graph.
     * @param {Object=} optAttr Attributes to add to every edge in path.
     */
    value: function addPath(nodes, optAttr) {
      var nlist = _Array$from(nodes);
      var edges = (0, _internals.zipSequence)(nlist.slice(0, nlist.length - 1), nlist.slice(1));
      this.addEdgesFrom(edges, optAttr);
    }
  }, {
    key: 'addCycle',

    /**
     * Add a cycle.
     *
     * ### Examples
     *
     * ```
     * var G= new jsnx.Graph();   // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addCycle([0,1,2,3]);
     * G.addCycle([10,11,12], {weight: 7});
     * ```
     *
     * @param {Iterable} nodes A container of nodes.
     *      A cycle will be constructed from the nodes (in order)
     *      and added to the graph.
     * @param {Object=} optAttr  Attributes to add to every edge in cycle.
     */
    value: function addCycle(nodes, optAttr) {
      var nlist = _Array$from(nodes);
      var edges = (0, _internals.zipSequence)(nlist, nlist.slice(1).concat([nlist[0]]));
      this.addEdgesFrom(edges, optAttr);
    }
  }, {
    key: 'nbunchIter',

    /**
     * Return an iterator of nodes contained in `nbunch` that are
     * also in the graph.
     *
     * The nodes in `nbunch` are checked for membership in the graph
     * and if not are silently ignored.
     *
     * ### Notes
     *
     * When `nbunch` is an iterator, the returned iterator yields values
     * directly from `nbunch`, becoming exhausted when `nbunch` is exhausted.
     *
     * To test whether `nbunch` is a single node, one can use
     * `if (this.hasNode(nbunch))`, even after processing with this routine.
     *
     * If `nbunch` is not a node or a (possibly empty) sequence/iterator
     * or not defined, an Error is raised.
     *
     * @param {(Node|Iterable)=} optNbunch (default=all nodes)
     *      A container of nodes.  The container will be iterated
     *      through once.
     * @return {!Iterator} An iterator over nodes in nbunch
     *      that are also in the graph.
     *      If nbunch is null or not defined, iterate over all nodes in the graph.
     */
    value: _regeneratorRuntime.mark(function nbunchIter(optNbunch) {
      var adj, _iteratorNormalCompletion12, _didIteratorError12, _iteratorError12, _iterator12, _step12, n;

      return _regeneratorRuntime.wrap(function nbunchIter$(context$2$0) {
        while (1) switch (context$2$0.prev = context$2$0.next) {
          case 0:
            if (!(optNbunch == null)) {
              context$2$0.next = 4;
              break;
            }

            return context$2$0.delegateYield(this.adj.keys(), 't0', 2);

          case 2:
            context$2$0.next = 44;
            break;

          case 4:
            if (!this.hasNode(optNbunch)) {
              context$2$0.next = 9;
              break;
            }

            context$2$0.next = 7;
            return optNbunch;

          case 7:
            context$2$0.next = 44;
            break;

          case 9:
            adj = this.adj;
            context$2$0.prev = 10;
            _iteratorNormalCompletion12 = true;
            _didIteratorError12 = false;
            _iteratorError12 = undefined;
            context$2$0.prev = 14;
            _iterator12 = _getIterator((0, _internals.toIterator)(optNbunch));

          case 16:
            if (_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done) {
              context$2$0.next = 24;
              break;
            }

            n = _step12.value;

            if (!adj.has(n)) {
              context$2$0.next = 21;
              break;
            }

            context$2$0.next = 21;
            return n;

          case 21:
            _iteratorNormalCompletion12 = true;
            context$2$0.next = 16;
            break;

          case 24:
            context$2$0.next = 30;
            break;

          case 26:
            context$2$0.prev = 26;
            context$2$0.t1 = context$2$0['catch'](14);
            _didIteratorError12 = true;
            _iteratorError12 = context$2$0.t1;

          case 30:
            context$2$0.prev = 30;
            context$2$0.prev = 31;

            if (!_iteratorNormalCompletion12 && _iterator12['return']) {
              _iterator12['return']();
            }

          case 33:
            context$2$0.prev = 33;

            if (!_didIteratorError12) {
              context$2$0.next = 36;
              break;
            }

            throw _iteratorError12;

          case 36:
            return context$2$0.finish(33);

          case 37:
            return context$2$0.finish(30);

          case 38:
            context$2$0.next = 44;
            break;

          case 40:
            context$2$0.prev = 40;
            context$2$0.t2 = context$2$0['catch'](10);

            if (!(context$2$0.t2 instanceof TypeError)) {
              context$2$0.next = 44;
              break;
            }

            throw new _exceptionsJSNetworkXError2['default']('nbunch is not a node or a sequence of nodes');

          case 44:
          case 'end':
            return context$2$0.stop();
        }
      }, nbunchIter, this, [[10, 40], [14, 26, 30, 38], [31,, 33, 37]]);
    })
  }, {
    key: _Symbol$iterator,

    /**
     * A graph is an iterable over its nodes.
     *
     * ### Example
     *
     * ```
     * var G = new jsnx.Graph();   // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addNodesFrom([0,1,2,3]);
     * for (var node of G) {
     *   console.log(node);
     * }
     * ```
     *
     * @return {Iterator}
     */
    value: function value() {
      return this.node.keys();
    }
  }, {
    key: 'name',

    /**
     * Gets or sets the name of the graph.
     *
     * @param {string=} opt_name Graph name.
     * @return {(string|undefined)} Graph name if no parameter was passed.
     */
    get: function get() {
      return this.graph.name || '';
    },
    set: function set(name) {
      this.graph.name = name;
    }
  }], [{
    key: '__name__',

    /**
     * Holds the graph type (class) name for information.
     *
     * @type {string}
     */
    get: function get() {
      return 'Graph';
    }
  }]);

  return Graph;
})();

exports['default'] = Graph;
module.exports = exports['default'];
// helper dict to keep track of multiply stored edges
// include all nodes
/*jshint expr:true*/
// if nbunch is a single node
// if nbunch is a sequence of nodes

/***/ }),
/* 72 */
/***/ (function(module, exports) {

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(35);

/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */
function toObject(value) {
  return isObject(value) ? value : Object(value);
}

module.exports = toObject;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(378),
    isArrayLike = __webpack_require__(90),
    isObject = __webpack_require__(35),
    shimKeys = __webpack_require__(804);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeKeys = getNative(Object, 'keys');

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
var keys = !nativeKeys ? shimKeys : function(object) {
  var Ctor = object == null ? undefined : object.constructor;
  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
      (typeof object != 'function' && isArrayLike(object))) {
    return shimKeys(object);
  }
  return isObject(object) ? nativeKeys(object) : [];
};

module.exports = keys;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(3);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(483);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(265)
  , enumBugKeys = __webpack_require__(160);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(125);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(99)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(549)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(175)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = __webpack_require__(56)['default'];

var _classCallCheck = __webpack_require__(24)['default'];

var _getIterator = __webpack_require__(8)['default'];

var _regeneratorRuntime = __webpack_require__(19)['default'];

var _Symbol$iterator = __webpack_require__(147)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.symmetricDifference = symmetricDifference;
exports.union = union;
/**
 * @fileoverview
 * A shim for ES6 maps and support for custom hash functions via toString().
 */

var _Map = __webpack_require__(70);

var _Map2 = _interopRequireDefault(_Map);

var _toIterator = __webpack_require__(348);

var _toIterator2 = _interopRequireDefault(_toIterator);

var Set = (function () {

  /**
   * @param {Iterable} opt_data An object, array or iterator to populate the set
   * with.
   */

  function Set(optData) {
    _classCallCheck(this, Set);

    this._map = new _Map2['default']();

    if (optData != null) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _getIterator((0, _toIterator2['default'])(optData)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var v = _step.value;

          this.add(v);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator['return']) {
            _iterator['return']();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }

  _createClass(Set, [{
    key: 'has',

    /**
     * Returns true if the key is in the map.
     *
     * @param {*} value
     *
     * @return {boolean}
     */
    value: function has(value) {
      return this._map.has(value);
    }
  }, {
    key: 'add',

    /**
     * Adds the value and key to the map.
     *
     * @param {*} value
     *
     * @export
     */
    value: function add(value) {
      this._map.set(value, true);
    }
  }, {
    key: 'delete',

    /**
     * Remove value with given key.
     *
     * @param {*} value
     *
     * @export
     */
    value: function _delete(value) {
      return this._map['delete'](value);
    }
  }, {
    key: 'values',

    /**
     * Returns an array of values.
     *
     * @return {!Iterator}
     * @export
     */
    value: function values() {
      return this._map.keys();
    }
  }, {
    key: 'keys',

    /**
     * Returns an array of values.
     *
     * @return {!Iterator}
     * @export
     */
    value: function keys() {
      return this.values();
    }
  }, {
    key: 'entries',

    /**
     * Returns an array of values.
     *
     * @return {!Iterator}
     * @export
     */
    value: _regeneratorRuntime.mark(function entries() {
      var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, v;

      return _regeneratorRuntime.wrap(function entries$(context$2$0) {
        while (1) switch (context$2$0.prev = context$2$0.next) {
          case 0:
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _iteratorError2 = undefined;
            context$2$0.prev = 3;
            _iterator2 = _getIterator(this.values());

          case 5:
            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
              context$2$0.next = 12;
              break;
            }

            v = _step2.value;
            context$2$0.next = 9;
            return [v, v];

          case 9:
            _iteratorNormalCompletion2 = true;
            context$2$0.next = 5;
            break;

          case 12:
            context$2$0.next = 18;
            break;

          case 14:
            context$2$0.prev = 14;
            context$2$0.t0 = context$2$0['catch'](3);
            _didIteratorError2 = true;
            _iteratorError2 = context$2$0.t0;

          case 18:
            context$2$0.prev = 18;
            context$2$0.prev = 19;

            if (!_iteratorNormalCompletion2 && _iterator2['return']) {
              _iterator2['return']();
            }

          case 21:
            context$2$0.prev = 21;

            if (!_didIteratorError2) {
              context$2$0.next = 24;
              break;
            }

            throw _iteratorError2;

          case 24:
            return context$2$0.finish(21);

          case 25:
            return context$2$0.finish(18);

          case 26:
          case 'end':
            return context$2$0.stop();
        }
      }, entries, this, [[3, 14, 18, 26], [19,, 21, 25]]);
    })
  }, {
    key: 'clear',

    /**
     * Empties the set.
     *
     * @export
     */
    value: function clear() {
      this._map.clear();
    }
  }, {
    key: 'forEach',

    /**
     * Executes the provided callback for each item in the set.
     *
     * @param {function(*)} callback A function which gets the key as first
     *  argument and value as second argument.
     * @param {*=} opt_this Object/value to set this to inside the callback
     * @export
    */
    value: function forEach(callback, optThis) {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = _getIterator(this.values()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var v = _step3.value;

          callback.call(optThis, v, v, this);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3['return']) {
            _iterator3['return']();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }, {
    key: 'difference',

    /** EXTENSIONS **/
    /**
     * The following methods are not part of the ES6 Set class but are provided
     * for convenience. Once Sets become more widely available, we could simply
     * extend the native Set class.
     */

    /**
     * Returns a new set with the values of this set, not found in the other
     * sets.
     *
     * @param {...(Set|Array)} others
     */
    value: function difference() {
      var result = new Set(this);

      for (var _len = arguments.length, others = Array(_len), _key = 0; _key < _len; _key++) {
        others[_key] = arguments[_key];
      }

      for (var i = 0, l = others.length; i < l; i++) {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = _getIterator(others[i]), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var v = _step4.value;

            result['delete'](v);
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4['return']) {
              _iterator4['return']();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }
      return result;
    }
  }, {
    key: 'intersection',

    /**
     * Returns a new set containing only elements found in this and every
     * other set/array.
     *
     * @param {...(Set|Array)} others
     */
    value: function intersection() {
      var result = new Set();
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = _getIterator(this), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var v = _step5.value;

          for (var _len2 = arguments.length, others = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            others[_key2] = arguments[_key2];
          }

          /* eslint-disable no-loop-func */
          if (others.every(function (other) {
            return other.has(v);
          })) {
            result.add(v);
          }
          /* eslint-enable no-loop-func */
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5['return']) {
            _iterator5['return']();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return result;
    }
  }, {
    key: 'pop',

    /**
     * Removes and returns an element from the set.
     *
     * @return {?}
     */
    value: function pop() {
      try {
        var value = this.values().next().value;
        this['delete'](value);
        return value;
      } catch (ex) {} // eslint-disable-line no-empty
    }
  }, {
    key: _Symbol$iterator,

    /**
     * Returns an iterator for the set object.
     *
     * @return {Iterator}
     */
    value: function value() {
      return this.values();
    }
  }, {
    key: 'size',

    /**
     * Returns the number of element in the set.
     *
     * @return {number}
     * @export
     */
    get: function get() {
      return this._map.size;
    }
  }]);

  return Set;
})();

exports['default'] = Set;

function symmetricDifference(a, b) {
  var c = new Set(a);
  var _iteratorNormalCompletion6 = true;
  var _didIteratorError6 = false;
  var _iteratorError6 = undefined;

  try {
    for (var _iterator6 = _getIterator(b), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
      var v = _step6.value;

      if (a.has(v)) {
        c['delete'](v);
      } else {
        c.add(v);
      }
    }
  } catch (err) {
    _didIteratorError6 = true;
    _iteratorError6 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion6 && _iterator6['return']) {
        _iterator6['return']();
      }
    } finally {
      if (_didIteratorError6) {
        throw _iteratorError6;
      }
    }
  }

  return c;
}

function union(a, b) {
  var c = new Set(a);
  var _iteratorNormalCompletion7 = true;
  var _didIteratorError7 = false;
  var _iteratorError7 = undefined;

  try {
    for (var _iterator7 = _getIterator(b), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
      var v = _step7.value;

      c.add(v);
    }
  } catch (err) {
    _didIteratorError7 = true;
    _iteratorError7 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion7 && _iterator7['return']) {
        _iterator7['return']();
      }
    } finally {
      if (_didIteratorError7) {
        throw _iteratorError7;
      }
    }
  }

  return c;
}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = isArrayLike;
/**
 * Returns true of the array is an object and has a numerical length property.
 *
 * @param {?} v
 * @return {bool}
 */

function isArrayLike(v) {
  return v && typeof v === 'object' && typeof v.length === 'number' && typeof v !== 'function';
}

module.exports = exports['default'];

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol$iterator = __webpack_require__(147)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = isIterable;
/**
 * Returns true if object implement the @@iterator method.
 *
 * @param {*} obj

 * @return {boolean}
 */

function isIterable(obj) {
  return typeof obj[_Symbol$iterator] === 'function';
}

module.exports = exports['default'];

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = isIterator;
/**
 * Returns true if object is an iterator
 *
 * @param {*} obj
 *
 * @return {boolean}
 */

function isIterator(obj) {
  return obj && typeof obj.next === 'function';
}

module.exports = exports['default'];

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _KeyError = __webpack_require__(362);

var _KeyError2 = _interopRequireDefault(_KeyError);

var _JSNetworkXAlgorithmError = __webpack_require__(360);

var _JSNetworkXAlgorithmError2 = _interopRequireDefault(_JSNetworkXAlgorithmError);

var _JSNetworkXError = __webpack_require__(34);

var _JSNetworkXError2 = _interopRequireDefault(_JSNetworkXError);

var _JSNetworkXException = __webpack_require__(214);

var _JSNetworkXException2 = _interopRequireDefault(_JSNetworkXException);

var _JSNetworkXNoPath = __webpack_require__(361);

var _JSNetworkXNoPath2 = _interopRequireDefault(_JSNetworkXNoPath);

var _JSNetworkXUnfeasible = __webpack_require__(215);

var _JSNetworkXUnfeasible2 = _interopRequireDefault(_JSNetworkXUnfeasible);

exports.KeyError = _KeyError2['default'];
exports.JSNetworkXAlgorithmError = _JSNetworkXAlgorithmError2['default'];
exports.JSNetworkXError = _JSNetworkXError2['default'];
exports.JSNetworkXException = _JSNetworkXException2['default'];
exports.JSNetworkXNoPath = _JSNetworkXNoPath2['default'];
exports.JSNetworkXUnfeasible = _JSNetworkXUnfeasible2['default'];

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(524), __esModule: true };

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var getLength = __webpack_require__(221),
    isLength = __webpack_require__(72);

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

module.exports = isArrayLike;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = __webpack_require__(236);
var setInnerHTML = __webpack_require__(155);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(244);
var setTextContent = __webpack_require__(435);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(3);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactRef = __webpack_require__(941);
var ReactInstrumentation = __webpack_require__(36);

var warning = __webpack_require__(6);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(12);

var ReactBaseClasses = __webpack_require__(442);
var ReactChildren = __webpack_require__(986);
var ReactDOMFactories = __webpack_require__(987);
var ReactElement = __webpack_require__(95);
var ReactPropTypes = __webpack_require__(988);
var ReactVersion = __webpack_require__(989);

var createReactClass = __webpack_require__(990);
var onlyChild = __webpack_require__(994);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(12);

var ReactCurrentOwner = __webpack_require__(52);

var warning = __webpack_require__(6);
var canDefineProperty = __webpack_require__(446);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(444);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 98 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var $          = __webpack_require__(18)
  , createDesc = __webpack_require__(178);
module.exports = __webpack_require__(79) ? function(object, key, value){
  return $.setDesc(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(18).setDesc
  , has = __webpack_require__(134)
  , TAG = __webpack_require__(26)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(273)
  , defined = __webpack_require__(132);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(554);
var Iterators = __webpack_require__(81);
Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x === null ? NaN : +x;
});


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_value__ = __webpack_require__(193);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_value__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_array__ = __webpack_require__(302);
/* unused harmony reexport interpolateArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_basis__ = __webpack_require__(192);
/* unused harmony reexport interpolateBasis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__ = __webpack_require__(303);
/* unused harmony reexport interpolateBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_date__ = __webpack_require__(305);
/* unused harmony reexport interpolateDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_number__ = __webpack_require__(136);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__src_number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_object__ = __webpack_require__(306);
/* unused harmony reexport interpolateObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_round__ = __webpack_require__(611);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__src_round__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_string__ = __webpack_require__(308);
/* unused harmony reexport interpolateString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_transform_index__ = __webpack_require__(613);
/* unused harmony reexport interpolateTransformCss */
/* unused harmony reexport interpolateTransformSvg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_zoom__ = __webpack_require__(615);
/* unused harmony reexport interpolateZoom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_rgb__ = __webpack_require__(307);
/* unused harmony reexport interpolateRgb */
/* unused harmony reexport interpolateRgbBasis */
/* unused harmony reexport interpolateRgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_hsl__ = __webpack_require__(608);
/* unused harmony reexport interpolateHsl */
/* unused harmony reexport interpolateHslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_lab__ = __webpack_require__(609);
/* unused harmony reexport interpolateLab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_hcl__ = __webpack_require__(607);
/* unused harmony reexport interpolateHcl */
/* unused harmony reexport interpolateHclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(606);
/* unused harmony reexport interpolateCubehelix */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_quantize__ = __webpack_require__(610);
/* unused harmony reexport quantize */



















/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = hue;
/* harmony export (immutable) */ __webpack_exports__["c"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(304);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_path__ = __webpack_require__(616);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_path__["a"]; });



/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
});


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = linearish;
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__(631);





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* ticks */])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" /* default */])(domain(), count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* tickIncrement */])(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* tickIncrement */])(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* tickIncrement */])(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolateNumber */]);

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* copy */])(scale, linear());
  };

  return linearish(scale);
}


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tau; });
/* harmony export (immutable) */ __webpack_exports__["l"] = acos;
/* harmony export (immutable) */ __webpack_exports__["k"] = asin;
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;

var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
});


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
});


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _get = __webpack_require__(57)['default'];

var _inherits = __webpack_require__(58)['default'];

var _createClass = __webpack_require__(56)['default'];

var _classCallCheck = __webpack_require__(24)['default'];

var _slicedToArray = __webpack_require__(16)['default'];

var _Object$assign = __webpack_require__(89)['default'];

var _Array$from = __webpack_require__(13)['default'];

var _regeneratorRuntime = __webpack_require__(19)['default'];

var _getIterator = __webpack_require__(8)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

var _interopRequireWildcard = __webpack_require__(25)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _Graph2 = __webpack_require__(71);

var _Graph3 = _interopRequireDefault(_Graph2);

var _internalsMap = __webpack_require__(70);

var _internalsMap2 = _interopRequireDefault(_internalsMap);

var _exceptionsJSNetworkXError = __webpack_require__(34);

var _exceptionsJSNetworkXError2 = _interopRequireDefault(_exceptionsJSNetworkXError);

var _convert = __webpack_require__(213);

var convert = _interopRequireWildcard(_convert);

var _internals = __webpack_require__(15);

/**
 * Base class for directed graphs.
 *
 * A DiGraph stores nodes and edges with optional data, or attributes.
 *
 * DiGraphs hold directed edges.  Self loops are allowed but multiple
 * (parallel) edges are not.
 *
 * Nodes can be strings, numbers or any object with a custom `toString` method.
 *
 * Edges are represented as links between nodes with optional
 * key/value attributes.
 *
 * ### Examples
 *
 * Create an empty graph (a "null graph") with no nodes and no edges.
 *
 * ```
 * var G = new jsnx.DiGraph();
 * ```
 *
 * G can be grown in several ways.
 *
 * #### Nodes
 *
 * Add one node at a time:
 *
 * ```
 * G.addNode(1);
 * ```
 *
 * Add the nodes from any iterable:
 *
 * ```
 * G.addNodesFrom([2, 3]);
 * G.addNodesFrom(new Set('foo', 'bar'));
 * var H = jsnx.completeGraph(10);
 * G.addNodesFrom(H);
 * ```
 *
 * In addition to strings, numbers and arrays, any object that implements a
 * custom `toString` method can be used as node.
 *
 * #### Edges
 *
 * `G` can also be grown by adding edges.
 *
 * Add one edge,
 *
 * ```
 * G.addEdge(1, 2);
 * ```
 *
 * a list of edges,
 *
 * ```
 * G.addEdgesFrom([[1,2], [1,3]]);
 * ```
 *
 * or a collection of edges,
 *
 * ```
 * G.addEdgesFrom(H.edges);
 * ```
 *
 * If some edges connect nodes not yet in the graph, the nodes are added
 * automatically. There are no errors when adding nodes or edges that already
 * exist.
 *
 * #### Attributes
 *
 * Each graph, node and edge can hold key/value attribute pairs in an associated
 * attribute object (keys must be strings or numbers).
 * By default these are empty, but can added or changed using `addEdge`,
 * `addNode`.
 *
 * ```
 * var G = new jsnx.DiGraph(null, {day: 'Friday'});
 * G.graph
 * // {day: 'Friday'}
 * ```
 *
 * Add node attributes using `addNode()` or `addNodesFrom()`:
 *
 * ```
 * G.addNode(1, {time: '5pm'});
 * G.addNodesFrom([2, [3, {time: '3pm'}]], {time: '2pm'});
 * G.nodes(true);
 * // [[1, {time: '5pm'}], [2, {time: '2pm'}], [3, {time: '3pm'}]]
 * ```
 *
 * Add edge attributes using `addEdge()`, or `addEdgesFrom()`:
 *
 * ```
 * G.addEdge(1, w, {weight: 4.7});
 * G.addEdgesFrom([[3,4], [4,5]], {color: 'red'});
 * ```
 *
 * @see Graph
 * @see MultiGraph
 * @see MultiDiGraph
 */

var DiGraph = (function (_Graph) {
  _inherits(DiGraph, _Graph);

  /**
   * @param {Iterable} optData
   *      Data to initialize graph.  If data=None (default) an empty
   *      graph is created.  The data can be an edge list, or any
   *      JSNetworkX graph object.
   *
   * @param {Object=} optAttr
   *       Attributes to add to graph as key=value pairs.
   */

  function DiGraph(optData, optAttr) {
    _classCallCheck(this, DiGraph);

    _get(Object.getPrototypeOf(DiGraph.prototype), 'constructor', this).call(this);
    this.graph = {}; // dictionary for graph attributes
    this.node = new _internalsMap2['default'](); // dictionary for node attributes
    // We store two adjacency lists:
    // the  predecessors of node n are stored in the dict self.pred
    // the successors of node n are stored in the dict self.succ=self.adj
    this.adj = new _internalsMap2['default'](); // empty adjacency dictionary
    this.pred = new _internalsMap2['default'](); // predecessor
    this.succ = this.adj; // successor

    //attempt to load graph with data
    if (optData != null) {
      convert.toNetworkxGraph(optData, this);
    }
    // load graph attributes (must be afte convert)
    _Object$assign(this.graph, optAttr || {});
    this.edge = this.adj;
  }

  _createClass(DiGraph, [{
    key: 'addNode',

    /**
     * Add a single node n and update node attributes.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addNode(1);
     * G.addNode('Hello');
     * G.numberOfNodes();
     * 2
     * ```
     *
     * @see #addNodesFrom
     *
     * @param {Node} n Node
     * @param {Object=} opt_attr_dict Dictionary of node attributes.
     *      Key/value pairs will update existing data associated with the node.
     */
    value: function addNode(n) {
      var optAttrDict = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

      if (!(0, _internals.isPlainObject)(optAttrDict)) {
        throw new _exceptionsJSNetworkXError2['default']('The opt_attr_dict argument must be an object.');
      }

      if (!this.succ.has(n)) {
        this.succ.set(n, new _internalsMap2['default']());
        this.pred.set(n, new _internalsMap2['default']());
        this.node.set(n, optAttrDict);
      } else {
        // update attr even if node already exists
        _Object$assign(this.node.get(n), optAttrDict);
      }
    }
  }, {
    key: 'addNodesFrom',

    /**
     * Add multiple nodes.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph(); // or DiGraph, MultiGraph, MultiDiGraph
     * G.addNodesFrom([1,2,3]);
     * G.nodes();
     * // [1,2,3]
     * ```
     *
     * Use the second argument to update specific node attributes for every node.
     *
     * ```
     * G.addNodesFrom([1,2], {size: 10});
     * G.addNodesFrom([2,3], {weight: 0.4});
     * ```
     *
     * Use `(node, object)` tuples to update attributes for specific nodes.
     *
     * ```
     * G.addNodesFrom([[1, {size: 11}], [2, {color: 'blue'}]]);
     * G.node.get(1).size
     * // 11
     * var H = new jsnx.Graph();
     * H.addNodesFrom(G.nodes(true));
     * H.node.get(1).size
     * // 11
     * ```
     *
     * @see #addNode
     *
     * @param {Iterable} nodes
     *      An iterable of nodes
     *      OR
     *      An iterable of (node, object) tuples.
     *
     * @param {Object=} optAttr  Update attributes for all nodes in nodes.
     *       Node attributes specified in nodes as a tuple
     *       take precedence over attributes specified generally.
     */
    value: function addNodesFrom(nodes) {
      var optAttr = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

      // if an object, only iterate over the keys
      (0, _internals.forEach)(nodes, function (n) {
        var newnode = !this.succ.has(n);

        // test whether n is a (node, attr) tuple
        if (Array.isArray(n) && n.length === 2 && (0, _internals.isPlainObject)(n[1])) {
          var nn = n[0];
          var ndict = n[1];

          if (!this.succ.has(nn)) {
            this.succ.set(nn, new _internalsMap2['default']());
            this.pred.set(nn, new _internalsMap2['default']());
            var newdict = (0, _internals.clone)(optAttr);
            _Object$assign(newdict, ndict);
            this.node.set(nn, newdict);
          } else {
            var olddict = this.node.get(nn);
            _Object$assign(olddict, optAttr, ndict);
          }
        } else if (newnode) {
          this.succ.set(n, new _internalsMap2['default']());
          this.pred.set(n, new _internalsMap2['default']());
          this.node.set(n, (0, _internals.clone)(optAttr));
        } else {
          _Object$assign(this.node.get(n), optAttr);
        }
      }, this);
    }
  }, {
    key: 'removeNode',

    /**
     * Remove node n.
     *
     * Removes the node n and all adjacent edges.
     * Attempting to remove a non-existent node will raise an exception.
     *
     * ### Example
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2]);
     * G.edges();
     * // [[0,1], [1,2]]
     * G.removeNode(1);
     * G.edges();
     * // []
     * ```
     *
     * @see #removeNodesFrom
     *
     * @param {Node} n  A node in the graph
     */
    value: function removeNode(n) {
      if (this.node['delete'](n)) {
        var nbrs = this.succ.get(n);
        nbrs.forEach(function (_, u) {
          this.pred.get(u)['delete'](n); // remove all edges n-u in digraph
        }, this);
        this.succ['delete'](n); // remove node from succ
        this.pred.get(n).forEach(function (_, u) {
          this.succ.get(u)['delete'](n); // remove all edges n-u in digraph
        }, this);
        this.pred['delete'](n); // remove node from pred
      } else {
        throw new _exceptionsJSNetworkXError2['default']((0, _internals.sprintf)('The node "%j" is not in the graph', n));
      }
    }
  }, {
    key: 'removeNodesFrom',

    /**
     * Remove multiple nodes.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2]);
     * var e = G.nodes(); // [0,1,2]
     * G.removeNodesFrom(e);
     * G.nodes();
     * // []
     * ```
     *
     * @see #removeNode
     *
     * @param {Iterable} nodes  A container of nodes.
     *      If a node in the container is not in the graph it is silently ignored.
     */
    value: function removeNodesFrom(nodes) {
      (0, _internals.forEach)(nodes, function (n) {
        if (this.succ.has(n)) {
          var succs = this.succ.get(n);

          this.node['delete'](n);
          succs.forEach(function (_, u) {
            // remove all edges n-u in digraph
            this.pred.get(u)['delete'](n);
          }, this);
          this.succ['delete'](n); // remove node from succ
          this.pred.get(n).forEach(function (_, u) {
            // remove all edges n-u in digraph
            this.succ.get(u)['delete'](n);
          }, this);
          this.pred['delete'](n); // remove node from pred
        }
      }, this);
    }
  }, {
    key: 'addEdge',

    /**
     * Add an edge between u and v.
     *
     * The nodes u and v will be automatically added if they are
     * not already in the graph.
     *
     * Edge attributes can be specified with keywords or by providing
     * a object with key/value pairs as third argument.
     *
     *
     * ### Examples
     *
     * The following all add the edge `(1,2)` to graph `G`:
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addEdge(1,2);
     * G.addEdgesFrom([[1,2]]);
     * ```
     *
     * Associate data to edges using an object:
     *
     * ```
     * G.addEdge(1, 2, {weight: 3});
     * G.addEdge(1, 3, {weight: 7, capacity: 15, length: 342.7});
     * ```
     *
     * ### Notes
     *
     * Adding an edge that already exists updates the edge data.
     *
     * Many algorithms designed for weighted graphs use as the edge weight a
     * numerical value assigned to an attribute which by default is 'weight'.
     *
     * @see #addEdgesFrom
     *
     * @param {Node} u Node
     * @param {Node} v Node
     * @param {Object=} optAttrDict Object of edge attributes.
     *      Key/value pairs will update existing data associated with the edge.
     */
    value: function addEdge(u, v) {
      var optAttrDict = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

      if (!(0, _internals.isPlainObject)(optAttrDict)) {
        throw new _exceptionsJSNetworkXError2['default']('The optAttrDict argument must be a plain object.');
      }

      // add nodes
      if (!this.succ.has(u)) {
        this.succ.set(u, new _internalsMap2['default']());
        this.pred.set(u, new _internalsMap2['default']());
        this.node.set(u, {});
      }

      if (!this.succ.has(v)) {
        this.succ.set(v, new _internalsMap2['default']());
        this.pred.set(v, new _internalsMap2['default']());
        this.node.set(v, {});
      }

      // add the edge
      var datadict = this.adj.get(u).get(v) || {};
      _Object$assign(datadict, optAttrDict);
      this.succ.get(u).set(v, datadict);
      this.pred.get(v).set(u, datadict);
    }
  }, {
    key: 'addEdgesFrom',

    /**
     * Add all the edges in `ebunch`.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addEdgesFrom([[0,1], [1,2]]); // using a list of edges
     * ```
     *
     * Associate data to edges
     *
     * ```
     * G.addEdgesFrom([[1,2], [2,3]], {weight: 3});
     * G.addEdgesFrom([[3,4], [1,4]], {label: 'WN2898'});
     * ```
     *
     * ### Notes
     *
     * Adding the same edge twice has no effect but any edge data
     * will be updated when each duplicate edge is added.
     *
     * @see #add_edge
     * @see #addWeightedEdgesFrom
     *
     * @param {Iterable} ebunch container of edges
     *      Each edge given in the container will be added to the
     *      graph. The edges must be given as as 2-tuples (u,v) or
     *      3-tuples (u,v,d) where d is a dictionary containing edge data.
     *
     * @param {Object=} optAttrDict Object of edge attributes.
     *      Dictionary of edge attributes.  Key/value pairs will
     *      update existing data associated with each edge.
     */
    value: function addEdgesFrom(ebunch) {
      var optAttrDict = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

      if (!(0, _internals.isPlainObject)(optAttrDict)) {
        throw new _exceptionsJSNetworkXError2['default']('The opt_attr_dict argument must be an object.');
      }

      // process ebunch
      (0, _internals.forEach)(ebunch, function (edge) {
        var length = (0, _internals.size)(edge);
        var u, v, edgeData;
        if (length === 3) {
          u = edge[0];
          v = edge[1];
          edgeData = edge[2];
        } else if (length === 2) {
          u = edge[0];
          v = edge[1];
          edgeData = {};
        } else {
          throw new _exceptionsJSNetworkXError2['default']((0, _internals.sprintf)('Edge tuple "%j" must be a 2-tuple or 3-tuple.', edge));
        }

        if (!this.succ.has(u)) {
          this.succ.set(u, new _internalsMap2['default']());
          this.pred.set(u, new _internalsMap2['default']());
          this.node.set(u, {});
        }
        if (!this.succ.has(v)) {
          this.succ.set(v, new _internalsMap2['default']());
          this.pred.set(v, new _internalsMap2['default']());
          this.node.set(v, {});
        }

        var datadict = this.adj.get(u).get(v) || {};
        _Object$assign(datadict, optAttrDict, edgeData);
        this.succ.get(u).set(v, datadict);
        this.pred.get(v).set(u, datadict);
      }, this);
    }
  }, {
    key: 'removeEdge',

    /**
     * Remove the edge between u and v.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2,3]);
     * G.removeEdge(0,1);
     * ```
     *
     * @see #removeEdgesFrom
     *
     * @param {Node} u Node
     * @param {Node} v Node
     */
    value: function removeEdge(u, v) {
      var edge = this.succ.get(u);
      if (edge !== undefined && edge['delete'](v)) {
        this.pred.get(v)['delete'](u);
      } else {
        throw new _exceptionsJSNetworkXError2['default']((0, _internals.sprintf)('The edge "%j-%j" is not in the graph', u, v));
      }
    }
  }, {
    key: 'removeEdgesFrom',

    /**
     * Remove all edges specified in `ebunch`.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2,3]);
     * var ebunch = [[1,2], [2,3]];
     * G.removeEdgesFrom(ebunch);
     * ```
     *
     * ### Notes
     *
     * Will fail silently if an edge in `ebunch` is not in the graph.
     *
     * @param {Iterable} ebunch Iterable of edge tuples
     *      Each edge given in the list or container will be removed
     *      from the graph. The edges can be:
     *        - 2-tuples (u,v) edge between u and v.
     *        - 3-tuples (u,v,k) where k is ignored.
     */
    value: function removeEdgesFrom(ebunch) {
      (0, _internals.forEach)(ebunch, function (edge) {
        var u = edge[0]; // ignore edge data if present
        var v = edge[1];

        try {
          this.succ.get(u)['delete'](v);
          this.pred.get(v)['delete'](u);
        } catch (ex) {}
      }, this);
    }
  }, {
    key: 'hasSuccessor',

    /**
     * Return True if node u has successor v.
     *
     * This is true if graph has the edge u->v.
     *
     * @param {Node} u Node
     * @param {Node} v Node
     * @return {boolean} True if node u has successor v
     */
    value: function hasSuccessor(u, v) {
      return this.succ.has(u) && this.succ.get(u).has(v);
    }
  }, {
    key: 'hasPredecessor',

    /**
     * Return True if node u has predecessor v.
     *
     * This is true if graph has the edge u<-v.
     *
     * @param {Node} u Node
     * @param {Node} v Node
     * @return {boolean} True if node u has predecessor v
     */
    value: function hasPredecessor(u, v) {
      return this.pred.has(u) && this.pred.get(u).has(v);
    }
  }, {
    key: 'successorsIter',

    /**
     * Return an iterator over successor nodes of n.
     *
     * `neighborsIter()` and `successorsIter()` are the same.
     *
     * @param {Node} n Node
     * @return {!Iterator} Iterator over successor nodes of n
     */
    value: function successorsIter(n) {
      var nbrs = this.succ.get(n);
      if (nbrs !== undefined) {
        return nbrs.keys();
      }
      throw new _exceptionsJSNetworkXError2['default']((0, _internals.sprintf)('The node "%j" is not in the digraph.', n));
    }
  }, {
    key: 'predecessorsIter',

    /**
     * Return an iterator over predecessor nodes of n.
     *
     * @param {Node} n Node
     * @return {!Iterator} Iterator over predecessor nodes of n
     */
    value: function predecessorsIter(n) {
      var nbrs = this.pred.get(n);
      if (nbrs !== undefined) {
        return nbrs.keys();
      }
      throw new _exceptionsJSNetworkXError2['default']((0, _internals.sprintf)('The node "%j" is not in the digraph.', n));
    }
  }, {
    key: 'successors',

    /**
     * Return a list of successor nodes of n.
     *
     * `neighbors()` and `successors()` are the same.
     *
     * @param {Node} n Node
     * @return {!Array} List of successor nodes of n
     */
    value: function successors(n) {
      return _Array$from(this.successorsIter(n));
    }
  }, {
    key: 'predecessors',

    /**
     * Return list of predecessor nodes of n.
     *
     * @param {Node} n Node
     * @return {!Array} List of predecessor nodes of n
     */
    value: function predecessors(n) {
      return _Array$from(this.predecessorsIter(n));
    }
  }, {
    key: 'neighbors',

    // digraph definitions
    /**
     * @alias successors
     */
    value: function neighbors(n) {
      return this.successors(n);
    }
  }, {
    key: 'neighborsIter',

    /**
     * @alias successorsIter
     */
    value: function neighborsIter(n) {
      return this.successorsIter(n);
    }
  }, {
    key: 'edgesIter',

    /**
     * Return an iterator over the edges.
     *
     * Edges are returned as tuples with optional data in the order
     * `(node, neighbor, data)`.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.DiGraph() // or MultiDiGraph, etc
     * G.addPath([0,1,2]);;
     * G.addEdge(2, 3, {weight: 5});
     * Array.from(G.edgesIter());
     * // [[0,1], [1,2], [2,3]]
     * Array.from(G.edgeIter(true)); // default data is {}
     * // [[0,1,{}], [1,2,{}], [2,3,{weight: 5}]]
     * Array.from(G.edgesIter([0,2]));
     * // [[0,1], [2,3]]
     * Array.from(G.edgesIter(0));
     * // [[0,1]]
     * ```
     *
     *
     * ### Notes
     *
     * Nodes in `nbunch` that are not in the graph will be (quietly) ignored.
     *
     * @see #edges
     *
     * @param {?boolean=} optNbunch A container of nodes.
     *       The container will be iterated through once.
     * @param {?boolean=} optData
     *      If True, return edge attribute dict in 3-tuple (u,v,data).
     * @return {!Iterator} An iterator of (u,v) or (u,v,d) tuples of edges.
     */
    value: _regeneratorRuntime.mark(function edgesIter(optNbunch) {
      var optData = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

      var nodesNbrs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, nodeNbrs, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, nbrData, result;

      return _regeneratorRuntime.wrap(function edgesIter$(context$2$0) {
        // istanbul ignore next

        var _this = this;

        while (1) switch (context$2$0.prev = context$2$0.next) {
          case 0:
            // handle calls with opt_data being the only argument
            if ((0, _internals.isBoolean)(optNbunch)) {
              optData = optNbunch;
              optNbunch = undefined;
            }

            if (optNbunch === undefined) {
              nodesNbrs = this.adj;
            } else {
              nodesNbrs = (0, _internals.mapIterator)(this.nbunchIter(optNbunch), function (n) {
                return (0, _internals.tuple2)(n, _this.adj.get(n));
              });
            }

            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            context$2$0.prev = 5;
            _iterator = _getIterator(nodesNbrs);

          case 7:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              context$2$0.next = 40;
              break;
            }

            nodeNbrs = _step.value;
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _iteratorError2 = undefined;
            context$2$0.prev = 12;
            _iterator2 = _getIterator(nodeNbrs[1]);

          case 14:
            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
              context$2$0.next = 23;
              break;
            }

            nbrData = _step2.value;
            result = [nodeNbrs[0], nbrData[0]];

            if (optData) {
              result[2] = nbrData[1];
            }
            context$2$0.next = 20;
            return result;

          case 20:
            _iteratorNormalCompletion2 = true;
            context$2$0.next = 14;
            break;

          case 23:
            context$2$0.next = 29;
            break;

          case 25:
            context$2$0.prev = 25;
            context$2$0.t0 = context$2$0['catch'](12);
            _didIteratorError2 = true;
            _iteratorError2 = context$2$0.t0;

          case 29:
            context$2$0.prev = 29;
            context$2$0.prev = 30;

            if (!_iteratorNormalCompletion2 && _iterator2['return']) {
              _iterator2['return']();
            }

          case 32:
            context$2$0.prev = 32;

            if (!_didIteratorError2) {
              context$2$0.next = 35;
              break;
            }

            throw _iteratorError2;

          case 35:
            return context$2$0.finish(32);

          case 36:
            return context$2$0.finish(29);

          case 37:
            _iteratorNormalCompletion = true;
            context$2$0.next = 7;
            break;

          case 40:
            context$2$0.next = 46;
            break;

          case 42:
            context$2$0.prev = 42;
            context$2$0.t1 = context$2$0['catch'](5);
            _didIteratorError = true;
            _iteratorError = context$2$0.t1;

          case 46:
            context$2$0.prev = 46;
            context$2$0.prev = 47;

            if (!_iteratorNormalCompletion && _iterator['return']) {
              _iterator['return']();
            }

          case 49:
            context$2$0.prev = 49;

            if (!_didIteratorError) {
              context$2$0.next = 52;
              break;
            }

            throw _iteratorError;

          case 52:
            return context$2$0.finish(49);

          case 53:
            return context$2$0.finish(46);

          case 54:
          case 'end':
            return context$2$0.stop();
        }
      }, edgesIter, this, [[5, 42, 46, 54], [12, 25, 29, 37], [30,, 32, 36], [47,, 49, 53]]);
    })
  }, {
    key: 'outEdgesIter',

    // alias out_edges to edges

    /**
     * @alias edgesIter
     */
    value: function outEdgesIter(optNbunch, optData) {
      return this.edgesIter(optNbunch, optData);
    }
  }, {
    key: 'outEdges',

    /**
     * @alias edges
     */
    value: function outEdges(optNbunch, optData) {
      return this.edges(optNbunch, optData);
    }
  }, {
    key: 'inEdgesIter',

    /**
     * Return an iterator over the incoming edges.
     *
     * @see edgesIter
     *
     * @param {?boolean=} optNbunch A container of nodes.
     *       The container will be iterated through once.
     * @param {?boolean=} optData
     *      If True, return edge attribute dict in 3-tuple (u,v,data).
     * @return {!Iterator} An iterator of (u,v) or (u,v,d) tuples of
     *      incoming edges.
     */
    value: _regeneratorRuntime.mark(function inEdgesIter(optNbunch) {
      var optData = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

      var nodesNbrs, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, nodeNbrs, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, nbrData, result;

      return _regeneratorRuntime.wrap(function inEdgesIter$(context$2$0) {
        // istanbul ignore next

        var _this2 = this;

        while (1) switch (context$2$0.prev = context$2$0.next) {
          case 0:
            // handle calls with opt_data being the only argument
            if ((0, _internals.isBoolean)(optNbunch)) {
              optData = optNbunch;
              optNbunch = undefined;
            }

            if (optNbunch === undefined) {
              nodesNbrs = this.pred;
            } else {
              nodesNbrs = (0, _internals.mapIterator)(this.nbunchIter(optNbunch), function (n) {
                return (0, _internals.tuple2)(n, _this2.pred.get(n));
              });
            }

            _iteratorNormalCompletion3 = true;
            _didIteratorError3 = false;
            _iteratorError3 = undefined;
            context$2$0.prev = 5;
            _iterator3 = _getIterator(nodesNbrs);

          case 7:
            if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
              context$2$0.next = 40;
              break;
            }

            nodeNbrs = _step3.value;
            _iteratorNormalCompletion4 = true;
            _didIteratorError4 = false;
            _iteratorError4 = undefined;
            context$2$0.prev = 12;
            _iterator4 = _getIterator(nodeNbrs[1]);

          case 14:
            if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
              context$2$0.next = 23;
              break;
            }

            nbrData = _step4.value;
            result = [nbrData[0], nodeNbrs[0]];

            if (optData) {
              result[2] = nbrData[1];
            }
            context$2$0.next = 20;
            return result;

          case 20:
            _iteratorNormalCompletion4 = true;
            context$2$0.next = 14;
            break;

          case 23:
            context$2$0.next = 29;
            break;

          case 25:
            context$2$0.prev = 25;
            context$2$0.t0 = context$2$0['catch'](12);
            _didIteratorError4 = true;
            _iteratorError4 = context$2$0.t0;

          case 29:
            context$2$0.prev = 29;
            context$2$0.prev = 30;

            if (!_iteratorNormalCompletion4 && _iterator4['return']) {
              _iterator4['return']();
            }

          case 32:
            context$2$0.prev = 32;

            if (!_didIteratorError4) {
              context$2$0.next = 35;
              break;
            }

            throw _iteratorError4;

          case 35:
            return context$2$0.finish(32);

          case 36:
            return context$2$0.finish(29);

          case 37:
            _iteratorNormalCompletion3 = true;
            context$2$0.next = 7;
            break;

          case 40:
            context$2$0.next = 46;
            break;

          case 42:
            context$2$0.prev = 42;
            context$2$0.t1 = context$2$0['catch'](5);
            _didIteratorError3 = true;
            _iteratorError3 = context$2$0.t1;

          case 46:
            context$2$0.prev = 46;
            context$2$0.prev = 47;

            if (!_iteratorNormalCompletion3 && _iterator3['return']) {
              _iterator3['return']();
            }

          case 49:
            context$2$0.prev = 49;

            if (!_didIteratorError3) {
              context$2$0.next = 52;
              break;
            }

            throw _iteratorError3;

          case 52:
            return context$2$0.finish(49);

          case 53:
            return context$2$0.finish(46);

          case 54:
          case 'end':
            return context$2$0.stop();
        }
      }, inEdgesIter, this, [[5, 42, 46, 54], [12, 25, 29, 37], [30,, 32, 36], [47,, 49, 53]]);
    })
  }, {
    key: 'inEdges',

    /**
     * Return a list of the incoming edges.
     *
     * @see #edges
     *
     * @param {?Iterable=} optNbunch A container of nodes.
     *       The container will be iterated through once.
     * @param {?boolean=} opt_data
     *      If True, return edge attribute dict in 3-tuple (u,v,data).
     * @return {!Array} A list of incoming edges
     */
    value: function inEdges(optNbunch) {
      var optData = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

      return _Array$from(this.inEdgesIter(optNbunch, optData));
    }
  }, {
    key: 'degreeIter',

    /**
     * Return an iterator for (node, degree).
     *
     * The node degree is the number of edges adjacent to the node.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.DiGraph() // or MultiDiGraph, etc
     * G.addPath([0,1,2,3]);
     * Array.from(G.degreeIter(0));
     * // [[0, 1]]
     * Array.from(G.degreeIter([0,1]));
     * // [[0, 1], [1, 2]]
     * ```
     *
     * @see #degree
     * @see #inDegree
     * @see #outDegree
     * @see #inDegreeIter
     * @see #outDegreeIter
     *
     * @param {(Node|Iterable)=} optNbunch  A container of nodes.
     *       The container will be iterated through once.
     * @param {string=} optWeight
     *       The edge attribute that holds the numerical value used
     *       as a weight.  If None, then each edge has weight 1.
     *       The degree is the sum of the edge weights adjacent to the node.
     * @return {!Iterator}  The iterator returns two-tuples of (node, degree).
     */
    value: function degreeIter(optNbunch, optWeight) {
      // istanbul ignore next

      var _this3 = this;

      var nodesNbrs;

      if (optNbunch == null) {
        nodesNbrs = (0, _internals.zipIterator)(this.succ.entries(), this.pred.entries());
      } else {
        var tuple2Succ = (0, _internals.createTupleFactory)(2);
        var tuple2Pred = (0, _internals.createTupleFactory)(2);
        nodesNbrs = (0, _internals.zipIterator)((0, _internals.mapIterator)(this.nbunchIter(optNbunch), function (n) {
          return tuple2Succ(n, _this3.succ.get(n));
        }), (0, _internals.mapIterator)(this.nbunchIter(optNbunch), function (n) {
          return tuple2Pred(n, _this3.pred.get(n));
        }));
      }

      if (optWeight == null) {
        /*eslint no-unused-vars:0*/
        return (0, _internals.mapIterator)(nodesNbrs, function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2);

          var _ref2$0 = _slicedToArray(_ref2[0], 2);

          var node = _ref2$0[0];
          var succ = _ref2$0[1];

          var _ref2$1 = _slicedToArray(_ref2[1], 2);

          var u = _ref2$1[0];
          var pred = _ref2$1[1];
          return [node, pred.size + succ.size];
        });
      } else {
        // edge weighted graph - degree is sum of edge weights
        return (0, _internals.mapIterator)(nodesNbrs, function (_ref3) {
          var _ref32 = _slicedToArray(_ref3, 2);

          var _ref32$0 = _slicedToArray(_ref32[0], 2);

          var node = _ref32$0[0];
          var succ = _ref32$0[1];

          var _ref32$1 = _slicedToArray(_ref32[1], 2);

          var _ = _ref32$1[0];
          var pred = _ref32$1[1];

          var sum = 0;

          function sumData(data) {
            var weight = data[optWeight];
            sum += weight != null ? +weight : 1;
          }

          succ.forEach(sumData);
          pred.forEach(sumData);

          return [node, sum];
        });
      }
    }
  }, {
    key: 'inDegreeIter',

    /**
     * Return an iterator for (node, in-degree).
     *
     * The node in-degree is the number of edges pointing in to the node.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.DiGraph();
     * G.addPath([0,1,2,3]);
     * Array.from(G.inDegreeIter(0));
     * // [[0, 0]]
     * Array.from(G.inDegreeIter([0,1]));
     * // [[0, 0], [1, ]]
     * ```
     *
     * @see #degree
     * @see #inDegree
     * @see #outDegree
     * @see #outDegreeIter
     *
     * @param {(Node|Iterable)=} optNbunch  A container of nodes.
     *       The container will be iterated through once.
     *
     * @param {string=} optWeight
     *       The edge attribute that holds the numerical value used
     *       as a weight.  If null or undefined, then each edge has weight 1.
     *       The degree is the sum of the edge weights adjacent to the node.
     * @return {Iterator}  The iterator returns two-tuples of (node, in-degree).
     */
    value: function inDegreeIter(optNbunch, optWeight) {
      // istanbul ignore next

      var _this4 = this;

      var nodesNbrs;

      if (optNbunch == null) {
        nodesNbrs = this.pred;
      } else {
        nodesNbrs = (0, _internals.mapIterator)(this.nbunchIter(optNbunch), function (n) {
          return (0, _internals.tuple2)(n, _this4.pred.get(n));
        });
      }

      if (optWeight == null) {
        return (0, _internals.mapIterator)(nodesNbrs, function (_ref4) {
          var _ref42 = _slicedToArray(_ref4, 2);

          var node = _ref42[0];
          var pred = _ref42[1];
          return [node, pred.size];
        });
      } else {
        return (0, _internals.mapIterator)(nodesNbrs, function (_ref5) {
          var _ref52 = _slicedToArray(_ref5, 2);

          var node = _ref52[0];
          var pred = _ref52[1];

          var sum = 0;
          pred.forEach(function (data) {
            var weight = data[optWeight];
            sum += weight != null ? +weight : 1;
          });
          return [node, sum];
        });
      }
    }
  }, {
    key: 'outDegreeIter',

    /**
     * Return an iterator for (node, out-degree).
     *
     * The node out-degree is the number of edges pointing in to the node.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.DiGraph();
     * G.addPath([0,1,2,3]);
     * Array.from(G.outDegreeIter(0));
     * // [[0, 1]]
     * Array.from(G.outDegreeIter([0,1]));
     * // [[0, 1], [1, ]]
     *
     *
     * @see #degree
     * @see #inDegree
     * @see #outDegree
     * @see #inDegreeIter
     *
     * @param {(Node|Iterable)=} opt_nbunch  A container of nodes.
     *       The container will be iterated through once.
     * @param {string=} optWeight
     *       The edge attribute that holds the numerical value used
     *       as a weight.  If None, then each edge has weight 1.
     *       The degree is the sum of the edge weights adjacent to the node.
     * @return {Iterator}  The iterator returns two-tuples of (node, out-degree).
     */
    value: function outDegreeIter(optNbunch, optWeight) {
      // istanbul ignore next

      var _this5 = this;

      var nodesNbrs;

      if (optNbunch == null) {
        nodesNbrs = this.succ;
      } else {
        nodesNbrs = (0, _internals.mapIterator)(this.nbunchIter(optNbunch), function (n) {
          return (0, _internals.tuple2)(n, _this5.succ.get(n));
        });
      }

      if (optWeight == null) {
        return (0, _internals.mapIterator)(nodesNbrs, function (_ref6) {
          var _ref62 = _slicedToArray(_ref6, 2);

          var node = _ref62[0];
          var succ = _ref62[1];
          return [node, succ.size];
        });
      } else {
        return (0, _internals.mapIterator)(nodesNbrs, function (_ref7) {
          var _ref72 = _slicedToArray(_ref7, 2);

          var node = _ref72[0];
          var succ = _ref72[1];

          var sum = 0;
          succ.forEach(function (data) {
            var weight = data[optWeight];
            sum += weight != null ? +weight : 1;
          });
          return [node, sum];
        });
      }
    }
  }, {
    key: 'inDegree',

    /**
     * Return the in-degree of a node or nodes.
     *
     * The node in-degree is the number of edges pointing in to the node.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.DiGraph(); // or MultiDiGraph
     * G.addPath([0,1,2,3]);
     * G.inDegree(0);
     * // 0
     * G.inDegree([0,1]);
     * // Map {0: 0, 1: 1}
     * Array.from(G.inDegree([0,1]).values());
     * // [0, 1]
     * ```
     *
     * @see #degree
     * @see #outDegree
     * @see #inDegreeIter
     *
     *
     * @param {(Node|Iterable)=} optNbunch  A container of nodes.
     *       The container will be iterated through once.
     * @param {string=} opt_weight
     *       The edge attribute that holds the numerical value used
     *       as a weight.  If None, then each edge has weight 1.
     *       The degree is the sum of the edge weights adjacent to the node.
     * @return {(number|Map)}
     *       A dictionary with nodes as keys and in-degree as values or
     *       a number if a single node is specified.
     */
    value: function inDegree(optNbunch, optWeight) {
      if (optNbunch != null && this.hasNode(optNbunch)) {
        // return a single node
        return (0, _internals.next)(this.inDegreeIter(optNbunch, optWeight))[1];
      } else {
        return new _internalsMap2['default'](this.inDegreeIter(optNbunch, optWeight));
      }
    }
  }, {
    key: 'outDegree',

    /**
     * Return the out-degree of a node or nodes.
     *
     * The node out-degree is the number of edges pointing out of the node.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.DiGraph(); // or MultiDiGraph
     * G.addPath([0,1,2,3]);
     * G.outDegree(0);
     * // 1
     * G.outDegree([0,1]);
     * // Map {0: 1, 1: 1}
     * Array.from(G.inDegree([0,1]).values());
     * // [1, 1]
     * ```
     *
     * @see #degree
     * @see #out_degree
     * @see #in_degree_iter
     *
     * @param {(Node|Iterable)=} optNbunch  A container of nodes.
     *       The container will be iterated through once.
     * @param {string=} optWeight
     *       The edge attribute that holds the numerical value used
     *       as a weight.  If None, then each edge has weight 1.
     *       The degree is the sum of the edge weights adjacent to the node.
     * @return {(number|Map)}
     *       A dictionary with nodes as keys and in-degree as values or
     *       a number if a single node is specified.
     */
    value: function outDegree(optNbunch, optWeight) {
      if (optNbunch != null && this.hasNode(optNbunch)) {
        // return a single node
        return (0, _internals.next)(this.outDegreeIter(optNbunch, optWeight))[1];
      } else {
        return new _internalsMap2['default'](this.outDegreeIter(optNbunch, optWeight));
      }
    }
  }, {
    key: 'clear',

    /**
     * Remove all nodes and edges from the graph.
     *
     * This also removes the name, and all graph, node, and edge attributes.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2,3]);
     * G.clear();
     * G.nodes();
     * // []
     * G.edges();
     * // []
     * ```
     */
    value: function clear() {
      this.succ.clear();
      this.pred.clear();
      this.node.clear();
      (0, _internals.clear)(this.graph);
    }
  }, {
    key: 'isMultigraph',

    /**
     * Return True if graph is a multigraph, False otherwise.
     *
     * @return {boolean} True if graph is a multigraph, False otherwise.
     */
    value: function isMultigraph() {
      return false;
    }
  }, {
    key: 'isDirected',

    /**
     * Return True if graph is directed, False otherwise.
     *
     * @return {boolean}  True if graph is directed, False otherwise.
     */
    value: function isDirected() {
      return true;
    }
  }, {
    key: 'toDirected',

    /**
     * Return a directed copy of the graph.
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph(); // or MultiGraph, etc
     * G.addPath([0,1]);
     * var H = G.toDirected();
     * H.edges();
     * // [[0,1], [1,0]]
     * ```
     *
     * If already directed, return a (deep) copy
     *
     * ```
     * var G = new jsnx.DiGraph(); // or MultiDiGraph, etc
     * G.addPath([0,1]);
     * var H = G.toDirected();
     * H.edges();
     * // [[0,1]]
     * ```
     *
     * ### Notes
     *
     * This returns a "deepcopy" of the edge, node, and
     * graph attributes which attempts to completely copy
     * all of the data and references.
     *
     * This is in contrast to the similar `var H = new jsnx.DiGraph(G)` which
     * returns a shallow copy of the data.
     *
     * @return {!DiGraph} A deepcopy of the graph
     */
    value: function toDirected() {
      return (0, _internals.deepcopy)(this);
    }
  }, {
    key: 'toUndirected',

    /**
     * Return an undirected representation of the digraph.
     *
     * ### Notes
     *
     * If edges in both directions (u,v) and (v,u) exist in the
     * graph, attributes for the new undirected edge will be a combination of
     * the attributes of the directed edges.  The edge data is updated
     * in the (arbitrary) order that the edges are encountered.  For
     * more customized control of the edge attributes use `addEdge()`.
     *
     * This returns a "deepcopy" of the edge, node, and graph attributes which
     * attempts to completely copy all of the data and references.
     *
     * This is in contrast to the similar `var H = new jsnx.Graph(G)`
     * which returns a shallow copy of the data.
     *
     * @param {boolean=} optReciprocal
     *      If True only keep edges that appear in both directions
     *      in the original digraph.
     * @return {!Graph}
     *      An undirected graph with the same name and nodes and
     *      with edge (u,v,data) if either (u,v,data) or (v,u,data)
     *      is in the digraph.  If both edges exist in digraph and
     *      their edge data is different, only one edge is created
     *      with an arbitrary choice of which edge data to use.
     *      You must check and correct for this manually if desired.
     */
    value: function toUndirected(optReciprocal) {
      var H = new _Graph3['default']();
      H.name = this.name;
      H.addNodesFrom(this);

      var thisPred = this.pred;

      if (optReciprocal) {
        H.addEdgesFrom(_regeneratorRuntime.mark(function callee$2$0() {
          var _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, nodeData, node, predecessors, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, nbrData;

          return _regeneratorRuntime.wrap(function callee$2$0$(context$3$0) {
            while (1) switch (context$3$0.prev = context$3$0.next) {
              case 0:
                _iteratorNormalCompletion5 = true;
                _didIteratorError5 = false;
                _iteratorError5 = undefined;
                context$3$0.prev = 3;
                _iterator5 = _getIterator(this.adjacencyIter());

              case 5:
                if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
                  context$3$0.next = 39;
                  break;
                }

                nodeData = _step5.value;
                node = nodeData[0];
                predecessors = thisPred.get(node);
                _iteratorNormalCompletion6 = true;
                _didIteratorError6 = false;
                _iteratorError6 = undefined;
                context$3$0.prev = 12;
                _iterator6 = _getIterator(nodeData[1]);

              case 14:
                if (_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done) {
                  context$3$0.next = 22;
                  break;
                }

                nbrData = _step6.value;

                if (!predecessors.has(nbrData[0])) {
                  context$3$0.next = 19;
                  break;
                }

                context$3$0.next = 19;
                return (0, _internals.tuple3)(node, nbrData[0], (0, _internals.deepcopy)(nbrData[1]));

              case 19:
                _iteratorNormalCompletion6 = true;
                context$3$0.next = 14;
                break;

              case 22:
                context$3$0.next = 28;
                break;

              case 24:
                context$3$0.prev = 24;
                context$3$0.t0 = context$3$0['catch'](12);
                _didIteratorError6 = true;
                _iteratorError6 = context$3$0.t0;

              case 28:
                context$3$0.prev = 28;
                context$3$0.prev = 29;

                if (!_iteratorNormalCompletion6 && _iterator6['return']) {
                  _iterator6['return']();
                }

              case 31:
                context$3$0.prev = 31;

                if (!_didIteratorError6) {
                  context$3$0.next = 34;
                  break;
                }

                throw _iteratorError6;

              case 34:
                return context$3$0.finish(31);

              case 35:
                return context$3$0.finish(28);

              case 36:
                _iteratorNormalCompletion5 = true;
                context$3$0.next = 5;
                break;

              case 39:
                context$3$0.next = 45;
                break;

              case 41:
                context$3$0.prev = 41;
                context$3$0.t1 = context$3$0['catch'](3);
                _didIteratorError5 = true;
                _iteratorError5 = context$3$0.t1;

              case 45:
                context$3$0.prev = 45;
                context$3$0.prev = 46;

                if (!_iteratorNormalCompletion5 && _iterator5['return']) {
                  _iterator5['return']();
                }

              case 48:
                context$3$0.prev = 48;

                if (!_didIteratorError5) {
                  context$3$0.next = 51;
                  break;
                }

                throw _iteratorError5;

              case 51:
                return context$3$0.finish(48);

              case 52:
                return context$3$0.finish(45);

              case 53:
              case 'end':
                return context$3$0.stop();
            }
          }, callee$2$0, this, [[3, 41, 45, 53], [12, 24, 28, 36], [29,, 31, 35], [46,, 48, 52]]);
        }).call(this));
      } else {
        H.addEdgesFrom(_regeneratorRuntime.mark(function callee$2$0() {
          var _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, nodeData, _iteratorNormalCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, nbrData;

          return _regeneratorRuntime.wrap(function callee$2$0$(context$3$0) {
            while (1) switch (context$3$0.prev = context$3$0.next) {
              case 0:
                _iteratorNormalCompletion7 = true;
                _didIteratorError7 = false;
                _iteratorError7 = undefined;
                context$3$0.prev = 3;
                _iterator7 = _getIterator(this.adjacencyIter());

              case 5:
                if (_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done) {
                  context$3$0.next = 36;
                  break;
                }

                nodeData = _step7.value;
                _iteratorNormalCompletion8 = true;
                _didIteratorError8 = false;
                _iteratorError8 = undefined;
                context$3$0.prev = 10;
                _iterator8 = _getIterator(nodeData[1]);

              case 12:
                if (_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done) {
                  context$3$0.next = 19;
                  break;
                }

                nbrData = _step8.value;
                context$3$0.next = 16;
                return (0, _internals.tuple3)(nodeData[0], nbrData[0], (0, _internals.deepcopy)(nbrData[1]));

              case 16:
                _iteratorNormalCompletion8 = true;
                context$3$0.next = 12;
                break;

              case 19:
                context$3$0.next = 25;
                break;

              case 21:
                context$3$0.prev = 21;
                context$3$0.t0 = context$3$0['catch'](10);
                _didIteratorError8 = true;
                _iteratorError8 = context$3$0.t0;

              case 25:
                context$3$0.prev = 25;
                context$3$0.prev = 26;

                if (!_iteratorNormalCompletion8 && _iterator8['return']) {
                  _iterator8['return']();
                }

              case 28:
                context$3$0.prev = 28;

                if (!_didIteratorError8) {
                  context$3$0.next = 31;
                  break;
                }

                throw _iteratorError8;

              case 31:
                return context$3$0.finish(28);

              case 32:
                return context$3$0.finish(25);

              case 33:
                _iteratorNormalCompletion7 = true;
                context$3$0.next = 5;
                break;

              case 36:
                context$3$0.next = 42;
                break;

              case 38:
                context$3$0.prev = 38;
                context$3$0.t1 = context$3$0['catch'](3);
                _didIteratorError7 = true;
                _iteratorError7 = context$3$0.t1;

              case 42:
                context$3$0.prev = 42;
                context$3$0.prev = 43;

                if (!_iteratorNormalCompletion7 && _iterator7['return']) {
                  _iterator7['return']();
                }

              case 45:
                context$3$0.prev = 45;

                if (!_didIteratorError7) {
                  context$3$0.next = 48;
                  break;
                }

                throw _iteratorError7;

              case 48:
                return context$3$0.finish(45);

              case 49:
                return context$3$0.finish(42);

              case 50:
              case 'end':
                return context$3$0.stop();
            }
          }, callee$2$0, this, [[3, 38, 42, 50], [10, 21, 25, 33], [26,, 28, 32], [43,, 45, 49]]);
        }).call(this));
      }

      H.graph = (0, _internals.deepcopy)(this.graph);
      H.node = (0, _internals.deepcopy)(this.node);
      return H;
    }
  }, {
    key: 'reverse',

    /**
     * Return the reverse of the graph.
     *
     * The reverse is a graph with the same nodes and edges
     * but with the directions of the edges reversed.
     *
     * @param {boolean=} optCopy (default=True)
     *      If True, return a new DiGraph holding the reversed edges.
     *      If False, reverse the reverse graph is created using
     *      the original graph (this changes the original graph).
     *
     * @return {!DiGraph} A copy of the graph or the graph itself
     */
    value: function reverse() {
      var optCopy = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

      var H;
      if (optCopy) {
        H = new this.constructor(null, { name: 'Reverse of (' + this.name + ')' });
        H.addNodesFrom(this);
        H.addEdgesFrom((0, _internals.mapIterator)(this.edgesIter(null, true), function (edge) {
          return (0, _internals.tuple3c)(edge[1], edge[0], (0, _internals.deepcopy)(edge[2]), edge);
        }));
        H.graph = (0, _internals.deepcopy)(this.graph);
        H.node = (0, _internals.deepcopy)(this.node);
      } else {
        var thisPred = this.pred;
        var thisSucc = this.succ;

        this.succ = thisPred;
        this.pred = thisSucc;
        this.adj = this.succ;
        H = this;
      }
      return H;
    }
  }, {
    key: 'subgraph',

    /**
     * Return the subgraph induced on nodes in `nbunch`.
     *
     * The induced subgraph of the graph contains the nodes in `nbunch`
     * and the edges between those nodes.
     *
     *
     * ### Examples
     *
     * ```
     * var G = new jsnx.Graph() // or DiGraph, MultiGraph, MultiDiGraph, etc
     * G.addPath([0,1,2,3]);
     * var H = G.subgraph([0,1,2]);
     * H.edges();
     * // [[0,1], [1,2]]
     * ```
     *
     * ### Notes
     *
     * The graph, edge or node attributes just point to the original graph.
     * So changes to the node or edge structure will not be reflected in
     * the original graph while changes to the attributes will.
     *
     * To create a subgraph with its own copy of the edge/node attributes use:
     * `new jsnx.Graph(G.subgraph(nbunch))`.
     *
     * For an inplace reduction of a graph to a subgraph you can remove nodes:
     *
     * ```
     * G.removeNodesFrom(G.nodes().filter(function(n) {
     *      return nbunch.indexOf(n) > -1;
     * }))
     * ```
     *
     * @param {Iterable} nbunch
     *      A container of nodes which will be iterated through once.
     * @return {DiGraph} A subgraph of the graph with the same edge
     *   attributes.
     */
    value: function subgraph(nbunch) {
      var bunch = this.nbunchIter(nbunch);
      var n;
      // create new graph and copy subgraph into it
      var H = new this.constructor();
      // copy node and attribute dictionaries
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = _getIterator(bunch), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          n = _step9.value;

          H.node.set(n, this.node.get(n));
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9['return']) {
            _iterator9['return']();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      // namespace shortcuts for speed
      var HSucc = H.succ;
      var HPred = H.pred;

      // add nodes
      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = _getIterator(H), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          n = _step10.value;

          HSucc.set(n, new _internalsMap2['default']());
          HPred.set(n, new _internalsMap2['default']());
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10['return']) {
            _iterator10['return']();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }

      // add edges
      var _iteratorNormalCompletion11 = true;
      var _didIteratorError11 = false;
      var _iteratorError11 = undefined;

      try {
        for (var _iterator11 = _getIterator(HSucc), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
          var unbrs = _step11.value;

          var _unbrs = _slicedToArray(unbrs, 2);

          var u = _unbrs[0];
          var Hnbrs = _unbrs[1];
          var _iteratorNormalCompletion12 = true;
          var _didIteratorError12 = false;
          var _iteratorError12 = undefined;

          try {
            for (var _iterator12 = _getIterator(this.succ.get(u)), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
              var vdataddict = _step12.value;

              var _vdataddict = _slicedToArray(vdataddict, 2);

              var v = _vdataddict[0];
              var datadict = _vdataddict[1];

              if (HSucc.has(v)) {
                // add both representations of edge: u-v and v-u
                Hnbrs.set(v, datadict);
                HPred.get(v).set(u, datadict);
              }
            }
          } catch (err) {
            _didIteratorError12 = true;
            _iteratorError12 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion12 && _iterator12['return']) {
                _iterator12['return']();
              }
            } finally {
              if (_didIteratorError12) {
                throw _iteratorError12;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError11 = true;
        _iteratorError11 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion11 && _iterator11['return']) {
            _iterator11['return']();
          }
        } finally {
          if (_didIteratorError11) {
            throw _iteratorError11;
          }
        }
      }

      H.graph = this.graph;
      return H;
    }
  }], [{
    key: '__name__',

    /**
     * Holds the graph type (class) name for information.
     *
     * @type {string}
     */
    get: function get() {
      return 'DiGraph';
    }
  }]);

  return DiGraph;
})(_Graph3['default']);

exports['default'] = DiGraph;
module.exports = exports['default'];

/*eslint no-empty:0*/
// pass

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(525), __esModule: true };

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(124);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(53);

var _keys2 = _interopRequireDefault(_keys);

exports.capitalizeFirstLetter = capitalizeFirstLetter;
exports.contains = contains;
exports.findIndex = findIndex;
exports.find = find;
exports.createChainedFunction = createChainedFunction;

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function capitalizeFirstLetter(string) {
   false ? (0, _warning2.default)(typeof string === 'string', 'Material-UI: capitalizeFirstLetter(string) expects a string argument.') : void 0;

  return string.charAt(0).toUpperCase() + string.slice(1);
} //  weak

function contains(obj, pred) {
  return (0, _keys2.default)(pred).every(function (key) {
    return obj.hasOwnProperty(key) && obj[key] === pred[key];
  });
}

function findIndex(arr, pred) {
  var predType = typeof pred === 'undefined' ? 'undefined' : (0, _typeof3.default)(pred);
  for (var i = 0; i < arr.length; i += 1) {
    if (predType === 'function' && !!pred(arr[i], i, arr) === true) {
      return i;
    }
    if (predType === 'object' && contains(arr[i], pred)) {
      return i;
    }
    if (['string', 'number', 'boolean'].indexOf(predType) !== -1) {
      return arr.indexOf(pred);
    }
  }
  return -1;
}

function find(arr, pred) {
  var index = findIndex(arr, pred);
  return index > -1 ? arr[index] : undefined;
}

/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (func) {
    return func != null;
  }).reduce(function (acc, func) {
     false ? (0, _warning2.default)(typeof func === 'function', 'Material-UI: invalid Argument Type, must only provide functions, undefined, or null.') : void 0;

    if (acc === null) {
      return func;
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, null);
}

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(918);


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var EventPluginRegistry = __webpack_require__(237);
var EventPluginUtils = __webpack_require__(238);
var ReactErrorUtils = __webpack_require__(242);

var accumulateInto = __webpack_require__(428);
var forEachAccumulated = __webpack_require__(429);
var invariant = __webpack_require__(3);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(118);
var EventPluginUtils = __webpack_require__(238);

var accumulateInto = __webpack_require__(428);
var forEachAccumulated = __webpack_require__(429);
var warning = __webpack_require__(6);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(51);

var getEventTarget = __webpack_require__(247);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getDisplayName = __webpack_require__(447);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
};

exports.default = wrapDisplayName;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(469);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(468);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 125 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(61)
  , dPs         = __webpack_require__(500)
  , enumBugKeys = __webpack_require__(160)
  , IE_PROTO    = __webpack_require__(167)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(256)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(495).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 127 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(31).f
  , has = __webpack_require__(63)
  , TAG = __webpack_require__(28)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(169)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 130 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(98)
  , TAG = __webpack_require__(26)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 132 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var ctx         = __webpack_require__(67)
  , call        = __webpack_require__(275)
  , isArrayIter = __webpack_require__(274)
  , anObject    = __webpack_require__(66)
  , toLength    = __webpack_require__(282)
  , getIterFn   = __webpack_require__(184);
module.exports = function(iterable, entries, fn, that){
  var iterFn = getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    call(iterator, f, step.value, entries);
  }
};

/***/ }),
/* 134 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(191);


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(Math.abs(x)), x ? x[1] : NaN;
});


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
});


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = deinterpolateLinear;
/* harmony export (immutable) */ __webpack_exports__["c"] = copy;
/* harmony export (immutable) */ __webpack_exports__["a"] = continuous;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(311);






var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* bisect */])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolate */],
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateRound */], rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Basis;
function point(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (function(context) {
  return new Basis(context);
});


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Cardinal;
function point(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Linear(context);
});


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {});


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
    return Array.isArray(val) ? [] : {}
}

function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
}

function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function(e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument));
        }
    });
    return destination
}

function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (isMergeableObject(target)) {
        Object.keys(target).forEach(function(key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
    }
    Object.keys(source).forEach(function(key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
    });
    return destination
}

function deepmerge(target, source, optionsArgument) {
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

    if (!sourceAndTargetTypesMatch) {
        return cloneIfNecessary(source, optionsArgument)
    } else if (sourceIsArray) {
        var arrayMerge = options.arrayMerge || defaultArrayMerge;
        return arrayMerge(target, source, optionsArgument)
    } else {
        return mergeObject(target, source, optionsArgument)
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements')
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, optionsArgument)
    })
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBrowser", function() { return isBrowser; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["default"] = (isBrowser);


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Array$from = __webpack_require__(13)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = range;

var _genRange = __webpack_require__(343);

var _genRange2 = _interopRequireDefault(_genRange);

/**
 * Implements Python's range function, returns an array.
 *
 * If one argument n is passed, iterates over 0...n.
 * If two arguments i,j are passed, iterates over i...j.
 * If three arguments i,j,k are passed, iterates over i, i+k, i+2k, ...j
 *
 * @param {?number=} optStart Number to start from
 * @param {?number=} optEnd Number to count to
 * @param {?number=} optStep Step size
 * @return {!Array}
 */

function range(optStart, optEnd, optStep) {
  return _Array$from((0, _genRange2['default'])(optStart, optEnd, optStep));
}

module.exports = exports['default'];

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regeneratorRuntime = __webpack_require__(19)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.fullRaryTree = fullRaryTree;
exports.balancedTree = balancedTree;
exports.completeGraph = completeGraph;
exports.cycleGraph = cycleGraph;
exports.emptyGraph = emptyGraph;
exports.grid2dGraph = grid2dGraph;
exports.nullGraph = nullGraph;
exports.pathGraph = pathGraph;
exports.trivialGraph = trivialGraph;
var marked0$0 = [treeEdges].map(_regeneratorRuntime.mark);

var _classesGraph = __webpack_require__(71);

var _classesGraph2 = _interopRequireDefault(_classesGraph);

var _internals = __webpack_require__(15);

/**
 * @param {number} n nodes
 * @param {number} r breadth
 * @return {Iterator}
 */
function treeEdges(n, r) {
  var nodes, parents, source, i, target;
  return _regeneratorRuntime.wrap(function treeEdges$(context$1$0) {
    while (1) switch (context$1$0.prev = context$1$0.next) {
      case 0:
        nodes = (0, _internals.genRange)(n);

        if (!(n === 0)) {
          context$1$0.next = 3;
          break;
        }

        return context$1$0.abrupt('return');

      case 3:
        parents = [(0, _internals.next)(nodes)];

      case 4:
        if (!(parents.length > 0)) {
          context$1$0.next = 20;
          break;
        }

        source = parents.shift();
        i = 0;

      case 7:
        if (!(i < r)) {
          context$1$0.next = 18;
          break;
        }

        target = nodes.next();

        if (!target.done) {
          context$1$0.next = 11;
          break;
        }

        return context$1$0.abrupt('return');

      case 11:
        target = target.value;
        parents.push(target);
        context$1$0.next = 15;
        return (0, _internals.tuple2)(source, target);

      case 15:
        i++;
        context$1$0.next = 7;
        break;

      case 18:
        context$1$0.next = 4;
        break;

      case 20:
      case 'end':
        return context$1$0.stop();
    }
  }, marked0$0[0], this);
}

/**
 * Creates a full r-ary tree of n vertices.
 *
 * Sometimes called a k-ary, n-ary, or m-ary tree.  "... all non-leaf
 * vertices have exactly r children and all levels are full except
 * for some rightmost position of the bottom level (if a leaf at the
 * bottom level is missing, then so are all of the leaves to its
 * right." (1)
 *
 * ### References
 *
 * [1] An introduction to data structures and algorithms,
 *    James Andrew Storer,  Birkhauser Boston 2001, (page 225).
 *
 * @param {number} r branching factor of the tree
 * @param {number} n number of nodes in the tree
 * @param {Graph=} optCreateUsing
 *   Use specified type to construct graph
 * @return {Graph} An r-ary tree with n nodes.
 */

function fullRaryTree(r, n, optCreateUsing) {
  var G = emptyGraph(n, optCreateUsing);
  G.addEdgesFrom(treeEdges(n, r));
  return G;
}

/**
 * Return the perfectly balanced r-tree of height h.
 *
 * This is the rooted tree where all leaves are at distance h from
 * the root. The root has degree r and all other internal nodes have
 * degree r+1.
 *
 * Node labels are the integers 0 (the root) up to  numberOfNodes - 1.
 *
 * Also referred to as a complete r-ary tree.
 *
 * @param {number} r  Branching factor of the tree
 * @param {number} h Height of the tree
 * @param {Graph} optCreateUsing
 *    Use specified type to construct graph
 * @return {Graph}
 */

function balancedTree(r, h, optCreateUsing) {
  var n = r === 1 ? h : Math.floor((1 - Math.pow(r, h + 1)) / (1 - r));
  var G = emptyGraph(n, optCreateUsing);
  G.addEdgesFrom(treeEdges(n, r));
  return G;
}

//TODO: barbell_graph

/**
 * Return the complete graph `$K_n$` with n nodes.
 *
 * Node labels are the integers 0 to n-1.
 * @param {number} n The number of nodes to add to the graph
 * @param {Graph=} optCreateUsing Graph instance to empty and add nodes to.
 * @return {Graph}
 */

function completeGraph(n, optCreateUsing) {
  var G = emptyGraph(n, optCreateUsing);
  G.name = 'complete_graph(' + n + ')';
  if (n > 1) {
    G.addEdgesFrom(G.isDirected() ? (0, _internals.genPermutations)((0, _internals.range)(n), 2) : (0, _internals.genCombinations)((0, _internals.range)(n), 2));
  }
  return G;
}

//TODO: complete_bipartite_graph
//TODO: circular_ladder_graph

/**
 * Return the cycle graph C_n over n nodes.
 *
 * `$C_n$` is the n-path with two end-nodes connected.
 *
 * Node labels are the integers 0 to n-1
 * If `optCreateUsing` is a DiGraph, the direction is in increasing order.
 *
 * @param {number} n The number of nodes to add to the graph
 * @param {Graph=} optCreateUsing Graph instance to empty and add nodes to.
 * @return {Graph}
 */

function cycleGraph(n, optCreateUsing) {
  var G = pathGraph(n, optCreateUsing);
  G.name = 'cycle_graph(' + n + ')';
  if (n > 1) {
    G.addEdge(n - 1, 0);
  }
  return G;
}

//TODO: dorogovtsev_goltsev_mendes_graph

/**
 * Return the empty graph with n nodes and zero edges.
 *
 * Node labels are the integers 0 to n-1
 *
 * ### Example
 *
 * ```
 * var G = jsnx.emptyGraph(10)
 * G.numberOfNodes()
 * // 10
 * G.numberOfEdges()
 * // 0
 * ```
 *
 * The variable `optCreateUsing` should point to a "graph"-like object that
 * will be cleaned (nodes and edges will be removed) and refitted as
 * an empty "graph" with n nodes with integer labels. This capability
 * is useful for specifying the class-nature of the resulting empty
 * "graph" (i.e. Graph, DiGraph, MyWeirdGraphClass, etc.).
 *
 * The variable `optCreateUsing` has two main uses:
 * Firstly, the variable `optCreateUsing` can be used to create an
 * empty digraph, network,etc.  For example,
 *
 * ```
 * var n = 10;
 * var G = jsnx.emptyGraph(n, new jsnx.DiGraph());
 * ```
 *
 * will create an empty digraph on n nodes.
 *
 * Secondly, one can pass an existing graph (digraph, pseudograph,
 * etc.) via `optCreateUsing`. For example, if `G` is an existing graph
 * (resp. digraph, pseudograph, etc.), then `emptyGraph(n,G)`
 * will empty G (i.e. delete all nodes and edges using `G.clear()` in
 * base) and then add n nodes and zero edges, and return the modified
 * graph (resp. digraph, pseudograph, etc.).
 *
 * @see createEmptyCopy
 *
 * @param {?number=} optN The number of nodes to add to the graph
 * @param {?Graph=} optCreateUsing Graph instance to empty and add nodes to.
 * @return {Graph}
 */

function emptyGraph(optN, optCreateUsing) {
  if ((0, _internals.isGraph)(optN)) {
    optCreateUsing = optN;
    optN = null;
  }
  if (optN == null) {
    optN = 0;
  }

  var G;

  if (optCreateUsing == null) {
    // default empty graph is a simple graph
    G = new _classesGraph2['default']();
  } else {
    G = optCreateUsing;
    G.clear();
  }

  G.addNodesFrom((0, _internals.genRange)(optN));
  G.name = 'emptyGraph(' + optN + ')';
  return G;
}

/**
 * Return the 2d grid graph of mxn nodes,
 * each connected to its nearest neighbors.
 * Optional argument `optPeriodic` will connect
 * boundary nodes via periodic boundary conditions.
 *
 * @param {number} rows Number of rows
 * @param {number} columns Number of columns
 * @param {boolean=} optPeriodic
 * @param {Graph=} optCreateUsing
 * @return {Graph}
 */

function grid2dGraph(rows, columns) {
  var optPeriodic = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
  var optCreateUsing = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];

  var G = emptyGraph(0, optCreateUsing);
  G.name = 'grid2dGraph';
  var i;
  var j;
  for (i = 0; i < rows; i++) {
    for (j = 0; j < columns; j++) {
      G.addNode([i, j]);
    }
  }
  for (i = 1; i < rows; i++) {
    for (j = 0; j < columns; j++) {
      G.addEdge([i, j], [i - 1, j]);
    }
  }
  for (i = 0; i < rows; i++) {
    for (j = 1; j < columns; j++) {
      G.addEdge([i, j], [i, j - 1]);
    }
  }
  if (G.isDirected()) {
    for (i = 0; i < rows - 1; i++) {
      for (j = 0; j < columns; j++) {
        G.addEdge([i, j], [i + 1, j]);
      }
    }
    for (i = 0; i < rows; i++) {
      for (j = 0; j < columns - 1; j++) {
        G.addEdge([i, j], [i, j + 1]);
      }
    }
  }

  if (optPeriodic) {
    if (columns > 2) {
      for (i = 0; i < rows; i++) {
        G.addEdge([i, 0], [i, columns - 1]);
      }
      if (G.isDirected()) {
        for (i = 0; i < rows; i++) {
          G.addEdge([i, columns - 1], [i, 0]);
        }
      }
    }
    if (rows > 2) {
      for (j = 0; j < columns; j++) {
        G.addEdge([0, j], [rows - 1, j]);
      }
      if (G.isDirected()) {
        for (j = 0; j < columns; j++) {
          G.addEdge([rows - 1, j], [0, j]);
        }
      }
    }
    G.name = 'periodicGrid2dGraph(' + rows + ', ' + columns + ')';
  }
  return G;
}

//TODO: grid_graph
//TODO: hypercube_graph
//TODO: ladder_graph
//TODO: lollipop_graph

/**
 * Return the Null graph with no nodes or edges.
 *
 * See `emptyGraph` for the use of `optCreateUsing`.
 *
 * @param {Graph=} optCreateUsing Graph instance to empty and add nodes to.
 * @return {Graph}
 */

function nullGraph(optCreateUsing) {
  var G = emptyGraph(0, optCreateUsing);
  G.name = 'nullGraph()';
  return G;
}

/**
 * Return the Null graph with no nodes or edges.
 *
 * See `emptyGraph` for the use of `optCreateUsing`.
 *
 * @param {number} n The number of nodes to add to the graph
 * @param {Graph=} optCreateUsing Graph instance to empty and
 *      add nodes to.
 * @return {Graph}
 */

function pathGraph(n, optCreateUsing) {
  var G = emptyGraph(n, optCreateUsing);
  G.name = 'pathGraph(' + n + ')';
  G.addEdgesFrom((0, _internals.mapIterator)((0, _internals.genRange)(n - 1), function (v) {
    return (0, _internals.tuple2)(v, v + 1);
  }));
  return G;
}

//TODO: star_graph

/**
 * Return the Trivial graph with one node (with integer label 0) and no edges.
 *
 * @param {Graph=} optCreateUsing Graph instance to empty and
 *      add nodes to.
 * @return {Graph}
 */

function trivialGraph(optCreateUsing) {
  var G = emptyGraph(1, optCreateUsing);
  G.name = 'nullGraph()';
  return G;
}

//TODO: wheel_graph

// helper function for trees
// yields edges in rooted tree at 0 with n nodes and branching ratio r

/*jshint unused:false*/

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(533), __esModule: true };

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(90),
    isObjectLike = __webpack_require__(49);

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Native method references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is classified as an `arguments` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  return isObjectLike(value) && isArrayLike(value) &&
    hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
}

module.exports = isArguments;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var baseForIn = __webpack_require__(781),
    isArguments = __webpack_require__(148),
    isObjectLike = __webpack_require__(49);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * **Note:** This method assumes objects created by the `Object` constructor
 * have no inherited enumerable properties.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  var Ctor;

  // Exit early for non `Object` objects.
  if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
      (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
    return false;
  }
  // IE < 9 iterates inherited properties before own properties. If the first
  // iterated property is an object's own property then there are no inherited
  // enumerable properties.
  var result;
  // In most environments an object's own properties are iterated before
  // its inherited properties. If the last iterated property is an object's
  // own property then there are no inherited enumerable properties.
  baseForIn(value, function(subValue, key) {
    result = key;
  });
  return result === undefined || hasOwnProperty.call(value, result);
}

module.exports = isPlainObject;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createRule = __webpack_require__(398);

var _createRule2 = _interopRequireDefault(_createRule);

var _updateRule = __webpack_require__(833);

var _updateRule2 = _interopRequireDefault(_updateRule);

var _linkRule = __webpack_require__(399);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _StyleRule = __webpack_require__(227);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Contains rules objects and allows adding/removing etc.
 * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
 */
var RuleList = function () {

  // Original styles object.
  function RuleList(options) {
    _classCallCheck(this, RuleList);

    this.map = {};
    this.raw = {};
    this.index = [];

    this.options = options;
    this.classes = options.classes;
  }

  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  // Used to ensure correct rules order.

  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.


  _createClass(RuleList, [{
    key: 'add',
    value: function add(name, decl, options) {
      var _options = this.options,
          parent = _options.parent,
          sheet = _options.sheet,
          jss = _options.jss,
          Renderer = _options.Renderer,
          generateClassName = _options.generateClassName;


      options = _extends({
        classes: this.classes,
        parent: parent,
        sheet: sheet,
        jss: jss,
        Renderer: Renderer,
        generateClassName: generateClassName
      }, options);

      if (!options.selector && this.classes[name]) options.selector = '.' + this.classes[name];

      this.raw[name] = decl;

      var rule = (0, _createRule2['default'])(name, decl, options);
      this.register(rule);

      var index = options.index === undefined ? this.index.length : options.index;
      this.index.splice(index, 0, rule);

      return rule;
    }

    /**
     * Get a rule.
     */

  }, {
    key: 'get',
    value: function get(name) {
      return this.map[name];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'remove',
    value: function remove(rule) {
      this.unregister(rule);
      this.index.splice(this.indexOf(rule), 1);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.index.indexOf(rule);
    }

    /**
     * Run `onProcessRule()` plugins on every rule.
     */

  }, {
    key: 'process',
    value: function process() {
      var plugins = this.options.jss.plugins;
      // We need to clone array because if we modify the index somewhere else during a loop
      // we end up with very hard-to-track-down side effects.

      this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    }

    /**
     * Register a rule in `.map` and `.classes` maps.
     */

  }, {
    key: 'register',
    value: function register(rule) {
      this.map[rule.key] = rule;
      if (rule instanceof _StyleRule2['default']) {
        this.map[rule.selector] = rule;
        this.classes[rule.key] = rule.selector.substr(1);
      }
    }

    /**
     * Unregister a rule.
     */

  }, {
    key: 'unregister',
    value: function unregister(rule) {
      delete this.map[rule.key];
      delete this.classes[rule.key];
      if (rule instanceof _StyleRule2['default']) delete this.map[rule.selector];
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'update',
    value: function update(name, data) {
      if (typeof name === 'string') {
        (0, _updateRule2['default'])(this.get(name), data, RuleList);
        return;
      }

      for (var index = 0; index < this.index.length; index++) {
        (0, _updateRule2['default'])(this.index[index], name, RuleList);
      }
    }

    /**
     * Link renderable rules with CSSRuleList.
     */

  }, {
    key: 'link',
    value: function link(cssRules) {
      for (var i = 0; i < cssRules.length; i++) {
        var cssRule = cssRules[i];
        var rule = this.get(this.options.sheet.renderer.getSelector(cssRule));
        if (rule) (0, _linkRule2['default'])(rule, cssRule);
      }
    }

    /**
     * Convert rules to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var str = '';

      for (var index = 0; index < this.index.length; index++) {
        var rule = this.index[index];
        var css = rule.toString(options);

        // No need to render an empty rule.
        if (!css) continue;

        if (str) str += '\n';
        str += css;
      }

      return str;
    }
  }]);

  return RuleList;
}();

exports['default'] = RuleList;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(12);

var EventPluginRegistry = __webpack_require__(237);
var ReactEventEmitterMixin = __webpack_require__(933);
var ViewportMetrics = __webpack_require__(427);

var getVendorPrefixedEventName = __webpack_require__(965);
var isEventSupported = __webpack_require__(248);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(121);
var ViewportMetrics = __webpack_require__(427);

var getEventModifierState = __webpack_require__(246);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(3);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(23);
var DOMNamespaces = __webpack_require__(236);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(244);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
                                                                                                                                                                                                                                                                                Copyright (c) 2016 Jed Watson.
                                                                                                                                                                                                                                                                                Licensed under the MIT License (MIT), see
                                                                                                                                                                                                                                                                                http://jedwatson.github.io/react-select
                                                                                                                                                                                                                                                                              */

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(117);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactInputAutosize = __webpack_require__(971);

var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _defaultArrowRenderer = __webpack_require__(978);

var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);

var _defaultFilterOptions = __webpack_require__(439);

var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);

var _defaultMenuRenderer = __webpack_require__(440);

var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);

var _defaultClearRenderer = __webpack_require__(979);

var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);

var _Async = __webpack_require__(973);

var _Async2 = _interopRequireDefault(_Async);

var _AsyncCreatable = __webpack_require__(974);

var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);

var _Creatable = __webpack_require__(975);

var _Creatable2 = _interopRequireDefault(_Creatable);

var _Option = __webpack_require__(976);

var _Option2 = _interopRequireDefault(_Option);

var _Value = __webpack_require__(977);

var _Value2 = _interopRequireDefault(_Value);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function stringifyValue(value) {
	var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	if (valueType === 'string') {
		return value;
	} else if (valueType === 'object') {
		return JSON.stringify(value);
	} else if (valueType === 'number' || valueType === 'boolean') {
		return String(value);
	} else {
		return '';
	}
}

var stringOrNode = _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.node]);

var instanceId = 1;

var _ref = _react2.default.createElement(
	'span',
	{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
	_react2.default.createElement('span', { className: 'Select-loading' })
);

var _ref2 = _react2.default.createElement(
	'span',
	{ className: 'Select-aria-only' },
	'\xA0'
);

var Select = _react2.default.createClass({

	displayName: 'Select',

	propTypes: {
		addLabelText: _react2.default.PropTypes.string, // placeholder displayed when you want to add a label on a multi-value input
		'aria-describedby': _react2.default.PropTypes.string, // HTML ID(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _react2.default.PropTypes.string, // Aria label (for assistive tech)
		'aria-labelledby': _react2.default.PropTypes.string, // HTML ID of an element that should be used as the label (for assistive tech)
		arrowRenderer: _react2.default.PropTypes.func, // Create drop-down caret element
		autoBlur: _react2.default.PropTypes.bool, // automatically blur the component when an option is selected
		autofocus: _react2.default.PropTypes.bool, // autofocus the component on mount
		autosize: _react2.default.PropTypes.bool, // whether to enable autosizing or not
		backspaceRemoves: _react2.default.PropTypes.bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _react2.default.PropTypes.string, // Message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _react2.default.PropTypes.string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _react2.default.PropTypes.func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _react2.default.PropTypes.bool, // should it be possible to reset value
		deleteRemoves: _react2.default.PropTypes.bool, // whether backspace removes an item if there is no text input
		delimiter: _react2.default.PropTypes.string, // delimiter to use to join multiple values for the hidden field value
		disabled: _react2.default.PropTypes.bool, // whether the Select is disabled or not
		escapeClearsValue: _react2.default.PropTypes.bool, // whether escape clears the value when the menu is closed
		filterOption: _react2.default.PropTypes.func, // method to filter a single option (option, filterString)
		filterOptions: _react2.default.PropTypes.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		ignoreAccents: _react2.default.PropTypes.bool, // whether to strip diacritics when filtering
		ignoreCase: _react2.default.PropTypes.bool, // whether to perform case-insensitive filtering
		inputProps: _react2.default.PropTypes.object, // custom attributes for the Input
		inputRenderer: _react2.default.PropTypes.func, // returns a custom input component
		instanceId: _react2.default.PropTypes.string, // set the components instanceId
		isLoading: _react2.default.PropTypes.bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _react2.default.PropTypes.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _react2.default.PropTypes.string, // path of the label value in option objects
		matchPos: _react2.default.PropTypes.string, // (any|start) match the start or entire string when filtering
		matchProp: _react2.default.PropTypes.string, // (any|label|value) which option property to filter on
		menuBuffer: _react2.default.PropTypes.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _react2.default.PropTypes.object, // optional style to apply to the menu container
		menuRenderer: _react2.default.PropTypes.func, // renders a custom menu with options
		menuStyle: _react2.default.PropTypes.object, // optional style to apply to the menu
		multi: _react2.default.PropTypes.bool, // multi-value input
		name: _react2.default.PropTypes.string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _react2.default.PropTypes.func, // onBlur handler: function (event) {}
		onBlurResetsInput: _react2.default.PropTypes.bool, // whether input is cleared on blur
		onChange: _react2.default.PropTypes.func, // onChange handler: function (newValue) {}
		onClose: _react2.default.PropTypes.func, // fires when the menu is closed
		onCloseResetsInput: _react2.default.PropTypes.bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _react2.default.PropTypes.func, // onFocus handler: function (event) {}
		onInputChange: _react2.default.PropTypes.func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _react2.default.PropTypes.func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _react2.default.PropTypes.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _react2.default.PropTypes.func, // fires when the menu is opened
		onValueClick: _react2.default.PropTypes.func, // onClick handler for value labels: function (value, event) {}
		openAfterFocus: _react2.default.PropTypes.bool, // boolean to enable opening dropdown when focused
		openOnFocus: _react2.default.PropTypes.bool, // always open options menu on focus
		optionClassName: _react2.default.PropTypes.string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _react2.default.PropTypes.func, // option component to render in dropdown
		optionRenderer: _react2.default.PropTypes.func, // optionRenderer: function (option) {}
		options: _react2.default.PropTypes.array, // array of options
		pageSize: _react2.default.PropTypes.number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		required: _react2.default.PropTypes.bool, // applies HTML5 required attribute when needed
		resetValue: _react2.default.PropTypes.any, // value to use when you clear the control
		scrollMenuIntoView: _react2.default.PropTypes.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _react2.default.PropTypes.bool, // whether to enable searching feature or not
		simpleValue: _react2.default.PropTypes.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _react2.default.PropTypes.object, // optional style to apply to the control
		tabIndex: _react2.default.PropTypes.string, // optional tab index of the control
		tabSelectsValue: _react2.default.PropTypes.bool, // whether to treat tabbing out while focused to be value selection
		value: _react2.default.PropTypes.any, // initial field value
		valueComponent: _react2.default.PropTypes.func, // value component to render
		valueKey: _react2.default.PropTypes.string, // path of the label value in option objects
		valueRenderer: _react2.default.PropTypes.func, // valueRenderer: function (option) {}
		wrapperStyle: _react2.default.PropTypes.object },

	statics: { Async: _Async2.default, AsyncCreatable: _AsyncCreatable2.default, Creatable: _Creatable2.default },

	getDefaultProps: function getDefaultProps() {
		return {
			addLabelText: 'Add "{label}"?',
			arrowRenderer: _defaultArrowRenderer2.default,
			autosize: true,
			backspaceRemoves: true,
			backspaceToRemoveMessage: 'Press backspace to remove {label}',
			clearable: true,
			clearAllText: 'Clear all',
			clearRenderer: _defaultClearRenderer2.default,
			clearValueText: 'Clear value',
			deleteRemoves: true,
			delimiter: ',',
			disabled: false,
			escapeClearsValue: true,
			filterOptions: _defaultFilterOptions2.default,
			ignoreAccents: true,
			ignoreCase: true,
			inputProps: {},
			isLoading: false,
			joinValues: false,
			labelKey: 'label',
			matchPos: 'any',
			matchProp: 'any',
			menuBuffer: 0,
			menuRenderer: _defaultMenuRenderer2.default,
			multi: false,
			noResultsText: 'No results found',
			onBlurResetsInput: true,
			onCloseResetsInput: true,
			openAfterFocus: false,
			optionComponent: _Option2.default,
			pageSize: 5,
			placeholder: 'Select...',
			required: false,
			scrollMenuIntoView: true,
			searchable: true,
			simpleValue: false,
			tabSelectsValue: true,
			valueComponent: _Value2.default,
			valueKey: 'value'
		};
	},
	getInitialState: function getInitialState() {
		return {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
	},
	componentWillMount: function componentWillMount() {
		this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
		var valueArray = this.getValueArray(this.props.value);

		if (this.props.required) {
			this.setState({
				required: this.handleRequired(valueArray[0], this.props.multi)
			});
		}
	},
	componentDidMount: function componentDidMount() {
		if (this.props.autofocus) {
			this.focus();
		}
	},
	componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		var valueArray = this.getValueArray(nextProps.value, nextProps);

		if (nextProps.required) {
			this.setState({
				required: this.handleRequired(valueArray[0], nextProps.multi)
			});
		}
	},
	componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
		if (nextState.isOpen !== this.state.isOpen) {
			this.toggleTouchOutsideEvent(nextState.isOpen);
			var handler = nextState.isOpen ? nextProps.onOpen : nextProps.onClose;
			handler && handler();
		}
	},
	componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
		// focus to the selected option
		if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
			var focusedOptionNode = _reactDom2.default.findDOMNode(this.focused);
			var menuNode = _reactDom2.default.findDOMNode(this.menu);
			menuNode.scrollTop = focusedOptionNode.offsetTop;
			this.hasScrolledToOption = true;
		} else if (!this.state.isOpen) {
			this.hasScrolledToOption = false;
		}

		if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
			this._scrollToFocusedOptionOnUpdate = false;
			var focusedDOM = _reactDom2.default.findDOMNode(this.focused);
			var menuDOM = _reactDom2.default.findDOMNode(this.menu);
			var focusedRect = focusedDOM.getBoundingClientRect();
			var menuRect = menuDOM.getBoundingClientRect();
			if (focusedRect.bottom > menuRect.bottom || focusedRect.top < menuRect.top) {
				menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
			}
		}
		if (this.props.scrollMenuIntoView && this.menuContainer) {
			var menuContainerRect = this.menuContainer.getBoundingClientRect();
			if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
				window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
			}
		}
		if (prevProps.disabled !== this.props.disabled) {
			this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
			this.closeMenu();
		}
	},
	componentWillUnmount: function componentWillUnmount() {
		if (!document.removeEventListener && document.detachEvent) {
			document.detachEvent('ontouchstart', this.handleTouchOutside);
		} else {
			document.removeEventListener('touchstart', this.handleTouchOutside);
		}
	},
	toggleTouchOutsideEvent: function toggleTouchOutsideEvent(enabled) {
		if (enabled) {
			if (!document.addEventListener && document.attachEvent) {
				document.attachEvent('ontouchstart', this.handleTouchOutside);
			} else {
				document.addEventListener('touchstart', this.handleTouchOutside);
			}
		} else {
			if (!document.removeEventListener && document.detachEvent) {
				document.detachEvent('ontouchstart', this.handleTouchOutside);
			} else {
				document.removeEventListener('touchstart', this.handleTouchOutside);
			}
		}
	},
	handleTouchOutside: function handleTouchOutside(event) {
		// handle touch outside on ios to dismiss menu
		if (this.wrapper && !this.wrapper.contains(event.target)) {
			this.closeMenu();
		}
	},
	focus: function focus() {
		if (!this.input) return;
		this.input.focus();

		if (this.props.openAfterFocus) {
			this.setState({
				isOpen: true
			});
		}
	},
	blurInput: function blurInput() {
		if (!this.input) return;
		this.input.blur();
	},
	handleTouchMove: function handleTouchMove(event) {
		// Set a flag that the view is being dragged
		this.dragging = true;
	},
	handleTouchStart: function handleTouchStart(event) {
		// Set a flag that the view is not being dragged
		this.dragging = false;
	},
	handleTouchEnd: function handleTouchEnd(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		// Fire the mouse events
		this.handleMouseDown(event);
	},
	handleTouchEndClearValue: function handleTouchEndClearValue(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		// Clear the value
		this.clearValue(event);
	},
	handleMouseDown: function handleMouseDown(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, or if the component is disabled, ignore it.
		if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
			return;
		}

		if (event.target.tagName === 'INPUT') {
			return;
		}

		// prevent default event handlers
		event.stopPropagation();
		event.preventDefault();

		// for the non-searchable select, toggle the menu
		if (!this.props.searchable) {
			this.focus();
			return this.setState({
				isOpen: !this.state.isOpen
			});
		}

		if (this.state.isFocused) {
			// On iOS, we can get into a state where we think the input is focused but it isn't really,
			// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
			// Call focus() again here to be safe.
			this.focus();

			var input = this.input;
			if (typeof input.getInput === 'function') {
				// Get the actual DOM input if the ref is an <AutosizeInput /> component
				input = input.getInput();
			}

			// clears the value so that the cursor will be at the end of input when the component re-renders
			input.value = '';

			// if the input is focused, ensure the menu is open
			this.setState({
				isOpen: true,
				isPseudoFocused: false
			});
		} else {
			// otherwise, focus the input and open the menu
			this._openAfterFocus = this.props.openOnFocus;
			this.focus();
		}
	},
	handleMouseDownOnArrow: function handleMouseDownOnArrow(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, or if the component is disabled, ignore it.
		if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		// If the menu isn't open, let the event bubble to the main handleMouseDown
		if (!this.state.isOpen) {
			return;
		}
		// prevent default event handlers
		event.stopPropagation();
		event.preventDefault();
		// close the menu
		this.closeMenu();
	},
	handleMouseDownOnMenu: function handleMouseDownOnMenu(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, or if the component is disabled, ignore it.
		if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		event.stopPropagation();
		event.preventDefault();

		this._openAfterFocus = true;
		this.focus();
	},
	closeMenu: function closeMenu() {
		if (this.props.onCloseResetsInput) {
			this.setState({
				isOpen: false,
				isPseudoFocused: this.state.isFocused && !this.props.multi,
				inputValue: this.handleInputValueChange('')
			});
		} else {
			this.setState({
				isOpen: false,
				isPseudoFocused: this.state.isFocused && !this.props.multi
			});
		}
		this.hasScrolledToOption = false;
	},
	handleInputFocus: function handleInputFocus(event) {
		if (this.props.disabled) return;
		var isOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
		if (this.props.onFocus) {
			this.props.onFocus(event);
		}
		this.setState({
			isFocused: true,
			isOpen: isOpen
		});
		this._openAfterFocus = false;
	},
	handleInputBlur: function handleInputBlur(event) {
		// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
		if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
			this.focus();
			return;
		}

		if (this.props.onBlur) {
			this.props.onBlur(event);
		}
		var onBlurredState = {
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false
		};
		if (this.props.onBlurResetsInput) {
			onBlurredState.inputValue = this.handleInputValueChange('');
		}
		this.setState(onBlurredState);
	},
	handleInputChange: function handleInputChange(event) {
		var newInputValue = event.target.value;

		if (this.state.inputValue !== event.target.value) {
			newInputValue = this.handleInputValueChange(newInputValue);
		}

		this.setState({
			isOpen: true,
			isPseudoFocused: false,
			inputValue: newInputValue
		});
	},
	handleInputValueChange: function handleInputValueChange(newValue) {
		if (this.props.onInputChange) {
			var nextState = this.props.onInputChange(newValue);
			// Note: != used deliberately here to catch undefined and null
			if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
				newValue = '' + nextState;
			}
		}
		return newValue;
	},
	handleKeyDown: function handleKeyDown(event) {
		if (this.props.disabled) return;

		if (typeof this.props.onInputKeyDown === 'function') {
			this.props.onInputKeyDown(event);
			if (event.defaultPrevented) {
				return;
			}
		}

		switch (event.keyCode) {
			case 8:
				// backspace
				if (!this.state.inputValue && this.props.backspaceRemoves) {
					event.preventDefault();
					this.popValue();
				}
				return;
			case 9:
				// tab
				if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
					return;
				}
				this.selectFocusedOption();
				return;
			case 13:
				// enter
				if (!this.state.isOpen) return;
				event.stopPropagation();
				this.selectFocusedOption();
				break;
			case 27:
				// escape
				if (this.state.isOpen) {
					this.closeMenu();
					event.stopPropagation();
				} else if (this.props.clearable && this.props.escapeClearsValue) {
					this.clearValue(event);
					event.stopPropagation();
				}
				break;
			case 38:
				// up
				this.focusPreviousOption();
				break;
			case 40:
				// down
				this.focusNextOption();
				break;
			case 33:
				// page up
				this.focusPageUpOption();
				break;
			case 34:
				// page down
				this.focusPageDownOption();
				break;
			case 35:
				// end key
				if (event.shiftKey) {
					return;
				}
				this.focusEndOption();
				break;
			case 36:
				// home key
				if (event.shiftKey) {
					return;
				}
				this.focusStartOption();
				break;
			case 46:
				// backspace
				if (!this.state.inputValue && this.props.deleteRemoves) {
					event.preventDefault();
					this.popValue();
				}
				return;
			default:
				return;
		}
		event.preventDefault();
	},
	handleValueClick: function handleValueClick(option, event) {
		if (!this.props.onValueClick) return;
		this.props.onValueClick(option, event);
	},
	handleMenuScroll: function handleMenuScroll(event) {
		if (!this.props.onMenuScrollToBottom) return;
		var target = event.target;

		if (target.scrollHeight > target.offsetHeight && !(target.scrollHeight - target.offsetHeight - target.scrollTop)) {
			this.props.onMenuScrollToBottom();
		}
	},
	handleRequired: function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	},
	getOptionLabel: function getOptionLabel(op) {
		return op[this.props.labelKey];
	},


	/**
  * Turns a value into an array from the given options
  * @param	{String|Number|Array}	value		- the value of the select input
  * @param	{Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
  * @returns	{Array}	the value of the select represented in an array
  */
	getValueArray: function getValueArray(value, nextProps) {
		var _this = this;

		/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
		var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
		if (props.multi) {
			if (typeof value === 'string') value = value.split(props.delimiter);
			if (!Array.isArray(value)) {
				if (value === null || value === undefined) return [];
				value = [value];
			}
			return value.map(function (value) {
				return _this.expandValue(value, props);
			}).filter(function (i) {
				return i;
			});
		}
		var expandedValue = this.expandValue(value, props);
		return expandedValue ? [expandedValue] : [];
	},


	/**
  * Retrieve a value from the given options and valueKey
  * @param	{String|Number|Array}	value	- the selected value(s)
  * @param	{Object}		props	- the Select component's props (or nextProps)
  */
	expandValue: function expandValue(value, props) {
		var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
		if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
		var options = props.options,
		    valueKey = props.valueKey;

		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (options[i][valueKey] === value) return options[i];
		}
	},
	setValue: function setValue(value) {
		var _this2 = this;

		if (this.props.autoBlur) {
			this.blurInput();
		}
		if (!this.props.onChange) return;
		if (this.props.required) {
			var required = this.handleRequired(value, this.props.multi);
			this.setState({ required: required });
		}
		if (this.props.simpleValue && value) {
			value = this.props.multi ? value.map(function (i) {
				return i[_this2.props.valueKey];
			}).join(this.props.delimiter) : value[this.props.valueKey];
		}
		this.props.onChange(value);
	},
	selectValue: function selectValue(value) {
		var _this3 = this;

		//NOTE: update value in the callback to make sure the input value is empty so that there are no styling issues (Chrome had issue otherwise)
		this.hasScrolledToOption = false;
		if (this.props.multi) {
			this.setState({
				inputValue: this.handleInputValueChange(''),
				focusedIndex: null
			}, function () {
				_this3.addValue(value);
			});
		} else {
			this.setState({
				isOpen: false,
				inputValue: this.handleInputValueChange(''),
				isPseudoFocused: this.state.isFocused
			}, function () {
				_this3.setValue(value);
			});
		}
	},
	addValue: function addValue(value) {
		var valueArray = this.getValueArray(this.props.value);
		var visibleOptions = this._visibleOptions.filter(function (val) {
			return !val.disabled;
		});
		var lastValueIndex = visibleOptions.indexOf(value);
		this.setValue(valueArray.concat(value));
		if (visibleOptions.length - 1 === lastValueIndex) {
			// the last option was selected; focus the second-last one
			this.focusOption(visibleOptions[lastValueIndex - 1]);
		} else if (visibleOptions.length > lastValueIndex) {
			// focus the option below the selected one
			this.focusOption(visibleOptions[lastValueIndex + 1]);
		}
	},
	popValue: function popValue() {
		var valueArray = this.getValueArray(this.props.value);
		if (!valueArray.length) return;
		if (valueArray[valueArray.length - 1].clearableValue === false) return;
		this.setValue(valueArray.slice(0, valueArray.length - 1));
	},
	removeValue: function removeValue(value) {
		var valueArray = this.getValueArray(this.props.value);
		this.setValue(valueArray.filter(function (i) {
			return i !== value;
		}));
		this.focus();
	},
	clearValue: function clearValue(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, ignore it.
		if (event && event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		event.stopPropagation();
		event.preventDefault();
		this.setValue(this.getResetValue());
		this.setState({
			isOpen: false,
			inputValue: this.handleInputValueChange('')
		}, this.focus);
	},
	getResetValue: function getResetValue() {
		if (this.props.resetValue !== undefined) {
			return this.props.resetValue;
		} else if (this.props.multi) {
			return [];
		} else {
			return null;
		}
	},
	focusOption: function focusOption(option) {
		this.setState({
			focusedOption: option
		});
	},
	focusNextOption: function focusNextOption() {
		this.focusAdjacentOption('next');
	},
	focusPreviousOption: function focusPreviousOption() {
		this.focusAdjacentOption('previous');
	},
	focusPageUpOption: function focusPageUpOption() {
		this.focusAdjacentOption('page_up');
	},
	focusPageDownOption: function focusPageDownOption() {
		this.focusAdjacentOption('page_down');
	},
	focusStartOption: function focusStartOption() {
		this.focusAdjacentOption('start');
	},
	focusEndOption: function focusEndOption() {
		this.focusAdjacentOption('end');
	},
	focusAdjacentOption: function focusAdjacentOption(dir) {
		var options = this._visibleOptions.map(function (option, index) {
			return { option: option, index: index };
		}).filter(function (option) {
			return !option.option.disabled;
		});
		this._scrollToFocusedOptionOnUpdate = true;
		if (!this.state.isOpen) {
			this.setState({
				isOpen: true,
				inputValue: '',
				focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null)
			});
			return;
		}
		if (!options.length) return;
		var focusedIndex = -1;
		for (var i = 0; i < options.length; i++) {
			if (this._focusedOption === options[i].option) {
				focusedIndex = i;
				break;
			}
		}
		if (dir === 'next' && focusedIndex !== -1) {
			focusedIndex = (focusedIndex + 1) % options.length;
		} else if (dir === 'previous') {
			if (focusedIndex > 0) {
				focusedIndex = focusedIndex - 1;
			} else {
				focusedIndex = options.length - 1;
			}
		} else if (dir === 'start') {
			focusedIndex = 0;
		} else if (dir === 'end') {
			focusedIndex = options.length - 1;
		} else if (dir === 'page_up') {
			var potentialIndex = focusedIndex - this.props.pageSize;
			if (potentialIndex < 0) {
				focusedIndex = 0;
			} else {
				focusedIndex = potentialIndex;
			}
		} else if (dir === 'page_down') {
			var potentialIndex = focusedIndex + this.props.pageSize;
			if (potentialIndex > options.length - 1) {
				focusedIndex = options.length - 1;
			} else {
				focusedIndex = potentialIndex;
			}
		}

		if (focusedIndex === -1) {
			focusedIndex = 0;
		}

		this.setState({
			focusedIndex: options[focusedIndex].index,
			focusedOption: options[focusedIndex].option
		});
	},
	getFocusedOption: function getFocusedOption() {
		return this._focusedOption;
	},
	getInputValue: function getInputValue() {
		return this.state.inputValue;
	},
	selectFocusedOption: function selectFocusedOption() {
		if (this._focusedOption) {
			return this.selectValue(this._focusedOption);
		}
	},
	renderLoading: function renderLoading() {
		if (!this.props.isLoading) return;
		return _ref;
	},
	renderValue: function renderValue(valueArray, isOpen) {
		var _this4 = this;

		var renderLabel = this.props.valueRenderer || this.getOptionLabel;
		var ValueComponent = this.props.valueComponent;
		if (!valueArray.length) {
			return !this.state.inputValue ? _react2.default.createElement(
				'div',
				{ className: 'Select-placeholder' },
				this.props.placeholder
			) : null;
		}
		var onClick = this.props.onValueClick ? this.handleValueClick : null;
		if (this.props.multi) {
			return valueArray.map(function (value, i) {
				return _react2.default.createElement(
					ValueComponent,
					{
						id: _this4._instancePrefix + '-value-' + i,
						instancePrefix: _this4._instancePrefix,
						disabled: _this4.props.disabled || value.clearableValue === false,
						key: 'value-' + i + '-' + value[_this4.props.valueKey],
						onClick: onClick,
						onRemove: _this4.removeValue,
						value: value
					},
					renderLabel(value, i),
					_ref2
				);
			});
		} else if (!this.state.inputValue) {
			if (isOpen) onClick = null;
			return _react2.default.createElement(
				ValueComponent,
				{
					id: this._instancePrefix + '-value-item',
					disabled: this.props.disabled,
					instancePrefix: this._instancePrefix,
					onClick: onClick,
					value: valueArray[0]
				},
				renderLabel(valueArray[0])
			);
		}
	},
	renderInput: function renderInput(valueArray, focusedOptionIndex) {
		var _classNames,
		    _this5 = this;

		var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
		var isOpen = !!this.state.isOpen;

		var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

		// TODO: Check how this project includes Object.assign()
		var inputProps = Object.assign({}, this.props.inputProps, {
			role: 'combobox',
			'aria-expanded': '' + isOpen,
			'aria-owns': ariaOwns,
			'aria-haspopup': '' + isOpen,
			'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
			'aria-describedby': this.props['aria-describedby'],
			'aria-labelledby': this.props['aria-labelledby'],
			'aria-label': this.props['aria-label'],
			className: className,
			tabIndex: this.props.tabIndex,
			onBlur: this.handleInputBlur,
			onChange: this.handleInputChange,
			onFocus: this.handleInputFocus,
			ref: function ref(_ref3) {
				return _this5.input = _ref3;
			},
			required: this.state.required,
			value: this.state.inputValue
		});

		if (this.props.inputRenderer) {
			return this.props.inputRenderer(inputProps);
		}

		if (this.props.disabled || !this.props.searchable) {
			var _props$inputProps = this.props.inputProps,
			    inputClassName = _props$inputProps.inputClassName,
			    divProps = _objectWithoutProperties(_props$inputProps, ['inputClassName']);

			return _react2.default.createElement('div', _extends({}, divProps, {
				role: 'combobox',
				'aria-expanded': isOpen,
				'aria-owns': isOpen ? this._instancePrefix + '-list' : this._instancePrefix + '-value',
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				className: className,
				tabIndex: this.props.tabIndex || 0,
				onBlur: this.handleInputBlur,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref4) {
					return _this5.input = _ref4;
				},
				'aria-readonly': '' + !!this.props.disabled,
				style: { border: 0, width: 1, display: 'inline-block' } }));
		}

		if (this.props.autosize) {
			return _react2.default.createElement(_reactInputAutosize2.default, _extends({}, inputProps, { minWidth: '5' }));
		}
		return _react2.default.createElement(
			'div',
			{ className: className },
			_react2.default.createElement('input', inputProps)
		);
	},
	renderClear: function renderClear() {
		if (!this.props.clearable || !this.props.value || this.props.value === 0 || this.props.multi && !this.props.value.length || this.props.disabled || this.props.isLoading) return;
		var clear = this.props.clearRenderer();

		return _react2.default.createElement(
			'span',
			{ className: 'Select-clear-zone', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText,
				'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText,
				onMouseDown: this.clearValue,
				onTouchStart: this.handleTouchStart,
				onTouchMove: this.handleTouchMove,
				onTouchEnd: this.handleTouchEndClearValue
			},
			clear
		);
	},
	renderArrow: function renderArrow() {
		var onMouseDown = this.handleMouseDownOnArrow;
		var isOpen = this.state.isOpen;
		var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

		return _react2.default.createElement(
			'span',
			{
				className: 'Select-arrow-zone',
				onMouseDown: onMouseDown
			},
			arrow
		);
	},
	filterOptions: function filterOptions(excludeOptions) {
		var filterValue = this.state.inputValue;
		var options = this.props.options || [];
		if (this.props.filterOptions) {
			// Maintain backwards compatibility with boolean attribute
			var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;

			return filterOptions(options, filterValue, excludeOptions, {
				filterOption: this.props.filterOption,
				ignoreAccents: this.props.ignoreAccents,
				ignoreCase: this.props.ignoreCase,
				labelKey: this.props.labelKey,
				matchPos: this.props.matchPos,
				matchProp: this.props.matchProp,
				valueKey: this.props.valueKey
			});
		} else {
			return options;
		}
	},
	onOptionRef: function onOptionRef(ref, isFocused) {
		if (isFocused) {
			this.focused = ref;
		}
	},
	renderMenu: function renderMenu(options, valueArray, focusedOption) {
		if (options && options.length) {
			return this.props.menuRenderer({
				focusedOption: focusedOption,
				focusOption: this.focusOption,
				instancePrefix: this._instancePrefix,
				labelKey: this.props.labelKey,
				onFocus: this.focusOption,
				onSelect: this.selectValue,
				optionClassName: this.props.optionClassName,
				optionComponent: this.props.optionComponent,
				optionRenderer: this.props.optionRenderer || this.getOptionLabel,
				options: options,
				selectValue: this.selectValue,
				valueArray: valueArray,
				valueKey: this.props.valueKey,
				onOptionRef: this.onOptionRef
			});
		} else if (this.props.noResultsText) {
			return _react2.default.createElement(
				'div',
				{ className: 'Select-noresults' },
				this.props.noResultsText
			);
		} else {
			return null;
		}
	},
	renderHiddenField: function renderHiddenField(valueArray) {
		var _this6 = this;

		if (!this.props.name) return;
		if (this.props.joinValues) {
			var value = valueArray.map(function (i) {
				return stringifyValue(i[_this6.props.valueKey]);
			}).join(this.props.delimiter);
			return _react2.default.createElement('input', {
				type: 'hidden',
				ref: function ref(_ref5) {
					return _this6.value = _ref5;
				},
				name: this.props.name,
				value: value,
				disabled: this.props.disabled });
		}
		return valueArray.map(function (item, index) {
			return _react2.default.createElement('input', { key: 'hidden.' + index,
				type: 'hidden',
				ref: 'value' + index,
				name: _this6.props.name,
				value: stringifyValue(item[_this6.props.valueKey]),
				disabled: _this6.props.disabled });
		});
	},
	getFocusableOptionIndex: function getFocusableOptionIndex(selectedOption) {
		var options = this._visibleOptions;
		if (!options.length) return null;

		var focusedOption = this.state.focusedOption || selectedOption;
		if (focusedOption && !focusedOption.disabled) {
			var focusedOptionIndex = -1;
			options.some(function (option, index) {
				var isOptionEqual = option.value === focusedOption.value;
				if (isOptionEqual) {
					focusedOptionIndex = index;
				}
				return isOptionEqual;
			});
			if (focusedOptionIndex !== -1) {
				return focusedOptionIndex;
			}
		}

		for (var i = 0; i < options.length; i++) {
			if (!options[i].disabled) return i;
		}
		return null;
	},
	renderOuter: function renderOuter(options, valueArray, focusedOption) {
		var _this7 = this;

		var menu = this.renderMenu(options, valueArray, focusedOption);
		if (!menu) {
			return null;
		}

		return _react2.default.createElement(
			'div',
			{ ref: function ref(_ref7) {
					return _this7.menuContainer = _ref7;
				}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
			_react2.default.createElement(
				'div',
				{ ref: function ref(_ref6) {
						return _this7.menu = _ref6;
					}, role: 'listbox', className: 'Select-menu', id: this._instancePrefix + '-list',
					style: this.props.menuStyle,
					onScroll: this.handleMenuScroll,
					onMouseDown: this.handleMouseDownOnMenu },
				menu
			)
		);
	},
	render: function render() {
		var _this8 = this;

		var valueArray = this.getValueArray(this.props.value);
		var options = this._visibleOptions = this.filterOptions(this.props.multi ? this.getValueArray(this.props.value) : null);
		var isOpen = this.state.isOpen;
		if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
		var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

		var focusedOption = null;
		if (focusedOptionIndex !== null) {
			focusedOption = this._focusedOption = options[focusedOptionIndex];
		} else {
			focusedOption = this._focusedOption = null;
		}
		var className = (0, _classnames2.default)('Select', this.props.className, {
			'Select--multi': this.props.multi,
			'Select--single': !this.props.multi,
			'is-disabled': this.props.disabled,
			'is-focused': this.state.isFocused,
			'is-loading': this.props.isLoading,
			'is-open': isOpen,
			'is-pseudo-focused': this.state.isPseudoFocused,
			'is-searchable': this.props.searchable,
			'has-value': valueArray.length
		});

		var removeMessage = null;
		if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
			removeMessage = _react2.default.createElement(
				'span',
				{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
				this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
			);
		}

		return _react2.default.createElement(
			'div',
			{ ref: function ref(_ref9) {
					return _this8.wrapper = _ref9;
				},
				className: className,
				style: this.props.wrapperStyle },
			this.renderHiddenField(valueArray),
			_react2.default.createElement(
				'div',
				{ ref: function ref(_ref8) {
						return _this8.control = _ref8;
					},
					className: 'Select-control',
					style: this.props.style,
					onKeyDown: this.handleKeyDown,
					onMouseDown: this.handleMouseDown,
					onTouchEnd: this.handleTouchEnd,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove
				},
				_react2.default.createElement(
					'span',
					{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
					this.renderValue(valueArray, isOpen),
					this.renderInput(valueArray, focusedOptionIndex)
				),
				removeMessage,
				this.renderLoading(),
				this.renderClear(),
				this.renderArrow()
			),
			isOpen ? this.renderOuter(options, !this.props.multi ? valueArray : null, focusedOption) : null
		);
	}
});

exports.default = Select;
module.exports = exports['default'];

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createEagerElementUtil = __webpack_require__(1001);

var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);

var _isReferentiallyTransparentFunctionComponent = __webpack_require__(997);

var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createFactory = function createFactory(type) {
  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
  return function (p, c) {
    return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
  };
};

exports.default = createFactory;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(477), __esModule: true };

/***/ }),
/* 159 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 160 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var ctx         = __webpack_require__(76)
  , call        = __webpack_require__(260)
  , isArrayIter = __webpack_require__(258)
  , anObject    = __webpack_require__(61)
  , toLength    = __webpack_require__(129)
  , getIterFn   = __webpack_require__(269)
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(159);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(164)
  , $export        = __webpack_require__(30)
  , redefine       = __webpack_require__(268)
  , hide           = __webpack_require__(54)
  , has            = __webpack_require__(63)
  , Iterators      = __webpack_require__(96)
  , $iterCreate    = __webpack_require__(496)
  , setToStringTag = __webpack_require__(128)
  , getPrototypeOf = __webpack_require__(264)
  , ITERATOR       = __webpack_require__(28)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports = true;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__(130)('meta')
  , isObject = __webpack_require__(64)
  , has      = __webpack_require__(63)
  , setDesc  = __webpack_require__(31).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(62)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 166 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(168)('keys')
  , uid    = __webpack_require__(130);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(43)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 169 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(64);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var global         = __webpack_require__(43)
  , core           = __webpack_require__(20)
  , LIBRARY        = __webpack_require__(164)
  , wksExt         = __webpack_require__(172)
  , defineProperty = __webpack_require__(31).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(28);

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(504)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(163)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(176)
  , $export        = __webpack_require__(47)
  , redefine       = __webpack_require__(180)
  , hide           = __webpack_require__(100)
  , has            = __webpack_require__(134)
  , Iterators      = __webpack_require__(81)
  , $iterCreate    = __webpack_require__(543)
  , setToStringTag = __webpack_require__(101)
  , getProto       = __webpack_require__(18).getProto
  , ITERATOR       = __webpack_require__(26)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , methods, key;
  // Fix native
  if($native){
    var IteratorPrototype = getProto($default.call(new Base));
    // Set @@toStringTag to native iterators
    setToStringTag(IteratorPrototype, TAG, true);
    // FF fix
    if(!LIBRARY && has(proto, FF_ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    // fix Array#{values, @@iterator}.name in V8 / FF
    if(DEF_VALUES && $native.name !== VALUES){
      VALUES_BUG = true;
      $default = function values(){ return $native.call(this); };
    }
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES  ? $default : getMethod(VALUES),
      keys:    IS_SET      ? $default : getMethod(KEYS),
      entries: !DEF_VALUES ? $default : getMethod('entries')
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports = true;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(47)
  , core    = __webpack_require__(22)
  , fails   = __webpack_require__(99);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(180);
module.exports = function(target, src){
  for(var key in src)redefine(target, key, src[key]);
  return target;
};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(100);

/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports = function(it, Constructor, name){
  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
  return it;
};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(132);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 183 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(131)
  , ITERATOR  = __webpack_require__(26)('iterator')
  , Iterators = __webpack_require__(81);
module.exports = __webpack_require__(22).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 185 */
/***/ (function(module, exports) {



/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInBrowser = __webpack_require__(144);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var js = ''; /**
              * Export javascript style and css style vendor prefixes.
              * Based on "transform" support test.
              */

var css = '';

// We should not do anything if required serverside.
if (_isInBrowser2['default']) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  }
}

/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String}}
 * @api public
 */
exports['default'] = { js: js, css: css };

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(104);


/* harmony default export */ __webpack_exports__["a"] = (function(values, p, valueof) {
  if (valueof == null) valueof = __WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */];
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefix; });
var prefix = "$";

function Map() {}

Map.prototype = map.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

/* harmony default export */ __webpack_exports__["a"] = (map);


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return brighter; });
/* harmony export (immutable) */ __webpack_exports__["h"] = color;
/* harmony export (immutable) */ __webpack_exports__["b"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["a"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["f"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(190);


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex3 = /^#([0-9a-f]{3})$/,
    reHex6 = /^#([0-9a-f]{6})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Color, color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Rgb, rgb, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hsl, hsl, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
});


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__(304);









/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__constant__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]
      : t === "string" ? ((c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* color */] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */])(a, b);
});


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__namespaces__ = __webpack_require__(197);



function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === __WEBPACK_IMPORTED_MODULE_1__namespaces__["a" /* xhtml */] && document.documentElement.namespaceURI === __WEBPACK_IMPORTED_MODULE_1__namespaces__["a" /* xhtml */]
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var fullname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" /* default */])(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
});


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespaces__ = __webpack_require__(197);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return __WEBPACK_IMPORTED_MODULE_0__namespaces__["b" /* default */].hasOwnProperty(prefix) ? {space: __WEBPACK_IMPORTED_MODULE_0__namespaces__["b" /* default */][prefix], local: name} : name;
});


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return xhtml; });
var xhtml = "http://www.w3.org/1999/xhtml";

/* harmony default export */ __webpack_exports__["b"] = ({
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
});


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node, event) {
  var svg = node.ownerSVGElement || node;

  if (svg.createSVGPoint) {
    var point = svg.createSVGPoint();
    point.x = event.clientX, point.y = event.clientY;
    point = point.matrixTransform(node.getScreenCTM().inverse());
    return [point.x, point.y];
  }

  var rect = node.getBoundingClientRect();
  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
});


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return event; });
/* unused harmony export customEvent */
var filterEvents = {};

var event = null;

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!("onmouseenter" in element)) {
    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
  }
}

function filterContextListener(listener, index, group) {
  listener = contextListener(listener, index, group);
  return function(event) {
    var related = event.relatedTarget;
    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
      listener.call(this, event);
    }
  };
}

function contextListener(listener, index, group) {
  return function(event1) {
    var event0 = event; // Events can be reentrant (e.g., focus).
    event = event1;
    try {
      listener.call(this, this.__data__, index, group);
    } finally {
      event = event0;
    }
  };
}

function parseTypenames(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, capture) {
  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
  return function(d, i, group) {
    var on = this.__on, o, listener = wrap(value, i, group);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, capture);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

/* harmony default export */ __webpack_exports__["b"] = (function(typename, value, capture) {
  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  if (capture == null) capture = false;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
  return this;
});

function customEvent(event1, listener, that, args) {
  var event0 = event;
  event1.sourceEvent = event;
  event = event1;
  try {
    return listener.apply(that, args);
  } finally {
    event = event0;
  }
}


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function none() {}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
});


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_on__ = __webpack_require__(199);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var current = __WEBPACK_IMPORTED_MODULE_0__selection_on__["a" /* event */], source;
  while (source = current.sourceEvent) current = source;
  return current;
});


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
});


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(139);



function point(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > __WEBPACK_IMPORTED_MODULE_0__math__["a" /* epsilon */]) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > __WEBPACK_IMPORTED_MODULE_0__math__["a" /* epsilon */]) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new __WEBPACK_IMPORTED_MODULE_1__cardinal__["a" /* Cardinal */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(206);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      defined = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
});


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sum;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(112);


/* harmony default export */ __webpack_exports__["b"] = (function(series) {
  var sums = series.map(sum);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[a] - sums[b]; });
});

function sum(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(p) {
  return p[0];
}

function y(p) {
  return p[1];
}


/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return timeFormat; });
/* unused harmony export timeParse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcParse; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(335);


var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_interval__ = __webpack_require__(21);
/* unused harmony reexport timeInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_millisecond__ = __webpack_require__(696);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
/* unused harmony reexport timeMilliseconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
/* unused harmony reexport utcMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_second__ = __webpack_require__(699);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
/* unused harmony reexport timeSeconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
/* unused harmony reexport utcSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_minute__ = __webpack_require__(697);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_3__src_minute__["a"]; });
/* unused harmony reexport timeMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_hour__ = __webpack_require__(695);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_4__src_hour__["a"]; });
/* unused harmony reexport timeHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_day__ = __webpack_require__(694);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__src_day__["a"]; });
/* unused harmony reexport timeDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_week__ = __webpack_require__(706);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["a"]; });
/* unused harmony reexport timeWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["a"]; });
/* unused harmony reexport timeSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["b"]; });
/* unused harmony reexport timeMondays */
/* unused harmony reexport timeTuesday */
/* unused harmony reexport timeTuesdays */
/* unused harmony reexport timeWednesday */
/* unused harmony reexport timeWednesdays */
/* unused harmony reexport timeThursday */
/* unused harmony reexport timeThursdays */
/* unused harmony reexport timeFriday */
/* unused harmony reexport timeFridays */
/* unused harmony reexport timeSaturday */
/* unused harmony reexport timeSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_month__ = __webpack_require__(698);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_7__src_month__["a"]; });
/* unused harmony reexport timeMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_year__ = __webpack_require__(707);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_8__src_year__["a"]; });
/* unused harmony reexport timeYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__ = __webpack_require__(702);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__["a"]; });
/* unused harmony reexport utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcHour__ = __webpack_require__(701);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcHour__["a"]; });
/* unused harmony reexport utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_utcDay__ = __webpack_require__(700);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_11__src_utcDay__["a"]; });
/* unused harmony reexport utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__ = __webpack_require__(704);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["a"]; });
/* unused harmony reexport utcWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["a"]; });
/* unused harmony reexport utcSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["b"]; });
/* unused harmony reexport utcMondays */
/* unused harmony reexport utcTuesday */
/* unused harmony reexport utcTuesdays */
/* unused harmony reexport utcWednesday */
/* unused harmony reexport utcWednesdays */
/* unused harmony reexport utcThursday */
/* unused harmony reexport utcThursdays */
/* unused harmony reexport utcFriday */
/* unused harmony reexport utcFridays */
/* unused harmony reexport utcSaturday */
/* unused harmony reexport utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__ = __webpack_require__(703);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__["a"]; });
/* unused harmony reexport utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_utcYear__ = __webpack_require__(705);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_14__src_utcYear__["a"]; });
/* unused harmony reexport utcYears */































/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

// https://d3js.org Version 4.10.0. Copyright 2017 Mike Bostock.
(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
}(this, (function (exports) { 'use strict';

var version = "4.10.0";

var ascending = function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
};

var bisector = function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
};

function ascendingComparator(f) {
  return function(d, x) {
    return ascending(f(d), x);
  };
}

var ascendingBisect = bisector(ascending);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;

var pairs = function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
};

function pair(a, b) {
  return [a, b];
}

var cross = function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = pair;

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
};

var descending = function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
};

var number = function(x) {
  return x === null ? NaN : +x;
};

var variance = function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = number(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = number(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
};

var deviation = function(array, f) {
  var v = variance(array, f);
  return v ? Math.sqrt(v) : v;
};

var extent = function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
};

var array = Array.prototype;

var slice = array.slice;
var map = array.map;

var constant = function(x) {
  return function() {
    return x;
  };
};

var identity = function(x) {
  return x;
};

var sequence = function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
};

var e10 = Math.sqrt(50);
var e5 = Math.sqrt(10);
var e2 = Math.sqrt(2);

var ticks = function(start, stop, count) {
  var reverse = stop < start,
      i = -1,
      n,
      ticks,
      step;

  if (reverse) n = start, start = stop, stop = n;

  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
};

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}

var sturges = function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
};

var histogram = function() {
  var value = identity,
      domain = extent,
      threshold = sturges;

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = tickStep(x0, x1, tz);
      tz = sequence(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[bisectRight(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
  };

  return histogram;
};

var threshold = function(values, p, valueof) {
  if (valueof == null) valueof = number;
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
};

var freedmanDiaconis = function(values, min, max) {
  values = map.call(values, number).sort(ascending);
  return Math.ceil((max - min) / (2 * (threshold(values, 0.75) - threshold(values, 0.25)) * Math.pow(values.length, -1 / 3)));
};

var scott = function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
};

var max = function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
};

var mean = function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = number(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
};

var median = function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = number(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = number(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return threshold(numbers.sort(ascending), 0.5);
};

var merge = function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
};

var min = function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
};

var permute = function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
};

var scan = function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = ascending;

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
};

var shuffle = function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
};

var sum = function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
};

var transpose = function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
};

function length(d) {
  return d.length;
}

var zip = function() {
  return transpose(arguments);
};

var slice$1 = Array.prototype.slice;

var identity$1 = function(x) {
  return x;
};

var top = 1;
var right = 2;
var bottom = 3;
var left = 4;
var epsilon = 1e-6;

function translateX(x) {
  return "translate(" + (x + 0.5) + ",0)";
}

function translateY(y) {
  return "translate(0," + (y + 0.5) + ")";
}

function number$1(scale) {
  return function(d) {
    return +scale(d);
  };
}

function center(scale) {
  var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
  if (scale.round()) offset = Math.round(offset);
  return function(d) {
    return +scale(d) + offset;
  };
}

function entering() {
  return !this.__axis;
}

function axis(orient, scale) {
  var tickArguments = [],
      tickValues = null,
      tickFormat = null,
      tickSizeInner = 6,
      tickSizeOuter = 6,
      tickPadding = 3,
      k = orient === top || orient === left ? -1 : 1,
      x = orient === left || orient === right ? "x" : "y",
      transform = orient === top || orient === bottom ? translateX : translateY;

  function axis(context) {
    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity$1) : tickFormat,
        spacing = Math.max(tickSizeInner, 0) + tickPadding,
        range = scale.range(),
        range0 = +range[0] + 0.5,
        range1 = +range[range.length - 1] + 0.5,
        position = (scale.bandwidth ? center : number$1)(scale.copy()),
        selection = context.selection ? context.selection() : context,
        path = selection.selectAll(".domain").data([null]),
        tick = selection.selectAll(".tick").data(values, scale).order(),
        tickExit = tick.exit(),
        tickEnter = tick.enter().append("g").attr("class", "tick"),
        line = tick.select("line"),
        text = tick.select("text");

    path = path.merge(path.enter().insert("path", ".tick")
        .attr("class", "domain")
        .attr("stroke", "#000"));

    tick = tick.merge(tickEnter);

    line = line.merge(tickEnter.append("line")
        .attr("stroke", "#000")
        .attr(x + "2", k * tickSizeInner));

    text = text.merge(tickEnter.append("text")
        .attr("fill", "#000")
        .attr(x, k * spacing)
        .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));

    if (context !== selection) {
      path = path.transition(context);
      tick = tick.transition(context);
      line = line.transition(context);
      text = text.transition(context);

      tickExit = tickExit.transition(context)
          .attr("opacity", epsilon)
          .attr("transform", function(d) { return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform"); });

      tickEnter
          .attr("opacity", epsilon)
          .attr("transform", function(d) { var p = this.parentNode.__axis; return transform(p && isFinite(p = p(d)) ? p : position(d)); });
    }

    tickExit.remove();

    path
        .attr("d", orient === left || orient == right
            ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter
            : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter);

    tick
        .attr("opacity", 1)
        .attr("transform", function(d) { return transform(position(d)); });

    line
        .attr(x + "2", k * tickSizeInner);

    text
        .attr(x, k * spacing)
        .text(format);

    selection.filter(entering)
        .attr("fill", "none")
        .attr("font-size", 10)
        .attr("font-family", "sans-serif")
        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");

    selection
        .each(function() { this.__axis = position; });
  }

  axis.scale = function(_) {
    return arguments.length ? (scale = _, axis) : scale;
  };

  axis.ticks = function() {
    return tickArguments = slice$1.call(arguments), axis;
  };

  axis.tickArguments = function(_) {
    return arguments.length ? (tickArguments = _ == null ? [] : slice$1.call(_), axis) : tickArguments.slice();
  };

  axis.tickValues = function(_) {
    return arguments.length ? (tickValues = _ == null ? null : slice$1.call(_), axis) : tickValues && tickValues.slice();
  };

  axis.tickFormat = function(_) {
    return arguments.length ? (tickFormat = _, axis) : tickFormat;
  };

  axis.tickSize = function(_) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
  };

  axis.tickSizeInner = function(_) {
    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
  };

  axis.tickSizeOuter = function(_) {
    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
  };

  axis.tickPadding = function(_) {
    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
  };

  return axis;
}

function axisTop(scale) {
  return axis(top, scale);
}

function axisRight(scale) {
  return axis(right, scale);
}

function axisBottom(scale) {
  return axis(bottom, scale);
}

function axisLeft(scale) {
  return axis(left, scale);
}

var noop = {value: function() {}};

function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}

function Dispatch(_) {
  this._ = _;
}

function parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {type: t, name: name};
  });
}

Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._,
        T = parseTypenames(typename + "", _),
        t,
        i = -1,
        n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
      return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
    }

    return this;
  },
  copy: function() {
    var copy = {}, _ = this._;
    for (var t in _) copy[t] = _[t].slice();
    return new Dispatch(copy);
  },
  call: function(type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};

function get(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}

function set(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({name: name, value: callback});
  return type;
}

var xhtml = "http://www.w3.org/1999/xhtml";

var namespaces = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};

var namespace = function(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name;
};

function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === xhtml && document.documentElement.namespaceURI === xhtml
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

var creator = function(name) {
  var fullname = namespace(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
};

var nextId = 0;

function local$1() {
  return new Local;
}

function Local() {
  this._ = "@" + (++nextId).toString(36);
}

Local.prototype = local$1.prototype = {
  constructor: Local,
  get: function(node) {
    var id = this._;
    while (!(id in node)) if (!(node = node.parentNode)) return;
    return node[id];
  },
  set: function(node, value) {
    return node[this._] = value;
  },
  remove: function(node) {
    return this._ in node && delete node[this._];
  },
  toString: function() {
    return this._;
  }
};

var matcher = function(selector) {
  return function() {
    return this.matches(selector);
  };
};

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!element.matches) {
    var vendorMatches = element.webkitMatchesSelector
        || element.msMatchesSelector
        || element.mozMatchesSelector
        || element.oMatchesSelector;
    matcher = function(selector) {
      return function() {
        return vendorMatches.call(this, selector);
      };
    };
  }
}

var matcher$1 = matcher;

var filterEvents = {};

exports.event = null;

if (typeof document !== "undefined") {
  var element$1 = document.documentElement;
  if (!("onmouseenter" in element$1)) {
    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
  }
}

function filterContextListener(listener, index, group) {
  listener = contextListener(listener, index, group);
  return function(event) {
    var related = event.relatedTarget;
    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
      listener.call(this, event);
    }
  };
}

function contextListener(listener, index, group) {
  return function(event1) {
    var event0 = exports.event; // Events can be reentrant (e.g., focus).
    exports.event = event1;
    try {
      listener.call(this, this.__data__, index, group);
    } finally {
      exports.event = event0;
    }
  };
}

function parseTypenames$1(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, capture) {
  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
  return function(d, i, group) {
    var on = this.__on, o, listener = wrap(value, i, group);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, capture);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

var selection_on = function(typename, value, capture) {
  var typenames = parseTypenames$1(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  if (capture == null) capture = false;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
  return this;
};

function customEvent(event1, listener, that, args) {
  var event0 = exports.event;
  event1.sourceEvent = exports.event;
  exports.event = event1;
  try {
    return listener.apply(that, args);
  } finally {
    exports.event = event0;
  }
}

var sourceEvent = function() {
  var current = exports.event, source;
  while (source = current.sourceEvent) current = source;
  return current;
};

var point = function(node, event) {
  var svg = node.ownerSVGElement || node;

  if (svg.createSVGPoint) {
    var point = svg.createSVGPoint();
    point.x = event.clientX, point.y = event.clientY;
    point = point.matrixTransform(node.getScreenCTM().inverse());
    return [point.x, point.y];
  }

  var rect = node.getBoundingClientRect();
  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
};

var mouse = function(node) {
  var event = sourceEvent();
  if (event.changedTouches) event = event.changedTouches[0];
  return point(node, event);
};

function none() {}

var selector = function(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
};

var selection_select = function(select) {
  if (typeof select !== "function") select = selector(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new Selection(subgroups, this._parents);
};

function empty$1() {
  return [];
}

var selectorAll = function(selector) {
  return selector == null ? empty$1 : function() {
    return this.querySelectorAll(selector);
  };
};

var selection_selectAll = function(select) {
  if (typeof select !== "function") select = selectorAll(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new Selection(subgroups, parents);
};

var selection_filter = function(match) {
  if (typeof match !== "function") match = matcher$1(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Selection(subgroups, this._parents);
};

var sparse = function(update) {
  return new Array(update.length);
};

var selection_enter = function() {
  return new Selection(this._enter || this._groups.map(sparse), this._parents);
};

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};

var constant$1 = function(x) {
  return function() {
    return x;
  };
};

var keyPrefix = "$"; // Protect against keys like “__proto__”.

function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = {},
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
      if (keyValue in nodeByKeyValue) {
        exit[i] = node;
      } else {
        nodeByKeyValue[keyValue] = node;
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = keyPrefix + key.call(parent, data[i], i, data);
    if (node = nodeByKeyValue[keyValue]) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue[keyValue] = null;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
      exit[i] = node;
    }
  }
}

var selection_data = function(value, key) {
  if (!value) {
    data = new Array(this.size()), j = -1;
    this.each(function(d) { data[++j] = d; });
    return data;
  }

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = constant$1(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = value.call(parent, parent && parent.__data__, j, parents),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new Selection(update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
};

var selection_exit = function() {
  return new Selection(this._exit || this._groups.map(sparse), this._parents);
};

var selection_merge = function(selection$$1) {

  for (var groups0 = this._groups, groups1 = selection$$1._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Selection(merges, this._parents);
};

var selection_order = function() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
};

var selection_sort = function(compare) {
  if (!compare) compare = ascending$1;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new Selection(sortgroups, this._parents).order();
};

function ascending$1(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

var selection_call = function() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
};

var selection_nodes = function() {
  var nodes = new Array(this.size()), i = -1;
  this.each(function() { nodes[++i] = this; });
  return nodes;
};

var selection_node = function() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
};

var selection_size = function() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
};

var selection_empty = function() {
  return !this.node();
};

var selection_each = function(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
};

function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

var selection_attr = function(name, value) {
  var fullname = namespace(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)
      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
};

var defaultView = function(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
};

function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

var selection_style = function(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove : typeof value === "function"
            ? styleFunction
            : styleConstant)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
};

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || defaultView(node).getComputedStyle(node, null).getPropertyValue(name);
}

function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

var selection_property = function(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
};

function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

var selection_classed = function(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
};

function textRemove() {
  this.textContent = "";
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

var selection_text = function(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction
          : textConstant)(value))
      : this.node().textContent;
};

function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

var selection_html = function(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
};

function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

var selection_raise = function() {
  return this.each(raise);
};

function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

var selection_lower = function() {
  return this.each(lower);
};

var selection_append = function(name) {
  var create = typeof name === "function" ? name : creator(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
};

function constantNull() {
  return null;
}

var selection_insert = function(name, before) {
  var create = typeof name === "function" ? name : creator(name),
      select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
};

function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

var selection_remove = function() {
  return this.each(remove);
};

var selection_datum = function(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
};

function dispatchEvent(node, type, params) {
  var window = defaultView(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

var selection_dispatch = function(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
};

var root = [null];

function Selection(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection() {
  return new Selection([[document.documentElement]], root);
}

Selection.prototype = selection.prototype = {
  constructor: Selection,
  select: selection_select,
  selectAll: selection_selectAll,
  filter: selection_filter,
  data: selection_data,
  enter: selection_enter,
  exit: selection_exit,
  merge: selection_merge,
  order: selection_order,
  sort: selection_sort,
  call: selection_call,
  nodes: selection_nodes,
  node: selection_node,
  size: selection_size,
  empty: selection_empty,
  each: selection_each,
  attr: selection_attr,
  style: selection_style,
  property: selection_property,
  classed: selection_classed,
  text: selection_text,
  html: selection_html,
  raise: selection_raise,
  lower: selection_lower,
  append: selection_append,
  insert: selection_insert,
  remove: selection_remove,
  datum: selection_datum,
  on: selection_on,
  dispatch: selection_dispatch
};

var select = function(selector) {
  return typeof selector === "string"
      ? new Selection([[document.querySelector(selector)]], [document.documentElement])
      : new Selection([[selector]], root);
};

var selectAll = function(selector) {
  return typeof selector === "string"
      ? new Selection([document.querySelectorAll(selector)], [document.documentElement])
      : new Selection([selector == null ? [] : selector], root);
};

var touch = function(node, touches, identifier) {
  if (arguments.length < 3) identifier = touches, touches = sourceEvent().changedTouches;

  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
    if ((touch = touches[i]).identifier === identifier) {
      return point(node, touch);
    }
  }

  return null;
};

var touches = function(node, touches) {
  if (touches == null) touches = sourceEvent().touches;

  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
    points[i] = point(node, touches[i]);
  }

  return points;
};

function nopropagation() {
  exports.event.stopImmediatePropagation();
}

var noevent = function() {
  exports.event.preventDefault();
  exports.event.stopImmediatePropagation();
};

var dragDisable = function(view) {
  var root = view.document.documentElement,
      selection$$1 = select(view).on("dragstart.drag", noevent, true);
  if ("onselectstart" in root) {
    selection$$1.on("selectstart.drag", noevent, true);
  } else {
    root.__noselect = root.style.MozUserSelect;
    root.style.MozUserSelect = "none";
  }
};

function yesdrag(view, noclick) {
  var root = view.document.documentElement,
      selection$$1 = select(view).on("dragstart.drag", null);
  if (noclick) {
    selection$$1.on("click.drag", noevent, true);
    setTimeout(function() { selection$$1.on("click.drag", null); }, 0);
  }
  if ("onselectstart" in root) {
    selection$$1.on("selectstart.drag", null);
  } else {
    root.style.MozUserSelect = root.__noselect;
    delete root.__noselect;
  }
}

var constant$2 = function(x) {
  return function() {
    return x;
  };
};

function DragEvent(target, type, subject, id, active, x, y, dx, dy, dispatch) {
  this.target = target;
  this.type = type;
  this.subject = subject;
  this.identifier = id;
  this.active = active;
  this.x = x;
  this.y = y;
  this.dx = dx;
  this.dy = dy;
  this._ = dispatch;
}

DragEvent.prototype.on = function() {
  var value = this._.on.apply(this._, arguments);
  return value === this._ ? this : value;
};

// Ignore right-click, since that should open the context menu.
function defaultFilter$1() {
  return !exports.event.button;
}

function defaultContainer() {
  return this.parentNode;
}

function defaultSubject(d) {
  return d == null ? {x: exports.event.x, y: exports.event.y} : d;
}

function touchable() {
  return "ontouchstart" in this;
}

var drag = function() {
  var filter = defaultFilter$1,
      container = defaultContainer,
      subject = defaultSubject,
      gestures = {},
      listeners = dispatch("start", "drag", "end"),
      active = 0,
      mousedownx,
      mousedowny,
      mousemoving,
      touchending,
      clickDistance2 = 0;

  function drag(selection) {
    selection
        .on("mousedown.drag", mousedowned)
      .filter(touchable)
        .on("touchstart.drag", touchstarted)
        .on("touchmove.drag", touchmoved)
        .on("touchend.drag touchcancel.drag", touchended)
        .style("touch-action", "none")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var gesture = beforestart("mouse", container.apply(this, arguments), mouse, this, arguments);
    if (!gesture) return;
    select(exports.event.view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
    dragDisable(exports.event.view);
    nopropagation();
    mousemoving = false;
    mousedownx = exports.event.clientX;
    mousedowny = exports.event.clientY;
    gesture("start");
  }

  function mousemoved() {
    noevent();
    if (!mousemoving) {
      var dx = exports.event.clientX - mousedownx, dy = exports.event.clientY - mousedowny;
      mousemoving = dx * dx + dy * dy > clickDistance2;
    }
    gestures.mouse("drag");
  }

  function mouseupped() {
    select(exports.event.view).on("mousemove.drag mouseup.drag", null);
    yesdrag(exports.event.view, mousemoving);
    noevent();
    gestures.mouse("end");
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var touches$$1 = exports.event.changedTouches,
        c = container.apply(this, arguments),
        n = touches$$1.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = beforestart(touches$$1[i].identifier, c, touch, this, arguments)) {
        nopropagation();
        gesture("start");
      }
    }
  }

  function touchmoved() {
    var touches$$1 = exports.event.changedTouches,
        n = touches$$1.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches$$1[i].identifier]) {
        noevent();
        gesture("drag");
      }
    }
  }

  function touchended() {
    var touches$$1 = exports.event.changedTouches,
        n = touches$$1.length, i, gesture;

    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches$$1[i].identifier]) {
        nopropagation();
        gesture("end");
      }
    }
  }

  function beforestart(id, container, point, that, args) {
    var p = point(container, id), s, dx, dy,
        sublisteners = listeners.copy();

    if (!customEvent(new DragEvent(drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
      if ((exports.event.subject = s = subject.apply(that, args)) == null) return false;
      dx = s.x - p[0] || 0;
      dy = s.y - p[1] || 0;
      return true;
    })) return;

    return function gesture(type) {
      var p0 = p, n;
      switch (type) {
        case "start": gestures[id] = gesture, n = active++; break;
        case "end": delete gestures[id], --active; // nobreak
        case "drag": p = point(container, id), n = active; break;
      }
      customEvent(new DragEvent(drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [type, that, args]);
    };
  }

  drag.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$2(!!_), drag) : filter;
  };

  drag.container = function(_) {
    return arguments.length ? (container = typeof _ === "function" ? _ : constant$2(_), drag) : container;
  };

  drag.subject = function(_) {
    return arguments.length ? (subject = typeof _ === "function" ? _ : constant$2(_), drag) : subject;
  };

  drag.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? drag : value;
  };

  drag.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
  };

  return drag;
};

var define = function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
};

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*";
var reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*";
var reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
var reHex3 = /^#([0-9a-f]{3})$/;
var reHex6 = /^#([0-9a-f]{6})$/;
var reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$");
var reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$");
var reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$");
var reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$");
var reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$");
var reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

define(Color, color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

define(Rgb, rgb, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Hsl, hsl, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}

var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;

var Kn = 18;
var Xn = 0.950470;
var Yn = 1;
var Zn = 1.088830;
var t0 = 4 / 29;
var t1 = 6 / 29;
var t2 = 3 * t1 * t1;
var t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    var h = o.h * deg2rad;
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var b = rgb2xyz(o.r),
      a = rgb2xyz(o.g),
      l = rgb2xyz(o.b),
      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

define(Lab, lab, extend(Color, {
  brighter: function(k) {
    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    y = Yn * lab2xyz(y);
    x = Xn * lab2xyz(x);
    z = Zn * lab2xyz(z);
    return new Rgb(
      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function xyz2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2xyz(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  var h = Math.atan2(o.b, o.a) * rad2deg;
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

define(Hcl, hcl, extend(Color, {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));

var A = -0.14861;
var B = +1.78277;
var C = -0.29227;
var D = -0.90649;
var E = +1.97294;
var ED = E * D;
var EB = E * B;
var BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Cubehelix, cubehelix, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new Rgb(
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));

function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

var basis$1 = function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
};

var basisClosed = function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
};

var constant$3 = function(x) {
  return function() {
    return x;
  };
};

function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant$3(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : constant$3(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : constant$3(isNaN(a) ? b : a);
}

var interpolateRgb = (function rgbGamma(y) {
  var color$$1 = gamma(y);

  function rgb$$1(start, end) {
    var r = color$$1((start = rgb(start)).r, (end = rgb(end)).r),
        g = color$$1(start.g, end.g),
        b = color$$1(start.b, end.b),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb$$1.gamma = rgbGamma;

  return rgb$$1;
})(1);

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color$$1;
    for (i = 0; i < n; ++i) {
      color$$1 = rgb(colors[i]);
      r[i] = color$$1.r || 0;
      g[i] = color$$1.g || 0;
      b[i] = color$$1.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color$$1.opacity = 1;
    return function(t) {
      color$$1.r = r(t);
      color$$1.g = g(t);
      color$$1.b = b(t);
      return color$$1 + "";
    };
  };
}

var rgbBasis = rgbSpline(basis$1);
var rgbBasisClosed = rgbSpline(basisClosed);

var array$1 = function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(nb),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = interpolateValue(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
};

var date = function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
};

var reinterpolate = function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
};

var object = function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = interpolateValue(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
};

var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
var reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

var interpolateString = function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: reinterpolate(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
};

var interpolateValue = function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? constant$3(b)
      : (t === "number" ? reinterpolate
      : t === "string" ? ((c = color(b)) ? (b = c, interpolateRgb) : interpolateString)
      : b instanceof color ? interpolateRgb
      : b instanceof Date ? date
      : Array.isArray(b) ? array$1
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
      : reinterpolate)(a, b);
};

var interpolateRound = function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
};

var degrees = 180 / Math.PI;

var identity$2 = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

var decompose = function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
};

var cssNode;
var cssRoot;
var cssView;
var svgNode;

function parseCss(value) {
  if (value === "none") return identity$2;
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return identity$2;
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return identity$2;
  value = value.matrix;
  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
}

function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: reinterpolate(xa, xb)}, {i: i - 2, x: reinterpolate(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: reinterpolate(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: reinterpolate(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: reinterpolate(xa, xb)}, {i: i - 2, x: reinterpolate(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");

var rho = Math.SQRT2;
var rho2 = 2;
var rho4 = 4;
var epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
var interpolateZoom = function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    };
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    };
  }

  i.duration = S * 1000;

  return i;
};

function hsl$1(hue$$1) {
  return function(start, end) {
    var h = hue$$1((start = hsl(start)).h, (end = hsl(end)).h),
        s = nogamma(start.s, end.s),
        l = nogamma(start.l, end.l),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

var hsl$2 = hsl$1(hue);
var hslLong = hsl$1(nogamma);

function lab$1(start, end) {
  var l = nogamma((start = lab(start)).l, (end = lab(end)).l),
      a = nogamma(start.a, end.a),
      b = nogamma(start.b, end.b),
      opacity = nogamma(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}

function hcl$1(hue$$1) {
  return function(start, end) {
    var h = hue$$1((start = hcl(start)).h, (end = hcl(end)).h),
        c = nogamma(start.c, end.c),
        l = nogamma(start.l, end.l),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

var hcl$2 = hcl$1(hue);
var hclLong = hcl$1(nogamma);

function cubehelix$1(hue$$1) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix$$1(start, end) {
      var h = hue$$1((start = cubehelix(start)).h, (end = cubehelix(end)).h),
          s = nogamma(start.s, end.s),
          l = nogamma(start.l, end.l),
          opacity = nogamma(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix$$1.gamma = cubehelixGamma;

    return cubehelix$$1;
  })(1);
}

var cubehelix$2 = cubehelix$1(hue);
var cubehelixLong = cubehelix$1(nogamma);

var quantize = function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
};

var frame = 0;
var timeout = 0;
var interval = 0;
var pokeDelay = 1000;
var taskHead;
var taskTail;
var clockLast = 0;
var clockNow = 0;
var clockSkew = 0;
var clock = typeof performance === "object" && performance.now ? performance : Date;
var setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow;
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, delay);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clockNow, interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}

var timeout$1 = function(callback, delay, time) {
  var t = new Timer;
  delay = delay == null ? 0 : +delay;
  t.restart(function(elapsed) {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
};

var interval$1 = function(callback, delay, time) {
  var t = new Timer, total = delay;
  if (delay == null) return t.restart(callback, delay, time), t;
  delay = +delay, time = time == null ? now() : +time;
  t.restart(function tick(elapsed) {
    elapsed += total;
    t.restart(tick, total += delay, time);
    callback(elapsed);
  }, delay, time);
  return t;
};

var emptyOn = dispatch("start", "end", "interrupt");
var emptyTween = [];

var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

var schedule = function(node, name, id, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};
  else if (id in schedules) return;
  create(node, id, {
    name: name,
    index: index, // For context during callback.
    group: group, // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
};

function init(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id]) || schedule.state > CREATED) throw new Error("too late");
  return schedule;
}

function set$1(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id]) || schedule.state > STARTING) throw new Error("too late");
  return schedule;
}

function get$1(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id])) throw new Error("too late");
  return schedule;
}

function create(node, id, self) {
  var schedules = node.__transition,
      tween;

  // Initialize the self timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  schedules[id] = self;
  self.timer = timer(schedule, 0, self.time);

  function schedule(elapsed) {
    self.state = SCHEDULED;
    self.timer.restart(start, self.delay, self.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (self.delay <= elapsed) start(elapsed - self.delay);
  }

  function start(elapsed) {
    var i, j, n, o;

    // If the state is not SCHEDULED, then we previously errored on start.
    if (self.state !== SCHEDULED) return stop();

    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name) continue;

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (o.state === STARTED) return timeout$1(start);

      // Interrupt the active transition, if any.
      // Dispatch the interrupt event.
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }

      // Cancel any pre-empted transitions. No interrupt event is dispatched
      // because the cancelled transitions never started. Note that this also
      // removes this transition from the pending list!
      else if (+i < id) {
        o.state = ENDED;
        o.timer.stop();
        delete schedules[i];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    timeout$1(function() {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });

    // Dispatch the start event.
    // Note this must be done before the tween are initialized.
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING) return; // interrupted
    self.state = STARTED;

    // Initialize the tween, deleting null tween.
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }

  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
        i = -1,
        n = tween.length;

    while (++i < n) {
      tween[i].call(null, t);
    }

    // Dispatch the end event.
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }

  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id];
    for (var i in schedules) return; // eslint-disable-line no-unused-vars
    delete node.__transition;
  }
}

var interrupt = function(node, name) {
  var schedules = node.__transition,
      schedule$$1,
      active,
      empty = true,
      i;

  if (!schedules) return;

  name = name == null ? null : name + "";

  for (i in schedules) {
    if ((schedule$$1 = schedules[i]).name !== name) { empty = false; continue; }
    active = schedule$$1.state > STARTING && schedule$$1.state < ENDING;
    schedule$$1.state = ENDED;
    schedule$$1.timer.stop();
    if (active) schedule$$1.on.call("interrupt", node, node.__data__, schedule$$1.index, schedule$$1.group);
    delete schedules[i];
  }

  if (empty) delete node.__transition;
};

var selection_interrupt = function(name) {
  return this.each(function() {
    interrupt(this, name);
  });
};

function tweenRemove(id, name) {
  var tween0, tween1;
  return function() {
    var schedule$$1 = set$1(this, id),
        tween = schedule$$1.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }

    schedule$$1.tween = tween1;
  };
}

function tweenFunction(id, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error;
  return function() {
    var schedule$$1 = set$1(this, id),
        tween = schedule$$1.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }

    schedule$$1.tween = tween1;
  };
}

var transition_tween = function(name, value) {
  var id = this._id;

  name += "";

  if (arguments.length < 2) {
    var tween = get$1(this.node(), id).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }

  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
};

function tweenValue(transition, name, value) {
  var id = transition._id;

  transition.each(function() {
    var schedule$$1 = set$1(this, id);
    (schedule$$1.value || (schedule$$1.value = {}))[name] = value.apply(this, arguments);
  });

  return function(node) {
    return get$1(node, id).value[name];
  };
}

var interpolate = function(a, b) {
  var c;
  return (typeof b === "number" ? reinterpolate
      : b instanceof color ? interpolateRgb
      : (c = color(b)) ? (b = c, interpolateRgb)
      : interpolateString)(a, b);
};

function attrRemove$1(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS$1(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant$1(name, interpolate$$1, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate$$1(value00 = value0, value1);
  };
}

function attrConstantNS$1(fullname, interpolate$$1, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate$$1(value00 = value0, value1);
  };
}

function attrFunction$1(name, interpolate$$1, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttribute(name);
    value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
  };
}

function attrFunctionNS$1(fullname, interpolate$$1, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
  };
}

var transition_attr = function(name, value) {
  var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : interpolate;
  return this.attrTween(name, typeof value === "function"
      ? (fullname.local ? attrFunctionNS$1 : attrFunction$1)(fullname, i, tweenValue(this, "attr." + name, value))
      : value == null ? (fullname.local ? attrRemoveNS$1 : attrRemove$1)(fullname)
      : (fullname.local ? attrConstantNS$1 : attrConstant$1)(fullname, i, value + ""));
};

function attrTweenNS(fullname, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttributeNS(fullname.space, fullname.local, i(t));
    };
  }
  tween._value = value;
  return tween;
}

function attrTween(name, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttribute(name, i(t));
    };
  }
  tween._value = value;
  return tween;
}

var transition_attrTween = function(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  var fullname = namespace(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
};

function delayFunction(id, value) {
  return function() {
    init(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function() {
    init(this, id).delay = value;
  };
}

var transition_delay = function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? delayFunction
          : delayConstant)(id, value))
      : get$1(this.node(), id).delay;
};

function durationFunction(id, value) {
  return function() {
    set$1(this, id).duration = +value.apply(this, arguments);
  };
}

function durationConstant(id, value) {
  return value = +value, function() {
    set$1(this, id).duration = value;
  };
}

var transition_duration = function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? durationFunction
          : durationConstant)(id, value))
      : get$1(this.node(), id).duration;
};

function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error;
  return function() {
    set$1(this, id).ease = value;
  };
}

var transition_ease = function(value) {
  var id = this._id;

  return arguments.length
      ? this.each(easeConstant(id, value))
      : get$1(this.node(), id).ease;
};

var transition_filter = function(match) {
  if (typeof match !== "function") match = matcher$1(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Transition(subgroups, this._parents, this._name, this._id);
};

var transition_merge = function(transition$$1) {
  if (transition$$1._id !== this._id) throw new Error;

  for (var groups0 = this._groups, groups1 = transition$$1._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Transition(merges, this._parents, this._name, this._id);
};

function start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}

function onFunction(id, name, listener) {
  var on0, on1, sit = start(name) ? init : set$1;
  return function() {
    var schedule$$1 = sit(this, id),
        on = schedule$$1.on;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);

    schedule$$1.on = on1;
  };
}

var transition_on = function(name, listener) {
  var id = this._id;

  return arguments.length < 2
      ? get$1(this.node(), id).on.on(name)
      : this.each(onFunction(id, name, listener));
};

function removeFunction(id) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id) return;
    if (parent) parent.removeChild(this);
  };
}

var transition_remove = function() {
  return this.on("end.remove", removeFunction(this._id));
};

var transition_select = function(select$$1) {
  var name = this._name,
      id = this._id;

  if (typeof select$$1 !== "function") select$$1 = selector(select$$1);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select$$1.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        schedule(subgroup[i], name, id, i, subgroup, get$1(node, id));
      }
    }
  }

  return new Transition(subgroups, this._parents, name, id);
};

var transition_selectAll = function(select$$1) {
  var name = this._name,
      id = this._id;

  if (typeof select$$1 !== "function") select$$1 = selectorAll(select$$1);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children = select$$1.call(node, node.__data__, i, group), child, inherit = get$1(node, id), k = 0, l = children.length; k < l; ++k) {
          if (child = children[k]) {
            schedule(child, name, id, k, children, inherit);
          }
        }
        subgroups.push(children);
        parents.push(node);
      }
    }
  }

  return new Transition(subgroups, parents, name, id);
};

var Selection$1 = selection.prototype.constructor;

var transition_selection = function() {
  return new Selection$1(this._groups, this._parents);
};

function styleRemove$1(name, interpolate$$1) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = styleValue(this, name),
        value1 = (this.style.removeProperty(name), styleValue(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
  };
}

function styleRemoveEnd(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant$1(name, interpolate$$1, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = styleValue(this, name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate$$1(value00 = value0, value1);
  };
}

function styleFunction$1(name, interpolate$$1, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = styleValue(this, name),
        value1 = value(this);
    if (value1 == null) value1 = (this.style.removeProperty(name), styleValue(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
  };
}

var transition_style = function(name, value, priority) {
  var i = (name += "") === "transform" ? interpolateTransformCss : interpolate;
  return value == null ? this
          .styleTween(name, styleRemove$1(name, i))
          .on("end.style." + name, styleRemoveEnd(name))
      : this.styleTween(name, typeof value === "function"
          ? styleFunction$1(name, i, tweenValue(this, "style." + name, value))
          : styleConstant$1(name, i, value + ""), priority);
};

function styleTween(name, value, priority) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.style.setProperty(name, i(t), priority);
    };
  }
  tween._value = value;
  return tween;
}

var transition_styleTween = function(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
};

function textConstant$1(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction$1(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

var transition_text = function(value) {
  return this.tween("text", typeof value === "function"
      ? textFunction$1(tweenValue(this, "text", value))
      : textConstant$1(value == null ? "" : value + ""));
};

var transition_transition = function() {
  var name = this._name,
      id0 = this._id,
      id1 = newId();

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit = get$1(node, id0);
        schedule(node, name, id1, i, group, {
          time: inherit.time + inherit.delay + inherit.duration,
          delay: 0,
          duration: inherit.duration,
          ease: inherit.ease
        });
      }
    }
  }

  return new Transition(groups, this._parents, name, id1);
};

var id = 0;

function Transition(groups, parents, name, id) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id;
}

function transition(name) {
  return selection().transition(name);
}

function newId() {
  return ++id;
}

var selection_prototype = selection.prototype;

Transition.prototype = transition.prototype = {
  constructor: Transition,
  select: transition_select,
  selectAll: transition_selectAll,
  filter: transition_filter,
  merge: transition_merge,
  selection: transition_selection,
  transition: transition_transition,
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: transition_on,
  attr: transition_attr,
  attrTween: transition_attrTween,
  style: transition_style,
  styleTween: transition_styleTween,
  text: transition_text,
  remove: transition_remove,
  tween: transition_tween,
  delay: transition_delay,
  duration: transition_duration,
  ease: transition_ease
};

function linear$1(t) {
  return +t;
}

function quadIn(t) {
  return t * t;
}

function quadOut(t) {
  return t * (2 - t);
}

function quadInOut(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}

function cubicIn(t) {
  return t * t * t;
}

function cubicOut(t) {
  return --t * t * t + 1;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

var exponent = 3;

var polyIn = (function custom(e) {
  e = +e;

  function polyIn(t) {
    return Math.pow(t, e);
  }

  polyIn.exponent = custom;

  return polyIn;
})(exponent);

var polyOut = (function custom(e) {
  e = +e;

  function polyOut(t) {
    return 1 - Math.pow(1 - t, e);
  }

  polyOut.exponent = custom;

  return polyOut;
})(exponent);

var polyInOut = (function custom(e) {
  e = +e;

  function polyInOut(t) {
    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
  }

  polyInOut.exponent = custom;

  return polyInOut;
})(exponent);

var pi = Math.PI;
var halfPi = pi / 2;

function sinIn(t) {
  return 1 - Math.cos(t * halfPi);
}

function sinOut(t) {
  return Math.sin(t * halfPi);
}

function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}

function expIn(t) {
  return Math.pow(2, 10 * t - 10);
}

function expOut(t) {
  return 1 - Math.pow(2, -10 * t);
}

function expInOut(t) {
  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
}

function circleIn(t) {
  return 1 - Math.sqrt(1 - t * t);
}

function circleOut(t) {
  return Math.sqrt(1 - --t * t);
}

function circleInOut(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}

var b1 = 4 / 11;
var b2 = 6 / 11;
var b3 = 8 / 11;
var b4 = 3 / 4;
var b5 = 9 / 11;
var b6 = 10 / 11;
var b7 = 15 / 16;
var b8 = 21 / 22;
var b9 = 63 / 64;
var b0 = 1 / b1 / b1;

function bounceIn(t) {
  return 1 - bounceOut(1 - t);
}

function bounceOut(t) {
  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}

function bounceInOut(t) {
  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}

var overshoot = 1.70158;

var backIn = (function custom(s) {
  s = +s;

  function backIn(t) {
    return t * t * ((s + 1) * t - s);
  }

  backIn.overshoot = custom;

  return backIn;
})(overshoot);

var backOut = (function custom(s) {
  s = +s;

  function backOut(t) {
    return --t * t * ((s + 1) * t + s) + 1;
  }

  backOut.overshoot = custom;

  return backOut;
})(overshoot);

var backInOut = (function custom(s) {
  s = +s;

  function backInOut(t) {
    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
  }

  backInOut.overshoot = custom;

  return backInOut;
})(overshoot);

var tau = 2 * Math.PI;
var amplitude = 1;
var period = 0.3;

var elasticIn = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticIn(t) {
    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
  }

  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
  elasticIn.period = function(p) { return custom(a, p); };

  return elasticIn;
})(amplitude, period);

var elasticOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticOut(t) {
    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
  }

  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticOut.period = function(p) { return custom(a, p); };

  return elasticOut;
})(amplitude, period);

var elasticInOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticInOut(t) {
    return ((t = t * 2 - 1) < 0
        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
  }

  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticInOut.period = function(p) { return custom(a, p); };

  return elasticInOut;
})(amplitude, period);

var defaultTiming = {
  time: null, // Set on use.
  delay: 0,
  duration: 250,
  ease: cubicInOut
};

function inherit(node, id) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id])) {
    if (!(node = node.parentNode)) {
      return defaultTiming.time = now(), defaultTiming;
    }
  }
  return timing;
}

var selection_transition = function(name) {
  var id,
      timing;

  if (name instanceof Transition) {
    id = name._id, name = name._name;
  } else {
    id = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
  }

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        schedule(node, name, id, i, group, timing || inherit(node, id));
      }
    }
  }

  return new Transition(groups, this._parents, name, id);
};

selection.prototype.interrupt = selection_interrupt;
selection.prototype.transition = selection_transition;

var root$1 = [null];

var active = function(node, name) {
  var schedules = node.__transition,
      schedule$$1,
      i;

  if (schedules) {
    name = name == null ? null : name + "";
    for (i in schedules) {
      if ((schedule$$1 = schedules[i]).state > SCHEDULED && schedule$$1.name === name) {
        return new Transition([[node]], root$1, name, +i);
      }
    }
  }

  return null;
};

var constant$4 = function(x) {
  return function() {
    return x;
  };
};

var BrushEvent = function(target, type, selection) {
  this.target = target;
  this.type = type;
  this.selection = selection;
};

function nopropagation$1() {
  exports.event.stopImmediatePropagation();
}

var noevent$1 = function() {
  exports.event.preventDefault();
  exports.event.stopImmediatePropagation();
};

var MODE_DRAG = {name: "drag"};
var MODE_SPACE = {name: "space"};
var MODE_HANDLE = {name: "handle"};
var MODE_CENTER = {name: "center"};

var X = {
  name: "x",
  handles: ["e", "w"].map(type),
  input: function(x, e) { return x && [[x[0], e[0][1]], [x[1], e[1][1]]]; },
  output: function(xy) { return xy && [xy[0][0], xy[1][0]]; }
};

var Y = {
  name: "y",
  handles: ["n", "s"].map(type),
  input: function(y, e) { return y && [[e[0][0], y[0]], [e[1][0], y[1]]]; },
  output: function(xy) { return xy && [xy[0][1], xy[1][1]]; }
};

var XY = {
  name: "xy",
  handles: ["n", "e", "s", "w", "nw", "ne", "se", "sw"].map(type),
  input: function(xy) { return xy; },
  output: function(xy) { return xy; }
};

var cursors = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
};

var flipX = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
};

var flipY = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
};

var signsX = {
  overlay: +1,
  selection: +1,
  n: null,
  e: +1,
  s: null,
  w: -1,
  nw: -1,
  ne: +1,
  se: +1,
  sw: -1
};

var signsY = {
  overlay: +1,
  selection: +1,
  n: -1,
  e: null,
  s: +1,
  w: null,
  nw: -1,
  ne: -1,
  se: +1,
  sw: +1
};

function type(t) {
  return {type: t};
}

// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !exports.event.button;
}

function defaultExtent() {
  var svg = this.ownerSVGElement || this;
  return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
}

// Like d3.local, but with the name “__brush” rather than auto-generated.
function local$$1(node) {
  while (!node.__brush) if (!(node = node.parentNode)) return;
  return node.__brush;
}

function empty(extent) {
  return extent[0][0] === extent[1][0]
      || extent[0][1] === extent[1][1];
}

function brushSelection(node) {
  var state = node.__brush;
  return state ? state.dim.output(state.selection) : null;
}

function brushX() {
  return brush$1(X);
}

function brushY() {
  return brush$1(Y);
}

var brush = function() {
  return brush$1(XY);
};

function brush$1(dim) {
  var extent = defaultExtent,
      filter = defaultFilter,
      listeners = dispatch(brush, "start", "brush", "end"),
      handleSize = 6,
      touchending;

  function brush(group) {
    var overlay = group
        .property("__brush", initialize)
      .selectAll(".overlay")
      .data([type("overlay")]);

    overlay.enter().append("rect")
        .attr("class", "overlay")
        .attr("pointer-events", "all")
        .attr("cursor", cursors.overlay)
      .merge(overlay)
        .each(function() {
          var extent = local$$1(this).extent;
          select(this)
              .attr("x", extent[0][0])
              .attr("y", extent[0][1])
              .attr("width", extent[1][0] - extent[0][0])
              .attr("height", extent[1][1] - extent[0][1]);
        });

    group.selectAll(".selection")
      .data([type("selection")])
      .enter().append("rect")
        .attr("class", "selection")
        .attr("cursor", cursors.selection)
        .attr("fill", "#777")
        .attr("fill-opacity", 0.3)
        .attr("stroke", "#fff")
        .attr("shape-rendering", "crispEdges");

    var handle = group.selectAll(".handle")
      .data(dim.handles, function(d) { return d.type; });

    handle.exit().remove();

    handle.enter().append("rect")
        .attr("class", function(d) { return "handle handle--" + d.type; })
        .attr("cursor", function(d) { return cursors[d.type]; });

    group
        .each(redraw)
        .attr("fill", "none")
        .attr("pointer-events", "all")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)")
        .on("mousedown.brush touchstart.brush", started);
  }

  brush.move = function(group, selection) {
    if (group.selection) {
      group
          .on("start.brush", function() { emitter(this, arguments).beforestart().start(); })
          .on("interrupt.brush end.brush", function() { emitter(this, arguments).end(); })
          .tween("brush", function() {
            var that = this,
                state = that.__brush,
                emit = emitter(that, arguments),
                selection0 = state.selection,
                selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent),
                i = interpolateValue(selection0, selection1);

            function tween(t) {
              state.selection = t === 1 && empty(selection1) ? null : i(t);
              redraw.call(that);
              emit.brush();
            }

            return selection0 && selection1 ? tween : tween(1);
          });
    } else {
      group
          .each(function() {
            var that = this,
                args = arguments,
                state = that.__brush,
                selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent),
                emit = emitter(that, args).beforestart();

            interrupt(that);
            state.selection = selection1 == null || empty(selection1) ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
          });
    }
  };

  function redraw() {
    var group = select(this),
        selection = local$$1(this).selection;

    if (selection) {
      group.selectAll(".selection")
          .style("display", null)
          .attr("x", selection[0][0])
          .attr("y", selection[0][1])
          .attr("width", selection[1][0] - selection[0][0])
          .attr("height", selection[1][1] - selection[0][1]);

      group.selectAll(".handle")
          .style("display", null)
          .attr("x", function(d) { return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2; })
          .attr("y", function(d) { return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2; })
          .attr("width", function(d) { return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize; })
          .attr("height", function(d) { return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize; });
    }

    else {
      group.selectAll(".selection,.handle")
          .style("display", "none")
          .attr("x", null)
          .attr("y", null)
          .attr("width", null)
          .attr("height", null);
    }
  }

  function emitter(that, args) {
    return that.__brush.emitter || new Emitter(that, args);
  }

  function Emitter(that, args) {
    this.that = that;
    this.args = args;
    this.state = that.__brush;
    this.active = 0;
  }

  Emitter.prototype = {
    beforestart: function() {
      if (++this.active === 1) this.state.emitter = this, this.starting = true;
      return this;
    },
    start: function() {
      if (this.starting) this.starting = false, this.emit("start");
      return this;
    },
    brush: function() {
      this.emit("brush");
      return this;
    },
    end: function() {
      if (--this.active === 0) delete this.state.emitter, this.emit("end");
      return this;
    },
    emit: function(type) {
      customEvent(new BrushEvent(brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function started() {
    if (exports.event.touches) { if (exports.event.changedTouches.length < exports.event.touches.length) return noevent$1(); }
    else if (touchending) return;
    if (!filter.apply(this, arguments)) return;

    var that = this,
        type = exports.event.target.__data__.type,
        mode = (exports.event.metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : (exports.event.altKey ? MODE_CENTER : MODE_HANDLE),
        signX = dim === Y ? null : signsX[type],
        signY = dim === X ? null : signsY[type],
        state = local$$1(that),
        extent = state.extent,
        selection = state.selection,
        W = extent[0][0], w0, w1,
        N = extent[0][1], n0, n1,
        E = extent[1][0], e0, e1,
        S = extent[1][1], s0, s1,
        dx,
        dy,
        moving,
        shifting = signX && signY && exports.event.shiftKey,
        lockX,
        lockY,
        point0 = mouse(that),
        point = point0,
        emit = emitter(that, arguments).beforestart();

    if (type === "overlay") {
      state.selection = selection = [
        [w0 = dim === Y ? W : point0[0], n0 = dim === X ? N : point0[1]],
        [e0 = dim === Y ? E : w0, s0 = dim === X ? S : n0]
      ];
    } else {
      w0 = selection[0][0];
      n0 = selection[0][1];
      e0 = selection[1][0];
      s0 = selection[1][1];
    }

    w1 = w0;
    n1 = n0;
    e1 = e0;
    s1 = s0;

    var group = select(that)
        .attr("pointer-events", "none");

    var overlay = group.selectAll(".overlay")
        .attr("cursor", cursors[type]);

    if (exports.event.touches) {
      group
          .on("touchmove.brush", moved, true)
          .on("touchend.brush touchcancel.brush", ended, true);
    } else {
      var view = select(exports.event.view)
          .on("keydown.brush", keydowned, true)
          .on("keyup.brush", keyupped, true)
          .on("mousemove.brush", moved, true)
          .on("mouseup.brush", ended, true);

      dragDisable(exports.event.view);
    }

    nopropagation$1();
    interrupt(that);
    redraw.call(that);
    emit.start();

    function moved() {
      var point1 = mouse(that);
      if (shifting && !lockX && !lockY) {
        if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
        else lockX = true;
      }
      point = point1;
      moving = true;
      noevent$1();
      move();
    }

    function move() {
      var t;

      dx = point[0] - point0[0];
      dy = point[1] - point0[1];

      switch (mode) {
        case MODE_SPACE:
        case MODE_DRAG: {
          if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
          if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
          break;
        }
        case MODE_HANDLE: {
          if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
          else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
          if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
          else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
          break;
        }
        case MODE_CENTER: {
          if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
          if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
          break;
        }
      }

      if (e1 < w1) {
        signX *= -1;
        t = w0, w0 = e0, e0 = t;
        t = w1, w1 = e1, e1 = t;
        if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
      }

      if (s1 < n1) {
        signY *= -1;
        t = n0, n0 = s0, s0 = t;
        t = n1, n1 = s1, s1 = t;
        if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
      }

      if (state.selection) selection = state.selection; // May be set by brush.move!
      if (lockX) w1 = selection[0][0], e1 = selection[1][0];
      if (lockY) n1 = selection[0][1], s1 = selection[1][1];

      if (selection[0][0] !== w1
          || selection[0][1] !== n1
          || selection[1][0] !== e1
          || selection[1][1] !== s1) {
        state.selection = [[w1, n1], [e1, s1]];
        redraw.call(that);
        emit.brush();
      }
    }

    function ended() {
      nopropagation$1();
      if (exports.event.touches) {
        if (exports.event.touches.length) return;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
        group.on("touchmove.brush touchend.brush touchcancel.brush", null);
      } else {
        yesdrag(exports.event.view, moving);
        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      }
      group.attr("pointer-events", "all");
      overlay.attr("cursor", cursors.overlay);
      if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
      if (empty(selection)) state.selection = null, redraw.call(that);
      emit.end();
    }

    function keydowned() {
      switch (exports.event.keyCode) {
        case 16: { // SHIFT
          shifting = signX && signY;
          break;
        }
        case 18: { // ALT
          if (mode === MODE_HANDLE) {
            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
            mode = MODE_CENTER;
            move();
          }
          break;
        }
        case 32: { // SPACE; takes priority over ALT
          if (mode === MODE_HANDLE || mode === MODE_CENTER) {
            if (signX < 0) e0 = e1 - dx; else if (signX > 0) w0 = w1 - dx;
            if (signY < 0) s0 = s1 - dy; else if (signY > 0) n0 = n1 - dy;
            mode = MODE_SPACE;
            overlay.attr("cursor", cursors.selection);
            move();
          }
          break;
        }
        default: return;
      }
      noevent$1();
    }

    function keyupped() {
      switch (exports.event.keyCode) {
        case 16: { // SHIFT
          if (shifting) {
            lockX = lockY = shifting = false;
            move();
          }
          break;
        }
        case 18: { // ALT
          if (mode === MODE_CENTER) {
            if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
            if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
            mode = MODE_HANDLE;
            move();
          }
          break;
        }
        case 32: { // SPACE
          if (mode === MODE_SPACE) {
            if (exports.event.altKey) {
              if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
              if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
              mode = MODE_CENTER;
            } else {
              if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
              if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
              mode = MODE_HANDLE;
            }
            overlay.attr("cursor", cursors[type]);
            move();
          }
          break;
        }
        default: return;
      }
      noevent$1();
    }
  }

  function initialize() {
    var state = this.__brush || {selection: null};
    state.extent = extent.apply(this, arguments);
    state.dim = dim;
    return state;
  }

  brush.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : constant$4([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), brush) : extent;
  };

  brush.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$4(!!_), brush) : filter;
  };

  brush.handleSize = function(_) {
    return arguments.length ? (handleSize = +_, brush) : handleSize;
  };

  brush.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? brush : value;
  };

  return brush;
}

var cos = Math.cos;
var sin = Math.sin;
var pi$1 = Math.PI;
var halfPi$1 = pi$1 / 2;
var tau$1 = pi$1 * 2;
var max$1 = Math.max;

function compareValue(compare) {
  return function(a, b) {
    return compare(
      a.source.value + a.target.value,
      b.source.value + b.target.value
    );
  };
}

var chord = function() {
  var padAngle = 0,
      sortGroups = null,
      sortSubgroups = null,
      sortChords = null;

  function chord(matrix) {
    var n = matrix.length,
        groupSums = [],
        groupIndex = sequence(n),
        subgroupIndex = [],
        chords = [],
        groups = chords.groups = new Array(n),
        subgroups = new Array(n * n),
        k,
        x,
        x0,
        dx,
        i,
        j;

    // Compute the sum.
    k = 0, i = -1; while (++i < n) {
      x = 0, j = -1; while (++j < n) {
        x += matrix[i][j];
      }
      groupSums.push(x);
      subgroupIndex.push(sequence(n));
      k += x;
    }

    // Sort groups…
    if (sortGroups) groupIndex.sort(function(a, b) {
      return sortGroups(groupSums[a], groupSums[b]);
    });

    // Sort subgroups…
    if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
      d.sort(function(a, b) {
        return sortSubgroups(matrix[i][a], matrix[i][b]);
      });
    });

    // Convert the sum to scaling factor for [0, 2pi].
    // TODO Allow start and end angle to be specified?
    // TODO Allow padding to be specified as percentage?
    k = max$1(0, tau$1 - padAngle * n) / k;
    dx = k ? padAngle : tau$1 / n;

    // Compute the start and end angle for each group and subgroup.
    // Note: Opera has a bug reordering object literal properties!
    x = 0, i = -1; while (++i < n) {
      x0 = x, j = -1; while (++j < n) {
        var di = groupIndex[i],
            dj = subgroupIndex[di][j],
            v = matrix[di][dj],
            a0 = x,
            a1 = x += v * k;
        subgroups[dj * n + di] = {
          index: di,
          subindex: dj,
          startAngle: a0,
          endAngle: a1,
          value: v
        };
      }
      groups[di] = {
        index: di,
        startAngle: x0,
        endAngle: x,
        value: groupSums[di]
      };
      x += dx;
    }

    // Generate chords for each (non-empty) subgroup-subgroup link.
    i = -1; while (++i < n) {
      j = i - 1; while (++j < n) {
        var source = subgroups[j * n + i],
            target = subgroups[i * n + j];
        if (source.value || target.value) {
          chords.push(source.value < target.value
              ? {source: target, target: source}
              : {source: source, target: target});
        }
      }
    }

    return sortChords ? chords.sort(sortChords) : chords;
  }

  chord.padAngle = function(_) {
    return arguments.length ? (padAngle = max$1(0, _), chord) : padAngle;
  };

  chord.sortGroups = function(_) {
    return arguments.length ? (sortGroups = _, chord) : sortGroups;
  };

  chord.sortSubgroups = function(_) {
    return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
  };

  chord.sortChords = function(_) {
    return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
  };

  return chord;
};

var slice$2 = Array.prototype.slice;

var constant$5 = function(x) {
  return function() {
    return x;
  };
};

var pi$2 = Math.PI;
var tau$2 = 2 * pi$2;
var epsilon$1 = 1e-6;
var tauEpsilon = tau$2 - epsilon$1;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon$1)) {}

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$1) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi$2 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon$1) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon$1 || Math.abs(this._y1 - y0) > epsilon$1) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau$2 + tau$2;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon$1) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi$2)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

function defaultSource(d) {
  return d.source;
}

function defaultTarget(d) {
  return d.target;
}

function defaultRadius(d) {
  return d.radius;
}

function defaultStartAngle(d) {
  return d.startAngle;
}

function defaultEndAngle(d) {
  return d.endAngle;
}

var ribbon = function() {
  var source = defaultSource,
      target = defaultTarget,
      radius = defaultRadius,
      startAngle = defaultStartAngle,
      endAngle = defaultEndAngle,
      context = null;

  function ribbon() {
    var buffer,
        argv = slice$2.call(arguments),
        s = source.apply(this, argv),
        t = target.apply(this, argv),
        sr = +radius.apply(this, (argv[0] = s, argv)),
        sa0 = startAngle.apply(this, argv) - halfPi$1,
        sa1 = endAngle.apply(this, argv) - halfPi$1,
        sx0 = sr * cos(sa0),
        sy0 = sr * sin(sa0),
        tr = +radius.apply(this, (argv[0] = t, argv)),
        ta0 = startAngle.apply(this, argv) - halfPi$1,
        ta1 = endAngle.apply(this, argv) - halfPi$1;

    if (!context) context = buffer = path();

    context.moveTo(sx0, sy0);
    context.arc(0, 0, sr, sa0, sa1);
    if (sa0 !== ta0 || sa1 !== ta1) { // TODO sr !== tr?
      context.quadraticCurveTo(0, 0, tr * cos(ta0), tr * sin(ta0));
      context.arc(0, 0, tr, ta0, ta1);
    }
    context.quadraticCurveTo(0, 0, sx0, sy0);
    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  ribbon.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$5(+_), ribbon) : radius;
  };

  ribbon.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$5(+_), ribbon) : startAngle;
  };

  ribbon.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$5(+_), ribbon) : endAngle;
  };

  ribbon.source = function(_) {
    return arguments.length ? (source = _, ribbon) : source;
  };

  ribbon.target = function(_) {
    return arguments.length ? (target = _, ribbon) : target;
  };

  ribbon.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), ribbon) : context;
  };

  return ribbon;
};

var prefix = "$";

function Map() {}

Map.prototype = map$1.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map$1(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

var nest = function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) {
      if (sortValues != null) array.sort(sortValues);
      return rollup != null ? rollup(array) : array;
    }

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = map$1(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
};

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return map$1();
}

function setMap(map, key, value) {
  map.set(key, value);
}

function Set() {}

var proto = map$1.prototype;

Set.prototype = set$2.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[prefix + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set$2(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

var keys = function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
};

var values = function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
};

var entries = function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
};

function objectConverter(columns) {
  return new Function("d", "return {" + columns.map(function(name, i) {
    return JSON.stringify(name) + ": d[" + i + "]";
  }).join(",") + "}");
}

function customConverter(columns, f) {
  var object = objectConverter(columns);
  return function(row, i) {
    return f(object(row), i, columns);
  };
}

// Compute unique columns in order of discovery.
function inferColumns(rows) {
  var columnSet = Object.create(null),
      columns = [];

  rows.forEach(function(row) {
    for (var column in row) {
      if (!(column in columnSet)) {
        columns.push(columnSet[column] = column);
      }
    }
  });

  return columns;
}

var dsv = function(delimiter) {
  var reFormat = new RegExp("[\"" + delimiter + "\n\r]"),
      delimiterCode = delimiter.charCodeAt(0);

  function parse(text, f) {
    var convert, columns, rows = parseRows(text, function(row, i) {
      if (convert) return convert(row, i - 1);
      columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
    });
    rows.columns = columns;
    return rows;
  }

  function parseRows(text, f) {
    var EOL = {}, // sentinel value for end-of-line
        EOF = {}, // sentinel value for end-of-file
        rows = [], // output rows
        N = text.length,
        I = 0, // current character index
        n = 0, // the current line number
        t, // the current token
        eol; // is the current token followed by EOL?

    function token() {
      if (I >= N) return EOF; // special case: end of file
      if (eol) return eol = false, EOL; // special case: end of line

      // special case: quotes
      var j = I, c;
      if (text.charCodeAt(j) === 34) {
        var i = j;
        while (i++ < N) {
          if (text.charCodeAt(i) === 34) {
            if (text.charCodeAt(i + 1) !== 34) break;
            ++i;
          }
        }
        I = i + 2;
        c = text.charCodeAt(i + 1);
        if (c === 13) {
          eol = true;
          if (text.charCodeAt(i + 2) === 10) ++I;
        } else if (c === 10) {
          eol = true;
        }
        return text.slice(j + 1, i).replace(/""/g, "\"");
      }

      // common case: find next delimiter or newline
      while (I < N) {
        var k = 1;
        c = text.charCodeAt(I++);
        if (c === 10) eol = true; // \n
        else if (c === 13) { eol = true; if (text.charCodeAt(I) === 10) ++I, ++k; } // \r|\r\n
        else if (c !== delimiterCode) continue;
        return text.slice(j, I - k);
      }

      // special case: last token before EOF
      return text.slice(j);
    }

    while ((t = token()) !== EOF) {
      var a = [];
      while (t !== EOL && t !== EOF) {
        a.push(t);
        t = token();
      }
      if (f && (a = f(a, n++)) == null) continue;
      rows.push(a);
    }

    return rows;
  }

  function format(rows, columns) {
    if (columns == null) columns = inferColumns(rows);
    return [columns.map(formatValue).join(delimiter)].concat(rows.map(function(row) {
      return columns.map(function(column) {
        return formatValue(row[column]);
      }).join(delimiter);
    })).join("\n");
  }

  function formatRows(rows) {
    return rows.map(formatRow).join("\n");
  }

  function formatRow(row) {
    return row.map(formatValue).join(delimiter);
  }

  function formatValue(text) {
    return text == null ? ""
        : reFormat.test(text += "") ? "\"" + text.replace(/\"/g, "\"\"") + "\""
        : text;
  }

  return {
    parse: parse,
    parseRows: parseRows,
    format: format,
    formatRows: formatRows
  };
};

var csv = dsv(",");

var csvParse = csv.parse;
var csvParseRows = csv.parseRows;
var csvFormat = csv.format;
var csvFormatRows = csv.formatRows;

var tsv = dsv("\t");

var tsvParse = tsv.parse;
var tsvParseRows = tsv.parseRows;
var tsvFormat = tsv.format;
var tsvFormatRows = tsv.formatRows;

var center$1 = function(x, y) {
  var nodes;

  if (x == null) x = 0;
  if (y == null) y = 0;

  function force() {
    var i,
        n = nodes.length,
        node,
        sx = 0,
        sy = 0;

    for (i = 0; i < n; ++i) {
      node = nodes[i], sx += node.x, sy += node.y;
    }

    for (sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i) {
      node = nodes[i], node.x -= sx, node.y -= sy;
    }
  }

  force.initialize = function(_) {
    nodes = _;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  return force;
};

var constant$6 = function(x) {
  return function() {
    return x;
  };
};

var jiggle = function() {
  return (Math.random() - 0.5) * 1e-6;
};

var tree_add = function(d) {
  var x = +this._x.call(null, d),
      y = +this._y.call(null, d);
  return add(this.cover(x, y), x, y, d);
};

function add(tree, x, y, d) {
  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points

  var parent,
      node = tree._root,
      leaf = {data: d},
      x0 = tree._x0,
      y0 = tree._y0,
      x1 = tree._x1,
      y1 = tree._y1,
      xm,
      ym,
      xp,
      yp,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return tree._root = leaf, tree;

  // Find the existing leaf for the new point, or add it.
  while (node.length) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
  }

  // Is the new point is exactly coincident with the existing point?
  xp = +tree._x.call(null, node.data);
  yp = +tree._y.call(null, node.data);
  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;

  // Otherwise, split the leaf node until the old and new point are separated.
  do {
    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
  return parent[j] = node, parent[i] = leaf, tree;
}

function addAll(data) {
  var d, i, n = data.length,
      x,
      y,
      xz = new Array(n),
      yz = new Array(n),
      x0 = Infinity,
      y0 = Infinity,
      x1 = -Infinity,
      y1 = -Infinity;

  // Compute the points and their extent.
  for (i = 0; i < n; ++i) {
    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
    xz[i] = x;
    yz[i] = y;
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
  }

  // If there were no (valid) points, inherit the existing extent.
  if (x1 < x0) x0 = this._x0, x1 = this._x1;
  if (y1 < y0) y0 = this._y0, y1 = this._y1;

  // Expand the tree to cover the new points.
  this.cover(x0, y0).cover(x1, y1);

  // Add the new points.
  for (i = 0; i < n; ++i) {
    add(this, xz[i], yz[i], data[i]);
  }

  return this;
}

var tree_cover = function(x, y) {
  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points

  var x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1;

  // If the quadtree has no extent, initialize them.
  // Integer extent are necessary so that if we later double the extent,
  // the existing quadrant boundaries don’t change due to floating point error!
  if (isNaN(x0)) {
    x1 = (x0 = Math.floor(x)) + 1;
    y1 = (y0 = Math.floor(y)) + 1;
  }

  // Otherwise, double repeatedly to cover.
  else if (x0 > x || x > x1 || y0 > y || y > y1) {
    var z = x1 - x0,
        node = this._root,
        parent,
        i;

    switch (i = (y < (y0 + y1) / 2) << 1 | (x < (x0 + x1) / 2)) {
      case 0: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1);
        break;
      }
      case 1: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1);
        break;
      }
      case 2: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y);
        break;
      }
      case 3: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y);
        break;
      }
    }

    if (this._root && this._root.length) this._root = node;
  }

  // If the quadtree covers the point already, just return.
  else return this;

  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  return this;
};

var tree_data = function() {
  var data = [];
  this.visit(function(node) {
    if (!node.length) do data.push(node.data); while (node = node.next)
  });
  return data;
};

var tree_extent = function(_) {
  return arguments.length
      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
};

var Quad = function(node, x0, y0, x1, y1) {
  this.node = node;
  this.x0 = x0;
  this.y0 = y0;
  this.x1 = x1;
  this.y1 = y1;
};

var tree_find = function(x, y, radius) {
  var data,
      x0 = this._x0,
      y0 = this._y0,
      x1,
      y1,
      x2,
      y2,
      x3 = this._x1,
      y3 = this._y1,
      quads = [],
      node = this._root,
      q,
      i;

  if (node) quads.push(new Quad(node, x0, y0, x3, y3));
  if (radius == null) radius = Infinity;
  else {
    x0 = x - radius, y0 = y - radius;
    x3 = x + radius, y3 = y + radius;
    radius *= radius;
  }

  while (q = quads.pop()) {

    // Stop searching if this quadrant can’t contain a closer node.
    if (!(node = q.node)
        || (x1 = q.x0) > x3
        || (y1 = q.y0) > y3
        || (x2 = q.x1) < x0
        || (y2 = q.y1) < y0) continue;

    // Bisect the current quadrant.
    if (node.length) {
      var xm = (x1 + x2) / 2,
          ym = (y1 + y2) / 2;

      quads.push(
        new Quad(node[3], xm, ym, x2, y2),
        new Quad(node[2], x1, ym, xm, y2),
        new Quad(node[1], xm, y1, x2, ym),
        new Quad(node[0], x1, y1, xm, ym)
      );

      // Visit the closest quadrant first.
      if (i = (y >= ym) << 1 | (x >= xm)) {
        q = quads[quads.length - 1];
        quads[quads.length - 1] = quads[quads.length - 1 - i];
        quads[quads.length - 1 - i] = q;
      }
    }

    // Visit this point. (Visiting coincident points isn’t necessary!)
    else {
      var dx = x - +this._x.call(null, node.data),
          dy = y - +this._y.call(null, node.data),
          d2 = dx * dx + dy * dy;
      if (d2 < radius) {
        var d = Math.sqrt(radius = d2);
        x0 = x - d, y0 = y - d;
        x3 = x + d, y3 = y + d;
        data = node.data;
      }
    }
  }

  return data;
};

var tree_remove = function(d) {
  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points

  var parent,
      node = this._root,
      retainer,
      previous,
      next,
      x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1,
      x,
      y,
      xm,
      ym,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return this;

  // Find the leaf node for the point.
  // While descending, also retain the deepest parent with a non-removed sibling.
  if (node.length) while (true) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
    if (!node.length) break;
    if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
  }

  // Find the point to remove.
  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
  if (next = node.next) delete node.next;

  // If there are multiple coincident points, remove just the point.
  if (previous) return (next ? previous.next = next : delete previous.next), this;

  // If this is the root point, remove it.
  if (!parent) return this._root = next, this;

  // Remove this leaf.
  next ? parent[i] = next : delete parent[i];

  // If the parent now contains exactly one leaf, collapse superfluous parents.
  if ((node = parent[0] || parent[1] || parent[2] || parent[3])
      && node === (parent[3] || parent[2] || parent[1] || parent[0])
      && !node.length) {
    if (retainer) retainer[j] = node;
    else this._root = node;
  }

  return this;
};

function removeAll(data) {
  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
  return this;
}

var tree_root = function() {
  return this._root;
};

var tree_size = function() {
  var size = 0;
  this.visit(function(node) {
    if (!node.length) do ++size; while (node = node.next)
  });
  return size;
};

var tree_visit = function(callback) {
  var quads = [], q, node = this._root, child, x0, y0, x1, y1;
  if (node) quads.push(new Quad(node, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
    }
  }
  return this;
};

var tree_visitAfter = function(callback) {
  var quads = [], next = [], q;
  if (this._root) quads.push(new Quad(this._root, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    var node = q.node;
    if (node.length) {
      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
    }
    next.push(q);
  }
  while (q = next.pop()) {
    callback(q.node, q.x0, q.y0, q.x1, q.y1);
  }
  return this;
};

function defaultX(d) {
  return d[0];
}

var tree_x = function(_) {
  return arguments.length ? (this._x = _, this) : this._x;
};

function defaultY(d) {
  return d[1];
}

var tree_y = function(_) {
  return arguments.length ? (this._y = _, this) : this._y;
};

function quadtree(nodes, x, y) {
  var tree = new Quadtree(x == null ? defaultX : x, y == null ? defaultY : y, NaN, NaN, NaN, NaN);
  return nodes == null ? tree : tree.addAll(nodes);
}

function Quadtree(x, y, x0, y0, x1, y1) {
  this._x = x;
  this._y = y;
  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  this._root = undefined;
}

function leaf_copy(leaf) {
  var copy = {data: leaf.data}, next = copy;
  while (leaf = leaf.next) next = next.next = {data: leaf.data};
  return copy;
}

var treeProto = quadtree.prototype = Quadtree.prototype;

treeProto.copy = function() {
  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
      node = this._root,
      nodes,
      child;

  if (!node) return copy;

  if (!node.length) return copy._root = leaf_copy(node), copy;

  nodes = [{source: node, target: copy._root = new Array(4)}];
  while (node = nodes.pop()) {
    for (var i = 0; i < 4; ++i) {
      if (child = node.source[i]) {
        if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
        else node.target[i] = leaf_copy(child);
      }
    }
  }

  return copy;
};

treeProto.add = tree_add;
treeProto.addAll = addAll;
treeProto.cover = tree_cover;
treeProto.data = tree_data;
treeProto.extent = tree_extent;
treeProto.find = tree_find;
treeProto.remove = tree_remove;
treeProto.removeAll = removeAll;
treeProto.root = tree_root;
treeProto.size = tree_size;
treeProto.visit = tree_visit;
treeProto.visitAfter = tree_visitAfter;
treeProto.x = tree_x;
treeProto.y = tree_y;

function x(d) {
  return d.x + d.vx;
}

function y(d) {
  return d.y + d.vy;
}

var collide = function(radius) {
  var nodes,
      radii,
      strength = 1,
      iterations = 1;

  if (typeof radius !== "function") radius = constant$6(radius == null ? 1 : +radius);

  function force() {
    var i, n = nodes.length,
        tree,
        node,
        xi,
        yi,
        ri,
        ri2;

    for (var k = 0; k < iterations; ++k) {
      tree = quadtree(nodes, x, y).visitAfter(prepare);
      for (i = 0; i < n; ++i) {
        node = nodes[i];
        ri = radii[node.index], ri2 = ri * ri;
        xi = node.x + node.vx;
        yi = node.y + node.vy;
        tree.visit(apply);
      }
    }

    function apply(quad, x0, y0, x1, y1) {
      var data = quad.data, rj = quad.r, r = ri + rj;
      if (data) {
        if (data.index > node.index) {
          var x = xi - data.x - data.vx,
              y = yi - data.y - data.vy,
              l = x * x + y * y;
          if (l < r * r) {
            if (x === 0) x = jiggle(), l += x * x;
            if (y === 0) y = jiggle(), l += y * y;
            l = (r - (l = Math.sqrt(l))) / l * strength;
            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
            node.vy += (y *= l) * r;
            data.vx -= x * (r = 1 - r);
            data.vy -= y * r;
          }
        }
        return;
      }
      return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
    }
  }

  function prepare(quad) {
    if (quad.data) return quad.r = radii[quad.data.index];
    for (var i = quad.r = 0; i < 4; ++i) {
      if (quad[i] && quad[i].r > quad.r) {
        quad.r = quad[i].r;
      }
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    radii = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = +_, force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : radius;
  };

  return force;
};

function index(d) {
  return d.index;
}

function find(nodeById, nodeId) {
  var node = nodeById.get(nodeId);
  if (!node) throw new Error("missing: " + nodeId);
  return node;
}

var link = function(links) {
  var id = index,
      strength = defaultStrength,
      strengths,
      distance = constant$6(30),
      distances,
      nodes,
      count,
      bias,
      iterations = 1;

  if (links == null) links = [];

  function defaultStrength(link) {
    return 1 / Math.min(count[link.source.index], count[link.target.index]);
  }

  function force(alpha) {
    for (var k = 0, n = links.length; k < iterations; ++k) {
      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
        link = links[i], source = link.source, target = link.target;
        x = target.x + target.vx - source.x - source.vx || jiggle();
        y = target.y + target.vy - source.y - source.vy || jiggle();
        l = Math.sqrt(x * x + y * y);
        l = (l - distances[i]) / l * alpha * strengths[i];
        x *= l, y *= l;
        target.vx -= x * (b = bias[i]);
        target.vy -= y * b;
        source.vx += x * (b = 1 - b);
        source.vy += y * b;
      }
    }
  }

  function initialize() {
    if (!nodes) return;

    var i,
        n = nodes.length,
        m = links.length,
        nodeById = map$1(nodes, id),
        link;

    for (i = 0, count = new Array(n); i < m; ++i) {
      link = links[i], link.index = i;
      if (typeof link.source !== "object") link.source = find(nodeById, link.source);
      if (typeof link.target !== "object") link.target = find(nodeById, link.target);
      count[link.source.index] = (count[link.source.index] || 0) + 1;
      count[link.target.index] = (count[link.target.index] || 0) + 1;
    }

    for (i = 0, bias = new Array(m); i < m; ++i) {
      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
    }

    strengths = new Array(m), initializeStrength();
    distances = new Array(m), initializeDistance();
  }

  function initializeStrength() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      strengths[i] = +strength(links[i], i, links);
    }
  }

  function initializeDistance() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      distances[i] = +distance(links[i], i, links);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.links = function(_) {
    return arguments.length ? (links = _, initialize(), force) : links;
  };

  force.id = function(_) {
    return arguments.length ? (id = _, force) : id;
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$6(+_), initializeStrength(), force) : strength;
  };

  force.distance = function(_) {
    return arguments.length ? (distance = typeof _ === "function" ? _ : constant$6(+_), initializeDistance(), force) : distance;
  };

  return force;
};

function x$1(d) {
  return d.x;
}

function y$1(d) {
  return d.y;
}

var initialRadius = 10;
var initialAngle = Math.PI * (3 - Math.sqrt(5));

var simulation = function(nodes) {
  var simulation,
      alpha = 1,
      alphaMin = 0.001,
      alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
      alphaTarget = 0,
      velocityDecay = 0.6,
      forces = map$1(),
      stepper = timer(step),
      event = dispatch("tick", "end");

  if (nodes == null) nodes = [];

  function step() {
    tick();
    event.call("tick", simulation);
    if (alpha < alphaMin) {
      stepper.stop();
      event.call("end", simulation);
    }
  }

  function tick() {
    var i, n = nodes.length, node;

    alpha += (alphaTarget - alpha) * alphaDecay;

    forces.each(function(force) {
      force(alpha);
    });

    for (i = 0; i < n; ++i) {
      node = nodes[i];
      if (node.fx == null) node.x += node.vx *= velocityDecay;
      else node.x = node.fx, node.vx = 0;
      if (node.fy == null) node.y += node.vy *= velocityDecay;
      else node.y = node.fy, node.vy = 0;
    }
  }

  function initializeNodes() {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.index = i;
      if (isNaN(node.x) || isNaN(node.y)) {
        var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
        node.x = radius * Math.cos(angle);
        node.y = radius * Math.sin(angle);
      }
      if (isNaN(node.vx) || isNaN(node.vy)) {
        node.vx = node.vy = 0;
      }
    }
  }

  function initializeForce(force) {
    if (force.initialize) force.initialize(nodes);
    return force;
  }

  initializeNodes();

  return simulation = {
    tick: tick,

    restart: function() {
      return stepper.restart(step), simulation;
    },

    stop: function() {
      return stepper.stop(), simulation;
    },

    nodes: function(_) {
      return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
    },

    alpha: function(_) {
      return arguments.length ? (alpha = +_, simulation) : alpha;
    },

    alphaMin: function(_) {
      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
    },

    alphaDecay: function(_) {
      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
    },

    alphaTarget: function(_) {
      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
    },

    velocityDecay: function(_) {
      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
    },

    force: function(name, _) {
      return arguments.length > 1 ? ((_ == null ? forces.remove(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
    },

    find: function(x, y, radius) {
      var i = 0,
          n = nodes.length,
          dx,
          dy,
          d2,
          node,
          closest;

      if (radius == null) radius = Infinity;
      else radius *= radius;

      for (i = 0; i < n; ++i) {
        node = nodes[i];
        dx = x - node.x;
        dy = y - node.y;
        d2 = dx * dx + dy * dy;
        if (d2 < radius) closest = node, radius = d2;
      }

      return closest;
    },

    on: function(name, _) {
      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
    }
  };
};

var manyBody = function() {
  var nodes,
      node,
      alpha,
      strength = constant$6(-30),
      strengths,
      distanceMin2 = 1,
      distanceMax2 = Infinity,
      theta2 = 0.81;

  function force(_) {
    var i, n = nodes.length, tree = quadtree(nodes, x$1, y$1).visitAfter(accumulate);
    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    strengths = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
  }

  function accumulate(quad) {
    var strength = 0, q, c, x, y, i;

    // For internal nodes, accumulate forces from child quadrants.
    if (quad.length) {
      for (x = y = i = 0; i < 4; ++i) {
        if ((q = quad[i]) && (c = q.value)) {
          strength += c, x += c * q.x, y += c * q.y;
        }
      }
      quad.x = x / strength;
      quad.y = y / strength;
    }

    // For leaf nodes, accumulate forces from coincident quadrants.
    else {
      q = quad;
      q.x = q.data.x;
      q.y = q.data.y;
      do strength += strengths[q.data.index];
      while (q = q.next);
    }

    quad.value = strength;
  }

  function apply(quad, x1, _, x2) {
    if (!quad.value) return true;

    var x = quad.x - node.x,
        y = quad.y - node.y,
        w = x2 - x1,
        l = x * x + y * y;

    // Apply the Barnes-Hut approximation if possible.
    // Limit forces for very close nodes; randomize direction if coincident.
    if (w * w / theta2 < l) {
      if (l < distanceMax2) {
        if (x === 0) x = jiggle(), l += x * x;
        if (y === 0) y = jiggle(), l += y * y;
        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        node.vx += x * quad.value * alpha / l;
        node.vy += y * quad.value * alpha / l;
      }
      return true;
    }

    // Otherwise, process points directly.
    else if (quad.length || l >= distanceMax2) return;

    // Limit forces for very close nodes; randomize direction if coincident.
    if (quad.data !== node || quad.next) {
      if (x === 0) x = jiggle(), l += x * x;
      if (y === 0) y = jiggle(), l += y * y;
      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
    }

    do if (quad.data !== node) {
      w = strengths[quad.data.index] * alpha / l;
      node.vx += x * w;
      node.vy += y * w;
    } while (quad = quad.next);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : strength;
  };

  force.distanceMin = function(_) {
    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
  };

  force.distanceMax = function(_) {
    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
  };

  force.theta = function(_) {
    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
  };

  return force;
};

var x$2 = function(x) {
  var strength = constant$6(0.1),
      nodes,
      strengths,
      xz;

  if (typeof x !== "function") x = constant$6(x == null ? 0 : +x);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    xz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : strength;
  };

  force.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : x;
  };

  return force;
};

var y$2 = function(y) {
  var strength = constant$6(0.1),
      nodes,
      strengths,
      yz;

  if (typeof y !== "function") y = constant$6(y == null ? 0 : +y);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    yz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : strength;
  };

  force.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : y;
  };

  return force;
};

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
var formatDecimal = function(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
};

var exponent$1 = function(x) {
  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
};

var formatGroup = function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
};

var formatNumerals = function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
};

var formatDefault = function(x, p) {
  x = x.toPrecision(p);

  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (x[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      case "e": break out;
      default: if (i0 > 0) i0 = 0; break;
    }
  }

  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
};

var prefixExponent;

var formatPrefixAuto = function(x, p) {
  var d = formatDecimal(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
};

var formatRounded = function(x, p) {
  var d = formatDecimal(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
};

var formatTypes = {
  "": formatDefault,
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return formatRounded(x * 100, p); },
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
};

// [[fill]align][sign][symbol][0][width][,][.precision][type]
var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);

  var match,
      fill = match[1] || " ",
      align = match[2] || ">",
      sign = match[3] || "-",
      symbol = match[4] || "",
      zero = !!match[5],
      width = match[6] && +match[6],
      comma = !!match[7],
      precision = match[8] && +match[8].slice(1),
      type = match[9] || "";

  // The "n" type is an alias for ",g".
  if (type === "n") comma = true, type = "g";

  // Map invalid types to the default format.
  else if (!formatTypes[type]) type = "";

  // If zero fill is specified, padding goes after sign and before digits.
  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

  this.fill = fill;
  this.align = align;
  this.sign = sign;
  this.symbol = symbol;
  this.zero = zero;
  this.width = width;
  this.comma = comma;
  this.precision = precision;
  this.type = type;
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width == null ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
      + this.type;
};

var identity$3 = function(x) {
  return x;
};

var prefixes = ["y","z","a","f","p","n","\xB5","m","","k","M","G","T","P","E","Z","Y"];

var formatLocale = function(locale) {
  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity$3,
      currency = locale.currency,
      decimal = locale.decimal,
      numerals = locale.numerals ? formatNumerals(locale.numerals) : identity$3,
      percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        type = specifier.type;

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes[type],
        maybeSuffix = !type || /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? (type ? 6 : 12)
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
};

var locale$1;



defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale$1 = formatLocale(definition);
  exports.format = locale$1.format;
  exports.formatPrefix = locale$1.formatPrefix;
  return locale$1;
}

var precisionFixed = function(step) {
  return Math.max(0, -exponent$1(Math.abs(step)));
};

var precisionPrefix = function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3 - exponent$1(Math.abs(step)));
};

var precisionRound = function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, exponent$1(max) - exponent$1(step)) + 1;
};

// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/

var adder = function() {
  return new Adder;
};

function Adder() {
  this.reset();
}

Adder.prototype = {
  constructor: Adder,
  reset: function() {
    this.s = // rounded value
    this.t = 0; // exact error
  },
  add: function(y) {
    add$1(temp, y, this.t);
    add$1(this, temp.s, this.s);
    if (this.s) this.t += temp.t;
    else this.s = temp.t;
  },
  valueOf: function() {
    return this.s;
  }
};

var temp = new Adder;

function add$1(adder, a, b) {
  var x = adder.s = a + b,
      bv = x - a,
      av = x - bv;
  adder.t = (a - av) + (b - bv);
}

var epsilon$2 = 1e-6;
var epsilon2$1 = 1e-12;
var pi$3 = Math.PI;
var halfPi$2 = pi$3 / 2;
var quarterPi = pi$3 / 4;
var tau$3 = pi$3 * 2;

var degrees$1 = 180 / pi$3;
var radians = pi$3 / 180;

var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos$1 = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;

var log = Math.log;
var pow = Math.pow;
var sin$1 = Math.sin;
var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
var sqrt = Math.sqrt;
var tan = Math.tan;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi$3 : Math.acos(x);
}

function asin(x) {
  return x > 1 ? halfPi$2 : x < -1 ? -halfPi$2 : Math.asin(x);
}

function haversin(x) {
  return (x = sin$1(x / 2)) * x;
}

function noop$1() {}

function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}

var streamObjectType = {
  Feature: function(object, stream) {
    streamGeometry(object.geometry, stream);
  },
  FeatureCollection: function(object, stream) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) streamGeometry(features[i].geometry, stream);
  }
};

var streamGeometryType = {
  Sphere: function(object, stream) {
    stream.sphere();
  },
  Point: function(object, stream) {
    object = object.coordinates;
    stream.point(object[0], object[1], object[2]);
  },
  MultiPoint: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
  },
  LineString: function(object, stream) {
    streamLine(object.coordinates, stream, 0);
  },
  MultiLineString: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamLine(coordinates[i], stream, 0);
  },
  Polygon: function(object, stream) {
    streamPolygon(object.coordinates, stream);
  },
  MultiPolygon: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamPolygon(coordinates[i], stream);
  },
  GeometryCollection: function(object, stream) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) streamGeometry(geometries[i], stream);
  }
};

function streamLine(coordinates, stream, closed) {
  var i = -1, n = coordinates.length - closed, coordinate;
  stream.lineStart();
  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}

function streamPolygon(coordinates, stream) {
  var i = -1, n = coordinates.length;
  stream.polygonStart();
  while (++i < n) streamLine(coordinates[i], stream, 1);
  stream.polygonEnd();
}

var geoStream = function(object, stream) {
  if (object && streamObjectType.hasOwnProperty(object.type)) {
    streamObjectType[object.type](object, stream);
  } else {
    streamGeometry(object, stream);
  }
};

var areaRingSum = adder();

var areaSum = adder();
var lambda00;
var phi00;
var lambda0;
var cosPhi0;
var sinPhi0;

var areaStream = {
  point: noop$1,
  lineStart: noop$1,
  lineEnd: noop$1,
  polygonStart: function() {
    areaRingSum.reset();
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    var areaRing = +areaRingSum;
    areaSum.add(areaRing < 0 ? tau$3 + areaRing : areaRing);
    this.lineStart = this.lineEnd = this.point = noop$1;
  },
  sphere: function() {
    areaSum.add(tau$3);
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaRingEnd() {
  areaPoint(lambda00, phi00);
}

function areaPointFirst(lambda, phi) {
  areaStream.point = areaPoint;
  lambda00 = lambda, phi00 = phi;
  lambda *= radians, phi *= radians;
  lambda0 = lambda, cosPhi0 = cos$1(phi = phi / 2 + quarterPi), sinPhi0 = sin$1(phi);
}

function areaPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  phi = phi / 2 + quarterPi; // half the angular distance from south pole

  // Spherical excess E for a spherical triangle with vertices: south pole,
  // previous point, current point.  Uses a formula derived from Cagnoli’s
  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
  var dLambda = lambda - lambda0,
      sdLambda = dLambda >= 0 ? 1 : -1,
      adLambda = sdLambda * dLambda,
      cosPhi = cos$1(phi),
      sinPhi = sin$1(phi),
      k = sinPhi0 * sinPhi,
      u = cosPhi0 * cosPhi + k * cos$1(adLambda),
      v = k * sdLambda * sin$1(adLambda);
  areaRingSum.add(atan2(v, u));

  // Advance the previous points.
  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}

var area = function(object) {
  areaSum.reset();
  geoStream(object, areaStream);
  return areaSum * 2;
};

function spherical(cartesian) {
  return [atan2(cartesian[1], cartesian[0]), asin(cartesian[2])];
}

function cartesian(spherical) {
  var lambda = spherical[0], phi = spherical[1], cosPhi = cos$1(phi);
  return [cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi)];
}

function cartesianDot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}

function cartesianCross(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}

// TODO return a
function cartesianAddInPlace(a, b) {
  a[0] += b[0], a[1] += b[1], a[2] += b[2];
}

function cartesianScale(vector, k) {
  return [vector[0] * k, vector[1] * k, vector[2] * k];
}

// TODO return d
function cartesianNormalizeInPlace(d) {
  var l = sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
  d[0] /= l, d[1] /= l, d[2] /= l;
}

var lambda0$1;
var phi0;
var lambda1;
var phi1;
var lambda2;
var lambda00$1;
var phi00$1;
var p0;
var deltaSum = adder();
var ranges;
var range;

var boundsStream = {
  point: boundsPoint,
  lineStart: boundsLineStart,
  lineEnd: boundsLineEnd,
  polygonStart: function() {
    boundsStream.point = boundsRingPoint;
    boundsStream.lineStart = boundsRingStart;
    boundsStream.lineEnd = boundsRingEnd;
    deltaSum.reset();
    areaStream.polygonStart();
  },
  polygonEnd: function() {
    areaStream.polygonEnd();
    boundsStream.point = boundsPoint;
    boundsStream.lineStart = boundsLineStart;
    boundsStream.lineEnd = boundsLineEnd;
    if (areaRingSum < 0) lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    else if (deltaSum > epsilon$2) phi1 = 90;
    else if (deltaSum < -epsilon$2) phi0 = -90;
    range[0] = lambda0$1, range[1] = lambda1;
  }
};

function boundsPoint(lambda, phi) {
  ranges.push(range = [lambda0$1 = lambda, lambda1 = lambda]);
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
}

function linePoint(lambda, phi) {
  var p = cartesian([lambda * radians, phi * radians]);
  if (p0) {
    var normal = cartesianCross(p0, p),
        equatorial = [normal[1], -normal[0], 0],
        inflection = cartesianCross(equatorial, normal);
    cartesianNormalizeInPlace(inflection);
    inflection = spherical(inflection);
    var delta = lambda - lambda2,
        sign$$1 = delta > 0 ? 1 : -1,
        lambdai = inflection[0] * degrees$1 * sign$$1,
        phii,
        antimeridian = abs(delta) > 180;
    if (antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
      phii = inflection[1] * degrees$1;
      if (phii > phi1) phi1 = phii;
    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
      phii = -inflection[1] * degrees$1;
      if (phii < phi0) phi0 = phii;
    } else {
      if (phi < phi0) phi0 = phi;
      if (phi > phi1) phi1 = phi;
    }
    if (antimeridian) {
      if (lambda < lambda2) {
        if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
      } else {
        if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
      }
    } else {
      if (lambda1 >= lambda0$1) {
        if (lambda < lambda0$1) lambda0$1 = lambda;
        if (lambda > lambda1) lambda1 = lambda;
      } else {
        if (lambda > lambda2) {
          if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
        } else {
          if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
        }
      }
    }
  } else {
    ranges.push(range = [lambda0$1 = lambda, lambda1 = lambda]);
  }
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
  p0 = p, lambda2 = lambda;
}

function boundsLineStart() {
  boundsStream.point = linePoint;
}

function boundsLineEnd() {
  range[0] = lambda0$1, range[1] = lambda1;
  boundsStream.point = boundsPoint;
  p0 = null;
}

function boundsRingPoint(lambda, phi) {
  if (p0) {
    var delta = lambda - lambda2;
    deltaSum.add(abs(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
  } else {
    lambda00$1 = lambda, phi00$1 = phi;
  }
  areaStream.point(lambda, phi);
  linePoint(lambda, phi);
}

function boundsRingStart() {
  areaStream.lineStart();
}

function boundsRingEnd() {
  boundsRingPoint(lambda00$1, phi00$1);
  areaStream.lineEnd();
  if (abs(deltaSum) > epsilon$2) lambda0$1 = -(lambda1 = 180);
  range[0] = lambda0$1, range[1] = lambda1;
  p0 = null;
}

// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function angle(lambda0, lambda1) {
  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}

function rangeCompare(a, b) {
  return a[0] - b[0];
}

function rangeContains(range, x) {
  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

var bounds = function(feature) {
  var i, n, a, b, merged, deltaMax, delta;

  phi1 = lambda1 = -(lambda0$1 = phi0 = Infinity);
  ranges = [];
  geoStream(feature, boundsStream);

  // First, sort ranges by their minimum longitudes.
  if (n = ranges.length) {
    ranges.sort(rangeCompare);

    // Then, merge any ranges that overlap.
    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
      b = ranges[i];
      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
      } else {
        merged.push(a = b);
      }
    }

    // Finally, find the largest gap between the merged ranges.
    // The final bounding box will be the inverse of this gap.
    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
      b = merged[i];
      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0$1 = b[0], lambda1 = a[1];
    }
  }

  ranges = range = null;

  return lambda0$1 === Infinity || phi0 === Infinity
      ? [[NaN, NaN], [NaN, NaN]]
      : [[lambda0$1, phi0], [lambda1, phi1]];
};

var W0;
var W1;
var X0;
var Y0;
var Z0;
var X1;
var Y1;
var Z1;
var X2;
var Y2;
var Z2;
var lambda00$2;
var phi00$2;
var x0;
var y0;
var z0; // previous point

var centroidStream = {
  sphere: noop$1,
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  }
};

// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos$1(phi);
  centroidPointCartesian(cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi));
}

function centroidPointCartesian(x, y, z) {
  ++W0;
  X0 += (x - X0) / W0;
  Y0 += (y - Y0) / W0;
  Z0 += (z - Z0) / W0;
}

function centroidLineStart() {
  centroidStream.point = centroidLinePointFirst;
}

function centroidLinePointFirst(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos$1(phi);
  x0 = cosPhi * cos$1(lambda);
  y0 = cosPhi * sin$1(lambda);
  z0 = sin$1(phi);
  centroidStream.point = centroidLinePoint;
  centroidPointCartesian(x0, y0, z0);
}

function centroidLinePoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos$1(phi),
      x = cosPhi * cos$1(lambda),
      y = cosPhi * sin$1(lambda),
      z = sin$1(phi),
      w = atan2(sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
  centroidStream.point = centroidRingPointFirst;
}

function centroidRingEnd() {
  centroidRingPoint(lambda00$2, phi00$2);
  centroidStream.point = centroidPoint;
}

function centroidRingPointFirst(lambda, phi) {
  lambda00$2 = lambda, phi00$2 = phi;
  lambda *= radians, phi *= radians;
  centroidStream.point = centroidRingPoint;
  var cosPhi = cos$1(phi);
  x0 = cosPhi * cos$1(lambda);
  y0 = cosPhi * sin$1(lambda);
  z0 = sin$1(phi);
  centroidPointCartesian(x0, y0, z0);
}

function centroidRingPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos$1(phi),
      x = cosPhi * cos$1(lambda),
      y = cosPhi * sin$1(lambda),
      z = sin$1(phi),
      cx = y0 * z - z0 * y,
      cy = z0 * x - x0 * z,
      cz = x0 * y - y0 * x,
      m = sqrt(cx * cx + cy * cy + cz * cz),
      w = asin(m), // line weight = angle
      v = m && -w / m; // area weight multiplier
  X2 += v * cx;
  Y2 += v * cy;
  Z2 += v * cz;
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

var centroid = function(object) {
  W0 = W1 =
  X0 = Y0 = Z0 =
  X1 = Y1 = Z1 =
  X2 = Y2 = Z2 = 0;
  geoStream(object, centroidStream);

  var x = X2,
      y = Y2,
      z = Z2,
      m = x * x + y * y + z * z;

  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
  if (m < epsilon2$1) {
    x = X1, y = Y1, z = Z1;
    // If the feature has zero length, fall back to arithmetic mean of point vectors.
    if (W1 < epsilon$2) x = X0, y = Y0, z = Z0;
    m = x * x + y * y + z * z;
    // If the feature still has an undefined ccentroid, then return.
    if (m < epsilon2$1) return [NaN, NaN];
  }

  return [atan2(y, x) * degrees$1, asin(z / sqrt(m)) * degrees$1];
};

var constant$7 = function(x) {
  return function() {
    return x;
  };
};

var compose = function(a, b) {

  function compose(x, y) {
    return x = a(x, y), b(x[0], x[1]);
  }

  if (a.invert && b.invert) compose.invert = function(x, y) {
    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
  };

  return compose;
};

function rotationIdentity(lambda, phi) {
  return [lambda > pi$3 ? lambda - tau$3 : lambda < -pi$3 ? lambda + tau$3 : lambda, phi];
}

rotationIdentity.invert = rotationIdentity;

function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= tau$3) ? (deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
    : rotationLambda(deltaLambda))
    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
    : rotationIdentity);
}

function forwardRotationLambda(deltaLambda) {
  return function(lambda, phi) {
    return lambda += deltaLambda, [lambda > pi$3 ? lambda - tau$3 : lambda < -pi$3 ? lambda + tau$3 : lambda, phi];
  };
}

function rotationLambda(deltaLambda) {
  var rotation = forwardRotationLambda(deltaLambda);
  rotation.invert = forwardRotationLambda(-deltaLambda);
  return rotation;
}

function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = cos$1(deltaPhi),
      sinDeltaPhi = sin$1(deltaPhi),
      cosDeltaGamma = cos$1(deltaGamma),
      sinDeltaGamma = sin$1(deltaGamma);

  function rotation(lambda, phi) {
    var cosPhi = cos$1(phi),
        x = cos$1(lambda) * cosPhi,
        y = sin$1(lambda) * cosPhi,
        z = sin$1(phi),
        k = z * cosDeltaPhi + x * sinDeltaPhi;
    return [
      atan2(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
      asin(k * cosDeltaGamma + y * sinDeltaGamma)
    ];
  }

  rotation.invert = function(lambda, phi) {
    var cosPhi = cos$1(phi),
        x = cos$1(lambda) * cosPhi,
        y = sin$1(lambda) * cosPhi,
        z = sin$1(phi),
        k = z * cosDeltaGamma - y * sinDeltaGamma;
    return [
      atan2(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
      asin(k * cosDeltaPhi - x * sinDeltaPhi)
    ];
  };

  return rotation;
}

var rotation = function(rotate) {
  rotate = rotateRadians(rotate[0] * radians, rotate[1] * radians, rotate.length > 2 ? rotate[2] * radians : 0);

  function forward(coordinates) {
    coordinates = rotate(coordinates[0] * radians, coordinates[1] * radians);
    return coordinates[0] *= degrees$1, coordinates[1] *= degrees$1, coordinates;
  }

  forward.invert = function(coordinates) {
    coordinates = rotate.invert(coordinates[0] * radians, coordinates[1] * radians);
    return coordinates[0] *= degrees$1, coordinates[1] *= degrees$1, coordinates;
  };

  return forward;
};

// Generates a circle centered at [0°, 0°], with a given radius and precision.
function circleStream(stream, radius, delta, direction, t0, t1) {
  if (!delta) return;
  var cosRadius = cos$1(radius),
      sinRadius = sin$1(radius),
      step = direction * delta;
  if (t0 == null) {
    t0 = radius + direction * tau$3;
    t1 = radius - step / 2;
  } else {
    t0 = circleRadius(cosRadius, t0);
    t1 = circleRadius(cosRadius, t1);
    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * tau$3;
  }
  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
    point = spherical([cosRadius, -sinRadius * cos$1(t), -sinRadius * sin$1(t)]);
    stream.point(point[0], point[1]);
  }
}

// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
  point = cartesian(point), point[0] -= cosRadius;
  cartesianNormalizeInPlace(point);
  var radius = acos(-point[1]);
  return ((-point[2] < 0 ? -radius : radius) + tau$3 - epsilon$2) % tau$3;
}

var circle = function() {
  var center = constant$7([0, 0]),
      radius = constant$7(90),
      precision = constant$7(6),
      ring,
      rotate,
      stream = {point: point};

  function point(x, y) {
    ring.push(x = rotate(x, y));
    x[0] *= degrees$1, x[1] *= degrees$1;
  }

  function circle() {
    var c = center.apply(this, arguments),
        r = radius.apply(this, arguments) * radians,
        p = precision.apply(this, arguments) * radians;
    ring = [];
    rotate = rotateRadians(-c[0] * radians, -c[1] * radians, 0).invert;
    circleStream(stream, r, p, 1);
    c = {type: "Polygon", coordinates: [ring]};
    ring = rotate = null;
    return c;
  }

  circle.center = function(_) {
    return arguments.length ? (center = typeof _ === "function" ? _ : constant$7([+_[0], +_[1]]), circle) : center;
  };

  circle.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$7(+_), circle) : radius;
  };

  circle.precision = function(_) {
    return arguments.length ? (precision = typeof _ === "function" ? _ : constant$7(+_), circle) : precision;
  };

  return circle;
};

var clipBuffer = function() {
  var lines = [],
      line;
  return {
    point: function(x, y) {
      line.push([x, y]);
    },
    lineStart: function() {
      lines.push(line = []);
    },
    lineEnd: noop$1,
    rejoin: function() {
      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
};

var clipLine = function(a, b, x0, y0, x1, y1) {
  var ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
  return true;
};

var pointEqual = function(a, b) {
  return abs(a[0] - b[0]) < epsilon$2 && abs(a[1] - b[1]) < epsilon$2;
};

function Intersection(point, points, other, entry) {
  this.x = point;
  this.z = points;
  this.o = other; // another intersection
  this.e = entry; // is an entry?
  this.v = false; // visited
  this.n = this.p = null; // next & previous
}

// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
var clipPolygon = function(segments, compareIntersection, startInside, interpolate, stream) {
  var subject = [],
      clip = [],
      i,
      n;

  segments.forEach(function(segment) {
    if ((n = segment.length - 1) <= 0) return;
    var n, p0 = segment[0], p1 = segment[n], x;

    // If the first and last points of a segment are coincident, then treat as a
    // closed ring. TODO if all rings are closed, then the winding order of the
    // exterior ring should be checked.
    if (pointEqual(p0, p1)) {
      stream.lineStart();
      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
      stream.lineEnd();
      return;
    }

    subject.push(x = new Intersection(p0, segment, null, true));
    clip.push(x.o = new Intersection(p0, null, x, false));
    subject.push(x = new Intersection(p1, segment, null, false));
    clip.push(x.o = new Intersection(p1, null, x, true));
  });

  if (!subject.length) return;

  clip.sort(compareIntersection);
  link$1(subject);
  link$1(clip);

  for (i = 0, n = clip.length; i < n; ++i) {
    clip[i].e = startInside = !startInside;
  }

  var start = subject[0],
      points,
      point;

  while (1) {
    // Find first unvisited intersection.
    var current = start,
        isSubject = true;
    while (current.v) if ((current = current.n) === start) return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
};

function link$1(array) {
  if (!(n = array.length)) return;
  var n,
      i = 0,
      a = array[0],
      b;
  while (++i < n) {
    a.n = b = array[i];
    b.p = a;
    a = b;
  }
  a.n = b = array[0];
  b.p = a;
}

var clipMax = 1e9;
var clipMin = -clipMax;

// TODO Use d3-polygon’s polygonContains here for the ring check?
// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?

function clipExtent(x0, y0, x1, y1) {

  function visible(x, y) {
    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
  }

  function interpolate(from, to, direction, stream) {
    var a = 0, a1 = 0;
    if (from == null
        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
        || comparePoint(from, to) < 0 ^ direction > 0) {
      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
      while ((a = (a + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }

  function corner(p, direction) {
    return abs(p[0] - x0) < epsilon$2 ? direction > 0 ? 0 : 3
        : abs(p[0] - x1) < epsilon$2 ? direction > 0 ? 2 : 1
        : abs(p[1] - y0) < epsilon$2 ? direction > 0 ? 1 : 0
        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
  }

  function compareIntersection(a, b) {
    return comparePoint(a.x, b.x);
  }

  function comparePoint(a, b) {
    var ca = corner(a, 1),
        cb = corner(b, 1);
    return ca !== cb ? ca - cb
        : ca === 0 ? b[1] - a[1]
        : ca === 1 ? a[0] - b[0]
        : ca === 2 ? a[1] - b[1]
        : b[0] - a[0];
  }

  return function(stream) {
    var activeStream = stream,
        bufferStream = clipBuffer(),
        segments,
        polygon,
        ring,
        x__, y__, v__, // first point
        x_, y_, v_, // previous point
        first,
        clean;

    var clipStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: polygonStart,
      polygonEnd: polygonEnd
    };

    function point(x, y) {
      if (visible(x, y)) activeStream.point(x, y);
    }

    function polygonInside() {
      var winding = 0;

      for (var i = 0, n = polygon.length; i < n; ++i) {
        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
        }
      }

      return winding;
    }

    // Buffer geometry within a polygon and then clip it en masse.
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }

    function polygonEnd() {
      var startInside = polygonInside(),
          cleanInside = clean && startInside,
          visible = (segments = merge(segments)).length;
      if (cleanInside || visible) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible) {
          clipPolygon(segments, compareIntersection, startInside, interpolate, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring = null;
    }

    function lineStart() {
      clipStream.point = linePoint;
      if (polygon) polygon.push(ring = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }

    // TODO rather than special-case polygons, simply handle them separately.
    // Ideally, coincident intersection points should be jittered to avoid
    // clipping issues.
    function lineEnd() {
      if (segments) {
        linePoint(x__, y__);
        if (v__ && v_) bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point;
      if (v_) activeStream.lineEnd();
    }

    function linePoint(x, y) {
      var v = visible(x, y);
      if (polygon) ring.push([x, y]);
      if (first) {
        x__ = x, y__ = y, v__ = v;
        first = false;
        if (v) {
          activeStream.lineStart();
          activeStream.point(x, y);
        }
      } else {
        if (v && v_) activeStream.point(x, y);
        else {
          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
          if (clipLine(a, b, x0, y0, x1, y1)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a[0], a[1]);
            }
            activeStream.point(b[0], b[1]);
            if (!v) activeStream.lineEnd();
            clean = false;
          } else if (v) {
            activeStream.lineStart();
            activeStream.point(x, y);
            clean = false;
          }
        }
      }
      x_ = x, y_ = y, v_ = v;
    }

    return clipStream;
  };
}

var extent$1 = function() {
  var x0 = 0,
      y0 = 0,
      x1 = 960,
      y1 = 500,
      cache,
      cacheStream,
      clip;

  return clip = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = clipExtent(x0, y0, x1, y1)(cacheStream = stream);
    },
    extent: function(_) {
      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
    }
  };
};

var sum$1 = adder();

var polygonContains = function(polygon, point) {
  var lambda = point[0],
      phi = point[1],
      normal = [sin$1(lambda), -cos$1(lambda), 0],
      angle = 0,
      winding = 0;

  sum$1.reset();

  for (var i = 0, n = polygon.length; i < n; ++i) {
    if (!(m = (ring = polygon[i]).length)) continue;
    var ring,
        m,
        point0 = ring[m - 1],
        lambda0 = point0[0],
        phi0 = point0[1] / 2 + quarterPi,
        sinPhi0 = sin$1(phi0),
        cosPhi0 = cos$1(phi0);

    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
      var point1 = ring[j],
          lambda1 = point1[0],
          phi1 = point1[1] / 2 + quarterPi,
          sinPhi1 = sin$1(phi1),
          cosPhi1 = cos$1(phi1),
          delta = lambda1 - lambda0,
          sign$$1 = delta >= 0 ? 1 : -1,
          absDelta = sign$$1 * delta,
          antimeridian = absDelta > pi$3,
          k = sinPhi0 * sinPhi1;

      sum$1.add(atan2(k * sign$$1 * sin$1(absDelta), cosPhi0 * cosPhi1 + k * cos$1(absDelta)));
      angle += antimeridian ? delta + sign$$1 * tau$3 : delta;

      // Are the longitudes either side of the point’s meridian (lambda),
      // and are the latitudes smaller than the parallel (phi)?
      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
        var arc = cartesianCross(cartesian(point0), cartesian(point1));
        cartesianNormalizeInPlace(arc);
        var intersection = cartesianCross(normal, arc);
        cartesianNormalizeInPlace(intersection);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin(intersection[2]);
        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }

  // First, determine whether the South pole is inside or outside:
  //
  // It is inside if:
  // * the polygon winds around it in a clockwise direction.
  // * the polygon does not (cumulatively) wind around it, but has a negative
  //   (counter-clockwise) area.
  //
  // Second, count the (signed) number of times a segment crosses a lambda
  // from the point to the South pole.  If it is zero, then the point is the
  // same side as the South pole.

  return (angle < -epsilon$2 || angle < epsilon$2 && sum$1 < -epsilon$2) ^ (winding & 1);
};

var lengthSum = adder();
var lambda0$2;
var sinPhi0$1;
var cosPhi0$1;

var lengthStream = {
  sphere: noop$1,
  point: noop$1,
  lineStart: lengthLineStart,
  lineEnd: noop$1,
  polygonStart: noop$1,
  polygonEnd: noop$1
};

function lengthLineStart() {
  lengthStream.point = lengthPointFirst;
  lengthStream.lineEnd = lengthLineEnd;
}

function lengthLineEnd() {
  lengthStream.point = lengthStream.lineEnd = noop$1;
}

function lengthPointFirst(lambda, phi) {
  lambda *= radians, phi *= radians;
  lambda0$2 = lambda, sinPhi0$1 = sin$1(phi), cosPhi0$1 = cos$1(phi);
  lengthStream.point = lengthPoint;
}

function lengthPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var sinPhi = sin$1(phi),
      cosPhi = cos$1(phi),
      delta = abs(lambda - lambda0$2),
      cosDelta = cos$1(delta),
      sinDelta = sin$1(delta),
      x = cosPhi * sinDelta,
      y = cosPhi0$1 * sinPhi - sinPhi0$1 * cosPhi * cosDelta,
      z = sinPhi0$1 * sinPhi + cosPhi0$1 * cosPhi * cosDelta;
  lengthSum.add(atan2(sqrt(x * x + y * y), z));
  lambda0$2 = lambda, sinPhi0$1 = sinPhi, cosPhi0$1 = cosPhi;
}

var length$1 = function(object) {
  lengthSum.reset();
  geoStream(object, lengthStream);
  return +lengthSum;
};

var coordinates = [null, null];
var object$1 = {type: "LineString", coordinates: coordinates};

var distance = function(a, b) {
  coordinates[0] = a;
  coordinates[1] = b;
  return length$1(object$1);
};

var containsObjectType = {
  Feature: function(object, point) {
    return containsGeometry(object.geometry, point);
  },
  FeatureCollection: function(object, point) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
    return false;
  }
};

var containsGeometryType = {
  Sphere: function() {
    return true;
  },
  Point: function(object, point) {
    return containsPoint(object.coordinates, point);
  },
  MultiPoint: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
    return false;
  },
  LineString: function(object, point) {
    return containsLine(object.coordinates, point);
  },
  MultiLineString: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsLine(coordinates[i], point)) return true;
    return false;
  },
  Polygon: function(object, point) {
    return containsPolygon(object.coordinates, point);
  },
  MultiPolygon: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
    return false;
  },
  GeometryCollection: function(object, point) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
    return false;
  }
};

function containsGeometry(geometry, point) {
  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
      ? containsGeometryType[geometry.type](geometry, point)
      : false;
}

function containsPoint(coordinates, point) {
  return distance(coordinates, point) === 0;
}

function containsLine(coordinates, point) {
  var ab = distance(coordinates[0], coordinates[1]),
      ao = distance(coordinates[0], point),
      ob = distance(point, coordinates[1]);
  return ao + ob <= ab + epsilon$2;
}

function containsPolygon(coordinates, point) {
  return !!polygonContains(coordinates.map(ringRadians), pointRadians(point));
}

function ringRadians(ring) {
  return ring = ring.map(pointRadians), ring.pop(), ring;
}

function pointRadians(point) {
  return [point[0] * radians, point[1] * radians];
}

var contains = function(object, point) {
  return (object && containsObjectType.hasOwnProperty(object.type)
      ? containsObjectType[object.type]
      : containsGeometry)(object, point);
};

function graticuleX(y0, y1, dy) {
  var y = sequence(y0, y1 - epsilon$2, dy).concat(y1);
  return function(x) { return y.map(function(y) { return [x, y]; }); };
}

function graticuleY(x0, x1, dx) {
  var x = sequence(x0, x1 - epsilon$2, dx).concat(x1);
  return function(y) { return x.map(function(x) { return [x, y]; }); };
}

function graticule() {
  var x1, x0, X1, X0,
      y1, y0, Y1, Y0,
      dx = 10, dy = dx, DX = 90, DY = 360,
      x, y, X, Y,
      precision = 2.5;

  function graticule() {
    return {type: "MultiLineString", coordinates: lines()};
  }

  function lines() {
    return sequence(ceil(X0 / DX) * DX, X1, DX).map(X)
        .concat(sequence(ceil(Y0 / DY) * DY, Y1, DY).map(Y))
        .concat(sequence(ceil(x0 / dx) * dx, x1, dx).filter(function(x) { return abs(x % DX) > epsilon$2; }).map(x))
        .concat(sequence(ceil(y0 / dy) * dy, y1, dy).filter(function(y) { return abs(y % DY) > epsilon$2; }).map(y));
  }

  graticule.lines = function() {
    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
  };

  graticule.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        X(X0).concat(
        Y(Y1).slice(1),
        X(X1).reverse().slice(1),
        Y(Y0).reverse().slice(1))
      ]
    };
  };

  graticule.extent = function(_) {
    if (!arguments.length) return graticule.extentMinor();
    return graticule.extentMajor(_).extentMinor(_);
  };

  graticule.extentMajor = function(_) {
    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
    X0 = +_[0][0], X1 = +_[1][0];
    Y0 = +_[0][1], Y1 = +_[1][1];
    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
    return graticule.precision(precision);
  };

  graticule.extentMinor = function(_) {
    if (!arguments.length) return [[x0, y0], [x1, y1]];
    x0 = +_[0][0], x1 = +_[1][0];
    y0 = +_[0][1], y1 = +_[1][1];
    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
    return graticule.precision(precision);
  };

  graticule.step = function(_) {
    if (!arguments.length) return graticule.stepMinor();
    return graticule.stepMajor(_).stepMinor(_);
  };

  graticule.stepMajor = function(_) {
    if (!arguments.length) return [DX, DY];
    DX = +_[0], DY = +_[1];
    return graticule;
  };

  graticule.stepMinor = function(_) {
    if (!arguments.length) return [dx, dy];
    dx = +_[0], dy = +_[1];
    return graticule;
  };

  graticule.precision = function(_) {
    if (!arguments.length) return precision;
    precision = +_;
    x = graticuleX(y0, y1, 90);
    y = graticuleY(x0, x1, precision);
    X = graticuleX(Y0, Y1, 90);
    Y = graticuleY(X0, X1, precision);
    return graticule;
  };

  return graticule
      .extentMajor([[-180, -90 + epsilon$2], [180, 90 - epsilon$2]])
      .extentMinor([[-180, -80 - epsilon$2], [180, 80 + epsilon$2]]);
}

function graticule10() {
  return graticule()();
}

var interpolate$1 = function(a, b) {
  var x0 = a[0] * radians,
      y0 = a[1] * radians,
      x1 = b[0] * radians,
      y1 = b[1] * radians,
      cy0 = cos$1(y0),
      sy0 = sin$1(y0),
      cy1 = cos$1(y1),
      sy1 = sin$1(y1),
      kx0 = cy0 * cos$1(x0),
      ky0 = cy0 * sin$1(x0),
      kx1 = cy1 * cos$1(x1),
      ky1 = cy1 * sin$1(x1),
      d = 2 * asin(sqrt(haversin(y1 - y0) + cy0 * cy1 * haversin(x1 - x0))),
      k = sin$1(d);

  var interpolate = d ? function(t) {
    var B = sin$1(t *= d) / k,
        A = sin$1(d - t) / k,
        x = A * kx0 + B * kx1,
        y = A * ky0 + B * ky1,
        z = A * sy0 + B * sy1;
    return [
      atan2(y, x) * degrees$1,
      atan2(z, sqrt(x * x + y * y)) * degrees$1
    ];
  } : function() {
    return [x0 * degrees$1, y0 * degrees$1];
  };

  interpolate.distance = d;

  return interpolate;
};

var identity$4 = function(x) {
  return x;
};

var areaSum$1 = adder();
var areaRingSum$1 = adder();
var x00;
var y00;
var x0$1;
var y0$1;

var areaStream$1 = {
  point: noop$1,
  lineStart: noop$1,
  lineEnd: noop$1,
  polygonStart: function() {
    areaStream$1.lineStart = areaRingStart$1;
    areaStream$1.lineEnd = areaRingEnd$1;
  },
  polygonEnd: function() {
    areaStream$1.lineStart = areaStream$1.lineEnd = areaStream$1.point = noop$1;
    areaSum$1.add(abs(areaRingSum$1));
    areaRingSum$1.reset();
  },
  result: function() {
    var area = areaSum$1 / 2;
    areaSum$1.reset();
    return area;
  }
};

function areaRingStart$1() {
  areaStream$1.point = areaPointFirst$1;
}

function areaPointFirst$1(x, y) {
  areaStream$1.point = areaPoint$1;
  x00 = x0$1 = x, y00 = y0$1 = y;
}

function areaPoint$1(x, y) {
  areaRingSum$1.add(y0$1 * x - x0$1 * y);
  x0$1 = x, y0$1 = y;
}

function areaRingEnd$1() {
  areaPoint$1(x00, y00);
}

var x0$2 = Infinity;
var y0$2 = x0$2;
var x1 = -x0$2;
var y1 = x1;

var boundsStream$1 = {
  point: boundsPoint$1,
  lineStart: noop$1,
  lineEnd: noop$1,
  polygonStart: noop$1,
  polygonEnd: noop$1,
  result: function() {
    var bounds = [[x0$2, y0$2], [x1, y1]];
    x1 = y1 = -(y0$2 = x0$2 = Infinity);
    return bounds;
  }
};

function boundsPoint$1(x, y) {
  if (x < x0$2) x0$2 = x;
  if (x > x1) x1 = x;
  if (y < y0$2) y0$2 = y;
  if (y > y1) y1 = y;
}

// TODO Enforce positive area for exterior, negative area for interior?

var X0$1 = 0;
var Y0$1 = 0;
var Z0$1 = 0;
var X1$1 = 0;
var Y1$1 = 0;
var Z1$1 = 0;
var X2$1 = 0;
var Y2$1 = 0;
var Z2$1 = 0;
var x00$1;
var y00$1;
var x0$3;
var y0$3;

var centroidStream$1 = {
  point: centroidPoint$1,
  lineStart: centroidLineStart$1,
  lineEnd: centroidLineEnd$1,
  polygonStart: function() {
    centroidStream$1.lineStart = centroidRingStart$1;
    centroidStream$1.lineEnd = centroidRingEnd$1;
  },
  polygonEnd: function() {
    centroidStream$1.point = centroidPoint$1;
    centroidStream$1.lineStart = centroidLineStart$1;
    centroidStream$1.lineEnd = centroidLineEnd$1;
  },
  result: function() {
    var centroid = Z2$1 ? [X2$1 / Z2$1, Y2$1 / Z2$1]
        : Z1$1 ? [X1$1 / Z1$1, Y1$1 / Z1$1]
        : Z0$1 ? [X0$1 / Z0$1, Y0$1 / Z0$1]
        : [NaN, NaN];
    X0$1 = Y0$1 = Z0$1 =
    X1$1 = Y1$1 = Z1$1 =
    X2$1 = Y2$1 = Z2$1 = 0;
    return centroid;
  }
};

function centroidPoint$1(x, y) {
  X0$1 += x;
  Y0$1 += y;
  ++Z0$1;
}

function centroidLineStart$1() {
  centroidStream$1.point = centroidPointFirstLine;
}

function centroidPointFirstLine(x, y) {
  centroidStream$1.point = centroidPointLine;
  centroidPoint$1(x0$3 = x, y0$3 = y);
}

function centroidPointLine(x, y) {
  var dx = x - x0$3, dy = y - y0$3, z = sqrt(dx * dx + dy * dy);
  X1$1 += z * (x0$3 + x) / 2;
  Y1$1 += z * (y0$3 + y) / 2;
  Z1$1 += z;
  centroidPoint$1(x0$3 = x, y0$3 = y);
}

function centroidLineEnd$1() {
  centroidStream$1.point = centroidPoint$1;
}

function centroidRingStart$1() {
  centroidStream$1.point = centroidPointFirstRing;
}

function centroidRingEnd$1() {
  centroidPointRing(x00$1, y00$1);
}

function centroidPointFirstRing(x, y) {
  centroidStream$1.point = centroidPointRing;
  centroidPoint$1(x00$1 = x0$3 = x, y00$1 = y0$3 = y);
}

function centroidPointRing(x, y) {
  var dx = x - x0$3,
      dy = y - y0$3,
      z = sqrt(dx * dx + dy * dy);

  X1$1 += z * (x0$3 + x) / 2;
  Y1$1 += z * (y0$3 + y) / 2;
  Z1$1 += z;

  z = y0$3 * x - x0$3 * y;
  X2$1 += z * (x0$3 + x);
  Y2$1 += z * (y0$3 + y);
  Z2$1 += z * 3;
  centroidPoint$1(x0$3 = x, y0$3 = y);
}

function PathContext(context) {
  this._context = context;
}

PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function(_) {
    return this._radius = _, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._context.closePath();
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(x, y);
        this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(x, y);
        break;
      }
      default: {
        this._context.moveTo(x + this._radius, y);
        this._context.arc(x, y, this._radius, 0, tau$3);
        break;
      }
    }
  },
  result: noop$1
};

var lengthSum$1 = adder();
var lengthRing;
var x00$2;
var y00$2;
var x0$4;
var y0$4;

var lengthStream$1 = {
  point: noop$1,
  lineStart: function() {
    lengthStream$1.point = lengthPointFirst$1;
  },
  lineEnd: function() {
    if (lengthRing) lengthPoint$1(x00$2, y00$2);
    lengthStream$1.point = noop$1;
  },
  polygonStart: function() {
    lengthRing = true;
  },
  polygonEnd: function() {
    lengthRing = null;
  },
  result: function() {
    var length = +lengthSum$1;
    lengthSum$1.reset();
    return length;
  }
};

function lengthPointFirst$1(x, y) {
  lengthStream$1.point = lengthPoint$1;
  x00$2 = x0$4 = x, y00$2 = y0$4 = y;
}

function lengthPoint$1(x, y) {
  x0$4 -= x, y0$4 -= y;
  lengthSum$1.add(sqrt(x0$4 * x0$4 + y0$4 * y0$4));
  x0$4 = x, y0$4 = y;
}

function PathString() {
  this._string = [];
}

PathString.prototype = {
  _radius: 4.5,
  _circle: circle$1(4.5),
  pointRadius: function(_) {
    if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
    return this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._string.push("Z");
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._string.push("M", x, ",", y);
        this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", x, ",", y);
        break;
      }
      default: {
        if (this._circle == null) this._circle = circle$1(this._radius);
        this._string.push("M", x, ",", y, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var result = this._string.join("");
      this._string = [];
      return result;
    } else {
      return null;
    }
  }
};

function circle$1(radius) {
  return "m0," + radius
      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
      + "z";
}

var index$1 = function(projection, context) {
  var pointRadius = 4.5,
      projectionStream,
      contextStream;

  function path(object) {
    if (object) {
      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
      geoStream(object, projectionStream(contextStream));
    }
    return contextStream.result();
  }

  path.area = function(object) {
    geoStream(object, projectionStream(areaStream$1));
    return areaStream$1.result();
  };

  path.measure = function(object) {
    geoStream(object, projectionStream(lengthStream$1));
    return lengthStream$1.result();
  };

  path.bounds = function(object) {
    geoStream(object, projectionStream(boundsStream$1));
    return boundsStream$1.result();
  };

  path.centroid = function(object) {
    geoStream(object, projectionStream(centroidStream$1));
    return centroidStream$1.result();
  };

  path.projection = function(_) {
    return arguments.length ? (projectionStream = _ == null ? (projection = null, identity$4) : (projection = _).stream, path) : projection;
  };

  path.context = function(_) {
    if (!arguments.length) return context;
    contextStream = _ == null ? (context = null, new PathString) : new PathContext(context = _);
    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
    return path;
  };

  path.pointRadius = function(_) {
    if (!arguments.length) return pointRadius;
    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
    return path;
  };

  return path.projection(projection).context(context);
};

var clip = function(pointVisible, clipLine, interpolate, start) {
  return function(rotate, sink) {
    var line = clipLine(sink),
        rotatedStart = rotate.invert(start[0], start[1]),
        ringBuffer = clipBuffer(),
        ringSink = clipLine(ringBuffer),
        polygonStarted = false,
        polygon,
        segments,
        ring;

    var clip = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        clip.point = pointRing;
        clip.lineStart = ringStart;
        clip.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function() {
        clip.point = point;
        clip.lineStart = lineStart;
        clip.lineEnd = lineEnd;
        segments = merge(segments);
        var startInside = polygonContains(polygon, rotatedStart);
        if (segments.length) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          clipPolygon(segments, compareIntersection, startInside, interpolate, sink);
        } else if (startInside) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function() {
        sink.polygonStart();
        sink.lineStart();
        interpolate(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };

    function point(lambda, phi) {
      var point = rotate(lambda, phi);
      if (pointVisible(lambda = point[0], phi = point[1])) sink.point(lambda, phi);
    }

    function pointLine(lambda, phi) {
      var point = rotate(lambda, phi);
      line.point(point[0], point[1]);
    }

    function lineStart() {
      clip.point = pointLine;
      line.lineStart();
    }

    function lineEnd() {
      clip.point = point;
      line.lineEnd();
    }

    function pointRing(lambda, phi) {
      ring.push([lambda, phi]);
      var point = rotate(lambda, phi);
      ringSink.point(point[0], point[1]);
    }

    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }

    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();

      var clean = ringSink.clean(),
          ringSegments = ringBuffer.result(),
          i, n = ringSegments.length, m,
          segment,
          point;

      ring.pop();
      polygon.push(ring);
      ring = null;

      if (!n) return;

      // No intersections.
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m = segment.length - 1) > 0) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
          sink.lineEnd();
        }
        return;
      }

      // Rejoin connected segments.
      // TODO reuse ringBuffer.rejoin()?
      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));

      segments.push(ringSegments.filter(validSegment));
    }

    return clip;
  };
};

function validSegment(segment) {
  return segment.length > 1;
}

// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
  return ((a = a.x)[0] < 0 ? a[1] - halfPi$2 - epsilon$2 : halfPi$2 - a[1])
       - ((b = b.x)[0] < 0 ? b[1] - halfPi$2 - epsilon$2 : halfPi$2 - b[1]);
}

var clipAntimeridian = clip(
  function() { return true; },
  clipAntimeridianLine,
  clipAntimeridianInterpolate,
  [-pi$3, -halfPi$2]
);

// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
  var lambda0 = NaN,
      phi0 = NaN,
      sign0 = NaN,
      clean; // no intersections

  return {
    lineStart: function() {
      stream.lineStart();
      clean = 1;
    },
    point: function(lambda1, phi1) {
      var sign1 = lambda1 > 0 ? pi$3 : -pi$3,
          delta = abs(lambda1 - lambda0);
      if (abs(delta - pi$3) < epsilon$2) { // line crosses a pole
        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi$2 : -halfPi$2);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        stream.point(lambda1, phi0);
        clean = 0;
      } else if (sign0 !== sign1 && delta >= pi$3) { // line crosses antimeridian
        if (abs(lambda0 - sign0) < epsilon$2) lambda0 -= sign0 * epsilon$2; // handle degeneracies
        if (abs(lambda1 - sign1) < epsilon$2) lambda1 -= sign1 * epsilon$2;
        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        clean = 0;
      }
      stream.point(lambda0 = lambda1, phi0 = phi1);
      sign0 = sign1;
    },
    lineEnd: function() {
      stream.lineEnd();
      lambda0 = phi0 = NaN;
    },
    clean: function() {
      return 2 - clean; // if intersections, rejoin first and last segments
    }
  };
}

function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
  var cosPhi0,
      cosPhi1,
      sinLambda0Lambda1 = sin$1(lambda0 - lambda1);
  return abs(sinLambda0Lambda1) > epsilon$2
      ? atan((sin$1(phi0) * (cosPhi1 = cos$1(phi1)) * sin$1(lambda1)
          - sin$1(phi1) * (cosPhi0 = cos$1(phi0)) * sin$1(lambda0))
          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
      : (phi0 + phi1) / 2;
}

function clipAntimeridianInterpolate(from, to, direction, stream) {
  var phi;
  if (from == null) {
    phi = direction * halfPi$2;
    stream.point(-pi$3, phi);
    stream.point(0, phi);
    stream.point(pi$3, phi);
    stream.point(pi$3, 0);
    stream.point(pi$3, -phi);
    stream.point(0, -phi);
    stream.point(-pi$3, -phi);
    stream.point(-pi$3, 0);
    stream.point(-pi$3, phi);
  } else if (abs(from[0] - to[0]) > epsilon$2) {
    var lambda = from[0] < to[0] ? pi$3 : -pi$3;
    phi = direction * lambda / 2;
    stream.point(-lambda, phi);
    stream.point(0, phi);
    stream.point(lambda, phi);
  } else {
    stream.point(to[0], to[1]);
  }
}

var clipCircle = function(radius, delta) {
  var cr = cos$1(radius),
      smallRadius = cr > 0,
      notHemisphere = abs(cr) > epsilon$2; // TODO optimise for this common case

  function interpolate(from, to, direction, stream) {
    circleStream(stream, radius, delta, direction, from, to);
  }

  function visible(lambda, phi) {
    return cos$1(lambda) * cos$1(phi) > cr;
  }

  // Takes a line and cuts into visible segments. Return values used for polygon
  // clipping: 0 - there were intersections or the line was empty; 1 - no
  // intersections 2 - there were intersections, and the first and last segments
  // should be rejoined.
  function clipLine(stream) {
    var point0, // previous point
        c0, // code for previous point
        v0, // visibility of previous point
        v00, // visibility of first point
        clean; // no intersections
    return {
      lineStart: function() {
        v00 = v0 = false;
        clean = 1;
      },
      point: function(lambda, phi) {
        var point1 = [lambda, phi],
            point2,
            v = visible(lambda, phi),
            c = smallRadius
              ? v ? 0 : code(lambda, phi)
              : v ? code(lambda + (lambda < 0 ? pi$3 : -pi$3), phi) : 0;
        if (!point0 && (v00 = v0 = v)) stream.lineStart();
        // Handle degeneracies.
        // TODO ignore if not clipping polygons.
        if (v !== v0) {
          point2 = intersect(point0, point1);
          if (!point2 || pointEqual(point0, point2) || pointEqual(point1, point2)) {
            point1[0] += epsilon$2;
            point1[1] += epsilon$2;
            v = visible(point1[0], point1[1]);
          }
        }
        if (v !== v0) {
          clean = 0;
          if (v) {
            // outside going in
            stream.lineStart();
            point2 = intersect(point1, point0);
            stream.point(point2[0], point2[1]);
          } else {
            // inside going out
            point2 = intersect(point0, point1);
            stream.point(point2[0], point2[1]);
            stream.lineEnd();
          }
          point0 = point2;
        } else if (notHemisphere && point0 && smallRadius ^ v) {
          var t;
          // If the codes for two points are different, or are both zero,
          // and there this segment intersects with the small circle.
          if (!(c & c0) && (t = intersect(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
            }
          }
        }
        if (v && (!point0 || !pointEqual(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v, c0 = c;
      },
      lineEnd: function() {
        if (v0) stream.lineEnd();
        point0 = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return clean | ((v00 && v0) << 1);
      }
    };
  }

  // Intersects the great circle between a and b with the clip circle.
  function intersect(a, b, two) {
    var pa = cartesian(a),
        pb = cartesian(b);

    // We have two planes, n1.p = d1 and n2.p = d2.
    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
    var n1 = [1, 0, 0], // normal
        n2 = cartesianCross(pa, pb),
        n2n2 = cartesianDot(n2, n2),
        n1n2 = n2[0], // cartesianDot(n1, n2),
        determinant = n2n2 - n1n2 * n1n2;

    // Two polar points.
    if (!determinant) return !two && a;

    var c1 =  cr * n2n2 / determinant,
        c2 = -cr * n1n2 / determinant,
        n1xn2 = cartesianCross(n1, n2),
        A = cartesianScale(n1, c1),
        B = cartesianScale(n2, c2);
    cartesianAddInPlace(A, B);

    // Solve |p(t)|^2 = 1.
    var u = n1xn2,
        w = cartesianDot(A, u),
        uu = cartesianDot(u, u),
        t2 = w * w - uu * (cartesianDot(A, A) - 1);

    if (t2 < 0) return;

    var t = sqrt(t2),
        q = cartesianScale(u, (-w - t) / uu);
    cartesianAddInPlace(q, A);
    q = spherical(q);

    if (!two) return q;

    // Two intersection points.
    var lambda0 = a[0],
        lambda1 = b[0],
        phi0 = a[1],
        phi1 = b[1],
        z;

    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;

    var delta = lambda1 - lambda0,
        polar = abs(delta - pi$3) < epsilon$2,
        meridian = polar || delta < epsilon$2;

    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;

    // Check that the first point is between a and b.
    if (meridian
        ? polar
          ? phi0 + phi1 > 0 ^ q[1] < (abs(q[0] - lambda0) < epsilon$2 ? phi0 : phi1)
          : phi0 <= q[1] && q[1] <= phi1
        : delta > pi$3 ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
      var q1 = cartesianScale(u, (-w + t) / uu);
      cartesianAddInPlace(q1, A);
      return [q, spherical(q1)];
    }
  }

  // Generates a 4-bit vector representing the location of a point relative to
  // the small circle's bounding box.
  function code(lambda, phi) {
    var r = smallRadius ? radius : pi$3 - radius,
        code = 0;
    if (lambda < -r) code |= 1; // left
    else if (lambda > r) code |= 2; // right
    if (phi < -r) code |= 4; // below
    else if (phi > r) code |= 8; // above
    return code;
  }

  return clip(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-pi$3, radius - pi$3]);
};

var transform = function(methods) {
  return {
    stream: transformer(methods)
  };
};

function transformer(methods) {
  return function(stream) {
    var s = new TransformStream;
    for (var key in methods) s[key] = methods[key];
    s.stream = stream;
    return s;
  };
}

function TransformStream() {}

TransformStream.prototype = {
  constructor: TransformStream,
  point: function(x, y) { this.stream.point(x, y); },
  sphere: function() { this.stream.sphere(); },
  lineStart: function() { this.stream.lineStart(); },
  lineEnd: function() { this.stream.lineEnd(); },
  polygonStart: function() { this.stream.polygonStart(); },
  polygonEnd: function() { this.stream.polygonEnd(); }
};

function fitExtent(projection, extent, object) {
  var w = extent[1][0] - extent[0][0],
      h = extent[1][1] - extent[0][1],
      clip = projection.clipExtent && projection.clipExtent();

  projection
      .scale(150)
      .translate([0, 0]);

  if (clip != null) projection.clipExtent(null);

  geoStream(object, projection.stream(boundsStream$1));

  var b = boundsStream$1.result(),
      k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
      x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
      y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;

  if (clip != null) projection.clipExtent(clip);

  return projection
      .scale(k * 150)
      .translate([x, y]);
}

function fitSize(projection, size, object) {
  return fitExtent(projection, [[0, 0], size], object);
}

var maxDepth = 16;
var cosMinDistance = cos$1(30 * radians); // cos(minimum angular distance)

var resample = function(project, delta2) {
  return +delta2 ? resample$1(project, delta2) : resampleNone(project);
};

function resampleNone(project) {
  return transformer({
    point: function(x, y) {
      x = project(x, y);
      this.stream.point(x[0], x[1]);
    }
  });
}

function resample$1(project, delta2) {

  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
    var dx = x1 - x0,
        dy = y1 - y0,
        d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a = a0 + a1,
          b = b0 + b1,
          c = c0 + c1,
          m = sqrt(a * a + b * b + c * c),
          phi2 = asin(c /= m),
          lambda2 = abs(abs(c) - 1) < epsilon$2 || abs(lambda0 - lambda1) < epsilon$2 ? (lambda0 + lambda1) / 2 : atan2(b, a),
          p = project(lambda2, phi2),
          x2 = p[0],
          y2 = p[1],
          dx2 = x2 - x0,
          dy2 = y2 - y0,
          dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 // perpendicular projected distance
          || abs((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
        stream.point(x2, y2);
        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
      }
    }
  }
  return function(stream) {
    var lambda00, x00, y00, a00, b00, c00, // first point
        lambda0, x0, y0, a0, b0, c0; // previous point

    var resampleStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
    };

    function point(x, y) {
      x = project(x, y);
      stream.point(x[0], x[1]);
    }

    function lineStart() {
      x0 = NaN;
      resampleStream.point = linePoint;
      stream.lineStart();
    }

    function linePoint(lambda, phi) {
      var c = cartesian([lambda, phi]), p = project(lambda, phi);
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
      stream.point(x0, y0);
    }

    function lineEnd() {
      resampleStream.point = point;
      stream.lineEnd();
    }

    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }

    function ringPoint(lambda, phi) {
      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
      resampleStream.point = linePoint;
    }

    function ringEnd() {
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }

    return resampleStream;
  };
}

var transformRadians = transformer({
  point: function(x, y) {
    this.stream.point(x * radians, y * radians);
  }
});

function projection(project) {
  return projectionMutator(function() { return project; })();
}

function projectionMutator(projectAt) {
  var project,
      k = 150, // scale
      x = 480, y = 250, // translate
      dx, dy, lambda = 0, phi = 0, // center
      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, // rotate
      theta = null, preclip = clipAntimeridian, // clip angle
      x0 = null, y0, x1, y1, postclip = identity$4, // clip extent
      delta2 = 0.5, projectResample = resample(projectTransform, delta2), // precision
      cache,
      cacheStream;

  function projection(point) {
    point = projectRotate(point[0] * radians, point[1] * radians);
    return [point[0] * k + dx, dy - point[1] * k];
  }

  function invert(point) {
    point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
    return point && [point[0] * degrees$1, point[1] * degrees$1];
  }

  function projectTransform(x, y) {
    return x = project(x, y), [x[0] * k + dx, dy - x[1] * k];
  }

  projection.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = transformRadians(preclip(rotate, projectResample(postclip(cacheStream = stream))));
  };

  projection.clipAngle = function(_) {
    return arguments.length ? (preclip = +_ ? clipCircle(theta = _ * radians, 6 * radians) : (theta = null, clipAntimeridian), reset()) : theta * degrees$1;
  };

  projection.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$4) : clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  projection.scale = function(_) {
    return arguments.length ? (k = +_, recenter()) : k;
  };

  projection.translate = function(_) {
    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
  };

  projection.center = function(_) {
    return arguments.length ? (lambda = _[0] % 360 * radians, phi = _[1] % 360 * radians, recenter()) : [lambda * degrees$1, phi * degrees$1];
  };

  projection.rotate = function(_) {
    return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [deltaLambda * degrees$1, deltaPhi * degrees$1, deltaGamma * degrees$1];
  };

  projection.precision = function(_) {
    return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : sqrt(delta2);
  };

  projection.fitExtent = function(extent, object) {
    return fitExtent(projection, extent, object);
  };

  projection.fitSize = function(size, object) {
    return fitSize(projection, size, object);
  };

  function recenter() {
    projectRotate = compose(rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma), project);
    var center = project(lambda, phi);
    dx = x - center[0] * k;
    dy = y + center[1] * k;
    return reset();
  }

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return function() {
    project = projectAt.apply(this, arguments);
    projection.invert = project.invert && invert;
    return recenter();
  };
}

function conicProjection(projectAt) {
  var phi0 = 0,
      phi1 = pi$3 / 3,
      m = projectionMutator(projectAt),
      p = m(phi0, phi1);

  p.parallels = function(_) {
    return arguments.length ? m(phi0 = _[0] * radians, phi1 = _[1] * radians) : [phi0 * degrees$1, phi1 * degrees$1];
  };

  return p;
}

function cylindricalEqualAreaRaw(phi0) {
  var cosPhi0 = cos$1(phi0);

  function forward(lambda, phi) {
    return [lambda * cosPhi0, sin$1(phi) / cosPhi0];
  }

  forward.invert = function(x, y) {
    return [x / cosPhi0, asin(y * cosPhi0)];
  };

  return forward;
}

function conicEqualAreaRaw(y0, y1) {
  var sy0 = sin$1(y0), n = (sy0 + sin$1(y1)) / 2;

  // Are the parallels symmetrical around the Equator?
  if (abs(n) < epsilon$2) return cylindricalEqualAreaRaw(y0);

  var c = 1 + sy0 * (2 * n - sy0), r0 = sqrt(c) / n;

  function project(x, y) {
    var r = sqrt(c - 2 * n * sin$1(y)) / n;
    return [r * sin$1(x *= n), r0 - r * cos$1(x)];
  }

  project.invert = function(x, y) {
    var r0y = r0 - y;
    return [atan2(x, abs(r0y)) / n * sign(r0y), asin((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
  };

  return project;
}

var conicEqualArea = function() {
  return conicProjection(conicEqualAreaRaw)
      .scale(155.424)
      .center([0, 33.6442]);
};

var albers = function() {
  return conicEqualArea()
      .parallels([29.5, 45.5])
      .scale(1070)
      .translate([480, 250])
      .rotate([96, 0])
      .center([-0.6, 38.7]);
};

// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
  var n = streams.length;
  return {
    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
  };
}

// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
var albersUsa = function() {
  var cache,
      cacheStream,
      lower48 = albers(), lower48Point,
      alaska = conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
      hawaii = conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
      point, pointStream = {point: function(x, y) { point = [x, y]; }};

  function albersUsa(coordinates) {
    var x = coordinates[0], y = coordinates[1];
    return point = null,
        (lower48Point.point(x, y), point)
        || (alaskaPoint.point(x, y), point)
        || (hawaiiPoint.point(x, y), point);
  }

  albersUsa.invert = function(coordinates) {
    var k = lower48.scale(),
        t = lower48.translate(),
        x = (coordinates[0] - t[0]) / k,
        y = (coordinates[1] - t[1]) / k;
    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
        : lower48).invert(coordinates);
  };

  albersUsa.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };

  albersUsa.precision = function(_) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
    return reset();
  };

  albersUsa.scale = function(_) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
    return albersUsa.translate(lower48.translate());
  };

  albersUsa.translate = function(_) {
    if (!arguments.length) return lower48.translate();
    var k = lower48.scale(), x = +_[0], y = +_[1];

    lower48Point = lower48
        .translate(_)
        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
        .stream(pointStream);

    alaskaPoint = alaska
        .translate([x - 0.307 * k, y + 0.201 * k])
        .clipExtent([[x - 0.425 * k + epsilon$2, y + 0.120 * k + epsilon$2], [x - 0.214 * k - epsilon$2, y + 0.234 * k - epsilon$2]])
        .stream(pointStream);

    hawaiiPoint = hawaii
        .translate([x - 0.205 * k, y + 0.212 * k])
        .clipExtent([[x - 0.214 * k + epsilon$2, y + 0.166 * k + epsilon$2], [x - 0.115 * k - epsilon$2, y + 0.234 * k - epsilon$2]])
        .stream(pointStream);

    return reset();
  };

  albersUsa.fitExtent = function(extent, object) {
    return fitExtent(albersUsa, extent, object);
  };

  albersUsa.fitSize = function(size, object) {
    return fitSize(albersUsa, size, object);
  };

  function reset() {
    cache = cacheStream = null;
    return albersUsa;
  }

  return albersUsa.scale(1070);
};

function azimuthalRaw(scale) {
  return function(x, y) {
    var cx = cos$1(x),
        cy = cos$1(y),
        k = scale(cx * cy);
    return [
      k * cy * sin$1(x),
      k * sin$1(y)
    ];
  }
}

function azimuthalInvert(angle) {
  return function(x, y) {
    var z = sqrt(x * x + y * y),
        c = angle(z),
        sc = sin$1(c),
        cc = cos$1(c);
    return [
      atan2(x * sc, z * cc),
      asin(z && y * sc / z)
    ];
  }
}

var azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
  return sqrt(2 / (1 + cxcy));
});

azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z) {
  return 2 * asin(z / 2);
});

var azimuthalEqualArea = function() {
  return projection(azimuthalEqualAreaRaw)
      .scale(124.75)
      .clipAngle(180 - 1e-3);
};

var azimuthalEquidistantRaw = azimuthalRaw(function(c) {
  return (c = acos(c)) && c / sin$1(c);
});

azimuthalEquidistantRaw.invert = azimuthalInvert(function(z) {
  return z;
});

var azimuthalEquidistant = function() {
  return projection(azimuthalEquidistantRaw)
      .scale(79.4188)
      .clipAngle(180 - 1e-3);
};

function mercatorRaw(lambda, phi) {
  return [lambda, log(tan((halfPi$2 + phi) / 2))];
}

mercatorRaw.invert = function(x, y) {
  return [x, 2 * atan(exp(y)) - halfPi$2];
};

var mercator = function() {
  return mercatorProjection(mercatorRaw)
      .scale(961 / tau$3);
};

function mercatorProjection(project) {
  var m = projection(project),
      center = m.center,
      scale = m.scale,
      translate = m.translate,
      clipExtent = m.clipExtent,
      x0 = null, y0, x1, y1; // clip extent

  m.scale = function(_) {
    return arguments.length ? (scale(_), reclip()) : scale();
  };

  m.translate = function(_) {
    return arguments.length ? (translate(_), reclip()) : translate();
  };

  m.center = function(_) {
    return arguments.length ? (center(_), reclip()) : center();
  };

  m.clipExtent = function(_) {
    return arguments.length ? ((_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1])), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  function reclip() {
    var k = pi$3 * scale(),
        t = m(rotation(m.rotate()).invert([0, 0]));
    return clipExtent(x0 == null
        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
  }

  return reclip();
}

function tany(y) {
  return tan((halfPi$2 + y) / 2);
}

function conicConformalRaw(y0, y1) {
  var cy0 = cos$1(y0),
      n = y0 === y1 ? sin$1(y0) : log(cy0 / cos$1(y1)) / log(tany(y1) / tany(y0)),
      f = cy0 * pow(tany(y0), n) / n;

  if (!n) return mercatorRaw;

  function project(x, y) {
    if (f > 0) { if (y < -halfPi$2 + epsilon$2) y = -halfPi$2 + epsilon$2; }
    else { if (y > halfPi$2 - epsilon$2) y = halfPi$2 - epsilon$2; }
    var r = f / pow(tany(y), n);
    return [r * sin$1(n * x), f - r * cos$1(n * x)];
  }

  project.invert = function(x, y) {
    var fy = f - y, r = sign(n) * sqrt(x * x + fy * fy);
    return [atan2(x, abs(fy)) / n * sign(fy), 2 * atan(pow(f / r, 1 / n)) - halfPi$2];
  };

  return project;
}

var conicConformal = function() {
  return conicProjection(conicConformalRaw)
      .scale(109.5)
      .parallels([30, 30]);
};

function equirectangularRaw(lambda, phi) {
  return [lambda, phi];
}

equirectangularRaw.invert = equirectangularRaw;

var equirectangular = function() {
  return projection(equirectangularRaw)
      .scale(152.63);
};

function conicEquidistantRaw(y0, y1) {
  var cy0 = cos$1(y0),
      n = y0 === y1 ? sin$1(y0) : (cy0 - cos$1(y1)) / (y1 - y0),
      g = cy0 / n + y0;

  if (abs(n) < epsilon$2) return equirectangularRaw;

  function project(x, y) {
    var gy = g - y, nx = n * x;
    return [gy * sin$1(nx), g - gy * cos$1(nx)];
  }

  project.invert = function(x, y) {
    var gy = g - y;
    return [atan2(x, abs(gy)) / n * sign(gy), g - sign(n) * sqrt(x * x + gy * gy)];
  };

  return project;
}

var conicEquidistant = function() {
  return conicProjection(conicEquidistantRaw)
      .scale(131.154)
      .center([0, 13.9389]);
};

function gnomonicRaw(x, y) {
  var cy = cos$1(y), k = cos$1(x) * cy;
  return [cy * sin$1(x) / k, sin$1(y) / k];
}

gnomonicRaw.invert = azimuthalInvert(atan);

var gnomonic = function() {
  return projection(gnomonicRaw)
      .scale(144.049)
      .clipAngle(60);
};

function scaleTranslate(kx, ky, tx, ty) {
  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? identity$4 : transformer({
    point: function(x, y) {
      this.stream.point(x * kx + tx, y * ky + ty);
    }
  });
}

var identity$5 = function() {
  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform$$1 = identity$4, // scale, translate and reflect
      x0 = null, y0, x1, y1, clip = identity$4, // clip extent
      cache,
      cacheStream,
      projection;

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return projection = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = transform$$1(clip(cacheStream = stream));
    },
    clipExtent: function(_) {
      return arguments.length ? (clip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$4) : clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
    },
    scale: function(_) {
      return arguments.length ? (transform$$1 = scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
    },
    translate: function(_) {
      return arguments.length ? (transform$$1 = scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
    },
    reflectX: function(_) {
      return arguments.length ? (transform$$1 = scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
    },
    reflectY: function(_) {
      return arguments.length ? (transform$$1 = scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
    },
    fitExtent: function(extent, object) {
      return fitExtent(projection, extent, object);
    },
    fitSize: function(size, object) {
      return fitSize(projection, size, object);
    }
  };
};

function orthographicRaw(x, y) {
  return [cos$1(y) * sin$1(x), sin$1(y)];
}

orthographicRaw.invert = azimuthalInvert(asin);

var orthographic = function() {
  return projection(orthographicRaw)
      .scale(249.5)
      .clipAngle(90 + epsilon$2);
};

function stereographicRaw(x, y) {
  var cy = cos$1(y), k = 1 + cos$1(x) * cy;
  return [cy * sin$1(x) / k, sin$1(y) / k];
}

stereographicRaw.invert = azimuthalInvert(function(z) {
  return 2 * atan(z);
});

var stereographic = function() {
  return projection(stereographicRaw)
      .scale(250)
      .clipAngle(142);
};

function transverseMercatorRaw(lambda, phi) {
  return [log(tan((halfPi$2 + phi) / 2)), -lambda];
}

transverseMercatorRaw.invert = function(x, y) {
  return [-y, 2 * atan(exp(x)) - halfPi$2];
};

var transverseMercator = function() {
  var m = mercatorProjection(transverseMercatorRaw),
      center = m.center,
      rotate = m.rotate;

  m.center = function(_) {
    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
  };

  m.rotate = function(_) {
    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
  };

  return rotate([0, 0, 90])
      .scale(159.155);
};

function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

function meanX(children) {
  return children.reduce(meanXReduce, 0) / children.length;
}

function meanXReduce(x, c) {
  return x + c.x;
}

function maxY(children) {
  return 1 + children.reduce(maxYReduce, 0);
}

function maxYReduce(y, c) {
  return Math.max(y, c.y);
}

function leafLeft(node) {
  var children;
  while (children = node.children) node = children[0];
  return node;
}

function leafRight(node) {
  var children;
  while (children = node.children) node = children[children.length - 1];
  return node;
}

var cluster = function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = false;

  function cluster(root) {
    var previousNode,
        x = 0;

    // First walk, computing the initial x & y values.
    root.eachAfter(function(node) {
      var children = node.children;
      if (children) {
        node.x = meanX(children);
        node.y = maxY(children);
      } else {
        node.x = previousNode ? x += separation(node, previousNode) : 0;
        node.y = 0;
        previousNode = node;
      }
    });

    var left = leafLeft(root),
        right = leafRight(root),
        x0 = left.x - separation(left, right) / 2,
        x1 = right.x + separation(right, left) / 2;

    // Second walk, normalizing x & y to the desired size.
    return root.eachAfter(nodeSize ? function(node) {
      node.x = (node.x - root.x) * dx;
      node.y = (root.y - node.y) * dy;
    } : function(node) {
      node.x = (node.x - x0) / (x1 - x0) * dx;
      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
    });
  }

  cluster.separation = function(x) {
    return arguments.length ? (separation = x, cluster) : separation;
  };

  cluster.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
  };

  cluster.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
  };

  return cluster;
};

function count(node) {
  var sum = 0,
      children = node.children,
      i = children && children.length;
  if (!i) sum = 1;
  else while (--i >= 0) sum += children[i].value;
  node.value = sum;
}

var node_count = function() {
  return this.eachAfter(count);
};

var node_each = function(callback) {
  var node = this, current, next = [node], children, i, n;
  do {
    current = next.reverse(), next = [];
    while (node = current.pop()) {
      callback(node), children = node.children;
      if (children) for (i = 0, n = children.length; i < n; ++i) {
        next.push(children[i]);
      }
    }
  } while (next.length);
  return this;
};

var node_eachBefore = function(callback) {
  var node = this, nodes = [node], children, i;
  while (node = nodes.pop()) {
    callback(node), children = node.children;
    if (children) for (i = children.length - 1; i >= 0; --i) {
      nodes.push(children[i]);
    }
  }
  return this;
};

var node_eachAfter = function(callback) {
  var node = this, nodes = [node], next = [], children, i, n;
  while (node = nodes.pop()) {
    next.push(node), children = node.children;
    if (children) for (i = 0, n = children.length; i < n; ++i) {
      nodes.push(children[i]);
    }
  }
  while (node = next.pop()) {
    callback(node);
  }
  return this;
};

var node_sum = function(value) {
  return this.eachAfter(function(node) {
    var sum = +value(node.data) || 0,
        children = node.children,
        i = children && children.length;
    while (--i >= 0) sum += children[i].value;
    node.value = sum;
  });
};

var node_sort = function(compare) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
};

var node_path = function(end) {
  var start = this,
      ancestor = leastCommonAncestor(start, end),
      nodes = [start];
  while (start !== ancestor) {
    start = start.parent;
    nodes.push(start);
  }
  var k = nodes.length;
  while (end !== ancestor) {
    nodes.splice(k, 0, end);
    end = end.parent;
  }
  return nodes;
};

function leastCommonAncestor(a, b) {
  if (a === b) return a;
  var aNodes = a.ancestors(),
      bNodes = b.ancestors(),
      c = null;
  a = aNodes.pop();
  b = bNodes.pop();
  while (a === b) {
    c = a;
    a = aNodes.pop();
    b = bNodes.pop();
  }
  return c;
}

var node_ancestors = function() {
  var node = this, nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
};

var node_descendants = function() {
  var nodes = [];
  this.each(function(node) {
    nodes.push(node);
  });
  return nodes;
};

var node_leaves = function() {
  var leaves = [];
  this.eachBefore(function(node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
};

var node_links = function() {
  var root = this, links = [];
  root.each(function(node) {
    if (node !== root) { // Don’t include the root’s parent, if any.
      links.push({source: node.parent, target: node});
    }
  });
  return links;
};

function hierarchy(data, children) {
  var root = new Node(data),
      valued = +data.value && (root.value = data.value),
      node,
      nodes = [root],
      child,
      childs,
      i,
      n;

  if (children == null) children = defaultChildren;

  while (node = nodes.pop()) {
    if (valued) node.value = +node.data.value;
    if ((childs = children(node.data)) && (n = childs.length)) {
      node.children = new Array(n);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new Node(childs[i]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }

  return root.eachBefore(computeHeight);
}

function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}

function defaultChildren(d) {
  return d.children;
}

function copyData(node) {
  node.data = node.data.data;
}

function computeHeight(node) {
  var height = 0;
  do node.height = height;
  while ((node = node.parent) && (node.height < ++height));
}

function Node(data) {
  this.data = data;
  this.depth =
  this.height = 0;
  this.parent = null;
}

Node.prototype = hierarchy.prototype = {
  constructor: Node,
  count: node_count,
  each: node_each,
  eachAfter: node_eachAfter,
  eachBefore: node_eachBefore,
  sum: node_sum,
  sort: node_sort,
  path: node_path,
  ancestors: node_ancestors,
  descendants: node_descendants,
  leaves: node_leaves,
  links: node_links,
  copy: node_copy
};

var slice$3 = Array.prototype.slice;

function shuffle$1(array) {
  var m = array.length,
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }

  return array;
}

var enclose = function(circles) {
  var i = 0, n = (circles = shuffle$1(slice$3.call(circles))).length, B = [], p, e;

  while (i < n) {
    p = circles[i];
    if (e && enclosesWeak(e, p)) ++i;
    else e = encloseBasis(B = extendBasis(B, p)), i = 0;
  }

  return e;
};

function extendBasis(B, p) {
  var i, j;

  if (enclosesWeakAll(p, B)) return [p];

  // If we get here then B must have at least one element.
  for (i = 0; i < B.length; ++i) {
    if (enclosesNot(p, B[i])
        && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
      return [B[i], p];
    }
  }

  // If we get here then B must have at least two elements.
  for (i = 0; i < B.length - 1; ++i) {
    for (j = i + 1; j < B.length; ++j) {
      if (enclosesNot(encloseBasis2(B[i], B[j]), p)
          && enclosesNot(encloseBasis2(B[i], p), B[j])
          && enclosesNot(encloseBasis2(B[j], p), B[i])
          && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
        return [B[i], B[j], p];
      }
    }
  }

  // If we get here then something is very wrong.
  throw new Error;
}

function enclosesNot(a, b) {
  var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
  return dr < 0 || dr * dr < dx * dx + dy * dy;
}

function enclosesWeak(a, b) {
  var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}

function enclosesWeakAll(a, B) {
  for (var i = 0; i < B.length; ++i) {
    if (!enclosesWeak(a, B[i])) {
      return false;
    }
  }
  return true;
}

function encloseBasis(B) {
  switch (B.length) {
    case 1: return encloseBasis1(B[0]);
    case 2: return encloseBasis2(B[0], B[1]);
    case 3: return encloseBasis3(B[0], B[1], B[2]);
  }
}

function encloseBasis1(a) {
  return {
    x: a.x,
    y: a.y,
    r: a.r
  };
}

function encloseBasis2(a, b) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
      l = Math.sqrt(x21 * x21 + y21 * y21);
  return {
    x: (x1 + x2 + x21 / l * r21) / 2,
    y: (y1 + y2 + y21 / l * r21) / 2,
    r: (l + r1 + r2) / 2
  };
}

function encloseBasis3(a, b, c) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x3 = c.x, y3 = c.y, r3 = c.r,
      a2 = x1 - x2,
      a3 = x1 - x3,
      b2 = y1 - y2,
      b3 = y1 - y3,
      c2 = r2 - r1,
      c3 = r3 - r1,
      d1 = x1 * x1 + y1 * y1 - r1 * r1,
      d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
      d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
      ab = a3 * b2 - a2 * b3,
      xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
      xb = (b3 * c2 - b2 * c3) / ab,
      ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
      yb = (a2 * c3 - a3 * c2) / ab,
      A = xb * xb + yb * yb - 1,
      B = 2 * (r1 + xa * xb + ya * yb),
      C = xa * xa + ya * ya - r1 * r1,
      r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
  return {
    x: x1 + xa + xb * r,
    y: y1 + ya + yb * r,
    r: r
  };
}

function place(a, b, c) {
  var ax = a.x,
      ay = a.y,
      da = b.r + c.r,
      db = a.r + c.r,
      dx = b.x - ax,
      dy = b.y - ay,
      dc = dx * dx + dy * dy;
  if (dc) {
    var x = 0.5 + ((db *= db) - (da *= da)) / (2 * dc),
        y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
    c.x = ax + x * dx + y * dy;
    c.y = ay + x * dy - y * dx;
  } else {
    c.x = ax + db;
    c.y = ay;
  }
}

function intersects(a, b) {
  var dx = b.x - a.x,
      dy = b.y - a.y,
      dr = a.r + b.r;
  return dr * dr - 1e-6 > dx * dx + dy * dy;
}

function score(node) {
  var a = node._,
      b = node.next._,
      ab = a.r + b.r,
      dx = (a.x * b.r + b.x * a.r) / ab,
      dy = (a.y * b.r + b.y * a.r) / ab;
  return dx * dx + dy * dy;
}

function Node$1(circle) {
  this._ = circle;
  this.next = null;
  this.previous = null;
}

function packEnclose(circles) {
  if (!(n = circles.length)) return 0;

  var a, b, c, n, aa, ca, i, j, k, sj, sk;

  // Place the first circle.
  a = circles[0], a.x = 0, a.y = 0;
  if (!(n > 1)) return a.r;

  // Place the second circle.
  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
  if (!(n > 2)) return a.r + b.r;

  // Place the third circle.
  place(b, a, c = circles[2]);

  // Initialize the front-chain using the first three circles a, b and c.
  a = new Node$1(a), b = new Node$1(b), c = new Node$1(c);
  a.next = c.previous = b;
  b.next = a.previous = c;
  c.next = b.previous = a;

  // Attempt to place each remaining circle…
  pack: for (i = 3; i < n; ++i) {
    place(a._, b._, c = circles[i]), c = new Node$1(c);

    // Find the closest intersecting circle on the front-chain, if any.
    // “Closeness” is determined by linear distance along the front-chain.
    // “Ahead” or “behind” is likewise determined by linear distance.
    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
    do {
      if (sj <= sk) {
        if (intersects(j._, c._)) {
          b = j, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sj += j._.r, j = j.next;
      } else {
        if (intersects(k._, c._)) {
          a = k, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sk += k._.r, k = k.previous;
      }
    } while (j !== k.next);

    // Success! Insert the new circle c between a and b.
    c.previous = a, c.next = b, a.next = b.previous = b = c;

    // Compute the new closest circle pair to the centroid.
    aa = score(a);
    while ((c = c.next) !== b) {
      if ((ca = score(c)) < aa) {
        a = c, aa = ca;
      }
    }
    b = a.next;
  }

  // Compute the enclosing circle of the front chain.
  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = enclose(a);

  // Translate the circles to put the enclosing circle around the origin.
  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;

  return c.r;
}

var siblings = function(circles) {
  packEnclose(circles);
  return circles;
};

function optional(f) {
  return f == null ? null : required(f);
}

function required(f) {
  if (typeof f !== "function") throw new Error;
  return f;
}

function constantZero() {
  return 0;
}

var constant$8 = function(x) {
  return function() {
    return x;
  };
};

function defaultRadius$1(d) {
  return Math.sqrt(d.value);
}

var index$2 = function() {
  var radius = null,
      dx = 1,
      dy = 1,
      padding = constantZero;

  function pack(root) {
    root.x = dx / 2, root.y = dy / 2;
    if (radius) {
      root.eachBefore(radiusLeaf(radius))
          .eachAfter(packChildren(padding, 0.5))
          .eachBefore(translateChild(1));
    } else {
      root.eachBefore(radiusLeaf(defaultRadius$1))
          .eachAfter(packChildren(constantZero, 1))
          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
    }
    return root;
  }

  pack.radius = function(x) {
    return arguments.length ? (radius = optional(x), pack) : radius;
  };

  pack.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
  };

  pack.padding = function(x) {
    return arguments.length ? (padding = typeof x === "function" ? x : constant$8(+x), pack) : padding;
  };

  return pack;
};

function radiusLeaf(radius) {
  return function(node) {
    if (!node.children) {
      node.r = Math.max(0, +radius(node) || 0);
    }
  };
}

function packChildren(padding, k) {
  return function(node) {
    if (children = node.children) {
      var children,
          i,
          n = children.length,
          r = padding(node) * k || 0,
          e;

      if (r) for (i = 0; i < n; ++i) children[i].r += r;
      e = packEnclose(children);
      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
      node.r = e + r;
    }
  };
}

function translateChild(k) {
  return function(node) {
    var parent = node.parent;
    node.r *= k;
    if (parent) {
      node.x = parent.x + k * node.x;
      node.y = parent.y + k * node.y;
    }
  };
}

var roundNode = function(node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
};

var treemapDice = function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (x1 - x0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k;
  }
};

var partition = function() {
  var dx = 1,
      dy = 1,
      padding = 0,
      round = false;

  function partition(root) {
    var n = root.height + 1;
    root.x0 =
    root.y0 = padding;
    root.x1 = dx;
    root.y1 = dy / n;
    root.eachBefore(positionNode(dy, n));
    if (round) root.eachBefore(roundNode);
    return root;
  }

  function positionNode(dy, n) {
    return function(node) {
      if (node.children) {
        treemapDice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
      }
      var x0 = node.x0,
          y0 = node.y0,
          x1 = node.x1 - padding,
          y1 = node.y1 - padding;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      node.x0 = x0;
      node.y0 = y0;
      node.x1 = x1;
      node.y1 = y1;
    };
  }

  partition.round = function(x) {
    return arguments.length ? (round = !!x, partition) : round;
  };

  partition.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
  };

  partition.padding = function(x) {
    return arguments.length ? (padding = +x, partition) : padding;
  };

  return partition;
};

var keyPrefix$1 = "$";
var preroot = {depth: -1};
var ambiguous = {};

function defaultId(d) {
  return d.id;
}

function defaultParentId(d) {
  return d.parentId;
}

var stratify = function() {
  var id = defaultId,
      parentId = defaultParentId;

  function stratify(data) {
    var d,
        i,
        n = data.length,
        root,
        parent,
        node,
        nodes = new Array(n),
        nodeId,
        nodeKey,
        nodeByKey = {};

    for (i = 0; i < n; ++i) {
      d = data[i], node = nodes[i] = new Node(d);
      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
        nodeKey = keyPrefix$1 + (node.id = nodeId);
        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
      }
    }

    for (i = 0; i < n; ++i) {
      node = nodes[i], nodeId = parentId(data[i], i, data);
      if (nodeId == null || !(nodeId += "")) {
        if (root) throw new Error("multiple roots");
        root = node;
      } else {
        parent = nodeByKey[keyPrefix$1 + nodeId];
        if (!parent) throw new Error("missing: " + nodeId);
        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
        if (parent.children) parent.children.push(node);
        else parent.children = [node];
        node.parent = parent;
      }
    }

    if (!root) throw new Error("no root");
    root.parent = preroot;
    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(computeHeight);
    root.parent = null;
    if (n > 0) throw new Error("cycle");

    return root;
  }

  stratify.id = function(x) {
    return arguments.length ? (id = required(x), stratify) : id;
  };

  stratify.parentId = function(x) {
    return arguments.length ? (parentId = required(x), stratify) : parentId;
  };

  return stratify;
};

function defaultSeparation$1(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }

// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
  var children = v.children;
  return children ? children[0] : v.t;
}

// This function works analogously to nextLeft.
function nextRight(v) {
  var children = v.children;
  return children ? children[children.length - 1] : v.t;
}

// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
  var change = shift / (wp.i - wm.i);
  wp.c -= change;
  wp.s += shift;
  wm.c += change;
  wp.z += shift;
  wp.m += shift;
}

// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
  var shift = 0,
      change = 0,
      children = v.children,
      i = children.length,
      w;
  while (--i >= 0) {
    w = children[i];
    w.z += shift;
    w.m += shift;
    shift += w.s + (change += w.c);
  }
}

// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
  return vim.a.parent === v.parent ? vim.a : ancestor;
}

function TreeNode(node, i) {
  this._ = node;
  this.parent = null;
  this.children = null;
  this.A = null; // default ancestor
  this.a = this; // ancestor
  this.z = 0; // prelim
  this.m = 0; // mod
  this.c = 0; // change
  this.s = 0; // shift
  this.t = null; // thread
  this.i = i; // number
}

TreeNode.prototype = Object.create(Node.prototype);

function treeRoot(root) {
  var tree = new TreeNode(root, 0),
      node,
      nodes = [tree],
      child,
      children,
      i,
      n;

  while (node = nodes.pop()) {
    if (children = node._.children) {
      node.children = new Array(n = children.length);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
        child.parent = node;
      }
    }
  }

  (tree.parent = new TreeNode(null, 0)).children = [tree];
  return tree;
}

// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
var tree = function() {
  var separation = defaultSeparation$1,
      dx = 1,
      dy = 1,
      nodeSize = null;

  function tree(root) {
    var t = treeRoot(root);

    // Compute the layout using Buchheim et al.’s algorithm.
    t.eachAfter(firstWalk), t.parent.m = -t.z;
    t.eachBefore(secondWalk);

    // If a fixed node size is specified, scale x and y.
    if (nodeSize) root.eachBefore(sizeNode);

    // If a fixed tree size is specified, scale x and y based on the extent.
    // Compute the left-most, right-most, and depth-most nodes for extents.
    else {
      var left = root,
          right = root,
          bottom = root;
      root.eachBefore(function(node) {
        if (node.x < left.x) left = node;
        if (node.x > right.x) right = node;
        if (node.depth > bottom.depth) bottom = node;
      });
      var s = left === right ? 1 : separation(left, right) / 2,
          tx = s - left.x,
          kx = dx / (right.x + s + tx),
          ky = dy / (bottom.depth || 1);
      root.eachBefore(function(node) {
        node.x = (node.x + tx) * kx;
        node.y = node.depth * ky;
      });
    }

    return root;
  }

  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
  // applied recursively to the children of v, as well as the function
  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
  // node v is placed to the midpoint of its outermost children.
  function firstWalk(v) {
    var children = v.children,
        siblings = v.parent.children,
        w = v.i ? siblings[v.i - 1] : null;
    if (children) {
      executeShifts(v);
      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
      if (w) {
        v.z = w.z + separation(v._, w._);
        v.m = v.z - midpoint;
      } else {
        v.z = midpoint;
      }
    } else if (w) {
      v.z = w.z + separation(v._, w._);
    }
    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
  }

  // Computes all real x-coordinates by summing up the modifiers recursively.
  function secondWalk(v) {
    v._.x = v.z + v.parent.m;
    v.m += v.parent.m;
  }

  // The core of the algorithm. Here, a new subtree is combined with the
  // previous subtrees. Threads are used to traverse the inside and outside
  // contours of the left and right subtree up to the highest common level. The
  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
  // superscript o means outside and i means inside, the subscript - means left
  // subtree and + means right subtree. For summing up the modifiers along the
  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
  // nodes of the inside contours conflict, we compute the left one of the
  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
  // Finally, we add a new thread (if necessary).
  function apportion(v, w, ancestor) {
    if (w) {
      var vip = v,
          vop = v,
          vim = w,
          vom = vip.parent.children[0],
          sip = vip.m,
          sop = vop.m,
          sim = vim.m,
          som = vom.m,
          shift;
      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
        vom = nextLeft(vom);
        vop = nextRight(vop);
        vop.a = v;
        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
        if (shift > 0) {
          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
          sip += shift;
          sop += shift;
        }
        sim += vim.m;
        sip += vip.m;
        som += vom.m;
        sop += vop.m;
      }
      if (vim && !nextRight(vop)) {
        vop.t = vim;
        vop.m += sim - sop;
      }
      if (vip && !nextLeft(vom)) {
        vom.t = vip;
        vom.m += sip - som;
        ancestor = v;
      }
    }
    return ancestor;
  }

  function sizeNode(node) {
    node.x *= dx;
    node.y = node.depth * dy;
  }

  tree.separation = function(x) {
    return arguments.length ? (separation = x, tree) : separation;
  };

  tree.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
  };

  tree.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
  };

  return tree;
};

var treemapSlice = function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (y1 - y0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k;
  }
};

var phi = (1 + Math.sqrt(5)) / 2;

function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [],
      nodes = parent.children,
      row,
      nodeValue,
      i0 = 0,
      i1 = 0,
      n = nodes.length,
      dx, dy,
      value = parent.value,
      sumValue,
      minValue,
      maxValue,
      newRatio,
      minRatio,
      alpha,
      beta;

  while (i0 < n) {
    dx = x1 - x0, dy = y1 - y0;

    // Find the next non-empty node.
    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);

    // Keep adding nodes while the aspect ratio maintains or improves.
    for (; i1 < n; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
      minRatio = newRatio;
    }

    // Position and record the row orientation.
    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
    if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
    else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }

  return rows;
}

var squarify = (function custom(ratio) {

  function squarify(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }

  squarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return squarify;
})(phi);

var index$3 = function() {
  var tile = squarify,
      round = false,
      dx = 1,
      dy = 1,
      paddingStack = [0],
      paddingInner = constantZero,
      paddingTop = constantZero,
      paddingRight = constantZero,
      paddingBottom = constantZero,
      paddingLeft = constantZero;

  function treemap(root) {
    root.x0 =
    root.y0 = 0;
    root.x1 = dx;
    root.y1 = dy;
    root.eachBefore(positionNode);
    paddingStack = [0];
    if (round) root.eachBefore(roundNode);
    return root;
  }

  function positionNode(node) {
    var p = paddingStack[node.depth],
        x0 = node.x0 + p,
        y0 = node.y0 + p,
        x1 = node.x1 - p,
        y1 = node.y1 - p;
    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
    node.x0 = x0;
    node.y0 = y0;
    node.x1 = x1;
    node.y1 = y1;
    if (node.children) {
      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
      x0 += paddingLeft(node) - p;
      y0 += paddingTop(node) - p;
      x1 -= paddingRight(node) - p;
      y1 -= paddingBottom(node) - p;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      tile(node, x0, y0, x1, y1);
    }
  }

  treemap.round = function(x) {
    return arguments.length ? (round = !!x, treemap) : round;
  };

  treemap.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
  };

  treemap.tile = function(x) {
    return arguments.length ? (tile = required(x), treemap) : tile;
  };

  treemap.padding = function(x) {
    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
  };

  treemap.paddingInner = function(x) {
    return arguments.length ? (paddingInner = typeof x === "function" ? x : constant$8(+x), treemap) : paddingInner;
  };

  treemap.paddingOuter = function(x) {
    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
  };

  treemap.paddingTop = function(x) {
    return arguments.length ? (paddingTop = typeof x === "function" ? x : constant$8(+x), treemap) : paddingTop;
  };

  treemap.paddingRight = function(x) {
    return arguments.length ? (paddingRight = typeof x === "function" ? x : constant$8(+x), treemap) : paddingRight;
  };

  treemap.paddingBottom = function(x) {
    return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant$8(+x), treemap) : paddingBottom;
  };

  treemap.paddingLeft = function(x) {
    return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant$8(+x), treemap) : paddingLeft;
  };

  return treemap;
};

var binary = function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      i, n = nodes.length,
      sum, sums = new Array(n + 1);

  for (sums[0] = sum = i = 0; i < n; ++i) {
    sums[i + 1] = sum += nodes[i].value;
  }

  partition(0, n, parent.value, x0, y0, x1, y1);

  function partition(i, j, value, x0, y0, x1, y1) {
    if (i >= j - 1) {
      var node = nodes[i];
      node.x0 = x0, node.y0 = y0;
      node.x1 = x1, node.y1 = y1;
      return;
    }

    var valueOffset = sums[i],
        valueTarget = (value / 2) + valueOffset,
        k = i + 1,
        hi = j - 1;

    while (k < hi) {
      var mid = k + hi >>> 1;
      if (sums[mid] < valueTarget) k = mid + 1;
      else hi = mid;
    }

    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;

    var valueLeft = sums[k] - valueOffset,
        valueRight = value - valueLeft;

    if ((x1 - x0) > (y1 - y0)) {
      var xk = (x0 * valueRight + x1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, xk, y1);
      partition(k, j, valueRight, xk, y0, x1, y1);
    } else {
      var yk = (y0 * valueRight + y1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, x1, yk);
      partition(k, j, valueRight, x0, yk, x1, y1);
    }
  }
};

var sliceDice = function(parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
};

var resquarify = (function custom(ratio) {

  function resquarify(parent, x0, y0, x1, y1) {
    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
      var rows,
          row,
          nodes,
          i,
          j = -1,
          n,
          m = rows.length,
          value = parent.value;

      while (++j < m) {
        row = rows[j], nodes = row.children;
        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
        if (row.dice) treemapDice(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
        else treemapSlice(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
        value -= row.value;
      }
    } else {
      parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
      rows.ratio = ratio;
    }
  }

  resquarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return resquarify;
})(phi);

var area$1 = function(polygon) {
  var i = -1,
      n = polygon.length,
      a,
      b = polygon[n - 1],
      area = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    area += a[1] * b[0] - a[0] * b[1];
  }

  return area / 2;
};

var centroid$1 = function(polygon) {
  var i = -1,
      n = polygon.length,
      x = 0,
      y = 0,
      a,
      b = polygon[n - 1],
      c,
      k = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    k += c = a[0] * b[1] - b[0] * a[1];
    x += (a[0] + b[0]) * c;
    y += (a[1] + b[1]) * c;
  }

  return k *= 3, [x / k, y / k];
};

// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
// right, +y is up). Returns a positive value if ABC is counter-clockwise,
// negative if clockwise, and zero if the points are collinear.
var cross$1 = function(a, b, c) {
  return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
};

function lexicographicOrder(a, b) {
  return a[0] - b[0] || a[1] - b[1];
}

// Computes the upper convex hull per the monotone chain algorithm.
// Assumes points.length >= 3, is sorted by x, unique in y.
// Returns an array of indices into points in left-to-right order.
function computeUpperHullIndexes(points) {
  var n = points.length,
      indexes = [0, 1],
      size = 2;

  for (var i = 2; i < n; ++i) {
    while (size > 1 && cross$1(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0) --size;
    indexes[size++] = i;
  }

  return indexes.slice(0, size); // remove popped points
}

var hull = function(points) {
  if ((n = points.length) < 3) return null;

  var i,
      n,
      sortedPoints = new Array(n),
      flippedPoints = new Array(n);

  for (i = 0; i < n; ++i) sortedPoints[i] = [+points[i][0], +points[i][1], i];
  sortedPoints.sort(lexicographicOrder);
  for (i = 0; i < n; ++i) flippedPoints[i] = [sortedPoints[i][0], -sortedPoints[i][1]];

  var upperIndexes = computeUpperHullIndexes(sortedPoints),
      lowerIndexes = computeUpperHullIndexes(flippedPoints);

  // Construct the hull polygon, removing possible duplicate endpoints.
  var skipLeft = lowerIndexes[0] === upperIndexes[0],
      skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1],
      hull = [];

  // Add upper hull in right-to-l order.
  // Then add lower hull in left-to-right order.
  for (i = upperIndexes.length - 1; i >= 0; --i) hull.push(points[sortedPoints[upperIndexes[i]][2]]);
  for (i = +skipLeft; i < lowerIndexes.length - skipRight; ++i) hull.push(points[sortedPoints[lowerIndexes[i]][2]]);

  return hull;
};

var contains$1 = function(polygon, point) {
  var n = polygon.length,
      p = polygon[n - 1],
      x = point[0], y = point[1],
      x0 = p[0], y0 = p[1],
      x1, y1,
      inside = false;

  for (var i = 0; i < n; ++i) {
    p = polygon[i], x1 = p[0], y1 = p[1];
    if (((y1 > y) !== (y0 > y)) && (x < (x0 - x1) * (y - y1) / (y0 - y1) + x1)) inside = !inside;
    x0 = x1, y0 = y1;
  }

  return inside;
};

var length$2 = function(polygon) {
  var i = -1,
      n = polygon.length,
      b = polygon[n - 1],
      xa,
      ya,
      xb = b[0],
      yb = b[1],
      perimeter = 0;

  while (++i < n) {
    xa = xb;
    ya = yb;
    b = polygon[i];
    xb = b[0];
    yb = b[1];
    xa -= xb;
    ya -= yb;
    perimeter += Math.sqrt(xa * xa + ya * ya);
  }

  return perimeter;
};

var slice$4 = [].slice;

var noabort = {};

function Queue(size) {
  this._size = size;
  this._call =
  this._error = null;
  this._tasks = [];
  this._data = [];
  this._waiting =
  this._active =
  this._ended =
  this._start = 0; // inside a synchronous task callback?
}

Queue.prototype = queue.prototype = {
  constructor: Queue,
  defer: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("defer after await");
    if (this._error != null) return this;
    var t = slice$4.call(arguments, 1);
    t.push(callback);
    ++this._waiting, this._tasks.push(t);
    poke$1(this);
    return this;
  },
  abort: function() {
    if (this._error == null) abort(this, new Error("abort"));
    return this;
  },
  await: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    this._call = function(error, results) { callback.apply(null, [error].concat(results)); };
    maybeNotify(this);
    return this;
  },
  awaitAll: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    this._call = callback;
    maybeNotify(this);
    return this;
  }
};

function poke$1(q) {
  if (!q._start) {
    try { start$1(q); } // let the current task complete
    catch (e) {
      if (q._tasks[q._ended + q._active - 1]) abort(q, e); // task errored synchronously
      else if (!q._data) throw e; // await callback errored synchronously
    }
  }
}

function start$1(q) {
  while (q._start = q._waiting && q._active < q._size) {
    var i = q._ended + q._active,
        t = q._tasks[i],
        j = t.length - 1,
        c = t[j];
    t[j] = end(q, i);
    --q._waiting, ++q._active;
    t = c.apply(null, t);
    if (!q._tasks[i]) continue; // task finished synchronously
    q._tasks[i] = t || noabort;
  }
}

function end(q, i) {
  return function(e, r) {
    if (!q._tasks[i]) return; // ignore multiple callbacks
    --q._active, ++q._ended;
    q._tasks[i] = null;
    if (q._error != null) return; // ignore secondary errors
    if (e != null) {
      abort(q, e);
    } else {
      q._data[i] = r;
      if (q._waiting) poke$1(q);
      else maybeNotify(q);
    }
  };
}

function abort(q, e) {
  var i = q._tasks.length, t;
  q._error = e; // ignore active callbacks
  q._data = undefined; // allow gc
  q._waiting = NaN; // prevent starting

  while (--i >= 0) {
    if (t = q._tasks[i]) {
      q._tasks[i] = null;
      if (t.abort) {
        try { t.abort(); }
        catch (e) { /* ignore */ }
      }
    }
  }

  q._active = NaN; // allow notification
  maybeNotify(q);
}

function maybeNotify(q) {
  if (!q._active && q._call) {
    var d = q._data;
    q._data = undefined; // allow gc
    q._call(q._error, d);
  }
}

function queue(concurrency) {
  if (concurrency == null) concurrency = Infinity;
  else if (!((concurrency = +concurrency) >= 1)) throw new Error("invalid concurrency");
  return new Queue(concurrency);
}

var defaultSource$1 = function() {
  return Math.random();
};

var uniform = (function sourceRandomUniform(source) {
  function randomUniform(min, max) {
    min = min == null ? 0 : +min;
    max = max == null ? 1 : +max;
    if (arguments.length === 1) max = min, min = 0;
    else max -= min;
    return function() {
      return source() * max + min;
    };
  }

  randomUniform.source = sourceRandomUniform;

  return randomUniform;
})(defaultSource$1);

var normal = (function sourceRandomNormal(source) {
  function randomNormal(mu, sigma) {
    var x, r;
    mu = mu == null ? 0 : +mu;
    sigma = sigma == null ? 1 : +sigma;
    return function() {
      var y;

      // If available, use the second previously-generated uniform random.
      if (x != null) y = x, x = null;

      // Otherwise, generate a new x and y.
      else do {
        x = source() * 2 - 1;
        y = source() * 2 - 1;
        r = x * x + y * y;
      } while (!r || r > 1);

      return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
    };
  }

  randomNormal.source = sourceRandomNormal;

  return randomNormal;
})(defaultSource$1);

var logNormal = (function sourceRandomLogNormal(source) {
  function randomLogNormal() {
    var randomNormal = normal.source(source).apply(this, arguments);
    return function() {
      return Math.exp(randomNormal());
    };
  }

  randomLogNormal.source = sourceRandomLogNormal;

  return randomLogNormal;
})(defaultSource$1);

var irwinHall = (function sourceRandomIrwinHall(source) {
  function randomIrwinHall(n) {
    return function() {
      for (var sum = 0, i = 0; i < n; ++i) sum += source();
      return sum;
    };
  }

  randomIrwinHall.source = sourceRandomIrwinHall;

  return randomIrwinHall;
})(defaultSource$1);

var bates = (function sourceRandomBates(source) {
  function randomBates(n) {
    var randomIrwinHall = irwinHall.source(source)(n);
    return function() {
      return randomIrwinHall() / n;
    };
  }

  randomBates.source = sourceRandomBates;

  return randomBates;
})(defaultSource$1);

var exponential$1 = (function sourceRandomExponential(source) {
  function randomExponential(lambda) {
    return function() {
      return -Math.log(1 - source()) / lambda;
    };
  }

  randomExponential.source = sourceRandomExponential;

  return randomExponential;
})(defaultSource$1);

var request = function(url, callback) {
  var request,
      event = dispatch("beforesend", "progress", "load", "error"),
      mimeType,
      headers = map$1(),
      xhr = new XMLHttpRequest,
      user = null,
      password = null,
      response,
      responseType,
      timeout = 0;

  // If IE does not support CORS, use XDomainRequest.
  if (typeof XDomainRequest !== "undefined"
      && !("withCredentials" in xhr)
      && /^(http(s)?:)?\/\//.test(url)) xhr = new XDomainRequest;

  "onload" in xhr
      ? xhr.onload = xhr.onerror = xhr.ontimeout = respond
      : xhr.onreadystatechange = function(o) { xhr.readyState > 3 && respond(o); };

  function respond(o) {
    var status = xhr.status, result;
    if (!status && hasResponse(xhr)
        || status >= 200 && status < 300
        || status === 304) {
      if (response) {
        try {
          result = response.call(request, xhr);
        } catch (e) {
          event.call("error", request, e);
          return;
        }
      } else {
        result = xhr;
      }
      event.call("load", request, result);
    } else {
      event.call("error", request, o);
    }
  }

  xhr.onprogress = function(e) {
    event.call("progress", request, e);
  };

  request = {
    header: function(name, value) {
      name = (name + "").toLowerCase();
      if (arguments.length < 2) return headers.get(name);
      if (value == null) headers.remove(name);
      else headers.set(name, value + "");
      return request;
    },

    // If mimeType is non-null and no Accept header is set, a default is used.
    mimeType: function(value) {
      if (!arguments.length) return mimeType;
      mimeType = value == null ? null : value + "";
      return request;
    },

    // Specifies what type the response value should take;
    // for instance, arraybuffer, blob, document, or text.
    responseType: function(value) {
      if (!arguments.length) return responseType;
      responseType = value;
      return request;
    },

    timeout: function(value) {
      if (!arguments.length) return timeout;
      timeout = +value;
      return request;
    },

    user: function(value) {
      return arguments.length < 1 ? user : (user = value == null ? null : value + "", request);
    },

    password: function(value) {
      return arguments.length < 1 ? password : (password = value == null ? null : value + "", request);
    },

    // Specify how to convert the response content to a specific type;
    // changes the callback value on "load" events.
    response: function(value) {
      response = value;
      return request;
    },

    // Alias for send("GET", …).
    get: function(data, callback) {
      return request.send("GET", data, callback);
    },

    // Alias for send("POST", …).
    post: function(data, callback) {
      return request.send("POST", data, callback);
    },

    // If callback is non-null, it will be used for error and load events.
    send: function(method, data, callback) {
      xhr.open(method, url, true, user, password);
      if (mimeType != null && !headers.has("accept")) headers.set("accept", mimeType + ",*/*");
      if (xhr.setRequestHeader) headers.each(function(value, name) { xhr.setRequestHeader(name, value); });
      if (mimeType != null && xhr.overrideMimeType) xhr.overrideMimeType(mimeType);
      if (responseType != null) xhr.responseType = responseType;
      if (timeout > 0) xhr.timeout = timeout;
      if (callback == null && typeof data === "function") callback = data, data = null;
      if (callback != null && callback.length === 1) callback = fixCallback(callback);
      if (callback != null) request.on("error", callback).on("load", function(xhr) { callback(null, xhr); });
      event.call("beforesend", request, xhr);
      xhr.send(data == null ? null : data);
      return request;
    },

    abort: function() {
      xhr.abort();
      return request;
    },

    on: function() {
      var value = event.on.apply(event, arguments);
      return value === event ? request : value;
    }
  };

  if (callback != null) {
    if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
    return request.get(callback);
  }

  return request;
};

function fixCallback(callback) {
  return function(error, xhr) {
    callback(error == null ? xhr : null);
  };
}

function hasResponse(xhr) {
  var type = xhr.responseType;
  return type && type !== "text"
      ? xhr.response // null on error
      : xhr.responseText; // "" on error
}

var type$1 = function(defaultMimeType, response) {
  return function(url, callback) {
    var r = request(url).mimeType(defaultMimeType).response(response);
    if (callback != null) {
      if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
      return r.get(callback);
    }
    return r;
  };
};

var html = type$1("text/html", function(xhr) {
  return document.createRange().createContextualFragment(xhr.responseText);
});

var json = type$1("application/json", function(xhr) {
  return JSON.parse(xhr.responseText);
});

var text = type$1("text/plain", function(xhr) {
  return xhr.responseText;
});

var xml = type$1("application/xml", function(xhr) {
  var xml = xhr.responseXML;
  if (!xml) throw new Error("parse error");
  return xml;
});

var dsv$1 = function(defaultMimeType, parse) {
  return function(url, row, callback) {
    if (arguments.length < 3) callback = row, row = null;
    var r = request(url).mimeType(defaultMimeType);
    r.row = function(_) { return arguments.length ? r.response(responseOf(parse, row = _)) : row; };
    r.row(row);
    return callback ? r.get(callback) : r;
  };
};

function responseOf(parse, row) {
  return function(request$$1) {
    return parse(request$$1.responseText, row);
  };
}

var csv$1 = dsv$1("text/csv", csvParse);

var tsv$1 = dsv$1("text/tab-separated-values", tsvParse);

var array$2 = Array.prototype;

var map$3 = array$2.map;
var slice$5 = array$2.slice;

var implicit = {name: "implicit"};

function ordinal(range) {
  var index = map$1(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : slice$5.call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = map$1();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = slice$5.call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}

function band() {
  var scale = ordinal().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = sequence(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point$1() {
  return pointish(band().paddingInner(1));
}

var constant$9 = function(x) {
  return function() {
    return x;
  };
};

var number$2 = function(x) {
  return +x;
};

var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : constant$9(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate$$1) {
  return function(a, b) {
    var r = reinterpolate$$1(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate$$1) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate$$1(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate$$1(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, deinterpolate, reinterpolate$$1) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate$$1(range[i], range[i + 1]);
  }

  return function(x) {
    var i = bisectRight(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate$$1) {
  var domain = unit,
      range = unit,
      interpolate = interpolateValue,
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate$$1) : reinterpolate$$1)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = map$3.call(_, number$2), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = slice$5.call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = slice$5.call(_), interpolate = interpolateRound, rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}

var tickFormat = function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = tickStep(start, stop, count == null ? 10 : count),
      precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
      return exports.formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return exports.format(specifier);
};

function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return tickFormat(domain(), count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = tickIncrement(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = tickIncrement(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = tickIncrement(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear$2() {
  var scale = continuous(deinterpolateLinear, reinterpolate);

  scale.copy = function() {
    return copy(scale, linear$2());
  };

  return linearish(scale);
}

function identity$6() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = map$3.call(_, number$2), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity$6().domain(domain);
  };

  return linearish(scale);
}

var nice = function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
};

function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : constant$9(b);
}

function reinterpolate$1(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log$1() {
  var scale = continuous(deinterpolate, reinterpolate$1).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = ticks(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = exports.format(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(nice(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return copy(scale, log$1().base(base));
  };

  return scale;
}

function raise$1(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow$1() {
  var exponent = 1,
      scale = continuous(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise$1(b, exponent) - (a = raise$1(a, exponent)))
        ? function(x) { return (raise$1(x, exponent) - a) / b; }
        : constant$9(b);
  }

  function reinterpolate(a, b) {
    b = raise$1(b, exponent) - (a = raise$1(a, exponent));
    return function(t) { return raise$1(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return copy(scale, pow$1().exponent(exponent));
  };

  return linearish(scale);
}

function sqrt$1() {
  return pow$1().exponent(0.5);
}

function quantile() {
  var domain = [],
      range = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = threshold(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range[bisectRight(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(ascending);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = slice$5.call(_), rescale()) : range.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range);
  };

  return scale;
}

function quantize$1() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[bisectRight(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = slice$5.call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize$1()
        .domain([x0, x1])
        .range(range);
  };

  return linearish(scale);
}

function threshold$1() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[bisectRight(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = slice$5.call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = slice$5.call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold$1()
        .domain(domain)
        .range(range);
  };

  return scale;
}

var t0$1 = new Date;
var t1$1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = new Date(+date)), date;
  }

  interval.floor = interval;

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [];
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(new Date(+start)); while (offseti(start, step), floori(start), start < stop)
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0$1.setTime(+start), t1$1.setTime(+end);
      floori(t0$1), floori(t1$1);
      return Math.floor(count(t0$1, t1$1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}

var millisecond = newInterval(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return newInterval(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

var milliseconds = millisecond.range;

var durationSecond$1 = 1e3;
var durationMinute$1 = 6e4;
var durationHour$1 = 36e5;
var durationDay$1 = 864e5;
var durationWeek$1 = 6048e5;

var second = newInterval(function(date) {
  date.setTime(Math.floor(date / durationSecond$1) * durationSecond$1);
}, function(date, step) {
  date.setTime(+date + step * durationSecond$1);
}, function(start, end) {
  return (end - start) / durationSecond$1;
}, function(date) {
  return date.getUTCSeconds();
});

var seconds = second.range;

var minute = newInterval(function(date) {
  date.setTime(Math.floor(date / durationMinute$1) * durationMinute$1);
}, function(date, step) {
  date.setTime(+date + step * durationMinute$1);
}, function(start, end) {
  return (end - start) / durationMinute$1;
}, function(date) {
  return date.getMinutes();
});

var minutes = minute.range;

var hour = newInterval(function(date) {
  var offset = date.getTimezoneOffset() * durationMinute$1 % durationHour$1;
  if (offset < 0) offset += durationHour$1;
  date.setTime(Math.floor((+date - offset) / durationHour$1) * durationHour$1 + offset);
}, function(date, step) {
  date.setTime(+date + step * durationHour$1);
}, function(start, end) {
  return (end - start) / durationHour$1;
}, function(date) {
  return date.getHours();
});

var hours = hour.range;

var day = newInterval(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute$1) / durationDay$1;
}, function(date) {
  return date.getDate() - 1;
});

var days = day.range;

function weekday(i) {
  return newInterval(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute$1) / durationWeek$1;
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;

var month = newInterval(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

var months = month.range;

var year = newInterval(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

var years = year.range;

var utcMinute = newInterval(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationMinute$1);
}, function(start, end) {
  return (end - start) / durationMinute$1;
}, function(date) {
  return date.getUTCMinutes();
});

var utcMinutes = utcMinute.range;

var utcHour = newInterval(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationHour$1);
}, function(start, end) {
  return (end - start) / durationHour$1;
}, function(date) {
  return date.getUTCHours();
});

var utcHours = utcHour.range;

var utcDay = newInterval(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / durationDay$1;
}, function(date) {
  return date.getUTCDate() - 1;
});

var utcDays = utcDay.range;

function utcWeekday(i) {
  return newInterval(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / durationWeek$1;
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;

var utcMonth = newInterval(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

var utcMonths = utcMonth.range;

var utcYear = newInterval(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

var utcYears = utcYear.range;

function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newYear(y) {
  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale$1(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "S": formatSeconds,
    "U": formatWeekNumberSunday,
    "w": formatWeekdayNumber,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "S": formatUTCSeconds,
    "U": formatUTCWeekNumberSunday,
    "w": formatUTCWeekdayNumber,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "S": parseSeconds,
    "U": parseWeekNumberSunday,
    "w": parseWeekdayNumber,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, newDate) {
    return function(string) {
      var d = newYear(1900),
          i = parseSpecifier(d, specifier, string += "", 0);
      if (i != string.length) return null;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "W" in d ? 1 : 0;
        var day$$1 = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day$$1 + 5) % 7 : d.w + d.U * 7 - (day$$1 + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", localDate);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier, utcDate);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"};
var numberRe = /^\s*\d+/;
var percentRe = /^%/;
var requoteRe = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + day.count(year(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekNumberSunday(d, p) {
  return pad(sunday.count(year(d), d), p, 2);
}

function formatWeekdayNumber(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(monday.count(year(d), d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + utcDay.count(utcYear(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(utcSunday.count(utcYear(d), d), p, 2);
}

function formatUTCWeekdayNumber(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(utcMonday.count(utcYear(d), d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

var locale$2;





defaultLocale$1({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale$1(definition) {
  locale$2 = formatLocale$1(definition);
  exports.timeFormat = locale$2.format;
  exports.timeParse = locale$2.parse;
  exports.utcFormat = locale$2.utcFormat;
  exports.utcParse = locale$2.utcParse;
  return locale$2;
}

var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : exports.utcFormat(isoSpecifier);

function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : exports.utcParse(isoSpecifier);

var durationSecond = 1000;
var durationMinute = durationSecond * 60;
var durationHour = durationMinute * 60;
var durationDay = durationHour * 24;
var durationWeek = durationDay * 7;
var durationMonth = durationDay * 30;
var durationYear = durationDay * 365;

function date$1(t) {
  return new Date(t);
}

function number$3(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year$$1, month$$1, week, day$$1, hour$$1, minute$$1, second$$1, millisecond$$1, format) {
  var scale = continuous(deinterpolateLinear, reinterpolate),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second$$1,  1,      durationSecond],
    [second$$1,  5,  5 * durationSecond],
    [second$$1, 15, 15 * durationSecond],
    [second$$1, 30, 30 * durationSecond],
    [minute$$1,  1,      durationMinute],
    [minute$$1,  5,  5 * durationMinute],
    [minute$$1, 15, 15 * durationMinute],
    [minute$$1, 30, 30 * durationMinute],
    [  hour$$1,  1,      durationHour  ],
    [  hour$$1,  3,  3 * durationHour  ],
    [  hour$$1,  6,  6 * durationHour  ],
    [  hour$$1, 12, 12 * durationHour  ],
    [   day$$1,  1,      durationDay   ],
    [   day$$1,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month$$1,  1,      durationMonth ],
    [ month$$1,  3,  3 * durationMonth ],
    [  year$$1,  1,      durationYear  ]
  ];

  function tickFormat(date$$1) {
    return (second$$1(date$$1) < date$$1 ? formatMillisecond
        : minute$$1(date$$1) < date$$1 ? formatSecond
        : hour$$1(date$$1) < date$$1 ? formatMinute
        : day$$1(date$$1) < date$$1 ? formatHour
        : month$$1(date$$1) < date$$1 ? (week(date$$1) < date$$1 ? formatDay : formatWeek)
        : year$$1(date$$1) < date$$1 ? formatMonth
        : formatYear)(date$$1);
  }

  function tickInterval(interval$$1, start, stop, step) {
    if (interval$$1 == null) interval$$1 = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval$$1 === "number") {
      var target = Math.abs(stop - start) / interval$$1,
          i = bisector(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = tickStep(start / durationYear, stop / durationYear, interval$$1);
        interval$$1 = year$$1;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval$$1 = i[0];
      } else {
        step = tickStep(start, stop, interval$$1);
        interval$$1 = millisecond$$1;
      }
    }

    return step == null ? interval$$1 : interval$$1.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(map$3.call(_, number$3)) : domain().map(date$1);
  };

  scale.ticks = function(interval$$1, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval$$1, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval$$1, step) {
    var d = domain();
    return (interval$$1 = tickInterval(interval$$1, d[0], d[d.length - 1], step))
        ? domain(nice(d, interval$$1))
        : scale;
  };

  scale.copy = function() {
    return copy(scale, calendar(year$$1, month$$1, week, day$$1, hour$$1, minute$$1, second$$1, millisecond$$1, format));
  };

  return scale;
}

var time = function() {
  return calendar(year, month, sunday, day, hour, minute, second, millisecond, exports.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
};

var utcTime = function() {
  return calendar(utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, millisecond, exports.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
};

var colors = function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
};

var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");

var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");

var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");

var cubehelix$3 = cubehelixLong(cubehelix(300, 0.5, 0.0), cubehelix(-240, 0.5, 1.0));

var warm = cubehelixLong(cubehelix(-100, 0.75, 0.35), cubehelix(80, 1.50, 0.8));

var cool = cubehelixLong(cubehelix(260, 0.75, 0.35), cubehelix(80, 1.50, 0.8));

var rainbow = cubehelix();

var rainbow$1 = function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
};

function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));

var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return linearish(scale);
}

var constant$10 = function(x) {
  return function constant() {
    return x;
  };
};

var abs$1 = Math.abs;
var atan2$1 = Math.atan2;
var cos$2 = Math.cos;
var max$2 = Math.max;
var min$1 = Math.min;
var sin$2 = Math.sin;
var sqrt$2 = Math.sqrt;

var epsilon$3 = 1e-12;
var pi$4 = Math.PI;
var halfPi$3 = pi$4 / 2;
var tau$4 = 2 * pi$4;

function acos$1(x) {
  return x > 1 ? 0 : x < -1 ? pi$4 : Math.acos(x);
}

function asin$1(x) {
  return x >= 1 ? halfPi$3 : x <= -1 ? -halfPi$3 : Math.asin(x);
}

function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / sqrt$2(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * sqrt$2(max$2(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

var arc = function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = constant$10(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - halfPi$3,
        a1 = endAngle.apply(this, arguments) - halfPi$3,
        da = abs$1(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = path();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > epsilon$3)) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > tau$4 - epsilon$3) {
      context.moveTo(r1 * cos$2(a0), r1 * sin$2(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > epsilon$3) {
        context.moveTo(r0 * cos$2(a1), r0 * sin$2(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > epsilon$3) && (padRadius ? +padRadius.apply(this, arguments) : sqrt$2(r0 * r0 + r1 * r1)),
          rc = min$1(abs$1(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > epsilon$3) {
        var p0 = asin$1(rp / r0 * sin$2(ap)),
            p1 = asin$1(rp / r1 * sin$2(ap));
        if ((da0 -= p0 * 2) > epsilon$3) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > epsilon$3) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * cos$2(a01),
          y01 = r1 * sin$2(a01),
          x10 = r0 * cos$2(a10),
          y10 = r0 * sin$2(a10);

      // Apply rounded corners?
      if (rc > epsilon$3) {
        var x11 = r1 * cos$2(a11),
            y11 = r1 * sin$2(a11),
            x00 = r0 * cos$2(a00),
            y00 = r0 * sin$2(a00);

        // Restrict the corner radius according to the sector angle.
        if (da < pi$4) {
          var oc = da0 > epsilon$3 ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
              ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / sin$2(acos$1((ax * bx + ay * by) / (sqrt$2(ax * ax + ay * ay) * sqrt$2(bx * bx + by * by))) / 2),
              lc = sqrt$2(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = min$1(rc, (r0 - lc) / (kc - 1));
          rc1 = min$1(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > epsilon$3)) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > epsilon$3) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2$1(t0.y01, t0.x01), atan2$1(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, atan2$1(t0.y01, t0.x01), atan2$1(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, atan2$1(t0.cy + t0.y11, t0.cx + t0.x11), atan2$1(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, atan2$1(t1.y11, t1.x11), atan2$1(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > epsilon$3) || !(da0 > epsilon$3)) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > epsilon$3) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2$1(t0.y01, t0.x01), atan2$1(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, atan2$1(t0.y01, t0.x01), atan2$1(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, atan2$1(t0.cy + t0.y11, t0.cx + t0.x11), atan2$1(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, atan2$1(t1.y11, t1.x11), atan2$1(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi$4 / 2;
    return [cos$2(a) * r, sin$2(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$10(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$10(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$10(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$10(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$10(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$10(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$10(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
};

function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

var curveLinear = function(context) {
  return new Linear(context);
};

function x$3(p) {
  return p[0];
}

function y$3(p) {
  return p[1];
}

var line = function() {
  var x = x$3,
      y = y$3,
      defined = constant$10(true),
      context = null,
      curve = curveLinear,
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant$10(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant$10(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$10(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
};

var area$2 = function() {
  var x0 = x$3,
      x1 = null,
      y0 = constant$10(0),
      y1 = y$3,
      defined = constant$10(true),
      context = null,
      curve = curveLinear,
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return line().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$10(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$10(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$10(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$10(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$10(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$10(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$10(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
};

var descending$1 = function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
};

var identity$7 = function(d) {
  return d;
};

var pie = function() {
  var value = identity$7,
      sortValues = descending$1,
      sort = null,
      startAngle = constant$10(0),
      endAngle = constant$10(tau$4),
      padAngle = constant$10(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(tau$4, Math.max(-tau$4, endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant$10(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$10(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$10(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$10(+_), pie) : padAngle;
  };

  return pie;
};

var curveRadialLinear = curveRadial(curveLinear);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}

function lineRadial(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(curveRadial(_)) : c()._curve;
  };

  return l;
}

var lineRadial$1 = function() {
  return lineRadial(line().curve(curveRadialLinear));
};

var areaRadial = function() {
  var a = area$2().curve(curveRadialLinear),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return lineRadial(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return lineRadial(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return lineRadial(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return lineRadial(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(curveRadial(_)) : c()._curve;
  };

  return a;
};

var pointRadial = function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
};

var slice$6 = Array.prototype.slice;

function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link$2(curve) {
  var source = linkSource,
      target = linkTarget,
      x = x$3,
      y = y$3,
      context = null;

  function link() {
    var buffer, argv = slice$6.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
    if (!context) context = buffer = path();
    curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function(_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function(_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant$10(+_), link) : x;
  };

  link.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant$10(+_), link) : y;
  };

  link.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function curveRadial$1(context, x0, y0, x1, y1) {
  var p0 = pointRadial(x0, y0),
      p1 = pointRadial(x0, y0 = (y0 + y1) / 2),
      p2 = pointRadial(x1, y0),
      p3 = pointRadial(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link$2(curveHorizontal);
}

function linkVertical() {
  return link$2(curveVertical);
}

function linkRadial() {
  var l = link$2(curveRadial$1);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}

var circle$2 = {
  draw: function(context, size) {
    var r = Math.sqrt(size / pi$4);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, tau$4);
  }
};

var cross$2 = {
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
};

var tan30 = Math.sqrt(1 / 3);
var tan30_2 = tan30 * 2;

var diamond = {
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
};

var ka = 0.89081309152928522810;
var kr = Math.sin(pi$4 / 10) / Math.sin(7 * pi$4 / 10);
var kx = Math.sin(tau$4 / 10) * kr;
var ky = -Math.cos(tau$4 / 10) * kr;

var star = {
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = tau$4 * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
};

var square = {
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
};

var sqrt3 = Math.sqrt(3);

var triangle = {
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
};

var c = -0.5;
var s = Math.sqrt(3) / 2;
var k = 1 / Math.sqrt(12);
var a = (k / 2 + 1) * 3;

var wye = {
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k,
        x1 = x0,
        y1 = r * k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
};

var symbols = [
  circle$2,
  cross$2,
  diamond,
  square,
  star,
  triangle,
  wye
];

var symbol = function() {
  var type = constant$10(circle$2),
      size = constant$10(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = path();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : constant$10(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : constant$10(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
};

var noop$2 = function() {};

function point$2(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point$2(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point$2(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

var basis$2 = function(context) {
  return new Basis(context);
};

function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: point$2(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

var basisClosed$1 = function(context) {
  return new BasisClosed(context);
};

function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: point$2(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

var basisOpen = function(context) {
  return new BasisOpen(context);
};

function Bundle(context, beta) {
  this._basis = new Basis(context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

var bundle = (function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85);

function point$3(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point$3(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point$3(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var cardinal = (function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0);

function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: point$3(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var cardinalClosed = (function custom(tension) {

  function cardinal$$1(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal$$1.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal$$1;
})(0);

function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: point$3(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var cardinalOpen = (function custom(tension) {

  function cardinal$$1(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal$$1.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal$$1;
})(0);

function point$4(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > epsilon$3) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > epsilon$3) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point$4(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var catmullRom = (function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5);

function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: point$4(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var catmullRomClosed = (function custom(alpha) {

  function catmullRom$$1(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
  }

  catmullRom$$1.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom$$1;
})(0.5);

function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: point$4(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var catmullRomOpen = (function custom(alpha) {

  function catmullRom$$1(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
  }

  catmullRom$$1.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom$$1;
})(0.5);

function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

var linearClosed = function(context) {
  return new LinearClosed(context);
};

function sign$1(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign$1(s0) + sign$1(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point$5(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point$5(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point$5(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point$5(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
};

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}

function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

var natural = function(context) {
  return new Natural(context);
};

function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

var step = function(context) {
  return new Step(context, 0.5);
};

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}

var none$1 = function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
};

var none$2 = function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
};

function stackValue(d, key) {
  return d[key];
}

var stack = function() {
  var keys = constant$10([]),
      order = none$2,
      offset = none$1,
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : constant$10(slice$6.call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant$10(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? none$2 : typeof _ === "function" ? _ : constant$10(slice$6.call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? none$1 : _, stack) : offset;
  };

  return stack;
};

var expand = function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  none$1(series, order);
};

var diverging = function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = yp;
      }
    }
  }
};

var silhouette = function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  none$1(series, order);
};

var wiggle = function(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  none$1(series, order);
};

var ascending$2 = function(series) {
  var sums = series.map(sum$2);
  return none$2(series).sort(function(a, b) { return sums[a] - sums[b]; });
};

function sum$2(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}

var descending$2 = function(series) {
  return ascending$2(series).reverse();
};

var insideOut = function(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(sum$2),
      order = none$2(series).sort(function(a, b) { return sums[b] - sums[a]; }),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
};

var reverse = function(series) {
  return none$2(series).reverse();
};

var constant$11 = function(x) {
  return function() {
    return x;
  };
};

function x$4(d) {
  return d[0];
}

function y$4(d) {
  return d[1];
}

function RedBlackTree() {
  this._ = null; // root node
}

function RedBlackNode(node) {
  node.U = // parent node
  node.C = // color - true for red, false for black
  node.L = // left node
  node.R = // right node
  node.P = // previous node
  node.N = null; // next node
}

RedBlackTree.prototype = {
  constructor: RedBlackTree,

  insert: function(after, node) {
    var parent, grandpa, uncle;

    if (after) {
      node.P = after;
      node.N = after.N;
      if (after.N) after.N.P = node;
      after.N = node;
      if (after.R) {
        after = after.R;
        while (after.L) after = after.L;
        after.L = node;
      } else {
        after.R = node;
      }
      parent = after;
    } else if (this._) {
      after = RedBlackFirst(this._);
      node.P = null;
      node.N = after;
      after.P = after.L = node;
      parent = after;
    } else {
      node.P = node.N = null;
      this._ = node;
      parent = null;
    }
    node.L = node.R = null;
    node.U = parent;
    node.C = true;

    after = node;
    while (parent && parent.C) {
      grandpa = parent.U;
      if (parent === grandpa.L) {
        uncle = grandpa.R;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.R) {
            RedBlackRotateLeft(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateRight(this, grandpa);
        }
      } else {
        uncle = grandpa.L;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.L) {
            RedBlackRotateRight(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateLeft(this, grandpa);
        }
      }
      parent = after.U;
    }
    this._.C = false;
  },

  remove: function(node) {
    if (node.N) node.N.P = node.P;
    if (node.P) node.P.N = node.N;
    node.N = node.P = null;

    var parent = node.U,
        sibling,
        left = node.L,
        right = node.R,
        next,
        red;

    if (!left) next = right;
    else if (!right) next = left;
    else next = RedBlackFirst(right);

    if (parent) {
      if (parent.L === node) parent.L = next;
      else parent.R = next;
    } else {
      this._ = next;
    }

    if (left && right) {
      red = next.C;
      next.C = node.C;
      next.L = left;
      left.U = next;
      if (next !== right) {
        parent = next.U;
        next.U = node.U;
        node = next.R;
        parent.L = node;
        next.R = right;
        right.U = next;
      } else {
        next.U = parent;
        parent = next;
        node = next.R;
      }
    } else {
      red = node.C;
      node = next;
    }

    if (node) node.U = parent;
    if (red) return;
    if (node && node.C) { node.C = false; return; }

    do {
      if (node === this._) break;
      if (node === parent.L) {
        sibling = parent.R;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateLeft(this, parent);
          sibling = parent.R;
        }
        if ((sibling.L && sibling.L.C)
            || (sibling.R && sibling.R.C)) {
          if (!sibling.R || !sibling.R.C) {
            sibling.L.C = false;
            sibling.C = true;
            RedBlackRotateRight(this, sibling);
            sibling = parent.R;
          }
          sibling.C = parent.C;
          parent.C = sibling.R.C = false;
          RedBlackRotateLeft(this, parent);
          node = this._;
          break;
        }
      } else {
        sibling = parent.L;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateRight(this, parent);
          sibling = parent.L;
        }
        if ((sibling.L && sibling.L.C)
          || (sibling.R && sibling.R.C)) {
          if (!sibling.L || !sibling.L.C) {
            sibling.R.C = false;
            sibling.C = true;
            RedBlackRotateLeft(this, sibling);
            sibling = parent.L;
          }
          sibling.C = parent.C;
          parent.C = sibling.L.C = false;
          RedBlackRotateRight(this, parent);
          node = this._;
          break;
        }
      }
      sibling.C = true;
      node = parent;
      parent = parent.U;
    } while (!node.C);

    if (node) node.C = false;
  }
};

function RedBlackRotateLeft(tree, node) {
  var p = node,
      q = node.R,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.R = q.L;
  if (p.R) p.R.U = p;
  q.L = p;
}

function RedBlackRotateRight(tree, node) {
  var p = node,
      q = node.L,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.L = q.R;
  if (p.L) p.L.U = p;
  q.R = p;
}

function RedBlackFirst(node) {
  while (node.L) node = node.L;
  return node;
}

function createEdge(left, right, v0, v1) {
  var edge = [null, null],
      index = edges.push(edge) - 1;
  edge.left = left;
  edge.right = right;
  if (v0) setEdgeEnd(edge, left, right, v0);
  if (v1) setEdgeEnd(edge, right, left, v1);
  cells[left.index].halfedges.push(index);
  cells[right.index].halfedges.push(index);
  return edge;
}

function createBorderEdge(left, v0, v1) {
  var edge = [v0, v1];
  edge.left = left;
  return edge;
}

function setEdgeEnd(edge, left, right, vertex) {
  if (!edge[0] && !edge[1]) {
    edge[0] = vertex;
    edge.left = left;
    edge.right = right;
  } else if (edge.left === right) {
    edge[1] = vertex;
  } else {
    edge[0] = vertex;
  }
}

// Liang–Barsky line clipping.
function clipEdge(edge, x0, y0, x1, y1) {
  var a = edge[0],
      b = edge[1],
      ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?

  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
  return true;
}

function connectEdge(edge, x0, y0, x1, y1) {
  var v1 = edge[1];
  if (v1) return true;

  var v0 = edge[0],
      left = edge.left,
      right = edge.right,
      lx = left[0],
      ly = left[1],
      rx = right[0],
      ry = right[1],
      fx = (lx + rx) / 2,
      fy = (ly + ry) / 2,
      fm,
      fb;

  if (ry === ly) {
    if (fx < x0 || fx >= x1) return;
    if (lx > rx) {
      if (!v0) v0 = [fx, y0];
      else if (v0[1] >= y1) return;
      v1 = [fx, y1];
    } else {
      if (!v0) v0 = [fx, y1];
      else if (v0[1] < y0) return;
      v1 = [fx, y0];
    }
  } else {
    fm = (lx - rx) / (ry - ly);
    fb = fy - fm * fx;
    if (fm < -1 || fm > 1) {
      if (lx > rx) {
        if (!v0) v0 = [(y0 - fb) / fm, y0];
        else if (v0[1] >= y1) return;
        v1 = [(y1 - fb) / fm, y1];
      } else {
        if (!v0) v0 = [(y1 - fb) / fm, y1];
        else if (v0[1] < y0) return;
        v1 = [(y0 - fb) / fm, y0];
      }
    } else {
      if (ly < ry) {
        if (!v0) v0 = [x0, fm * x0 + fb];
        else if (v0[0] >= x1) return;
        v1 = [x1, fm * x1 + fb];
      } else {
        if (!v0) v0 = [x1, fm * x1 + fb];
        else if (v0[0] < x0) return;
        v1 = [x0, fm * x0 + fb];
      }
    }
  }

  edge[0] = v0;
  edge[1] = v1;
  return true;
}

function clipEdges(x0, y0, x1, y1) {
  var i = edges.length,
      edge;

  while (i--) {
    if (!connectEdge(edge = edges[i], x0, y0, x1, y1)
        || !clipEdge(edge, x0, y0, x1, y1)
        || !(Math.abs(edge[0][0] - edge[1][0]) > epsilon$4
            || Math.abs(edge[0][1] - edge[1][1]) > epsilon$4)) {
      delete edges[i];
    }
  }
}

function createCell(site) {
  return cells[site.index] = {
    site: site,
    halfedges: []
  };
}

function cellHalfedgeAngle(cell, edge) {
  var site = cell.site,
      va = edge.left,
      vb = edge.right;
  if (site === vb) vb = va, va = site;
  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
  if (site === va) va = edge[1], vb = edge[0];
  else va = edge[0], vb = edge[1];
  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}

function cellHalfedgeStart(cell, edge) {
  return edge[+(edge.left !== cell.site)];
}

function cellHalfedgeEnd(cell, edge) {
  return edge[+(edge.left === cell.site)];
}

function sortCellHalfedges() {
  for (var i = 0, n = cells.length, cell, halfedges, j, m; i < n; ++i) {
    if ((cell = cells[i]) && (m = (halfedges = cell.halfedges).length)) {
      var index = new Array(m),
          array = new Array(m);
      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, edges[halfedges[j]]);
      index.sort(function(i, j) { return array[j] - array[i]; });
      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
      for (j = 0; j < m; ++j) halfedges[j] = array[j];
    }
  }
}

function clipCells(x0, y0, x1, y1) {
  var nCells = cells.length,
      iCell,
      cell,
      site,
      iHalfedge,
      halfedges,
      nHalfedges,
      start,
      startX,
      startY,
      end,
      endX,
      endY,
      cover = true;

  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = cells[iCell]) {
      site = cell.site;
      halfedges = cell.halfedges;
      iHalfedge = halfedges.length;

      // Remove any dangling clipped edges.
      while (iHalfedge--) {
        if (!edges[halfedges[iHalfedge]]) {
          halfedges.splice(iHalfedge, 1);
        }
      }

      // Insert any border edges as necessary.
      iHalfedge = 0, nHalfedges = halfedges.length;
      while (iHalfedge < nHalfedges) {
        end = cellHalfedgeEnd(cell, edges[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
        start = cellHalfedgeStart(cell, edges[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
        if (Math.abs(endX - startX) > epsilon$4 || Math.abs(endY - startY) > epsilon$4) {
          halfedges.splice(iHalfedge, 0, edges.push(createBorderEdge(site, end,
              Math.abs(endX - x0) < epsilon$4 && y1 - endY > epsilon$4 ? [x0, Math.abs(startX - x0) < epsilon$4 ? startY : y1]
              : Math.abs(endY - y1) < epsilon$4 && x1 - endX > epsilon$4 ? [Math.abs(startY - y1) < epsilon$4 ? startX : x1, y1]
              : Math.abs(endX - x1) < epsilon$4 && endY - y0 > epsilon$4 ? [x1, Math.abs(startX - x1) < epsilon$4 ? startY : y0]
              : Math.abs(endY - y0) < epsilon$4 && endX - x0 > epsilon$4 ? [Math.abs(startY - y0) < epsilon$4 ? startX : x0, y0]
              : null)) - 1);
          ++nHalfedges;
        }
      }

      if (nHalfedges) cover = false;
    }
  }

  // If there weren’t any edges, have the closest site cover the extent.
  // It doesn’t matter which corner of the extent we measure!
  if (cover) {
    var dx, dy, d2, dc = Infinity;

    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
      if (cell = cells[iCell]) {
        site = cell.site;
        dx = site[0] - x0;
        dy = site[1] - y0;
        d2 = dx * dx + dy * dy;
        if (d2 < dc) dc = d2, cover = cell;
      }
    }

    if (cover) {
      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
      cover.halfedges.push(
        edges.push(createBorderEdge(site = cover.site, v00, v01)) - 1,
        edges.push(createBorderEdge(site, v01, v11)) - 1,
        edges.push(createBorderEdge(site, v11, v10)) - 1,
        edges.push(createBorderEdge(site, v10, v00)) - 1
      );
    }
  }

  // Lastly delete any cells with no edges; these were entirely clipped.
  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = cells[iCell]) {
      if (!cell.halfedges.length) {
        delete cells[iCell];
      }
    }
  }
}

var circlePool = [];

var firstCircle;

function Circle() {
  RedBlackNode(this);
  this.x =
  this.y =
  this.arc =
  this.site =
  this.cy = null;
}

function attachCircle(arc) {
  var lArc = arc.P,
      rArc = arc.N;

  if (!lArc || !rArc) return;

  var lSite = lArc.site,
      cSite = arc.site,
      rSite = rArc.site;

  if (lSite === rSite) return;

  var bx = cSite[0],
      by = cSite[1],
      ax = lSite[0] - bx,
      ay = lSite[1] - by,
      cx = rSite[0] - bx,
      cy = rSite[1] - by;

  var d = 2 * (ax * cy - ay * cx);
  if (d >= -epsilon2$2) return;

  var ha = ax * ax + ay * ay,
      hc = cx * cx + cy * cy,
      x = (cy * ha - ay * hc) / d,
      y = (ax * hc - cx * ha) / d;

  var circle = circlePool.pop() || new Circle;
  circle.arc = arc;
  circle.site = cSite;
  circle.x = x + bx;
  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom

  arc.circle = circle;

  var before = null,
      node = circles._;

  while (node) {
    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
      if (node.L) node = node.L;
      else { before = node.P; break; }
    } else {
      if (node.R) node = node.R;
      else { before = node; break; }
    }
  }

  circles.insert(before, circle);
  if (!before) firstCircle = circle;
}

function detachCircle(arc) {
  var circle = arc.circle;
  if (circle) {
    if (!circle.P) firstCircle = circle.N;
    circles.remove(circle);
    circlePool.push(circle);
    RedBlackNode(circle);
    arc.circle = null;
  }
}

var beachPool = [];

function Beach() {
  RedBlackNode(this);
  this.edge =
  this.site =
  this.circle = null;
}

function createBeach(site) {
  var beach = beachPool.pop() || new Beach;
  beach.site = site;
  return beach;
}

function detachBeach(beach) {
  detachCircle(beach);
  beaches.remove(beach);
  beachPool.push(beach);
  RedBlackNode(beach);
}

function removeBeach(beach) {
  var circle = beach.circle,
      x = circle.x,
      y = circle.cy,
      vertex = [x, y],
      previous = beach.P,
      next = beach.N,
      disappearing = [beach];

  detachBeach(beach);

  var lArc = previous;
  while (lArc.circle
      && Math.abs(x - lArc.circle.x) < epsilon$4
      && Math.abs(y - lArc.circle.cy) < epsilon$4) {
    previous = lArc.P;
    disappearing.unshift(lArc);
    detachBeach(lArc);
    lArc = previous;
  }

  disappearing.unshift(lArc);
  detachCircle(lArc);

  var rArc = next;
  while (rArc.circle
      && Math.abs(x - rArc.circle.x) < epsilon$4
      && Math.abs(y - rArc.circle.cy) < epsilon$4) {
    next = rArc.N;
    disappearing.push(rArc);
    detachBeach(rArc);
    rArc = next;
  }

  disappearing.push(rArc);
  detachCircle(rArc);

  var nArcs = disappearing.length,
      iArc;
  for (iArc = 1; iArc < nArcs; ++iArc) {
    rArc = disappearing[iArc];
    lArc = disappearing[iArc - 1];
    setEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
  }

  lArc = disappearing[0];
  rArc = disappearing[nArcs - 1];
  rArc.edge = createEdge(lArc.site, rArc.site, null, vertex);

  attachCircle(lArc);
  attachCircle(rArc);
}

function addBeach(site) {
  var x = site[0],
      directrix = site[1],
      lArc,
      rArc,
      dxl,
      dxr,
      node = beaches._;

  while (node) {
    dxl = leftBreakPoint(node, directrix) - x;
    if (dxl > epsilon$4) node = node.L; else {
      dxr = x - rightBreakPoint(node, directrix);
      if (dxr > epsilon$4) {
        if (!node.R) {
          lArc = node;
          break;
        }
        node = node.R;
      } else {
        if (dxl > -epsilon$4) {
          lArc = node.P;
          rArc = node;
        } else if (dxr > -epsilon$4) {
          lArc = node;
          rArc = node.N;
        } else {
          lArc = rArc = node;
        }
        break;
      }
    }
  }

  createCell(site);
  var newArc = createBeach(site);
  beaches.insert(lArc, newArc);

  if (!lArc && !rArc) return;

  if (lArc === rArc) {
    detachCircle(lArc);
    rArc = createBeach(lArc.site);
    beaches.insert(newArc, rArc);
    newArc.edge = rArc.edge = createEdge(lArc.site, newArc.site);
    attachCircle(lArc);
    attachCircle(rArc);
    return;
  }

  if (!rArc) { // && lArc
    newArc.edge = createEdge(lArc.site, newArc.site);
    return;
  }

  // else lArc !== rArc
  detachCircle(lArc);
  detachCircle(rArc);

  var lSite = lArc.site,
      ax = lSite[0],
      ay = lSite[1],
      bx = site[0] - ax,
      by = site[1] - ay,
      rSite = rArc.site,
      cx = rSite[0] - ax,
      cy = rSite[1] - ay,
      d = 2 * (bx * cy - by * cx),
      hb = bx * bx + by * by,
      hc = cx * cx + cy * cy,
      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];

  setEdgeEnd(rArc.edge, lSite, rSite, vertex);
  newArc.edge = createEdge(lSite, site, null, vertex);
  rArc.edge = createEdge(site, rSite, null, vertex);
  attachCircle(lArc);
  attachCircle(rArc);
}

function leftBreakPoint(arc, directrix) {
  var site = arc.site,
      rfocx = site[0],
      rfocy = site[1],
      pby2 = rfocy - directrix;

  if (!pby2) return rfocx;

  var lArc = arc.P;
  if (!lArc) return -Infinity;

  site = lArc.site;
  var lfocx = site[0],
      lfocy = site[1],
      plby2 = lfocy - directrix;

  if (!plby2) return lfocx;

  var hl = lfocx - rfocx,
      aby2 = 1 / pby2 - 1 / plby2,
      b = hl / plby2;

  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;

  return (rfocx + lfocx) / 2;
}

function rightBreakPoint(arc, directrix) {
  var rArc = arc.N;
  if (rArc) return leftBreakPoint(rArc, directrix);
  var site = arc.site;
  return site[1] === directrix ? site[0] : Infinity;
}

var epsilon$4 = 1e-6;
var epsilon2$2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;

function triangleArea(a, b, c) {
  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}

function lexicographic(a, b) {
  return b[1] - a[1]
      || b[0] - a[0];
}

function Diagram(sites, extent) {
  var site = sites.sort(lexicographic).pop(),
      x,
      y,
      circle;

  edges = [];
  cells = new Array(sites.length);
  beaches = new RedBlackTree;
  circles = new RedBlackTree;

  while (true) {
    circle = firstCircle;
    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
      if (site[0] !== x || site[1] !== y) {
        addBeach(site);
        x = site[0], y = site[1];
      }
      site = sites.pop();
    } else if (circle) {
      removeBeach(circle.arc);
    } else {
      break;
    }
  }

  sortCellHalfedges();

  if (extent) {
    var x0 = +extent[0][0],
        y0 = +extent[0][1],
        x1 = +extent[1][0],
        y1 = +extent[1][1];
    clipEdges(x0, y0, x1, y1);
    clipCells(x0, y0, x1, y1);
  }

  this.edges = edges;
  this.cells = cells;

  beaches =
  circles =
  edges =
  cells = null;
}

Diagram.prototype = {
  constructor: Diagram,

  polygons: function() {
    var edges = this.edges;

    return this.cells.map(function(cell) {
      var polygon = cell.halfedges.map(function(i) { return cellHalfedgeStart(cell, edges[i]); });
      polygon.data = cell.site.data;
      return polygon;
    });
  },

  triangles: function() {
    var triangles = [],
        edges = this.edges;

    this.cells.forEach(function(cell, i) {
      if (!(m = (halfedges = cell.halfedges).length)) return;
      var site = cell.site,
          halfedges,
          j = -1,
          m,
          s0,
          e1 = edges[halfedges[m - 1]],
          s1 = e1.left === site ? e1.right : e1.left;

      while (++j < m) {
        s0 = s1;
        e1 = edges[halfedges[j]];
        s1 = e1.left === site ? e1.right : e1.left;
        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
          triangles.push([site.data, s0.data, s1.data]);
        }
      }
    });

    return triangles;
  },

  links: function() {
    return this.edges.filter(function(edge) {
      return edge.right;
    }).map(function(edge) {
      return {
        source: edge.left.data,
        target: edge.right.data
      };
    });
  },

  find: function(x, y, radius) {
    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;

    // Use the previously-found cell, or start with an arbitrary one.
    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;

    // Traverse the half-edges to find a closer cell, if any.
    do {
      cell = that.cells[i0 = i1], i1 = null;
      cell.halfedges.forEach(function(e) {
        var edge = that.edges[e], v = edge.left;
        if ((v === cell.site || !v) && !(v = edge.right)) return;
        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
        if (v2 < d2) d2 = v2, i1 = v.index;
      });
    } while (i1 !== null);

    that._found = i0;

    return radius == null || d2 <= radius * radius ? cell.site : null;
  }
};

var voronoi = function() {
  var x = x$4,
      y = y$4,
      extent = null;

  function voronoi(data) {
    return new Diagram(data.map(function(d, i) {
      var s = [Math.round(x(d, i, data) / epsilon$4) * epsilon$4, Math.round(y(d, i, data) / epsilon$4) * epsilon$4];
      s.index = i;
      s.data = d;
      return s;
    }), extent);
  }

  voronoi.polygons = function(data) {
    return voronoi(data).polygons();
  };

  voronoi.links = function(data) {
    return voronoi(data).links();
  };

  voronoi.triangles = function(data) {
    return voronoi(data).triangles();
  };

  voronoi.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant$11(+_), voronoi) : x;
  };

  voronoi.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant$11(+_), voronoi) : y;
  };

  voronoi.extent = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
  };

  voronoi.size = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
  };

  return voronoi;
};

var constant$12 = function(x) {
  return function() {
    return x;
  };
};

function ZoomEvent(target, type, transform) {
  this.target = target;
  this.type = type;
  this.transform = transform;
}

function Transform(k, x, y) {
  this.k = k;
  this.x = x;
  this.y = y;
}

Transform.prototype = {
  constructor: Transform,
  scale: function(k) {
    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
  },
  translate: function(x, y) {
    return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
  },
  apply: function(point) {
    return [point[0] * this.k + this.x, point[1] * this.k + this.y];
  },
  applyX: function(x) {
    return x * this.k + this.x;
  },
  applyY: function(y) {
    return y * this.k + this.y;
  },
  invert: function(location) {
    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
  },
  invertX: function(x) {
    return (x - this.x) / this.k;
  },
  invertY: function(y) {
    return (y - this.y) / this.k;
  },
  rescaleX: function(x) {
    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
  },
  rescaleY: function(y) {
    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};

var identity$8 = new Transform(1, 0, 0);

transform$1.prototype = Transform.prototype;

function transform$1(node) {
  return node.__zoom || identity$8;
}

function nopropagation$2() {
  exports.event.stopImmediatePropagation();
}

var noevent$2 = function() {
  exports.event.preventDefault();
  exports.event.stopImmediatePropagation();
};

// Ignore right-click, since that should open the context menu.
function defaultFilter$2() {
  return !exports.event.button;
}

function defaultExtent$1() {
  var e = this, w, h;
  if (e instanceof SVGElement) {
    e = e.ownerSVGElement || e;
    w = e.width.baseVal.value;
    h = e.height.baseVal.value;
  } else {
    w = e.clientWidth;
    h = e.clientHeight;
  }
  return [[0, 0], [w, h]];
}

function defaultTransform() {
  return this.__zoom || identity$8;
}

function defaultWheelDelta() {
  return -exports.event.deltaY * (exports.event.deltaMode ? 120 : 1) / 500;
}

function touchable$1() {
  return "ontouchstart" in this;
}

var zoom = function() {
  var filter = defaultFilter$2,
      extent = defaultExtent$1,
      wheelDelta = defaultWheelDelta,
      k0 = 0,
      k1 = Infinity,
      x0 = -k1,
      x1 = k1,
      y0 = x0,
      y1 = x1,
      duration = 250,
      interpolate = interpolateZoom,
      gestures = [],
      listeners = dispatch("start", "zoom", "end"),
      touchstarting,
      touchending,
      touchDelay = 500,
      wheelDelay = 150,
      clickDistance2 = 0;

  function zoom(selection$$1) {
    selection$$1
        .property("__zoom", defaultTransform)
        .on("wheel.zoom", wheeled)
        .on("mousedown.zoom", mousedowned)
        .on("dblclick.zoom", dblclicked)
      .filter(touchable$1)
        .on("touchstart.zoom", touchstarted)
        .on("touchmove.zoom", touchmoved)
        .on("touchend.zoom touchcancel.zoom", touchended)
        .style("touch-action", "none")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  zoom.transform = function(collection, transform$$1) {
    var selection$$1 = collection.selection ? collection.selection() : collection;
    selection$$1.property("__zoom", defaultTransform);
    if (collection !== selection$$1) {
      schedule(collection, transform$$1);
    } else {
      selection$$1.interrupt().each(function() {
        gesture(this, arguments)
            .start()
            .zoom(null, typeof transform$$1 === "function" ? transform$$1.apply(this, arguments) : transform$$1)
            .end();
      });
    }
  };

  zoom.scaleBy = function(selection$$1, k) {
    zoom.scaleTo(selection$$1, function() {
      var k0 = this.__zoom.k,
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return k0 * k1;
    });
  };

  zoom.scaleTo = function(selection$$1, k) {
    zoom.transform(selection$$1, function() {
      var e = extent.apply(this, arguments),
          t0 = this.__zoom,
          p0 = centroid(e),
          p1 = t0.invert(p0),
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return constrain(translate(scale(t0, k1), p0, p1), e);
    });
  };

  zoom.translateBy = function(selection$$1, x, y) {
    zoom.transform(selection$$1, function() {
      return constrain(this.__zoom.translate(
        typeof x === "function" ? x.apply(this, arguments) : x,
        typeof y === "function" ? y.apply(this, arguments) : y
      ), extent.apply(this, arguments));
    });
  };

  zoom.translateTo = function(selection$$1, x, y) {
    zoom.transform(selection$$1, function() {
      var e = extent.apply(this, arguments),
          t = this.__zoom,
          p = centroid(e);
      return constrain(identity$8.translate(p[0], p[1]).scale(t.k).translate(
        typeof x === "function" ? -x.apply(this, arguments) : -x,
        typeof y === "function" ? -y.apply(this, arguments) : -y
      ), e);
    });
  };

  function scale(transform$$1, k) {
    k = Math.max(k0, Math.min(k1, k));
    return k === transform$$1.k ? transform$$1 : new Transform(k, transform$$1.x, transform$$1.y);
  }

  function translate(transform$$1, p0, p1) {
    var x = p0[0] - p1[0] * transform$$1.k, y = p0[1] - p1[1] * transform$$1.k;
    return x === transform$$1.x && y === transform$$1.y ? transform$$1 : new Transform(transform$$1.k, x, y);
  }

  function constrain(transform$$1, extent) {
    var dx0 = transform$$1.invertX(extent[0][0]) - x0,
        dx1 = transform$$1.invertX(extent[1][0]) - x1,
        dy0 = transform$$1.invertY(extent[0][1]) - y0,
        dy1 = transform$$1.invertY(extent[1][1]) - y1;
    return transform$$1.translate(
      dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1),
      dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1)
    );
  }

  function centroid(extent) {
    return [(+extent[0][0] + +extent[1][0]) / 2, (+extent[0][1] + +extent[1][1]) / 2];
  }

  function schedule(transition$$1, transform$$1, center) {
    transition$$1
        .on("start.zoom", function() { gesture(this, arguments).start(); })
        .on("interrupt.zoom end.zoom", function() { gesture(this, arguments).end(); })
        .tween("zoom", function() {
          var that = this,
              args = arguments,
              g = gesture(that, args),
              e = extent.apply(that, args),
              p = center || centroid(e),
              w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]),
              a = that.__zoom,
              b = typeof transform$$1 === "function" ? transform$$1.apply(that, args) : transform$$1,
              i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
          return function(t) {
            if (t === 1) t = b; // Avoid rounding error on end.
            else { var l = i(t), k = w / l[2]; t = new Transform(k, p[0] - l[0] * k, p[1] - l[1] * k); }
            g.zoom(null, t);
          };
        });
  }

  function gesture(that, args) {
    for (var i = 0, n = gestures.length, g; i < n; ++i) {
      if ((g = gestures[i]).that === that) {
        return g;
      }
    }
    return new Gesture(that, args);
  }

  function Gesture(that, args) {
    this.that = that;
    this.args = args;
    this.index = -1;
    this.active = 0;
    this.extent = extent.apply(that, args);
  }

  Gesture.prototype = {
    start: function() {
      if (++this.active === 1) {
        this.index = gestures.push(this) - 1;
        this.emit("start");
      }
      return this;
    },
    zoom: function(key, transform$$1) {
      if (this.mouse && key !== "mouse") this.mouse[1] = transform$$1.invert(this.mouse[0]);
      if (this.touch0 && key !== "touch") this.touch0[1] = transform$$1.invert(this.touch0[0]);
      if (this.touch1 && key !== "touch") this.touch1[1] = transform$$1.invert(this.touch1[0]);
      this.that.__zoom = transform$$1;
      this.emit("zoom");
      return this;
    },
    end: function() {
      if (--this.active === 0) {
        gestures.splice(this.index, 1);
        this.index = -1;
        this.emit("end");
      }
      return this;
    },
    emit: function(type) {
      customEvent(new ZoomEvent(zoom, type, this.that.__zoom), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function wheeled() {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        t = this.__zoom,
        k = Math.max(k0, Math.min(k1, t.k * Math.pow(2, wheelDelta.apply(this, arguments)))),
        p = mouse(this);

    // If the mouse is in the same location as before, reuse it.
    // If there were recent wheel events, reset the wheel idle timeout.
    if (g.wheel) {
      if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) {
        g.mouse[1] = t.invert(g.mouse[0] = p);
      }
      clearTimeout(g.wheel);
    }

    // If this wheel event won’t trigger a transform change, ignore it.
    else if (t.k === k) return;

    // Otherwise, capture the mouse point and location at the start.
    else {
      g.mouse = [p, t.invert(p)];
      interrupt(this);
      g.start();
    }

    noevent$2();
    g.wheel = setTimeout(wheelidled, wheelDelay);
    g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent));

    function wheelidled() {
      g.wheel = null;
      g.end();
    }
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        v = select(exports.event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true),
        p = mouse(this),
        x0 = exports.event.clientX,
        y0 = exports.event.clientY;

    dragDisable(exports.event.view);
    nopropagation$2();
    g.mouse = [p, this.__zoom.invert(p)];
    interrupt(this);
    g.start();

    function mousemoved() {
      noevent$2();
      if (!g.moved) {
        var dx = exports.event.clientX - x0, dy = exports.event.clientY - y0;
        g.moved = dx * dx + dy * dy > clickDistance2;
      }
      g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = mouse(g.that), g.mouse[1]), g.extent));
    }

    function mouseupped() {
      v.on("mousemove.zoom mouseup.zoom", null);
      yesdrag(exports.event.view, g.moved);
      noevent$2();
      g.end();
    }
  }

  function dblclicked() {
    if (!filter.apply(this, arguments)) return;
    var t0 = this.__zoom,
        p0 = mouse(this),
        p1 = t0.invert(p0),
        k1 = t0.k * (exports.event.shiftKey ? 0.5 : 2),
        t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments));

    noevent$2();
    if (duration > 0) select(this).transition().duration(duration).call(schedule, t1, p0);
    else select(this).call(zoom.transform, t1);
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        touches$$1 = exports.event.changedTouches,
        started,
        n = touches$$1.length, i, t, p;

    nopropagation$2();
    for (i = 0; i < n; ++i) {
      t = touches$$1[i], p = touch(this, touches$$1, t.identifier);
      p = [p, this.__zoom.invert(p), t.identifier];
      if (!g.touch0) g.touch0 = p, started = true;
      else if (!g.touch1) g.touch1 = p;
    }

    // If this is a dbltap, reroute to the (optional) dblclick.zoom handler.
    if (touchstarting) {
      touchstarting = clearTimeout(touchstarting);
      if (!g.touch1) {
        g.end();
        p = select(this).on("dblclick.zoom");
        if (p) p.apply(this, arguments);
        return;
      }
    }

    if (started) {
      touchstarting = setTimeout(function() { touchstarting = null; }, touchDelay);
      interrupt(this);
      g.start();
    }
  }

  function touchmoved() {
    var g = gesture(this, arguments),
        touches$$1 = exports.event.changedTouches,
        n = touches$$1.length, i, t, p, l;

    noevent$2();
    if (touchstarting) touchstarting = clearTimeout(touchstarting);
    for (i = 0; i < n; ++i) {
      t = touches$$1[i], p = touch(this, touches$$1, t.identifier);
      if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
      else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
    }
    t = g.that.__zoom;
    if (g.touch1) {
      var p0 = g.touch0[0], l0 = g.touch0[1],
          p1 = g.touch1[0], l1 = g.touch1[1],
          dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp,
          dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
      t = scale(t, Math.sqrt(dp / dl));
      p = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
      l = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
    }
    else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
    else return;
    g.zoom("touch", constrain(translate(t, p, l), g.extent));
  }

  function touchended() {
    var g = gesture(this, arguments),
        touches$$1 = exports.event.changedTouches,
        n = touches$$1.length, i, t;

    nopropagation$2();
    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, touchDelay);
    for (i = 0; i < n; ++i) {
      t = touches$$1[i];
      if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
      else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
    }
    if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
    if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
    else g.end();
  }

  zoom.wheelDelta = function(_) {
    return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : constant$12(+_), zoom) : wheelDelta;
  };

  zoom.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$12(!!_), zoom) : filter;
  };

  zoom.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : constant$12([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), zoom) : extent;
  };

  zoom.scaleExtent = function(_) {
    return arguments.length ? (k0 = +_[0], k1 = +_[1], zoom) : [k0, k1];
  };

  zoom.translateExtent = function(_) {
    return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], zoom) : [[x0, y0], [x1, y1]];
  };

  zoom.duration = function(_) {
    return arguments.length ? (duration = +_, zoom) : duration;
  };

  zoom.interpolate = function(_) {
    return arguments.length ? (interpolate = _, zoom) : interpolate;
  };

  zoom.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? zoom : value;
  };

  zoom.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
  };

  return zoom;
};

exports.version = version;
exports.bisect = bisectRight;
exports.bisectRight = bisectRight;
exports.bisectLeft = bisectLeft;
exports.ascending = ascending;
exports.bisector = bisector;
exports.cross = cross;
exports.descending = descending;
exports.deviation = deviation;
exports.extent = extent;
exports.histogram = histogram;
exports.thresholdFreedmanDiaconis = freedmanDiaconis;
exports.thresholdScott = scott;
exports.thresholdSturges = sturges;
exports.max = max;
exports.mean = mean;
exports.median = median;
exports.merge = merge;
exports.min = min;
exports.pairs = pairs;
exports.permute = permute;
exports.quantile = threshold;
exports.range = sequence;
exports.scan = scan;
exports.shuffle = shuffle;
exports.sum = sum;
exports.ticks = ticks;
exports.tickIncrement = tickIncrement;
exports.tickStep = tickStep;
exports.transpose = transpose;
exports.variance = variance;
exports.zip = zip;
exports.axisTop = axisTop;
exports.axisRight = axisRight;
exports.axisBottom = axisBottom;
exports.axisLeft = axisLeft;
exports.brush = brush;
exports.brushX = brushX;
exports.brushY = brushY;
exports.brushSelection = brushSelection;
exports.chord = chord;
exports.ribbon = ribbon;
exports.nest = nest;
exports.set = set$2;
exports.map = map$1;
exports.keys = keys;
exports.values = values;
exports.entries = entries;
exports.color = color;
exports.rgb = rgb;
exports.hsl = hsl;
exports.lab = lab;
exports.hcl = hcl;
exports.cubehelix = cubehelix;
exports.dispatch = dispatch;
exports.drag = drag;
exports.dragDisable = dragDisable;
exports.dragEnable = yesdrag;
exports.dsvFormat = dsv;
exports.csvParse = csvParse;
exports.csvParseRows = csvParseRows;
exports.csvFormat = csvFormat;
exports.csvFormatRows = csvFormatRows;
exports.tsvParse = tsvParse;
exports.tsvParseRows = tsvParseRows;
exports.tsvFormat = tsvFormat;
exports.tsvFormatRows = tsvFormatRows;
exports.easeLinear = linear$1;
exports.easeQuad = quadInOut;
exports.easeQuadIn = quadIn;
exports.easeQuadOut = quadOut;
exports.easeQuadInOut = quadInOut;
exports.easeCubic = cubicInOut;
exports.easeCubicIn = cubicIn;
exports.easeCubicOut = cubicOut;
exports.easeCubicInOut = cubicInOut;
exports.easePoly = polyInOut;
exports.easePolyIn = polyIn;
exports.easePolyOut = polyOut;
exports.easePolyInOut = polyInOut;
exports.easeSin = sinInOut;
exports.easeSinIn = sinIn;
exports.easeSinOut = sinOut;
exports.easeSinInOut = sinInOut;
exports.easeExp = expInOut;
exports.easeExpIn = expIn;
exports.easeExpOut = expOut;
exports.easeExpInOut = expInOut;
exports.easeCircle = circleInOut;
exports.easeCircleIn = circleIn;
exports.easeCircleOut = circleOut;
exports.easeCircleInOut = circleInOut;
exports.easeBounce = bounceOut;
exports.easeBounceIn = bounceIn;
exports.easeBounceOut = bounceOut;
exports.easeBounceInOut = bounceInOut;
exports.easeBack = backInOut;
exports.easeBackIn = backIn;
exports.easeBackOut = backOut;
exports.easeBackInOut = backInOut;
exports.easeElastic = elasticOut;
exports.easeElasticIn = elasticIn;
exports.easeElasticOut = elasticOut;
exports.easeElasticInOut = elasticInOut;
exports.forceCenter = center$1;
exports.forceCollide = collide;
exports.forceLink = link;
exports.forceManyBody = manyBody;
exports.forceSimulation = simulation;
exports.forceX = x$2;
exports.forceY = y$2;
exports.formatDefaultLocale = defaultLocale;
exports.formatLocale = formatLocale;
exports.formatSpecifier = formatSpecifier;
exports.precisionFixed = precisionFixed;
exports.precisionPrefix = precisionPrefix;
exports.precisionRound = precisionRound;
exports.geoArea = area;
exports.geoBounds = bounds;
exports.geoCentroid = centroid;
exports.geoCircle = circle;
exports.geoClipExtent = extent$1;
exports.geoContains = contains;
exports.geoDistance = distance;
exports.geoGraticule = graticule;
exports.geoGraticule10 = graticule10;
exports.geoInterpolate = interpolate$1;
exports.geoLength = length$1;
exports.geoPath = index$1;
exports.geoAlbers = albers;
exports.geoAlbersUsa = albersUsa;
exports.geoAzimuthalEqualArea = azimuthalEqualArea;
exports.geoAzimuthalEqualAreaRaw = azimuthalEqualAreaRaw;
exports.geoAzimuthalEquidistant = azimuthalEquidistant;
exports.geoAzimuthalEquidistantRaw = azimuthalEquidistantRaw;
exports.geoConicConformal = conicConformal;
exports.geoConicConformalRaw = conicConformalRaw;
exports.geoConicEqualArea = conicEqualArea;
exports.geoConicEqualAreaRaw = conicEqualAreaRaw;
exports.geoConicEquidistant = conicEquidistant;
exports.geoConicEquidistantRaw = conicEquidistantRaw;
exports.geoEquirectangular = equirectangular;
exports.geoEquirectangularRaw = equirectangularRaw;
exports.geoGnomonic = gnomonic;
exports.geoGnomonicRaw = gnomonicRaw;
exports.geoIdentity = identity$5;
exports.geoProjection = projection;
exports.geoProjectionMutator = projectionMutator;
exports.geoMercator = mercator;
exports.geoMercatorRaw = mercatorRaw;
exports.geoOrthographic = orthographic;
exports.geoOrthographicRaw = orthographicRaw;
exports.geoStereographic = stereographic;
exports.geoStereographicRaw = stereographicRaw;
exports.geoTransverseMercator = transverseMercator;
exports.geoTransverseMercatorRaw = transverseMercatorRaw;
exports.geoRotation = rotation;
exports.geoStream = geoStream;
exports.geoTransform = transform;
exports.cluster = cluster;
exports.hierarchy = hierarchy;
exports.pack = index$2;
exports.packSiblings = siblings;
exports.packEnclose = enclose;
exports.partition = partition;
exports.stratify = stratify;
exports.tree = tree;
exports.treemap = index$3;
exports.treemapBinary = binary;
exports.treemapDice = treemapDice;
exports.treemapSlice = treemapSlice;
exports.treemapSliceDice = sliceDice;
exports.treemapSquarify = squarify;
exports.treemapResquarify = resquarify;
exports.interpolate = interpolateValue;
exports.interpolateArray = array$1;
exports.interpolateBasis = basis$1;
exports.interpolateBasisClosed = basisClosed;
exports.interpolateDate = date;
exports.interpolateNumber = reinterpolate;
exports.interpolateObject = object;
exports.interpolateRound = interpolateRound;
exports.interpolateString = interpolateString;
exports.interpolateTransformCss = interpolateTransformCss;
exports.interpolateTransformSvg = interpolateTransformSvg;
exports.interpolateZoom = interpolateZoom;
exports.interpolateRgb = interpolateRgb;
exports.interpolateRgbBasis = rgbBasis;
exports.interpolateRgbBasisClosed = rgbBasisClosed;
exports.interpolateHsl = hsl$2;
exports.interpolateHslLong = hslLong;
exports.interpolateLab = lab$1;
exports.interpolateHcl = hcl$2;
exports.interpolateHclLong = hclLong;
exports.interpolateCubehelix = cubehelix$2;
exports.interpolateCubehelixLong = cubehelixLong;
exports.quantize = quantize;
exports.path = path;
exports.polygonArea = area$1;
exports.polygonCentroid = centroid$1;
exports.polygonHull = hull;
exports.polygonContains = contains$1;
exports.polygonLength = length$2;
exports.quadtree = quadtree;
exports.queue = queue;
exports.randomUniform = uniform;
exports.randomNormal = normal;
exports.randomLogNormal = logNormal;
exports.randomBates = bates;
exports.randomIrwinHall = irwinHall;
exports.randomExponential = exponential$1;
exports.request = request;
exports.html = html;
exports.json = json;
exports.text = text;
exports.xml = xml;
exports.csv = csv$1;
exports.tsv = tsv$1;
exports.scaleBand = band;
exports.scalePoint = point$1;
exports.scaleIdentity = identity$6;
exports.scaleLinear = linear$2;
exports.scaleLog = log$1;
exports.scaleOrdinal = ordinal;
exports.scaleImplicit = implicit;
exports.scalePow = pow$1;
exports.scaleSqrt = sqrt$1;
exports.scaleQuantile = quantile;
exports.scaleQuantize = quantize$1;
exports.scaleThreshold = threshold$1;
exports.scaleTime = time;
exports.scaleUtc = utcTime;
exports.schemeCategory10 = category10;
exports.schemeCategory20b = category20b;
exports.schemeCategory20c = category20c;
exports.schemeCategory20 = category20;
exports.interpolateCubehelixDefault = cubehelix$3;
exports.interpolateRainbow = rainbow$1;
exports.interpolateWarm = warm;
exports.interpolateCool = cool;
exports.interpolateViridis = viridis;
exports.interpolateMagma = magma;
exports.interpolateInferno = inferno;
exports.interpolatePlasma = plasma;
exports.scaleSequential = sequential;
exports.creator = creator;
exports.local = local$1;
exports.matcher = matcher$1;
exports.mouse = mouse;
exports.namespace = namespace;
exports.namespaces = namespaces;
exports.select = select;
exports.selectAll = selectAll;
exports.selection = selection;
exports.selector = selector;
exports.selectorAll = selectorAll;
exports.style = styleValue;
exports.touch = touch;
exports.touches = touches;
exports.window = defaultView;
exports.customEvent = customEvent;
exports.arc = arc;
exports.area = area$2;
exports.line = line;
exports.pie = pie;
exports.areaRadial = areaRadial;
exports.radialArea = areaRadial;
exports.lineRadial = lineRadial$1;
exports.radialLine = lineRadial$1;
exports.pointRadial = pointRadial;
exports.linkHorizontal = linkHorizontal;
exports.linkVertical = linkVertical;
exports.linkRadial = linkRadial;
exports.symbol = symbol;
exports.symbols = symbols;
exports.symbolCircle = circle$2;
exports.symbolCross = cross$2;
exports.symbolDiamond = diamond;
exports.symbolSquare = square;
exports.symbolStar = star;
exports.symbolTriangle = triangle;
exports.symbolWye = wye;
exports.curveBasisClosed = basisClosed$1;
exports.curveBasisOpen = basisOpen;
exports.curveBasis = basis$2;
exports.curveBundle = bundle;
exports.curveCardinalClosed = cardinalClosed;
exports.curveCardinalOpen = cardinalOpen;
exports.curveCardinal = cardinal;
exports.curveCatmullRomClosed = catmullRomClosed;
exports.curveCatmullRomOpen = catmullRomOpen;
exports.curveCatmullRom = catmullRom;
exports.curveLinearClosed = linearClosed;
exports.curveLinear = curveLinear;
exports.curveMonotoneX = monotoneX;
exports.curveMonotoneY = monotoneY;
exports.curveNatural = natural;
exports.curveStep = step;
exports.curveStepAfter = stepAfter;
exports.curveStepBefore = stepBefore;
exports.stack = stack;
exports.stackOffsetExpand = expand;
exports.stackOffsetDiverging = diverging;
exports.stackOffsetNone = none$1;
exports.stackOffsetSilhouette = silhouette;
exports.stackOffsetWiggle = wiggle;
exports.stackOrderAscending = ascending$2;
exports.stackOrderDescending = descending$2;
exports.stackOrderInsideOut = insideOut;
exports.stackOrderNone = none$2;
exports.stackOrderReverse = reverse;
exports.timeInterval = newInterval;
exports.timeMillisecond = millisecond;
exports.timeMilliseconds = milliseconds;
exports.utcMillisecond = millisecond;
exports.utcMilliseconds = milliseconds;
exports.timeSecond = second;
exports.timeSeconds = seconds;
exports.utcSecond = second;
exports.utcSeconds = seconds;
exports.timeMinute = minute;
exports.timeMinutes = minutes;
exports.timeHour = hour;
exports.timeHours = hours;
exports.timeDay = day;
exports.timeDays = days;
exports.timeWeek = sunday;
exports.timeWeeks = sundays;
exports.timeSunday = sunday;
exports.timeSundays = sundays;
exports.timeMonday = monday;
exports.timeMondays = mondays;
exports.timeTuesday = tuesday;
exports.timeTuesdays = tuesdays;
exports.timeWednesday = wednesday;
exports.timeWednesdays = wednesdays;
exports.timeThursday = thursday;
exports.timeThursdays = thursdays;
exports.timeFriday = friday;
exports.timeFridays = fridays;
exports.timeSaturday = saturday;
exports.timeSaturdays = saturdays;
exports.timeMonth = month;
exports.timeMonths = months;
exports.timeYear = year;
exports.timeYears = years;
exports.utcMinute = utcMinute;
exports.utcMinutes = utcMinutes;
exports.utcHour = utcHour;
exports.utcHours = utcHours;
exports.utcDay = utcDay;
exports.utcDays = utcDays;
exports.utcWeek = utcSunday;
exports.utcWeeks = utcSundays;
exports.utcSunday = utcSunday;
exports.utcSundays = utcSundays;
exports.utcMonday = utcMonday;
exports.utcMondays = utcMondays;
exports.utcTuesday = utcTuesday;
exports.utcTuesdays = utcTuesdays;
exports.utcWednesday = utcWednesday;
exports.utcWednesdays = utcWednesdays;
exports.utcThursday = utcThursday;
exports.utcThursdays = utcThursdays;
exports.utcFriday = utcFriday;
exports.utcFridays = utcFridays;
exports.utcSaturday = utcSaturday;
exports.utcSaturdays = utcSaturdays;
exports.utcMonth = utcMonth;
exports.utcMonths = utcMonths;
exports.utcYear = utcYear;
exports.utcYears = utcYears;
exports.timeFormatDefaultLocale = defaultLocale$1;
exports.timeFormatLocale = formatLocale$1;
exports.isoFormat = formatIso;
exports.isoParse = parseIso;
exports.now = now;
exports.timer = timer;
exports.timerFlush = timerFlush;
exports.timeout = timeout$1;
exports.interval = interval$1;
exports.transition = transition;
exports.active = active;
exports.interrupt = interrupt;
exports.voronoi = voronoi;
exports.zoom = zoom;
exports.zoomTransform = transform$1;
exports.zoomIdentity = identity$8;

Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _getIterator = __webpack_require__(8)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = forEach;

var _isIterable = __webpack_require__(86);

var _isIterable2 = _interopRequireDefault(_isIterable);

var _isIterator = __webpack_require__(87);

var _isIterator2 = _interopRequireDefault(_isIterator);

/**
 * Helper to iterate over sequence types (arrays, array-like objects,
 * objects, etc)
 *
 * @param {Iterable} seq
 * @param {function(this:T, ...)} callback
 * @param {T=} optThisObj
 * @template T
 */

function forEach(seq, callback, optThisObj) {
  if (Array.isArray(seq)) {
    var _i = 0;
    var l = seq.length;
    if (optThisObj) {
      for (; _i < l; _i++) {
        callback.call(optThisObj, seq[_i], _i);
      }
    } else {
      for (; _i < l; _i++) {
        callback(seq[_i], _i);
      }
    }
    return;
  }
  if ((0, _isIterable2['default'])(seq)) {
    seq = _getIterator(seq);
  }
  if ((0, _isIterator2['default'])(seq)) {
    var v;
    var i;
    // Avoiding call if it is not necessary is faster in some browsers
    if (optThisObj !== undefined) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _getIterator(seq), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          v = _step.value;

          i += 1;
          callback.call(optThisObj, v, i);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator['return']) {
            _iterator['return']();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } else {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = _getIterator(seq), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          v = _step2.value;

          i += 1;
          callback(v, i);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2['return']) {
            _iterator2['return']();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  } else if (seq && typeof seq === 'object') {
    if (optThisObj) {
      for (var prop in seq) {
        callback.call(optThisObj, seq[prop], prop);
      }
    } else {
      for (var prop in seq) {
        callback(seq[prop], prop);
      }
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = isGraph;
/**
 * Returns true if value is a Graph
 *
 * @param {*} value
 * @return {bool}
 */

function isGraph(value) {
  // We are not using instanceof to avoid circular dependencies
  return value && typeof value.addNode === 'function';
}

module.exports = exports['default'];

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(16)['default'];

var _Object$create = __webpack_require__(115)['default'];

var _Array$from = __webpack_require__(13)['default'];

var _getIterator = __webpack_require__(8)['default'];

var _regeneratorRuntime = __webpack_require__(19)['default'];

var _interopRequireWildcard = __webpack_require__(25)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.toNetworkxGraph = toNetworkxGraph;
exports.convertToUndirected = convertToUndirected;
exports.convertToDirected = convertToDirected;
exports.toDictOfLists = toDictOfLists;
exports.fromDictOfLists = fromDictOfLists;
exports.toDictOfDicts = toDictOfDicts;
exports.fromDictOfDicts = fromDictOfDicts;
exports.toEdgelist = toEdgelist;
exports.fromEdgelist = fromEdgelist;
/**
 * This module provides functions to convert
 * NetworkX graphs to and from other formats.
 *
 * The preferred way of converting data to a NetworkX graph
 * is through the graph constuctor.  The constructor calls
 * the to_networkx_graph() function which attempts to guess the
 * input type and convert it automatically.
 */

var _contribConvert = __webpack_require__(761);

var convertMap = _interopRequireWildcard(_contribConvert);

var _contribPrepCreateUsing = __webpack_require__(359);

var _contribPrepCreateUsing2 = _interopRequireDefault(_contribPrepCreateUsing);

var _lodashObjectMapValues = __webpack_require__(384);

var _lodashObjectMapValues2 = _interopRequireDefault(_lodashObjectMapValues);

var _internals = __webpack_require__(15);

var hasOwn = Object.prototype.hasOwnProperty;

/**
 * Make a JSNetworkX graph from a known data structure.
 *
 * The preferred way to call this is automatically from the class constructor
 *
 * ```
 * var data = {0: {1 : {weight: 1}}} // object of objects single edge (0,1)
 * var G = new jsnx.Graph(d);
 * ```
 *
 * instead of the equivalent
 *
 * ```
 * var G = jsnx.fromDictOfDicts(d);
 * ```
 *
 * @param {?} data An object to be converted
 *   Current accepts types are:
 *
 *   - any JSNetworkX graph
 *   - object of objects
 *   - object of lists
 *   - list of edges
 *
 * @param {Graph=} optCreateUsing NetworkX graph
 *     Use specified graph for result.  Otherwise a new graph is created.
 * @param {boolean=} optMultigraphInput
 *     If `true` and  `data` is an object of objects,
 *     try to create a multigraph assuming object of objects of lists
 *     If data and createUsing are both multigraphs then create
 *     a multigraph from a multigraph.
 * @return {Graph}
 */

function toNetworkxGraph(data, optCreateUsing) {
  var optMultigraphInput = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

  var result = null;

  // jsnx graph
  if (hasOwn.call(data, 'adj')) {
    try {
      result = convertMap.fromMapOfMaps(data.adj, optCreateUsing, data.isMultigraph());
      if (hasOwn.call(data, 'graph') && typeof data.graph === 'object') {
        result.graph = (0, _internals.clone)(data.graph);
      }
      if (hasOwn.call(data, 'node') && (0, _internals.isMap)(data.node)) {
        result.node = new _internals.Map();
        data.node.forEach(function (element, k) {
          return result.node.set(k, (0, _internals.clone)(element));
        });
      }
      return result;
    } catch (ex) {
      throw ex;
    }
  }

  // map of maps / lists
  if ((0, _internals.isMap)(data)) {
    try {
      return convertMap.fromMapOfMaps(data, optCreateUsing, optMultigraphInput);
    } catch (e) {
      try {
        return convertMap.fromMapOfLists(data, optCreateUsing);
      } catch (ex) {
        throw new Error('Map data structure cannot be converted to a graph.');
      }
    }
  }

  // dict of dicts / lists
  if ((0, _internals.isPlainObject)(data)) {
    try {
      return fromDictOfDicts(data, optCreateUsing, optMultigraphInput);
    } catch (e) {
      try {
        return fromDictOfLists(data, optCreateUsing);
      } catch (ex) {
        throw new Error('Object data structure cannot be converted to a graph.');
      }
    }
  }

  // list of edges
  if ((0, _internals.isArrayLike)(data)) {
    try {
      return fromEdgelist(data, optCreateUsing);
    } catch (e) {
      throw new Error('Input is not a valid edge list');
    }
  }

  return result;
}

/**
 * Return a new undirected representation of the graph G.
 *
 * @param {Graph} G Graph to convert
 * @return {!Graph}
 */

function convertToUndirected(G) {
  return G.toUndirected();
}

/**
 * Return a new directed representation of the graph G.
 *
 * @param {Graph} G Graph to convert
 * @return {!Graph}
 */

function convertToDirected(G) {
  return G.toDirected();
}

/**
 * Return adjacency representation of graph as a dictionary of lists.
 *
 * Completely ignores edge data for MultiGraph and MultiDiGraph.
 *
 * @param {Graph} G A JSNetworkX graph
 * @param {Iterable=} optNodelist Use only nodes specified in nodelist
 *
 * @return {!Object.<Array>}
 */

function toDictOfLists(G, optNodelist) {
  var contains = function contains(n) {
    return optNodelist.indexOf(n) > -1;
  };
  var d = _Object$create(null);

  if (optNodelist == null) {
    optNodelist = G;
    contains = function (n) {
      return optNodelist.hasNode(n);
    };
  } else {
    optNodelist = _Array$from(optNodelist);
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _getIterator(optNodelist), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var n = _step.value;

      d[n] = G.neighbors(n).filter(contains);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator['return']) {
        _iterator['return']();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return d;
}

/**
 * Return a graph from a dictionary of lists.
 *
 * ### Examples
 *
 * ```
 * var data = {0: [1]}; // single edge (0,1)
 * var G = jsnx.fromDictOfLists(data);
 * // or
 * var G = new jsnx.Graph(data);
 * ```
 *
 * @param {!Object.<Array>} d A dictionary of lists adjacency representation.
 * @param {Graph=} optCreateUsing Use specified graph for result.
 *    Otherwise a new graph is created.
 * @return {!Graph}
 */

function fromDictOfLists(d, optCreateUsing) {
  var G = (0, _contribPrepCreateUsing2['default'])(optCreateUsing);

  // Convert numeric property names to numbers
  G.addNodesFrom(_regeneratorRuntime.mark(function callee$1$0() {
    var n;
    return _regeneratorRuntime.wrap(function callee$1$0$(context$2$0) {
      while (1) switch (context$2$0.prev = context$2$0.next) {
        case 0:
          context$2$0.t0 = _regeneratorRuntime.keys(d);

        case 1:
          if ((context$2$0.t1 = context$2$0.t0()).done) {
            context$2$0.next = 7;
            break;
          }

          n = context$2$0.t1.value;
          context$2$0.next = 5;
          return isNaN(n) ? n : +n;

        case 5:
          context$2$0.next = 1;
          break;

        case 7:
        case 'end':
          return context$2$0.stop();
      }
    }, callee$1$0, this);
  })());

  var node;
  var nbrlist;
  if (G.isMultigraph() && !G.isDirected()) {
    // a dict_of_lists can't show multiedges.  BUT for undirected graphs,
    // each edge shows up twice in the dict_of_lists.
    // So we need to treat this case separately.
    var seen = new _internals.Set();

    for (node in d) {
      nbrlist = d[node];
      // treat numeric keys like numbers
      node = isNaN(node) ? node : +node;
      /*eslint no-loop-func:0*/
      (0, _internals.forEach)(nbrlist, function (nbr) {
        if (!seen.has(nbr)) {
          G.addEdge(node, nbr);
        }
      });
      seen.add(node); // don't allow reverse edge to show up
    }
  } else {
    var edgeList = [];
    for (node in d) {
      nbrlist = d[node];
      // treat numeric keys like numbers
      node = isNaN(node) ? node : +node;
      (0, _internals.forEach)(nbrlist, function (nbr) {
        edgeList.push([node, nbr]);
      });
    }

    G.addEdgesFrom(edgeList);
  }

  return G;
}

/**
 * Return adjacency representation of graph as a dictionary of dictionaries.
 *
 * @param {Graph} G A jsnx Graph
 * @param {Iterable=} optNodelist Use only nodes specified in nodelist
 * @param {Object=} optEdgeData If provided,  the value of the dictionary will
 *      be set to edgeData for all edges.  This is useful to make
 *      an adjacency matrix type representation with 1 as the edge data.
 *      If edgedata is null or undefined, the edgedata in G is used to fill
 *      the values.
 *      If G is a multigraph, the edgedata is a dict for each pair (u,v).
 * @return {!Object.<Object>}
 */

function toDictOfDicts(G, optNodelist, optEdgeData) {
  var dod = {};

  if (optNodelist != null) {
    optNodelist = _Array$from(optNodelist);
    if (optEdgeData != null) {
      optNodelist.forEach(function (u) {
        dod[u] = {};
        G.get(u).forEach(function (data, v) {
          if (optNodelist.indexOf(v) > -1) {
            dod[u][v] = optEdgeData;
          }
        });
      });
    } else {
      // nodelist and edgeData are defined
      optNodelist.forEach(function (u) {
        dod[u] = {};
        G.get(u).forEach(function (data, v) {
          if (optNodelist.indexOf(v) > -1) {
            dod[u][v] = data;
          }
        });
      });
    }
  } else {
    // nodelist is undefined
    if (optEdgeData != null) {
      // dn = [nbrdict, u]
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = _getIterator(G.adjacencyIter()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _step2$value = _slicedToArray(_step2.value, 2);

          var nbrdict = _step2$value[0];
          var u = _step2$value[1];

          /*jshint loopfunc:true*/
          dod[u] = (0, _lodashObjectMapValues2['default'])(nbrdict, function () {
            return optEdgeData;
          });
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2['return']) {
            _iterator2['return']();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    } else {
      // edge_data is defined
      // dn = [nbrdict, u]
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = _getIterator(G.adjacencyIter()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _step3$value = _slicedToArray(_step3.value, 2);

          var nbrdict = _step3$value[0];
          var u = _step3$value[1];

          dod[u] = (0, _internals.clone)(nbrdict);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3['return']) {
            _iterator3['return']();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }

  return dod;
}

/**
 * Return a graph from a dictionary of dictionaries.
 *
 *
 * ### Examples
 *
 * ```
 * var data = {0: {1: {weight: 1}}}; // single edge (0,1)
 * var G = jsnx.fromDictOfDicts(data);
 * // or
 * var G = new jsnx.Graph(data);
 * ```
 *
 * @param {!Object.<!Object>} d A dictionary of dictionaries adjacency
 *      representation.
 * @param {Graph=} optCreateUsing Use specified graph for result.
 *      Otherwise a new graph is created.
 * @param {boolean=} optMultigraphInput
 *      When `true`, the values of the inner object are assumed
 *      to be containers of edge data for multiple edges.
 *      Otherwise this routine assumes the edge data are singletons.
 *
 * @return {Graph}
 */

function fromDictOfDicts(d, optCreateUsing) {
  var optMultigraphInput = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

  var G = (0, _contribPrepCreateUsing2['default'])(optCreateUsing);
  var seen = new _internals.Set();

  // Convert numeric property names to numbers
  G.addNodesFrom(_regeneratorRuntime.mark(function callee$1$0() {
    var n;
    return _regeneratorRuntime.wrap(function callee$1$0$(context$2$0) {
      while (1) switch (context$2$0.prev = context$2$0.next) {
        case 0:
          context$2$0.t0 = _regeneratorRuntime.keys(d);

        case 1:
          if ((context$2$0.t1 = context$2$0.t0()).done) {
            context$2$0.next = 7;
            break;
          }

          n = context$2$0.t1.value;
          context$2$0.next = 5;
          return isNaN(n) ? n : +n;

        case 5:
          context$2$0.next = 1;
          break;

        case 7:
        case 'end':
          return context$2$0.stop();
      }
    }, callee$1$0, this);
  })());

  // is dict a MultiGraph or MultiDiGraph?
  if (optMultigraphInput) {
    // make a copy  of the list of edge data (but not the edge data)
    if (G.isDirected()) {
      for (var u in d) {
        var nbrs = d[u];
        if ((0, _internals.isArrayLike)(nbrs)) {
          // throw exception of not dict (object)
          throw new TypeError('Inner object seems to be an array');
        }
        // treat numeric keys like numbers
        u = isNaN(u) ? u : +u;
        for (var v in nbrs) {
          var datadict = nbrs[v];
          // treat numeric keys like numbers
          v = isNaN(v) ? v : +v;
          for (var key in datadict) {
            if (G.isMultigraph()) {
              G.addEdge(u, v, key, datadict[key]);
            } else {
              G.addEdge(u, v, datadict[key]);
            }
          }
        }
      }
    } else {
      // undirected
      // don't add both directions of undirected graph
      for (var u in d) {
        var nbrs = d[u];
        if ((0, _internals.isArrayLike)(nbrs)) {
          // throw exception of not dict (object)
          throw new TypeError('Inner object seems to be an array');
        }
        // treat numeric keys like numbers
        u = isNaN(u) ? u : +u;
        for (var v in nbrs) {
          var datadict = nbrs[v];
          // treat numeric keys like numbers
          v = isNaN(v) ? v : +v;
          if (!seen.has([u, v])) {
            for (var key in datadict) {
              if (G.isMultigraph()) {
                G.addEdge(u, v, key, datadict[key]);
              } else {
                G.addEdge(u, v, datadict[key]);
              }
            }
            seen.add([v, u]);
          }
        }
      }
    }
  } else {
    // not a multigraph to multigraph transfer
    if (G.isMultigraph() && !G.isDirected()) {
      // d can have both representations u-v, v-u in dict.  Only add one.
      // We don't need this check for digraphs since we add both directions,
      // or for Graph() since it is done implicitly (parallel edges not allowed)
      for (var u in d) {
        var nbrs = d[u];
        if ((0, _internals.isArrayLike)(nbrs)) {
          // throw exception of not dict (object)
          throw new TypeError('Inner object seems to be an array');
        }
        // treat numeric keys like numbers
        u = isNaN(u) ? u : +u;
        for (var v in nbrs) {
          var data = nbrs[v];
          v = isNaN(v) ? v : +v;
          if (!seen.has([u, v])) {
            G.addEdge(u, v, data);
            seen.add([v, u]);
          }
        }
      }
    } else {
      for (var u in d) {
        var nbrs = d[u];
        if ((0, _internals.isArrayLike)(nbrs)) {
          // throw exception of not dict (object)
          throw new TypeError('Inner object seems to be an array');
        }
        // treat numeric keys like numbers
        u = isNaN(u) ? u : +u;
        for (var v in nbrs) {
          var data = nbrs[v];
          // treat numeric keys like numbers
          v = isNaN(v) ? v : +v;
          G.addEdge(u, v, data);
        }
      }
    }
  }

  return G;
}

/**
 * Return a list of edges in the graph.
 *
 * @param {Graph} G A JSNetworkX graph
 * @param {Iterable=} optNodelist Use only nodes specified in nodelist
 * @return {!Array}
 */

function toEdgelist(G, optNodelist) {
  if (optNodelist != null) {
    return G.edges(optNodelist, true);
  } else {
    return G.edges(null, true);
  }
}

/**
 * Return a graph from a list of edges.
 *
 * @param {Array.<Array>} edgelist Edge tuples
 * @param {Graph=} optCreateUsing Use specified graph for result.
 *      Otherwise a new graph is created.
 * @return {!Graph}
 */

function fromEdgelist(edgelist, optCreateUsing) {
  var G = (0, _contribPrepCreateUsing2['default'])(optCreateUsing);
  G.addEdgesFrom(edgelist);
  return G;
}

// NOT IMPLEMENTED

// to_numpy_matrix
// from_numpy_matrix
// to_numpy_recarray
// to_scipy_sparse_matrix
// from_scipy_sparse_matrix
// setup_module

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__(24)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var JSNetworkXException = function JSNetworkXException(message) {
  _classCallCheck(this, JSNetworkXException);

  this.name = 'JSNetworkXException';
  this.message = message;
};

exports['default'] = JSNetworkXException;
module.exports = exports['default'];

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _get = __webpack_require__(57)['default'];

var _inherits = __webpack_require__(58)['default'];

var _classCallCheck = __webpack_require__(24)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _JSNetworkXAlgorithmError2 = __webpack_require__(360);

var _JSNetworkXAlgorithmError3 = _interopRequireDefault(_JSNetworkXAlgorithmError2);

/**
 * Exception raised by algorithms trying to solve a problem
 * instance that has no feasible solution.
 * @constructor
 * @extends {JSNetworkXAlgorithmError}
 */

var JSNetworkXUnfeasible = (function (_JSNetworkXAlgorithmError) {
  _inherits(JSNetworkXUnfeasible, _JSNetworkXAlgorithmError);

  function JSNetworkXUnfeasible(message) {
    _classCallCheck(this, JSNetworkXUnfeasible);

    _get(Object.getPrototypeOf(JSNetworkXUnfeasible.prototype), 'constructor', this).call(this, message);
    this.name = 'JSNetworkXUnfeasible';
  }

  return JSNetworkXUnfeasible;
})(_JSNetworkXAlgorithmError3['default']);

exports['default'] = JSNetworkXUnfeasible;
module.exports = exports['default'];

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(526), __esModule: true };

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(531), __esModule: true };

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$defineProperty = __webpack_require__(216)["default"];

exports["default"] = function (obj, key, value) {
  if (key in obj) {
    _Object$defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

exports.__esModule = true;

/***/ }),
/* 219 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function arrayCopy(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = arrayCopy;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(386);

/**
 * A specialized version of `baseCallback` which only supports `this` binding
 * and specifying the number of arguments to provide to `func`.
 *
 * @private
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {number} [argCount] The number of arguments to provide to `func`.
 * @returns {Function} Returns the callback.
 */
function bindCallback(func, thisArg, argCount) {
  if (typeof func != 'function') {
    return identity;
  }
  if (thisArg === undefined) {
    return func;
  }
  switch (argCount) {
    case 1: return function(value) {
      return func.call(thisArg, value);
    };
    case 3: return function(value, index, collection) {
      return func.call(thisArg, value, index, collection);
    };
    case 4: return function(accumulator, value, index, collection) {
      return func.call(thisArg, accumulator, value, index, collection);
    };
    case 5: return function(value, other, key, object, source) {
      return func.call(thisArg, value, other, key, object, source);
    };
  }
  return function() {
    return func.apply(thisArg, arguments);
  };
}

module.exports = bindCallback;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(377);

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

module.exports = getLength;


/***/ }),
/* 222 */
/***/ (function(module, exports) {

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

module.exports = isIndex;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(90),
    isIndex = __webpack_require__(222),
    isObject = __webpack_require__(35);

/**
 * Checks if the provided arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
      ? (isArrayLike(object) && isIndex(index, object.length))
      : (type == 'string' && index in object)) {
    var other = object[index];
    return value === value ? (value === other) : (other !== other);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var isLength = __webpack_require__(72),
    isObjectLike = __webpack_require__(49);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dateTag] = typedArrayTags[errorTag] =
typedArrayTags[funcTag] = typedArrayTags[mapTag] =
typedArrayTags[numberTag] = typedArrayTags[objectTag] =
typedArrayTags[regexpTag] = typedArrayTags[setTag] =
typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

/** Used for native method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
function isTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
}

module.exports = isTypedArray;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var isArguments = __webpack_require__(148),
    isArray = __webpack_require__(50),
    isIndex = __webpack_require__(222),
    isLength = __webpack_require__(72),
    isObject = __webpack_require__(35);

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  if (object == null) {
    return [];
  }
  if (!isObject(object)) {
    object = Object(object);
  }
  var length = object.length;
  length = (length && isLength(length) &&
    (isArray(object) || isArguments(object)) && length) || 0;

  var Ctor = object.constructor,
      index = -1,
      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
      result = Array(length),
      skipIndexes = length > 0;

  while (++index < length) {
    result[index] = (index + '');
  }
  for (var key in object) {
    if (!(skipIndexes && isIndex(key, length)) &&
        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = keysIn;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _linkRule = __webpack_require__(399);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _RuleList = __webpack_require__(150);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StyleSheet = function () {
  function StyleSheet(styles, options) {
    _classCallCheck(this, StyleSheet);

    this.attached = false;
    this.deployed = false;
    this.linked = false;
    this.classes = {};
    this.options = _extends({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes
    });
    this.renderer = new options.Renderer(this);
    this.rules = new _RuleList2['default'](this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }

  /**
   * Attach renderable to the render tree.
   */


  _createClass(StyleSheet, [{
    key: 'attach',
    value: function attach() {
      if (this.attached) return this;
      if (!this.deployed) this.deploy();
      this.renderer.attach();
      if (!this.linked && this.options.link) this.link();
      this.attached = true;
      return this;
    }

    /**
     * Remove renderable from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      if (!this.attached) return this;
      this.renderer.detach();
      this.attached = false;
      return this;
    }

    /**
     * Add a rule to the current stylesheet.
     * Will insert a rule also after the stylesheet has been rendered first time.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, decl, options) {
      var queue = this.queue;

      // Plugins can create rules.
      // In order to preserve the right order, we need to queue all `.addRule` calls,
      // which happen after the first `rules.add()` call.

      if (this.attached && !queue) this.queue = [];

      var rule = this.rules.add(name, decl, options);
      this.options.jss.plugins.onProcessRule(rule);

      if (this.attached) {
        if (!this.deployed) return rule;
        // Don't insert rule directly if there is no stringified version yet.
        // It will be inserted all together when .attach is called.
        if (queue) queue.push(rule);else {
          this.insertRule(rule);
          if (this.queue) {
            this.queue.forEach(this.insertRule, this);
            this.queue = undefined;
          }
        }
        return rule;
      }

      // We can't add rules to a detached style node.
      // We will redeploy the sheet once user will attach it.
      this.deployed = false;

      return rule;
    }

    /**
     * Insert rule into the StyleSheet
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule) {
      var renderable = this.renderer.insertRule(rule);
      if (renderable && this.options.link) (0, _linkRule2['default'])(rule, renderable);
    }

    /**
     * Create and add rules.
     * Will render also after Style Sheet was rendered the first time.
     */

  }, {
    key: 'addRules',
    value: function addRules(styles, options) {
      var added = [];
      for (var name in styles) {
        added.push(this.addRule(name, styles[name], options));
      }
      return added;
    }

    /**
     * Get a rule by name.
     */

  }, {
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Delete a rule by name.
     * Returns `true`: if rule has been deleted from the DOM.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(name) {
      var rule = this.rules.get(name);

      if (!rule) return false;

      this.rules.remove(rule);

      if (this.attached && rule.renderable) {
        return this.renderer.deleteRule(rule.renderable);
      }

      return true;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Deploy pure CSS string to a renderable.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      this.renderer.deploy();
      this.deployed = true;
      return this;
    }

    /**
     * Link renderable CSS rules from sheet with their corresponding models.
     */

  }, {
    key: 'link',
    value: function link() {
      var cssRules = this.renderer.getRules();

      // Is undefined when VirtualRenderer is used.
      if (cssRules) this.rules.link(cssRules);
      this.linked = true;
      return this;
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'update',
    value: function update(name, data) {
      this.rules.update(name, data);
      return this;
    }

    /**
     * Convert rules to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      return this.rules.toString(options);
    }
  }]);

  return StyleSheet;
}();

exports['default'] = StyleSheet;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(229);

var _toCss2 = _interopRequireDefault(_toCss);

var _toCssValue = __webpack_require__(400);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StyleRule = function () {
  function StyleRule(key, style, options) {
    _classCallCheck(this, StyleRule);

    this.type = 'style';
    this.isProcessed = false;
    var generateClassName = options.generateClassName,
        sheet = options.sheet,
        Renderer = options.Renderer,
        selector = options.selector;

    this.key = key;
    this.options = options;
    this.style = style;
    this.selectorText = selector || '.' + generateClassName(this, sheet);
    this.renderer = sheet ? sheet.renderer : new Renderer();
  }

  /**
   * Set selector string.
   * TODO rewrite this #419
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  _createClass(StyleRule, [{
    key: 'prop',


    /**
     * Get or set a style property.
     */
    value: function prop(name, nextValue) {
      var $name = typeof this.style[name] === 'function' ? '$' + name : name;
      var currValue = this.style[$name];

      // Its a setter.
      if (nextValue != null) {
        // Don't do anything if the value has not changed.
        if (currValue !== nextValue) {
          nextValue = this.options.jss.plugins.onChangeValue(nextValue, name, this);
          Object.defineProperty(this.style, $name, {
            value: nextValue,
            writable: true
          });
          // Defined if StyleSheet option `link` is true.
          if (this.renderable) this.renderer.setStyle(this.renderable, name, nextValue);
        }
        return this;
      }

      // Its a getter, read the value from the DOM if its not cached.
      if (this.renderable && currValue == null) {
        // Cache the value after we have got it from the DOM first time.
        Object.defineProperty(this.style, $name, {
          value: this.renderer.getStyle(this.renderable, name),
          writable: true
        });
      }

      return this.style[$name];
    }

    /**
     * Apply rule to an element inline.
     */

  }, {
    key: 'applyTo',
    value: function applyTo(renderable) {
      var json = this.toJSON();
      for (var prop in json) {
        this.renderer.setStyle(renderable, prop, json[prop]);
      }return this;
    }

    /**
     * Returns JSON representation of the rule.
     * Fallbacks are not supported.
     * Useful for inline styles.
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = {};
      for (var prop in this.style) {
        var value = this.style[prop];
        var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
        if (type === 'function') json[prop] = this.style['$' + prop];else if (type !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = (0, _toCssValue2['default'])(value);
      }
      return json;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      return (0, _toCss2['default'])(this.selector, this.style, options);
    }
  }, {
    key: 'selector',
    set: function set(selector) {
      var sheet = this.options.sheet;

      // After we modify a selector, ref by old selector needs to be removed.

      if (sheet) sheet.rules.unregister(this);

      this.selectorText = selector;

      if (!this.renderable) {
        // Register the rule with new selector.
        if (sheet) sheet.rules.register(this);
        return;
      }

      var changed = this.renderer.setSelector(this.renderable, selector);

      if (changed && sheet) {
        sheet.rules.register(this);
        return;
      }

      // If selector setter is not implemented, rerender the sheet.
      // We need to delete renderable from the rule, because when sheet.deploy()
      // calls rule.toString, it will get the old selector.
      delete this.renderable;
      if (sheet) {
        sheet.rules.register(this);
        sheet.deploy().link();
      }
    }

    /**
     * Get selector string.
     */
    ,
    get: function get() {
      if (this.renderable) {
        return this.renderer.getSelector(this.renderable);
      }

      return this.selectorText;
    }
  }]);

  return StyleRule;
}();

exports['default'] = StyleRule;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SheetsRegistry = __webpack_require__(389);

var _SheetsRegistry2 = _interopRequireDefault(_SheetsRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */
exports['default'] = new _SheetsRegistry2['default']();

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCss;

var _toCssValue = __webpack_require__(400);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';
  for (var index = 0; index < indent; index++) {
    result += '  ';
  }return result + str;
}

/**
 * Converts a Rule to CSS string.
 */

function toCss(selector, style) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var result = '';

  if (!style) return result;

  var _options$indent = options.indent,
      indent = _options$indent === undefined ? 0 : _options$indent;
  var fallbacks = style.fallbacks;


  indent++;

  // Apply fallbacks first.
  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];
        for (var prop in fallback) {
          var value = fallback[prop];
          if (value != null) {
            result += '\n' + indentStr(prop + ': ' + (0, _toCssValue2['default'])(value) + ';', indent);
          }
        }
      }
    }
    // Object syntax {fallbacks: {prop: value}}
    else {
        for (var _prop in fallbacks) {
          var _value = fallbacks[_prop];
          if (_value != null) {
            result += '\n' + indentStr(_prop + ': ' + (0, _toCssValue2['default'])(_value) + ';', indent);
          }
        }
      }
  }

  var hasFunctionValue = false;

  for (var _prop2 in style) {
    var _value2 = style[_prop2];
    if (typeof _value2 === 'function') {
      _value2 = style['$' + _prop2];
      hasFunctionValue = true;
    }
    if (_value2 != null && _prop2 !== 'fallbacks') {
      result += '\n' + indentStr(_prop2 + ': ' + (0, _toCssValue2['default'])(_value2) + ';', indent);
    }
  }

  if (!result && !hasFunctionValue) return result;

  indent--;
  result = indentStr(selector + ' {' + result + '\n', indent) + indentStr('}', indent);

  return result;
}

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var babelPluginFlowReactPropTypes_proptype_Node = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_Node || __webpack_require__(0).any;

var babelPluginFlowReactPropTypes_proptype_ChildrenArray = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_ChildrenArray || __webpack_require__(0).any;

var babelPluginFlowReactPropTypes_proptype_Breakpoint = __webpack_require__(59).babelPluginFlowReactPropTypes_proptype_Breakpoint || __webpack_require__(0).any;

var babelPluginFlowReactPropTypes_proptype_HiddenProps = {
  children: typeof $ReadOnlyArray === 'function' ? __webpack_require__(0).instanceOf($ReadOnlyArray) : __webpack_require__(0).any,
  className: __webpack_require__(0).string,
  only: __webpack_require__(0).oneOfType([typeof babelPluginFlowReactPropTypes_proptype_Breakpoint === 'function' ? babelPluginFlowReactPropTypes_proptype_Breakpoint : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Breakpoint), __webpack_require__(0).arrayOf(typeof babelPluginFlowReactPropTypes_proptype_Breakpoint === 'function' ? babelPluginFlowReactPropTypes_proptype_Breakpoint : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Breakpoint))]),
  xsUp: __webpack_require__(0).bool,
  smUp: __webpack_require__(0).bool,
  mdUp: __webpack_require__(0).bool,
  lgUp: __webpack_require__(0).bool,
  xlUp: __webpack_require__(0).bool,
  xsDown: __webpack_require__(0).bool,
  smDown: __webpack_require__(0).bool,
  mdDown: __webpack_require__(0).bool,
  lgDown: __webpack_require__(0).bool,
  xlDown: __webpack_require__(0).bool
};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SvgIcon = __webpack_require__(873);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SvgIcon).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Typography = __webpack_require__(874);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Typography).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneChildrenWithClassName = cloneChildrenWithClassName;
exports.isMuiElement = isMuiElement;
exports.isMuiComponent = isMuiComponent;

var _react = __webpack_require__(1);

var babelPluginFlowReactPropTypes_proptype_ChildrenArray = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_ChildrenArray || __webpack_require__(0).any;
/* eslint-disable import/prefer-default-export */

function cloneChildrenWithClassName(children, className) {
  return _react.Children.map(children, function (child) {
    return (0, _react.isValidElement)(child) && (0, _react.cloneElement)(child, {
      className: child.props.hasOwnProperty('className') ? child.props.className + ' ' + className : className
    });
  });
}

function isMuiElement(element, muiNames) {
  return (0, _react.isValidElement)(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

function isMuiComponent(element, muiNames) {
  return muiNames.indexOf(element.muiName) !== -1;
}

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMLazyTree = __webpack_require__(91);
var Danger = __webpack_require__(910);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactInstrumentation = __webpack_require__(36);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(244);
var setInnerHTML = __webpack_require__(155);
var setTextContent = __webpack_require__(435);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(3);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var ReactErrorUtils = __webpack_require__(242);

var invariant = __webpack_require__(3);
var warning = __webpack_require__(6);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var ReactPropTypesSecret = __webpack_require__(939);
var propTypesFactory = __webpack_require__(414);

var React = __webpack_require__(94);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(3);
var warning = __webpack_require__(6);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(3);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = func.bind(null, a);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var ReactCurrentOwner = __webpack_require__(52);
var ReactInstanceMap = __webpack_require__(120);
var ReactInstrumentation = __webpack_require__(36);
var ReactUpdates = __webpack_require__(46);

var invariant = __webpack_require__(3);
var warning = __webpack_require__(6);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(23);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(12);

var emptyFunction = __webpack_require__(29);
var warning = __webpack_require__(6);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shouldUpdate = __webpack_require__(1000);

var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);

var _shallowEqual = __webpack_require__(999);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _setDisplayName = __webpack_require__(448);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(123);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pure = function pure(BaseComponent) {
  var hoc = (0, _shouldUpdate2.default)(function (props, nextProps) {
    return !(0, _shallowEqual2.default)(props, nextProps);
  });

  if (false) {
    return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

exports.default = pure;

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export seriateBySorting */
/* unused harmony export countCrossings */
/* harmony export (immutable) */ __webpack_exports__["a"] = seriateByEnergyMinimization;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__optimization__ = __webpack_require__(460);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();/* 

  BSD License:

  SVEN: Storyline Visualization Library and Demonstration

  Copyright © 2017, Battelle Memorial Institute
  All rights reserved.

  1. Battelle Memorial Institute (hereinafter Battelle) hereby grants permission
     to any person or entity lawfully obtaining a copy of this software and
     associated documentation files (hereinafter “the Software”) to redistribute
     and use the Software in source and binary forms, with or without 
     modification.  Such person or entity may use, copy, modify, merge, publish,
     distribute, sublicense, and/or sell copies of the Software, and may permit
     others to do so, subject to the following conditions:

     * Redistributions of source code must retain the above copyright notice,
       this list of conditions and the following disclaimers.
     * Redistributions in binary form must reproduce the above copyright notice,
       this list of conditions and the following disclaimer in the documentation
       and/or other materials provided with the distribution.
     * Other than as used herein, neither the name Battelle Memorial Institute
       or Battelle may be used in any form whatsoever without the express
       written consent of Battelle. 

  2. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
     AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
     THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
     PURPOSEARE DISCLAIMED. IN NO EVENT SHALL BATTELLE OR CONTRIBUTORS BE LIABLE
     FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
     DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
     SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
     CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
     LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
     OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
     DAMAGE.
     
*/var d3=__webpack_require__(209);function byY(u,v){return this.node.get(u).y-this.node.get(v).y;}function yBecomesIndex(v,i){this.node.get(v).y=i;}function edgeWeight(v,u){return this.getEdgeData(u,v).weight;}function scaledEdgeWeight(v,u){return this.node.get(u).y*this.getEdgeData(u,v).weight;}function seriateBySorting(G,nIters){nIters=nIters||5;for(var i=0;i<nIters;i++){// sort nodes by y-coordinate, then
// re-assign y-coordinate
G.nodes().sort(byY.bind(G)).forEach(yBecomesIndex.bind(G));if(i===nIters-1){return;}var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=G[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var v=_step.value;var nei=G.neighbors(v);var mass=d3.sum(nei,edgeWeight.bind(G,v));G.node.get(v).y=1.0/mass*d3.sum(nei,scaledEdgeWeight.bind(G,v));}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}}function countCrossings(G){var E=G.edges();var nCrossings=0;for(var i=0;i<E.length;i++){var e0=E[i];var y00=G.node.get(e0[0]).y;var y01=G.node.get(e0[1]).y;for(var j=i+1;j<E.length;j++){var e1=E[j];var y10=G.node.get(e1[0]).y;var y11=G.node.get(e1[1]).y;nCrossings+=y00>=y10&&y01>=y11||y00<=y10&&y01>=y11;}}return nCrossings;}function seriateByEnergyMinimization(G){// initial state: nodes sorted by their existing y value
var state=G.nodes(true).sort(function(_ref,_ref2){var _ref4=_slicedToArray(_ref,2),u=_ref4[0],du=_ref4[1];var _ref3=_slicedToArray(_ref2,2),v=_ref3[0],dv=_ref3[1];return du.y-dv.y;}).map(function(_ref5){var _ref6=_slicedToArray(_ref5,2),u=_ref6[0],du=_ref6[1];return u;});// update the y-value of the nodes in the graph
state.forEach(function(v,i){return G.node.get(v).y=i;});var _getSwapLattice1d=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__optimization__["a" /* getSwapLattice1d */])(state.length),moves=_getSwapLattice1d.moves,createApplyMove=_getSwapLattice1d.createApplyMove;var applyMove=createApplyMove(state,function(k,u,v){G.node.get(u).y=k+1;G.node.get(v).y=k;});var neighborData=function neighborData(v){return G.neighbors(v).map(function(v){return G.node.get(v);});};var getEnergy=function getEnergy(key){var u=state[key];var v=state[key+1];var yu=G.node.get(u).y;var yv=G.node.get(v).y;var above=function above(d){return d.y>yv?d.weight||1:0;};var below=function below(d){return d.y<yu?d.weight||1:0;};var nu=neighborData(u);var nv=neighborData(v);var uAbove=d3.sum(nu,above);var uBelow=d3.sum(nu,below);var vAbove=d3.sum(nv,above);var vBelow=d3.sum(nv,below);return uBelow*vAbove-uAbove*vBelow||uBelow+vAbove-uAbove-vBelow;};var _minimizeEnergy=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__optimization__["b" /* minimizeEnergy */])(moves,applyMove,getEnergy),delta=_minimizeEnergy.delta,steps=_minimizeEnergy.steps;state.forEach(function(v,i){return G.node.get(v).y=i;});}

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(475), __esModule: true };

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(159)
  , TAG = __webpack_require__(28)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(64)
  , document = __webpack_require__(43).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(42) && !__webpack_require__(62)(function(){
  return Object.defineProperty(__webpack_require__(256)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__(96)
  , ITERATOR   = __webpack_require__(28)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(159);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(61);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__(127)
  , createDesc     = __webpack_require__(97)
  , toIObject      = __webpack_require__(65)
  , toPrimitive    = __webpack_require__(170)
  , has            = __webpack_require__(63)
  , IE8_DOM_DEFINE = __webpack_require__(257)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(42) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(265)
  , hiddenKeys = __webpack_require__(160).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(63)
  , toObject    = __webpack_require__(78)
  , IE_PROTO    = __webpack_require__(167)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(63)
  , toIObject    = __webpack_require__(65)
  , arrayIndexOf = __webpack_require__(486)(false)
  , IE_PROTO     = __webpack_require__(167)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(30)
  , core    = __webpack_require__(20)
  , fails   = __webpack_require__(62);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(54);
module.exports = function(target, src, safe){
  for(var key in src){
    if(safe && target[key])target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(54);

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(255)
  , ITERATOR  = __webpack_require__(28)('iterator')
  , Iterators = __webpack_require__(96);
module.exports = __webpack_require__(20).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 270 */
/***/ (function(module, exports) {



/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(507);
var global        = __webpack_require__(43)
  , hide          = __webpack_require__(54)
  , Iterators     = __webpack_require__(96)
  , TO_STRING_TAG = __webpack_require__(28)('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(102)
  , getNames  = __webpack_require__(18).getNames
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return getNames(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.get = function getOwnPropertyNames(it){
  if(windowNames && toString.call(it) == '[object Window]')return getWindowNames(it);
  return getNames(toIObject(it));
};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(98);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__(81)
  , ITERATOR   = __webpack_require__(26)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(66);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__(26)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var getDesc  = __webpack_require__(18).getDesc
  , isObject = __webpack_require__(80)
  , anObject = __webpack_require__(66);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(67)(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core        = __webpack_require__(22)
  , $           = __webpack_require__(18)
  , DESCRIPTORS = __webpack_require__(79)
  , SPECIES     = __webpack_require__(26)('species');

module.exports = function(KEY){
  var C = core[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])$.setDesc(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(44)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 281 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(281)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(12);

var emptyObject = __webpack_require__(143);
var _invariant = __webpack_require__(3);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
var array = Array.prototype;

var slice = array.slice;
var map = array.map;


/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bisectRight */
/* unused harmony export bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisector__ = __webpack_require__(286);



var ascendingBisect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bisector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ __webpack_exports__["a"] = (bisectRight);


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(83);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function(d, x) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(f(d), x);
  };
}


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variance__ = __webpack_require__(295);


/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  var v = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__variance__["a" /* default */])(array, f);
  return v ? Math.sqrt(v) : v;
});


/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});


/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pair;
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
});

function pair(a, b) {
  return [a, b];
}


/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});


/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = tickIncrement;
/* harmony export (immutable) */ __webpack_exports__["a"] = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ __webpack_exports__["b"] = (function(start, stop, count) {
  var reverse = stop < start,
      i = -1,
      n,
      ticks,
      step;

  if (reverse) n = start, start = stop, stop = n;

  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
});

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}


/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__(289);


/* harmony default export */ __webpack_exports__["a"] = (function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__min__["a" /* default */])(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function length(d) {
  return d.length;
}


/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(104);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(597);
/* unused harmony reexport formatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(301);
/* unused harmony reexport formatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__ = __webpack_require__(299);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__ = __webpack_require__(603);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__ = __webpack_require__(604);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__ = __webpack_require__(605);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__["a"]; });








/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefixExponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(191);


var prefixExponent;

/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatSpecifier;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatTypes__ = __webpack_require__(300);


// [[fill]align][sign][symbol][0][width][,][.precision][type]
var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);

  var match,
      fill = match[1] || " ",
      align = match[2] || ">",
      sign = match[3] || "-",
      symbol = match[4] || "",
      zero = !!match[5],
      width = match[6] && +match[6],
      comma = !!match[7],
      precision = match[8] && +match[8].slice(1),
      type = match[9] || "";

  // The "n" type is an alias for ",g".
  if (type === "n") comma = true, type = "g";

  // Map invalid types to the default format.
  else if (!__WEBPACK_IMPORTED_MODULE_0__formatTypes__["a" /* default */][type]) type = "";

  // If zero fill is specified, padding goes after sign and before digits.
  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

  this.fill = fill;
  this.align = align;
  this.sign = sign;
  this.symbol = symbol;
  this.zero = zero;
  this.width = width;
  this.comma = comma;
  this.precision = precision;
  this.type = type;
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width == null ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
      + this.type;
};


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDefault__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatRounded__ = __webpack_require__(601);




/* harmony default export */ __webpack_exports__["a"] = ({
  "": __WEBPACK_IMPORTED_MODULE_0__formatDefault__["a" /* default */],
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */])(x * 100, p); },
  "r": __WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */],
  "s": __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__["a" /* default */],
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
});


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatGroup__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatNumerals__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatTypes__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__identity__ = __webpack_require__(602);








var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ __webpack_exports__["a"] = (function(locale) {
  var group = locale.grouping && locale.thousands ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__formatGroup__["a" /* default */])(locale.grouping, locale.thousands) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      currency = locale.currency,
      decimal = locale.decimal,
      numerals = locale.numerals ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__formatNumerals__["a" /* default */])(locale.numerals) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        type = specifier.type;

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = __WEBPACK_IMPORTED_MODULE_4__formatTypes__["a" /* default */][type],
        maybeSuffix = !type || /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? (type ? 6 : 12)
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__["b" /* prefixExponent */] / 3] : "") + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(193);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(nb),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
});


/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(192);


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__basis__["b" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
});


/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(193);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export rgbBasis */
/* unused harmony export rgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__(106);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__color__["c" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* rgb */])(start)).r, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* rgb */])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* rgb */])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["a" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" /* default */]);


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(136);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_band__ = __webpack_require__(617);
/* unused harmony reexport scaleBand */
/* unused harmony reexport scalePoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_identity__ = __webpack_require__(623);
/* unused harmony reexport scaleIdentity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_linear__ = __webpack_require__(109);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__src_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_log__ = __webpack_require__(624);
/* unused harmony reexport scaleLog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_ordinal__ = __webpack_require__(312);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__["a"]; });
/* unused harmony reexport scaleImplicit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_pow__ = __webpack_require__(625);
/* unused harmony reexport scalePow */
/* unused harmony reexport scaleSqrt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_quantile__ = __webpack_require__(626);
/* unused harmony reexport scaleQuantile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_quantize__ = __webpack_require__(627);
/* unused harmony reexport scaleQuantize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold__ = __webpack_require__(630);
/* unused harmony reexport scaleThreshold */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_time__ = __webpack_require__(313);
/* unused harmony reexport scaleTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcTime__ = __webpack_require__(632);
/* unused harmony reexport scaleUtc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_category10__ = __webpack_require__(618);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_11__src_category10__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_category20b__ = __webpack_require__(620);
/* unused harmony reexport schemeCategory20b */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_category20c__ = __webpack_require__(621);
/* unused harmony reexport schemeCategory20c */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_category20__ = __webpack_require__(619);
/* unused harmony reexport schemeCategory20 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(622);
/* unused harmony reexport interpolateCubehelixDefault */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_rainbow__ = __webpack_require__(628);
/* unused harmony reexport interpolateRainbow */
/* unused harmony reexport interpolateWarm */
/* unused harmony reexport interpolateCool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_viridis__ = __webpack_require__(633);
/* unused harmony reexport interpolateViridis */
/* unused harmony reexport interpolateMagma */
/* unused harmony reexport interpolateInferno */
/* unused harmony reexport interpolatePlasma */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_sequential__ = __webpack_require__(629);
/* unused harmony reexport scaleSequential */







































/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});


/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return +x;
});


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export implicit */
/* harmony export (immutable) */ __webpack_exports__["a"] = ordinal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(68);



var implicit = {name: "implicit"};

function ordinal(range) {
  var index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_time_format__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__array__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__continuous__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nice__ = __webpack_require__(310);








var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__continuous__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__continuous__["b" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolateNumber */]),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* bisector */])(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* tickStep */])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* tickStep */])(start, stop, interval);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(__WEBPACK_IMPORTED_MODULE_4__array__["a" /* map */].call(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__nice__["a" /* default */])(d, interval))
        : scale;
  };

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__continuous__["c" /* copy */])(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return calendar(__WEBPACK_IMPORTED_MODULE_2_d3_time__["j" /* timeYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["o" /* timeMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["p" /* timeWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["i" /* timeDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["q" /* timeHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["r" /* timeMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["s" /* timeSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["t" /* timeMillisecond */], __WEBPACK_IMPORTED_MODULE_3_d3_time_format__["b" /* timeFormat */]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
});


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var matcher = function(selector) {
  return function() {
    return this.matches(selector);
  };
};

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!element.matches) {
    var vendorMatches = element.webkitMatchesSelector
        || element.msMatchesSelector
        || element.mozMatchesSelector
        || element.oMatchesSelector;
    matcher = function(selector) {
      return function() {
        return vendorMatches.call(this, selector);
      };
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (matcher);


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = EnterNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(33);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Selection */](this._enter || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" /* default */]), this._parents);
});

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};


/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(update) {
  return new Array(update.length);
});


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styleValue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__(202);


function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove : typeof value === "function"
            ? styleFunction
            : styleConstant)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
});

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__window__["a" /* default */])(node).getComputedStyle(node, null).getPropertyValue(name);
}


/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function empty() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
});


/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__line__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__point__ = __webpack_require__(206);






/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x0 = __WEBPACK_IMPORTED_MODULE_4__point__["a" /* x */],
      x1 = null,
      y0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      y1 = __WEBPACK_IMPORTED_MODULE_4__point__["b" /* y */],
      defined = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__line__["a" /* default */])().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
});


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalClosed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(139);



function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cardinal__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinal__ = __webpack_require__(139);


function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cardinal__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return curveRadialLinear; });
/* harmony export (immutable) */ __webpack_exports__["a"] = curveRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(140);


var curveRadialLinear = curveRadial(__WEBPACK_IMPORTED_MODULE_0__linear__["a" /* default */]);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}


/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lineRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__line__ = __webpack_require__(204);



function lineRadial(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* default */])(_)) : c()._curve;
  };

  return l;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return lineRadial(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__line__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* curveRadialLinear */]));
});


/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
});


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / __WEBPACK_IMPORTED_MODULE_0__math__["b" /* pi */]);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, __WEBPACK_IMPORTED_MODULE_0__math__["c" /* tau */]);
  }
});


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
});


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
});


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
});


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(110);


var ka = 0.89081309152928522810,
    kr = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["b" /* pi */] / 10) / Math.sin(7 * __WEBPACK_IMPORTED_MODULE_0__math__["b" /* pi */] / 10),
    kx = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* tau */] / 10) * kr,
    ky = -Math.cos(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* tau */] / 10) * kr;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = __WEBPACK_IMPORTED_MODULE_0__math__["c" /* tau */] * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
});


/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var sqrt3 = Math.sqrt(3);

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
});


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var c = -0.5,
    s = Math.sqrt(3) / 2,
    k = 1 / Math.sqrt(12),
    a = (k / 2 + 1) * 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k,
        x1 = x0,
        y1 = r * k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
});


/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(207);
/* unused harmony reexport timeFormatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["c"]; });
/* unused harmony reexport timeParse */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* unused harmony reexport utcParse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(335);
/* unused harmony reexport timeFormatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_isoFormat__ = __webpack_require__(334);
/* unused harmony reexport isoFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_isoParse__ = __webpack_require__(693);
/* unused harmony reexport isoParse */






/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isoSpecifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__ = __webpack_require__(207);


var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__defaultLocale__["a" /* utcFormat */])(isoSpecifier);

/* unused harmony default export */ var _unused_webpack_default_export = (formatIso);


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time__ = __webpack_require__(208);


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newYear(y) {
  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "S": formatSeconds,
    "U": formatWeekNumberSunday,
    "w": formatWeekdayNumber,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "S": formatUTCSeconds,
    "U": formatUTCWeekNumberSunday,
    "w": formatUTCWeekdayNumber,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "S": parseSeconds,
    "U": parseWeekNumberSunday,
    "w": parseWeekdayNumber,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, newDate) {
    return function(string) {
      var d = newYear(1900),
          i = parseSpecifier(d, specifier, string += "", 0);
      if (i != string.length) return null;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "W" in d ? 1 : 0;
        var day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", localDate);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier, utcDate);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeDay */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* timeYear */])(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeSunday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* timeYear */])(d), d), p, 2);
}

function formatWeekdayNumber(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeMonday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* timeYear */])(d), d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["d" /* utcDay */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["m" /* utcSunday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d), d), p, 2);
}

function formatUTCWeekdayNumber(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["n" /* utcMonday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d), d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(29);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

/**
 *  Copyright (c) 2014-2015, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.Immutable = factory());
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step !== 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      if (o !== o || o === Infinity) {
        return 0;
      }
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
      return emptyMap().withMutations(function(map ) {
        for (var i = 0; i < keyValues.length; i += 2) {
          if (i + 1 >= keyValues.length) {
            throw new Error('Missing value for key: ' + keyValues[i]);
          }
          map.set(keyValues[i], keyValues[i + 1]);
        }
      });
    };

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      if (end === Infinity) {
        end = originalSize;
      } else {
        end = end | 0;
      }
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      if (this._map && !this._map.has(k)) {
        var defaultVal = this._defaultValues[k];
        if (v === defaultVal) {
          return this;
        }
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findEntry: function(predicate, context, notSetValue) {
      var found = notSetValue;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    findLastEntry: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },

    findLastKey: function(predicate, context) {
      return this.toKeyedSeq().reverse().findKey(predicate, context);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    lastKeyOf: function(searchValue) {
      return this.toKeyedSeq().reverse().keyOf(searchValue);
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.lastKeyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var entry = this.findLastEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    keySeq: function() {
      return Range(0, this.size);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;
  SetIterable.prototype.contains = SetIterable.prototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : String(value);
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = {
  workerPath: '{{JSNETWORKX_BUNDLE}}'
};
module.exports = exports['default'];

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = clear;
/**
 * Removes every property of the object.
 *
 * @param {Object} obj
 */

function clear(obj) {
  for (var prop in obj) {
    delete obj[prop];
  }
}

module.exports = exports['default'];

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = fillArray;
/**
 * Creates an array of `n` elements, each being `value`.
 *
 * @param {number} n Number of elements in the array
 * @param {?} value The value to put in each location
 * @return {Array}
 */

function fillArray(n, value) {
  var array = new Array(n);
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

module.exports = exports['default'];

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regeneratorRuntime = __webpack_require__(19)["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = genRange;
var marked0$0 = [genRange].map(_regeneratorRuntime.mark);
/**
 * Implements Python's range function, returns an iterator.
 *
 * If one argument n is passed, iterates over 0...n.
 * If two arguments i,j are passed, iterates over i...j.
 * If three arguments i,j,k are passed, iterates over i, i+k, i+2k, ...j
 *
 * @param {?number=} opt_start Number to start from
 * @param {?number=} opt_end Number to count to
 * @param {?number=} opt_step Step size
 * @return {!Iterator}
 */

function genRange(optStart, optEnd, optStep) {
  var negative, i;
  return _regeneratorRuntime.wrap(function genRange$(context$1$0) {
    while (1) switch (context$1$0.prev = context$1$0.next) {
      case 0:
        if (!(optStart == null)) {
          context$1$0.next = 4;
          break;
        }

        return context$1$0.abrupt("return");

      case 4:
        if (!(optEnd == null)) {
          context$1$0.next = 10;
          break;
        }

        optEnd = optStart;
        optStart = 0;
        optStep = 1;
        context$1$0.next = 16;
        break;

      case 10:
        if (!(optStep == null)) {
          context$1$0.next = 14;
          break;
        }

        optStep = 1;
        context$1$0.next = 16;
        break;

      case 14:
        if (!(optStep === 0)) {
          context$1$0.next = 16;
          break;
        }

        throw new RangeError("opt_step can't be 0");

      case 16:
        negative = optStep < 0;
        i = optStart;

      case 18:
        if (!(negative && i > optEnd || !negative && i < optEnd)) {
          context$1$0.next = 24;
          break;
        }

        context$1$0.next = 21;
        return i;

      case 21:
        i += optStep;
        context$1$0.next = 18;
        break;

      case 24:
      case "end":
        return context$1$0.stop();
    }
  }, marked0$0[0], this);
}

module.exports = exports["default"];

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = isMap;

var _Map = __webpack_require__(70);

var _Map2 = _interopRequireDefault(_Map);

/**
 * Tests whether the value is a Map.
 *
 * @param {*} v The value to test
 * @return {bool}
 */

function isMap(v) {
  return v instanceof _Map2['default'];
}

module.exports = exports['default'];

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _lodashLangIsPlainObject = __webpack_require__(149);

var _lodashLangIsPlainObject2 = _interopRequireDefault(_lodashLangIsPlainObject);

exports['default'] = _lodashLangIsPlainObject2['default'];
module.exports = exports['default'];

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regeneratorRuntime = __webpack_require__(19)['default'];

var _getIterator = __webpack_require__(8)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = mapIterator;
var marked0$0 = [mapIterator].map(_regeneratorRuntime.mark);
/**
 * Returns a new iterator which maps every value from the provided iterator via
 * the callback function.
 *
 * @param {Iterator} iterator
 * @param {function} map
 * @param {?=} opt_this_obj
 * @return {Iterator}
 */

function mapIterator(iterator, map, optThisObj) {
  var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, v;

  return _regeneratorRuntime.wrap(function mapIterator$(context$1$0) {
    while (1) switch (context$1$0.prev = context$1$0.next) {
      case 0:
        _iteratorNormalCompletion = true;
        _didIteratorError = false;
        _iteratorError = undefined;
        context$1$0.prev = 3;
        _iterator = _getIterator(iterator);

      case 5:
        if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
          context$1$0.next = 12;
          break;
        }

        v = _step.value;
        context$1$0.next = 9;
        return map.call(optThisObj, v);

      case 9:
        _iteratorNormalCompletion = true;
        context$1$0.next = 5;
        break;

      case 12:
        context$1$0.next = 18;
        break;

      case 14:
        context$1$0.prev = 14;
        context$1$0.t0 = context$1$0['catch'](3);
        _didIteratorError = true;
        _iteratorError = context$1$0.t0;

      case 18:
        context$1$0.prev = 18;
        context$1$0.prev = 19;

        if (!_iteratorNormalCompletion && _iterator['return']) {
          _iterator['return']();
        }

      case 21:
        context$1$0.prev = 21;

        if (!_didIteratorError) {
          context$1$0.next = 24;
          break;
        }

        throw _iteratorError;

      case 24:
        return context$1$0.finish(21);

      case 25:
        return context$1$0.finish(18);

      case 26:
      case 'end':
        return context$1$0.stop();
    }
  }, marked0$0[0], this, [[3, 14, 18, 26], [19,, 21, 25]]);
}

module.exports = exports['default'];

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _tinySprintf = __webpack_require__(1002);

var _tinySprintf2 = _interopRequireDefault(_tinySprintf);

var undef;

_tinySprintf2['default'].j = function (value) {
  if (value === undef) {
    return undef + '';
  }

  try {
    return JSON.stringify(value);
  } catch (e) {
    return value + '';
  }
};

exports['default'] = _tinySprintf2['default'];
module.exports = exports['default'];

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _getIterator = __webpack_require__(8)['default'];

var _regeneratorRuntime = __webpack_require__(19)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = toIterator;

var _isArrayLike = __webpack_require__(85);

var _isArrayLike2 = _interopRequireDefault(_isArrayLike);

var _isIterator = __webpack_require__(87);

var _isIterator2 = _interopRequireDefault(_isIterator);

var _isIterable = __webpack_require__(86);

var _isIterable2 = _interopRequireDefault(_isIterable);

/**
 * Returns an iterator object for the given array, array-like object
 * or object. Should behave like Python's iter:
 * http://docs.python.org/library/functions.html#iter
 *
 *
 * The iterator object implements the goog.iter.Iterator interface.
 *
 * @param {Iterable} seq
 * @return {!Iterator}
 */

function toIterator(seq) {
  /*jshint expr:true*/
  if ((0, _isIterator2['default'])(seq)) {
    return seq;
  } else if ((0, _isIterable2['default'])(seq)) {
    return _getIterator(seq);
  } else if (Array.isArray(seq) || (0, _isArrayLike2['default'])(seq)) {
    return _regeneratorRuntime.mark(function callee$1$0(seq) {
      var i, l;
      return _regeneratorRuntime.wrap(function callee$1$0$(context$2$0) {
        while (1) switch (context$2$0.prev = context$2$0.next) {
          case 0:
            i = 0, l = seq.length;

          case 1:
            if (!(i < l)) {
              context$2$0.next = 7;
              break;
            }

            context$2$0.next = 4;
            return seq[i];

          case 4:
            i++;
            context$2$0.next = 1;
            break;

          case 7:
          case 'end':
            return context$2$0.stop();
        }
      }, callee$1$0, this);
    })(seq);
  } else {
    throw new TypeError('Unable to convert ' + seq + ' to an iterator');
  }
}

module.exports = exports['default'];
// eslint-disable-line no-shadow

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regeneratorRuntime = __webpack_require__(19)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = zipIterator;
var marked0$0 = [zipIterator].map(_regeneratorRuntime.mark);
/**
 * Takes a number of iterators and returns a new iterator which emits an array
 * of each of the iterators next values. Stops when the shortest iterator is
 * exhausted.
 *
 * @param {...Iterator} var_args
 * @return {Iterator}
 */

function zipIterator() {
  var varArgs,
      length,
      done,
      nextZip,
      i,
      next,
      args$1$0 = arguments;
  return _regeneratorRuntime.wrap(function zipIterator$(context$1$0) {
    while (1) switch (context$1$0.prev = context$1$0.next) {
      case 0:
        varArgs = args$1$0;
        length = varArgs.length;

      case 2:
        if (false) {
          context$1$0.next = 21;
          break;
        }

        done = false;
        nextZip = new Array(length);
        i = 0;

      case 6:
        if (!(i < length)) {
          context$1$0.next = 15;
          break;
        }

        next = varArgs[i].next();

        if (!next.done) {
          context$1$0.next = 11;
          break;
        }

        done = true;
        return context$1$0.abrupt('break', 15);

      case 11:
        nextZip[i] = next.value;

      case 12:
        i++;
        context$1$0.next = 6;
        break;

      case 15:
        if (!done) {
          context$1$0.next = 17;
          break;
        }

        return context$1$0.abrupt('break', 21);

      case 17:
        context$1$0.next = 19;
        return nextZip;

      case 19:
        context$1$0.next = 2;
        break;

      case 21:
      case 'end':
        return context$1$0.stop();
    }
  }, marked0$0[0], this);
}

module.exports = exports['default'];

// TODO: Use rest parameter once 6to5 is fixed (2.0)

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(16)['default'];

var _regeneratorRuntime = __webpack_require__(19)['default'];

var _getIterator = __webpack_require__(8)['default'];

var _Array$from = __webpack_require__(13)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.findCliques = findCliques;
exports.genFindCliques = genFindCliques;
exports.findCliquesRecursive = findCliquesRecursive;
exports.genFindCliquesRecursive = genFindCliquesRecursive;
exports.graphCliqueNumber = graphCliqueNumber;
exports.genGraphCliqueNumber = genGraphCliqueNumber;
exports.graphNumberOfCliques = graphNumberOfCliques;
exports.genGraphNumberOfCliques = genGraphNumberOfCliques;
exports.numberOfCliques = numberOfCliques;
exports.genNumberOfCliques = genNumberOfCliques;
var marked0$0 = [findCliques, findCliquesRecursive].map(_regeneratorRuntime.mark);

var _internalsDelegate = __webpack_require__(27);

var _internalsDelegate2 = _interopRequireDefault(_internalsDelegate);

var _internals = __webpack_require__(15);

/*eslint max-len:[1, 94]*/
'use strict';

/**
 * @fileoverview
 * Find and manipulate cliques of graphs.
 *
 * Note that finding the largest clique of a graph has been
 * shown to be an NP-complete problem; the algorithms here
 * could take a long time to run.
 *
 * http://en.wikipedia.org/wiki/Clique_problem
 */

// TODO: enumerate_all_cliques

/**
 * Search for all maximal cliques in a graph.
 *
 * Maximal cliques are the largest complete subgraph containing
 * a given node.  The largest maximal clique is sometimes called
 * the maximum clique.
 *
 *
 * ### Notes
 *
 * Based on the algorithm published by Bron & Kerbosch (1973) ([1][])
 * as adapted by Tomita, Tanaka and Takahashi (2006) ([2][])
 * and discussed in Cazals and Karande (2008) ([3][]).
 *
 * This algorithm ignores self-loops and parallel edges as
 * clique is not conventionally defined with such edges.
 *
 * There are often many cliques in graphs.  This algorithm can
 * run out of memory for large graphs.
 *
 * ### References
 *
 * [1] [Bron, C. and Kerbosch, J. 1973.
 *    Algorithm 457: finding all cliques of an undirected graph.
 *    Commun. ACM 16, 9 (Sep. 1973), 575-577.][1]
 * [1]: http://portal.acm.org/citation.cfm?doid=362342.362367
 *
 * [2] [Etsuji Tomita, Akira Tanaka, Haruhisa Takahashi,
 *    The worst-case time complexity for generating all maximal
 *    cliques and computational experiments,
 *    Theoretical Computer Science, Volume 363, Issue 1,
 *    Computing and Combinatorics,
 *    10th Annual International Conference on
 *    Computing and Combinatorics (COCOON 2004), 25 October 2006,
 *    Pages 28-42][2]
 * [2]: http://dx.doi.org/10.1016/j.tcs.2006.06.015
 *
 * [3] [F. Cazals, C. Karande,
 *    A note on the problem of reporting maximal cliques,
 *    Theoretical Computer Science,
 *    Volume 407, Issues 1-3, 6 November 2008, Pages 564-568][3]
 * [3]: http://dx.doi.org/10.1016/j.tcs.2008.05.010
 *
 * @see findCliquesRecursive
 *
 * @param {Graph} G
 * @return {Iterator<Array<Node>>} Iterator over member lists for each maximal
 *  clique
 */

function findCliques(G) {
  var adj, subgraph, candidates, Q, u, extU, stack, q, adjQ, subgraphQ, candidatesQ, _stack$pop, _stack$pop2;

  return _regeneratorRuntime.wrap(function findCliques$(context$1$0) {
    while (1) switch (context$1$0.prev = context$1$0.next) {
      case 0:
        if (!(G.numberOfNodes() === 0)) {
          context$1$0.next = 2;
          break;
        }

        return context$1$0.abrupt('return', []);

      case 2:
        adj = new _internals.Map((0, _internals.mapIterator)(G, function (u) {
          var neighbors = new _internals.Set(G.neighborsIter(u));
          neighbors['delete'](u);
          return (0, _internals.tuple2)(u, neighbors);
        }));
        subgraph = new _internals.Set(G);
        candidates = new _internals.Set(G);
        Q = [null];
        u = (0, _internals.max)(subgraph, function (u) {
          return candidates.intersection(adj.get(u)).size;
        });
        extU = candidates.difference(adj.get(u));
        stack = [];

      case 9:
        if (false) {
          context$1$0.next = 35;
          break;
        }

        if (!(extU.size > 0)) {
          context$1$0.next = 25;
          break;
        }

        q = extU.pop();

        candidates['delete'](q);
        Q[Q.length - 1] = q;
        adjQ = adj.get(q);
        subgraphQ = subgraph.intersection(adjQ);

        if (!(subgraphQ.size === 0)) {
          context$1$0.next = 21;
          break;
        }

        context$1$0.next = 19;
        return Q.slice();

      case 19:
        context$1$0.next = 23;
        break;

      case 21:
        candidatesQ = candidates.intersection(adjQ);

        if (candidatesQ.size > 0) {
          stack.push([subgraph, candidates, extU]);
          Q.push(null);
          subgraph = subgraphQ;
          candidates = candidatesQ;
          /* eslint-disable no-loop-func*/
          u = (0, _internals.max)(subgraph, function (u) {
            return candidates.intersection(adj.get(u)).size;
          });
          /* eslint-enable no-loop-func*/
          extU = candidates.difference(adj.get(u));
        }

      case 23:
        context$1$0.next = 33;
        break;

      case 25:
        if (!(Q.length === 0 || stack.length === 0)) {
          context$1$0.next = 27;
          break;
        }

        return context$1$0.abrupt('break', 35);

      case 27:
        Q.pop();
        _stack$pop = stack.pop();
        _stack$pop2 = _slicedToArray(_stack$pop, 3);
        subgraph = _stack$pop2[0];
        candidates = _stack$pop2[1];
        extU = _stack$pop2[2];

      case 33:
        context$1$0.next = 9;
        break;

      case 35:
      case 'end':
        return context$1$0.stop();
    }
  }, marked0$0[0], this);
}

function genFindCliques(G) {
  return (0, _internalsDelegate2['default'])('findCliques', [G]);
}

;

/**
 * Recursive search for all maximal cliques in a graph.
 *
 * Maximal cliques are the largest complete subgraph containing
 * a given point.  The largest maximal clique is sometimes called
 * the maximum clique.
 *
 * ### Notes
 *
 * Based on the algorithm published by Bron & Kerbosch (1973) ([1][])
 * as adapted by Tomita, Tanaka and Takahashi (2006) ([2][])
 * and discussed in Cazals and Karande (2008) ([3][]).
 *
 * This algorithm ignores self-loops and parallel edges as
 * clique is not conventionally defined with such edges.
 *
 *
 * ### References
 *
 * [1] [Bron, C. and Kerbosch, J. 1973.
 *    Algorithm 457: finding all cliques of an undirected graph.
 *    Commun. ACM 16, 9 (Sep. 1973), 575-577.][1]
 * [1]: http://portal.acm.org/citation.cfm?doid=362342.362367
 *
 * [2] [Etsuji Tomita, Akira Tanaka, Haruhisa Takahashi,
 *    The worst-case time complexity for generating all maximal
 *    cliques and computational experiments,
 *    Theoretical Computer Science, Volume 363, Issue 1,
 *    Computing and Combinatorics,
 *    10th Annual International Conference on
 *    Computing and Combinatorics (COCOON 2004), 25 October 2006, Pages 28-42][2]
 * [2]: http://dx.doi.org/10.1016/j.tcs.2006.06.015
 *
 * [3] [F. Cazals, C. Karande,
 *    A note on the problem of reporting maximal cliques,
 *    Theoretical Computer Science,
 *    Volume 407, Issues 1-3, 6 November 2008, Pages 564-568][3]
 * [3]: http://dx.doi.org/10.1016/j.tcs.2008.05.010
 *
 * @param {Graph} G
 * @return {!Iterator<Array<Node>>} List of members in each maximal clique
 *
 * @see find_cliques
 */

function findCliquesRecursive(G) {
  var marked1$0, adj, Q, expand;
  return _regeneratorRuntime.wrap(function findCliquesRecursive$(context$1$0) {
    while (1) switch (context$1$0.prev = context$1$0.next) {
      case 0:
        expand = function expand(subgraph, candidates) {
          var u, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, q, adjQ, subgraphQ, candidatesQ;

          return _regeneratorRuntime.wrap(function expand$(context$2$0) {
            while (1) switch (context$2$0.prev = context$2$0.next) {
              case 0:
                u = (0, _internals.max)(subgraph, function (u) {
                  return candidates.intersection(adj.get(u)).size;
                });
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                context$2$0.prev = 4;
                _iterator = _getIterator(candidates.difference(adj.get(u)));

              case 6:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  context$2$0.next = 24;
                  break;
                }

                q = _step.value;

                candidates['delete'](q);
                Q.push(q);
                adjQ = adj.get(q);
                subgraphQ = subgraph.intersection(adjQ);

                if (!(subgraphQ.size === 0)) {
                  context$2$0.next = 17;
                  break;
                }

                context$2$0.next = 15;
                return Q.slice();

              case 15:
                context$2$0.next = 20;
                break;

              case 17:
                candidatesQ = candidates.intersection(adjQ);

                if (!(candidatesQ.size > 0)) {
                  context$2$0.next = 20;
                  break;
                }

                return context$2$0.delegateYield(expand(subgraphQ, candidatesQ), 't0', 20);

              case 20:
                Q.pop();

              case 21:
                _iteratorNormalCompletion = true;
                context$2$0.next = 6;
                break;

              case 24:
                context$2$0.next = 30;
                break;

              case 26:
                context$2$0.prev = 26;
                context$2$0.t1 = context$2$0['catch'](4);
                _didIteratorError = true;
                _iteratorError = context$2$0.t1;

              case 30:
                context$2$0.prev = 30;
                context$2$0.prev = 31;

                if (!_iteratorNormalCompletion && _iterator['return']) {
                  _iterator['return']();
                }

              case 33:
                context$2$0.prev = 33;

                if (!_didIteratorError) {
                  context$2$0.next = 36;
                  break;
                }

                throw _iteratorError;

              case 36:
                return context$2$0.finish(33);

              case 37:
                return context$2$0.finish(30);

              case 38:
              case 'end':
                return context$2$0.stop();
            }
          }, marked1$0[0], this, [[4, 26, 30, 38], [31,, 33, 37]]);
        };

        marked1$0 = [expand].map(_regeneratorRuntime.mark);

        if (!(G.size === 0)) {
          context$1$0.next = 5;
          break;
        }

        context$1$0.next = 5;
        return [];

      case 5:
        adj = new _internals.Map((0, _internals.mapIterator)(G, function (u) {
          var neighbors = new _internals.Set(G.neighborsIter(u));
          neighbors['delete'](u);
          return (0, _internals.tuple2)(u, neighbors);
        }));
        Q = [];
        return context$1$0.delegateYield(expand(new _internals.Set(G), new _internals.Set(G)), 't0', 8);

      case 8:
      case 'end':
        return context$1$0.stop();
    }
  }, marked0$0[1], this);
}

function genFindCliquesRecursive(G) {
  return (0, _internalsDelegate2['default'])('findCliquesRecursive', [G]);
}

;

//TODO: make_max_clique_graph
//TODO: make_clique_bipartite
//TODO: project_down
//TODO: project_up

/**
 * Return the clique number (size of the largest clique) for G.
 *
 * An optional list of cliques can be input if already computed.
 *
 * @param {Graph} G graph
 * @param {Iterable=} optCliques
 * @return {number}
 */

function graphCliqueNumber(G, optCliques) {
  if (optCliques == null) {
    optCliques = findCliques(G); // eslint-disable-line no-undef
  }
  return (0, _internals.max)(optCliques, function (c) {
    return c.length;
  }).length;
}

function genGraphCliqueNumber(G, optCliques) {
  return (0, _internalsDelegate2['default'])('graphCliqueNumber', [G, optCliques]);
}

/**
 * Returns the number of maximal cliques in G.
 *
 * An optional list of cliques can be input if already computed.
 *
 * @param {Graph} G graph
 * @param {Iterable=} optCliques
 * @return {number}
 */

function graphNumberOfCliques(G, optCliques) {
  if (optCliques == null) {
    optCliques = findCliques(G); // eslint-disable-line no-undef
  }
  return _Array$from(optCliques).length;
}

function genGraphNumberOfCliques(G, optCliques) {
  return (0, _internalsDelegate2['default'])('graphNumberOfCliques', [G, optCliques]);
}

//TODO: node_clique_number

/**
 * Returns the number of maximal cliques for each node.
 *
 * Returns a single or list depending on input nodes.
 * Optional list of cliques can be input if already computed.
 *
 * @param {Graph} G graph
 * @param {Iterable=} optNodes List of nodes
 * @param {Iterable=} optCliques List of cliques
 * @return {!(Map|number)}
 */

function numberOfCliques(G, optNodes, optCliques) {
  optCliques = _Array$from(optCliques || findCliques(G)); // eslint-disable-line no-undef

  if (optNodes == null) {
    optNodes = G.nodes(); // none, get entire graph
  }

  var numcliq;
  if (!Array.isArray(optNodes)) {
    var v = optNodes;
    numcliq = optCliques.filter(function (c) {
      return new _internals.Set(c).has(v);
    }).length;
  } else {
    optCliques = optCliques.map(function (c) {
      return new _internals.Set(c);
    });
    numcliq = new _internals.Map();
    optNodes.forEach(function (v) {
      numcliq.set(v, optCliques.filter(function (c) {
        return c.has(v);
      }).length);
    });
  }
  return numcliq;
}

//TODO: cliques_containing_node

function genNumberOfCliques(G, optNodes, optCliques) {
  return (0, _internalsDelegate2['default'])('numberOfCliques', [G, optNodes, optCliques]);
}

/*jshint ignore:start*/

/*jshint ignore:end*/

// eslint-disable-line no-unused-expressions
// eslint-disable-line no-unused-expressions

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(16)['default'];

var _regeneratorRuntime = __webpack_require__(19)['default'];

var _getIterator = __webpack_require__(8)['default'];

var _Array$from = __webpack_require__(13)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.triangles = triangles;
exports.genTriangles = genTriangles;
exports.averageClustering = averageClustering;
exports.genAverageClustering = genAverageClustering;
exports.clustering = clustering;
exports.genClustering = genClustering;
exports.transitivity = transitivity;
exports.genTransitivity = genTransitivity;
exports.squareClustering = squareClustering;
exports.genSquareClustering = genSquareClustering;
var marked0$0 = [trianglesAndDegreeIter, weightedTrianglesAndDegreeIter].map(_regeneratorRuntime.mark);

var _internalsDelegate = __webpack_require__(27);

var _internalsDelegate2 = _interopRequireDefault(_internalsDelegate);

var _exceptionsJSNetworkXError = __webpack_require__(34);

var _exceptionsJSNetworkXError2 = _interopRequireDefault(_exceptionsJSNetworkXError);

var _internals = __webpack_require__(15);

'use strict';

/**
 * Compute the number of triangles.
 *
 * Finds the number of triangles that include a node as one vertex.
 *
 * ### Examples
 *
 * ```
 * var G = jsnx.completeGraph(5);
 * jsnx.triangles(G, 0);
 * // 6
 * jsnx.triangles(G);
 * Map {0: 6, 1: 6, 2: 6, 3: 6, 4: 6}
 * Array.from(jsnx.triangles(G, [0,1]).values());
 * // [6, 6]
 * ```
 *
 * ### Notes
 *
 * When computing triangles for the entire graph each triangle is counted
 * three times, once at each node.  Self loops are ignored.
 *
 * @param {Graph} G A JSnetworkX graph
 * @param {Iterable=} optNodes (default: all nodes)
 *      Compute triangles for nodes in this container.
 *
 * @return {!(Map|number)} Number of triangles keyed by node label.
 */

function triangles(G, optNodes) {
  if (G.isDirected()) {
    throw new _exceptionsJSNetworkXError2['default']('triangles() is not defined for directed graphs.');
  }

  if (optNodes != null && G.hasNode(optNodes)) {
    // return single value
    return Math.floor((0, _internals.next)(trianglesAndDegreeIter(G, optNodes))[2] / 2);
  }

  return new _internals.Map((0, _internals.mapIterator)(trianglesAndDegreeIter(G, optNodes),
  /* eslint-disable no-unused-vars */
  function (_ref) {
    var _ref2 = _slicedToArray(_ref, 3);

    var v = _ref2[0];
    var _ = _ref2[1];
    var triangles = _ref2[2];
    return (0, _internals.tuple2)(v, Math.floor(triangles / 2), v)
    /* eslint-enable no-unused-vars */
    ;
  }));
}

function genTriangles(G, optNodes) {
  return (0, _internalsDelegate2['default'])('triangles', [G, optNodes]);
}

/**
 * Return an iterator of (node, degree, triangles).
 *
 * This double counts triangles so you may want to divide by 2.
 * See `degree()` and `triangles()` for definitions and details.
 *
 * @param {Graph} G A jsnetworkx graph
 * @param {Iterable=} optNodes (default: all nodes)
 *      Compute triangles for nodes in this container.
 *
 * @return {!Iterator<Array>}
 */
function trianglesAndDegreeIter(G, optNodes) {
  var nodesNbrs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step$value, v, vNbrs, vset, ntriangles, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, w, wset;

  return _regeneratorRuntime.wrap(function trianglesAndDegreeIter$(context$1$0) {
    while (1) switch (context$1$0.prev = context$1$0.next) {
      case 0:
        if (!G.isMultigraph()) {
          context$1$0.next = 2;
          break;
        }

        throw new _exceptionsJSNetworkXError2['default']('Not defined for multigraphs.');

      case 2:
        nodesNbrs = (0, _internals.mapIterator)(optNodes == null ? G : G.nbunchIter(optNodes), function (n) {
          return (0, _internals.tuple2)(n, G.get(n));
        });
        _iteratorNormalCompletion = true;
        _didIteratorError = false;
        _iteratorError = undefined;
        context$1$0.prev = 6;
        _iterator = _getIterator(nodesNbrs);

      case 8:
        if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
          context$1$0.next = 39;
          break;
        }

        _step$value = _slicedToArray(_step.value, 2);
        v = _step$value[0];
        vNbrs = _step$value[1];
        vset = new _internals.Set(vNbrs.keys());

        vset['delete'](v);
        ntriangles = 0;
        _iteratorNormalCompletion2 = true;
        _didIteratorError2 = false;
        _iteratorError2 = undefined;
        context$1$0.prev = 18;

        for (_iterator2 = _getIterator(vset); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          w = _step2.value;
          wset = new _internals.Set(G.get(w).keys());

          wset['delete'](w);
          ntriangles += vset.intersection(wset).size;
        }
        context$1$0.next = 26;
        break;

      case 22:
        context$1$0.prev = 22;
        context$1$0.t0 = context$1$0['catch'](18);
        _didIteratorError2 = true;
        _iteratorError2 = context$1$0.t0;

      case 26:
        context$1$0.prev = 26;
        context$1$0.prev = 27;

        if (!_iteratorNormalCompletion2 && _iterator2['return']) {
          _iterator2['return']();
        }

      case 29:
        context$1$0.prev = 29;

        if (!_didIteratorError2) {
          context$1$0.next = 32;
          break;
        }

        throw _iteratorError2;

      case 32:
        return context$1$0.finish(29);

      case 33:
        return context$1$0.finish(26);

      case 34:
        context$1$0.next = 36;
        return (0, _internals.tuple3)(v, vset.size, ntriangles);

      case 36:
        _iteratorNormalCompletion = true;
        context$1$0.next = 8;
        break;

      case 39:
        context$1$0.next = 45;
        break;

      case 41:
        context$1$0.prev = 41;
        context$1$0.t1 = context$1$0['catch'](6);
        _didIteratorError = true;
        _iteratorError = context$1$0.t1;

      case 45:
        context$1$0.prev = 45;
        context$1$0.prev = 46;

        if (!_iteratorNormalCompletion && _iterator['return']) {
          _iterator['return']();
        }

      case 48:
        context$1$0.prev = 48;

        if (!_didIteratorError) {
          context$1$0.next = 51;
          break;
        }

        throw _iteratorError;

      case 51:
        return context$1$0.finish(48);

      case 52:
        return context$1$0.finish(45);

      case 53:
      case 'end':
        return context$1$0.stop();
    }
  }, marked0$0[0], this, [[6, 41, 45, 53], [18, 22, 26, 34], [27,, 29, 33], [46,, 48, 52]]);
}

/**
 * Return an iterator of `(node, degree, weightedTriangles)`.
 *
 * Used for weighted clustering.
 *
 * @param {Graph} G A JSnetworkX graph
 * @param {Iterable=} optNodes (default: all nodes)
 *      Compute triangles for nodes in this container.
 * @param {string=} opt_weight (default: 'weight')
 *      The name of edge weight attribute.
 *
 * @return {Iterator<Array>}
 */
function weightedTrianglesAndDegreeIter(G, optNodes) {
  var optWeight = arguments.length <= 2 || arguments[2] === undefined ? 'weight' : arguments[2];

  var maxWeight, nodesNbrs, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _step3$value, i, nbrs, inbrs, weightedTriangles, seen, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, j, weightij, jnbrs, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, k, weightjk, weightki;

  return _regeneratorRuntime.wrap(function weightedTrianglesAndDegreeIter$(context$1$0) {
    while (1) switch (context$1$0.prev = context$1$0.next) {
      case 0:
        if (!G.isMultigraph()) {
          context$1$0.next = 2;
          break;
        }

        throw new _exceptionsJSNetworkXError2['default']('Not defined for multigraphs.');

      case 2:
        maxWeight = optWeight == null || G.edges().length === 0 ? 1 : (0, _internals.max)((0, _internals.mapIterator)(G.edgesIter(true),
        /* eslint-disable no-unused-vars */
        function (_ref3) {
          var _ref32 = _slicedToArray(_ref3, 3);

          var u = _ref32[0];
          var v = _ref32[1];
          var data = _ref32[2];
          return (0, _internals.getDefault)(data[optWeight], 1)
          /* eslint-enable no-unused-vars */
          ;
        }));
        nodesNbrs = (0, _internals.mapIterator)(optNodes == null ? G : G.nbunchIter(optNodes), function (n) {
          return (0, _internals.tuple2)(n, G.get(n));
        });
        _iteratorNormalCompletion3 = true;
        _didIteratorError3 = false;
        _iteratorError3 = undefined;
        context$1$0.prev = 7;
        _iterator3 = _getIterator(nodesNbrs);

      case 9:
        if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
          context$1$0.next = 67;
          break;
        }

        _step3$value = _slicedToArray(_step3.value, 2);
        i = _step3$value[0];
        nbrs = _step3$value[1];
        inbrs = new _internals.Set(nbrs.keys()).difference([i]);
        weightedTriangles = 0;
        seen = new _internals.Set();
        _iteratorNormalCompletion4 = true;
        _didIteratorError4 = false;
        _iteratorError4 = undefined;
        context$1$0.prev = 19;
        _iterator4 = _getIterator(inbrs);

      case 21:
        if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
          context$1$0.next = 48;
          break;
        }

        j = _step4.value;
        weightij = (0, _internals.getDefault)(nbrs.get(j)[optWeight], 1) / maxWeight;

        seen.add(j);
        jnbrs = new _internals.Set(G.get(j).keys()).difference(seen);
        _iteratorNormalCompletion5 = true;
        _didIteratorError5 = false;
        _iteratorError5 = undefined;
        context$1$0.prev = 29;

        for (_iterator5 = _getIterator(inbrs.intersection(jnbrs)); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          k = _step5.value;
          weightjk = (0, _internals.getDefault)(G.get(j).get(k)[optWeight], 1) / maxWeight;
          weightki = (0, _internals.getDefault)(nbrs.get(k)[optWeight], 1) / maxWeight;

          weightedTriangles += Math.pow(weightij * weightjk * weightki, 1 / 3);
        }
        context$1$0.next = 37;
        break;

      case 33:
        context$1$0.prev = 33;
        context$1$0.t0 = context$1$0['catch'](29);
        _didIteratorError5 = true;
        _iteratorError5 = context$1$0.t0;

      case 37:
        context$1$0.prev = 37;
        context$1$0.prev = 38;

        if (!_iteratorNormalCompletion5 && _iterator5['return']) {
          _iterator5['return']();
        }

      case 40:
        context$1$0.prev = 40;

        if (!_didIteratorError5) {
          context$1$0.next = 43;
          break;
        }

        throw _iteratorError5;

      case 43:
        return context$1$0.finish(40);

      case 44:
        return context$1$0.finish(37);

      case 45:
        _iteratorNormalCompletion4 = true;
        context$1$0.next = 21;
        break;

      case 48:
        context$1$0.next = 54;
        break;

      case 50:
        context$1$0.prev = 50;
        context$1$0.t1 = context$1$0['catch'](19);
        _didIteratorError4 = true;
        _iteratorError4 = context$1$0.t1;

      case 54:
        context$1$0.prev = 54;
        context$1$0.prev = 55;

        if (!_iteratorNormalCompletion4 && _iterator4['return']) {
          _iterator4['return']();
        }

      case 57:
        context$1$0.prev = 57;

        if (!_didIteratorError4) {
          context$1$0.next = 60;
          break;
        }

        throw _iteratorError4;

      case 60:
        return context$1$0.finish(57);

      case 61:
        return context$1$0.finish(54);

      case 62:
        context$1$0.next = 64;
        return (0, _internals.tuple3)(i, inbrs.size, weightedTriangles * 2);

      case 64:
        _iteratorNormalCompletion3 = true;
        context$1$0.next = 9;
        break;

      case 67:
        context$1$0.next = 73;
        break;

      case 69:
        context$1$0.prev = 69;
        context$1$0.t2 = context$1$0['catch'](7);
        _didIteratorError3 = true;
        _iteratorError3 = context$1$0.t2;

      case 73:
        context$1$0.prev = 73;
        context$1$0.prev = 74;

        if (!_iteratorNormalCompletion3 && _iterator3['return']) {
          _iterator3['return']();
        }

      case 76:
        context$1$0.prev = 76;

        if (!_didIteratorError3) {
          context$1$0.next = 79;
          break;
        }

        throw _iteratorError3;

      case 79:
        return context$1$0.finish(76);

      case 80:
        return context$1$0.finish(73);

      case 81:
      case 'end':
        return context$1$0.stop();
    }
  }, marked0$0[1], this, [[7, 69, 73, 81], [19, 50, 54, 62], [29, 33, 37, 45], [38,, 40, 44], [55,, 57, 61], [74,, 76, 80]]);
}

/**
 * Compute the average clustering coefficient for the graph G.
 *
 * The clustering coefficient for the graph is the average,
 *
 * ```math
 * C = \frac{1}{n}\sum_{v \in G} c_v
 * ```
 *
 * where `$n$` is the number of nodes in `$G$`.
 *
 * ### Example
 *
 * ```
 * var G = jsnx.completeGraph(5);
 * jsnx.averageClustering(G);
 * // 1
 * ```
 *
 * ### Notes
 *
 * Self loops are ignored.
 *
 *
 * ### References
 *
 * [1] [Generalizations of the clustering coefficient to weighted
 *     complex networks by J. Saramäki, M. Kivelä, J.-P. Onnela,
 *     K. Kaski, and J. Kertész, Physical Review E, 75 027105 (2007).][1]
 * [1]: http://jponnela.com/web_documents/a9.pdf
 * [2] [Marcus Kaiser,  Mean clustering coefficients: the role of isolated
 *     nodes and leafs on clustering measures for small-world networks.][2]
 * [2]:http://arxiv.org/abs/0802.2512
 *
 * @param {Graph} G graph
 * @param {?Iterable} optNodes (default: all nodes)
 *    Compute average clustering for nodes in this container.
 * @param {?string=} optWeight (default: null)
 *    The edge attribute that holds the numerical value used as a weight.
 *    If `null`, then each edge has weight `1`.
 * @param {?boolean=} optCountZeros
 *    If `false` include only the nodes with nonzero clustering in the average.
 * @return {number}
 */

function averageClustering(G, optNodes, optWeight) {
  var optCountZeros = arguments.length <= 3 || arguments[3] === undefined ? true : arguments[3];

  var clusters = _Array$from(clustering(G, optNodes, optWeight).values());

  if (!optCountZeros) {
    clusters = clusters.filter(function (v) {
      return v > 0;
    });
  }
  return clusters.reduce(function (s, x) {
    return s + x;
  }, 0) / clusters.length;
}

function genAverageClustering(G, optNodes, optWeight, optCountZeros) {
  return (0, _internalsDelegate2['default'])('averageClustering', [G, optNodes, optWeight, optCountZeros]);
}

/**
 * Compute the clustering coefficient for nodes.
 *
 * For unweighted graphs the clustering of each node `$u$`
 * is the fraction of possible triangles through that node that exist,
 *
 * ```math
 * c_u = \frac{2 T(u)}{deg(u)(deg(u)-1)}
 * ```
 *
 * where `$T(u)$` is the number of triangles through node `$u$` and `$deg(u)$`
 * is the degree of `$u$`.
 *
 * For weighted graphs the clustering is defined as the geometric average of
 * the subgraph edge weights,
 *
 * ```math
 * c_u = \frac{1}{deg(u)(deg(u)-1)}
 *       \sum_{uv} (\hat{w}_{uv} \hat{w}_{uw} \hat{w}_{vw})^{1/3}
 * ```
 *
 * The edge weights `$\hat{w}_{uv}$` are normalized by the maximum weight in the
 * network `$\hat{w}_{uv} = w_{uv}/\max(2)$`.
 *
 * The value `$c_u$` is assigned to `$0$` if `$deg(u) < 2$`.
 *
 * ### Example
 *
 * ```
 * var G = jsnx.completeGraph(5);
 * jsnx.clustering(G, 0);
 * // 1
 * jsnx.clustering(G);
 * // Map {0: 1, 1: 1, 2: 1, 3: 1, 4: 1}
 * ```
 *
 * @param {Graph} G graph
 * @param {?Iterable=} optNodes (default: all nodes)
 *      Compute average clustering for nodes in this container.
 * @param {?string=} optWeight (default: null)
 *  If the edge attribute that holds the numerical value used as a weight.
 *  If `null`, then each edge has weight `1`.
 *
 * @return {!(number|Map)} Clustering coefficient at specified nodes
 */

function clustering(G, optNodes, optWeight) {
  if (G.isDirected()) {
    throw new _exceptionsJSNetworkXError2['default']('Clustering algorithms are not defined for directed graphs.');
  }

  var trianglesIter = optWeight == null ? trianglesAndDegreeIter(G, optNodes) : weightedTrianglesAndDegreeIter(G, optNodes, optWeight);

  var clusters = new _internals.Map((0, _internals.mapIterator)(trianglesIter, function (_ref4) {
    var _ref42 = _slicedToArray(_ref4, 3);

    var node = _ref42[0];
    var degree = _ref42[1];
    var triangles = _ref42[2];

    return (0, _internals.tuple2)(node, triangles === 0 ? 0 : triangles / (degree * (degree - 1)));
  }));

  return G.hasNode(optNodes) ? (0, _internals.next)(clusters.values()) : clusters;
}

function genClustering(G, optNodes, optWeight) {
  return (0, _internalsDelegate2['default'])('clustering', [G, optNodes, optWeight]);
}

/**
 * Compute graph transitivity, the fraction of all possible triangles
 * present in G.
 *
 * Possible triangles are identified by the number of "triads"
 * (two edges with a shared vertex).
 *
 * The transitivity is
 *
 * ```math
 * T = 3\frac{\#triangles}{\#triads}
 * ```
 *
 * ### Example
 *
 * ```
 * var G = jsnx.completeGraph(5);
 * jsnx.transitivity(G);
 * // 1
 * ```
 *
 * @param {Graph} G graph
 * @return {number} Transitivity
 */

function transitivity(G) {
  /* eslint-disable no-shadow */
  var triangles = 0; // 6 times number of triangles
  /* eslint-enable no-shadow */
  var triples = 0; // 2 times number of connected triples

  /* eslint-disable no-unused-vars */
  var _iteratorNormalCompletion6 = true;
  var _didIteratorError6 = false;
  var _iteratorError6 = undefined;

  try {
    for (var _iterator6 = _getIterator(trianglesAndDegreeIter(G)), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
      var _step6$value = _slicedToArray(_step6.value, 3);

      var node = _step6$value[0];
      var degree = _step6$value[1];
      var triangles_ = _step6$value[2];

      /* eslint-enable no-unused-vars */
      triples += degree * (degree - 1);
      triangles += triangles_;
    }
  } catch (err) {
    _didIteratorError6 = true;
    _iteratorError6 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion6 && _iterator6['return']) {
        _iterator6['return']();
      }
    } finally {
      if (_didIteratorError6) {
        throw _iteratorError6;
      }
    }
  }

  return triangles === 0 ? 0 : triangles / triples;
}

function genTransitivity(G) {
  return (0, _internalsDelegate2['default'])('transitivity', [G]);
}

/**
 * Compute the squares clustering coefficient for nodes.
 *
 * For each node return the faction of possible squares that exist at the node
 *
 * ```math
 * C_4(v) = \frac{ \sum_{u=1}^{k_v}
 * \sum_{w=u+1}^{k_v} q_v(u,w) }{ \sum_{u=1}^{k_v}
 * \sum_{w=u+1}^{k_v} [a_v(u,w) + q_v(u,w)]}
 * ```
 *
 * where `$q_v(u,w)$` are the number of common neighbors of `$u$` and `$v$`
 * other than `$v$` (i.e. squares), and
 * `$a_v(u,w) = (k_u-(1+q_v(u,w)+\theta_{uv}))(k_w-(1+q_v(u,w)+\theta_{uw}))$`
 * where `$\theta_{uw} = 1$` if `$u$` and `$w$` are  connected and `$0$`
 * otherwise.
 *
 * ### Examples
 *
 * ```
 * var G = jsnx.completeGraph(5);
 * jsnx.squareClustering(G, 0);
 * // 1
 * jsnx.squareClustering(G);
 * // Map {0: 1, 1: 1, 2: 1, 3: 1, 4: 1}
 * ```
 *
 * ### Notes
 *
 * While `$C_3(v)$` (triangle clustering) gives the probability that
 * two neighbors of node `$v$` are connected with each other, `$C_4(v)$` is
 * the probability that two neighbors of node `$v$` share a common
 * neighbor different from `$v$`. This algorithm can be applied to both
 * bipartite and unipartite networks.
 *
 * @param {Graph} G graph
 * @param {Iterable=} opt_nodes (default: all)
 *   Compute clustering for nodes in this container.
 *
 * @return {!(Map|number)}
 *      A dictionary keyed by node with the square clustering coefficient value.
 */

function squareClustering(G, optNodes) {
  var nodesIter = optNodes == null ? G : G.nbunchIter(optNodes);
  var clustering = new _internals.Map(); // eslint-disable-line no-shadow

  var _iteratorNormalCompletion7 = true;
  var _didIteratorError7 = false;
  var _iteratorError7 = undefined;

  try {
    for (var _iterator7 = _getIterator(nodesIter), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
      var v = _step7.value;

      clustering.set(v, 0);
      var potential = 0;

      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = _getIterator((0, _internals.genCombinations)(G.get(v).keys(), 2)), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var _step8$value = _slicedToArray(_step8.value, 2);

          var u = _step8$value[0];
          var w = _step8$value[1];

          var squares = new _internals.Set(G.get(u).keys()).intersection(new _internals.Set(G.get(w).keys()));
          squares['delete'](v);
          squares = squares.size;

          clustering.set(v, clustering.get(v) + squares);
          var degm = squares + 1;
          if (G.get(u).has(w)) {
            degm += 1;
          }
          potential += (G.get(u).size - degm) * (G.get(w).size - degm) + squares;
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8['return']) {
            _iterator8['return']();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      if (potential > 0) {
        clustering.set(v, clustering.get(v) / potential);
      }
    }
  } catch (err) {
    _didIteratorError7 = true;
    _iteratorError7 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion7 && _iterator7['return']) {
        _iterator7['return']();
      }
    } finally {
      if (_didIteratorError7) {
        throw _iteratorError7;
      }
    }
  }

  if (G.hasNode(optNodes)) {
    return (0, _internals.next)(clustering.values()); // return single value
  }
  return clustering;
}

function genSquareClustering(G, optNodes) {
  return (0, _internalsDelegate2['default'])('squareClustering', [G, optNodes]);
}

/*jshint ignore:start*/

/*jshint ignore:end*/

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(16)['default'];

var _Array$from = __webpack_require__(13)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.isGraphical = isGraphical;
exports.genIsGraphical = genIsGraphical;
exports.isValidDegreeSequence = isValidDegreeSequence;
exports.genIsValidDegreeSequence = genIsValidDegreeSequence;
exports.isValidDegreeSequenceHavelHakimi = isValidDegreeSequenceHavelHakimi;
exports.genIsValidDegreeSequenceHavelHakimi = genIsValidDegreeSequenceHavelHakimi;
exports.isValidDegreeSequenceErdosGallai = isValidDegreeSequenceErdosGallai;
exports.genIsValidDegreeSequenceErdosGallai = genIsValidDegreeSequenceErdosGallai;

var _internalsDelegate = __webpack_require__(27);

var _internalsDelegate2 = _interopRequireDefault(_internalsDelegate);

var _exceptions = __webpack_require__(88);

var _internalsFillArray = __webpack_require__(342);

var _internalsFillArray2 = _interopRequireDefault(_internalsFillArray);

'use strict';

/**
 * Returns `true` if `sequence` is a valid degree sequence.
 * A degree sequence is valid if some graph can realize it.
 *
 * ### Example
 *
 * ```
 * var G = jsnx.pathGraph(4);
 * var sequence = G.degree().values();
 * jsnx.isValidDegreeSequence(sequence);
 * // true
 * ```
 *
 * @param {Iterable} sequence A sequence of integer node degrees.
 * @param {string=} optMethod ('eg' | 'hh')
 *      The method used to validate the degree sequence.
 *      "eg" corresponds to the Erdős-Gallai algorithm, and
 *      "hh" to the Havel-Hakimi algorithm.
 * @return {boolean}
 *      `true` if `sequence` is a valid degree sequence and `false` if not.
 */

function isGraphical(sequence) {
  var optMethod = arguments.length <= 1 || arguments[1] === undefined ? 'hh' : arguments[1];

  switch (optMethod) {
    case 'eg':
      return isValidDegreeSequenceErdosGallai(_Array$from(sequence));
    case 'hh':
      return isValidDegreeSequenceHavelHakimi(_Array$from(sequence));
    default:
      throw new _exceptions.JSNetworkXException('`opt_method` must be \'eg\' or \'hh\'');
  }
}

function genIsGraphical(sequence, optMethod) {
  return (0, _internalsDelegate2['default'])('isGraphical', [sequence, optMethod]);
}

// We need this instead of just aliasing this so that the async code transform
// kicks in
/**
 * @alias isGraphical
 */

function isValidDegreeSequence(sequence, optMethod) {
  return isGraphical(sequence, optMethod);
}

function genIsValidDegreeSequence(sequence, optMethod) {
  return (0, _internalsDelegate2['default'])('isValidDegreeSequence', [sequence, optMethod]);
}

function basicGraphicalTests(sequence) {
  // sort and perform some simple tests on the sequence
  if (!sequence.every(function (x) {
    return Math.floor(x) === x;
  })) {
    // list of positive intengers
    throw new _exceptions.JSNetworkXUnfeasible();
  }

  var numberOfNodes = sequence.length;
  var numDegress = (0, _internalsFillArray2['default'])(numberOfNodes, 0);
  var maxDegree = 0;
  var minDegree = numberOfNodes;
  var degreeSum = 0;
  var n = 0;

  for (var i = 0; i < numberOfNodes; i++) {
    var degree = sequence[i];
    // Reject if degree is negative or larger than the sequence length
    if (degree < 0 || degree >= numberOfNodes) {
      throw new _exceptions.JSNetworkXUnfeasible();
    }
    // process only the non-zero integers
    else if (degree > 0) {
      maxDegree = Math.max(maxDegree, degree);
      minDegree = Math.min(minDegree, degree);
      degreeSum += degree;
      n += 1;
      numDegress[degree] += 1;
    }
  }
  // Reject sequence if it has odd sum or is over-saturated
  if (degreeSum % 2 === 1 || degreeSum > n * (n - 1)) {
    throw new _exceptions.JSNetworkXUnfeasible();
  }
  return [maxDegree, minDegree, degreeSum, n, numDegress];
}

/**
 * Returns `true` if `degreeSequence` cam be realized by a simple graph.
 *
 * The Validation proceeds via the Havel-Hakimi theorem.
 * Worst-case run time is `$O(s)$`, where `$s$` is the sum of the degree
 * sequence.
 *
 * The `$ZZ$` condition says that for the sequence `$d$`, if
 *
 * ```math
 *     |d| >= \frac{(\max(d) + \min(d) + 1)^2}{4*\min(d)}
 * ```
 *
 * then `$d$` is graphical.
 *
 * ### References
 *
 * [1] I.E. Zverovich and V.E. Zverovich. "Contributions to the theory
 *     of graphic sequences", Discrete Mathematics, 105, pp. 292-303 (1992).
 *
 * @param {Iterable} degreeSequence
 *   A list of integers where each element specifies the degree of a node
 *   in a graph.
 * @return {boolean} `true` if `degreeSequence` is graphical and `false` if not.
 */

function isValidDegreeSequenceHavelHakimi(degreeSequence) {
  var _; // eslint-disable-line no-unused-vars
  var maxDegree;
  var minDegree;
  var n;
  var numDegrees;

  try {
    var _basicGraphicalTests = basicGraphicalTests(degreeSequence);

    var _basicGraphicalTests2 = _slicedToArray(_basicGraphicalTests, 5);

    maxDegree = _basicGraphicalTests2[0];
    minDegree = _basicGraphicalTests2[1];
    _ = _basicGraphicalTests2[2];
    n = _basicGraphicalTests2[3];
    numDegrees = _basicGraphicalTests2[4];
  } catch (ex) {
    if (ex instanceof _exceptions.JSNetworkXUnfeasible) {
      return false;
    } else {
      throw ex;
    }
  }
  // Accept if sequence has no non-zero degrees or passes the ZZ condition
  if (n === 0 || 4 * minDegree * n >= Math.pow(maxDegree + minDegree + 1, 2)) {
    return true;
  }

  var modstubs = (0, _internalsFillArray2['default'])(maxDegree + 1, 0);
  // successively reduce degree sequence by removing node of maximum degree
  while (n > 0) {
    // Retrieve the maximum degree in the sequence
    while (numDegrees[maxDegree] === 0) {
      maxDegree -= 1;
    }
    // If there are not enough stubs to connect to, then the sequence is not
    // graphical
    if (maxDegree > n - 1) {
      return false;
    }

    // Remove largest stub in list
    numDegrees[maxDegree] -= 1;
    n -= 1;
    // Reduce the next maxDegree largest stubs
    var mslen = 0;
    var k = maxDegree;
    for (var i = 0; i < maxDegree; i++) {
      while (numDegrees[k] === 0) {
        k -= 1;
      }
      numDegrees[k] -= 1;
      n -= 1;
      if (k > 1) {
        modstubs[mslen] = k - 1;
        mslen += 1;
      }
    }
    // Add back to the list any non-zero stubs that were removed
    for (i = 0; i < mslen; i++) {
      var stub = modstubs[i];
      numDegrees[stub] += 1;
      n += 1;
    }
  }
  return true;
}

function genIsValidDegreeSequenceHavelHakimi(degreeSequence) {
  return (0, _internalsDelegate2['default'])('isValidDegreeSequenceHavelHakimi', [degreeSequence]);
}

/**
 * Returns `true` if `degreeSequence` can be realized by a simple graph.
 * The validation is done using the Erdős-Gallai theorem.
 *
 * This implementation uses an equivalent form of the Erdős-Gallai criterion.
 * Worst-case run time is `$O(n)$` where `$n$` is the length of the sequence.
 *
 * Specifically, a sequence `$d$` is graphical if and only if the sum of the
 * sequence is even and for all strong indices `$k$` in the sequence,
 *
 * ```math
 * \sum_{i=1}^{k} d_i \leq k(k-1) + \sum_{j=k+1}^{n} \min(d_i,k)
 *    = k(n-1) - ( k \sum_{j=0}^{k-1} n_j - \sum_{j=0}^{k-1} j n_j )
 * ```
 *
 * A strong index `$k$` is any index where `$d_k \geq k$` and the value `$n_j$`
 * is the number of occurrences of `$j$` in `$d$`. The maximal strong index is
 * called the Durfee index.
 *
 * This particular rearrangement comes from the proof of Theorem 3 in (2)
 *
 * The `$ZZ$` condition says that for the sequence `$d$`, if
 *
 * ```math
 * |d| >= \frac{(\max(d) + \min(d) + 1)^2}{4*\min(d)}
 * ```
 *
 * then `$d$` is graphical. This was shown in Theorem 6 in (2).
 *
 * ### References
 * [1] A. Tripathi and S. Vijay. "A note on a theorem of Erdős & Gallai",
 *     Discrete Mathematics, 265, pp. 417-420 (2003).
 *
 * [2] I.E. Zverovich and V.E. Zverovich. "Contributions to the theory
 *     of graphic sequences", Discrete Mathematics, 105, pp. 292-303 (1992).
 *
 * @param {Iterable} degreeSequence
 *      A list of integers where each element specifies the degree of a node
 *      in a graph.
 * @return {boolean} `true` if `degreeSequence` is graphical and f`alse` if not.
 */

function isValidDegreeSequenceErdosGallai(degreeSequence) {
  var maxDegree;
  var minDegree;
  var _; // eslint-disable-line no-unused-vars
  var n;
  var numDegrees;

  try {
    var _basicGraphicalTests3 = basicGraphicalTests(degreeSequence);

    var _basicGraphicalTests32 = _slicedToArray(_basicGraphicalTests3, 5);

    maxDegree = _basicGraphicalTests32[0];
    minDegree = _basicGraphicalTests32[1];
    _ = _basicGraphicalTests32[2];
    n = _basicGraphicalTests32[3];
    numDegrees = _basicGraphicalTests32[4];
  } catch (ex) {
    if (ex instanceof _exceptions.JSNetworkXUnfeasible) {
      return false;
    } else {
      throw ex;
    }
  }
  // Accept if sequence has no non-zero degrees or passes the ZZ condition
  if (n === 0 || 4 * minDegree * n >= Math.pow(maxDegree + minDegree + 1, 2)) {
    return true;
  }

  // Perform the EG checks using the reformulation of Zverovich and Zverovich
  var k = 0;
  var degreeSum = 0;
  var sumnj = 0;
  var sumjnj = 0;

  for (var dk = maxDegree; dk >= minDegree; dk -= 1) {
    if (dk < k + 1) {
      // Check if already past Durfee index
      return true;
    }
    if (numDegrees[dk] > 0) {
      var runSize = numDegrees[dk]; // Process a run of identical-valued degrees
      if (dk < k + runSize) {
        // Check if end of run is past Durfee index
        runSize = dk - k; // Adjust back to Durfee index
      }
      degreeSum += runSize * dk;
      for (var v = 0; v < runSize; v++) {
        sumnj += numDegrees[k + v];
        sumjnj += (k + v) * numDegrees[k + v];
      }
      k += runSize;
      if (degreeSum > k * (n - 1) - k * sumnj + sumjnj) {
        return false;
      }
    }
  }
  return true;
}

// TODO: is_multigraphical
// TODO: is_pseudographical
// TODO: is_digraphical

function genIsValidDegreeSequenceErdosGallai(degreeSequence) {
  return (0, _internalsDelegate2['default'])('isValidDegreeSequenceErdosGallai', [degreeSequence]);
}

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(16)['default'];

var _getIterator = __webpack_require__(8)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.singleSourceShortestPathLength = singleSourceShortestPathLength;
exports.genSingleSourceShortestPathLength = genSingleSourceShortestPathLength;
exports.allPairsShortestPathLength = allPairsShortestPathLength;
exports.genAllPairsShortestPathLength = genAllPairsShortestPathLength;
exports.bidirectionalShortestPath = bidirectionalShortestPath;
exports.genBidirectionalShortestPath = genBidirectionalShortestPath;
exports.singleSourceShortestPath = singleSourceShortestPath;
exports.genSingleSourceShortestPath = genSingleSourceShortestPath;
exports.allPairsShortestPath = allPairsShortestPath;
exports.genAllPairsShortestPath = genAllPairsShortestPath;
exports.predecessor = predecessor;
exports.genPredecessor = genPredecessor;

var _internalsDelegate = __webpack_require__(27);

var _internalsDelegate2 = _interopRequireDefault(_internalsDelegate);

/**
 * @fileoverview Shortest path algorithms for unweighted graphs.
 */

var _exceptions = __webpack_require__(88);

var _internals = __webpack_require__(15);

'use strict';

/**
 * Compute the shortest path lengths from source to all reachable nodes.
 *
 * ### Example
 *
 * ```
 * var G = jsnx.pathGraph(5);
 * var length = jsnx.singleSourceShortestPathLength(G, 0);
 * length.get(4);
 * // 4
 * length
 * // Map {0: 0, 1: 1, 2: 2, 3: 3, 4: 4}
 * ```
 *
 * @see shortestPathLength
 *
 * @param {Graph} G graph
 * @param {Node} source Starting node for path
 * @param {number=} optCutoff
 *    Depth to stop the search. Only paths of length <= cutoff are returned.
 *
 * @return {!Map} Map of shortest path lengths keyed by target.
 */

function singleSourceShortestPathLength(G, source, optCutoff) {
  var seen = new _internals.Map(); // level (number of hops) when seen n BFS
  var level = 0; // the current level
  // map of nodes to check at next level
  var nextlevel = new _internals.Map([[source, 1]]);

  while (nextlevel.size > 0) {
    var thislevel = nextlevel;
    nextlevel = new _internals.Map();
    /*eslint no-loop-func:0*/
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = _getIterator(thislevel.keys()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var v = _step.value;

        if (!seen.has(v)) {
          seen.set(v, level);
          G.get(v).forEach(function (_, n) {
            return nextlevel.set(n, 1);
          });
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator['return']) {
          _iterator['return']();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    if (optCutoff != null && optCutoff <= level) {
      break;
    }
    level += 1;
  }
  return seen;
}

function genSingleSourceShortestPathLength(G, source, optCutoff) {
  return (0, _internalsDelegate2['default'])('singleSourceShortestPathLength', [G, source, optCutoff]);
}

/**
 * Compute the shortest path lengths between all nodes in G.
 *
 * The map returned only has keys for reachable node pairs.
 *
 * ### Example
 *
 * ```
 * var G = jsnx.pathGraph(5);
 * var length = jsnx.allPairsShortestPathLength(G);
 * length.get(1).get(4);
 * // 3
 * length.get(1);
 * // Map {0: 1, 1: 0, 2: 1, 3: 2, 4: 3}
 * ```
 *
 * @param {Graph} G
 * @param {number=} optCutoff  depth to stop the search.
 *    Only paths of length <= cutoff are returned.
 *
 * @return {!Map}
 */

function allPairsShortestPathLength(G, optCutoff) {
  var paths = new _internals.Map();
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = _getIterator(G), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var n = _step2.value;

      paths.set(n, singleSourceShortestPathLength(G, n, optCutoff));
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2['return']) {
        _iterator2['return']();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return paths;
}

function genAllPairsShortestPathLength(G, optCutoff) {
  return (0, _internalsDelegate2['default'])('allPairsShortestPathLength', [G, optCutoff]);
}

/**
 * Return a list of nodes in a shortest path between source and target.
 *
 * This algorithm is used by `shortestPath(G, source, target)`.
 *
 * @see shortestPath
 *
 * @param {Graph} G
 * @param {Node} source starting node for path
 * @param {Node} target ending node for path
 *
 * @return {!Array}
 */

function bidirectionalShortestPath(G, source, target) {
  // call helper to do the real work

  var _bidirectionalPredSucc = bidirectionalPredSucc(G, source, target);

  var _bidirectionalPredSucc2 = _slicedToArray(_bidirectionalPredSucc, 3);

  var pred = _bidirectionalPredSucc2[0];
  var succ = _bidirectionalPredSucc2[1];
  var w = _bidirectionalPredSucc2[2];

  // build path from pred+w+succ
  var path = [];
  // from source to w
  while (w != null) {
    path.push(w);
    w = pred.get(w);
  }
  w = succ.get(path[0]);
  path.reverse();
  // from w to target
  while (w != null) {
    path.push(w);
    w = succ.get(w);
  }
  return path;
}

function genBidirectionalShortestPath(G, source, target) {
  return (0, _internalsDelegate2['default'])('bidirectionalShortestPath', [G, source, target]);
}

/**
 * Bidirectional shortest path helper.
 *
 * @return {!Array} Returns [pred,succ,w] where
 *    pred is a map of predecessors from w to the source, and
 *    succ is a map of successors from w to the target.
 */
function bidirectionalPredSucc(G, source, target) {
  // does BFS from both source and target and meets in the middle
  if ((0, _internals.nodesAreEqual)(source, target)) {
    return [new _internals.Map([[source, null]]), new _internals.Map([[target, null]]), source];
  }

  // handle either directed or undirected
  var gpred, gsucc;
  if (G.isDirected()) {
    gpred = G.predecessorsIter.bind(G);
    gsucc = G.successorsIter.bind(G);
  } else {
    gpred = G.neighborsIter.bind(G);
    gsucc = G.neighborsIter.bind(G);
  }

  // predecesssor and successors in search
  var pred = new _internals.Map([[source, null]]);
  var succ = new _internals.Map([[target, null]]);
  //
  // initialize fringes, start with forward
  var forwardFringe = [source];
  var reverseFringe = [target];
  var thisLevel;

  /*jshint newcap:false*/
  while (forwardFringe.length > 0 && reverseFringe.length > 0) {
    if (forwardFringe.length <= reverseFringe.length) {
      thisLevel = forwardFringe;
      forwardFringe = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = _getIterator(thisLevel), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var v = _step3.value;
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = _getIterator(gsucc(v)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var w = _step4.value;

              if (!pred.has(w)) {
                forwardFringe.push(w);
                pred.set(w, v);
              }
              if (succ.has(w)) {
                return [pred, succ, w]; // found path
              }
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4['return']) {
                _iterator4['return']();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3['return']) {
            _iterator3['return']();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    } else {
      thisLevel = reverseFringe;
      reverseFringe = [];
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = _getIterator(thisLevel), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var v = _step5.value;
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = _getIterator(gpred(v)), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var w = _step6.value;

              if (!succ.has(w)) {
                reverseFringe.push(w);
                succ.set(w, v);
              }
              if (pred.has(w)) {
                return [pred, succ, w]; // found path
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6['return']) {
                _iterator6['return']();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5['return']) {
            _iterator5['return']();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    }
  }
  throw new _exceptions.JSNetworkXNoPath((0, _internals.sprintf)('No path between `%j` and `%j`.', source, target));
}

/**
 * Compute shortest path between source and all other nodes reachable from
 * source.
 *
 * ### Example
 *
 * ```
 * var G = jsnx.pathGraph(5);
 * var path = jsnx.singleSourceShortestPath(G, 0);
 * path.get(4);
 * // [1, 2, 3, 4]
 * ```
 *
 * ### Notes
 *
 * The shortest path is not necessarily unique. So there can be multiple⋅
 * paths between the source and each target node, all of which have the⋅
 * same 'shortest' length. For each target node, this function returns⋅
 * only one of those paths.
 *
 *
 * @see shortestPath
 *
 * @param {Graph} G
 * @param {Node} source
 * @param {number=} optCutoff Depth to stop the search.
 *    Only paths of `length <= cutoff` are returned.
 *
 * @return {!Map<Array>} Map, keyed by target, of shortest paths.
 */

function singleSourceShortestPath(G, source, optCutoff) {
  var level = 0;
  var nextlevel = new _internals.Map([[source, 1]]);
  var paths = new _internals.Map([[source, [source]]]);
  if (optCutoff === 0) {
    return paths;
  }
  /*jshint loopfunc:true*/
  while (nextlevel.size > 0) {
    var thislevel = nextlevel;
    nextlevel = new _internals.Map();
    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
      for (var _iterator7 = _getIterator(thislevel.keys()), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
        var v = _step7.value;
        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
          for (var _iterator8 = _getIterator(G.get(v).keys()), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
            var w = _step8.value;

            if (!paths.has(w)) {
              paths.set(w, paths.get(v).concat([w]));
              nextlevel.set(w, 1);
            }
          }
        } catch (err) {
          _didIteratorError8 = true;
          _iteratorError8 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion8 && _iterator8['return']) {
              _iterator8['return']();
            }
          } finally {
            if (_didIteratorError8) {
              throw _iteratorError8;
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError7 = true;
      _iteratorError7 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion7 && _iterator7['return']) {
          _iterator7['return']();
        }
      } finally {
        if (_didIteratorError7) {
          throw _iteratorError7;
        }
      }
    }

    level += 1;
    if (optCutoff != null && optCutoff <= level) {
      break;
    }
  }
  return paths;
}

function genSingleSourceShortestPath(G, source, optCutoff) {
  return (0, _internalsDelegate2['default'])('singleSourceShortestPath', [G, source, optCutoff]);
}

/**
 * Compute shortest paths between all nodes.
 *
 * ### Example
 *
 * ```
 * var G = jsnx.pathGraph(5);
 * var path = jsnx.allPairsShortestPath(G);
 * path.get(0).get(4);
 * // [0, 1, 2, 3, 4]
 * ```
 *
 * @see floydWarshall
 *
 * @param {Graph} G
 * @param {number=} optCutoff Depth to stop the search.
 *    Only paths of length <= cutoff are returned.
 *
 * @return {!Map} Map, keyed by source and target, of shortest paths.
 */

function allPairsShortestPath(G, optCutoff) {
  var paths = new _internals.Map();
  var _iteratorNormalCompletion9 = true;
  var _didIteratorError9 = false;
  var _iteratorError9 = undefined;

  try {
    for (var _iterator9 = _getIterator(G), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
      var n = _step9.value;

      paths.set(n, singleSourceShortestPath(G, n, optCutoff));
    }
  } catch (err) {
    _didIteratorError9 = true;
    _iteratorError9 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion9 && _iterator9['return']) {
        _iterator9['return']();
      }
    } finally {
      if (_didIteratorError9) {
        throw _iteratorError9;
      }
    }
  }

  return paths;
}

function genAllPairsShortestPath(G, optCutoff) {
  return (0, _internalsDelegate2['default'])('allPairsShortestPath', [G, optCutoff]);
}

/**
 * Returns a map of predecessors for the path from source to all nodes in G.
 *
 * ### Example
 *
 * ```
 * var G = jsnx.pathGraph(4);
 * G.nodes();
 * // [0, 1, 2, 3, 4]
 * jsnx.predecessor(G, 0);
 * // Map {0: [], 1: [0], 2: [1], 3: [2]}
 *
 * @param {Graph} G
 * @param {Node} source Starting node for path
 * @param {{target: Node, cutoff: number, returnSeen: boolean}} optArgs
 *   - `target(=null)`: If provided only predecessors between⋅source and target
 *     are returned
 *   - `cutoff`: Depth to stop the search. Only paths of `length <= cutoff` are
 *     returned
 *   - `returnSeen(=false)`: If `true`, return `(seenNodes, predecessors)`
 *
 * @return {!(Map|Array)} Map, keyed by node, of predecessors in the shortest
 *   path.
 */

function predecessor(G, source) {
  var optArgs = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

  // TODO: use parameter destructuring
  // {target, cutoff, returnSeen}
  var target = optArgs.target;
  var cutoff = optArgs.cutoff;
  var returnSeen = optArgs.returnSeen;

  var level = 0;
  var nextlevel = [source];
  var seen = new _internals.Map([[source, level]]);
  var pred = new _internals.Map([[source, []]]);

  /*jshint loopfunc:true*/
  while (nextlevel.length > 0) {
    level += 1;
    var thislevel = nextlevel;
    nextlevel = [];
    thislevel.forEach(function (v) {
      G.get(v).forEach(function (_, w) {
        if (!seen.has(w)) {
          pred.set(w, [v]);
          seen.set(w, level);
          nextlevel.push(w);
        } else if (seen.get(w) === level) {
          // add v to predecesssor list if it
          pred.get(w).push(v); // is at the correct level
        }
      });
    });
    if (cutoff != null && cutoff <= level) {
      break;
    }
  }

  if (target != null) {
    if (returnSeen) {
      return pred.has(target) ? [pred.get(target), seen.get(target)] : [[], -1];
    } else {
      return (0, _internals.getDefault)(pred.get(target), []);
    }
  }
  return returnSeen ? [pred, seen] : pred;
}

function genPredecessor(G, source, optArgs) {
  return (0, _internalsDelegate2['default'])('predecessor', [G, source, optArgs]);
}

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty = __webpack_require__(218)['default'];

var _slicedToArray = __webpack_require__(16)['default'];

var _getIterator = __webpack_require__(8)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.dijkstraPath = dijkstraPath;
exports.genDijkstraPath = genDijkstraPath;
exports.dijkstraPathLength = dijkstraPathLength;
exports.genDijkstraPathLength = genDijkstraPathLength;
exports.singleSourceDijkstraPath = singleSourceDijkstraPath;
exports.genSingleSourceDijkstraPath = genSingleSourceDijkstraPath;
exports.singleSourceDijkstraPathLength = singleSourceDijkstraPathLength;
exports.genSingleSourceDijkstraPathLength = genSingleSourceDijkstraPathLength;
exports.singleSourceDijkstra = singleSourceDijkstra;
exports.genSingleSourceDijkstra = genSingleSourceDijkstra;
exports.allPairsDijkstraPathLength = allPairsDijkstraPathLength;
exports.genAllPairsDijkstraPathLength = genAllPairsDijkstraPathLength;
exports.allPairsDijkstraPath = allPairsDijkstraPath;
exports.genAllPairsDijkstraPath = genAllPairsDijkstraPath;

var _internalsDelegate = __webpack_require__(27);

var _internalsDelegate2 = _interopRequireDefault(_internalsDelegate);

var _internals = __webpack_require__(15);

var _exceptionsJSNetworkXNoPath = __webpack_require__(361);

var _exceptionsJSNetworkXNoPath2 = _interopRequireDefault(_exceptionsJSNetworkXNoPath);

'use strict';

/**
 * Returns the shortest path from `source` to `target` in a weighted graph G.
 *
 * ### Examples
 *
 * ```
 * var G = jsnx.pathGraph(5);
 * jsnx.dijkstraPath(G, {source: 0, target: 4});
 * // [0, 1, 2, 3, 4]
 * ```
 *
 * ### Notes
 *
 * Edge weight attributes must be numerical. Distances are calculated as sums
 * of weighted edges traversed.
 *
 * @see bidirectionalDijkstra
 *
 * @param {Graph} G
 * @param {{source: Node, target: Node, weight: ?string}} parameters
 *   - source: Starting node
 *   - target: Ending node
 *   - weight(='weight'): Edge data key corresponding to the edge weight
 * @return {Array} List of nodes in a shortest path
 */

function dijkstraPath(G, _ref3) {
  var source = _ref3.source;
  var target = _ref3.target;
  var _ref3$weight = _ref3.weight;
  var weight = _ref3$weight === undefined ? 'weight' : _ref3$weight;

  var _singleSourceDijkstra = // eslint-disable-line no-unused-vars
  singleSourceDijkstra(G, { source: source, target: target, weight: weight });

  var _singleSourceDijkstra2 = _slicedToArray(_singleSourceDijkstra, 2);

  var distances = _singleSourceDijkstra2[0];
  var paths = _singleSourceDijkstra2[1];

  var path = paths.get(target);
  if (!path) {
    throw new _exceptionsJSNetworkXNoPath2['default']((0, _internals.sprintf)('Node %j is not reachable from %j', source, target));
  }
  return path;
}

function genDijkstraPath(G, _source$target$weight) {
  return (0, _internalsDelegate2['default'])('dijkstraPath', [G, _source$target$weight]);
}

/**
 * Returns the shortest path length from `source` to `target` in a weighted
 * graph.
 *
 * ### Examples
 *
 * ```
 * var G = jsnx.pathGraph(5);
 * jsnx.dijkstraPathLength(G, {source: 0, target: 4});
 * // 4
 * ```
 *
 * ### Notes
 *
 * Edge weight attributes must be numerical. Distances are calculated as sums
 * of weighted edges traversed.
 *
 * @see bidirectionalDijkstra
 *
 * @param {Graph} G
 * @param {{source: Node, target: Node, weight: ?string}} parameters
 *   - source: Starting node
 *   - target: Ending node
 *   - weight(='weight'): Edge data key corresponding to the edge weight
 * @return {number} Shortest path length
 */

function dijkstraPathLength(G, _ref4) {
  var source = _ref4.source;
  var target = _ref4.target;
  var _ref4$weight = _ref4.weight;
  var weight = _ref4$weight === undefined ? 'weight' : _ref4$weight;

  var distances = singleSourceDijkstraPathLength(G, { source: source, weight: weight });
  var distance = distances.get(target);
  if (distance == null) {
    throw new _exceptionsJSNetworkXNoPath2['default']((0, _internals.sprintf)('Node %j is not reachable from %j', source, target));
  }
  return distance;
}

function genDijkstraPathLength(G, _source$target$weight2) {
  return (0, _internalsDelegate2['default'])('dijkstraPathLength', [G, _source$target$weight2]);
}

function minMultiEdgeWeight(keydata, weight) {
  var minweight = Infinity;
  for (var key in keydata) {
    var edgeWeight = (0, _internals.getDefault)(keydata[key][weight], 1);
    if (edgeWeight < minweight) {
      minweight = edgeWeight;
    }
  }
  return minweight;
}

/**
 * Compute shortest path between source and all other reachable nodes for a
 * weighted graph.
 *
 * ### Examples
 *
 * ```
 * var G = jsnx.pathGraph(5);
 * var path = jsnx.singleSourceDijkstraPath(G, {source: 0});
 * path.get(4);
 * // [0, 1, 2, 3, 4]
 * ```
 *
 * ### Notes
 *
 * Edge weight attributes must be numerical. Distances are calculated as sums
 * of weighted edges traversed.
 *
 * @see singleSourceDijkstra
 *
 * @param {Graph} G
 * @param {{source: Node, weight: ?string, cutoff: ?number}} parameters
 *   - source: Starting node for path
 *   - weight: Edge data key corresponding to the edge weight
 *   - cutoff: Depth to stop the search. Only paths of length <= cutoff are
 *     returned.
 * @return {Map} Map of shortest paths keyed by target
 */

function singleSourceDijkstraPath(G, _ref5) {
  var source = _ref5.source;
  var cutoff = _ref5.cutoff;
  var _ref5$weight = _ref5.weight;
  var weight = _ref5$weight === undefined ? 'weight' : _ref5$weight;

  var _singleSourceDijkstra3 = // eslint-disable-line no-unused-vars
  singleSourceDijkstra(G, { source: source, cutoff: cutoff, weight: weight });

  var _singleSourceDijkstra32 = _slicedToArray(_singleSourceDijkstra3, 2);

  var length = _singleSourceDijkstra32[0];
  var path = _singleSourceDijkstra32[1];

  return path;
}

function genSingleSourceDijkstraPath(G, _source$cutoff$weight) {
  return (0, _internalsDelegate2['default'])('singleSourceDijkstraPath', [G, _source$cutoff$weight]);
}

/**
 * Compute the shortest path length between source and all other reachable
 * nodes for a weighted graph.
 *
 * ### Examples
 *
 * ```
 * var G = jsnx.pathGraph(5);
 * var length = jsnx.singleSourceDijkstraPathLength(G, {source: 0});
 * length.get(4);
 * // 4
 * length
 * // Map {0: 0, 1: 1, 2: 2, 3: 3, 4: 4}
 * ```
 *
 * ### Notes
 *
 * Edge weight attributes must be numerical. Distances are calculated as sums
 * of weighted edges traversed.
 *
 * @see singleSourceDijkstra
 *

 * @param {Graph} G
 * @param {{source: Node, weight: ?string, cutoff: ?number}} parameters
 *   - source: Starting node for path
 *   - weight: Edge data key corresponding to the edge weight
 *   - cutoff: Depth to stop the search. Only paths of length <= cutoff are
 *     returned.
 * @return {Map} Map of shortest paths keyed by target
 */

function singleSourceDijkstraPathLength(G, _ref6) {
  var source = _ref6.source;
  var cutoff = _ref6.cutoff;
  var _ref6$weight = _ref6.weight;
  var weight = _ref6$weight === undefined ? 'weight' : _ref6$weight;

  var distances = new _internals.Map();
  var seen = new _internals.Map([[source, 0]]);
  var fringe = new _internals.PriorityQueue();
  var i = 0;
  fringe.enqueue(0, [i++, source]);
  while (fringe.size > 0) {
    var _fringe$dequeue = fringe.dequeue();

    var _fringe$dequeue2 = _slicedToArray(_fringe$dequeue, 2);

    var d = _fringe$dequeue2[0];

    var _fringe$dequeue2$1 = _slicedToArray(_fringe$dequeue2[1], 2);

    var _ = _fringe$dequeue2$1[0];
    var v = _fringe$dequeue2$1[1];
    // eslint-disable-line no-unused-vars
    if (distances.has(v)) {
      continue; // already searched this node
    }
    distances.set(v, d);
    var edata = undefined;
    if (G.isMultigraph()) {
      edata = (0, _internals.mapIterator)(G.get(v), function (_ref7) {
        var _ref72 = _slicedToArray(_ref7, 2);

        var w = _ref72[0];
        var keydata = _ref72[1];
        // eslint-disable-line no-loop-func
        return [w, _defineProperty({}, weight, minMultiEdgeWeight(keydata, weight))];
      });
    } else {
      edata = G.get(v);
    }
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = _getIterator(edata), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _step$value = _slicedToArray(_step.value, 2);

        var w = _step$value[0];
        var edgeData = _step$value[1];

        var vwDistance = d + (0, _internals.getDefault)(edgeData[weight], 1);
        if (cutoff != null) {
          if (vwDistance > cutoff) {
            continue;
          }
        }
        if (distances.has(w)) {
          if (vwDistance < distances.get(w)) {
            throw new Error('Contradictory paths found: negative weights?');
          }
        } else if (!seen.has(w) || vwDistance < seen.get(w)) {
          seen.set(w, vwDistance);
          fringe.enqueue(vwDistance, [i++, w]);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator['return']) {
          _iterator['return']();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return distances;
}

function genSingleSourceDijkstraPathLength(G, _source$cutoff$weight2) {
  return (0, _internalsDelegate2['default'])('singleSourceDijkstraPathLength', [G, _source$cutoff$weight2]);
}

/**
 * Compute shortest paths and lengths in a weighted graph G.
 *
 * ### Examples
 *
 * ```
 * var G = jsnx.pathGraph(5);
 * var [lengths, paths] = jsnx.singleSourceDijkstra(G, {source: 0});
 * lengths.get(4);
 * // 4
 * lengths
 * // Map {0: 0, 1: 1, 2: 2, 3: 3, 4: 4}
 * paths.get(4);
 * // [0, 1, 2, 3, 4]
 * ```
 *
 * ### Notes
 *
 * Edge weight attributes must be numerical.
 * Distances are calculated as sums of weighted edges traversed.
 *
 * This algorithm is not guaranteed to work if edge weights are negative or are
 * floating point numbers (overflows and roundoff errors can cause problems).
 *
 * @see singleSourceDijkstraPath
 * @see singleSourceDijkstraPathLength
 *
 * @param {Graph} G
 * @param {{source: Node, target: ?Node, cutoff: ?number, weight: ?string}}
 *   parameters
 *   - source: Starting node for path
 *   - target: Ending node in the path (optional)
 *   - weight: Edge data key corresponding to the edge weight
 *   - cutoff: Depth to stop the search. Only paths of length <= cutoff are
 *     returned.
 * @return {Array<Map>}
 *   Returns a tuple of two Maps keyed by node. The first Map stores distances
 *   from the source. The second one stores the path from the source to that
 *   node.
 */

function singleSourceDijkstra(G, _ref8) {
  var source = _ref8.source;
  var target = _ref8.target;
  var cutoff = _ref8.cutoff;
  var _ref8$weight = _ref8.weight;
  var weight = _ref8$weight === undefined ? 'weight' : _ref8$weight;

  if ((0, _internals.nodesAreEqual)(source, target)) {
    return [new _internals.Map([[source, 0]]), new _internals.Map([[source, target]])];
  }

  var distances = new _internals.Map();
  var paths = new _internals.Map([[source, [source]]]);
  var seen = new _internals.Map([[source, 0]]);
  var fringe = new _internals.PriorityQueue();
  var i = 0;
  fringe.enqueue(0, [i++, source]);
  while (fringe.size > 0) {
    var _fringe$dequeue3 = fringe.dequeue();

    var _fringe$dequeue32 = _slicedToArray(_fringe$dequeue3, 2);

    var d = _fringe$dequeue32[0];

    var _fringe$dequeue32$1 = _slicedToArray(_fringe$dequeue32[1], 2);

    var _ = _fringe$dequeue32$1[0];
    var v = _fringe$dequeue32$1[1];
    // eslint-disable-line no-unused-vars
    if (distances.has(v)) {
      continue; // already searched this node
    }
    distances.set(v, d);
    if ((0, _internals.nodesAreEqual)(v, target)) {
      break;
    }
    var edata = undefined;
    if (G.isMultigraph()) {
      edata = (0, _internals.mapIterator)(G.get(v), function (_ref9) {
        var _ref92 = _slicedToArray(_ref9, 2);

        var w = _ref92[0];
        var keydata = _ref92[1];
        // eslint-disable-line no-loop-func
        return [w, _defineProperty({}, weight, minMultiEdgeWeight(keydata, weight))];
      });
    } else {
      edata = G.get(v);
    }
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = _getIterator(edata), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var _step2$value = _slicedToArray(_step2.value, 2);

        var w = _step2$value[0];
        var edgeData = _step2$value[1];

        var vwDistance = d + (0, _internals.getDefault)(edgeData[weight], 1);
        if (cutoff != null) {
          if (vwDistance > cutoff) {
            continue;
          }
        }
        if (distances.has(w)) {
          if (vwDistance < distances.get(w)) {
            throw new Error('Contradictory paths found: negative weights?');
          }
        } else if (!seen.has(w) || vwDistance < seen.get(w)) {
          seen.set(w, vwDistance);
          fringe.enqueue(vwDistance, [i++, w]);
          paths.set(w, paths.get(v).concat([w]));
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2['return']) {
          _iterator2['return']();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }

  return [distances, paths];
}

function genSingleSourceDijkstra(G, _source$target$cutoff$weight) {
  return (0, _internalsDelegate2['default'])('singleSourceDijkstra', [G, _source$target$cutoff$weight]);
}

// TODO dijkstraPredecessorAndDistance

/**
 * Compute shortest path lengths between all nodes in a weighted graph.
 *
 * ### Examples
 *
 * ```
 * var G = jsnx.pathGraph(5);
 * var path = jsnx.allPairsDijkstraPath(G);
 * path.get(1).get(4);
 * // 3
 * path.get(1);
 * // Map {0: 1, 1: 0, 2: 1, 3: 2, 4: 3}
 * ```
 *
 * ### Notes
 *
 * Edge weight attributes must be numerical.
 * Distances are calculated as sums of weighted edges traversed.
 *
 * The Map returned only has keys for reachable node pairs.
 *
 * @param {Graph} G
 * @param {{weight: ?string, cutoff: ?number}=} optParameters
 *   - weight: Edge data key corresponding to the edge weight
 *   - cutoff: Depth to stop the search. Only paths of length <= cutoff are
 *     returned.
 * @return {Map} A Map of Maps of shortest path lengths
 */

function allPairsDijkstraPathLength(G) {
  var _ref10 = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  var cutoff = _ref10.cutoff;
  var _ref10$weight = _ref10.weight;
  var weight = _ref10$weight === undefined ? 'weight' : _ref10$weight;

  var distances = new _internals.Map();
  var parameters = { weight: weight, cutoff: cutoff };
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = _getIterator(G), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var source = _step3.value;

      parameters.source = source;
      distances.set(source, singleSourceDijkstraPathLength(G, parameters));
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3['return']) {
        _iterator3['return']();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return distances;
}

function genAllPairsDijkstraPathLength(G, _cutoff$weight) {
  return (0, _internalsDelegate2['default'])('allPairsDijkstraPathLength', [G, _cutoff$weight]);
}

/**
 * Compute shortest paths between all nodes in a weighted graph.
 *
 * ### Examples
 *
 * ```
 * var G = jsnx.pathGraph(5);
 * var path = jsnx.allPairsDijkstraPath(G);
 * path.get(0).get(4);
 * // [0, 1, 2, 3, 4]
 * ```
 *
 * ### Notes
 *
 * Edge weight attributes must be numerical.
 * Distances are calculated as sums of weighted edges traversed.
 *
 * @param {Graph} G
 * @param {{weight: ?string, cutoff: ?number}=} optParameters
 *   - weight: Edge data key corresponding to the edge weight
 *   - cutoff: Depth to stop the search. Only paths of length <= cutoff are
 *     returned.
 * @return {Map} A Map of Maps of shortest paths.
 */

function allPairsDijkstraPath(G) {
  var _ref11 = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  var cutoff = _ref11.cutoff;
  var _ref11$weight = _ref11.weight;
  var weight = _ref11$weight === undefined ? 'weight' : _ref11$weight;

  var paths = new _internals.Map();
  var parameters = { weight: weight, cutoff: cutoff };
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = _getIterator(G), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var source = _step4.value;

      parameters.source = source;
      paths.set(source, singleSourceDijkstraPath(G, parameters));
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4['return']) {
        _iterator4['return']();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  return paths;
}

// TODO bellmanFord
// TODO goldbergRadzik
// TODO negativeEdgeCycle
// TODO bidirectionalDijkstra

function genAllPairsDijkstraPath(G, _cutoff$weight2) {
  return (0, _internalsDelegate2['default'])('allPairsDijkstraPath', [G, _cutoff$weight2]);
}

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _get = __webpack_require__(57)['default'];

var _inherits = __webpack_require__(58)['default'];

var _createClass = __webpack_require__(56)['default'];

var _classCallCheck = __webpack_require__(24)['default'];

var _defineProperty = __webpack_require__(218)['default'];

var _slicedToArray = __webpack_require__(16)['default'];

var _regeneratorRuntime = __webpack_require__(19)['default'];

var _Object$keys = __webpack_require__(366)['default'];

var _Object$assign = __webpack_require__(89)['default'];

var _Array$from = __webpack_require__(13)['default'];

var _getIterator = __webpack_require__(8)['default'];

var _Object$getOwnPropertyNames = __webpack_require__(365)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
var marked0$0 = [yieldEdges, yieldDegree].map(_regeneratorRuntime.mark);

var _DiGraph2 = __webpack_require__(114);

var _DiGraph3 = _interopRequireDefault(_DiGraph2);

var _MultiGraph = __webpack_require__(356);

var _MultiGraph2 = _interopRequireDefault(_MultiGraph);

var _exceptionsJSNetworkXError = __webpack_require__(34);

var _exceptionsJSNetworkXError2 = _interopRequireDefault(_exceptionsJSNetworkXError);

var _internals = __webpack_require__(15);

/**
 * A directed graph class that can store multiedges.
 *
 * Multiedges are multiple edges between two nodes. Each edge can hold optional
 * data or attributes.
 *
 * A MultiDiGraph holds directed edges. Self loops are allowed. Edges are
 * respresented as links between nodes with optional key/value attributes.
 *
 * ### Example
 *
 * Create an empty graph structure (a "null graph") with no nodes and no edges:
 *
 * ```
 * var G = new jsnx.MultiDiGraph();
 * ```
 *
 * G can be grown in several ways.
 *
 * #### Nodes
 *
 * Add one node at a time:
 *
 * ```
 * G.addNode(1);
 * ```
 *
 * Add the nodes from any iterable:
 *
 * ```
 * G.addNodesFrom([2,3]);
 * var H = new jsnx.Graph();
 * H.addPath([0,1,2,3,4,5]);
 * G.addNodesFrom(H);
 * ```
 *
 * In addition to strings and integers, any object that implements a custom
 * `toString` method can represent a node.
 *
 * #### Edges
 *
 * `G` can also be grown by adding edges. Add one edge,
 *
 * ```
 * G.addEdge(1, 2);
 * ```
 *
 * a list of edges,
 *
 * ```
 * G.addEdgesFrom([[1,2], [1,3]]);
 * ```
 *
 * or a collection of edges
 *
 * ```
 * G.addEdgesFrom(H.edges());
 * ```
 *
 * If some edges connect nodes not yet in the graph, the nodes are added
 * automatically. If an edge already exists, an additional edge is created and
 * stored using a key to identify the edge. By default the key is the lowest
 * unused integer.
 *
 * ```
 * G.addEdgesFrom([[4,5,{route:282}], [4,5,{route:37}]]);
 * G.get(4);
 * // Map {5: {0: {}, 1: {route: 282}, 2: {route: 37}}}
 *
 * #### Attributes
 *
 * Each graph, node and edge can hold key/value attribute pairs in an associated
 * attribute object. By default these are empty, but can be added or changed
 * using `addEdge` or `addNode`.
 *
 * ```
 * G.addNode(1, {time: '5pm'});
 * G.addNodesFrom([3], {time: '2pm'});
 * G.nodes(true);
 * // [[1, {time: '5pm'}], [3, {time: '2pm'}]]
 * ```
 *
 * Add edge attributes using `addEdge` and `addEdgesFrom`:
 *
 * ```
 * G.addEdge(1, 2, {weight: 4.7});
 * G.addEdgesFrom([[3,4], [4,5]], {color: 'red'});
 * G.addEdgesFrom([[1,2,{color: 'blue'}], [2,3,{weight: 8}]]);
 * ```
 */

var MultiDiGraph = (function (_DiGraph) {
  _inherits(MultiDiGraph, _DiGraph);

  /**
   * @param {(Object|Array|Graph)} optData Data to initialize graph.
   *   If no data is passed, an empty graph is created. The data can be an edge
   *   list, or any JSNetworkX graph object.
   * @param {Object=} opt_attr (default= no attributes)
   *       Attributes to add to graph as key=value pairs.
   */

  function MultiDiGraph(optData, optAttr) {
    _classCallCheck(this, MultiDiGraph);

    _get(Object.getPrototypeOf(MultiDiGraph.prototype), 'constructor', this).call(this, optData, optAttr);
  }

  _createClass(MultiDiGraph, [{
    key: 'addEdge',

    /**
     * Add an edge between u and v.
     *
     * The nodes u and v will be automatically added if they are not already in
     * the graph.
     *
     * Edge attributes can be specified by providing an object with key/value
     * pairs.
     *
     * ### Note
     *
     * To replace/update edge data, use the optional key argument to identify a
     * unique edge. Otherwise a new edge will be created.
     *
     * ### Example
     *
     * The following add the edge e=(1,2) to graph G:
     *
     * ```
     * var G = new jsnx.MultiDiGraph();
     * G.addEdge(1, 2);
     * G.addEdgesFrom([[1,2]]);
     * ```
     *
     * Associate data to edges using keywords:
     *
     * ```
     * G.addEdge(1, 2, {weight: 3});
     * G.addEdge(1, 2, 0, {weight: 4}); // update data for key=0
     * G.addEdge(1, 3, {weight: 7, capacity: 15, length: 342.7});
     * ```
     * @param {Node} u
     * @param {Node} v
     * @param {(string|number)} optKey (default=lowest unused integer) Used to
     *   distinguish multiedges between a pair of nodes.
     * @param {Object} opAttrDict Object of edge attributes. Key/value pairs will
     *   update existing data associated with the edge.
     */
    value: function addEdge(u, v, optKey, optAttrDict) {
      if (optKey && typeof optKey === 'object') {
        optAttrDict = optKey;
        optKey = null;
      }

      if (optAttrDict && !(0, _internals.isPlainObject)(optAttrDict)) {
        throw new _exceptionsJSNetworkXError2['default']('The optAttrDict argument must be a plain object.');
      }

      // add nodes
      var keydict;
      if (!this.succ.has(u)) {
        this.succ.set(u, new _internals.Map());
        this.pred.set(u, new _internals.Map());
        this.node.set(u, {});
      }
      if (!this.succ.has(v)) {
        this.succ.set(v, new _internals.Map());
        this.pred.set(v, new _internals.Map());
        this.node.set(v, {});
      }
      if (this.succ.get(u).has(v)) {
        keydict = this.get(u).get(v);
        if (optKey == null) {
          // find unique integer key
          optKey = _Object$keys(keydict).length;
          while (keydict[optKey]) {
            optKey += 1;
          }
        }
        keydict[optKey] = _Object$assign((0, _internals.getDefault)(keydict[optKey], {}), optAttrDict);
      } else {
        // selfloops work this way without special treatment
        if (optKey == null) {
          optKey = 0;
        }
        keydict = _defineProperty({}, optKey, _Object$assign({}, optAttrDict));
        this.succ.get(u).set(v, keydict);
        this.pred.get(v).set(u, keydict);
      }
    }
  }, {
    key: 'removeEdge',

    /**
     * Remove an edge between u and v.
     *
     * ### Example
     *
     * ```
     * var G = new jsnx.MultiDiGraph();
     * G.addPath([0,1,2,3]);
     * G.removeEdge(0, 1);
     * ```
     *
     * For multiple edges:
     *
     * ```
     * var G = new jsnx.MultiDiGraph();
     * G.addEdgesFrom([[1,2], [1,2], [1,2]]);
     * G.removeEdge(1, 2); // remove a single (arbitrary) edge
     * ```
     *
     * For edges with keys:
     *
     * ```
     * var G = new jsnx.MultiDiGraph();
     * G.addEdge(1, 2, 'first');
     * G.addEdge(1, 2, 'second');
     * G.removeEdge(1, 2, 'second');
     * ```
     * @param {Node} u
     * @param {Node} v
     * @param {(string|number)} optKey Used to distinguish multiple edges between
     *   a pair of nodes. If undefined, remove a single (arbitrary) edge between
     *   u and v.
     */
    value: function removeEdge(u, v, optKey) {
      var keydict;
      var neightborsOfU = this.adj.get(u);
      if (neightborsOfU) {
        keydict = neightborsOfU.get(v);
      }
      if (keydict == null) {
        throw new _exceptionsJSNetworkXError2['default']((0, _internals.sprintf)('The edge %j-%j is not in the graph', u, v));
      }

      // remove the edge with specified data
      if (optKey == null) {
        for (var key in keydict) {
          delete keydict[key];
          break;
        }
      } else {
        if (!keydict[optKey]) {
          throw new _exceptionsJSNetworkXError2['default']((0, _internals.sprintf)('The edge %j-%j with key %j is not in the graph', u, v, optKey));
        }
        delete keydict[optKey];
      }
      if (_Object$keys(keydict).length === 0) {
        // remove the key entries if last edge
        this.succ.get(u)['delete'](v);
        this.pred.get(v)['delete'](u);
      }
    }
  }, {
    key: 'edgesIter',

    /**
     * Return an iterator over the edges.
     *
     * Edges are returned as tuples with optional data and keys in the order
     * `(node, neighbor, key, data)`.
     *
     * ### Note
     *
     * Nodes in `optNbunch` that are not in the graph will be (quietly) ignored.
     * For directed graphs this returns the out-edges.
     *
     * ### Example
     *
     * ```
     * var G = new jsnx.MultiDiGraph();
     * G.addPath([0,1,2,3]);
     * Array.from(G.edgesIter());
     * // [[0,1], [1,2], [2,3]]
     * Array.from(G.edgesIter(true));
     * // [[0,1,{}], [1,2,{}], [2,3,{}]]
     * Array.from(G.edgesIter([0,2]));
     * // [[0,1], [2,3]]
     * ```
     *
     * @alias outEdgesIter
     *
     * @param {Iterable} optNbunch (default=all nodes) A container of nodes.
     *   The container will be iterated over only once.
     * @param {boolean} optData (default=false) If true, return edge attribute
     *   dictionaries with each edge.
     * @param {boolean} optKeys (default=flase) If true, return edge keys with
     *   each edge.
     * @return {Iterator} An iterator of `(u,v)`, `(u,v,d)` or `(u,v,key,d)` edges
     */
    value: _regeneratorRuntime.mark(function edgesIter(optNbunch) {
      var optData = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
      var optKeys = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
      var nodesNbrs;
      return _regeneratorRuntime.wrap(function edgesIter$(context$2$0) {
        // istanbul ignore next

        var _this = this;

        while (1) switch (context$2$0.prev = context$2$0.next) {
          case 0:
            if (typeof optNbunch === 'boolean') {
              optKeys = optData;
              optData = optNbunch;
              optNbunch = null;
            }

            nodesNbrs = optNbunch == null ? this.adj : (0, _internals.mapIterator)(this.nbunchIter(optNbunch), function (n) {
              return (0, _internals.tuple2)(n, _this.adj.get(n));
            });
            return context$2$0.delegateYield(yieldEdges(nodesNbrs, optData, optKeys, 'out'), 't0', 3);

          case 3:
          case 'end':
            return context$2$0.stop();
        }
      }, edgesIter, this);
    })
  }, {
    key: 'outEdgesIter',

    /**
     * @alias edgesIter
     */
    value: function outEdgesIter(optNbunch, optData, optKeys) {
      return this.edgesIter(optNbunch, optData, optKeys);
    }
  }, {
    key: 'outEdges',

    /**
     * Return a list of the outgoing edges.
     *
     * Edges are returned as tuples with optional data and keys in the order
     * `(node, neighbor, key, data)`.
     *
     * ### Note
     *
     * Nodes in `optNbunch` that are not in the graph will be (quietly) ignored.
     * For directed graphs `edges()` is the same as `outEdges()`.
     *
     * @see inEdges
     *
     * @param {Iterable} optNbunch (default=all nodes) A container of nodes.
     *   The container will be iterated over only once.
     * @param {boolean} optData (default=false) If true, return edge attribute
     *   dictionaries with each edge.
     * @param {boolean} optKeys (default=flase) If true, return edge keys with
     *   each edge.
     * @return {Array} A list of `(u,v)`, `(u,v,d)` or `(u,v,key,d)` tuples of
     *   edges
     */
    value: function outEdges(optNbunch, optData, optKeys) {
      return _Array$from(this.outEdgesIter(optNbunch, optData, optKeys));
    }
  }, {
    key: 'inEdgesIter',

    /**
     * Return an iterator over the incoming edges.
     *
     * Edges are returned as tuples with optional data and keys in the order
     * `(node, neighbor, key, data)`.
     *
     * @see edgesIter
     *
     * @param {Iterable=} optNbunch (default=all nodes) A container of nodes.
     *   The container will be iterated over only once.
     * @param {boolean=} optData (default=false) If true, return edge attribute
     *   dictionaries with each edge.
     * @param {boolean=} optKeys (default=flase) If true, return edge keys with
     *   each edge.
     * @return {Iterator} An iterator of `(u,v)`, `(u,v,d)` or `(u,v,key,d)` edges
     */
    value: _regeneratorRuntime.mark(function inEdgesIter(optNbunch) {
      var optData = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
      var optKeys = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
      var nodesNbrs;
      return _regeneratorRuntime.wrap(function inEdgesIter$(context$2$0) {
        // istanbul ignore next

        var _this2 = this;

        while (1) switch (context$2$0.prev = context$2$0.next) {
          case 0:
            if (typeof optNbunch === 'boolean') {
              optKeys = optData;
              optData = optNbunch;
              optNbunch = null;
            }

            nodesNbrs = optNbunch == null ? this.pred : (0, _internals.mapIterator)(this.nbunchIter(optNbunch), function (n) {
              return (0, _internals.tuple2)(n, _this2.pred.get(n));
            });
            return context$2$0.delegateYield(yieldEdges(nodesNbrs, optData, optKeys, 'in'), 't0', 3);

          case 3:
          case 'end':
            return context$2$0.stop();
        }
      }, inEdgesIter, this);
    })
  }, {
    key: 'inEdges',

    /**
     * Return a list of the incoming edges.
     *
     * @see outEdges
     *
     * @param {Iterable=} optNbunch (default=all nodes) A container of nodes.
     *   The container will be iterated over only once.
     * @param {boolean=} optData (default=false) If true, return edge attribute
     *   dictionaries with each edge.
     * @param {boolean=} optKeys (default=flase) If true, return edge keys with
     *   each edge.
     * @return {Array} A list of `(u,v)`, `(u,v,d)` or `(u,v,key,d)` tuples of
     *   edges
     */
    value: function inEdges(optNbunch, optData, optKeys) {
      return _Array$from(this.inEdgesIter(optNbunch, optData, optKeys));
    }
  }, {
    key: 'degreeIter',

    /**
     * Return an iterator for `(node, degree)`.
     *
     * The node degree is the number of edges adjacent to the node.
     *
     * ### Example
     *
     * ```
     * var G = new jsnx.MultiDiGraph();
     * G.addPath([0,1,2,3]);
     * Array.from(G.degreeIter([0,1]));
     * // [[0,1], [1,2]]
     * ```
     *
     * @param {Iterable=} optNbunch (default=all nodes) A container of nodes.
     *   The container will be iterated through once.
     * @param {string=} optString (default=null)
     *   The edge attribute that holds the numerical value used as a weight. If
     *   None, then each edge has weight 1.
     *   The degree is the sum of the edge weights.
     * @return {Iterator} The iterator returns two-tuples of `(node, degree)`.
     */
    value: _regeneratorRuntime.mark(function degreeIter(optNbunch, optWeight) {
      var tuple2Succ, tuple2Pred, nodesNbrs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step$value, _step$value$0, n, succ, _step$value$1, _, pred, keydict, inDegree, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, outDegree, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, _step4$value, _step4$value$0, _step4$value$1;

      return _regeneratorRuntime.wrap(function degreeIter$(context$2$0) {
        // istanbul ignore next

        var _this3 = this;

        while (1) switch (context$2$0.prev = context$2$0.next) {
          case 0:
            tuple2Succ = (0, _internals.createTupleFactory)(2);
            tuple2Pred = (0, _internals.createTupleFactory)(2);
            nodesNbrs = optNbunch == null ? (0, _internals.zipIterator)(this.succ.entries(), this.pred.entries()) : (0, _internals.zipIterator)((0, _internals.mapIterator)(this.nbunchIter(optNbunch), function (n) {
              return tuple2Succ(n, _this3.succ.get(n));
            }), (0, _internals.mapIterator)(this.nbunchIter(optNbunch), function (n) {
              return tuple2Pred(n, _this3.pred.get(n));
            }));

            if (!(optWeight == null)) {
              context$2$0.next = 78;
              break;
            }

            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            context$2$0.prev = 7;
            _iterator = _getIterator(nodesNbrs);

          case 9:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              context$2$0.next = 62;
              break;
            }

            _step$value = _slicedToArray(_step.value, 2);
            _step$value$0 = _slicedToArray(_step$value[0], 2);
            n = _step$value$0[0];
            succ = _step$value$0[1];
            _step$value$1 = _slicedToArray(_step$value[1], 2);
            _ = _step$value$1[0];
            pred = _step$value$1[1];
            inDegree = 0;
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _iteratorError2 = undefined;
            context$2$0.prev = 21;

            for (_iterator2 = _getIterator(pred.values()); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              keydict = _step2.value;

              inDegree += _Object$keys(keydict).length;
            }
            context$2$0.next = 29;
            break;

          case 25:
            context$2$0.prev = 25;
            context$2$0.t0 = context$2$0['catch'](21);
            _didIteratorError2 = true;
            _iteratorError2 = context$2$0.t0;

          case 29:
            context$2$0.prev = 29;
            context$2$0.prev = 30;

            if (!_iteratorNormalCompletion2 && _iterator2['return']) {
              _iterator2['return']();
            }

          case 32:
            context$2$0.prev = 32;

            if (!_didIteratorError2) {
              context$2$0.next = 35;
              break;
            }

            throw _iteratorError2;

          case 35:
            return context$2$0.finish(32);

          case 36:
            return context$2$0.finish(29);

          case 37:
            outDegree = 0;
            _iteratorNormalCompletion3 = true;
            _didIteratorError3 = false;
            _iteratorError3 = undefined;
            context$2$0.prev = 41;

            for (_iterator3 = _getIterator(succ.values()); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              keydict = _step3.value;

              inDegree += _Object$keys(keydict).length;
            }
            context$2$0.next = 49;
            break;

          case 45:
            context$2$0.prev = 45;
            context$2$0.t1 = context$2$0['catch'](41);
            _didIteratorError3 = true;
            _iteratorError3 = context$2$0.t1;

          case 49:
            context$2$0.prev = 49;
            context$2$0.prev = 50;

            if (!_iteratorNormalCompletion3 && _iterator3['return']) {
              _iterator3['return']();
            }

          case 52:
            context$2$0.prev = 52;

            if (!_didIteratorError3) {
              context$2$0.next = 55;
              break;
            }

            throw _iteratorError3;

          case 55:
            return context$2$0.finish(52);

          case 56:
            return context$2$0.finish(49);

          case 57:
            context$2$0.next = 59;
            return [n, inDegree + outDegree];

          case 59:
            _iteratorNormalCompletion = true;
            context$2$0.next = 9;
            break;

          case 62:
            context$2$0.next = 68;
            break;

          case 64:
            context$2$0.prev = 64;
            context$2$0.t2 = context$2$0['catch'](7);
            _didIteratorError = true;
            _iteratorError = context$2$0.t2;

          case 68:
            context$2$0.prev = 68;
            context$2$0.prev = 69;

            if (!_iteratorNormalCompletion && _iterator['return']) {
              _iterator['return']();
            }

          case 71:
            context$2$0.prev = 71;

            if (!_didIteratorError) {
              context$2$0.next = 74;
              break;
            }

            throw _iteratorError;

          case 74:
            return context$2$0.finish(71);

          case 75:
            return context$2$0.finish(68);

          case 76:
            context$2$0.next = 110;
            break;

          case 78:
            _iteratorNormalCompletion4 = true;
            _didIteratorError4 = false;
            _iteratorError4 = undefined;
            context$2$0.prev = 81;
            _iterator4 = _getIterator(nodesNbrs);

          case 83:
            if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
              context$2$0.next = 96;
              break;
            }

            _step4$value = _slicedToArray(_step4.value, 2);
            _step4$value$0 = _slicedToArray(_step4$value[0], 2);
            n = _step4$value$0[0];
            succ = _step4$value$0[1];
            _step4$value$1 = _slicedToArray(_step4$value[1], 2);
            _ = _step4$value$1[0];
            pred = _step4$value$1[1];
            context$2$0.next = 93;
            return [n, sumEdgeAttribute(pred, optWeight, 1) + sumEdgeAttribute(succ, optWeight, 1)];

          case 93:
            _iteratorNormalCompletion4 = true;
            context$2$0.next = 83;
            break;

          case 96:
            context$2$0.next = 102;
            break;

          case 98:
            context$2$0.prev = 98;
            context$2$0.t3 = context$2$0['catch'](81);
            _didIteratorError4 = true;
            _iteratorError4 = context$2$0.t3;

          case 102:
            context$2$0.prev = 102;
            context$2$0.prev = 103;

            if (!_iteratorNormalCompletion4 && _iterator4['return']) {
              _iterator4['return']();
            }

          case 105:
            context$2$0.prev = 105;

            if (!_didIteratorError4) {
              context$2$0.next = 108;
              break;
            }

            throw _iteratorError4;

          case 108:
            return context$2$0.finish(105);

          case 109:
            return context$2$0.finish(102);

          case 110:
          case 'end':
            return context$2$0.stop();
        }
      }, degreeIter, this, [[7, 64, 68, 76], [21, 25, 29, 37], [30,, 32, 36], [41, 45, 49, 57], [50,, 52, 56], [69,, 71, 75], [81, 98, 102, 110], [103,, 105, 109]]);
    })
  }, {
    key: 'inDegreeIter',

    /**
     * Return an iterator for `(node, in-degree)`.
     *
     * The node in-degree is the number of edges pointing to the node.
     *
     * ### Example
     *
     * ```
     * var G = new jsnx.MultiDiGraph();
     * G.addPath([0,1,2,3]);
     * Array.from(G.degreeIter([0,1]));
     * // [[0,0], [1,1]]
     * ```
     *
     * @param {Iterable=} optNbunch (default=all nodes) A container of nodes.
     *   The container will be iterated through once.
     * @param {string=} optString (default=null)
     *   The edge attribute that holds the numerical value used as a weight. If
     *   None, then each edge has weight 1.
     *   The degree is the sum of the edge weights.
     * @return {Iterator} The iterator returns two-tuples of `(node, degree)`.
     */
    value: _regeneratorRuntime.mark(function inDegreeIter(optNbunch, optWeight) {
      return _regeneratorRuntime.wrap(function inDegreeIter$(context$2$0) {
        while (1) switch (context$2$0.prev = context$2$0.next) {
          case 0:
            return context$2$0.delegateYield(yieldDegree(this, this.pred, optNbunch, optWeight), 't0', 1);

          case 1:
          case 'end':
            return context$2$0.stop();
        }
      }, inDegreeIter, this);
    })
  }, {
    key: 'outDegreeIter',

    /**
     * Return an iterator for `(node, out-degree)`.
     *
     * The node out-degree is the number of edges pointing out of the node.
     *
     * ### Example
     *
     * ```
     * var G = new jsnx.MultiDiGraph();
     * G.addPath([0,1,2,3]);
     * Array.from(G.degreeIter([0,1]));
     * // [[0,1], [1,1]]
     * ```
     *
     * @param {Iterable=} optNbunch (default=all nodes) A container of nodes.
     *   The container will be iterated through once.
     * @param {string=} optString (default=null)
     *   The edge attribute that holds the numerical value used as a weight. If
     *   None, then each edge has weight 1.
     *   The degree is the sum of the edge weights.
     * @return {Iterator} The iterator returns two-tuples of `(node, degree)`.
     */
    value: _regeneratorRuntime.mark(function outDegreeIter(optNbunch, optWeight) {
      return _regeneratorRuntime.wrap(function outDegreeIter$(context$2$0) {
        while (1) switch (context$2$0.prev = context$2$0.next) {
          case 0:
            return context$2$0.delegateYield(yieldDegree(this, this.succ, optNbunch, optWeight), 't0', 1);

          case 1:
          case 'end':
            return context$2$0.stop();
        }
      }, outDegreeIter, this);
    })
  }, {
    key: 'isMultigraph',

    /**
     * Return True if graph is a multigraph, False otherwise.
     *
     * @return {boolean} True if graph is a multigraph, False otherwise.
     */
    value: function isMultigraph() {
      return true;
    }
  }, {
    key: 'isDirected',

    /**
     * Return True if graph is directed, False otherwise.
     *
     * @return {boolean}  True if graph is directed, False otherwise.
     */
    value: function isDirected() {
      return true;
    }
  }, {
    key: 'toDirected',

    /**
     * Return a directed copy of the graph.
     *
     * ### Notes
     *
     * This returns a deep copy of the edge, node, and
     * graph attributes which attempts to completely copy
     * all of the data and references.
     *
     * This is in contrast to the similar `var G = new MultiDiGraph(D);`, which
     * returns a shallow copy of the data.
     *
     * @return {MultiDiGraph} A deep copy of the graph.
     */
    value: function toDirected() {
      return (0, _internals.deepcopy)(this);
    }
  }, {
    key: 'toUndirected',

    /**
     * Return an undirected representation of the digraph.
     *
     * ### Notes
     *
     * The result is an undirected graph with the same name, nodes and
     * with edge `(u,v,data)` if either `(u,v,data)` or `(v,u,data)`
     * is in the digraph.  If both edges exist in digraph and
     * their edge data is different, only one edge is created
     * with an arbitrary choice of which edge data to use.
     * You must check and correct for this manually if desired.
     *
     * This returns a deep copy of the edge, node, and
     * graph attributes which attempts to completely copy
     * all of the data and references.
     *
     * This is in contrast to the similar `var G = new MultiGraph(D);`, which
     * returns a shallow copy of the data.
     *
     * @param {boolean=} optReciprocal If true, only keep edges that appear in
     *   both directions in the original digraph.
     * @return {MultiGraph}
     */
    value: function toUndirected(optReciprocal) {
      var H = new _MultiGraph2['default']();
      H.name = this.name;
      H.addNodesFrom(this);
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = _getIterator(this.adjacencyIter()), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _step5$value = _slicedToArray(_step5.value, 2);

          var u = _step5$value[0];
          var nbrs = _step5$value[1];
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = _getIterator(nbrs), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var _step6$value = _slicedToArray(_step6.value, 2);

              var v = _step6$value[0];
              var keydict = _step6$value[1];

              for (var key in keydict) {
                if (!optReciprocal || this.hasEdge(v, u, key)) {
                  H.addEdge(u, v, key, (0, _internals.deepcopy)(keydict[key]));
                }
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6['return']) {
                _iterator6['return']();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5['return']) {
            _iterator5['return']();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      H.graph = (0, _internals.deepcopy)(this.graph);
      H.node = (0, _internals.deepcopy)(this.node);
      return H;
    }
  }, {
    key: 'subgraph',

    /**
     * Return the subgraph induced on nodes in `nbunch`.
     *
     * The induced subgraph of the graph contains the nodes in `optNbunch` and the
     * edges between those nodes.
     *
     * ### Notes
     *
     * The graph, edge or node attributes just point to the original graph.
     * So changes to the node or edge structure will not be reflected in
     * the original graph while changes to the attributes will.
     *
     * To create a subgraph with its own copy of the edge/node attributes use:
     * `jsnx.MultiDiGraph(G.subgraph(nbunch))`.
     *
     * ### Example
     *
     * ```
     * var G = new jsnx.MultiDiGraph();
     * G.addPath([0,1,2,3]);
     * var H = G.subgraph([0,1,2]);
     * H.edges();
     * // [[0,1], [1,2]]
     * ```
     *
     * @param {Iterable} nBunch A container of nodes which will be iterated
     *   through once.
     * @return {MultiDiGraph}
     */
    value: function subgraph(nBunch) {
      var bunch = this.nbunchIter(nBunch);
      // create new graph and copy subgraph into it
      var H = new this.constructor();
      // copy node and attribute dictionaries
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = _getIterator(bunch), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var n = _step7.value;

          H.node.set(n, this.node.get(n));
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7['return']) {
            _iterator7['return']();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      var HSucc = H.succ;
      var HPred = H.pred;
      var thisSucc = this.succ;

      // add nodes
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = _getIterator(H), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var n = _step8.value;

          HSucc.set(n, new _internals.Map());
          HPred.set(n, new _internals.Map());
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8['return']) {
            _iterator8['return']();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      // add edges
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = _getIterator(HSucc), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var _step9$value = _slicedToArray(_step9.value, 2);

          var u = _step9$value[0];
          var HNbrs = _step9$value[1];
          var _iteratorNormalCompletion10 = true;
          var _didIteratorError10 = false;
          var _iteratorError10 = undefined;

          try {
            for (var _iterator10 = _getIterator(thisSucc.get(u)), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
              var _step10$value = _slicedToArray(_step10.value, 2);

              var v = _step10$value[0];
              var keydict = _step10$value[1];

              if (HSucc.has(v)) {
                // add both representations of edge: u-v and v-u
                // they share the same keydict
                var keydictCopy = (0, _internals.clone)(keydict);
                HNbrs.set(v, keydictCopy);
                HPred.get(v).set(u, keydictCopy);
              }
            }
          } catch (err) {
            _didIteratorError10 = true;
            _iteratorError10 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion10 && _iterator10['return']) {
                _iterator10['return']();
              }
            } finally {
              if (_didIteratorError10) {
                throw _iteratorError10;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9['return']) {
            _iterator9['return']();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      H.graph = this.graph;
      return H;
    }
  }, {
    key: 'reverse',

    /**
     * Return the reverse of the graph.
     *
     * The reverse is a graph with the same nodes and edges but with the
     * directions of the edges reversed.
     *
     * @param {boolean=} optCopy If true, return a new MultiDiGraph holding the
     *   reversed edges. If false, the reverse graph is created using the original
     *   graph (this changes the original graph).
     * @return {?MultiDiGraph}
     */
    value: function reverse() {
      var optCopy = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

      var H;
      if (optCopy) {
        H = new this.constructor(null, { name: (0, _internals.sprintf)('Reverse of (%s)', this.name) });

        H.addNodesFrom(this);
        H.addEdgesFrom((0, _internals.mapIterator)(this.edges(true, true), function (_ref) {
          var _ref2 = _slicedToArray(_ref, 4);

          var u = _ref2[0];
          var v = _ref2[1];
          var key = _ref2[2];
          var data = _ref2[3];
          return (0, _internals.tuple4)(v, u, key, (0, _internals.deepcopy)(data));
        }));
        H.graph = (0, _internals.deepcopy)(this.graph);
        H.node = (0, _internals.deepcopy)(this.node);
      } else {
        var _ref3 = [this.succ, this.pred];
        this.pred = _ref3[0];
        this.succ = _ref3[1];

        this.adj = this.succ;
        H = this;
      }
      return H;
    }
  }], [{
    key: '__name__',

    /**
     * Holds the graph type (class) name for information.
     *
     * @type {string}
     */
    get: function get() {
      return 'MultiDiGraph';
    }
  }]);

  return MultiDiGraph;
})(_DiGraph3['default']);

exports['default'] = MultiDiGraph;

// Simulate multiple inheritance by merging prototypes
_Object$getOwnPropertyNames(_MultiGraph2['default'].prototype).forEach(function (prop) {
  if (!MultiDiGraph.prototype.hasOwnProperty(prop)) {
    MultiDiGraph.prototype[prop] = _MultiGraph2['default'].prototype[prop];
  }
});

function yieldEdges(nodesNbrs, data, keys, type) {
  var _iteratorNormalCompletion11, _didIteratorError11, _iteratorError11, _iterator11, _step11, _step11$value, n, nbrs, _iteratorNormalCompletion12, _didIteratorError12, _iteratorError12, _iterator12, _step12, _step12$value, nbr, keydict, key, result;

  return _regeneratorRuntime.wrap(function yieldEdges$(context$1$0) {
    while (1) switch (context$1$0.prev = context$1$0.next) {
      case 0:
        _iteratorNormalCompletion11 = true;
        _didIteratorError11 = false;
        _iteratorError11 = undefined;
        context$1$0.prev = 3;
        _iterator11 = _getIterator(nodesNbrs);

      case 5:
        if (_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done) {
          context$1$0.next = 48;
          break;
        }

        _step11$value = _slicedToArray(_step11.value, 2);
        n = _step11$value[0];
        nbrs = _step11$value[1];
        _iteratorNormalCompletion12 = true;
        _didIteratorError12 = false;
        _iteratorError12 = undefined;
        context$1$0.prev = 12;
        _iterator12 = _getIterator(nbrs);

      case 14:
        if (_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done) {
          context$1$0.next = 31;
          break;
        }

        _step12$value = _slicedToArray(_step12.value, 2);
        nbr = _step12$value[0];
        keydict = _step12$value[1];
        context$1$0.t0 = _regeneratorRuntime.keys(keydict);

      case 19:
        if ((context$1$0.t1 = context$1$0.t0()).done) {
          context$1$0.next = 28;
          break;
        }

        key = context$1$0.t1.value;
        result = type === 'out' ? [n, nbr] : [nbr, n];

        if (keys) {
          result[2] = isNaN(key) ? key : +key;
        }
        if (data) {
          result.push(keydict[key]);
        }
        context$1$0.next = 26;
        return result;

      case 26:
        context$1$0.next = 19;
        break;

      case 28:
        _iteratorNormalCompletion12 = true;
        context$1$0.next = 14;
        break;

      case 31:
        context$1$0.next = 37;
        break;

      case 33:
        context$1$0.prev = 33;
        context$1$0.t2 = context$1$0['catch'](12);
        _didIteratorError12 = true;
        _iteratorError12 = context$1$0.t2;

      case 37:
        context$1$0.prev = 37;
        context$1$0.prev = 38;

        if (!_iteratorNormalCompletion12 && _iterator12['return']) {
          _iterator12['return']();
        }

      case 40:
        context$1$0.prev = 40;

        if (!_didIteratorError12) {
          context$1$0.next = 43;
          break;
        }

        throw _iteratorError12;

      case 43:
        return context$1$0.finish(40);

      case 44:
        return context$1$0.finish(37);

      case 45:
        _iteratorNormalCompletion11 = true;
        context$1$0.next = 5;
        break;

      case 48:
        context$1$0.next = 54;
        break;

      case 50:
        context$1$0.prev = 50;
        context$1$0.t3 = context$1$0['catch'](3);
        _didIteratorError11 = true;
        _iteratorError11 = context$1$0.t3;

      case 54:
        context$1$0.prev = 54;
        context$1$0.prev = 55;

        if (!_iteratorNormalCompletion11 && _iterator11['return']) {
          _iterator11['return']();
        }

      case 57:
        context$1$0.prev = 57;

        if (!_didIteratorError11) {
          context$1$0.next = 60;
          break;
        }

        throw _iteratorError11;

      case 60:
        return context$1$0.finish(57);

      case 61:
        return context$1$0.finish(54);

      case 62:
      case 'end':
        return context$1$0.stop();
    }
  }, marked0$0[0], this, [[3, 50, 54, 62], [12, 33, 37, 45], [38,, 40, 44], [55,, 57, 61]]);
}

function sumEdgeAttribute(nbrs, attribute, def) {
  var sum = 0;
  var _iteratorNormalCompletion13 = true;
  var _didIteratorError13 = false;
  var _iteratorError13 = undefined;

  try {
    for (var _iterator13 = _getIterator(nbrs.values()), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
      var keydict = _step13.value;

      for (var key in keydict) {
        sum += (0, _internals.getDefault)(keydict[key][attribute], def);
      }
    }
  } catch (err) {
    _didIteratorError13 = true;
    _iteratorError13 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion13 && _iterator13['return']) {
        _iterator13['return']();
      }
    } finally {
      if (_didIteratorError13) {
        throw _iteratorError13;
      }
    }
  }

  return sum;
}

function yieldDegree(graph, edges, nBunch, weight) {
  var nodesNbrs, _iteratorNormalCompletion14, _didIteratorError14, _iteratorError14, _iterator14, _step14, _step14$value, n, nbrs, sum, _iteratorNormalCompletion15, _didIteratorError15, _iteratorError15, _iterator15, _step15, keydict, _iteratorNormalCompletion16, _didIteratorError16, _iteratorError16, _iterator16, _step16, _step16$value;

  return _regeneratorRuntime.wrap(function yieldDegree$(context$1$0) {
    while (1) switch (context$1$0.prev = context$1$0.next) {
      case 0:
        nodesNbrs = nBunch == null ? edges : (0, _internals.mapIterator)(graph.nbunchIter(nBunch), function (n) {
          return (0, _internals.tuple2)(n, edges.get(n));
        });

        if (!(weight == null)) {
          context$1$0.next = 52;
          break;
        }

        _iteratorNormalCompletion14 = true;
        _didIteratorError14 = false;
        _iteratorError14 = undefined;
        context$1$0.prev = 5;
        _iterator14 = _getIterator(nodesNbrs);

      case 7:
        if (_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done) {
          context$1$0.next = 36;
          break;
        }

        _step14$value = _slicedToArray(_step14.value, 2);
        n = _step14$value[0];
        nbrs = _step14$value[1];
        sum = 0;
        _iteratorNormalCompletion15 = true;
        _didIteratorError15 = false;
        _iteratorError15 = undefined;
        context$1$0.prev = 15;

        for (_iterator15 = _getIterator(nbrs.values()); !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
          keydict = _step15.value;

          sum += _Object$keys(keydict).length;
        }
        context$1$0.next = 23;
        break;

      case 19:
        context$1$0.prev = 19;
        context$1$0.t0 = context$1$0['catch'](15);
        _didIteratorError15 = true;
        _iteratorError15 = context$1$0.t0;

      case 23:
        context$1$0.prev = 23;
        context$1$0.prev = 24;

        if (!_iteratorNormalCompletion15 && _iterator15['return']) {
          _iterator15['return']();
        }

      case 26:
        context$1$0.prev = 26;

        if (!_didIteratorError15) {
          context$1$0.next = 29;
          break;
        }

        throw _iteratorError15;

      case 29:
        return context$1$0.finish(26);

      case 30:
        return context$1$0.finish(23);

      case 31:
        context$1$0.next = 33;
        return [n, sum];

      case 33:
        _iteratorNormalCompletion14 = true;
        context$1$0.next = 7;
        break;

      case 36:
        context$1$0.next = 42;
        break;

      case 38:
        context$1$0.prev = 38;
        context$1$0.t1 = context$1$0['catch'](5);
        _didIteratorError14 = true;
        _iteratorError14 = context$1$0.t1;

      case 42:
        context$1$0.prev = 42;
        context$1$0.prev = 43;

        if (!_iteratorNormalCompletion14 && _iterator14['return']) {
          _iterator14['return']();
        }

      case 45:
        context$1$0.prev = 45;

        if (!_didIteratorError14) {
          context$1$0.next = 48;
          break;
        }

        throw _iteratorError14;

      case 48:
        return context$1$0.finish(45);

      case 49:
        return context$1$0.finish(42);

      case 50:
        context$1$0.next = 80;
        break;

      case 52:
        _iteratorNormalCompletion16 = true;
        _didIteratorError16 = false;
        _iteratorError16 = undefined;
        context$1$0.prev = 55;
        _iterator16 = _getIterator(nodesNbrs);

      case 57:
        if (_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done) {
          context$1$0.next = 66;
          break;
        }

        _step16$value = _slicedToArray(_step16.value, 2);
        n = _step16$value[0];
        nbrs = _step16$value[1];
        context$1$0.next = 63;
        return [n, sumEdgeAttribute(nbrs, weight, 1)];

      case 63:
        _iteratorNormalCompletion16 = true;
        context$1$0.next = 57;
        break;

      case 66:
        context$1$0.next = 72;
        break;

      case 68:
        context$1$0.prev = 68;
        context$1$0.t2 = context$1$0['catch'](55);
        _didIteratorError16 = true;
        _iteratorError16 = context$1$0.t2;

      case 72:
        context$1$0.prev = 72;
        context$1$0.prev = 73;

        if (!_iteratorNormalCompletion16 && _iterator16['return']) {
          _iterator16['return']();
        }

      case 75:
        context$1$0.prev = 75;

        if (!_didIteratorError16) {
          context$1$0.next = 78;
          break;
        }

        throw _iteratorError16;

      case 78:
        return context$1$0.finish(75);

      case 79:
        return context$1$0.finish(72);

      case 80:
      case 'end':
        return context$1$0.stop();
    }
  }, marked0$0[1], this, [[5, 38, 42, 50], [15, 19, 23, 31], [24,, 26, 30], [43,, 45, 49], [55, 68, 72, 80], [73,, 75, 79]]);
}
module.exports = exports['default'];

/* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */

/* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _get = __webpack_require__(57)['default'];

var _inherits = __webpack_require__(58)['default'];

var _createClass = __webpack_require__(56)['default'];

var _classCallCheck = __webpack_require__(24)['default'];

var _slicedToArray = __webpack_require__(16)['default'];

var _Object$keys = __webpack_require__(366)['default'];

var _Object$assign = __webpack_require__(89)['default'];

var _Object$create = __webpack_require__(115)['default'];

var _Array$from = __webpack_require__(13)['default'];

var _regeneratorRuntime = __webpack_require__(19)['default'];

var _getIterator = __webpack_require__(8)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _Graph2 = __webpack_require__(71);

var _Graph3 = _interopRequireDefault(_Graph2);

var _exceptionsJSNetworkXError = __webpack_require__(34);

var _exceptionsJSNetworkXError2 = _interopRequireDefault(_exceptionsJSNetworkXError);

var _internals = __webpack_require__(15);

/**
 * An undirected graph class that can store multiedges.
 *
 * Multiedges are multiple edges between two nodes.  Each edge
 * can hold optional data or attributes. A MultiGraph holds undirected edges.
 * Self loops are allowed.
 *
 * Edges are represented as links between nodes with optional
 * key/value attributes.
 *
 * ### Examples
 *
 * Create an empty graph structure (a "null graph") with no nodes and no edges.
 *
 * ```
 * var G = jsnx.MultiGraph();
 * ```
 *
 * G can be grown in several ways.
 *
 * #### Nodes
 *
 * Add one node at a time:
 *
 * ```
 * G.addNode(1);
 * ```
 *
 * Add the nodes from any iterable:
 *
 * ```
 * G.addNodesFrom([2, 3]);
 * var H = jsnx.Graph();
 * H.addPath([0,1,2,3,4,5,6,7,8,9]);
 * G.addNodesFrom(h);
 * ```
 *
 * In addition to strings and integers, any object that implements a custom
 * `toString` method can be used as node. For example, arrays:
 *
 * ```
 * G.addNode([1,2]);
 * ```
 *
 * #### Edges
 *
 * A graph can also be grown by adding edges.
 *
 * Add one edge,
 *
 * ```
 * G.addEdge(1, 2);
 * ```
 *
 * a list or collection of edges,
 *
 * ```
 * G.addEdgesFrom([[1,2], [1,3]]);
 * G.addEdgesFrom(H.edges());
 * ```
 *
 * If some edges connect nodes not yet in the graph, the nodes are added
 * automatically. If an edge already exists, an addition edge is created and
 * stored using a key to identify the edge. By default, the key is the lowest
 * unused integer.
 *
 * ```
 * G.addEdgesFrom([[4,5,{route: 282}], [4,5,{route: 37}]]);
 * G.get(4);
 * // Map { 3: {0: {}}, 5: {0: {}, 1: {route: 282}, 2: {route: 37}}}
 * ```
 *
 * #### Attributes
 *
 * Each graph, node and edge can hold key/value attribute pairs in an associated
 * attribute "dictionary" (object). By defauly these are empty, but can be added
 * or changed using `addEdge` or `addNode`.
 *
 * ```
 * var G = jsnx.MultiGraph(null, {day: Friday}):
 * G.graph
 * // {day: 'Friday'}
 *
 * G.addNode(1, {time: '5pm'});
 * G.addNodesFrom([3], {time: '2pm'});
 * G.nodes(true);
 * // [[1, {time: '5pm'}], [3, {time: '2pm'}]]
 * ```
 *
 * @see Graph
 * @see DiGraph
 * @see MultiDiGraph
 *
 */

var MultiGraph = (function (_Graph) {
  _inherits(MultiGraph, _Graph);

  /**
   * @param {?} optData Data to initialze graph.
   *      If no data is provided, an empty graph is created. The data can be
   *      an edge list or any graph object.
   * @param {Object=} optAttr Attributes to add to graph as key=value pairs.
   */

  function MultiGraph(optData, optAttr) {
    _classCallCheck(this, MultiGraph);

    _get(Object.getPrototypeOf(MultiGraph.prototype), 'constructor', this).call(this, optData, optAttr);
  }

  _createClass(MultiGraph, [{
    key: 'addEdge',

    /**
     * Add an edge between u and v.
     *
     * The nodes u and v will be automatically added if they are
     * not already in the graph.
     *
     * Edge attributes can be specified with keywords or by providing
     * a dictionary with key/value pairs.
     *
     * ### Notes:
     *
     * To replace/update edge data, use the optional key argument
     * to identify a unique edge.  Otherwise a new edge will be created.
     *
     * NetworkX algorithms designed for weighted graphs cannot use
     * multigraphs directly because it is not clear how to handle
     * multiedge weights.  Convert to Graph using edge attribute
     * 'weight' to enable weighted graph algorithms.
     *
     * ### Example
     *
     * The following all add the edge [1,2] to the graph G:
     *
     * ```
     * var G = jsnx.MultiGraph();
     * var e = [1,2];
     * G.addEdge(1, 2);
     * G.addEdge.apply(G, e);
     * G.addEdgesFrom([e]);
     * ```
     * Associate data to edges by passing a data object:
     *
     * ```
     * G.addEdge(1, 2, {weight: 3});
     * G.addEdge(1, 2, 0, {weight: 4}); // update data for key=0
     * G.addEdge(1, 3, {weight: 7, capacity: 15, length: 342.7});
     * ```
     * @see #addEdgesFrom
     *
     * @param {Node} u node
     * @param {Node} v node
     * @param {?(number|string)=} optKey identifier
     *      Used to distinguish multiedges between a pair of nodes. Default is
     *      the lowest unused integer.
     * @param {?Object=} optAttrDict  Dictionary of edge attributes.
     *      Key/value pairs will update existing data associated with the edge.
     */
    value: function addEdge(u, v, optKey, optAttrDict) {
      var type = typeof optKey;
      if (optKey != null && type !== 'number' && type !== 'string') {
        optAttrDict = optKey;
        optKey = null;
      }

      // set up attribute dict
      if (optAttrDict && !(0, _internals.isPlainObject)(optAttrDict)) {
        throw new _exceptionsJSNetworkXError2['default']('The optAttrDict argument must be an object.');
      }

      // add nodes
      if (!this.adj.has(u)) {
        this.adj.set(u, new _internals.Map());
        this.node.set(u, {});
      }
      if (!this.adj.has(v)) {
        this.adj.set(v, new _internals.Map());
        this.node.set(v, {});
      }

      var keydict;
      if (this.adj.get(u).has(v)) {
        keydict = this.adj.get(u).get(v);
        if (optKey == null) {
          // find a unique integer key
          // other methods might be better here?
          optKey = _Object$keys(keydict).length;
          while (keydict[optKey]) {
            // ok, because values are objects only
            optKey += 1;
          }
        }
        var datadict = keydict[optKey] || {};
        keydict[optKey] = _Object$assign(datadict, optAttrDict);
      } else {
        // selfloops work this way without special treatment
        if (optKey == null) {
          optKey = 0;
        }
        keydict = _Object$create(null);
        keydict[optKey] = _Object$assign({}, optAttrDict);
        this.adj.get(u).set(v, keydict);
        this.adj.get(v).set(u, keydict);
      }
    }
  }, {
    key: 'addEdgesFrom',

    /**
     * Add all the edges in `ebunch`.
     *
     * Adding the same edge twice has no effect but any edge data will be updated
     * when each duplicate edge is added.
     *
     * Edge attributes specified in edges as a tuple take precedence over the
     * attributes specified generally.
     *
     * ### Example
     *
     * ```
     * var G = new jsnx.MultiGraph();
     * G.addEdgesFrom([[0,1], [1,2]]);
     * ```
     *
     * Associate data to edges
     *
     * ```
     * G.addEdgesFrom([[1,2], [2,3]], {weight: 3});
     * G.addEdgesFrom([[1,2], [2,3]], {label: 'WN2898'});
     * ```
     *
     * @see #addEdge
     * @see #addWeightedEdgesFrom
     *
     *
     * @param {Iterable} ebunch container of edges
     *      Each edge given in the container will be added to the
     *      graph. The edges can be:
     *
     *          - 2-tuples (u,v) or
     *          - 3-tuples (u,v,d) for an edge attribute dict d or
     *          - 4-tuples (u,v,k,d) for an edge identified by key k
     *
     * @param {Object=} optAttrDict Dictionary of edge attributes.
     *       Key/value pairs will update existing data associated with each edge.
     */
    value: function addEdgesFrom(ebunch, optAttrDict) {
      // istanbul ignore next

      var _this = this;

      if (optAttrDict && !(0, _internals.isPlainObject)(optAttrDict)) {
        throw new _exceptionsJSNetworkXError2['default']('The optAttrDict argument must be an object.');
      }

      // process ebunch
      (0, _internals.forEach)(ebunch, function (edge) {
        var u;
        var v;
        var key;
        var data;

        switch (edge.length) {
          case 4:
            u = edge[0];
            v = edge[1];
            key = edge[2];
            data = edge[3];
            break;
          case 3:
            u = edge[0];
            v = edge[1];
            data = edge[2];
            break;
          case 2:
            u = edge[0];
            v = edge[1];
            break;
          default:
            if (!(0, _internals.isArrayLike)(edge)) {
              throw new TypeError('Elements in edgelists must be tuples.');
            }
            throw new _exceptionsJSNetworkXError2['default']((0, _internals.sprintf)('Edge tuple %j must be a 2-tuple, 3-tuple or 4-tuple.', edge));
        }

        var keydict = _this.adj.has(u) ? _this.adj.get(u).get(v) || _Object$create(null) : _Object$create(null);

        if (key == null) {
          // find a unique integer key
          // other methods might be better here?
          key = _Object$keys(keydict).length;
          while (keydict[key]) {
            key += 1;
          }
        }
        var datadict = keydict[key] || {};
        _Object$assign(datadict, optAttrDict, data);
        _this.addEdge(u, v, key, datadict);
      });
    }
  }, {
    key: 'removeEdge',

    /**
     * Remove an edge between u and v.
     *
     * ### Example
     *
     * ```
     * var G = new jsnx.MultiGraph();
     * G.addPath([0,1,2,3]);
     * G.removeEdge(0, 1);
     * ```
     *
     * For multiple edges
     *
     * ```
     * var G = new jsnx.MultiGraph();
     * G.addEdgesFrom([[1,2], [1,2], [1,2]]);
     * G.removeEdge(1, 2); // remove a single edge
     * ```
     *
     * For edges with keys
     *
     * ```
     * var G = new jsnx.MultiGraph();
     * G.addEdge(1, 2, 'first');
     * G.addEdge(1, 2, 'second');
     * G.removeEdge(1, 2, 'second');
     * ```
     *
     * @see #removeEdgesFrom
     *
     * @param {Node} u
     * @param {Node} v
     * @param {(number|string)=} optKey
     *      Used to distinguish multiple edges between a pair of nodes.
     *      If null or undefined remove a single (arbitrary) edge between u and v.
     */
    value: function removeEdge(u, v, optKey) {
      var keydict;
      var neightborsOfU = this.adj.get(u);
      if (neightborsOfU) {
        keydict = neightborsOfU.get(v);
      }
      if (keydict == null) {
        throw new _exceptionsJSNetworkXError2['default']((0, _internals.sprintf)('The edge %j-%j is not in the graph', u, v));
      }

      // remove the edge with specified data
      if (optKey == null) {
        for (var key in keydict) {
          delete keydict[key];
          break;
        }
      } else {
        if (!keydict[optKey]) {
          throw new _exceptionsJSNetworkXError2['default']((0, _internals.sprintf)('The edge %j-%j with key %j is not in the graph', u, v, optKey));
        }
        delete keydict[optKey];
      }
      if (_Object$keys(keydict).length === 0) {
        // remove the key entries if last edge
        neightborsOfU['delete'](v);
        if (!(0, _internals.nodesAreEqual)(u, v)) {
          this.adj.get(v)['delete'](u);
        }
      }
    }
  }, {
    key: 'removeEdgesFrom',

    /**
     * Remove all edges specified in `ebunch`.
     *
     * Will fail silently if an edge in `ebunch` is not in the graph.
     *
     * ### Example
     *
     * ```
     * var G = new jsnx.MultiGraph();
     * G.addPath([0,1,2,3]);
     * var ebunch = [[1,2], [2,3]];
     * G.removeEdgesFrom(ebunch);
     * ```
     *
     * Removing multiple copies of edges.
     *
     * ```
     * var G = new jsnx.MultiGraph();
     * G.addEdgesFrom([[1,2], [1,2], [1,2]]);
     * G.removeEdgesFrom([[1,2], [1,2]]);
     * G.edges();
     * // [[1,2]]
     * ```
     *
     * @see #removeEdge
     *
     * @param {?} ebunch list or container of edge tuples
     *      Each edge given in the list or container will be removed
     *      from the graph. The edges can be:
     *
     *        - 2-tuples (u,v) All edges between u and v are removed.
     *        - 3-tuples (u,v,key) The edge identified by key is removed.
     */
    value: function removeEdgesFrom(ebunch) {
      // istanbul ignore next

      var _this2 = this;

      (0, _internals.forEach)(ebunch, function (edge) {
        try {
          _this2.removeEdge(edge[0], edge[1], edge[2]);
        } catch (ex) {
          if (!(ex instanceof _exceptionsJSNetworkXError2['default'])) {
            throw ex;
          }
        }
      });
    }
  }, {
    key: 'hasEdge',

    /**
     * Return True if the graph has an edge between nodes u and v.
     *
     * ### Example
     *
     * ```
     * var G = new jsnx.MultiGraph();
     * G.addPath([0,1,2,3]);
     * G.hasEdge(0,1);
     * // true
     * G.addEdge(0, 1, 'a');
     * G.hasEdge(0, 1, 'a');
     * // true
     * ```
     *
     * The following syntax are equivalent:
     *
     * ```
     * G.hasEdge(0, 1);
     * // true
     * G.get(0).has(1);
     * // true
     * ```
     *
     * @param {Node} u node
     * @param {Node} v node
     * @param {(string|number)=} optKey If specified return true only
     *      if the edge with key is found.
     *
     * @return {boolean} true if edge is in the graph, false otherwise.
     */
    value: function hasEdge(u, v, optKey) {
      var neighborsOfU = this.adj.get(u);
      if (neighborsOfU) {
        return neighborsOfU.has(v) && (optKey == null || !!neighborsOfU.get(v)[optKey]);
      }
      return false;
    }
  }, {
    key: 'edges',

    /**
     * Return a list of edges.
     *
     * Edges are returned as tuples with optional data and keys in the order
     * (node, neighbor, key, data).
     *
     * Nodes in `nbunch` that are not in the graph will be (quietly) ignored.
     *
     * ### Example
     *
     * ```
     * var G = new jsnx.MultiGraph();
     * G.addPath([0,1,2,3]);
     * G.edges();
     * // [[0,1], [1,2], [2,3]]
     * G.edges(true);
     * // [[0,1,{}], [1,2,{}], [2,3,{}]]
     * G.edges(false, true);
     * // [[0,1,0], [1,2,0], [2,3,0]]
     * G.edges(true, true);
     * // [[0,1,0,{}], [1,2,0,{}], [2,3,0,{}]]
     * G.edges([0,3]);
     * // [[0,1], [3, 2]]
     * G.edges(0);
     * // [[0,1]]
     * ```
     *
     * @see #edgesIter
     *
     * @param {?NodeContainer=} optNbunch A container of nodes.
     *      The container will be iterated through once.
     * @param {?boolean=} optData (default=False)
     *      Return two tuples (u,v) (False) or three-tuples (u,v,data) (True).
     * @param {?boolean=} optKeys (default=False)
     *      Return two tuples (u,v) (False) or three-tuples (u,v,key) (True).
     *
     * @return {!Array} list of edge tuples
     *      Edges that are adjacent to any node in nbunch, or a list
     *      of all edges if nbunch is not specified.
     */
    value: function edges(optNbunch, optData, optKeys) {
      return _Array$from(this.edgesIter(optNbunch, optData, optKeys));
    }
  }, {
    key: 'edgesIter',

    /**
     * Return an iterator over edges.
     *
     * Edges are returned as tuples with optional data and keys
     * in the order (node, neighbor, key, data).
     *
     * Nodes in nbunch that are not in the graph will be (quietly) ignored.
     *
     * ### Example
     *
     * ```
     * var G = new jsnx.MultiGraph();
     * G.addPath([0,1,2,3]);
     * Array.from(G.edgesIter);
     * // [[0,1], [1,2], [2,3]]
     * Array.from(G.edges(true));
     * // [[0,1,{}], [1,2,{}], [2,3,{}]]
     * Array.from(G.edges(false, true));
     * // [[0,1,0], [1,2,0], [2,3,0]]
     * Array.from(G.edges(true, true));
     * // [[0,1,0,{}], [1,2,0,{}], [2,3,0,{}]]
     * Array.from(G.edges([0,3]));
     * // [[0,1], [3, 2]]
     * Array.from(G.edges(0));
     * // [[0,1]]
     * ```
     *
     * @see #edges
     *
     * @param {?(NodeContainer|boolean)=} optNbunch A container of nodes.
     *      The container will be iterated through once.
     * @param {?boolean=} optData (default=False)
     *      If True, return edge attribute dict with each edge.
     * @param {?boolean=} optKeys (default=False)
     *      If True, return edge keys with each edge.
     *
     * @return {!Iterator}
     *      An iterator of (u,v), (u,v,d) or (u,v,key,d) tuples of edges.
     *
     * @override
     * @export
     */
    value: _regeneratorRuntime.mark(function edgesIter(optNbunch) {
      var optData = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
      var optKeys = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

      var seen, nodesNbrs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step$value, n, nbrs, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _step2$value, nbr, keydict, key, tuple;

      return _regeneratorRuntime.wrap(function edgesIter$(context$2$0) {
        // istanbul ignore next

        var _this3 = this;

        while (1) switch (context$2$0.prev = context$2$0.next) {
          case 0:
            if (typeof optNbunch === 'boolean') {
              optKeys = optData;
              optData = optNbunch;
              optNbunch = null;
            }

            seen = new _internals.Set();
            nodesNbrs = optNbunch == null ? this.adj : (0, _internals.mapIterator)(this.nbunchIter(optNbunch), function (n) {
              return (0, _internals.tuple2)(n, _this3.adj.get(n));
            });
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            context$2$0.prev = 6;
            _iterator = _getIterator(nodesNbrs);

          case 8:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              context$2$0.next = 53;
              break;
            }

            _step$value = _slicedToArray(_step.value, 2);
            n = _step$value[0];
            nbrs = _step$value[1];
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _iteratorError2 = undefined;
            context$2$0.prev = 15;
            _iterator2 = _getIterator(nbrs);

          case 17:
            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
              context$2$0.next = 36;
              break;
            }

            _step2$value = _slicedToArray(_step2.value, 2);
            nbr = _step2$value[0];
            keydict = _step2$value[1];

            if (seen.has(nbr)) {
              context$2$0.next = 33;
              break;
            }

            context$2$0.t0 = _regeneratorRuntime.keys(keydict);

          case 23:
            if ((context$2$0.t1 = context$2$0.t0()).done) {
              context$2$0.next = 32;
              break;
            }

            key = context$2$0.t1.value;
            tuple = [n, nbr];

            if (optKeys) {
              tuple[2] = key;
            }
            if (optData) {
              tuple.push(keydict[key]);
            }
            context$2$0.next = 30;
            return tuple;

          case 30:
            context$2$0.next = 23;
            break;

          case 32:
            seen.add(n);

          case 33:
            _iteratorNormalCompletion2 = true;
            context$2$0.next = 17;
            break;

          case 36:
            context$2$0.next = 42;
            break;

          case 38:
            context$2$0.prev = 38;
            context$2$0.t2 = context$2$0['catch'](15);
            _didIteratorError2 = true;
            _iteratorError2 = context$2$0.t2;

          case 42:
            context$2$0.prev = 42;
            context$2$0.prev = 43;

            if (!_iteratorNormalCompletion2 && _iterator2['return']) {
              _iterator2['return']();
            }

          case 45:
            context$2$0.prev = 45;

            if (!_didIteratorError2) {
              context$2$0.next = 48;
              break;
            }

            throw _iteratorError2;

          case 48:
            return context$2$0.finish(45);

          case 49:
            return context$2$0.finish(42);

          case 50:
            _iteratorNormalCompletion = true;
            context$2$0.next = 8;
            break;

          case 53:
            context$2$0.next = 59;
            break;

          case 55:
            context$2$0.prev = 55;
            context$2$0.t3 = context$2$0['catch'](6);
            _didIteratorError = true;
            _iteratorError = context$2$0.t3;

          case 59:
            context$2$0.prev = 59;
            context$2$0.prev = 60;

            if (!_iteratorNormalCompletion && _iterator['return']) {
              _iterator['return']();
            }

          case 62:
            context$2$0.prev = 62;

            if (!_didIteratorError) {
              context$2$0.next = 65;
              break;
            }

            throw _iteratorError;

          case 65:
            return context$2$0.finish(62);

          case 66:
            return context$2$0.finish(59);

          case 67:
          case 'end':
            return context$2$0.stop();
        }
      }, edgesIter, this, [[6, 55, 59, 67], [15, 38, 42, 50], [43,, 45, 49], [60,, 62, 66]]);
    })
  }, {
    key: 'getEdgeData',

    /**
     * Return the attribute dictionary associated with edge (u,v).
     *
     * ### Example
     *
     * ```
     * var G = jsnx.MultiGraph();
     * G.addPath([0,1,2,3]);
     * G.getEdgeData(0, 1);
     * // {0: {}}
     * G.getEdgeData('a', 'b', null, 0); // edge not in graph, return 0
     * // 0
     * ```
     *
     * @param {Node} u node
     * @param {Node} v node
     * @param {(string|number)=} optKey Return data only for the edge with
     *      specified key.
     * @param {T=} optDefault Value to return if the edge (u,v) is not found.
     *
     * @return {(Object|T)} The edge attribute dictionary.
     * @template T
     */
    value: function getEdgeData(u, v, optKey, optDefault) {
      var neightborsOfU = this.adj.get(u);
      if (neightborsOfU) {
        if (optKey == null) {
          return neightborsOfU.get(v) || optDefault;
        }
        return neightborsOfU.has(v) && neightborsOfU.get(v)[optKey] || optDefault;
      }
    }
  }, {
    key: 'degreeIter',

    /**
     * Return an iterator for (node, degree).
     *
     * The node degree is the number of edges adjacent to the node.
     *
     * ### Example
     *
     * ```
     * var G = new jsnx.Graph();
     * G.addPath([0,1,2,3]);
     * Array.from(G.degreeIter(0));
     * // [[0,1]]  // node 0 with degree 1
     * Array.from(G.degreeIter([0,1]));
     * // [[0,1], [1,2]]
     *
     * @see #degree
     *
     * @param {?(Node|NodeContainer)=} optNbunch  A container of nodes
     *      The container will be iterated through once.
     * @param {?string=} optWeight  The edge attribute that holds the numerical
     *      value used as a weight.  If undefined, then each edge has weight 1.
     *      The degree is the sum of the edge weights adjacent to the node.
     *
     * @return {!Iterator} The iterator returns two-tuples of (node, degree).
     */
    value: _regeneratorRuntime.mark(function degreeIter(optNbunch, optWeight) {
      var nodesNbrs, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _step3$value, n, nbrs, deg, keydict, key;

      return _regeneratorRuntime.wrap(function degreeIter$(context$2$0) {
        // istanbul ignore next

        var _this4 = this;

        while (1) switch (context$2$0.prev = context$2$0.next) {
          case 0:
            if (typeof optNbunch === 'string') {
              optWeight = optNbunch;
              optNbunch = null;
            }
            nodesNbrs = optNbunch == null ? this.adj : (0, _internals.mapIterator)(this.nbunchIter(optNbunch), function (n) {
              return (0, _internals.tuple2)(n, _this4.adj.get(n));
            });
            _iteratorNormalCompletion3 = true;
            _didIteratorError3 = false;
            _iteratorError3 = undefined;
            context$2$0.prev = 5;
            _iterator3 = _getIterator(nodesNbrs);

          case 7:
            if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
              context$2$0.next = 25;
              break;
            }

            _step3$value = _slicedToArray(_step3.value, 2);
            n = _step3$value[0];
            nbrs = _step3$value[1];
            deg = 0;

            if (!(optWeight == null)) {
              context$2$0.next = 18;
              break;
            }

            nbrs.forEach(function (keydict) {
              return deg += _Object$keys(keydict).length;
            });
            context$2$0.next = 16;
            return [n, deg + +(nbrs.has(n) && _Object$keys(nbrs.get(n)).length)];

          case 16:
            context$2$0.next = 22;
            break;

          case 18:
            // edge weighted graph - degree is sum of nbr edge weights
            nbrs.forEach(function (keydict) {
              for (var key in keydict) {
                deg += (0, _internals.getDefault)(keydict[key][optWeight], 1);
              }
            });

            if (nbrs.has(n)) {
              keydict = nbrs.get(n);

              for (key in keydict) {
                deg += (0, _internals.getDefault)(keydict[key][optWeight], 1);
              }
            }

            context$2$0.next = 22;
            return [n, deg];

          case 22:
            _iteratorNormalCompletion3 = true;
            context$2$0.next = 7;
            break;

          case 25:
            context$2$0.next = 31;
            break;

          case 27:
            context$2$0.prev = 27;
            context$2$0.t0 = context$2$0['catch'](5);
            _didIteratorError3 = true;
            _iteratorError3 = context$2$0.t0;

          case 31:
            context$2$0.prev = 31;
            context$2$0.prev = 32;

            if (!_iteratorNormalCompletion3 && _iterator3['return']) {
              _iterator3['return']();
            }

          case 34:
            context$2$0.prev = 34;

            if (!_didIteratorError3) {
              context$2$0.next = 37;
              break;
            }

            throw _iteratorError3;

          case 37:
            return context$2$0.finish(34);

          case 38:
            return context$2$0.finish(31);

          case 39:
          case 'end':
            return context$2$0.stop();
        }
      }, degreeIter, this, [[5, 27, 31, 39], [32,, 34, 38]]);
    })
  }, {
    key: 'isMultigraph',

    /**
     * Return true if graph is a multigraph, false otherwise.
     *
     * @return {boolean} true if graph is a multigraph, false otherwise.
     */
    value: function isMultigraph() {
      return true;
    }
  }, {
    key: 'isDirected',

    /**
     * Return true if graph is directed, false otherwise.
     *
     * @return {boolean}  True if graph is directed, False otherwise.
     */
    value: function isDirected() {
      return false;
    }
  }, {
    key: 'toDirected',

    /**
     * Return a directed representation of the graph.
     *
     * ### Notes
     *
     * This returns a "deepcopy" of the edge, node, and graph attributes which
     * attempts to completely copy all of the data and references.
     *
     * This is in contrast to the similar D = DiGraph(G) which returns a shallow
     * copy of the data.
     *
     * ### Example
     *
     * ```
     * var G = new jsnx.MultiGraph();
     * G.addPath([0,1]);
     * var H = G.toDirected();
     * G.edges();
     * // [[0,1], [1,0]]
     * ```
     *
     * If already directed, return a (deep) copy
     *
     * ```
     * var G = new jsnx.MultiDiGraph();
     * G.addPath([0,1]);
     * var H = G.toDirected();
     * G.edges();
     * // [[0,1]]
     * ```
     *
     * @return {!MultiDiGraph}
     *      A directed graph with the same name, same nodes, and with
     *      each edge (u,v,data) replaced by two directed edges
     *      (u,v,data) and (v,u,data).
     */
    value: function toDirected() {
      var G = new (__webpack_require__(355))();
      G.addNodesFrom(this);
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = _getIterator(this.adjacencyIter()), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _step4$value = _slicedToArray(_step4.value, 2);

          var u = _step4$value[0];
          var nbrs = _step4$value[1];
          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = _getIterator(nbrs), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var _step5$value = _slicedToArray(_step5.value, 2);

              var v = _step5$value[0];
              var keydict = _step5$value[1];

              for (var key in keydict) {
                G.addEdge(u, v, key, (0, _internals.deepcopy)(keydict[key]));
              }
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5['return']) {
                _iterator5['return']();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4['return']) {
            _iterator4['return']();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      G.graph = (0, _internals.deepcopy)(this.graph);
      G.node = (0, _internals.deepcopy)(this.node);
      return G;
    }
  }, {
    key: 'selfloopEdges',

    /**
     * Return a list of selfloop edges.
     *
     * ### Example
     *
     * ```
     * var G = new jsnx.MultiGraph();
     * G.addEdge(1, 1);
     * G.addEdge(1, 2);
     * G.selfloopEdges();
     * // [[1,1]]
     * G.selfloopEdges(true);
     * // [[1,1,{}]]
     * G.selfloopEdges(false, true);
     * // [[1,1,0]]
     * G.selfloopEdges(true, true);
     * // [[1,1,0,{}]]
     * ```
     *
     * @see #nodesWithSelfloops
     * @see #numberOfSelfloops
     *
     *
     * @param {boolean=} optData  (default=False)
     *      Return selfloop edges as two tuples (u,v) (data=False)
     *      or three-tuples (u,v,data) (data=True)
     * @param {boolean=} optKeys  (default=False)
     *       If True, return edge keys with each edge
     *
     * @return {Array} A list of all selfloop edges
     */
    value: function selfloopEdges() {
      var optData = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
      var optKeys = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

      var edges = [];
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = _getIterator(this.adj), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var _step6$value = _slicedToArray(_step6.value, 2);

          var n = _step6$value[0];
          var nbrs = _step6$value[1];

          if (nbrs.has(n)) {
            var keydict = nbrs.get(n);
            for (var key in keydict) {
              var edge = [n, n];
              if (optKeys) {
                edge[2] = key;
              }
              if (optData) {
                edge.push(keydict[key]);
              }
              edges.push(edge);
            }
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6['return']) {
            _iterator6['return']();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      return edges;
    }
  }, {
    key: 'numberOfEdges',

    /**
     * Return the number of edges between two nodes.
     *
     * ### Example
     *
     * ```
     * var G = new jsnx.MultiGraph();
     * G.addPath([0,1,2,3]);
     * G.numberOfEdges();
     * // 3
     * G.numberOfEdges(0,1);
     * // 1
     * ```
     *
     * @see #size
     *
     * @param {Node=} optU node
     * @param {Node=} optV node
     *      If u and v are specified, return the number of edges between
     *      u and v. Otherwise return the total number of all edges.
     *
     * @return {number} The number of edges in the graph.
     *      If nodes u and v are specified return the number of edges between
     *      those nodes.
     */
    value: function numberOfEdges(optU, optV) {
      if (optU == null || optV == null) {
        return this.size();
      }

      var neightborsOfU = this.get(optU);
      if (neightborsOfU) {
        return neightborsOfU.has(optV) ? _Object$keys(neightborsOfU.get(optV)).length : 0;
      }
      return 0;
    }
  }, {
    key: 'subgraph',

    /**
     * Return the subgraph induced on nodes in nbunch.
     *
     * The induced subgraph of the graph contains the nodes in nbunch and the
     * edges between those nodes.
     *
     * ### Notes
     *
     * The graph, edge or node attributes just point to the original graph.
     * So changes to the node or edge structure will not be reflected in
     * the original graph while changes to the attributes will.
     *
     * To create a subgraph with its own copy of the edge/node attributes use:
     * `jsnx.Graph(G.subgraph(nbunch))`
     *
     * If edge attributes are containers, a deep copy can be obtained using:
     * `G.subgraph(nbunch).copy()`.
     *
     * ### Example
     *
     * ```
     * var G = new jsnx.Graph();
     * G.addPath([0,1,2,3]);
     * var H = G.subgraph([0,1,2]);
     * H.edges();
     * // [[0,1], [1,2]]
     * ```
     *
     * @param {NodeContainer=} nbunch A container of nodes which will be
     *      iterated through once.
     * @return {MultiGraph} A subgraph of the graph with the same edge attributes.
     */
    value: function subgraph(nbunch) {
      var bunch = this.nbunchIter(nbunch);
      // create new graph and copy subgraph into it
      var H = new this.constructor();
      // copy node and attribute dictionaries
      this.node.forEach(function (d, n) {
        return H.node.set(n, d);
      });
      // namespace shortcuts for speed
      var HAdj = H.adj,
          thisAdj = this.adj;

      // add nodes and edges (undirected method)
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = _getIterator(bunch), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var n = _step7.value;

          var Hnbrs = new _internals.Map();
          HAdj.set(n, Hnbrs);

          var _iteratorNormalCompletion8 = true;
          var _didIteratorError8 = false;
          var _iteratorError8 = undefined;

          try {
            for (var _iterator8 = _getIterator(thisAdj.get(n)), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
              var _step8$value = _slicedToArray(_step8.value, 2);

              var nbr = _step8$value[0];
              var edgedict = _step8$value[1];

              if (HAdj.has(nbr)) {
                // add both representations of edge: n-nbr and nbr-n
                // they share the same edgedict
                var ed = (0, _internals.clone)(edgedict);
                Hnbrs.set(nbr, ed);
                HAdj.get(nbr).set(n, ed);
              }
            }
          } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion8 && _iterator8['return']) {
                _iterator8['return']();
              }
            } finally {
              if (_didIteratorError8) {
                throw _iteratorError8;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7['return']) {
            _iterator7['return']();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      H.graph = this.graph;
      return H;
    }
  }], [{
    key: '__name__',

    /**
     * Holds the graph type (class) name for information.
     * This is compatible to Pythons __name__ property.
     *
     * @type {string}
     */
    get: function get() {
      return 'MultiGraph';
    }
  }]);

  return MultiGraph;
})(_Graph3['default']);

exports['default'] = MultiGraph;
module.exports = exports['default'];

/*eslint no-loop-func:0*/

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Array$from = __webpack_require__(13)['default'];

var _getIterator = __webpack_require__(8)['default'];

var _Map = __webpack_require__(772)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.nodes = nodes;
exports.nodesIter = nodesIter;
exports.edges = edges;
exports.edgesIter = edgesIter;
exports.degree = degree;
exports.neighbors = neighbors;
exports.numberOfNodes = numberOfNodes;
exports.numberOfEdges = numberOfEdges;
exports.density = density;
exports.degreeHistogram = degreeHistogram;
exports.isDirected = isDirected;
exports.freeze = freeze;
exports.isFrozen = isFrozen;
exports.subgraph = subgraph;
exports.createEmptyCopy = createEmptyCopy;
exports.info = info;
exports.setNodeAttributes = setNodeAttributes;
exports.getNodeAttributes = getNodeAttributes;
exports.setEdgeAttributes = setEdgeAttributes;
exports.getEdgeAttributes = getEdgeAttributes;

var _exceptionsJSNetworkXError = __webpack_require__(34);

var _exceptionsJSNetworkXError2 = _interopRequireDefault(_exceptionsJSNetworkXError);

var _internals = __webpack_require__(15);

/**
 * Return a copy of the graph nodes in a list.
 *
 * @param {Graph} G Graph
 * @return {Array} List of nodes
 */

function nodes(G) {
  return G.nodes();
}

/**
 * Return an iterator over the graph nodes.
 *
 * @param {Graph} G Graph
 * @return {Iterator} Iterator over graph nodes
 */

function nodesIter(G) {
  return G.nodesIter();
}

/**
 * Return a list of edges adjacent to nodes in nbunch.
 *
 * Return all edges if nbunch is unspecified or nbunch=None.
 * For digraphs, edges=out_edges
 *
 * @param {Graph} G Graph
 * @param {NodeContainer=} opt_nbunch Nodes
 * @return {Array} List of edges
 */

function edges(G, optNbunch) {
  return G.edges(optNbunch);
}

/**
 * Return iterator over  edges adjacent to nodes in nbunch.
 *
 * Return all edges if nbunch is unspecified or nbunch=None.
 * For digraphs, edges=out_edges
 *
 * @param {Graph} G Graph
 * @param {NodeContainer=} opt_nbunch Nodes
 * @return {Iterator} Iterator over edges
 */

function edgesIter(G, optNbunch) {
  return G.edgesIter(optNbunch);
}

/**
 * Return degree of single node or of nbunch of nodes.
 * If nbunch is omitted, then return degrees of *all* nodes.
 *
 * @param {Graph} G Graph
 * @param {NodeContainer=} opt_nbunch Nodes
 * @param {string=} opt_weight Weight attribute name
 * @return {(number|Map)} Degree of node(s)
 */

function degree(G, optNbunch, optWeight) {
  return G.degree(optNbunch, optWeight);
}

/**
 * Return a list of nodes connected to node n.
 *
 * @param {Graph} G Graph
 * @param {Node} n Node
 * @return {Array} List of nodes
 */

function neighbors(G, n) {
  return G.neighbors(n);
}

/**
 * Return the number of nodes in the graph.
 *
 * @param {Graph} G Graph
 * @return {number} Number of nodes
 */

function numberOfNodes(G) {
  return G.numberOfNodes();
}

/**
 * Return the number of edges in the graph.
 *
 * @param {Graph} G Graph
 * @return {number} Number of edges
 */

function numberOfEdges(G) {
  return G.numberOfEdges();
}

/**
 * Return the density of a graph.
 * The density for undirected graphs is
 *
 * ```math
 * d = \frac{2m}{n(n-1)}
 * ```
 *
 * and for directed graphs is
 *
 * ```math
 * \frac{m}{n(n-1)}
 * ```
 *
 * where n is the number of nodes and m is the number of edges in G
 *
 * The density is 0 for an graph without edges and 1.0 for a complete graph.
 * The density of multigraphs can be higher than 1.
 *
 * @param {Graph} G Graph
 * @return {number} Density
 */

function density(G) {
  var n = G.numberOfNodes();
  var m = G.numberOfEdges();
  var d;

  if (m === 0) {
    // includes cases n === 0 and n === 1
    d = 0.0;
  } else {
    if (G.isDirected()) {
      d = m / (n * (n - 1));
    } else {
      d = m * 2 / (n * (n - 1));
    }
  }

  return d;
}

/**
 * Return a list of the frequency of each degree value.
 *
 * Note: the bins are width one, hence list.length can be large
 * (Order(number_of_edges))
 *
 *
 * @param {Graph} G Graph
 * @return {Array} A list of frequencies of degrees.
 *      The degree values are the index in the list.
 */

function degreeHistogram(G) {
  var degseq = _Array$from(G.degree().values());
  var dmax = Math.max.apply(Math, degseq) + 1;
  var freq = (0, _internals.fillArray)(dmax, 0);

  degseq.forEach(function (d) {
    freq[d] += 1;
  });

  return freq;
}

/**
 * Return True if graph is directed.
 *
 * @param {Graph} G Graph
 * @return {boolean}  True if graph is directed
 */

function isDirected(G) {
  return G.isDirected();
}

/**
 * Modify graph to prevent addition of nodes or edges.
 *
 * This does not prevent modification of edge data.
 * To "unfreeze" a graph you must make a copy.
 *
 * @see #is_frozen
 *
 * @param {Graph} G Graph
 * @return {Graph} A reference to the input graph
 */

function freeze(G) {
  function frozen() {
    throw new _exceptionsJSNetworkXError2['default']('Frozen graph can\'t be modified');
  }

  // This double assignment is necessary for the closure compiler
  G.addNode = frozen;
  G.addNodesFrom = frozen;
  G.removeNode = frozen;
  G.removeNodesFrom = frozen;
  G.addEdge = frozen;
  G.addEdgesFrom = frozen;
  G.removeEdge = frozen;
  G.removeEdgesFrom = frozen;
  G.clear = frozen;
  G.frozen = true;
  return G;
}

/**
 * Return True if graph is frozen.
 *
 * @see #freeze
 *
 * @param {Graph} G Graph
 * @return {boolean}  True if graph is frozen.
 */

function isFrozen(G) {
  return !!G.frozen;
}

/**
 * Return the subgraph induced on nodes in nbunch.
 *
 * Note:  subgraph(G) calls G.subgraph()
 *
 * @param {Graph} G Graph
 * @param {NodeContainer} nbunch
 *      A container of nodes that will be iterated through once (thus
 *      it should be an iterator or be iterable).  Each element of the
 *      container should be a valid node type: any hashable type except
 *      None.  If nbunch is None, return all edges data in the graph.
 *      Nodes in nbunch that are not in the graph will be (quietly)
 *      ignored.
 * @return {Graph} Subgraph
 */

function subgraph(G, nbunch) {
  return G.subgraph(nbunch);
}

/**
 * Return a copy of the graph G with all of the edges removed.
 *
 * Notes: Graph, node, and edge data is not propagated to the new graph.
 *
 * @param {Graph} G Graph
 * @param {boolean} opt_with_nodes (default=True)
 *      Include nodes.
 *
 * @return {Graph} A copy of the graph
 */

function createEmptyCopy(G) {
  var optWithNodes = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

  var H = new G.constructor();
  if (optWithNodes) {
    H.addNodesFrom(G);
  }
  return H;
}

/**
 * Print short summary of information for the graph G or the node n.
 *
 * @param {Graph} G Graph
 * @param {Node=} opt_n A node in the graph G
 * @return {string} Info
 */

function info(G, optN) {
  var result = '';
  if (optN == null) {
    var template = 'Name: %s\n' + 'Type: %s\n' + 'Number of nodes: %s\n' + 'Number of edges: %s\n';
    var nnodes = G.numberOfNodes();
    result = (0, _internals.sprintf)(template, G.name, G.constructor.__name__, nnodes, G.numberOfEdges());
    if (nnodes > 0) {
      if (G.isDirected()) {
        var inDegree = 0;
        var outDegree = 0;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _getIterator(G.inDegree().values()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _degree = _step.value;

            inDegree += _degree;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator['return']) {
              _iterator['return']();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = _getIterator(G.outDegree().values()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _degree2 = _step2.value;

            outDegree += _degree2;
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2['return']) {
              _iterator2['return']();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        result += (0, _internals.sprintf)('Average in degree: %s\nAverage out degree: %s', (inDegree / nnodes).toFixed(4), (outDegree / nnodes).toFixed(4));
      } else {
        var sum = 0;
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = _getIterator(G.degree().values()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var v = _step3.value;

            sum += v;
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3['return']) {
              _iterator3['return']();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        result += (0, _internals.sprintf)('Average degree: %s', (sum / nnodes).toFixed(4));
      }
    }
  } else {
    if (!G.hasNode(optN)) {
      throw new _exceptionsJSNetworkXError2['default']((0, _internals.sprintf)('Node %j not in graph.', optN));
    }
    result = (0, _internals.sprintf)('Node %j has the following properties:\nDegree: %s\nNeighbors: %s', optN, G.degree(optN), G.neighbors(optN).map(function (n) {
      return JSON.stringify(n);
    }).join(' '));
  }
  return result;
}

/**
 * Set node attributes from dictionary of nodes and values
 *
 * @param {Graph} G Graph
 * @param {string} name Attribute name
 * @param {(Object|Map)} attributes Dictionary of attributes keyed by node
 */

function setNodeAttributes(G, name, attributes) {
  if ((0, _internals.isMap)(attributes)) {
    attributes.forEach(function (value, node) {
      return G.node.get(node)[name] = value;
    });
  } else if ((0, _internals.isPlainObject)(attributes)) {
    for (var node in attributes) {
      node = isNaN(node) ? node : +node;
      G.node.get(node)[name] = attributes[node];
    }
  } else {
    throw new TypeError('Attributes must be a Map or a plain object');
  }
}

/**
 * Get node attributes from graph
 *
 * @param {Graph} G Graph
 * @param {string} name Attribute name
 * @return {!Map} Dictionary of attributes keyed by node.
 */

function getNodeAttributes(G, name) {
  var dict = new _Map();
  G.node.forEach(function (node, data) {
    if (data.hasOwnProperty(name)) {
      dict.set(node, data[name]);
    }
  });
  return dict;
}

/**
 * Set edge attributes from dictionary of edge tuples and values
 *
 * @param {Graph} G Graph
 * @param {string} name Attribute name
 * @param {Map} attributes
 *    Dictionary of attributes keyed by edge (tuple).
 */

function setEdgeAttributes(G, name, attributes) {
  attributes.forEach(function (edge, value) {
    G.get(edge[0]).get(edge[1])[name] = value;
  });
}

/**
 * Get edge attributes from graph
 *
 * Since keys can only be strings in JavaScript, the edge is returned as
 * {@code "node1,node2"} string. You'd have to call {@code .split(',')} on
 * the keys to extract the actual node names.
 *
 * @param {Graph} G Graph
 * @param {string} name Attribute name
 * @return {!Map} Dictionary of attributes keyed by edge.
 */

function getEdgeAttributes(G, name) {
  var dict = new _Map();
  G.edges(null, true).forEach(function (edged) {
    if (edged[2].hasOwnProperty(name)) {
      var value = edged[2][name];
      edged.length = 2; // cut of data
      dict.set(edged, value);
    }
  });
  return dict;
}

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2)['default'];

var _interopRequireWildcard = __webpack_require__(25)['default'];

var _defaults = __webpack_require__(45)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _Graph = __webpack_require__(71);

var _Graph2 = _interopRequireDefault(_Graph);

var _DiGraph = __webpack_require__(114);

var _DiGraph2 = _interopRequireDefault(_DiGraph);

var _MultiGraph = __webpack_require__(356);

var _MultiGraph2 = _interopRequireDefault(_MultiGraph);

var _MultiDiGraph = __webpack_require__(355);

var _MultiDiGraph2 = _interopRequireDefault(_MultiDiGraph);

var _functions = __webpack_require__(357);

var functions = _interopRequireWildcard(_functions);

exports.Graph = _Graph2['default'];
exports.DiGraph = _DiGraph2['default'];
exports.MultiGraph = _MultiGraph2['default'];
exports.MultiDiGraph = _MultiDiGraph2['default'];
exports.functions = functions;

_defaults(exports, _interopRequireWildcard(_functions));

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = prepCreateUsing;
/**
 * Return a graph object ready to be populated.
 *
 * If create_using is null or undefined return the default (just jsnx.Graph())
 * If create_using.clear() works, assume it returns a graph object.
 * Otherwise raise an exception because create_using is not a jsnx graph.
 *
 * @param {Graph=} opt_create_using
 * @return {Graph}
 */

function prepCreateUsing(optCreateUsing) {
  var G;
  // can't use import statement because of circular dependency
  var Graph = __webpack_require__(71);

  if (optCreateUsing == null) {
    G = new Graph();
  } else {
    G = optCreateUsing;

    try {
      G.clear();
    } catch (e) {
      throw new TypeError('Input graph is not a jsnx graph type');
    }
  }
  return G;
}

module.exports = exports['default'];

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _get = __webpack_require__(57)['default'];

var _inherits = __webpack_require__(58)['default'];

var _classCallCheck = __webpack_require__(24)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _JSNetworkXException2 = __webpack_require__(214);

var _JSNetworkXException3 = _interopRequireDefault(_JSNetworkXException2);

/**
 * Exception for unexpected termination of algorithms.
 * @constructor
 * @extends {JSNetworkXException}
 */

var JSNetworkXAlgorithmError = (function (_JSNetworkXException) {
  _inherits(JSNetworkXAlgorithmError, _JSNetworkXException);

  function JSNetworkXAlgorithmError(message) {
    _classCallCheck(this, JSNetworkXAlgorithmError);

    _get(Object.getPrototypeOf(JSNetworkXAlgorithmError.prototype), 'constructor', this).call(this, message);
    this.name = 'JSNetworkXAlgorithmError';
  }

  return JSNetworkXAlgorithmError;
})(_JSNetworkXException3['default']);

exports['default'] = JSNetworkXAlgorithmError;
module.exports = exports['default'];

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _get = __webpack_require__(57)['default'];

var _inherits = __webpack_require__(58)['default'];

var _classCallCheck = __webpack_require__(24)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _JSNetworkXUnfeasible2 = __webpack_require__(215);

var _JSNetworkXUnfeasible3 = _interopRequireDefault(_JSNetworkXUnfeasible2);

/**
 * Exception for algorithms that should return a path when running
 * on graphs where such a path does not exist.
 */

var JSNetworkXNoPath = (function (_JSNetworkXUnfeasible) {
  _inherits(JSNetworkXNoPath, _JSNetworkXUnfeasible);

  function JSNetworkXNoPath(message) {
    _classCallCheck(this, JSNetworkXNoPath);

    _get(Object.getPrototypeOf(JSNetworkXNoPath.prototype), 'constructor', this).call(this, message);
    this.name = 'JSNetworkXNoPath';
  }

  return JSNetworkXNoPath;
})(_JSNetworkXUnfeasible3['default']);

exports['default'] = JSNetworkXNoPath;
module.exports = exports['default'];

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _get = __webpack_require__(57)['default'];

var _inherits = __webpack_require__(58)['default'];

var _classCallCheck = __webpack_require__(24)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var KeyError = (function (_Error) {
  _inherits(KeyError, _Error);

  function KeyError(message) {
    _classCallCheck(this, KeyError);

    _get(Object.getPrototypeOf(KeyError.prototype), 'constructor', this).call(this);
    this.name = 'KeyError';
    this.message = message;
  }

  return KeyError;
})(Error);

exports['default'] = KeyError;
module.exports = exports['default'];

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$assign = __webpack_require__(89)['default'];

var _Array$from = __webpack_require__(13)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.relabelNodes = relabelNodes;
exports.convertNodeLabelsToIntegers = convertNodeLabelsToIntegers;

var _classesDiGraph = __webpack_require__(114);

var _classesDiGraph2 = _interopRequireDefault(_classesDiGraph);

var _exceptions = __webpack_require__(88);

var _internals = __webpack_require__(15);

/**
 * Relabel the nodes of the graph G.
 *
 * ### Examples
 *
 * ```
 * var G = jsnx.pathGraph(3);  // nodes 0-1-2
 * var mapping = {0: 'a', 1: 'b', 2: 'c'};
 * // var mapping = new Map([[0, 'a'], [1, 'b'], [2, 'c']]);
 * var H = jsnx.relabelNodes(G, mapping);
 * H.nodes();
 * // ['a', 'b', 'c']
 * ```
 *
 * Partial in-place mapping
 *
 * ```
 * var G = jsnx.pathGraph(3);  // nodes 0-1-2
 * var mapping = {0: 'a', 1: 'b'};
 * // var mapping = new Map([[0, 'a'], [1, 'b']]);
 * var H = jsnx.relabelNodes(G, mapping, false);
 * H.nodes();
 * // [2, 'b', 'c']
 * ```
 *
 * Mapping as function:
 *
 * ```
 * var G = jsnx.pathGraph(3);
 * var H = jsnx.relabelNodes(G, x => Math.pow(x, 2));
 * H.nodes()
 * // [0, 1, 4]
 * ```
 *
 * ### Notes
 *
 * Only the nodes specified in the mapping will be relabeled.
 *
 * The setting `copy=false` modifies the graph in place.
 * This is not always possible if the mapping is circular.
 * In that case use copy=true.
 *
 * @see #convertNodeLabelsToIntegers
 *
 * @param {Graph} G A JSNetworkX graph
 * @param {(Object|Map|function(Node):Node)} mapping
 *      A dictionary with the old labels as keys and new labels as values.
 *      A partial mapping is allowed.
 * @param {boolean=} optCopy
 *      If `true` return a copy or if `false` relabel the nodes in place.
 * @return {Graph}
 */

function relabelNodes(G, mapping) {
  var optCopy = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];

  // you can pass a function f(oldLabel)->newLabel
  // but we'll just make a dictionary here regardless
  var m = mapping;
  if (typeof mapping !== 'function') {
    if (!(0, _internals.isMap)(m)) {
      m = new _internals.Map(m);
    }
  } else {
    m = new _internals.Map((0, _internals.mapIterator)(G.nodesIter(), function (n) {
      return (0, _internals.tuple2)(n, mapping(n));
    }));
  }

  return optCopy ? relabelCopy(G, m) : relabelInplace(G, m);
}

/**
 * @param {Graph} G A JSNetworkX graph
 * @param {Map} mapping
 *      A dictionary with the old labels as keys and new labels as values.
 *      A partial mapping is allowed.
 *
 * @return .Graph}
 * @private
 */
function relabelInplace(G, mapping) {
  var oldLabels = new _internals.Set(mapping.keys());
  var nodes;

  if ((0, _internals.someIterator)(mapping.values(), function (v) {
    return oldLabels.has(v);
  })) {
    // labels sets overlap
    // can we topological sort and still do the relabeling?
    var D = new _classesDiGraph2['default'](mapping);
    D.removeEdgesFrom(D.selfloopEdges());
    try {
      nodes = (0, _internals.topologicalSort)(D);
    } catch (e) {
      if (e instanceof _exceptions.JSNetworkXUnfeasible) {
        throw new _exceptions.JSNetworkXUnfeasible('The node label sets are overlapping and' + ' no ordering can resolve the mapping.' + ' Use copy=True.');
      }
    }
    nodes.reverse(); // reverse topological order
  } else {
    // non-overlapping label sets
    nodes = oldLabels.values();
  }
  var multigraph = G.isMultigraph();
  var directed = G.isDirected();
  var newEdges;

  (0, _internals.forEach)(nodes, function (old) {
    var newMapping;
    if (mapping.has(old)) {
      newMapping = mapping.get(old);
    } else {
      return; // continue
    }

    if (!G.hasNode(old)) {
      throw new _exceptions.JSNetworkXError((0, _internals.sprintf)('Node %j is not in the graph.', old));
    }
    G.addNode(newMapping, G.node.get(old));
    if (multigraph) {
      newEdges = G.edges(old, true, true).map(function (d) {
        return (0, _internals.tuple4c)(newMapping, d[1], d[2], d[3], d);
      });

      if (directed) {
        newEdges = newEdges.concat(G.inEdges(old, true, true).map(function (d) {
          return (0, _internals.tuple4c)(d[0], newMapping, d[2], d[3], d);
        }));
      }
    } else {
      newEdges = G.edges(old, true).map(function (d) {
        return (0, _internals.tuple3c)(newMapping, d[1], d[2], d);
      });

      if (directed) {
        newEdges = newEdges.concat(G.inEdges(old, true).map(function (d) {
          return (0, _internals.tuple3c)(d[0], newMapping, d[2], d);
        }));
      }
    }
    G.removeNode(old);
    G.addEdgesFrom(newEdges);
  });
  return G;
}

/**
 * @param {Graph} G A JSNetworkX graph
 * @param {Map} mapping
 *      A dictionary with the old labels as keys and new labels as values.
 *      A partial mapping is allowed.
 *
 * @return {Graph}
 * @private
 */
function relabelCopy(G, mapping) {
  var H = new G.constructor();
  H.name = '(' + G.name + ')';
  if (G.isMultigraph()) {
    H.addEdgesFrom((0, _internals.mapIterator)(G.edgesIter(null, true, true), function (d) {
      return (0, _internals.tuple4c)(mapping.has(d[0]) ? mapping.get(d[0]) : d[0], mapping.has(d[1]) ? mapping.get(d[1]) : d[1], d[2], (0, _internals.clone)(d[3]), d);
    }));
  } else {
    H.addEdgesFrom((0, _internals.mapIterator)(G.edgesIter(null, true), function (d) {
      return (0, _internals.tuple3c)(mapping.has(d[0]) ? mapping.get(d[0]) : d[0], mapping.has(d[1]) ? mapping.get(d[1]) : d[1], (0, _internals.clone)(d[3]), d);
    }));
  }
  G.node.forEach(function (data, n) {
    return H.addNode(mapping.has(n) ? mapping.get(n) : n, (0, _internals.clone)(data));
  });
  _Object$assign(H.graph, (0, _internals.clone)(G.graph));

  return H;
}

/**
 * Return a copy of G node labels replaced with integers.
 *
 * ### Notes
 *
 * Node and edge attribute data are copied to the new (relabeled) graph.
 *
 * @param {Graph} G A JSNetworkX graph
 * @param {?number=} optFirstLabel
 *      An integer specifying the offset in numbering nodes.
 *      The n new integer labels are numbered firstLabel, ..., n-1+firstLabel.
 * @param {?string=} optOrdering
 *   - "default" : inherit node ordering from `G.nodes()`
 *   - "sorted"  : inherit node ordering from `G.nodes().sort()`
 *   - "increasing degree" : nodes are sorted by increasing degree
 *   - "decreasing degree" : nodes are sorted by decreasing degree
 * @param {?boolean=} optDiscardOldLabels
 *      If true discard old labels. If false, create a node attribute
 *      'oldLabel' to hold the old labels.
 * @return {Graph}
 */

function convertNodeLabelsToIntegers(G) {
  var optFirstLabel = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
  var optOrdering = arguments.length <= 2 || arguments[2] === undefined ? 'default' : arguments[2];
  var optDiscardOldLabels = arguments.length <= 3 || arguments[3] === undefined ? true : arguments[3];

  //   This function strips information attached to the nodes and/or
  //   edges of a graph, and returns a graph with appropriate integer
  //   labels. One can view this as a re-labeling of the nodes. Be
  //   warned that the term "labeled graph" has a loaded meaning
  //   in graph theory. The fundamental issue is whether the names
  //   (labels) of the nodes (and edges) matter in deciding when two
  //   graphs are the same. For example, in problems of graph enumeration
  //   there is a distinct difference in techniques required when
  //   counting labeled vs. unlabeled graphs.
  //
  //   When implementing graph
  //   algorithms it is often convenient to strip off the original node
  //   and edge information and appropriately relabel the n nodes with
  //   the integer values 1,..,n. This is the purpose of this function,
  //   and it provides the option (see discardOldLabels variable) to either
  //   preserve the original labels in separate dicts (these are not
  //   returned but made an attribute of the new graph.

  if (typeof optOrdering === 'boolean') {
    optDiscardOldLabels = optOrdering;
    optOrdering = 'default';
  }

  switch (typeof optFirstLabel) {
    case 'string':
      optOrdering = optFirstLabel;
      optFirstLabel = 0;
      break;
    case 'boolean':
      optDiscardOldLabels = optFirstLabel;
      optFirstLabel = 0;
      break;
  }

  var mapping = new _internals.Map();
  var nodes;
  var dvPairs;
  var i;
  var j;
  var l;

  switch (optOrdering) {
    case 'default':
      nodes = G.nodes();
      for (i = 0, j = optFirstLabel, l = nodes.length; i < l; i++, j++) {
        mapping.set(nodes[i], j);
      }
      break;
    case 'sorted':
      nodes = G.nodes();
      nodes.sort();
      for (i = 0, j = optFirstLabel, l = nodes.length; i < l; i++, j++) {
        mapping.set(nodes[i], j);
      }
      break;
    case 'increasing degree':
      dvPairs = _Array$from(G.degreeIter());
      dvPairs.sort(function (a, b) {
        return a[1] - b[1];
      });
      for (i = 0, j = optFirstLabel, l = dvPairs.length; i < l; i++, j++) {
        mapping.set(dvPairs[i][0], j);
      }
      break;
    case 'decreasing degree':
      dvPairs = _Array$from(G.degreeIter());
      dvPairs.sort(function (a, b) {
        return b[1] - a[1];
      });
      for (i = 0, j = optFirstLabel, l = dvPairs.length; i < l; i++, j++) {
        mapping.set(dvPairs[i][0], j);
      }
      break;
    default:
      throw new _exceptions.JSNetworkXError((0, _internals.sprintf)('Unkown node ordering: "%s"', optOrdering));
  }

  var H = relabelNodes(G, mapping);
  H.name = '(' + G.name + ')WithIntLabels';
  if (!optDiscardOldLabels) {
    H.nodeLabels = mapping;
  }
  return H;
}

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(527), __esModule: true };

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(528), __esModule: true };

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(529), __esModule: true };

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(530), __esModule: true };

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var baseRandom = __webpack_require__(789),
    isIterateeCall = __webpack_require__(223),
    toArray = __webpack_require__(809),
    toIterable = __webpack_require__(805);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Gets a random element or `n` random elements from a collection.
 *
 * @static
 * @memberOf _
 * @category Collection
 * @param {Array|Object|string} collection The collection to sample.
 * @param {number} [n] The number of elements to sample.
 * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
 * @returns {*} Returns the random sample(s).
 * @example
 *
 * _.sample([1, 2, 3, 4]);
 * // => 2
 *
 * _.sample([1, 2, 3, 4], 2);
 * // => [3, 1]
 */
function sample(collection, n, guard) {
  if (guard ? isIterateeCall(collection, n, guard) : n == null) {
    collection = toIterable(collection);
    var length = collection.length;
    return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
  }
  var index = -1,
      result = toArray(collection),
      length = result.length,
      lastIndex = length - 1;

  n = nativeMin(n < 0 ? 0 : (+n || 0), length);
  while (++index < n) {
    var rand = baseRandom(index, lastIndex),
        value = result[rand];

    result[rand] = result[index];
    result[index] = value;
  }
  result.length = n;
  return result;
}

module.exports = sample;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var getLength = __webpack_require__(221),
    isLength = __webpack_require__(72),
    keys = __webpack_require__(74);

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable properties for objects.
 *
 * @static
 * @memberOf _
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the size of `collection`.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size(collection) {
  var length = collection ? getLength(collection) : 0;
  return isLength(length) ? length : keys(collection).length;
}

module.exports = size;


/***/ }),
/* 370 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var arrayCopy = __webpack_require__(219),
    arrayEach = __webpack_require__(370),
    baseAssign = __webpack_require__(779),
    baseForOwn = __webpack_require__(374),
    initCloneArray = __webpack_require__(801),
    initCloneByTag = __webpack_require__(802),
    initCloneObject = __webpack_require__(803),
    isArray = __webpack_require__(50),
    isObject = __webpack_require__(35);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
cloneableTags[dateTag] = cloneableTags[float32Tag] =
cloneableTags[float64Tag] = cloneableTags[int8Tag] =
cloneableTags[int16Tag] = cloneableTags[int32Tag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[stringTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[mapTag] = cloneableTags[setTag] =
cloneableTags[weakMapTag] = false;

/** Used for native method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * The base implementation of `_.clone` without support for argument juggling
 * and `this` binding `customizer` functions.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {Function} [customizer] The function to customize cloning values.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The object `value` belongs to.
 * @param {Array} [stackA=[]] Tracks traversed source objects.
 * @param {Array} [stackB=[]] Associates clones with source counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return arrayCopy(value, result);
    }
  } else {
    var tag = objToString.call(value),
        isFunc = tag == funcTag;

    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return baseAssign(result, value);
      }
    } else {
      return cloneableTags[tag]
        ? initCloneByTag(value, tag, isDeep)
        : (object ? value : {});
    }
  }
  // Check for circular references and return its corresponding clone.
  stackA || (stackA = []);
  stackB || (stackB = []);

  var length = stackA.length;
  while (length--) {
    if (stackA[length] == value) {
      return stackB[length];
    }
  }
  // Add the source value to the stack of traversed objects and associate it with its clone.
  stackA.push(value);
  stackB.push(result);

  // Recursively populate clone (susceptible to call stack limits).
  (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
    result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 372 */
/***/ (function(module, exports) {

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property names to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @returns {Object} Returns `object`.
 */
function baseCopy(source, props, object) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];
    object[key] = source[key];
  }
  return object;
}

module.exports = baseCopy;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(795);

/**
 * The base implementation of `baseForIn` and `baseForOwn` which iterates
 * over `object` properties returned by `keysFunc` invoking `iteratee` for
 * each property. Iteratee functions may exit iteration early by explicitly
 * returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(373),
    keys = __webpack_require__(74);

/**
 * The base implementation of `_.forOwn` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var toObject = __webpack_require__(73);

/**
 * The base implementation of `get` without support for string paths
 * and default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path of the property to get.
 * @param {string} [pathKey] The key representation of path.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path, pathKey) {
  if (object == null) {
    return;
  }
  if (pathKey !== undefined && pathKey in toObject(object)) {
    path = [pathKey];
  }
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[path[index++]];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(782),
    isObject = __webpack_require__(35),
    isObjectLike = __webpack_require__(49);

/**
 * The base implementation of `_.isEqual` without support for `this` binding
 * `customizer` functions.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparing values.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA] Tracks traversed `value` objects.
 * @param {Array} [stackB] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
}

module.exports = baseIsEqual;


/***/ }),
/* 377 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var isNative = __webpack_require__(807);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(50),
    toObject = __webpack_require__(73);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  var type = typeof value;
  if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
    return true;
  }
  if (isArray(value)) {
    return false;
  }
  var result = !reIsDeepProp.test(value);
  return result || (object != null && value in toObject(object));
}

module.exports = isKey;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(35);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(791),
    isArray = __webpack_require__(50);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `value` to property path array if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Array} Returns the property path array.
 */
function toPath(value) {
  if (isArray(value)) {
    return value;
  }
  var result = [];
  baseToString(value).replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
}

module.exports = toPath;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var isObjectLike = __webpack_require__(49);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/** Used for native method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
}

module.exports = isBoolean;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(35);

/** `Object#toString` result references. */
var funcTag = '[object Function]';

/** Used for native method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 which returns 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

module.exports = isFunction;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var createObjectMapper = __webpack_require__(796);

/**
 * Creates an object with the same keys as `object` and values generated by
 * running each own enumerable property of `object` through `iteratee`. The
 * iteratee function is bound to `thisArg` and invoked with three arguments:
 * (value, key, object).
 *
 * If a property name is provided for `iteratee` the created `_.property`
 * style callback returns the property value of the given element.
 *
 * If a value is also provided for `thisArg` the created `_.matchesProperty`
 * style callback returns `true` for elements that have a matching property
 * value, else `false`.
 *
 * If an object is provided for `iteratee` the created `_.matches` style
 * callback returns `true` for elements that have the properties of the given
 * object, else `false`.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function|Object|string} [iteratee=_.identity] The function invoked
 *  per iteration.
 * @param {*} [thisArg] The `this` binding of `iteratee`.
 * @returns {Object} Returns the new mapped object.
 * @example
 *
 * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
 *   return n * 3;
 * });
 * // => { 'a': 3, 'b': 6 }
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * // using the `_.property` callback shorthand
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
var mapValues = createObjectMapper();

module.exports = mapValues;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(792),
    keys = __webpack_require__(74);

/**
 * Creates an array of the own enumerable property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 386 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument provided to it.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.identity(object) === object;
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _StyleSheet = __webpack_require__(226);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _PluginsRegistry = __webpack_require__(826);

var _PluginsRegistry2 = _interopRequireDefault(_PluginsRegistry);

var _rules = __webpack_require__(827);

var _rules2 = _interopRequireDefault(_rules);

var _sheets = __webpack_require__(228);

var _sheets2 = _interopRequireDefault(_sheets);

var _createGenerateClassName = __webpack_require__(397);

var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);

var _createRule2 = __webpack_require__(398);

var _createRule3 = _interopRequireDefault(_createRule2);

var _findRenderer = __webpack_require__(831);

var _findRenderer2 = _interopRequireDefault(_findRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Jss = function () {
  function Jss(options) {
    _classCallCheck(this, Jss);

    this.version = "8.1.0";
    this.plugins = new _PluginsRegistry2['default']();

    // eslint-disable-next-line prefer-spread
    this.use.apply(this, _rules2['default']);
    this.setup(options);
  }

  _createClass(Jss, [{
    key: 'setup',
    value: function setup() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var createGenerateClassName = options.createGenerateClassName || _createGenerateClassName2['default'];
      this.generateClassName = createGenerateClassName();
      this.options = _extends({}, options, {
        createGenerateClassName: createGenerateClassName,
        Renderer: (0, _findRenderer2['default'])(options)
        // eslint-disable-next-line prefer-spread
      });if (options.plugins) this.use.apply(this, options.plugins);
      return this;
    }

    /**
     * Create a Style Sheet.
     */

  }, {
    key: 'createStyleSheet',
    value: function createStyleSheet(styles) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var index = options.index;
      if (typeof index !== 'number') {
        index = _sheets2['default'].index === 0 ? 0 : _sheets2['default'].index + 1;
      }
      var sheet = new _StyleSheet2['default'](styles, _extends({}, options, {
        jss: this,
        generateClassName: options.generateClassName || this.generateClassName,
        insertionPoint: this.options.insertionPoint,
        Renderer: this.options.Renderer,
        index: index
      }));
      this.plugins.onProcessSheet(sheet);
      return sheet;
    }

    /**
     * Detach the Style Sheet and remove it from the registry.
     */

  }, {
    key: 'removeStyleSheet',
    value: function removeStyleSheet(sheet) {
      sheet.detach();
      _sheets2['default'].remove(sheet);
      return this;
    }

    /**
     * Create a rule without a Style Sheet.
     */

  }, {
    key: 'createRule',
    value: function createRule(name) {
      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // Enable rule without name for inline styles.
      if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
        options = style;
        style = name;
        name = undefined;
      }

      // Cast from RuleFactoryOptions to RuleOptions
      // https://stackoverflow.com/questions/41328728/force-casting-in-flow
      var ruleOptions = options;

      ruleOptions.jss = this;
      ruleOptions.Renderer = this.options.Renderer;
      if (!ruleOptions.generateClassName) ruleOptions.generateClassName = this.generateClassName;
      if (!ruleOptions.classes) ruleOptions.classes = {};
      var rule = (0, _createRule3['default'])(name, style, ruleOptions);
      this.plugins.onProcessRule(rule);

      return rule;
    }

    /**
     * Register plugin. Passed function will be invoked with a rule instance.
     */

  }, {
    key: 'use',
    value: function use() {
      var _this = this;

      for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
        plugins[_key] = arguments[_key];
      }

      plugins.forEach(function (plugin) {
        return _this.plugins.use(plugin);
      });
      return this;
    }
  }]);

  return Jss;
}();

exports['default'] = Jss;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 */
var SheetsManager = function () {
  function SheetsManager() {
    _classCallCheck(this, SheetsManager);

    this.sheets = [];
    this.refs = [];
    this.keys = [];
  }

  _createClass(SheetsManager, [{
    key: 'get',
    value: function get(key) {
      var index = this.keys.indexOf(key);
      return this.sheets[index];
    }
  }, {
    key: 'add',
    value: function add(key, sheet) {
      var sheets = this.sheets,
          refs = this.refs,
          keys = this.keys;

      var index = sheets.indexOf(sheet);

      if (index !== -1) return index;

      sheets.push(sheet);
      refs.push(0);
      keys.push(key);

      return sheets.length - 1;
    }
  }, {
    key: 'manage',
    value: function manage(key) {
      var index = this.keys.indexOf(key);
      var sheet = this.sheets[index];
      if (this.refs[index] === 0) sheet.attach();
      this.refs[index]++;
      if (!this.keys[index]) this.keys.splice(index, 0, key);
      return sheet;
    }
  }, {
    key: 'unmanage',
    value: function unmanage(key) {
      var index = this.keys.indexOf(key);
      if (index === -1) {
        // eslint-ignore-next-line no-console
        (0, _warning2['default'])('SheetsManager: can\'t find sheet to unmanage');
        return;
      }
      if (this.refs[index] > 0) {
        this.refs[index]--;
        if (this.refs[index] === 0) this.sheets[index].detach();
      }
    }
  }]);

  return SheetsManager;
}();

exports['default'] = SheetsManager;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Sheets registry to access them all at one place.
 */
var SheetsRegistry = function () {
  function SheetsRegistry() {
    _classCallCheck(this, SheetsRegistry);

    this.registry = [];
  }

  _createClass(SheetsRegistry, [{
    key: 'add',


    /**
     * Register a Style Sheet.
     */
    value: function add(sheet) {
      var registry = this.registry;
      var index = sheet.options.index;


      if (registry.indexOf(sheet) !== -1) return;

      if (registry.length === 0 || index >= this.index) {
        registry.push(sheet);
        return;
      }

      // Find a position.
      for (var i = 0; i < registry.length; i++) {
        if (registry[i].options.index > index) {
          registry.splice(i, 0, sheet);
          return;
        }
      }
    }

    /**
     * Reset the registry.
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.registry = [];
    }

    /**
     * Remove a Style Sheet.
     */

  }, {
    key: 'remove',
    value: function remove(sheet) {
      var index = this.registry.indexOf(sheet);
      this.registry.splice(index, 1);
    }

    /**
     * Convert all attached sheets to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      return this.registry.filter(function (sheet) {
        return sheet.attached;
      }).map(function (sheet) {
        return sheet.toString(options);
      }).join('\n');
    }
  }, {
    key: 'index',


    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

exports['default'] = SheetsRegistry;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.sheets = exports.RuleList = exports.SheetsManager = exports.SheetsRegistry = exports.getDynamicStyles = undefined;

var _getDynamicStyles = __webpack_require__(832);

Object.defineProperty(exports, 'getDynamicStyles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getDynamicStyles)['default'];
  }
});

var _SheetsRegistry = __webpack_require__(389);

Object.defineProperty(exports, 'SheetsRegistry', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsRegistry)['default'];
  }
});

var _SheetsManager = __webpack_require__(388);

Object.defineProperty(exports, 'SheetsManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsManager)['default'];
  }
});

var _RuleList = __webpack_require__(150);

Object.defineProperty(exports, 'RuleList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RuleList)['default'];
  }
});

var _sheets = __webpack_require__(228);

Object.defineProperty(exports, 'sheets', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sheets)['default'];
  }
});

var _Jss = __webpack_require__(387);

var _Jss2 = _interopRequireDefault(_Jss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Creates a new instance of Jss.
 */
var create = exports.create = function create(options) {
  return new _Jss2['default'](options);
};

/**
 * A global Jss instance.
 */
exports['default'] = create();

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(150);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Conditional rule for @media, @supports
 */
var ConditionalRule = function () {
  function ConditionalRule(key, styles, options) {
    _classCallCheck(this, ConditionalRule);

    this.type = 'conditional';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(ConditionalRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      return inner ? this.key + ' {\n' + inner + '\n}' : '';
    }
  }]);

  return ConditionalRule;
}();

exports['default'] = ConditionalRule;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(229);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FontFaceRule = function () {
  function FontFaceRule(key, style, options) {
    _classCallCheck(this, FontFaceRule);

    this.type = 'font-face';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(FontFaceRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.style)) {
        var str = '';
        for (var index = 0; index < this.style.length; index++) {
          str += (0, _toCss2['default'])(this.key, this.style[index]);
          if (this.style[index + 1]) str += '\n';
        }
        return str;
      }

      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return FontFaceRule;
}();

exports['default'] = FontFaceRule;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(150);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Rule for @keyframes
 */
var KeyframesRule = function () {
  function KeyframesRule(key, frames, options) {
    _classCallCheck(this, KeyframesRule);

    this.type = 'keyframes';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends({}, this.options, {
        parent: this,
        selector: name
      }));
    }

    this.rules.process();
  }

  /**
   * Generates a CSS string.
   */


  _createClass(KeyframesRule, [{
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      if (inner) inner += '\n';
      return this.key + ' {\n' + inner + '}';
    }
  }]);

  return KeyframesRule;
}();

exports['default'] = KeyframesRule;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SimpleRule = function () {
  function SimpleRule(key, value, options) {
    _classCallCheck(this, SimpleRule);

    this.type = 'simple';
    this.isProcessed = false;

    this.key = key;
    this.value = value;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  _createClass(SimpleRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.value)) {
        var str = '';
        for (var index = 0; index < this.value.length; index++) {
          str += this.key + ' ' + this.value[index] + ';';
          if (this.value[index + 1]) str += '\n';
        }
        return str;
      }

      return this.key + ' ' + this.value + ';';
    }
  }]);

  return SimpleRule;
}();

exports['default'] = SimpleRule;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(229);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ViewportRule = function () {
  function ViewportRule(key, style, options) {
    _classCallCheck(this, ViewportRule);

    this.type = 'viewport';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(ViewportRule, [{
    key: 'toString',
    value: function toString(options) {
      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return ViewportRule;
}();

exports['default'] = ViewportRule;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Jss = __webpack_require__(387);

var _Jss2 = _interopRequireDefault(_Jss);

var _StyleSheet = __webpack_require__(226);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _ConditionalRule = __webpack_require__(391);

var _ConditionalRule2 = _interopRequireDefault(_ConditionalRule);

var _KeyframesRule = __webpack_require__(393);

var _KeyframesRule2 = _interopRequireDefault(_KeyframesRule);

var _StyleRule = __webpack_require__(227);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _ViewportRule = __webpack_require__(395);

var _ViewportRule2 = _interopRequireDefault(_ViewportRule);

var _SimpleRule = __webpack_require__(394);

var _SimpleRule2 = _interopRequireDefault(_SimpleRule);

var _FontFaceRule = __webpack_require__(392);

var _FontFaceRule2 = _interopRequireDefault(_FontFaceRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});


var globalRef = typeof window === 'undefined' ? global : window;

var namespace = '__JSS_VERSION_COUNTER__';
if (globalRef[namespace] == null) globalRef[namespace] = 0;
// In case we have more than one JSS version.
var jssCounter = globalRef[namespace]++;

/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

exports['default'] = function () {
  var ruleCounter = 0;

  return function (rule) {
    return rule.key + '-' + jssCounter + '-' + ruleCounter++;
  };
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = createRule;

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

var _StyleRule = __webpack_require__(227);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _cloneStyle = __webpack_require__(830);

var _cloneStyle2 = _interopRequireDefault(_cloneStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Create a rule instance.
 */
function createRule() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unnamed';
  var decl = arguments[1];
  var options = arguments[2];
  var jss = options.jss;

  var declCopy = (0, _cloneStyle2['default'])(decl);

  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule;

  // It is an at-rule and it has no instance.
  if (name[0] === '@') {
    (0, _warning2['default'])(false, '[JSS] Unknown at-rule %s', name);
  }

  return new _StyleRule2['default'](name, declCopy, options);
}

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = linkRule;
/**
 * Link rule with CSSStyleRule and nested rules with corresponding nested cssRules if both exists.
 */
function linkRule(rule, cssRule) {
  rule.renderable = cssRule;
  if (rule.rules && cssRule.cssRules) rule.rules.link(cssRule.cssRules);
}

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCssValue;
var joinWithSpace = function joinWithSpace(value) {
  return value.join(' ');
};

/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 */
function toCssValue(value) {
  if (!Array.isArray(value)) return value;

  // Support space separated values.
  if (Array.isArray(value[0])) {
    return toCssValue(value.map(joinWithSpace));
  }

  return value.join(', ');
}

/***/ }),
/* 401 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

exports = module.exports = function(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}


/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(403);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(835);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 404 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ButtonBase = __webpack_require__(845);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ButtonBase).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _ref;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(11);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      padding: theme.spacing.unit * 2,
      '&:last-child': {
        paddingBottom: theme.spacing.unit * 3
      }
    }
  };
};

var babelPluginFlowReactPropTypes_proptype_Props = {
  classes: __webpack_require__(0).object,
  className: __webpack_require__(0).string
};


function CardContent(props) {
  var classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className']);


  return _react2.default.createElement('div', (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other));
}

CardContent.propTypes =  false ? (_ref = {
  classes: require('prop-types').object.isRequired
}, (0, _defineProperty3.default)(_ref, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref, 'className', require('prop-types').string), _ref) : {};
exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCardContent' })(CardContent);

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(463);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(53);

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

var _createBreakpoints = __webpack_require__(59);

var _withWidth = __webpack_require__(897);

var _withWidth2 = _interopRequireDefault(_withWidth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_HiddenProps = __webpack_require__(230).babelPluginFlowReactPropTypes_proptype_HiddenProps || __webpack_require__(0).any;

var babelPluginFlowReactPropTypes_proptype_Props = (0, _extends3.default)({}, babelPluginFlowReactPropTypes_proptype_HiddenProps === __webpack_require__(0).any ? {} : babelPluginFlowReactPropTypes_proptype_HiddenProps, {
  width: __webpack_require__(0).string.isRequired
});


/**
 * @ignore - internal component.
 */
function HiddenJs(props) {
  var children = props.children,
      only = props.only,
      xsUp = props.xsUp,
      smUp = props.smUp,
      mdUp = props.mdUp,
      lgUp = props.lgUp,
      xlUp = props.xlUp,
      xsDown = props.xsDown,
      smDown = props.smDown,
      mdDown = props.mdDown,
      lgDown = props.lgDown,
      xlDown = props.xlDown,
      width = props.width,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'only', 'xsUp', 'smUp', 'mdUp', 'lgUp', 'xlUp', 'xsDown', 'smDown', 'mdDown', 'lgDown', 'xlDown', 'width']);


   false ? (0, _warning2.default)((0, _keys2.default)(other).length === 0, 'Material-UI: unsupported properties received ' + (0, _stringify2.default)(other) + ' by `<Hidden />`.') : void 0;

  var visible = true;

  // `only` check is faster to get out sooner if used.
  if (only) {
    if (Array.isArray(only)) {
      for (var i = 0; i < only.length; i += 1) {
        var breakpoint = only[i];
        if (width === breakpoint) {
          visible = false;
          break;
        }
      }
    } else if (only && width === only) {
      visible = false;
    }
  }

  // Allow `only` to be combined with other props. If already hidden, no need to check others.
  if (visible) {
    // determine visibility based on the smallest size up
    for (var _i = 0; _i < _createBreakpoints.keys.length; _i += 1) {
      var _breakpoint = _createBreakpoints.keys[_i];
      var breakpointUp = props[_breakpoint + 'Up'];
      var breakpointDown = props[_breakpoint + 'Down'];
      if (breakpointUp && (0, _withWidth.isWidthUp)(_breakpoint, width) || breakpointDown && (0, _withWidth.isWidthDown)(_breakpoint, width)) {
        visible = false;
        break;
      }
    }
  }

  if (!visible) {
    return null;
  }

  return children;
}

exports.default = (0, _withWidth2.default)()(HiddenJs);

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = __webpack_require__(861);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Icon).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Paper = __webpack_require__(872);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Paper).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertColorToString = convertColorToString;
exports.convertHexToRGB = convertHexToRGB;
exports.decomposeColor = decomposeColor;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.emphasize = emphasize;
exports.fade = fade;
exports.darken = darken;
exports.lighten = lighten;
//  weak
/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value, min, max) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of, 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
function convertColorToString(color) {
  var type = color.type,
      values = color.values;


  if (type.indexOf('rgb') > -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    for (var i = 0; i < 3; i += 1) {
      values[i] = parseInt(values[i], 10);
    }
  }

  var colorString = void 0;

  if (type.indexOf('hsl') > -1) {
    colorString = color.type + '(' + values[0] + ', ' + values[1] + '%, ' + values[2] + '%';
  } else {
    colorString = color.type + '(' + values[0] + ', ' + values[1] + ', ' + values[2];
  }

  if (values.length === 4) {
    colorString += ', ' + color.values[3] + ')';
  } else {
    colorString += ')';
  }

  return colorString;
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 *  @returns {string} A CSS rgb color string
 */
function convertHexToRGB(color) {
  if (color.length === 4) {
    var extendedColor = '#';
    for (var i = 1; i < color.length; i += 1) {
      extendedColor += color.charAt(i) + color.charAt(i);
    }
    color = extendedColor;
  }

  var values = {
    r: parseInt(color.substr(1, 2), 16),
    g: parseInt(color.substr(3, 2), 16),
    b: parseInt(color.substr(5, 2), 16)
  };

  return 'rgb(' + values.r + ', ' + values.g + ', ' + values.b + ')';
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {{type: string, values: number[]}} A MUI color object
 */
function decomposeColor(color) {
  if (color.charAt(0) === '#') {
    return decomposeColor(convertHexToRGB(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });

  return { type: type, values: values };
}

/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21 with 2 digit precision.
 */
function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  var contrastRatio = (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);

  return Number(contrastRatio.toFixed(2)); // Truncate at two digits
}

/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/WAI/GL/wiki/Relative_luminance
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */
function getLuminance(color) {
  var decomposedColor = decomposeColor(color);

  if (decomposedColor.type.indexOf('rgb') > -1) {
    var rgb = decomposedColor.values.map(function (val) {
      val /= 255; // normalized
      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
  } else if (decomposedColor.type.indexOf('hsl') > -1) {
    return decomposedColor.values[2] / 100;
  }

  throw new Error('Material-UI: unsupported `' + color + '` color.');
}

/**
 * Darken or lighten a colour, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;

  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}

/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function fade(color, value) {
  color = decomposeColor(color);
  value = clamp(value, 0, 1);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  color.values[3] = value;

  return convertColorToString(color);
}

/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient, 0, 1);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return convertColorToString(color);
}

/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient, 0, 1);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return convertColorToString(color);
}

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _deepmerge = __webpack_require__(142);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _createTypography = __webpack_require__(884);

var _createTypography2 = _interopRequireDefault(_createTypography);

var _createBreakpoints = __webpack_require__(59);

var _createBreakpoints2 = _interopRequireDefault(_createBreakpoints);

var _createPalette = __webpack_require__(883);

var _createPalette2 = _interopRequireDefault(_createPalette);

var _createMixins = __webpack_require__(882);

var _createMixins2 = _interopRequireDefault(_createMixins);

var _shadows = __webpack_require__(886);

var _shadows2 = _interopRequireDefault(_shadows);

var _transitions = __webpack_require__(888);

var _transitions2 = _interopRequireDefault(_transitions);

var _zIndex = __webpack_require__(890);

var _zIndex2 = _interopRequireDefault(_zIndex);

var _spacing = __webpack_require__(887);

var _spacing2 = _interopRequireDefault(_spacing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// < 1kb payload overhead when lodash/merge is > 3kb.
function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$palette = options.palette,
      paletteInput = _options$palette === undefined ? {} : _options$palette,
      _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === undefined ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === undefined ? {} : _options$mixins,
      _options$typography = options.typography,
      typographyInput = _options$typography === undefined ? {} : _options$typography,
      other = (0, _objectWithoutProperties3.default)(options, ['palette', 'breakpoints', 'mixins', 'typography']);


  var palette = (0, _createPalette2.default)(paletteInput);
  var breakpoints = (0, _createBreakpoints2.default)(breakpointsInput);

  return (0, _extends3.default)({
    direction: 'ltr',
    palette: palette,
    typography: (0, _createTypography2.default)(palette, typographyInput),
    mixins: (0, _createMixins2.default)(breakpoints, _spacing2.default, mixinsInput),
    breakpoints: breakpoints
  }, (0, _deepmerge2.default)({
    shadows: _shadows2.default,
    transitions: _transitions2.default,
    spacing: _spacing2.default,
    zIndex: _zIndex2.default
  }, other, {
    clone: true // We don't want to mutate the input
  }));
}

exports.default = createMuiTheme;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHANNEL = undefined;

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CHANNEL = exports.CHANNEL = 'material-ui';

var themeListener = {
  contextTypes: (0, _defineProperty3.default)({}, CHANNEL, _propTypes2.default.object),
  initial: function initial(context) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].getState();
  },
  subscribe: function subscribe(context, cb) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].subscribe(cb);
  },
  unsubscribe: function unsubscribe(context, subscriptionId) {
    if (context[CHANNEL]) {
      context[CHANNEL].unsubscribe(subscriptionId);
    }
  }
};

exports.default = themeListener;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(451);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('not a function');
  }
  this._45 = 0;
  this._81 = 0;
  this._65 = null;
  this._54 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._10 = null;
Promise._97 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
};
function handle(self, deferred) {
  while (self._81 === 3) {
    self = self._65;
  }
  if (Promise._10) {
    Promise._10(self);
  }
  if (self._81 === 0) {
    if (self._45 === 0) {
      self._45 = 1;
      self._54 = deferred;
      return;
    }
    if (self._45 === 1) {
      self._45 = 2;
      self._54 = [self._54, deferred];
      return;
    }
    self._54.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._81 === 1) {
        resolve(deferred.promise, self._65);
      } else {
        reject(deferred.promise, self._65);
      }
      return;
    }
    var ret = tryCallOne(cb, self._65);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._81 = 3;
      self._65 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._81 = 1;
  self._65 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._81 = 2;
  self._65 = newValue;
  if (Promise._97) {
    Promise._97(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._45 === 1) {
    handle(self, self._54);
    self._54 = null;
  }
  if (self._45 === 2) {
    for (var i = 0; i < self._54.length; i++) {
      handle(self, self._54[i]);
    }
    self._54 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  })
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(904);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(75);

var invariant = __webpack_require__(3);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(92);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactInstrumentation = __webpack_require__(36);

var quoteAttributeValueForBrowser = __webpack_require__(966);
var warning = __webpack_require__(6);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(12);

var LinkedValueUtils = __webpack_require__(240);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactUpdates = __webpack_require__(46);

var warning = __webpack_require__(6);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(3);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMSelection = __webpack_require__(926);

var containsNode = __webpack_require__(717);
var focusNode = __webpack_require__(337);
var getActiveElement = __webpack_require__(338);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var DOMLazyTree = __webpack_require__(91);
var DOMProperty = __webpack_require__(92);
var React = __webpack_require__(94);
var ReactBrowserEventEmitter = __webpack_require__(151);
var ReactCurrentOwner = __webpack_require__(52);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactDOMContainerInfo = __webpack_require__(920);
var ReactDOMFeatureFlags = __webpack_require__(922);
var ReactFeatureFlags = __webpack_require__(422);
var ReactInstanceMap = __webpack_require__(120);
var ReactInstrumentation = __webpack_require__(36);
var ReactMarkupChecksum = __webpack_require__(936);
var ReactReconciler = __webpack_require__(93);
var ReactUpdateQueue = __webpack_require__(243);
var ReactUpdates = __webpack_require__(46);

var emptyObject = __webpack_require__(143);
var instantiateReactComponent = __webpack_require__(433);
var invariant = __webpack_require__(3);
var setInnerHTML = __webpack_require__(155);
var shouldUpdateReactComponent = __webpack_require__(249);
var warning = __webpack_require__(6);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var React = __webpack_require__(94);

var invariant = __webpack_require__(3);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(3);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactNodeTypes = __webpack_require__(426);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(23);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(14);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  delete inst._wrapperState.valueTracker;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(12);

var ReactCompositeComponent = __webpack_require__(917);
var ReactEmptyComponent = __webpack_require__(421);
var ReactHostComponent = __webpack_require__(423);

var getNextDebugID = __webpack_require__(992);
var invariant = __webpack_require__(3);
var warning = __webpack_require__(6);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(23);
var escapeTextContentForBrowser = __webpack_require__(154);
var setInnerHTML = __webpack_require__(155);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var ReactCurrentOwner = __webpack_require__(52);
var REACT_ELEMENT_TYPE = __webpack_require__(932);

var getIteratorFn = __webpack_require__(963);
var invariant = __webpack_require__(3);
var KeyEscapeUtils = __webpack_require__(239);
var warning = __webpack_require__(6);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDynamicStyles = exports.SheetsRegistry = exports.SheetsManager = exports.createGenerateClassNameDefault = undefined;

var _createGenerateClassName = __webpack_require__(397);

Object.defineProperty(exports, 'createGenerateClassNameDefault', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createGenerateClassName)['default'];
  }
});

var _SheetsManager = __webpack_require__(388);

Object.defineProperty(exports, 'SheetsManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsManager)['default'];
  }
});

var _jss = __webpack_require__(390);

Object.defineProperty(exports, 'SheetsRegistry', {
  enumerable: true,
  get: function get() {
    return _jss.SheetsRegistry;
  }
});
Object.defineProperty(exports, 'getDynamicStyles', {
  enumerable: true,
  get: function get() {
    return _jss.getDynamicStyles;
  }
});

var _jssPresetDefault = __webpack_require__(823);

var _jssPresetDefault2 = _interopRequireDefault(_jssPresetDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = (0, _jss.create)((0, _jssPresetDefault2['default'])());

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Namespaces to avoid conflicts on the context.
 */
var jss = exports.jss = '64a55d578f856d258dc345b094a2a2b3';
var sheetsRegistry = exports.sheetsRegistry = 'd4bd0baacbc52bbd48bbb9eb24344ecd';
var providerId = exports.providerId = 'd9f144a51454eae08eb84ab3ade674a5';
var sheetOptions = exports.sheetOptions = '6fc570d6bd61383819d0f9e7407c452d';

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stripDiacritics = __webpack_require__(441);

var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function filterOptions(options, filterValue, excludeOptions, props) {
	var _this = this;

	if (props.ignoreAccents) {
		filterValue = (0, _stripDiacritics2.default)(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(_this, option, filterValue);
		if (!filterValue) return true;
		var valueTest = String(option[props.valueKey]);
		var labelTest = String(option[props.labelKey]);
		if (props.ignoreAccents) {
			if (props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
			if (props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
		}
		if (props.ignoreCase) {
			if (props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}
		return props.matchPos === 'start' ? props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
}

module.exports = filterOptions;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    instancePrefix = _ref.instancePrefix,
	    labelKey = _ref.labelKey,
	    onFocus = _ref.onFocus,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey,
	    onOptionRef = _ref.onOptionRef;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.indexOf(option) > -1;
		var isFocused = option === focusedOption;
		var optionClass = (0, _classnames2.default)(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return _react2.default.createElement(
			Option,
			{
				className: optionClass,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				}
			},
			optionRenderer(option, i)
		);
	});
}

module.exports = menuRenderer;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

module.exports = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(122),
    _assign = __webpack_require__(12);

var ReactNoopUpdateQueue = __webpack_require__(445);

var canDefineProperty = __webpack_require__(446);
var emptyObject = __webpack_require__(143);
var invariant = __webpack_require__(3);
var lowPriorityWarning = __webpack_require__(993);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(122);

var ReactCurrentOwner = __webpack_require__(52);

var invariant = __webpack_require__(3);
var warning = __webpack_require__(6);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(6);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

exports.default = getDisplayName;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setStatic = __webpack_require__(998);

var _setStatic2 = _interopRequireDefault(_setStatic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic2.default)('displayName', displayName);
};

exports.default = setDisplayName;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(901).enable();
  window.Promise = __webpack_require__(900);
}

// fetch() polyfill for making API calls.
__webpack_require__(1004);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(12);


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__ = __webpack_require__(455);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */],null),document.getElementById('root'));__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_scale__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_array__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Avatar__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Grid__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Paper__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_List__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_Checkbox__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_Card__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_select_2__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_select_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_select_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_select_2_dist_css_react_select_2_css__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_select_2_dist_css_react_select_2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_select_2_dist_css_react_select_2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__sven_layout__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__StorylineChart__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__data_events_json__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__data_events_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__data_events_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__data_employees_json__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__data_employees_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__data_employees_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__App_css__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__App_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* 

  BSD License:

  SVEN: Storyline Visualization Library and Demonstration

  Copyright © 2017, Battelle Memorial Institute
  All rights reserved.

  1. Battelle Memorial Institute (hereinafter Battelle) hereby grants permission
     to any person or entity lawfully obtaining a copy of this software and
     associated documentation files (hereinafter “the Software”) to redistribute
     and use the Software in source and binary forms, with or without 
     modification.  Such person or entity may use, copy, modify, merge, publish,
     distribute, sublicense, and/or sell copies of the Software, and may permit
     others to do so, subject to the following conditions:

     * Redistributions of source code must retain the above copyright notice,
       this list of conditions and the following disclaimers.
     * Redistributions in binary form must reproduce the above copyright notice,
       this list of conditions and the following disclaimer in the documentation
       and/or other materials provided with the distribution.
     * Other than as used herein, neither the name Battelle Memorial Institute
       or Battelle may be used in any form whatsoever without the express
       written consent of Battelle. 

  2. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
     AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
     THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
     PURPOSEARE DISCLAIMED. IN NO EVENT SHALL BATTELLE OR CONTRIBUTORS BE LIABLE
     FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
     DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
     SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
     CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
     LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
     OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
     DAMAGE.
     
*/var layout=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__sven_layout__["a" /* default */])().time(function(d){return d.hour;}).id(function(d){return String([d.name,d.date]);}).group(function(d){return d.activity;});var _color=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_scale__["a" /* scaleOrdinal */])(__WEBPACK_IMPORTED_MODULE_2_d3_scale__["b" /* schemeCategory10 */]);var employees=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(__WEBPACK_IMPORTED_MODULE_17__data_employees_json___default.a);var employeesByType=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])().withMutations(function(map){return employees.map(function(v,k){return map.setIn([v,k],true);});});var EmployeeList=function EmployeeList(_ref){var data=_ref.data,_onClick=_ref.onClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_List___default.a,null,data.keySeq().sort().map(function(k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_List__["ListItem"],{button:true,dense:true,key:k,onClick:function onClick(e){return _onClick(k,data.get(k),e.shiftKey);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Avatar___default.a,{style:{backgroundColor:_color(k)}},data.get(k).size),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_List__["ListItemText"],{primary:k}));}));};var asSelectList=function asSelectList(map){return map.keySeq().sort().map(function(value){return{value:value,label:value};}).toArray();};var DELIIMTER=';';var PersonSelect=function PersonSelect(_ref2){var data=_ref2.data,onChange=_ref2.onChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_select_2___default.a,{simpleValue:true,multi:true,delimiter:DELIIMTER,options:asSelectList(data.filter(function(v){return!v;})),value:asSelectList(data.filter(function(v){return v;})),onChange:onChange});};var DatesSelect=function DatesSelect(_ref3){var data=_ref3.data,onChange=_ref3.onChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dates-component noselect'},data.keySeq().sort().map(function(k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:k,onClick:function onClick(e){return onChange(k,!data.get(k),e.shiftKey);},className:'date'+(data.get(k)?' selected':'')},__WEBPACK_IMPORTED_MODULE_4_moment___default()(k).format('dd'));}));};var dates=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(__WEBPACK_IMPORTED_MODULE_16__data_events_json___default.a.map(function(d){return[d.date,false];}));var App=function(_Component){_inherits(App,_Component);function App(){var _ref4;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref4=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref4,[this].concat(args))),_this),_this.state={people:employees.map(function(){return false;}),dates:dates.set(dates.keySeq().sort().first(),true)},_this.handleEmployeeTypeClick=function(k,v,append){if(append){_this.setState({people:_this.state.people.merge(v)});}else{_this.setState({people:_this.state.people.map(function(_,k){return v.has(k);})});}},_this.handlePersonChange=function(value){var selection=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])(value.split(DELIIMTER));_this.setState({people:_this.state.people.map(function(_,k){return selection.has(k);})});},_this.handlePersonClick=function(values){var selection=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])(values.map(function(d){return d.name;}));_this.setState({people:_this.state.people.map(function(v,k){return selection.has(k);})});},_this.handleDateChage=function(k,v,append){_this.setState({dates:append?_this.state.dates.set(k,v):_this.state.dates.map(function(_,k2){return k===k2;})});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:'render',value:function render(){var _state=this.state,people=_state.people,dates=_state.dates;var nFiltered=people.valueSeq().reduce(function(v,sum){return v+sum;},0);var data=__WEBPACK_IMPORTED_MODULE_16__data_events_json___default.a.filter(function(d){return nFiltered===0||people.get(d.name);}).filter(function(d){return dates.get(d.date);});var storylines=layout(data);var ymin=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_array__["a" /* min */])(storylines.interactions,function(d){return d.y0;});var ymax=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_array__["b" /* max */])(storylines.interactions,function(d){return d.y1;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_Card___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_Card__["CardHeader"],{title:'Dates',subheader:'click to include data from one or more days'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_Card__["CardContent"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DatesSelect,{data:this.state.dates,onChange:this.handleDateChage}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_Card___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_Card__["CardHeader"],{title:'Legend',subheader:'click to add names to filter'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_Card__["CardContent"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EmployeeList,{data:employeesByType,onClick:this.handleEmployeeTypeClick}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_Card___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_Card__["CardHeader"],{title:'Filter by name',subheader:'show specific people only'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_Card__["CardContent"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PersonSelect,{data:people,onChange:this.handlePersonChange})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Grid___default.a,{item:true,xs:12,sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_Paper___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__StorylineChart__["a" /* default */],{data:storylines,height:Math.max(10*(ymax-ymin),50),color:function color(d){return _color(__WEBPACK_IMPORTED_MODULE_17__data_employees_json___default.a[d.values[0].data.name]);},lineLabel:function lineLabel(d){return d.values[0].data.name;},lineTitle:function lineTitle(d){return __WEBPACK_IMPORTED_MODULE_4_moment___default()(d.values[0].data.date).format('MMM D YYYY');},groupLabel:function groupLabel(d){return d.activity;},onClick:this.handlePersonClick}))));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(634);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* 

  BSD License:

  SVEN: Storyline Visualization Library and Demonstration

  Copyright © 2017, Battelle Memorial Institute
  All rights reserved.

  1. Battelle Memorial Institute (hereinafter Battelle) hereby grants permission
     to any person or entity lawfully obtaining a copy of this software and
     associated documentation files (hereinafter “the Software”) to redistribute
     and use the Software in source and binary forms, with or without 
     modification.  Such person or entity may use, copy, modify, merge, publish,
     distribute, sublicense, and/or sell copies of the Software, and may permit
     others to do so, subject to the following conditions:

     * Redistributions of source code must retain the above copyright notice,
       this list of conditions and the following disclaimers.
     * Redistributions in binary form must reproduce the above copyright notice,
       this list of conditions and the following disclaimer in the documentation
       and/or other materials provided with the distribution.
     * Other than as used herein, neither the name Battelle Memorial Institute
       or Battelle may be used in any form whatsoever without the express
       written consent of Battelle. 

  2. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
     AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
     THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
     PURPOSEARE DISCLAIMED. IN NO EVENT SHALL BATTELLE OR CONTRIBUTORS BE LIABLE
     FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
     DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
     SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
     CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
     LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
     OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
     DAMAGE.
     
*/var setupLayers=function setupLayers(selection){var layers=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var state=arguments[2];var g=selection.selectAll('g.layer').data(layers,function(d){return d.name;});g.enter().append('g').attr('class',function(d){return'layer '+d.name;}).merge(g).each(function(d){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["a" /* select */])(this).call(d.callback,state);});g.exit().remove();};var noInit=function noInit(){return null;};var ChartComponent=function(_React$Component){_inherits(ChartComponent,_React$Component);function ChartComponent(){_classCallCheck(this,ChartComponent);return _possibleConstructorReturn(this,(ChartComponent.__proto__||Object.getPrototypeOf(ChartComponent)).apply(this,arguments));}_createClass(ChartComponent,[{key:'componentDidMount',value:function componentDidMount(){this.componentDidUpdate();}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props=this.props,_props$margin=_props.margin,margin=_props$margin===undefined?{}:_props$margin,_props$init=_props.init,init=_props$init===undefined?noInit:_props$init;var _margin$top=margin.top,top=_margin$top===undefined?0:_margin$top,_margin$left=margin.left,left=_margin$left===undefined?0:_margin$left,_margin$bottom=margin.bottom,bottom=_margin$bottom===undefined?0:_margin$bottom,_margin$right=margin.right,right=_margin$right===undefined?0:_margin$right;var _svg$getBoundingClien=this.svg.getBoundingClientRect(),width=_svg$getBoundingClien.width,height=_svg$getBoundingClien.height;width=width-left-right;height=height-top-bottom;var props=Object.assign({},this.props,{width:width,height:height});var state=Object.assign({},props,init(props));if(width&&height){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_selection__["a" /* select */])(this.svg).select('g.chart').attr('transform','translate('+[left,height+top]+')').call(setupLayers,state.layers,state);}}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,width=_props2.width,height=_props2.height,className=_props2.className,style=_props2.style;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:width,height:height,className:className,style:style,ref:function ref(svg){_this2.svg=svg;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{className:'chart'}));}}]);return ChartComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);ChartComponent.displayName='ChartComponent';// Uncomment properties you need
// ChartComponent.propTypes = {};
// ChartComponent.defaultProps = {};
/* harmony default export */ __webpack_exports__["a"] = (ChartComponent);

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReactD3Chart__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Storyline_css__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Storyline_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Storyline_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_scale__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3_array__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_d3_shape__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_d3_axis__ = __webpack_require__(585);
/* 

  BSD License:

  SVEN: Storyline Visualization Library and Demonstration

  Copyright © 2017, Battelle Memorial Institute
  All rights reserved.

  1. Battelle Memorial Institute (hereinafter Battelle) hereby grants permission
     to any person or entity lawfully obtaining a copy of this software and
     associated documentation files (hereinafter “the Software”) to redistribute
     and use the Software in source and binary forms, with or without 
     modification.  Such person or entity may use, copy, modify, merge, publish,
     distribute, sublicense, and/or sell copies of the Software, and may permit
     others to do so, subject to the following conditions:

     * Redistributions of source code must retain the above copyright notice,
       this list of conditions and the following disclaimers.
     * Redistributions in binary form must reproduce the above copyright notice,
       this list of conditions and the following disclaimer in the documentation
       and/or other materials provided with the distribution.
     * Other than as used herein, neither the name Battelle Memorial Institute
       or Battelle may be used in any form whatsoever without the express
       written consent of Battelle. 

  2. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
     AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
     THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
     PURPOSEARE DISCLAIMED. IN NO EVENT SHALL BATTELLE OR CONTRIBUTORS BE LIABLE
     FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
     DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
     SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
     CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
     LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
     OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
     DAMAGE.
     
*/var storylinesInit=function storylinesInit(_ref){var _ref$data=_ref.data,data=_ref$data===undefined?{}:_ref$data,width=_ref.width,height=_ref.height,groupLabel=_ref.groupLabel;var _data$interactions=data.interactions,interactions=_data$interactions===undefined?[]:_data$interactions,_data$events=data.events,events=_data$events===undefined?[]:_data$events;if(interactions.length===0){return{layers:[]};}else{var xAxisData=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])(events.map(function(d){return+d.x;})).sort().toArray();var padding=width/xAxisData.length/3;var x=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_scale__["c" /* scaleLinear */])().domain([xAxisData[0]||0,xAxisData[xAxisData.length-1]||1]).range([padding,width-padding]);var ymax=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_d3_array__["b" /* max */])(interactions,function(d){return d.y1;});var ymin=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_d3_array__["a" /* min */])(interactions,function(d){return d.y0;});var actualHeight=Math.min(height,(ymax-ymin)*20);var y=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_scale__["c" /* scaleLinear */])().domain([ymin,ymax]).range([actualHeight-height,-height]);var yAxisData=interactions.map(function(_ref2){var values=_ref2.values,y0=_ref2.y0,y1=_ref2.y1;return{group:groupLabel&&groupLabel(values[0].values[0].data),values:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_d3_array__["c" /* merge */])(values.map(function(d){return d.values.map(function(d){return d.data;});})),y:(y0+y1)/2,y0:y0,y1:y1};});return{x:x,y:y,xAxisData:xAxisData,yAxisData:yAxisData,padding:padding};}};var storylineLayers=[{name:'groups',callback:function callback(selection,_ref3){var yAxisData=_ref3.yAxisData,width=_ref3.width,y=_ref3.y,_ref3$onClick=_ref3.onClick,onClick=_ref3$onClick===undefined?Object:_ref3$onClick;var groups=selection.selectAll('rect').data(yAxisData,function(d){return d.group;});groups.enter().append('rect').on('click',function(d){return onClick(d.values);}).merge(groups).attr('x',0).attr('width',width).attr('y',function(d){return y(d.y1);}).attr('height',function(d){return Math.abs(y(d.y1)-y(d.y0));});groups.exit().remove();var labels=selection.selectAll('text').data(yAxisData,function(d){return d.group;});labels.enter().append('text').merge(labels).attr('x',0).attr('y',function(d){return y(d.y1);}).text(function(d){return d.group;});labels.exit().remove();}},{name:'storylines',callback:function callback(selection,_ref4){var data=_ref4.data,x=_ref4.x,y=_ref4.y,color=_ref4.color,padding=_ref4.padding,highlights=_ref4.highlights,_ref4$onClick=_ref4.onClick,onClick=_ref4$onClick===undefined?Object:_ref4$onClick,lineLabel=_ref4.lineLabel,lineTitle=_ref4.lineTitle;var storyline=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_d3_shape__["a" /* line */])().curve(__WEBPACK_IMPORTED_MODULE_6_d3_shape__["b" /* curveMonotoneX */]);function getPoints(d){var points=[];d.values.forEach(function(d){points.push([x(d.x)-padding,y(d.y)]);points.push([x(d.x)+padding,y(d.y)]);});return points;}var paths=selection.selectAll('g').data(data.storylines,function(d){return d.key;});var paths_enter=paths.enter().append('g').on('click',function(d){return onClick(d.values.map(function(d){return d.data;}));});paths_enter.append('path');paths_enter.append('text');paths_enter.append('title');var paths_merge=paths_enter.merge(paths).classed('highlighted',function(d){return highlights&&highlights.has(d.key);});paths_merge.select('title').text(lineTitle);paths_merge.select('path').style('stroke',function(d){return color&&color(d);}).attr('d',function(d){return storyline(getPoints(d));});paths_merge.select('text').style('fill',function(d){return color&&color(d);}).text(function(d){return lineLabel?lineLabel(d):d.key;}).attr('x',function(d){return x(d.values[d.values.length-1].x)+padding;}).attr('y',function(d){return y(d.values[d.values.length-1].y);});paths.exit().remove();}},{name:'x-axis',callback:function callback(selection,_ref5){var data=_ref5.data,x=_ref5.x;selection.call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_d3_axis__["a" /* axisBottom */])(x));}}];var StorylineChart=function StorylineChart(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ReactD3Chart__["a" /* default */],Object.assign({init:storylinesInit,layers:storylineLayers},props,{margin:{top:30,right:135,bottom:25,left:20},className:'storylines-chart'}));};/* harmony default export */ __webpack_exports__["a"] = (StorylineChart);

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("/sven",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl="/sven"+'/service-worker.js';if(!isLocalhost){// Is not local host. Just register service worker
registerValidSW(swUrl);}else{// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* 

  BSD License:

  SVEN: Storyline Visualization Library and Demonstration

  Copyright © 2017, Battelle Memorial Institute
  All rights reserved.

  1. Battelle Memorial Institute (hereinafter Battelle) hereby grants permission
     to any person or entity lawfully obtaining a copy of this software and
     associated documentation files (hereinafter “the Software”) to redistribute
     and use the Software in source and binary forms, with or without 
     modification.  Such person or entity may use, copy, modify, merge, publish,
     distribute, sublicense, and/or sell copies of the Software, and may permit
     others to do so, subject to the following conditions:

     * Redistributions of source code must retain the above copyright notice,
       this list of conditions and the following disclaimers.
     * Redistributions in binary form must reproduce the above copyright notice,
       this list of conditions and the following disclaimer in the documentation
       and/or other materials provided with the distribution.
     * Other than as used herein, neither the name Battelle Memorial Institute
       or Battelle may be used in any form whatsoever without the express
       written consent of Battelle. 

  2. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
     AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
     THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
     PURPOSEARE DISCLAIMED. IN NO EVENT SHALL BATTELLE OR CONTRIBUTORS BE LIABLE
     FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
     DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
     SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
     CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
     LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
     OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
     DAMAGE.
     
*//* harmony default export */ __webpack_exports__["a"] = (function(G,weight){var sourcesAdded=[];var sinksAdded=[];while(G.numberOfNodes()){var sources=[];var sinks=[];var vMax=null;var dMax=-Infinity;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=G[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var v=_step.value;var dIn=G.inDegree(v,weight);var dOut=G.outDegree(v,weight);var delta=dOut-dIn;if(dIn===0){sources.push(v);}else if(dOut===0){sinks.push(v);}else if(delta>dMax||delta===dMax&&v<vMax){dMax=delta;vMax=v;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}if(sources.length+sinks.length===0){sources.push(vMax);}G.removeNodesFrom(sources);sourcesAdded=sourcesAdded.concat(sources.sort());G.removeNodesFrom(sinks);sinksAdded=sinksAdded.concat(sinks.sort().reverse());}sourcesAdded.push.apply(sourcesAdded,sinksAdded.reverse());return sourcesAdded;});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* 

  BSD License:

  SVEN: Storyline Visualization Library and Demonstration

  Copyright © 2017, Battelle Memorial Institute
  All rights reserved.

  1. Battelle Memorial Institute (hereinafter Battelle) hereby grants permission
     to any person or entity lawfully obtaining a copy of this software and
     associated documentation files (hereinafter “the Software”) to redistribute
     and use the Software in source and binary forms, with or without 
     modification.  Such person or entity may use, copy, modify, merge, publish,
     distribute, sublicense, and/or sell copies of the Software, and may permit
     others to do so, subject to the following conditions:

     * Redistributions of source code must retain the above copyright notice,
       this list of conditions and the following disclaimers.
     * Redistributions in binary form must reproduce the above copyright notice,
       this list of conditions and the following disclaimer in the documentation
       and/or other materials provided with the distribution.
     * Other than as used herein, neither the name Battelle Memorial Institute
       or Battelle may be used in any form whatsoever without the express
       written consent of Battelle. 

  2. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
     AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
     THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
     PURPOSEARE DISCLAIMED. IN NO EVENT SHALL BATTELLE OR CONTRIBUTORS BE LIABLE
     FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
     DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
     SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
     CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
     LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
     OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
     DAMAGE.
     
*//* harmony default export */ __webpack_exports__["a"] = (function(G,weight,w0,w1){weight=weight||'weight';var wobj={};wobj[weight]=w0||0;w1=w1||1;return function(u,v,w){var obj={};obj[weight]=(G.getEdgeData(u,v)||wobj)[weight]+(w||w1);G.addEdge(u,v,obj);};});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_layered_layout_js__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graph_algorithms_seriation_js__ = __webpack_require__(252);
/* unused harmony namespace reexport */
/* 

  BSD License:

  SVEN: Storyline Visualization Library and Demonstration

  Copyright © 2017, Battelle Memorial Institute
  All rights reserved.

  1. Battelle Memorial Institute (hereinafter Battelle) hereby grants permission
     to any person or entity lawfully obtaining a copy of this software and
     associated documentation files (hereinafter “the Software”) to redistribute
     and use the Software in source and binary forms, with or without 
     modification.  Such person or entity may use, copy, modify, merge, publish,
     distribute, sublicense, and/or sell copies of the Software, and may permit
     others to do so, subject to the following conditions:

     * Redistributions of source code must retain the above copyright notice,
       this list of conditions and the following disclaimers.
     * Redistributions in binary form must reproduce the above copyright notice,
       this list of conditions and the following disclaimer in the documentation
       and/or other materials provided with the distribution.
     * Other than as used herein, neither the name Battelle Memorial Institute
       or Battelle may be used in any form whatsoever without the express
       written consent of Battelle. 

  2. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
     AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
     THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
     PURPOSEARE DISCLAIMED. IN NO EVENT SHALL BATTELLE OR CONTRIBUTORS BE LIABLE
     FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
     DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
     SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
     CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
     LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
     OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
     DAMAGE.
     
*//* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__layouts_layered_layout_js__["a" /* default */]);

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_properties_js__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graph_algorithms_incrementer_js__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graph_algorithms_seriation_js__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graph_algorithms_feedback_arc_set_js__ = __webpack_require__(456);
/* 

  BSD License:

  SVEN: Storyline Visualization Library and Demonstration

  Copyright © 2017, Battelle Memorial Institute
  All rights reserved.

  1. Battelle Memorial Institute (hereinafter Battelle) hereby grants permission
     to any person or entity lawfully obtaining a copy of this software and
     associated documentation files (hereinafter “the Software”) to redistribute
     and use the Software in source and binary forms, with or without 
     modification.  Such person or entity may use, copy, modify, merge, publish,
     distribute, sublicense, and/or sell copies of the Software, and may permit
     others to do so, subject to the following conditions:

     * Redistributions of source code must retain the above copyright notice,
       this list of conditions and the following disclaimers.
     * Redistributions in binary form must reproduce the above copyright notice,
       this list of conditions and the following disclaimer in the documentation
       and/or other materials provided with the distribution.
     * Other than as used herein, neither the name Battelle Memorial Institute
       or Battelle may be used in any form whatsoever without the express
       written consent of Battelle. 

  2. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
     AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
     THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
     PURPOSEARE DISCLAIMED. IN NO EVENT SHALL BATTELLE OR CONTRIBUTORS BE LIABLE
     FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
     DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
     SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
     CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
     LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
     OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
     DAMAGE.
     
*/var d3=__webpack_require__(209);var jsnx=__webpack_require__(770);/* harmony default export */ __webpack_exports__["a"] = (function(){function self(data,previousTrees){var trees=self.constructTrees(data);var G=self.getGroupTransitionGraph(trees);self.initialGroupOrder(trees,G,previousTrees);self.finalGroupOrder(trees,G);self.initialEntityOrder(trees,G);self.finalEntityOrder(trees);self.findInteractionOffsets(trees);return trees;}var addProperty=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_properties_js__["a" /* default */])(self);addProperty('id');addProperty('group');addProperty('time');self.constructTrees=function(data){var id=self.id();var group=self.group();var time=self.time();// wrap the data
// lets us add fields to it without mutating the underlying data
data=data.map(function(d){return{data:d};});// store the x-coordinate in the data
data.forEach(function(d){d.x=time(d.data);});var interactions=d3.nest().key(function(d){return group(d.data);}).key(function(d){return time(d.data);}).entries(data);// use nest to create a id x time data structure
// this models the storylines
var storylines=d3.nest().key(function(d){return id(d.data);}).entries(data);// internally, sort the storylines by time, and add prev, next, first pointers
storylines.forEach(function(entity){entity.values.sort(function(a,b){return time(a.data)-time(b.data);}).forEach(function(event,i,a){if(i>0){event.prev=a[i-1];event.first=group(event.prev.data)===group(event.data)?event.prev.first:event;}else{event.prev=event.first=event;}event.next=i<a.length-1?a[i+1]:event;});});// sort the groups by date
interactions.forEach(function(g){return g.values.sort(function(a,b){return a.values[0].x-b.values[0].x;});});var events=data.concat([]).sort(function(a,b){return a.x-b.x;});return{interactions:interactions,storylines:storylines,events:events};};self.getEventSerializer=function(){var id=self.id();var time=self.time();return function(d){return String([id(d),time(d)]);};};self.getGroupTransitionGraph=function(trees){var group=self.group();var G=new jsnx.Graph();var inc=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__graph_algorithms_incrementer_js__["a" /* default */])(G);// add a node for each group
trees.interactions.forEach(function(interaction){G.addNode(group(interaction.values[0].values[0].data));});// add an edge for each
trees.events.forEach(function(event){var u=group(event.prev.data);var v=group(event.data);if(u!==v){inc(u,v);}});return G;};// pos maps {id, time} -> y coordinate
self.initialGroupOrder=function(trees,G,previousTrees){var group=self.group();var key=self.getEventSerializer();var pos=new Map();if(previousTrees){previousTrees.events.forEach(function(d){pos.set(key(d.data),d.y);});}trees.interactions.forEach(function(g){var heights=d3.merge(g.values.map(function(d){return d.values;})).map(function(d){return pos.get(key(d.data));});G.addNode(group(g.values[0].values[0].data),{y:d3.mean(heights.filter(function(d){return d!==undefined;}))||-1});});};self.finalGroupOrder=function(trees,G){var group=self.group();__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__graph_algorithms_seriation_js__["a" /* seriateByEnergyMinimization */])(G);// sort the groups by the order found during seriation
trees.interactions.forEach(function(g){g.y=G.node.get(group(g.values[0].values[0].data)).y;});trees.interactions.sort(function(a,b){return a.y-b.y;});};self.initialEntityOrder=function(trees,G){var group=self.group();trees.events.forEach(function(event){event.y=G.node.get(group(event.data)).y;});};// TODO: memoization of this will help a lot
self.getBias=function(u,v,direction){while((u[direction]!==u||v[direction]!==v)&&u.y===v.y){u=u[direction];v=v[direction];}return Math.sign(v.y-u.y);};self.finalEntityOrder=function(trees){var G=new jsnx.DiGraph();var inc=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__graph_algorithms_incrementer_js__["a" /* default */])(G);var key=self.getEventSerializer();// for each pair of storyline in each {group x time}
trees.interactions.forEach(function(group){group.values.forEach(function(time){time.values.forEach(function(u,i,ary){G.addNode(key(u.first.data),{event:u.first});for(var j=i+1;j<ary.length;j++){var v=ary[j];var bias=self.getBias(u,v,'prev')+self.getBias(u,v,'next');if(bias!==0){if(u.first.y>v.first.y){inc(key(u.first.data),key(v.first.data),bias);}else{inc(key(v.first.data),key(u.first.data),-bias);}}}});});});// reverse the direction edges with negative weight
G.edges(true).forEach(function(e){var u=e[0];var v=e[1];var d=e[2];var w=d.weight;if(w<=0){G.removeEdge(u,v);}if(w<0){G.addEdge(v,u,{weight:-w});}});// set the y coordinate of the first node based on the FAS ordering
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__graph_algorithms_feedback_arc_set_js__["a" /* default */])(G.copy()).forEach(function(d,i){G.node.get(d).event.yfas=i;});// loop over each interactin and find the y-coordinate by sorting
trees.interactions.forEach(function(group){group.values.forEach(function(interaction){interaction.values.sort(function(a,b){return a.first.yfas-b.first.yfas;}).forEach(function(event,j){event.y=j;});});});};self.findInteractionOffsets=function(trees){// convert ranking to offsets within each interaction session
var group=self.group();// loop over each group
trees.interactions.forEach(function(g,j){// loop over each interaction
g.values.forEach(function(interaction,i){interaction.y=0;// by default there is no y-offset
if(i>0){// loop over each event again to find the optimal offset
// between the current interaction and the previous one
var offsets={};interaction.values.forEach(function(event){if(event.prev!==event&&group(event.data)===group(event.prev.data)){var dy=event.y-event.prev.y;offsets[dy]=(offsets[dy]||0)+1;}});var ary=d3.entries(offsets);ary.forEach(function(d){d.key=Number(d.key);});if(ary.length>0){var best=d3.scan(ary,function(b,a){var av=a.value;var bv=b.value;if(av<bv){return-1;}else if(av>bv){return 1;}return 0;});interaction.y=g.values[i-1].y+ary[best].key;}}});// find the smallest y value of the interaction (guaranteed <= 0)
var padding=5;var origin=g.y0=g.y1=j>0?trees.interactions[j-1].y1+padding-d3.min(g.values,function(d){return-d.y;}):0;// finally, find the actual y-coordinates of the storylines
g.values.forEach(function(interaction){interaction.values.forEach(function(event){event.y+=origin-interaction.y;});g.y0=Math.min(g.y0,interaction.values[0].y-1);g.y1=Math.max(g.y1,interaction.values[interaction.values.length-1].y+1);});});};return self;});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSwapLattice1d;
/* harmony export (immutable) */ __webpack_exports__["b"] = minimizeEnergy;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pq2__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pq2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pq2__);
/* 

  BSD License:

  SVEN: Storyline Visualization Library and Demonstration

  Copyright © 2017, Battelle Memorial Institute
  All rights reserved.

  1. Battelle Memorial Institute (hereinafter Battelle) hereby grants permission
     to any person or entity lawfully obtaining a copy of this software and
     associated documentation files (hereinafter “the Software”) to redistribute
     and use the Software in source and binary forms, with or without 
     modification.  Such person or entity may use, copy, modify, merge, publish,
     distribute, sublicense, and/or sell copies of the Software, and may permit
     others to do so, subject to the following conditions:

     * Redistributions of source code must retain the above copyright notice,
       this list of conditions and the following disclaimers.
     * Redistributions in binary form must reproduce the above copyright notice,
       this list of conditions and the following disclaimer in the documentation
       and/or other materials provided with the distribution.
     * Other than as used herein, neither the name Battelle Memorial Institute
       or Battelle may be used in any form whatsoever without the express
       written consent of Battelle. 

  2. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
     AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
     THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
     PURPOSEARE DISCLAIMED. IN NO EVENT SHALL BATTELLE OR CONTRIBUTORS BE LIABLE
     FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
     DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
     SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
     CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
     LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
     OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
     DAMAGE.
     
*/var d3=__webpack_require__(209);function getSwapLattice1d(n){var moves=d3.range(n-1);var lattice=moves.map(function(i){return[i-1,i+1];});lattice[0]=[1];lattice[n-2]=[n-3];var createApplyMove=function createApplyMove(state,callback){return function(key){var u=state[key];var v=state[key+1];state[key]=v;state[key+1]=u;callback&&callback(key,u,v);return lattice[key];};};return{moves:moves,createApplyMove:createApplyMove};}function minimizeEnergy(initialMoves,applyMove,getEnergy){var moves=new __WEBPACK_IMPORTED_MODULE_0_pq2__["PriorityQueue"]();var delta=0;var steps=0;var bestMove={};initialMoves.forEach(function(d){return moves.enq({key:d,priority:getEnergy(d)});});while(moves.size()&&(bestMove=moves.peek()).priority<0){// update the change in energy
delta+=bestMove.priority;steps+=1;// apply the move, recalculate dependent moves
applyMove(bestMove.key).forEach(function(d){return moves.change_key(d,getEnergy(d));});// update the utility of the move performed
moves.change_key(bestMove.key,getEnergy(bestMove.key));}return{delta:delta,steps:steps};}

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* 

  BSD License:

  SVEN: Storyline Visualization Library and Demonstration

  Copyright © 2017, Battelle Memorial Institute
  All rights reserved.

  1. Battelle Memorial Institute (hereinafter Battelle) hereby grants permission
     to any person or entity lawfully obtaining a copy of this software and
     associated documentation files (hereinafter “the Software”) to redistribute
     and use the Software in source and binary forms, with or without 
     modification.  Such person or entity may use, copy, modify, merge, publish,
     distribute, sublicense, and/or sell copies of the Software, and may permit
     others to do so, subject to the following conditions:

     * Redistributions of source code must retain the above copyright notice,
       this list of conditions and the following disclaimers.
     * Redistributions in binary form must reproduce the above copyright notice,
       this list of conditions and the following disclaimer in the documentation
       and/or other materials provided with the distribution.
     * Other than as used herein, neither the name Battelle Memorial Institute
       or Battelle may be used in any form whatsoever without the express
       written consent of Battelle. 

  2. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
     AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
     THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
     PURPOSEARE DISCLAIMED. IN NO EVENT SHALL BATTELLE OR CONTRIBUTORS BE LIABLE
     FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
     DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
     SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
     CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
     LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
     OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
     DAMAGE.
     
*//* harmony default export */ __webpack_exports__["a"] = (function(chart){var properties={};return function(name,defaultValue){properties[name]=arguments.length===1?function(d){return d[name];}:defaultValue;chart[name]=function(value){if(arguments.length===0){return properties[name];}properties[name]=value;return chart;};};});

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(471), __esModule: true };

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(472), __esModule: true };

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(473), __esModule: true };

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(474), __esModule: true };

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(476), __esModule: true };

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(480), __esModule: true };

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(481), __esModule: true };

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(482), __esModule: true };

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(462);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(173);
__webpack_require__(506);
module.exports = __webpack_require__(20).Array.from;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var core  = __webpack_require__(20)
  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(270);
__webpack_require__(173);
__webpack_require__(271);
__webpack_require__(508);
__webpack_require__(517);
module.exports = __webpack_require__(20).Map;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(509);
module.exports = -0x1fffffffffffff;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(510);
module.exports = __webpack_require__(20).Object.assign;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(511);
var $Object = __webpack_require__(20).Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(512);
var $Object = __webpack_require__(20).Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(513);
module.exports = __webpack_require__(20).Object.getPrototypeOf;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(514);
module.exports = __webpack_require__(20).Object.keys;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(515);
module.exports = __webpack_require__(20).Object.setPrototypeOf;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(516);
__webpack_require__(270);
__webpack_require__(518);
__webpack_require__(519);
module.exports = __webpack_require__(20).Symbol;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(173);
__webpack_require__(271);
module.exports = __webpack_require__(172).f('iterator');

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports = function(){ /* empty */ };

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(161);

module.exports = function(iter, ITERATOR){
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(65)
  , toLength  = __webpack_require__(129)
  , toIndex   = __webpack_require__(505);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx      = __webpack_require__(76)
  , IObject  = __webpack_require__(162)
  , toObject = __webpack_require__(78)
  , toLength = __webpack_require__(129)
  , asc      = __webpack_require__(489);
module.exports = function(TYPE, $create){
  var IS_MAP        = TYPE == 1
    , IS_FILTER     = TYPE == 2
    , IS_SOME       = TYPE == 3
    , IS_EVERY      = TYPE == 4
    , IS_FIND_INDEX = TYPE == 6
    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
    , create        = $create || asc;
  return function($this, callbackfn, that){
    var O      = toObject($this)
      , self   = IObject(O)
      , f      = ctx(callbackfn, that, 3)
      , length = toLength(self.length)
      , index  = 0
      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
      , val, res;
    for(;length > index; index++)if(NO_HOLES || index in self){
      val = self[index];
      res = f(val, index, O);
      if(TYPE){
        if(IS_MAP)result[index] = res;            // map
        else if(res)switch(TYPE){
          case 3: return true;                    // some
          case 5: return val;                     // find
          case 6: return index;                   // findIndex
          case 2: result.push(val);               // filter
        } else if(IS_EVERY)return false;          // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(64)
  , isArray  = __webpack_require__(259)
  , SPECIES  = __webpack_require__(28)('species');

module.exports = function(original){
  var C;
  if(isArray(original)){
    C = original.constructor;
    // cross-realm fallback
    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
    if(isObject(C)){
      C = C[SPECIES];
      if(C === null)C = undefined;
    }
  } return C === undefined ? Array : C;
};

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(488);

module.exports = function(original, length){
  return new (speciesConstructor(original))(length);
};

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP          = __webpack_require__(31).f
  , create      = __webpack_require__(126)
  , redefineAll = __webpack_require__(267)
  , ctx         = __webpack_require__(76)
  , anInstance  = __webpack_require__(254)
  , defined     = __webpack_require__(125)
  , forOf       = __webpack_require__(161)
  , $iterDefine = __webpack_require__(163)
  , step        = __webpack_require__(261)
  , setSpecies  = __webpack_require__(503)
  , DESCRIPTORS = __webpack_require__(42)
  , fastKey     = __webpack_require__(165).fastKey
  , SIZE        = DESCRIPTORS ? '_s' : 'size';

var getEntry = function(that, key){
  // fast case
  var index = fastKey(key), entry;
  if(index !== 'F')return that._i[index];
  // frozen object case
  for(entry = that._f; entry; entry = entry.n){
    if(entry.k == key)return entry;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear(){
        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
          entry.r = true;
          if(entry.p)entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function(key){
        var that  = this
          , entry = getEntry(that, key);
        if(entry){
          var next = entry.n
            , prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if(prev)prev.n = next;
          if(next)next.p = prev;
          if(that._f == entry)that._f = next;
          if(that._l == entry)that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /*, that = undefined */){
        anInstance(this, C, 'forEach');
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
          , entry;
        while(entry = entry ? entry.n : this._f){
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while(entry && entry.r)entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key){
        return !!getEntry(this, key);
      }
    });
    if(DESCRIPTORS)dP(C.prototype, 'size', {
      get: function(){
        return defined(this[SIZE]);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var entry = getEntry(that, key)
      , prev, index;
    // change existing entry
    if(entry){
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if(!that._f)that._f = entry;
      if(prev)prev.n = entry;
      that[SIZE]++;
      // add to index
      if(index !== 'F')that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function(C, NAME, IS_MAP){
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function(iterated, kind){
      this._t = iterated;  // target
      this._k = kind;      // kind
      this._l = undefined; // previous
    }, function(){
      var that  = this
        , kind  = that._k
        , entry = that._l;
      // revert to the last existing entry
      while(entry && entry.r)entry = entry.p;
      // get next entry
      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if(kind == 'keys'  )return step(0, entry.k);
      if(kind == 'values')return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(255)
  , from    = __webpack_require__(485);
module.exports = function(NAME){
  return function toJSON(){
    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global         = __webpack_require__(43)
  , $export        = __webpack_require__(30)
  , meta           = __webpack_require__(165)
  , fails          = __webpack_require__(62)
  , hide           = __webpack_require__(54)
  , redefineAll    = __webpack_require__(267)
  , forOf          = __webpack_require__(161)
  , anInstance     = __webpack_require__(254)
  , isObject       = __webpack_require__(64)
  , setToStringTag = __webpack_require__(128)
  , dP             = __webpack_require__(31).f
  , each           = __webpack_require__(487)(0)
  , DESCRIPTORS    = __webpack_require__(42);

module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
  var Base  = global[NAME]
    , C     = Base
    , ADDER = IS_MAP ? 'set' : 'add'
    , proto = C && C.prototype
    , O     = {};
  if(!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
    new C().entries().next();
  }))){
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function(target, iterable){
      anInstance(target, C, NAME, '_c');
      target._c = new Base;
      if(iterable != undefined)forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','),function(KEY){
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if(KEY in proto && !(IS_WEAK && KEY == 'clear'))hide(C.prototype, KEY, function(a, b){
        anInstance(this, C, KEY);
        if(!IS_ADDER && IS_WEAK && !isObject(a))return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    if('size' in proto)dP(C.prototype, 'size', {
      get: function(){
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);

  return C;
};

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(31)
  , createDesc      = __webpack_require__(97);

module.exports = function(object, index, value){
  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(77)
  , gOPS    = __webpack_require__(166)
  , pIE     = __webpack_require__(127);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(43).document && document.documentElement;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__(126)
  , descriptor     = __webpack_require__(97)
  , setToStringTag = __webpack_require__(128)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(54)(IteratorPrototype, __webpack_require__(28)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__(28)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(77)
  , toIObject = __webpack_require__(65);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(77)
  , gOPS     = __webpack_require__(166)
  , pIE      = __webpack_require__(127)
  , toObject = __webpack_require__(78)
  , IObject  = __webpack_require__(162)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(62)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(31)
  , anObject = __webpack_require__(61)
  , getKeys  = __webpack_require__(77);

module.exports = __webpack_require__(42) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(65)
  , gOPN      = __webpack_require__(263).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(64)
  , anObject = __webpack_require__(61);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(76)(Function.call, __webpack_require__(262).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global      = __webpack_require__(43)
  , core        = __webpack_require__(20)
  , dP          = __webpack_require__(31)
  , DESCRIPTORS = __webpack_require__(42)
  , SPECIES     = __webpack_require__(28)('species');

module.exports = function(KEY){
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(169)
  , defined   = __webpack_require__(125);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(169)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx            = __webpack_require__(76)
  , $export        = __webpack_require__(30)
  , toObject       = __webpack_require__(78)
  , call           = __webpack_require__(260)
  , isArrayIter    = __webpack_require__(258)
  , toLength       = __webpack_require__(129)
  , createProperty = __webpack_require__(493)
  , getIterFn      = __webpack_require__(269);

$export($export.S + $export.F * !__webpack_require__(497)(function(iter){ Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
    var O       = toObject(arrayLike)
      , C       = typeof this == 'function' ? this : Array
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , index   = 0
      , iterFn  = getIterFn(O)
      , length, result, step, iterator;
    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for(result = new C(length); length > index; index++){
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(484)
  , step             = __webpack_require__(261)
  , Iterators        = __webpack_require__(96)
  , toIObject        = __webpack_require__(65);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(163)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(490);

// 23.1 Map Objects
module.exports = __webpack_require__(492)('Map', function(get){
  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key){
    var entry = strong.getEntry(this, key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value){
    return strong.def(this, key === 0 ? 0 : key, value);
  }
}, strong, true);

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(30);

$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(30);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(499)});

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(30)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: __webpack_require__(126)});

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(30);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(42), 'Object', {defineProperty: __webpack_require__(31).f});

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = __webpack_require__(78)
  , $getPrototypeOf = __webpack_require__(264);

__webpack_require__(266)('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(78)
  , $keys    = __webpack_require__(77);

__webpack_require__(266)('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(30);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(502).set});

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global         = __webpack_require__(43)
  , has            = __webpack_require__(63)
  , DESCRIPTORS    = __webpack_require__(42)
  , $export        = __webpack_require__(30)
  , redefine       = __webpack_require__(268)
  , META           = __webpack_require__(165).KEY
  , $fails         = __webpack_require__(62)
  , shared         = __webpack_require__(168)
  , setToStringTag = __webpack_require__(128)
  , uid            = __webpack_require__(130)
  , wks            = __webpack_require__(28)
  , wksExt         = __webpack_require__(172)
  , wksDefine      = __webpack_require__(171)
  , keyOf          = __webpack_require__(498)
  , enumKeys       = __webpack_require__(494)
  , isArray        = __webpack_require__(259)
  , anObject       = __webpack_require__(61)
  , toIObject      = __webpack_require__(65)
  , toPrimitive    = __webpack_require__(170)
  , createDesc     = __webpack_require__(97)
  , _create        = __webpack_require__(126)
  , gOPNExt        = __webpack_require__(501)
  , $GOPD          = __webpack_require__(262)
  , $DP            = __webpack_require__(31)
  , $keys          = __webpack_require__(77)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(263).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(127).f  = $propertyIsEnumerable;
  __webpack_require__(166).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(164)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(54)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = __webpack_require__(30);

$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(491)('Map')});

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(171)('asyncIterator');

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(171)('observable');

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(82);
__webpack_require__(553);
module.exports = __webpack_require__(22).Array.from;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(103);
__webpack_require__(82);
module.exports = __webpack_require__(551);

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(103);
__webpack_require__(82);
module.exports = __webpack_require__(552);

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(185);
__webpack_require__(82);
__webpack_require__(103);
__webpack_require__(555);
__webpack_require__(563);
module.exports = __webpack_require__(22).Map;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(556);
module.exports = __webpack_require__(22).Object.assign;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(18);
module.exports = function create(P, D){
  return $.create(P, D);
};

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(18);
module.exports = function defineProperty(it, key, desc){
  return $.setDesc(it, key, desc);
};

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(18);
__webpack_require__(557);
module.exports = function getOwnPropertyDescriptor(it, key){
  return $.getDesc(it, key);
};

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(18);
__webpack_require__(558);
module.exports = function getOwnPropertyNames(it){
  return $.getNames(it);
};

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(559);
module.exports = __webpack_require__(22).Object.keys;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(560);
module.exports = __webpack_require__(22).Object.setPrototypeOf;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(185);
__webpack_require__(82);
__webpack_require__(103);
__webpack_require__(561);
module.exports = __webpack_require__(22).Promise;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(562);
__webpack_require__(185);
module.exports = __webpack_require__(22).Symbol;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(82);
__webpack_require__(103);
module.exports = __webpack_require__(26)('iterator');

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports = function(){ /* empty */ };

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $            = __webpack_require__(18)
  , hide         = __webpack_require__(100)
  , redefineAll  = __webpack_require__(179)
  , ctx          = __webpack_require__(67)
  , strictNew    = __webpack_require__(181)
  , defined      = __webpack_require__(132)
  , forOf        = __webpack_require__(133)
  , $iterDefine  = __webpack_require__(175)
  , step         = __webpack_require__(277)
  , ID           = __webpack_require__(183)('id')
  , $has         = __webpack_require__(134)
  , isObject     = __webpack_require__(80)
  , setSpecies   = __webpack_require__(279)
  , DESCRIPTORS  = __webpack_require__(79)
  , isExtensible = Object.isExtensible || isObject
  , SIZE         = DESCRIPTORS ? '_s' : 'size'
  , id           = 0;

var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!$has(it, ID)){
    // can't set id to frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add id
    if(!create)return 'E';
    // add missing object id
    hide(it, ID, ++id);
  // return object id with prefix
  } return 'O' + it[ID];
};

var getEntry = function(that, key){
  // fast case
  var index = fastKey(key), entry;
  if(index !== 'F')return that._i[index];
  // frozen object case
  for(entry = that._f; entry; entry = entry.n){
    if(entry.k == key)return entry;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      strictNew(that, C, NAME);
      that._i = $.create(null); // index
      that._f = undefined;      // first entry
      that._l = undefined;      // last entry
      that[SIZE] = 0;           // size
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear(){
        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
          entry.r = true;
          if(entry.p)entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function(key){
        var that  = this
          , entry = getEntry(that, key);
        if(entry){
          var next = entry.n
            , prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if(prev)prev.n = next;
          if(next)next.p = prev;
          if(that._f == entry)that._f = next;
          if(that._l == entry)that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /*, that = undefined */){
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
          , entry;
        while(entry = entry ? entry.n : this._f){
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while(entry && entry.r)entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key){
        return !!getEntry(this, key);
      }
    });
    if(DESCRIPTORS)$.setDesc(C.prototype, 'size', {
      get: function(){
        return defined(this[SIZE]);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var entry = getEntry(that, key)
      , prev, index;
    // change existing entry
    if(entry){
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if(!that._f)that._f = entry;
      if(prev)prev.n = entry;
      that[SIZE]++;
      // add to index
      if(index !== 'F')that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function(C, NAME, IS_MAP){
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function(iterated, kind){
      this._t = iterated;  // target
      this._k = kind;      // kind
      this._l = undefined; // previous
    }, function(){
      var that  = this
        , kind  = that._k
        , entry = that._l;
      // revert to the last existing entry
      while(entry && entry.r)entry = entry.p;
      // get next entry
      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if(kind == 'keys'  )return step(0, entry.k);
      if(kind == 'values')return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var forOf   = __webpack_require__(133)
  , classof = __webpack_require__(131);
module.exports = function(NAME){
  return function toJSON(){
    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
    var arr = [];
    forOf(this, false, arr.push, arr);
    return arr;
  };
};

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $              = __webpack_require__(18)
  , global         = __webpack_require__(44)
  , $export        = __webpack_require__(47)
  , fails          = __webpack_require__(99)
  , hide           = __webpack_require__(100)
  , redefineAll    = __webpack_require__(179)
  , forOf          = __webpack_require__(133)
  , strictNew      = __webpack_require__(181)
  , isObject       = __webpack_require__(80)
  , setToStringTag = __webpack_require__(101)
  , DESCRIPTORS    = __webpack_require__(79);

module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
  var Base  = global[NAME]
    , C     = Base
    , ADDER = IS_MAP ? 'set' : 'add'
    , proto = C && C.prototype
    , O     = {};
  if(!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
    new C().entries().next();
  }))){
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
  } else {
    C = wrapper(function(target, iterable){
      strictNew(target, C, NAME);
      target._c = new Base;
      if(iterable != undefined)forOf(iterable, IS_MAP, target[ADDER], target);
    });
    $.each.call('add,clear,delete,forEach,get,has,set,keys,values,entries'.split(','),function(KEY){
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if(KEY in proto && !(IS_WEAK && KEY == 'clear'))hide(C.prototype, KEY, function(a, b){
        if(!IS_ADDER && IS_WEAK && !isObject(a))return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    if('size' in proto)$.setDesc(C.prototype, 'size', {
      get: function(){
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);

  return C;
};

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(80)
  , document = __webpack_require__(44).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var $ = __webpack_require__(18);
module.exports = function(it){
  var keys       = $.getKeys(it)
    , getSymbols = $.getSymbols;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = $.isEnum
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))keys.push(key);
  }
  return keys;
};

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(44).document && document.documentElement;

/***/ }),
/* 541 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(98);
module.exports = Array.isArray || function(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $              = __webpack_require__(18)
  , descriptor     = __webpack_require__(178)
  , setToStringTag = __webpack_require__(101)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(100)(IteratorPrototype, __webpack_require__(26)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = $.create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var $         = __webpack_require__(18)
  , toIObject = __webpack_require__(102);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = $.getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(44)
  , macrotask = __webpack_require__(550).set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = __webpack_require__(98)(process) == 'process'
  , head, last, notify;

var flush = function(){
  var parent, domain, fn;
  if(isNode && (parent = process.domain)){
    process.domain = null;
    parent.exit();
  }
  while(head){
    domain = head.domain;
    fn     = head.fn;
    if(domain)domain.enter();
    fn(); // <- currently we use it only for Promise - try / catch not required
    if(domain)domain.exit();
    head = head.next;
  } last = undefined;
  if(parent)parent.enter();
};

// Node.js
if(isNode){
  notify = function(){
    process.nextTick(flush);
  };
// browsers with MutationObserver
} else if(Observer){
  var toggle = 1
    , node   = document.createTextNode('');
  new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
  notify = function(){
    node.data = toggle = -toggle;
  };
// environments with maybe non-completely correct, but existent Promise
} else if(Promise && Promise.resolve){
  notify = function(){
    Promise.resolve().then(flush);
  };
// for other environments - macrotask based on:
// - setImmediate
// - MessageChannel
// - window.postMessag
// - onreadystatechange
// - setTimeout
} else {
  notify = function(){
    // strange IE + webpack dev server bug - use .call(global)
    macrotask.call(global, flush);
  };
}

module.exports = function asap(fn){
  var task = {fn: fn, next: undefined, domain: isNode && process.domain};
  if(last)last.next = task;
  if(!head){
    head = task;
    notify();
  } last = task;
};

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.1 Object.assign(target, source, ...)
var $        = __webpack_require__(18)
  , toObject = __webpack_require__(182)
  , IObject  = __webpack_require__(273);

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = __webpack_require__(99)(function(){
  var a = Object.assign
    , A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , $$    = arguments
    , $$len = $$.length
    , index = 1
    , getKeys    = $.getKeys
    , getSymbols = $.getSymbols
    , isEnum     = $.isEnum;
  while($$len > index){
    var S      = IObject($$[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  }
  return T;
} : Object.assign;

/***/ }),
/* 547 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y){
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = __webpack_require__(66)
  , aFunction = __webpack_require__(174)
  , SPECIES   = __webpack_require__(26)('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(281)
  , defined   = __webpack_require__(132);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var ctx                = __webpack_require__(67)
  , invoke             = __webpack_require__(541)
  , html               = __webpack_require__(540)
  , cel                = __webpack_require__(538)
  , global             = __webpack_require__(44)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listner = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(__webpack_require__(98)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listner;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listner, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(66)
  , get      = __webpack_require__(184);
module.exports = __webpack_require__(22).getIterator = function(it){
  var iterFn = get(it);
  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(131)
  , ITERATOR  = __webpack_require__(26)('iterator')
  , Iterators = __webpack_require__(81);
module.exports = __webpack_require__(22).isIterable = function(it){
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    || Iterators.hasOwnProperty(classof(O));
};

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx         = __webpack_require__(67)
  , $export     = __webpack_require__(47)
  , toObject    = __webpack_require__(182)
  , call        = __webpack_require__(275)
  , isArrayIter = __webpack_require__(274)
  , toLength    = __webpack_require__(282)
  , getIterFn   = __webpack_require__(184);
$export($export.S + $export.F * !__webpack_require__(276)(function(iter){ Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
    var O       = toObject(arrayLike)
      , C       = typeof this == 'function' ? this : Array
      , $$      = arguments
      , $$len   = $$.length
      , mapfn   = $$len > 1 ? $$[1] : undefined
      , mapping = mapfn !== undefined
      , index   = 0
      , iterFn  = getIterFn(O)
      , length, result, step, iterator;
    if(mapping)mapfn = ctx(mapfn, $$len > 2 ? $$[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
        result[index] = mapping ? call(iterator, mapfn, [step.value, index], true) : step.value;
      }
    } else {
      length = toLength(O.length);
      for(result = new C(length); length > index; index++){
        result[index] = mapping ? mapfn(O[index], index) : O[index];
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(534)
  , step             = __webpack_require__(277)
  , Iterators        = __webpack_require__(81)
  , toIObject        = __webpack_require__(102);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(175)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(535);

// 23.1 Map Objects
__webpack_require__(537)('Map', function(get){
  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key){
    var entry = strong.getEntry(this, key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value){
    return strong.def(this, key === 0 ? 0 : key, value);
  }
}, strong, true);

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(47);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(546)});

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(102);

__webpack_require__(177)('getOwnPropertyDescriptor', function($getOwnPropertyDescriptor){
  return function getOwnPropertyDescriptor(it, key){
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(177)('getOwnPropertyNames', function(){
  return __webpack_require__(272).get;
});

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(182);

__webpack_require__(177)('keys', function($keys){
  return function keys(it){
    return $keys(toObject(it));
  };
});

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(47);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(278).set});

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $          = __webpack_require__(18)
  , LIBRARY    = __webpack_require__(176)
  , global     = __webpack_require__(44)
  , ctx        = __webpack_require__(67)
  , classof    = __webpack_require__(131)
  , $export    = __webpack_require__(47)
  , isObject   = __webpack_require__(80)
  , anObject   = __webpack_require__(66)
  , aFunction  = __webpack_require__(174)
  , strictNew  = __webpack_require__(181)
  , forOf      = __webpack_require__(133)
  , setProto   = __webpack_require__(278).set
  , same       = __webpack_require__(547)
  , SPECIES    = __webpack_require__(26)('species')
  , speciesConstructor = __webpack_require__(548)
  , asap       = __webpack_require__(545)
  , PROMISE    = 'Promise'
  , process    = global.process
  , isNode     = classof(process) == 'process'
  , P          = global[PROMISE]
  , empty      = function(){ /* empty */ }
  , Wrapper;

var testResolve = function(sub){
  var test = new P(empty), promise;
  if(sub)test.constructor = function(exec){
    exec(empty, empty);
  };
  (promise = P.resolve(test))['catch'](empty);
  return promise === test;
};

var USE_NATIVE = function(){
  var works = false;
  function P2(x){
    var self = new P(x);
    setProto(self, P2.prototype);
    return self;
  }
  try {
    works = P && P.resolve && testResolve();
    setProto(P2, P);
    P2.prototype = $.create(P.prototype, {constructor: {value: P2}});
    // actual Firefox has broken subclass support, test that
    if(!(P2.resolve(5).then(function(){}) instanceof P2)){
      works = false;
    }
    // actual V8 bug, https://code.google.com/p/v8/issues/detail?id=4162
    if(works && __webpack_require__(79)){
      var thenableThenGotten = false;
      P.resolve($.setDesc({}, 'then', {
        get: function(){ thenableThenGotten = true; }
      }));
      works = thenableThenGotten;
    }
  } catch(e){ works = false; }
  return works;
}();

// helpers
var sameConstructor = function(a, b){
  // library wrapper special case
  if(LIBRARY && a === P && b === Wrapper)return true;
  return same(a, b);
};
var getConstructor = function(C){
  var S = anObject(C)[SPECIES];
  return S != undefined ? S : C;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var PromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve),
  this.reject  = aFunction(reject)
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(record, isReject){
  if(record.n)return;
  record.n = true;
  var chain = record.c;
  asap(function(){
    var value = record.v
      , ok    = record.s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , result, then;
      try {
        if(handler){
          if(!ok)record.h = true;
          result = handler === true ? value : handler(value);
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    chain.length = 0;
    record.n = false;
    if(isReject)setTimeout(function(){
      var promise = record.p
        , handler, console;
      if(isUnhandled(promise)){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      } record.a = undefined;
    }, 1);
  });
};
var isUnhandled = function(promise){
  var record = promise._d
    , chain  = record.a || record.c
    , i      = 0
    , reaction;
  if(record.h)return false;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var $reject = function(value){
  var record = this;
  if(record.d)return;
  record.d = true;
  record = record.r || record; // unwrap
  record.v = value;
  record.s = 2;
  record.a = record.c.slice();
  notify(record, true);
};
var $resolve = function(value){
  var record = this
    , then;
  if(record.d)return;
  record.d = true;
  record = record.r || record; // unwrap
  try {
    if(record.p === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      asap(function(){
        var wrapper = {r: record, d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      record.v = value;
      record.s = 1;
      notify(record, false);
    }
  } catch(e){
    $reject.call({r: record, d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  P = function Promise(executor){
    aFunction(executor);
    var record = this._d = {
      p: strictNew(this, P, PROMISE),         // <- promise
      c: [],                                  // <- awaiting reactions
      a: undefined,                           // <- checked in isUnhandled reactions
      s: 0,                                   // <- state
      d: false,                               // <- done
      v: undefined,                           // <- value
      h: false,                               // <- handled rejection
      n: false                                // <- notify
    };
    try {
      executor(ctx($resolve, record, 1), ctx($reject, record, 1));
    } catch(err){
      $reject.call(record, err);
    }
  };
  __webpack_require__(179)(P.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction = new PromiseCapability(speciesConstructor(this, P))
        , promise  = reaction.promise
        , record   = this._d;
      reaction.ok   = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      record.c.push(reaction);
      if(record.a)record.a.push(reaction);
      if(record.s)notify(record, false);
      return promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: P});
__webpack_require__(101)(P, PROMISE);
__webpack_require__(279)(PROMISE);
Wrapper = __webpack_require__(22)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = new PromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (!USE_NATIVE || testResolve(true)), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof P && sameConstructor(x.constructor, this))return x;
    var capability = new PromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(276)(function(iter){
  P.all(iter)['catch'](function(){});
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = getConstructor(this)
      , capability = new PromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject
      , values     = [];
    var abrupt = perform(function(){
      forOf(iterable, false, values.push, values);
      var remaining = values.length
        , results   = Array(remaining);
      if(remaining)$.each.call(values, function(promise, index){
        var alreadyCalled = false;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled = true;
          results[index] = value;
          --remaining || resolve(results);
        }, reject);
      });
      else resolve(results);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = getConstructor(this)
      , capability = new PromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var $              = __webpack_require__(18)
  , global         = __webpack_require__(44)
  , has            = __webpack_require__(134)
  , DESCRIPTORS    = __webpack_require__(79)
  , $export        = __webpack_require__(47)
  , redefine       = __webpack_require__(180)
  , $fails         = __webpack_require__(99)
  , shared         = __webpack_require__(280)
  , setToStringTag = __webpack_require__(101)
  , uid            = __webpack_require__(183)
  , wks            = __webpack_require__(26)
  , keyOf          = __webpack_require__(544)
  , $names         = __webpack_require__(272)
  , enumKeys       = __webpack_require__(539)
  , isArray        = __webpack_require__(542)
  , anObject       = __webpack_require__(66)
  , toIObject      = __webpack_require__(102)
  , createDesc     = __webpack_require__(178)
  , getDesc        = $.getDesc
  , setDesc        = $.setDesc
  , _create        = $.create
  , getNames       = $names.get
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , setter         = false
  , HIDDEN         = wks('_hidden')
  , isEnum         = $.isEnum
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , useNative      = typeof $Symbol == 'function'
  , ObjectProto    = Object.prototype;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(setDesc({}, 'a', {
    get: function(){ return setDesc(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = getDesc(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  setDesc(it, key, D);
  if(protoDesc && it !== ObjectProto)setDesc(ObjectProto, key, protoDesc);
} : setDesc;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol.prototype);
  sym._k = tag;
  DESCRIPTORS && setter && setSymbolDesc(ObjectProto, tag, {
    configurable: true,
    set: function(value){
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    }
  });
  return sym;
};

var isSymbol = function(it){
  return typeof it == 'symbol';
};

var $defineProperty = function defineProperty(it, key, D){
  if(D && has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))setDesc(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return setDesc(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key);
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key]
    ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  var D = getDesc(it = toIObject(it), key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = getNames(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i)if(!has(AllSymbols, key = names[i++]) && key != HIDDEN)result.push(key);
  return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var names  = getNames(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i)if(has(AllSymbols, key = names[i++]))result.push(AllSymbols[key]);
  return result;
};
var $stringify = function stringify(it){
  if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
  var args = [it]
    , i    = 1
    , $$   = arguments
    , replacer, $replacer;
  while($$.length > i)args.push($$[i++]);
  replacer = args[1];
  if(typeof replacer == 'function')$replacer = replacer;
  if($replacer || !isArray(replacer))replacer = function(key, value){
    if($replacer)value = $replacer.call(this, key, value);
    if(!isSymbol(value))return value;
  };
  args[1] = replacer;
  return _stringify.apply($JSON, args);
};
var buggyJSON = $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
});

// 19.4.1.1 Symbol([description])
if(!useNative){
  $Symbol = function Symbol(){
    if(isSymbol(this))throw TypeError('Symbol is not a constructor');
    return wrap(uid(arguments.length > 0 ? arguments[0] : undefined));
  };
  redefine($Symbol.prototype, 'toString', function toString(){
    return this._k;
  });

  isSymbol = function(it){
    return it instanceof $Symbol;
  };

  $.create     = $create;
  $.isEnum     = $propertyIsEnumerable;
  $.getDesc    = $getOwnPropertyDescriptor;
  $.setDesc    = $defineProperty;
  $.setDescs   = $defineProperties;
  $.getNames   = $names.get = $getOwnPropertyNames;
  $.getSymbols = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(176)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }
}

var symbolStatics = {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    return keyOf(SymbolRegistry, key);
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
};
// 19.4.2.2 Symbol.hasInstance
// 19.4.2.3 Symbol.isConcatSpreadable
// 19.4.2.4 Symbol.iterator
// 19.4.2.6 Symbol.match
// 19.4.2.8 Symbol.replace
// 19.4.2.9 Symbol.search
// 19.4.2.10 Symbol.species
// 19.4.2.11 Symbol.split
// 19.4.2.12 Symbol.toPrimitive
// 19.4.2.13 Symbol.toStringTag
// 19.4.2.14 Symbol.unscopables
$.each.call((
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,' +
  'species,split,toPrimitive,toStringTag,unscopables'
).split(','), function(it){
  var sym = wks(it);
  symbolStatics[it] = useNative ? sym : wrap(sym);
});

setter = true;

$export($export.G + $export.W, {Symbol: $Symbol});

$export($export.S, 'Symbol', symbolStatics);

$export($export.S + $export.F * !useNative, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!useNative || buggyJSON), 'JSON', {stringify: $stringify});

// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = __webpack_require__(47);

$export($export.P, 'Map', {toJSON: __webpack_require__(536)('Map')});

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var React = __webpack_require__(1);
var factory = __webpack_require__(283);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelize;
var regExp = /[-\s]+(.)?/g;

/**
 * Convert dash separated strings to camel cased.
 *
 * @param {String} str
 * @return {String}
 */
function camelize(str) {
  return str.replace(regExp, toUpper);
}

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedValue = exports.supportedProperty = exports.prefix = undefined;

var _prefix = __webpack_require__(186);

var _prefix2 = _interopRequireDefault(_prefix);

var _supportedProperty = __webpack_require__(567);

var _supportedProperty2 = _interopRequireDefault(_supportedProperty);

var _supportedValue = __webpack_require__(568);

var _supportedValue2 = _interopRequireDefault(_supportedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  prefix: _prefix2['default'],
  supportedProperty: _supportedProperty2['default'],
  supportedValue: _supportedValue2['default']
}; /**
    * CSS Vendor prefix detection and property feature testing.
    *
    * @copyright Oleg Slobodskoi 2015
    * @website https://github.com/jsstyles/css-vendor
    * @license MIT
    */

exports.prefix = _prefix2['default'];
exports.supportedProperty = _supportedProperty2['default'];
exports.supportedValue = _supportedValue2['default'];

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedProperty;

var _isInBrowser = __webpack_require__(144);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(186);

var _prefix2 = _interopRequireDefault(_prefix);

var _camelize = __webpack_require__(565);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var el = void 0;
var cache = {};

if (_isInBrowser2['default']) {
  el = document.createElement('p');

  /**
   * We test every property on vendor prefix requirement.
   * Once tested, result is cached. It gives us up to 70% perf boost.
   * http://jsperf.com/element-style-object-access-vs-plain-object
   *
   * Prefill cache with known css properties to reduce amount of
   * properties we need to feature test at runtime.
   * http://davidwalsh.name/vendor-prefix
   */
  var computed = window.getComputedStyle(document.documentElement, '');
  for (var key in computed) {
    if (!isNaN(key)) cache[computed[key]] = computed[key];
  }
}

/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @return {String|Boolean}
 * @api public
 */
function supportedProperty(prop) {
  // For server-side rendering.
  if (!el) return prop;

  // We have not tested this prop yet, lets do the test.
  if (cache[prop] != null) return cache[prop];

  // Camelization is required because we can't test using
  // css syntax for e.g. in FF.
  // Test if property is supported as it is.
  if ((0, _camelize2['default'])(prop) in el.style) {
    cache[prop] = prop;
  }
  // Test if property is supported with vendor prefix.
  else if (_prefix2['default'].js + (0, _camelize2['default'])('-' + prop) in el.style) {
      cache[prop] = _prefix2['default'].css + prop;
    } else {
      cache[prop] = false;
    }

  return cache[prop];
}

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedValue;

var _isInBrowser = __webpack_require__(144);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(186);

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var cache = {};
var el = void 0;

if (_isInBrowser2['default']) el = document.createElement('p');

/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */
function supportedValue(property, value) {
  // For server-side rendering.
  if (!el) return value;

  // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  if (typeof value !== 'string' || !isNaN(parseInt(value, 10))) return value;

  var cacheKey = property + value;

  if (cache[cacheKey] != null) return cache[cacheKey];

  // IE can even throw an error in some cases, for e.g. style.content = 'bar'
  try {
    // Test value as it is.
    el.style[property] = value;
  } catch (err) {
    cache[cacheKey] = false;
    return false;
  }

  // Value is supported as it is.
  if (el.style[property] !== '') {
    cache[cacheKey] = value;
  } else {
    // Test value with vendor prefix.
    value = _prefix2['default'].css + value;

    // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
    if (value === '-ms-flex') value = '-ms-flexbox';

    el.style[property] = value;

    // Value is supported with vendor prefix.
    if (el.style[property] !== '') cache[cacheKey] = value;
  }

  if (!cache[cacheKey]) cache[cacheKey] = false;

  // Reset style value.
  el.style[property] = '';

  return cache[cacheKey];
}

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pairs__ = __webpack_require__(290);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = __WEBPACK_IMPORTED_MODULE_0__pairs__["a" /* pair */];

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});


/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisect__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__range__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ticks__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__ = __webpack_require__(292);









/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */],
      domain = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */],
      threshold = __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__["a" /* default */];

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__ticks__["a" /* tickStep */])(x0, x1, tz);
      tz = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__range__["a" /* default */])(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bisect__["a" /* default */])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(_)) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : threshold;
  };

  return histogram;
});


/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});


/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(104);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
});


/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quantile__ = __webpack_require__(187);




/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__quantile__["a" /* default */])(numbers.sort(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]), 0.5);
});


/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
});


/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(83);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = __WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */];

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});


/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});


/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});


/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quantile__ = __webpack_require__(187);





/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  values = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(values, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]).sort(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* default */]);
  return Math.ceil((max - min) / (2 * (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.75) - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deviation__ = __webpack_require__(287);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__deviation__["a" /* default */])(values) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transpose__ = __webpack_require__(294);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__transpose__["a" /* default */])(arguments);
});


/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_axis__ = __webpack_require__(587);
/* unused harmony reexport axisTop */
/* unused harmony reexport axisRight */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_axis__["a"]; });
/* unused harmony reexport axisLeft */



/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export axisTop */
/* unused harmony export axisRight */
/* harmony export (immutable) */ __webpack_exports__["a"] = axisBottom;
/* unused harmony export axisLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__(588);



var top = 1,
    right = 2,
    bottom = 3,
    left = 4,
    epsilon = 1e-6;

function translateX(x) {
  return "translate(" + (x + 0.5) + ",0)";
}

function translateY(y) {
  return "translate(0," + (y + 0.5) + ")";
}

function number(scale) {
  return function(d) {
    return +scale(d);
  };
}

function center(scale) {
  var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
  if (scale.round()) offset = Math.round(offset);
  return function(d) {
    return +scale(d) + offset;
  };
}

function entering() {
  return !this.__axis;
}

function axis(orient, scale) {
  var tickArguments = [],
      tickValues = null,
      tickFormat = null,
      tickSizeInner = 6,
      tickSizeOuter = 6,
      tickPadding = 3,
      k = orient === top || orient === left ? -1 : 1,
      x = orient === left || orient === right ? "x" : "y",
      transform = orient === top || orient === bottom ? translateX : translateY;

  function axis(context) {
    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */]) : tickFormat,
        spacing = Math.max(tickSizeInner, 0) + tickPadding,
        range = scale.range(),
        range0 = +range[0] + 0.5,
        range1 = +range[range.length - 1] + 0.5,
        position = (scale.bandwidth ? center : number)(scale.copy()),
        selection = context.selection ? context.selection() : context,
        path = selection.selectAll(".domain").data([null]),
        tick = selection.selectAll(".tick").data(values, scale).order(),
        tickExit = tick.exit(),
        tickEnter = tick.enter().append("g").attr("class", "tick"),
        line = tick.select("line"),
        text = tick.select("text");

    path = path.merge(path.enter().insert("path", ".tick")
        .attr("class", "domain")
        .attr("stroke", "#000"));

    tick = tick.merge(tickEnter);

    line = line.merge(tickEnter.append("line")
        .attr("stroke", "#000")
        .attr(x + "2", k * tickSizeInner));

    text = text.merge(tickEnter.append("text")
        .attr("fill", "#000")
        .attr(x, k * spacing)
        .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));

    if (context !== selection) {
      path = path.transition(context);
      tick = tick.transition(context);
      line = line.transition(context);
      text = text.transition(context);

      tickExit = tickExit.transition(context)
          .attr("opacity", epsilon)
          .attr("transform", function(d) { return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform"); });

      tickEnter
          .attr("opacity", epsilon)
          .attr("transform", function(d) { var p = this.parentNode.__axis; return transform(p && isFinite(p = p(d)) ? p : position(d)); });
    }

    tickExit.remove();

    path
        .attr("d", orient === left || orient == right
            ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter
            : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter);

    tick
        .attr("opacity", 1)
        .attr("transform", function(d) { return transform(position(d)); });

    line
        .attr(x + "2", k * tickSizeInner);

    text
        .attr(x, k * spacing)
        .text(format);

    selection.filter(entering)
        .attr("fill", "none")
        .attr("font-size", 10)
        .attr("font-family", "sans-serif")
        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");

    selection
        .each(function() { this.__axis = position; });
  }

  axis.scale = function(_) {
    return arguments.length ? (scale = _, axis) : scale;
  };

  axis.ticks = function() {
    return tickArguments = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(arguments), axis;
  };

  axis.tickArguments = function(_) {
    return arguments.length ? (tickArguments = _ == null ? [] : __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_), axis) : tickArguments.slice();
  };

  axis.tickValues = function(_) {
    return arguments.length ? (tickValues = _ == null ? null : __WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_), axis) : tickValues && tickValues.slice();
  };

  axis.tickFormat = function(_) {
    return arguments.length ? (tickFormat = _, axis) : tickFormat;
  };

  axis.tickSize = function(_) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
  };

  axis.tickSizeInner = function(_) {
    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
  };

  axis.tickSizeOuter = function(_) {
    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
  };

  axis.tickPadding = function(_) {
    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
  };

  return axis;
}

function axisTop(scale) {
  return axis(top, scale);
}

function axisRight(scale) {
  return axis(right, scale);
}

function axisBottom(scale) {
  return axis(bottom, scale);
}

function axisLeft(scale) {
  return axis(left, scale);
}


/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_nest__ = __webpack_require__(592);
/* unused harmony reexport nest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_set__ = __webpack_require__(593);
/* unused harmony reexport set */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_map__ = __webpack_require__(188);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_keys__ = __webpack_require__(591);
/* unused harmony reexport keys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_values__ = __webpack_require__(594);
/* unused harmony reexport values */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_entries__ = __webpack_require__(590);
/* unused harmony reexport entries */








/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
});


/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
});


/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(188);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) {
      if (sortValues != null) array.sort(sortValues);
      return rollup != null ? rollup(array) : array;
    }

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
});

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])();
}

function setMap(map, key, value) {
  map.set(key, value);
}


/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(188);


function Set() {}

var proto = __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */].prototype;

Set.prototype = set.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[__WEBPACK_IMPORTED_MODULE_0__map__["b" /* prefix */] + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

/* unused harmony default export */ var _unused_webpack_default_export = (set);


/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
});


/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(296);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["a" /* Rgb */])) o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Cubehelix, cubehelix, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* Color */], {
  brighter: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["d" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["d" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["e" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["e" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["a" /* Rgb */](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = lab;
/* unused harmony export Lab */
/* harmony export (immutable) */ __webpack_exports__["a"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(296);




var Kn = 18,
    Xn = 0.950470, // D65 standard referent
    Yn = 1,
    Zn = 1.088830,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* deg2rad */];
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["a" /* Rgb */])) o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* rgbConvert */])(o);
  var b = rgb2xyz(o.r),
      a = rgb2xyz(o.g),
      l = rgb2xyz(o.b),
      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Lab, lab, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* Color */], {
  brighter: function(k) {
    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    y = Yn * lab2xyz(y);
    x = Xn * lab2xyz(x);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["a" /* Rgb */](
      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function xyz2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2xyz(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hcl, hcl, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* Color */], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));


/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatPrefix; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(301);


var locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}


/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  x = x.toPrecision(p);

  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (x[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      case "e": break out;
      default: if (i0 > 0) i0 = 0; break;
    }
  }

  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
});


/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});


/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
});


/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(191);


/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});


/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(135);


/* harmony default export */ __webpack_exports__["a"] = (function(step) {
  return Math.max(0, -__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(135);


/* harmony default export */ __webpack_exports__["a"] = (function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3 - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(135);


/* harmony default export */ __webpack_exports__["a"] = (function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(max) - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(step)) + 1;
});


/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelixLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(106);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(end)).h),
          s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
          l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* unused harmony default export */ var _unused_webpack_default_export = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(106);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* hcl */])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* hcl */])(end)).h),
        c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.c, end.c),
        l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hcl(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(106);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(end)).h),
        s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
        l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hsl(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(106);



function lab(start, end) {
  var l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* lab */])(start)).l, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* lab */])(end)).l),
      a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.a, end.a),
      b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.b, end.b),
      opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
});


/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["b"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export interpolateTransformCss */
/* unused harmony export interpolateTransformSvg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(614);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__(612);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* identity */];
  value = value.matrix;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* unused harmony default export */ var _unused_webpack_default_export = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pi = Math.PI,
    tau = 2 * pi,
    epsilon = 1e-6,
    tauEpsilon = tau - epsilon;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon)) {}

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau + tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (path);


/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export point */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ordinal__ = __webpack_require__(312);



function band() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ordinal__["a" /* default */])().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["k" /* range */])(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band().paddingInner(1));
}


/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"));


/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(108);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5"));


/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(108);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6"));


/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(108);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9"));


/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(105);



/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateCubehelixLong */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(300, 0.5, 0.0), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(-240, 0.5, 1.0)));


/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(311);




function identity() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity().domain(domain);
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nice__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__continuous__ = __webpack_require__(137);






function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(b);
}

function reinterpolate(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* default */])(deinterpolate, reinterpolate).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* ticks */])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* format */])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__nice__["a" /* default */])(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__continuous__["c" /* copy */])(scale, log().base(base));
  };

  return scale;
}


/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export sqrt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(137);




function raise(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow() {
  var exponent = 1,
      scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* default */])(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise(b, exponent) - (a = raise(a, exponent)))
        ? function(x) { return (raise(x, exponent) - a) / b; }
        : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(b);
  }

  function reinterpolate(a, b) {
    b = raise(b, exponent) - (a = raise(a, exponent));
    return function(t) { return raise(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* copy */])(scale, pow().exponent(exponent));
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}

function sqrt() {
  return pow().exponent(0.5);
}


/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(68);



function quantile() {
  var domain = [],
      range = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["i" /* quantile */])(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* bisect */])(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["j" /* ascending */]);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(109);




function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* bisect */])(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range);
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export warm */
/* unused harmony export cool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(105);



var warm = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateCubehelixLong */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(-100, 0.75, 0.35), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(80, 1.50, 0.8));

var cool = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateCubehelixLong */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(260, 0.75, 0.35), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(80, 1.50, 0.8));

var rainbow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])();

/* unused harmony default export */ var _unused_webpack_default_export = (function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
});


/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(109);


function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(68);



function threshold() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* bisect */])(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(297);



/* harmony default export */ __webpack_exports__["a"] = (function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* tickStep */])(start, stop, count == null ? 10 : count),
      precision;
  specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* formatSpecifier */])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["b" /* precisionPrefix */])(step, value))) specifier.precision = precision;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["c" /* formatPrefix */])(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d" /* precisionRound */])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e" /* precisionFixed */])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* format */])(specifier);
});


/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(208);




/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__time__["a" /* calendar */])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["a" /* utcYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["b" /* utcMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["c" /* utcWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["d" /* utcDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["e" /* utcHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["f" /* utcMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["g" /* utcSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["h" /* utcMillisecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time_format__["a" /* utcFormat */]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
});


/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export magma */
/* unused harmony export inferno */
/* unused harmony export plasma */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(108);


function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")));

var magma = ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));


/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_creator__ = __webpack_require__(195);
/* unused harmony reexport creator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_local__ = __webpack_require__(636);
/* unused harmony reexport local */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_matcher__ = __webpack_require__(314);
/* unused harmony reexport matcher */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_mouse__ = __webpack_require__(637);
/* unused harmony reexport mouse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_namespace__ = __webpack_require__(196);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_namespaces__ = __webpack_require__(197);
/* unused harmony reexport namespaces */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_select__ = __webpack_require__(638);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__src_select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_selectAll__ = __webpack_require__(639);
/* unused harmony reexport selectAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_selection_index__ = __webpack_require__(33);
/* unused harmony reexport selection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_selector__ = __webpack_require__(200);
/* unused harmony reexport selector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_selectorAll__ = __webpack_require__(318);
/* unused harmony reexport selectorAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_selection_style__ = __webpack_require__(317);
/* unused harmony reexport style */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_touch__ = __webpack_require__(666);
/* unused harmony reexport touch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_touches__ = __webpack_require__(667);
/* unused harmony reexport touches */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_window__ = __webpack_require__(202);
/* unused harmony reexport window */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_selection_on__ = __webpack_require__(199);
/* unused harmony reexport event */
/* unused harmony reexport customEvent */


















/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
var nextId = 0;

function local() {
  return new Local;
}

function Local() {
  this._ = "@" + (++nextId).toString(36);
}

Local.prototype = local.prototype = {
  constructor: Local,
  get: function(node) {
    var id = this._;
    while (!(id in node)) if (!(node = node.parentNode)) return;
    return node[id];
  },
  set: function(node, value) {
    return node[this._] = value;
  },
  remove: function(node) {
    return this._ in node && delete node[this._];
  },
  toString: function() {
    return this._;
  }
};


/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(198);



/* unused harmony default export */ var _unused_webpack_default_export = (function(node) {
  var event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])();
  if (event.changedTouches) event = event.changedTouches[0];
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, event);
});


/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__(33);


/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([[document.querySelector(selector)]], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([[selector]], __WEBPACK_IMPORTED_MODULE_0__selection_index__["b" /* root */]);
});


/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__(33);


/* unused harmony default export */ var _unused_webpack_default_export = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([document.querySelectorAll(selector)], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["a" /* Selection */]([selector == null ? [] : selector], __WEBPACK_IMPORTED_MODULE_0__selection_index__["b" /* root */]);
});


/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(195);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var create = typeof name === "function" ? name : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
});


/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__(196);


function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var fullname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" /* default */])(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)
      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
});


/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
});


/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
});


/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enter__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(635);




var keyPrefix = "$"; // Protect against keys like “__proto__”.

function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["b" /* EnterNode */](parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = {},
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
      if (keyValue in nodeByKeyValue) {
        exit[i] = node;
      } else {
        nodeByKeyValue[keyValue] = node;
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = keyPrefix + key.call(parent, data[i], i, data);
    if (node = nodeByKeyValue[keyValue]) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue[keyValue] = null;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["b" /* EnterNode */](parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
      exit[i] = node;
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (function(value, key) {
  if (!value) {
    data = new Array(this.size()), j = -1;
    this.each(function(d) { data[++j] = d; });
    return data;
  }

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = value.call(parent, parent && parent.__data__, j, parents),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
});


/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
});


/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__(202);


function dispatchEvent(node, type, params) {
  var window = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__window__["a" /* default */])(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
});


/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
});


/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return !this.node();
});


/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(33);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["a" /* Selection */](this._exit || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" /* default */]), this._parents);
});


/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matcher__ = __webpack_require__(314);



/* harmony default export */ __webpack_exports__["a"] = (function(match) {
  if (typeof match !== "function") match = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__matcher__["a" /* default */])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, this._parents);
});


/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
});


/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(200);



function constantNull() {
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, before) {
  var create = typeof name === "function" ? name : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name),
      select = before == null ? constantNull : typeof before === "function" ? before : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* default */])(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
});


/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(lower);
});


/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(33);


/* harmony default export */ __webpack_exports__["a"] = (function(selection) {

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](merges, this._parents);
});


/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
});


/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes = new Array(this.size()), i = -1;
  this.each(function() { nodes[++i] = this; });
  return nodes;
});


/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
});


/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
});


/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(raise);
});


/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(remove);
});


/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(200);



/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, this._parents);
});


/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectorAll__ = __webpack_require__(318);



/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__selectorAll__["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](subgroups, parents);
});


/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
});


/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(33);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (!compare) compare = ascending;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* Selection */](sortgroups, this._parents).order();
});

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function textRemove() {
  this.textContent = "";
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction
          : textConstant)(value))
      : this.node().textContent;
});


/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(198);



/* unused harmony default export */ var _unused_webpack_default_export = (function(node, touches, identifier) {
  if (arguments.length < 3) identifier = touches, touches = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])().changedTouches;

  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
    if ((touch = touches[i]).identifier === identifier) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, touch);
    }
  }

  return null;
});


/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(198);



/* unused harmony default export */ var _unused_webpack_default_export = (function(node, touches) {
  if (touches == null) touches = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])().touches;

  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
    points[i] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, touches[i]);
  }

  return points;
});


/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_arc__ = __webpack_require__(669);
/* unused harmony reexport arc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_area__ = __webpack_require__(319);
/* unused harmony reexport area */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_line__ = __webpack_require__(204);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_line__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_pie__ = __webpack_require__(690);
/* unused harmony reexport pie */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_areaRadial__ = __webpack_require__(670);
/* unused harmony reexport areaRadial */
/* unused harmony reexport radialArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_lineRadial__ = __webpack_require__(324);
/* unused harmony reexport lineRadial */
/* unused harmony reexport radialLine */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_pointRadial__ = __webpack_require__(325);
/* unused harmony reexport pointRadial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_link_index__ = __webpack_require__(682);
/* unused harmony reexport linkHorizontal */
/* unused harmony reexport linkVertical */
/* unused harmony reexport linkRadial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_symbol__ = __webpack_require__(692);
/* unused harmony reexport symbol */
/* unused harmony reexport symbols */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_symbol_circle__ = __webpack_require__(326);
/* unused harmony reexport symbolCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_symbol_cross__ = __webpack_require__(327);
/* unused harmony reexport symbolCross */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_symbol_diamond__ = __webpack_require__(328);
/* unused harmony reexport symbolDiamond */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_symbol_square__ = __webpack_require__(329);
/* unused harmony reexport symbolSquare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_symbol_star__ = __webpack_require__(330);
/* unused harmony reexport symbolStar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_symbol_triangle__ = __webpack_require__(331);
/* unused harmony reexport symbolTriangle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_symbol_wye__ = __webpack_require__(332);
/* unused harmony reexport symbolWye */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_curve_basisClosed__ = __webpack_require__(671);
/* unused harmony reexport curveBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_curve_basisOpen__ = __webpack_require__(672);
/* unused harmony reexport curveBasisOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_curve_basis__ = __webpack_require__(138);
/* unused harmony reexport curveBasis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_curve_bundle__ = __webpack_require__(673);
/* unused harmony reexport curveBundle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_curve_cardinalClosed__ = __webpack_require__(321);
/* unused harmony reexport curveCardinalClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_curve_cardinalOpen__ = __webpack_require__(322);
/* unused harmony reexport curveCardinalOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_curve_cardinal__ = __webpack_require__(139);
/* unused harmony reexport curveCardinal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_curve_catmullRomClosed__ = __webpack_require__(674);
/* unused harmony reexport curveCatmullRomClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_curve_catmullRomOpen__ = __webpack_require__(675);
/* unused harmony reexport curveCatmullRomOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_curve_catmullRom__ = __webpack_require__(203);
/* unused harmony reexport curveCatmullRom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_curve_linearClosed__ = __webpack_require__(676);
/* unused harmony reexport curveLinearClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_curve_linear__ = __webpack_require__(140);
/* unused harmony reexport curveLinear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__ = __webpack_require__(677);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_28__src_curve_monotone__["a"]; });
/* unused harmony reexport curveMonotoneY */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__src_curve_natural__ = __webpack_require__(678);
/* unused harmony reexport curveNatural */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__src_curve_step__ = __webpack_require__(679);
/* unused harmony reexport curveStep */
/* unused harmony reexport curveStepAfter */
/* unused harmony reexport curveStepBefore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__src_stack__ = __webpack_require__(691);
/* unused harmony reexport stack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__src_offset_expand__ = __webpack_require__(684);
/* unused harmony reexport stackOffsetExpand */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__src_offset_diverging__ = __webpack_require__(683);
/* unused harmony reexport stackOffsetDiverging */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__src_offset_none__ = __webpack_require__(111);
/* unused harmony reexport stackOffsetNone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__src_offset_silhouette__ = __webpack_require__(685);
/* unused harmony reexport stackOffsetSilhouette */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__src_offset_wiggle__ = __webpack_require__(686);
/* unused harmony reexport stackOffsetWiggle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__src_order_ascending__ = __webpack_require__(205);
/* unused harmony reexport stackOrderAscending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__src_order_descending__ = __webpack_require__(687);
/* unused harmony reexport stackOrderDescending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__src_order_insideOut__ = __webpack_require__(688);
/* unused harmony reexport stackOrderInsideOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__src_order_none__ = __webpack_require__(112);
/* unused harmony reexport stackOrderNone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__src_order_reverse__ = __webpack_require__(689);
/* unused harmony reexport stackOrderReverse */




 // Note: radialArea is deprecated!
 // Note: radialLine is deprecated!









































/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(110);




function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sqrt */])(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sqrt */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* max */])(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["f" /* halfPi */],
        a1 = endAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["f" /* halfPi */],
        da = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* abs */])(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */])) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > __WEBPACK_IMPORTED_MODULE_2__math__["c" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
      context.moveTo(r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a0), r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        context.moveTo(r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a1), r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) && (padRadius ? +padRadius.apply(this, arguments) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sqrt */])(r0 * r0 + r1 * r1)),
          rc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["j" /* min */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["g" /* abs */])(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        var p0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* asin */])(rp / r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(ap)),
            p1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* asin */])(rp / r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(ap));
        if ((da0 -= p0 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a01),
          y01 = r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a01),
          x10 = r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a10),
          y10 = r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a10);

      // Apply rounded corners?
      if (rc > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        var x11 = r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a11),
            y11 = r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a11),
            x00 = r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a00),
            y00 = r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a00);

        // Restrict the corner radius according to the sector angle.
        if (da < __WEBPACK_IMPORTED_MODULE_2__math__["b" /* pi */]) {
          var oc = da0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */] ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
              ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* acos */])((ax * bx + ay * by) / (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sqrt */])(ax * ax + ay * ay) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sqrt */])(bx * bx + by * by))) / 2),
              lc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sqrt */])(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["j" /* min */])(rc, (r0 - lc) / (kc - 1));
          rc1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["j" /* min */])(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */])) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.y01, t0.x01), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.y01, t0.x01), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.y11, t1.x11), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) || !(da0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */])) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* epsilon */]) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.y01, t0.x01), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.y01, t0.x01), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.y11, t1.x11), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["m" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - __WEBPACK_IMPORTED_MODULE_2__math__["b" /* pi */] / 2;
    return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* cos */])(a) * r, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* sin */])(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
});


/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lineRadial__ = __webpack_require__(324);




/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__area__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* curveRadialLinear */]),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* default */])(_)) : c()._curve;
  };

  return a;
});


/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(138);



function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__basis__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (function(context) {
  return new BasisClosed(context);
});


/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(138);


function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__basis__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (function(context) {
  return new BasisOpen(context);
});


/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(138);


function Bundle(context, beta) {
  this._basis = new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85));


/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__catmullRom__ = __webpack_require__(203);




function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__catmullRom__["a" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__["a" /* CardinalClosed */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__catmullRom__ = __webpack_require__(203);



function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__catmullRom__["a" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__["a" /* CardinalOpen */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(141);


function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (function(context) {
  return new LinearClosed(context);
});


/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = monotoneX;
/* unused harmony export monotoneY */
function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
}

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}


/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(context) {
  return new Natural(context);
});


/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stepBefore */
/* unused harmony export stepAfter */
function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (function(context) {
  return new Step(context, 0.5);
});

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}


/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  return d;
});


/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export linkHorizontal */
/* unused harmony export linkVertical */
/* unused harmony export linkRadial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pointRadial__ = __webpack_require__(325);






function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link(curve) {
  var source = linkSource,
      target = linkTarget,
      x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      context = null;

  function link() {
    var buffer, argv = __WEBPACK_IMPORTED_MODULE_1__array__["a" /* slice */].call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
    if (!context) context = buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function(_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function(_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : x;
  };

  link.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : y;
  };

  link.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function curveRadial(context, x0, y0, x1, y1) {
  var p0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0),
      p1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0 = (y0 + y1) / 2),
      p2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y0),
      p3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link(curveHorizontal);
}

function linkVertical() {
  return link(curveVertical);
}

function linkRadial() {
  var l = link(curveRadial);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}


/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = yp;
      }
    }
  }
});


/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(111);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(111);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(111);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(205);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ascending__["b" /* default */])(series).reverse();
});


/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(205);



/* unused harmony default export */ var _unused_webpack_default_export = (function(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* sum */]),
      order = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[b] - sums[a]; }),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
});


/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(112);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).reverse();
});


/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__descending__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(110);





/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_2__identity__["a" /* default */],
      sortValues = __WEBPACK_IMPORTED_MODULE_1__descending__["a" /* default */],
      sort = null,
      startAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0),
      endAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__math__["c" /* tau */]),
      padAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(__WEBPACK_IMPORTED_MODULE_3__math__["c" /* tau */], Math.max(-__WEBPACK_IMPORTED_MODULE_3__math__["c" /* tau */], endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : padAngle;
  };

  return pie;
});


/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__offset_none__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__order_none__ = __webpack_require__(112);





function stackValue(d, key) {
  return d[key];
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var keys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([]),
      order = __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */],
      offset = __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */],
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */] : typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */] : _, stack) : offset;
  };

  return stack;
});


/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export symbols */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__symbol_circle__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_cross__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symbol_star__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__symbol_square__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__symbol_wye__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constant__ = __webpack_require__(69);










var symbols = [
  __WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_2__symbol_cross__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_5__symbol_square__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_4__symbol_star__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_7__symbol_wye__["a" /* default */]
];

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var type = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */]),
      size = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
});


/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isoFormat__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultLocale__ = __webpack_require__(207);



function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__defaultLocale__["b" /* utcParse */])(__WEBPACK_IMPORTED_MODULE_0__isoFormat__["a" /* isoSpecifier */]);

/* unused harmony default export */ var _unused_webpack_default_export = (parseIso);


/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export days */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(48);



var day = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationDay */];
}, function(date) {
  return date.getDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (day);
var days = day.range;


/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(48);



var hour = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  var offset = date.getTimezoneOffset() * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */] % __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
  if (offset < 0) offset += __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
  date.setTime(Math.floor((+date - offset) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */] + offset);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
}, function(date) {
  return date.getHours();
});

/* harmony default export */ __webpack_exports__["a"] = (hour);
var hours = hour.range;


/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export milliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(21);


var millisecond = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (millisecond);
var milliseconds = millisecond.range;


/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export minutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(48);



var minute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */];
}, function(date) {
  return date.getMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (minute);
var minutes = minute.range;


/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export months */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(21);


var month = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (month);
var months = month.range;


/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export seconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(48);



var second = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */];
}, function(date) {
  return date.getUTCSeconds();
});

/* harmony default export */ __webpack_exports__["a"] = (second);
var seconds = second.range;


/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(48);



var utcDay = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationDay */];
}, function(date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (utcDay);
var utcDays = utcDay.range;


/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(48);



var utcHour = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
}, function(date) {
  return date.getUTCHours();
});

/* harmony default export */ __webpack_exports__["a"] = (utcHour);
var utcHours = utcHour.range;


/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(48);



var utcMinute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */];
}, function(date) {
  return date.getUTCMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMinute);
var utcMinutes = utcMinute.range;


/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(21);


var utcMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMonth);
var utcMonths = utcMonth.range;


/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcSunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcMonday; });
/* unused harmony export utcTuesday */
/* unused harmony export utcWednesday */
/* unused harmony export utcThursday */
/* unused harmony export utcFriday */
/* unused harmony export utcSaturday */
/* unused harmony export utcSundays */
/* unused harmony export utcMondays */
/* unused harmony export utcTuesdays */
/* unused harmony export utcWednesdays */
/* unused harmony export utcThursdays */
/* unused harmony export utcFridays */
/* unused harmony export utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(48);



function utcWeekday(i) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationWeek */];
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;


/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(21);


var utcYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (utcYear);
var utcYears = utcYear.range;


/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return monday; });
/* unused harmony export tuesday */
/* unused harmony export wednesday */
/* unused harmony export thursday */
/* unused harmony export friday */
/* unused harmony export saturday */
/* unused harmony export sundays */
/* unused harmony export mondays */
/* unused harmony export tuesdays */
/* unused harmony export wednesdays */
/* unused harmony export thursdays */
/* unused harmony export fridays */
/* unused harmony export saturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(48);



function weekday(i) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationWeek */];
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;


/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export years */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(21);


var year = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (year);
var years = year.range;


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(210);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var off = function off() {};
if (_inDOM2.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

exports.default = off;
module.exports = exports['default'];

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(210);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var on = function on() {};
if (_inDOM2.default) {
  on = function () {

    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

exports.default = on;
module.exports = exports['default'];

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(210);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM2.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);

  return false;
}
module.exports = exports['default'];

/***/ }),
/* 711 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 712 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 713 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 714 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var camelize = __webpack_require__(715);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var isTextNode = __webpack_require__(725);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var invariant = __webpack_require__(3);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(23);

var createArrayFromMixed = __webpack_require__(718);
var getMarkupWrap = __webpack_require__(720);
var invariant = __webpack_require__(3);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(23);

var invariant = __webpack_require__(3);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(722);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var isNode = __webpack_require__(724);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _lodashCollectionShuffle = __webpack_require__(776);

var _lodashCollectionShuffle2 = _interopRequireDefault(_lodashCollectionShuffle);

var _lodashCollectionSample = __webpack_require__(368);

var _lodashCollectionSample2 = _interopRequireDefault(_lodashCollectionSample);

exports['default'] = { shuffle: _lodashCollectionShuffle2['default'], sample: _lodashCollectionSample2['default'] };
module.exports = exports['default'];

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = __webpack_require__(56)['default'];

var _classCallCheck = __webpack_require__(24)['default'];

var _slicedToArray = __webpack_require__(16)['default'];

var _getIterator = __webpack_require__(8)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
function sorter(a, b) {
  return b[0] - a[0];
}

/**
 * A simple priority queue implementation.
 */

var PriorityQueue = (function () {

  /**
   * Accepts an iterable that emits `[priority, value]` pairs. Iterates over the
   * iterable only once.
   *
   * `priority` must be a number.
   *
   * @param {Iterable} iterable
   */

  function PriorityQueue(iterable) {
    _classCallCheck(this, PriorityQueue);

    this._values = [];
    if (iterable != null) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _getIterator(iterable), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2);

          var priority = _step$value[0];
          var value = _step$value[1];

          this._values.push([priority, value]);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator['return']) {
            _iterator['return']();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this._values.sort(sorter);
    }
  }

  _createClass(PriorityQueue, [{
    key: 'enqueue',

    /**
     * Adds a value to the queue. It will be inserted into the queue according to
     * `priority`.
     *
     * @param {number} priority
     * @param {*} value
     */
    value: function enqueue(priority, value) {
      this._values.push([priority, value]);
      this._values.sort(sorter);
    }
  }, {
    key: 'dequeue',

    /**
     * Removes and returns the smallest [priority, value] tuple from the queue.
     *
     * @return {?}
     */
    value: function dequeue() {
      return this._values.pop();
    }
  }, {
    key: 'size',

    /**
     * Returns the current size of the queue.
     *
     * @return {number}
     */
    get: function get() {
      return this._values.length;
    }
  }]);

  return PriorityQueue;
})();

exports['default'] = PriorityQueue;
module.exports = exports['default'];

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = global.Worker;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _lodashLangClone = __webpack_require__(806);

var _lodashLangClone2 = _interopRequireDefault(_lodashLangClone);

exports['default'] = _lodashLangClone2['default'];
module.exports = exports['default'];

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*jshint latedef:false*/


var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = deepcopy;

var _lodashInternalBaseClone = __webpack_require__(371);

var _lodashInternalBaseClone2 = _interopRequireDefault(_lodashInternalBaseClone);

var _isGraph = __webpack_require__(212);

var _isGraph2 = _interopRequireDefault(_isGraph);

var _isMap = __webpack_require__(344);

var _isMap2 = _interopRequireDefault(_isMap);

var _isSet = __webpack_require__(740);

var _isSet2 = _interopRequireDefault(_isSet);

function deepcopyInstance(obj, stackA, stackB) {
  // temporary constructor, we don't know if the original expects
  // parameter
  /**
   * @constructor
   */
  var T_ = function T_() {};
  T_.prototype = obj.constructor.prototype;
  var ownProps = {};
  var prop;
  var instance;

  // collect instance properties
  for (prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      ownProps[prop] = obj[prop];
    }
  }

  // deepcopy them
  ownProps = deepcopyImplementation(ownProps, stackA, stackB);

  // create a new instance and assign properties
  instance = new T_();
  for (prop in ownProps) {
    instance[prop] = ownProps[prop];
  }

  return instance;
}

function deepcopyImplementation(value, stackA, stackB) {
  return (0, _lodashInternalBaseClone2['default'])(value, true, function (v) {
    if ((0, _isMap2['default'])(v) || (0, _isSet2['default'])(v) || (0, _isGraph2['default'])(v)) {
      var copy = deepcopyInstance(v, stackA, stackB);
      stackA.push(v);
      stackB.push(copy);
      return copy;
    }
  }, null, null, stackA, stackB);
}

/**
 * Creates a deep copy of the value, also of maps and sets.
 *
 * @param {*} value The value to be cloned
 * @return {?}
 */

function deepcopy(value) {
  return deepcopyImplementation(value, [], []);
}

module.exports = exports['default'];

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _lodashObjectMerge = __webpack_require__(811);

var _lodashObjectMerge2 = _interopRequireDefault(_lodashObjectMerge);

exports['default'] = _lodashObjectMerge2['default'];
module.exports = exports['default'];

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Promise = __webpack_require__(217)['default'];

var _Array$from = __webpack_require__(13)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = delegateSync;

var _WorkerSettings = __webpack_require__(340);

var _WorkerSettings2 = _interopRequireDefault(_WorkerSettings);

var _isIterator = __webpack_require__(87);

var _isIterator2 = _interopRequireDefault(_isIterator);

/**
 * DON'T CALL THIS FUNCTION EXPLICITLY. It's inserted by a transform.
 *
 * In environments that does not support workers, we are using this synchronous
 * version.
 *
 * @param {string} method The name on the root jsnx object to execute.
 * @param {Array} args An array of arguments to send to the worker.
 *    Some types, such as graphs, are converted to a different format first.
 * @return {Promise}
 */

function delegateSync(method, args) {
  return new _Promise(function (resolve, reject) {
    try {
      // We have to do the same here as we do in the worker, which is
      // returning an array if we get back an iterator
      var result = _WorkerSettings2['default'].methodLookupFunction(method).apply(null, args);
      if ((0, _isIterator2['default'])(result)) {
        result = _Array$from(result);
      }
      resolve(result);
    } catch (ex) {
      reject(ex);
    }
  });
}

module.exports = exports['default'];

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = gcd;
/**
 * Computes the greatest common divisor of two numbers using Euclid's algorithm.
 *
 * @param {number} a
 * @param {number} b
 * @return {number}
 */

function gcd(a, b) {
  while (b !== 0) {
    var _ = a;
    a = b;
    b = _ % b;
  }
  return a;
}

module.exports = exports['default'];

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regeneratorRuntime = __webpack_require__(19)['default'];

var _Array$from = __webpack_require__(13)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = genCombinations;
var marked0$0 = [genCombinations].map(_regeneratorRuntime.mark);

var _range = __webpack_require__(145);

var _range2 = _interopRequireDefault(_range);

function reversed(array) {
  return array.slice().reverse();
}

/**
 * Implements Python's itertools.combinations
 *
 * Return r length subsequences of elements from the input iterable.
 *
 * @param {Iterable} iterable
 * @param {number} r
 *
 * @return {Iterator}
 */

function genCombinations(iterable, r) {
  var pool, n, indicies, reversedIndicies, i, k, j;
  return _regeneratorRuntime.wrap(function genCombinations$(context$1$0) {
    while (1) switch (context$1$0.prev = context$1$0.next) {
      case 0:
        pool = _Array$from(iterable);
        n = pool.length;

        if (!(r > n)) {
          context$1$0.next = 4;
          break;
        }

        return context$1$0.abrupt('return');

      case 4:
        indicies = (0, _range2['default'])(r);
        reversedIndicies = reversed(indicies);
        context$1$0.next = 8;
        return indicies.map(function (i) {
          return pool[i];
        });

      case 8:
        if (false) {
          context$1$0.next = 26;
          break;
        }

        i = undefined;
        k = 0;

      case 11:
        if (!(k < reversedIndicies.length)) {
          context$1$0.next = 18;
          break;
        }

        i = reversedIndicies[k];

        if (!(indicies[i] !== i + n - r)) {
          context$1$0.next = 15;
          break;
        }

        return context$1$0.abrupt('break', 18);

      case 15:
        k++;
        context$1$0.next = 11;
        break;

      case 18:
        if (!(reversedIndicies.length === k)) {
          context$1$0.next = 20;
          break;
        }

        return context$1$0.abrupt('return');

      case 20:
        indicies[i] += 1;
        for (j = i + 1; j < r; j++) {
          indicies[j] = indicies[j - 1] + 1;
        }
        context$1$0.next = 24;
        return indicies.map(function (i) {
          return pool[i];
        });

      case 24:
        context$1$0.next = 8;
        break;

      case 26:
      case 'end':
        return context$1$0.stop();
    }
  }, marked0$0[0], this);
}

module.exports = exports['default'];

// genCombinations('ABCD', 2) --> AB AC AD BC BD CD
// genCombinations(range(4), 3) --> 012 013 023 123
// eslint-disable-line no-loop-func

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regeneratorRuntime = __webpack_require__(19)['default'];

var _Array$from = __webpack_require__(13)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = genPermutations;
var marked0$0 = [genPermutations].map(_regeneratorRuntime.mark);

var _range = __webpack_require__(145);

var _range2 = _interopRequireDefault(_range);

/**
 * Implements Python's itertools.permutations
 *
 * Return successive r length permutations of elements in the iterable.
 * *
 * @param {Iterable} iterable
 * @param {number=} opt_r
 *
 * @return {Iterator}
 */

function genPermutations(iterable, r) {
  var pool, n, indicies, cycles, rangeR, k, i, index, j;
  return _regeneratorRuntime.wrap(function genPermutations$(context$1$0) {
    while (1) switch (context$1$0.prev = context$1$0.next) {
      case 0:
        pool = _Array$from(iterable);
        n = pool.length;

        r = r == null ? n : r;

        if (!(r > n)) {
          context$1$0.next = 5;
          break;
        }

        return context$1$0.abrupt('return');

      case 5:
        indicies = (0, _range2['default'])(n);
        cycles = (0, _range2['default'])(n, n - r, -1);
        rangeR = (0, _range2['default'])(r - 1, -1, -1);
        context$1$0.next = 10;
        return indicies.slice(0, r).map(function (i) {
          return pool[i];
        });

      case 10:
        if (false) {
          context$1$0.next = 35;
          break;
        }

        k = 0;

      case 12:
        if (!(k < rangeR.length)) {
          context$1$0.next = 31;
          break;
        }

        i = rangeR[k];

        cycles[i] -= 1;
        index = indicies[i];

        if (!(cycles[i] === 0)) {
          context$1$0.next = 22;
          break;
        }

        indicies.splice(i, 1);
        indicies.push(index);
        cycles[i] = n - i;
        context$1$0.next = 28;
        break;

      case 22:
        j = cycles[i];

        indicies[i] = indicies[indicies.length - j];
        indicies[indicies.length - j] = index;
        context$1$0.next = 27;
        return indicies.slice(0, r).map(function (i) {
          return pool[i];
        });

      case 27:
        return context$1$0.abrupt('break', 31);

      case 28:
        k++;
        context$1$0.next = 12;
        break;

      case 31:
        if (!(rangeR.length === k)) {
          context$1$0.next = 33;
          break;
        }

        return context$1$0.abrupt('return');

      case 33:
        context$1$0.next = 10;
        break;

      case 35:
      case 'end':
        return context$1$0.stop();
    }
  }, marked0$0[0], this);
}

module.exports = exports['default'];

// genPermutations('ABCD', 2) --> AB AC AD BA BC BD CA CB CD DA DB DC
// genPermutations(range(3)) --> 012 021 102 120 201 210
/* eslint-disable no-loop-func */

/* eslint-enable no-loop-func */

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = get;
/**
 * Returns the second argument if the first argument is null or undefined.
 *
 * @param {*} value
 * @param {*} defaultValue
 * @return {?}
 */

function get(value, defaultValue) {
  return value == null ? defaultValue : value;
}

module.exports = exports['default'];

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _lodashLangIsBoolean = __webpack_require__(382);

var _lodashLangIsBoolean2 = _interopRequireDefault(_lodashLangIsBoolean);

exports['default'] = _lodashLangIsBoolean2['default'];
module.exports = exports['default'];

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = isSet;

var _Set = __webpack_require__(84);

var _Set2 = _interopRequireDefault(_Set);

/**
 * Tests whether the value is a Map.
 *
 * @param {*} v The value to test
 * @return {bool}
 */

function isSet(v) {
  return v instanceof _Set2['default'];
}

module.exports = exports['default'];

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _getIterator = __webpack_require__(8)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = mapSequence;

var _lodashLangIsPlainObject = __webpack_require__(149);

var _lodashLangIsPlainObject2 = _interopRequireDefault(_lodashLangIsPlainObject);

var _lodashObjectMapValues = __webpack_require__(384);

var _lodashObjectMapValues2 = _interopRequireDefault(_lodashObjectMapValues);

var _isArrayLike = __webpack_require__(85);

var _isArrayLike2 = _interopRequireDefault(_isArrayLike);

var _isIterable = __webpack_require__(86);

var _isIterable2 = _interopRequireDefault(_isIterable);

var _isIterator = __webpack_require__(87);

var _isIterator2 = _interopRequireDefault(_isIterator);

var _mapIterator = __webpack_require__(346);

var _mapIterator2 = _interopRequireDefault(_mapIterator);

var nativeMap = Array.prototype.map;

/**
 * Helper to map sequence types (arrays, array-like objects, objects, etc).
 * Note that if an array-like object is passed, an array is returned:
 *
 * Array -> Array
 * ArrayLike -> Array
 * Iterator -> Iterator
 * Iterable -> Iterator
 * Object -> Object
 *
 * @param {Iterable} sequence
 * @param {function(this:T,...)} callback
 * @param {T=} this_obj
 * @template T
 *
 * @return {(Array|Object|Iterator)}
 */

function mapSequence(sequence, callback, thisObj) {
  if ((0, _isArrayLike2['default'])(sequence)) {
    return nativeMap.call(sequence, callback, thisObj);
  } else if ((0, _isIterable2['default'])(sequence)) {
    sequence = _getIterator(sequence);
  }
  if ((0, _isIterator2['default'])(sequence)) {
    return (0, _mapIterator2['default'])(sequence, callback, thisObj);
  } else if ((0, _lodashLangIsPlainObject2['default'])(sequence)) {
    return (0, _lodashObjectMapValues2['default'])(sequence, callback, thisObj);
  } else {
    throw new TypeError('Can\'t map value of type %s', typeof sequence);
  }
}

module.exports = exports['default'];

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = max;

var _forEach = __webpack_require__(211);

var _forEach2 = _interopRequireDefault(_forEach);

/**
 * Returns the maximum value from an iterable. It uses the optional callback
 * function to determine the value to compare.
 *
 * @param {Iterable} iterable
 * @param {function(?): ?} map
 * @return {?}
 */

function max(iterable, map) {
  var maxComparisonValue = -Infinity;
  var maxValue;

  (0, _forEach2['default'])(iterable, function (value) {
    var comparisonValue = map ? map(value) : value;
    if (comparisonValue > maxComparisonValue) {
      maxComparisonValue = comparisonValue;
      maxValue = value;
    }
  });

  return maxValue;
}

module.exports = exports['default'];

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty = __webpack_require__(218)['default'];

var _slicedToArray = __webpack_require__(16)['default'];

var _Array$from = __webpack_require__(13)['default'];

var _getIterator = __webpack_require__(8)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

var _interopRequireWildcard = __webpack_require__(25)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.isSupported = isSupported;
exports.serialize = serialize;
exports.deserialize = deserialize;
exports.serializeAll = serializeAll;

var _isIterable = __webpack_require__(86);

var _isIterable2 = _interopRequireDefault(_isIterable);

var _isPlainObject = __webpack_require__(345);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _Map = __webpack_require__(70);

var _Map2 = _interopRequireDefault(_Map);

var _Set = __webpack_require__(84);

var _Set2 = _interopRequireDefault(_Set);

var _classes = __webpack_require__(358);

var classes = _interopRequireWildcard(_classes);

var KEY = '__type-jsnx__';

/**
 * @fileoverview
 * Helper methods to serialize and unserialize data for communicating with
 * workers.
 */

function serializeSet(value) {
  // istanbul ignore next

  var _ref;

  // TODO: serialize nested values
  return (_ref = {}, _defineProperty(_ref, KEY, 'Set'), _defineProperty(_ref, 'data', _Array$from(value.values())), _ref);
}

function deserializeSet(value) {
  return new _Set2['default'](value.data);
}

function serializeMap(value) {
  // istanbul ignore next

  var _ref2;

  return (_ref2 = {}, _defineProperty(_ref2, KEY, 'Map'), _defineProperty(_ref2, 'data', (function () {
    var _data = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = _getIterator(value), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _step$value = _slicedToArray(_step.value, 2);

        var k = _step$value[0];
        var v = _step$value[1];

        _data.push([k, serialize(v)]);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator['return']) {
          _iterator['return']();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return _data;
  })() //eslint-disable-line no-undef
  ), _ref2);
}

function deserializeMap(value) {
  return new _Map2['default'](value.data.map(function (kv) {
    return (kv[1] = deserialize(kv[1]), kv);
  }));
}

function serializeGraph(value) {
  // istanbul ignore next

  var _ref3;

  // TODO: serialize complex edge and node data
  return (_ref3 = {}, _defineProperty(_ref3, KEY, value.constructor.__name__), _defineProperty(_ref3, 'data', value.graph), _defineProperty(_ref3, 'nodes', _Array$from(value.node)), _defineProperty(_ref3, 'edges', value.edges(null, true)), _ref3);
}

function deserializeGraph(value) {
  var G = new classes[value[KEY]](value.edges, value.data);
  G.addNodesFrom(value.nodes);
  return G;
}

/**
 * Returns true if the value can be properly serialized, otherwise false.
 *
 * @param {*} value
 * @return {boolean}
 */

function isSupported(value) {
  var type = typeof value;
  return (
    // Primitives
    value == null || type === 'string' || type === 'number' || type === 'boolean' ||

    // Objects and arrays (we just assume they contain only primitives)
    (0, _isPlainObject2['default'])(value) || Array.isArray(value) ||

    // Our custom collections (shallow)
    value instanceof _Map2['default'] || value instanceof _Set2['default'] ||

    // Graphs
    value.constructor.__name__ === 'Graph' || value.constructor.__name__ === 'DiGraph' ||

    // Generic iterables
    (0, _isIterable2['default'])(value)
  );
}

function serialize(value) {
  // primitives
  var type = typeof value;
  if (!value || type === 'string' || type === 'number' || type === 'boolean') {
    return value;
  }
  // Collections
  if (value instanceof _Set2['default']) {
    return serializeSet(value);
  } else if (value instanceof _Map2['default']) {
    return serializeMap(value);
  }
  // Graphs
  else if (value.constructor.__name__ === 'Graph' || value.constructor.__name__ === 'DiGraph') {
    return serializeGraph(value);
  }
  // Iterables
  else if ((0, _isIterable2['default'])(value)) {
    // We keep it simple for now and don't serialize the values of the iterable
    // itself
    return _Array$from(value);
  }
  // TODO: Handle arrays and objects better

  // default
  return value;
}

function deserialize(value) {
  // primitives
  var type = typeof value;
  if (!value || type === 'string' || type === 'number' || type === 'boolean') {
    return value;
  }
  // custom serializtion?
  if (value[KEY]) {
    switch (value[KEY]) {
      case 'Map':
        return deserializeMap(value);
      case 'Set':
        return deserializeSet(value);
      case 'Graph':
      case 'DiGraph':
        return deserializeGraph(value);
    }
  }
  // TODO: Handle arrays and objects better

  // default
  return value;
}

/**
 * Serialize an array of values (e.g. arguments passed to a method).,
 *
 * @param {Array} values
 * @return {{serializable: bool, values: Array}}
 */

function serializeAll() {
  var values = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];

  var serializedValues = new Array(values.length);
  var serializable = values.every(function (value, i) {
    var supported = isSupported(value);
    if (supported) {
      serializedValues[i] = serialize(value);
    }
    return supported;
  });

  return { serializable: serializable, serializedValues: serializedValues };
}

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = next;
/**
 * Returns the next value of an iterator or throws an error if the iterator was
 * already consumed.
 *
 * @param {Iterator} iterator
 * @return {?}
 */

function next(iterator) {
  var result = iterator.next();
  if (result.done) {
    throw new Error('Iterator is already exhausted');
  }
  return result.value;
}

module.exports = exports['default'];

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = nodesAreEqual;
/**
 * Returns true if the two values are equal node values. If the values are
 * primitives, they are compared directly. If they are objects, their string
 * representation is compared.
 *
 * @param {Node} a
 * @param {Node} b
 * @return {boolean}
 */

function nodesAreEqual(a, b) {
  return a === b || typeof a === 'object' && a.toString() === b.toString();
}

module.exports = exports['default'];

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = size;

var _isArrayLike = __webpack_require__(85);

var _isArrayLike2 = _interopRequireDefault(_isArrayLike);

var _isGraph = __webpack_require__(212);

var _isGraph2 = _interopRequireDefault(_isGraph);

var _lodashLangIsPlainObject = __webpack_require__(149);

var _lodashLangIsPlainObject2 = _interopRequireDefault(_lodashLangIsPlainObject);

var _lodashCollectionSize = __webpack_require__(369);

var _lodashCollectionSize2 = _interopRequireDefault(_lodashCollectionSize);

/**
 * Returns the number of elements in the container. That is
 * the number of elements in the array or object or the length
 * of a string.
 *
 * @param {(string|Object|ArrayLike|Graph)} obj
 *    Object to determine the length of
 *
 * @return {number} The number of elements
 * @throws {TypeError} When length cannot be determined
 */

function size(obj) {
  if ((0, _isGraph2['default'])(obj)) {
    return obj.numberOfNodes();
  } else if (typeof obj === 'string' || (0, _isArrayLike2['default'])(obj)) {
    return obj.length;
  } else if ((0, _lodashLangIsPlainObject2['default'])(obj)) {
    return (0, _lodashCollectionSize2['default'])(obj);
  } else {
    throw new TypeError('Expected a graph object, array, string or object, but got %s instead', typeof obj);
  }
}

module.exports = exports['default'];

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _getIterator = __webpack_require__(8)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = someIterator;
/**
 * Returns true if the callback function returns true for any of the elements
 * of the iterator.
 *
 * @param {Iterator} iterator
 * @param {function} callback
 * @return {boolean}
 */

function someIterator(iterator, callback) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _getIterator(iterator), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var value = _step.value;

      if (callback(value)) {
        return true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator['return']) {
        _iterator['return']();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return false;
}

module.exports = exports['default'];

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.tuple2 = tuple2;
exports.tuple3 = tuple3;
exports.tuple4 = tuple4;
exports.tuple2c = tuple2c;
exports.tuple3c = tuple3c;
exports.tuple4c = tuple4c;
exports.createTupleFactory = createTupleFactory;
var t2 = new Array(2);
var t3 = new Array(3);
var t4 = new Array(4);

/**
 * This function always returns the same instance of an array for a given number
 * of arguments.
 * It should be used instead of creating temporary arrays, if the arrays are
 * consumed immediately anyways.
 *
 * @param {...*} var_args The elemens of the tuple
 * @return {Array}
 */

function tuple2(x, y) {
  t2[0] = x;
  t2[1] = y;
  return t2;
}

function tuple3(x, y, z) {
  t3[0] = x;
  t3[1] = y;
  t3[2] = z;
  return t3;
}

function tuple4(a, b, c, d) {
  t4[0] = a;
  t4[1] = b;
  t4[2] = c;
  t4[3] = d;
  return t4;
}

/**
 * Same as tuple2, but sets the values on container instead of the allocated
 * array here. Useful to reuse an existing array.
 *
 * @param {...*} var_args The elemens of the tuple
 * @param {Array} opt_container If present, set values there instead
 * @return {Array}
 */

function tuple2c(x, y, container) {
  container.length = 2;
  container[0] = x;
  container[1] = y;
  return container;
}

function tuple3c(x, y, z, container) {
  container.length = 3;
  container[0] = x;
  container[1] = y;
  container[2] = z;
  return container;
}

function tuple4c(a, b, c, d, container) {
  container.length = 4;
  container[0] = a;
  container[1] = b;
  container[2] = c;
  container[3] = d;
  return container;
}

function createTupleFactory(count) {
  var t = new Array(count);
  switch (count) {
    case 2:
      return function (a, b) {
        t[0] = a;
        t[1] = b;
        return t;
      };
    case 3:
      return function (a, b, c) {
        t[0] = a;
        t[1] = b;
        t[2] = c;
        return t;
      };
    default:
      throw new Error('Typle size not supported.');
  }
}

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = zipSequence;

var _isArrayLike = __webpack_require__(85);

var _isArrayLike2 = _interopRequireDefault(_isArrayLike);

var _isIterator = __webpack_require__(87);

var _isIterator2 = _interopRequireDefault(_isIterator);

var _zipIterator = __webpack_require__(349);

var _zipIterator2 = _interopRequireDefault(_zipIterator);

function zipArray() {
  for (var _len = arguments.length, varArgs = Array(_len), _key = 0; _key < _len; _key++) {
    varArgs[_key] = arguments[_key];
  }

  // Pre-allocation arrays speeds up assignment drastically, so we want to
  // optimize for that case
  var length = varArgs.length;
  var min = Infinity;
  var i;
  var result;
  var nextZip = new Array(length);

  // first pass
  for (i = 0; i < length; i++) {
    var array = varArgs[i];
    var arrayLength = array.length;
    if (arrayLength < min) {
      min = arrayLength;
      if (min === 0) {
        return []; // backout early
      }
    }
    nextZip[i] = array[0];
  }
  result = new Array(min);
  result[0] = nextZip;

  for (i = 1; i < min; i++) {
    nextZip = new Array(length);
    for (var j = 0; j < length; j++) {
      nextZip[j] = varArgs[j][i];
    }
    result[i] = nextZip;
  }
  return result;
}

/**
 * Helper to zip sequence types (arrays, array-like objects, objects, etc).
 * All arguments must be the same type. The first argument is used to determine
 * the type.
 * This behaves the same as Python's zip function, i.e. the result has the
 * length of the shortest input.
 *
 * Array -> Array
 * Array-like -> Array
 * Iterator -> Iterator
 *
 * @param {...(Iterable)} var_args
 *
 * @return {!(Array|Iterator)}
 */

function zipSequence() {
  for (var _len2 = arguments.length, varArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    varArgs[_key2] = arguments[_key2];
  }

  var first = varArgs[0];

  if ((0, _isArrayLike2['default'])(first)) {
    return zipArray.apply(null, varArgs);
  } else if ((0, _isIterator2['default'])(first)) {
    return _zipIterator2['default'].apply(null, varArgs);
  } else {
    throw new TypeError('Expected an iterator, array-like object or object, but got %s instead', first);
  }
}

module.exports = exports['default'];

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(16)['default'];

var _regeneratorRuntime = __webpack_require__(19)['default'];

var _getIterator = __webpack_require__(8)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.betweennessCentrality = betweennessCentrality;
exports.genBetweennessCentrality = genBetweennessCentrality;
exports.edgeBetweennessCentrality = edgeBetweennessCentrality;
exports.genEdgeBetweennessCentrality = genEdgeBetweennessCentrality;

var _internalsDelegate = __webpack_require__(27);

var _internalsDelegate2 = _interopRequireDefault(_internalsDelegate);

var _internals = __webpack_require__(15);

/*eslint max-len:[1, 94]*/
'use strict';

/**
 * Compute the shortest-path betweenness centrality for nodes.
 *
 * Betweenness centrality of a node `$v$` is the sum of the
 * fraction of all-pairs shortest paths that pass through `$v$`:
 *
 * ```math
 * c_B(v) = \sum_{s,t \in V} \frac{\sigma(s, t|v)}{\sigma(s, t)}
 * ```
 *
 * where `$V$` is the set of nodes, `$\sigma(s, t)$` is the number of
 * shortest `$(s, t)$`-paths,  and `$\sigma(s, t|v)$` is the number of those
 * paths  passing through some  node `$v$` other than `$s, t$`.
 * If `$s = t$`, `$\sigma(s, t) = 1$`, and if `$v \in {s, t}$`,
 * `$\sigma(s, t|v) = 0$` ([2][]).
 *
 * ### Notes
 *
 * The algorithm is from Ulrik Brandes ([1][]):
 *
 * See ([2][]) for details on algorithms for variations and related metrics.
 *
 * For approximate betweenness calculations set `k=#samples` to use
 * `k` nodes ("pivots") to estimate the betweenness values. For an estimate
 * of the number of pivots needed see ([3][]).
 *
 * For weighted graphs the edge weights must be greater than zero.
 * Zero edge weights can produce an infinite number of equal length
 * paths between pairs of nodes.
 *
 * ### References
 *
 * [1] [A Faster Algorithm for Betweenness Centrality.
 *    Ulrik Brandes,
 *    Journal of Mathematical Sociology 25(2):163-177, 2001.][1]
 * [1]: http://www.inf.uni-konstanz.de/algo/publications/b-fabc-01.pdf
 *
 * [2] [Ulrik Brandes: On Variants of Shortest-Path Betweenness
 *    Centrality and their Generic Computation.
 *    Social Networks 30(2):136-145, 2008.][2]
 * [2]: http://www.inf.uni-konstanz.de/algo/publications/b-vspbc-08.pdf
 *
 * [3] [Ulrik Brandes and Christian Pich:
 *    Centrality Estimation in Large Networks.
 *    International Journal of Bifurcation and Chaos 17(7):2303-2318, 2007.][3]
 * [3]: http://www.inf.uni-konstanz.de/algo/publications/bp-celn-06.pdf
 *
 * @see edgeBetweennessCentrality
 * @see loadCentrality
 *
 * @param {!Graph} G A JSNetworkX graph
 * @param {{k: ?number, normalized: ?bool, weight: ?string,endpoints: ?bool}=} optParameters
 *   - `k` (int)
 *
 *     If `k` is defined use `k` node samples to estimate betweenness.
 *     The value of `k <= n` where `n` is the number of nodes in the graph.
 *     Higher values give better approximation.
 *   - `normalized` (bool)
 *
 *     If `true`, the betweenness values are normalized by `2/((n-1)(n-2))`
 *     for graphs and `1/((n-1)(n-2))` for directed graphs where `n` is the
 *     number of nodes in G.
 *   - `weight` (default=null)
 *
 *     If null, all edge weights are considered equal.
 *     Otherwise holds the name of the edge attribute used as weight.
 *
 *   - `endpoints` (default=false)
 *
 *     If true include the endpoints in the shortest path counts.
 *
 * @return {Map} object with node keys with betweenness centrality as the value.
 */

function betweennessCentrality(G) {
  // istanbul ignore next

  var _this = this;

  var optArgDict = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  // TODO: Use destructuring defaults once 6to5 supports it
  // {k=null, normalized=true, weight=null, endpoints=false}
  var k = optArgDict.k;
  var normalized = optArgDict.normalized;
  var weight = optArgDict.weight;
  var endpoints = optArgDict.endpoints;

  normalized = normalized == null ? true : normalized;
  endpoints = endpoints == null ? false : endpoints;

  var v;
  var betweenness = new _internals.Map(_regeneratorRuntime.mark(function callee$1$0() {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _v;

    return _regeneratorRuntime.wrap(function callee$1$0$(context$2$0) {
      while (1) switch (context$2$0.prev = context$2$0.next) {
        case 0:
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _iteratorError = undefined;
          context$2$0.prev = 3;
          _iterator = _getIterator(G);

        case 5:
          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
            context$2$0.next = 12;
            break;
          }

          _v = _step.value;
          context$2$0.next = 9;
          return (0, _internals.tuple2)(_v, 0);

        case 9:
          _iteratorNormalCompletion = true;
          context$2$0.next = 5;
          break;

        case 12:
          context$2$0.next = 18;
          break;

        case 14:
          context$2$0.prev = 14;
          context$2$0.t0 = context$2$0['catch'](3);
          _didIteratorError = true;
          _iteratorError = context$2$0.t0;

        case 18:
          context$2$0.prev = 18;
          context$2$0.prev = 19;

          if (!_iteratorNormalCompletion && _iterator['return']) {
            _iterator['return']();
          }

        case 21:
          context$2$0.prev = 21;

          if (!_didIteratorError) {
            context$2$0.next = 24;
            break;
          }

          throw _iteratorError;

        case 24:
          return context$2$0.finish(21);

        case 25:
          return context$2$0.finish(18);

        case 26:
        case 'end':
          return context$2$0.stop();
      }
    }, callee$1$0, _this, [[3, 14, 18, 26], [19,, 21, 25]]);
  })());

  var nodes = G.nodes();
  if (k != null) {
    nodes = _internals.Arrays.sample(nodes, k);
  }

  nodes.forEach(function (s) {
    // single source shortest paths

    var _ref = weight == null ? singleSourceShortestPathBasic(G, s) : // use BFS
    singleSourceDijkstraPathBasic(G, s, weight);

    var _ref2 = _slicedToArray(_ref, 3);

    var S = _ref2[0];
    var P = _ref2[1];
    var sigma = _ref2[2];
    // use Dijkstra's algorithm
    // accumulation
    betweenness = endpoints ? accumulateEndpoints(betweenness, S, P, sigma, s) : accumulateBasic(betweenness, S, P, sigma, s);
  });
  // rescaling
  return rescale(betweenness, G.order(), normalized, G.isDirected(), k);
}

function genBetweennessCentrality(G, optArgDict) {
  return (0, _internalsDelegate2['default'])('betweennessCentrality', [G, optArgDict]);
}

/**
 * Compute betweenness centrality for edges.
 *
 * Betweenness centrality of an edge `$e$` is the sum of the
 * fraction of all-pairs shortest paths that pass through `$e$`:
 *
 * ```math
 * c_B(v) = \sum_{s,t \in V} \frac{\sigma(s, t|e)}{\sigma(s, t)}
 * ```
 *
 * where `$V$` is the set of nodes, `$\sigma(s, t)$` is the number of
 * shortest `$(s, t)$`-paths, and `$\sigma(s, t|e)$` is the number of
 * those paths passing through edge `$e$` ([2][]).
 *
 * ### Notes
 *
 * The algorithm is from Ulrik Brandes ([1][]).
 *
 * For weighted graphs the edge weights must be greater than zero.
 * Zero edge weights can produce an infinite number of equal length
 * paths between pairs of nodes.
 *
 * ### References
 *
 * [1] [A Faster Algorithm for Betweenness Centrality. Ulrik Brandes,
 *    Journal of Mathematical Sociology 25(2):163-177, 2001.][1]
 * [1]: http://www.inf.uni-konstanz.de/algo/publications/b-fabc-01.pdf
 * [2] [Ulrik Brandes: On Variants of Shortest-Path Betweenness
 *    Centrality and their Generic Computation.
 *    Social Networks 30(2):136-145, 2008.][2]
 * [2]: http://www.inf.uni-konstanz.de/algo/publications/b-vspbc-08.pdf
 *
 * @see betweennessCentrality
 * @see edgeLoad
 *
 * @param {!Graph} G A NetworkX graph
 * @param {{normalized: bool=, weight: string=}=} optArgDict
 *   - `normalized` (default=false)
 *
 *     If true the betweenness values are normalized by `2/(n(n-1))`
 *     for graphs, and `1/(n(n-1))` for directed graphs where `n`
 *     is the number of nodes in G.
 *
 *   - `weight` (default=null)
 *
 *     If null, all edge weights are considered equal.
 *     Otherwise holds the name of the edge attribute used as weight.
 *
 * @return {Map} object with edge keys with betweenness centrality as the value.
*/

function edgeBetweennessCentrality(G) {
  // istanbul ignore next

  var _this2 = this;

  var optArgDict = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  // TODO: Use destructuring defaults once 6to5 supports it
  var normalized = optArgDict.normalized;
  var weight = optArgDict.weight;

  normalized = normalized == null ? true : normalized;

  var v;
  var betweenness = new _internals.Map(_regeneratorRuntime.mark(function callee$1$0() {
    var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _v2;

    return _regeneratorRuntime.wrap(function callee$1$0$(context$2$0) {
      while (1) switch (context$2$0.prev = context$2$0.next) {
        case 0:
          _iteratorNormalCompletion2 = true;
          _didIteratorError2 = false;
          _iteratorError2 = undefined;
          context$2$0.prev = 3;
          _iterator2 = _getIterator(G);

        case 5:
          if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
            context$2$0.next = 12;
            break;
          }

          _v2 = _step2.value;
          context$2$0.next = 9;
          return (0, _internals.tuple2)(_v2, 0);

        case 9:
          _iteratorNormalCompletion2 = true;
          context$2$0.next = 5;
          break;

        case 12:
          context$2$0.next = 18;
          break;

        case 14:
          context$2$0.prev = 14;
          context$2$0.t0 = context$2$0['catch'](3);
          _didIteratorError2 = true;
          _iteratorError2 = context$2$0.t0;

        case 18:
          context$2$0.prev = 18;
          context$2$0.prev = 19;

          if (!_iteratorNormalCompletion2 && _iterator2['return']) {
            _iterator2['return']();
          }

        case 21:
          context$2$0.prev = 21;

          if (!_didIteratorError2) {
            context$2$0.next = 24;
            break;
          }

          throw _iteratorError2;

        case 24:
          return context$2$0.finish(21);

        case 25:
          return context$2$0.finish(18);

        case 26:
        case 'end':
          return context$2$0.stop();
      }
    }, callee$1$0, _this2, [[3, 14, 18, 26], [19,, 21, 25]]);
  })());
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = _getIterator(G.edgesIter()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var edge = _step3.value;

      betweenness.set(edge, 0);
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3['return']) {
        _iterator3['return']();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = _getIterator(G), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var s = _step4.value;

      // single source shortest paths

      var _ref3 = weight == null ? singleSourceShortestPathBasic(G, s) : // use BFS
      singleSourceDijkstraPathBasic(G, s, weight);

      var _ref32 = _slicedToArray(_ref3, 3);

      var S = _ref32[0];
      var P = _ref32[1];
      var sigma = _ref32[2];
      // use Dijkstra's algorithm
      // accumulation
      betweenness = accumulateEdges(betweenness, S, P, sigma, s);
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4['return']) {
        _iterator4['return']();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  // rescaling
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = _getIterator(G), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var n = _step5.value;

      betweenness['delete'](n);
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5['return']) {
        _iterator5['return']();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  return rescaleE(betweenness, G.order(), normalized, G.isDirected());
}

function genEdgeBetweennessCentrality(G, optArgDict) {
  return (0, _internalsDelegate2['default'])('edgeBetweennessCentrality', [G, optArgDict]);
}

// helpers for betweenness centrality

function singleSourceShortestPathBasic(G, s) {
  // istanbul ignore next

  var _this3 = this;

  var S = [];
  var P = new _internals.Map(_regeneratorRuntime.mark(function callee$1$0() {
    var _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, _v3;

    return _regeneratorRuntime.wrap(function callee$1$0$(context$2$0) {
      while (1) switch (context$2$0.prev = context$2$0.next) {
        case 0:
          _iteratorNormalCompletion6 = true;
          _didIteratorError6 = false;
          _iteratorError6 = undefined;
          context$2$0.prev = 3;
          _iterator6 = _getIterator(G);

        case 5:
          if (_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done) {
            context$2$0.next = 12;
            break;
          }

          _v3 = _step6.value;
          context$2$0.next = 9;
          return (0, _internals.tuple2)(_v3, []);

        case 9:
          _iteratorNormalCompletion6 = true;
          context$2$0.next = 5;
          break;

        case 12:
          context$2$0.next = 18;
          break;

        case 14:
          context$2$0.prev = 14;
          context$2$0.t0 = context$2$0['catch'](3);
          _didIteratorError6 = true;
          _iteratorError6 = context$2$0.t0;

        case 18:
          context$2$0.prev = 18;
          context$2$0.prev = 19;

          if (!_iteratorNormalCompletion6 && _iterator6['return']) {
            _iterator6['return']();
          }

        case 21:
          context$2$0.prev = 21;

          if (!_didIteratorError6) {
            context$2$0.next = 24;
            break;
          }

          throw _iteratorError6;

        case 24:
          return context$2$0.finish(21);

        case 25:
          return context$2$0.finish(18);

        case 26:
        case 'end':
          return context$2$0.stop();
      }
    }, callee$1$0, _this3, [[3, 14, 18, 26], [19,, 21, 25]]);
  })());
  var sigma = new _internals.Map(_regeneratorRuntime.mark(function callee$1$0() {
    var _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, _v4;

    return _regeneratorRuntime.wrap(function callee$1$0$(context$2$0) {
      while (1) switch (context$2$0.prev = context$2$0.next) {
        case 0:
          _iteratorNormalCompletion7 = true;
          _didIteratorError7 = false;
          _iteratorError7 = undefined;
          context$2$0.prev = 3;
          _iterator7 = _getIterator(G);

        case 5:
          if (_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done) {
            context$2$0.next = 12;
            break;
          }

          _v4 = _step7.value;
          context$2$0.next = 9;
          return (0, _internals.tuple2)(_v4, 0);

        case 9:
          _iteratorNormalCompletion7 = true;
          context$2$0.next = 5;
          break;

        case 12:
          context$2$0.next = 18;
          break;

        case 14:
          context$2$0.prev = 14;
          context$2$0.t0 = context$2$0['catch'](3);
          _didIteratorError7 = true;
          _iteratorError7 = context$2$0.t0;

        case 18:
          context$2$0.prev = 18;
          context$2$0.prev = 19;

          if (!_iteratorNormalCompletion7 && _iterator7['return']) {
            _iterator7['return']();
          }

        case 21:
          context$2$0.prev = 21;

          if (!_didIteratorError7) {
            context$2$0.next = 24;
            break;
          }

          throw _iteratorError7;

        case 24:
          return context$2$0.finish(21);

        case 25:
          return context$2$0.finish(18);

        case 26:
        case 'end':
          return context$2$0.stop();
      }
    }, callee$1$0, _this3, [[3, 14, 18, 26], [19,, 21, 25]]);
  })());
  var D = new _internals.Map();

  sigma.set(s, 1);
  D.set(s, 0);
  var Q = [s];
  while (Q.length > 0) {
    // use BFS to find shortest paths
    var v = Q.shift();
    S.push(v);
    var Dv = D.get(v);
    var sigmav = sigma.get(v);
    /* eslint-disable no-loop-func */
    G.neighbors(v).forEach(function (w) {
      if (!D.has(w)) {
        Q.push(w);
        D.set(w, Dv + 1);
      }
      if (D.get(w) === Dv + 1) {
        // this is a shortest path, count paths
        sigma.set(w, sigma.get(w) + sigmav);
        P.get(w).push(v); // predecessors
      }
    });
    /* eslint-enable no-loop-func */
  }
  return [S, P, sigma];
}

function singleSourceDijkstraPathBasic(G, s) {
  // istanbul ignore next

  var _this4 = this;

  var weight = arguments.length <= 2 || arguments[2] === undefined ? 'weight' : arguments[2];

  // modified from Eppstein
  var S = [];
  var P = new _internals.Map(_regeneratorRuntime.mark(function callee$1$0() {
    var _iteratorNormalCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, _v5;

    return _regeneratorRuntime.wrap(function callee$1$0$(context$2$0) {
      while (1) switch (context$2$0.prev = context$2$0.next) {
        case 0:
          _iteratorNormalCompletion8 = true;
          _didIteratorError8 = false;
          _iteratorError8 = undefined;
          context$2$0.prev = 3;
          _iterator8 = _getIterator(G);

        case 5:
          if (_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done) {
            context$2$0.next = 12;
            break;
          }

          _v5 = _step8.value;
          context$2$0.next = 9;
          return (0, _internals.tuple2)(_v5, []);

        case 9:
          _iteratorNormalCompletion8 = true;
          context$2$0.next = 5;
          break;

        case 12:
          context$2$0.next = 18;
          break;

        case 14:
          context$2$0.prev = 14;
          context$2$0.t0 = context$2$0['catch'](3);
          _didIteratorError8 = true;
          _iteratorError8 = context$2$0.t0;

        case 18:
          context$2$0.prev = 18;
          context$2$0.prev = 19;

          if (!_iteratorNormalCompletion8 && _iterator8['return']) {
            _iterator8['return']();
          }

        case 21:
          context$2$0.prev = 21;

          if (!_didIteratorError8) {
            context$2$0.next = 24;
            break;
          }

          throw _iteratorError8;

        case 24:
          return context$2$0.finish(21);

        case 25:
          return context$2$0.finish(18);

        case 26:
        case 'end':
          return context$2$0.stop();
      }
    }, callee$1$0, _this4, [[3, 14, 18, 26], [19,, 21, 25]]);
  })());
  var sigma = new _internals.Map(_regeneratorRuntime.mark(function callee$1$0() {
    var _iteratorNormalCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, _v6;

    return _regeneratorRuntime.wrap(function callee$1$0$(context$2$0) {
      while (1) switch (context$2$0.prev = context$2$0.next) {
        case 0:
          _iteratorNormalCompletion9 = true;
          _didIteratorError9 = false;
          _iteratorError9 = undefined;
          context$2$0.prev = 3;
          _iterator9 = _getIterator(G);

        case 5:
          if (_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done) {
            context$2$0.next = 12;
            break;
          }

          _v6 = _step9.value;
          context$2$0.next = 9;
          return (0, _internals.tuple2)(_v6, 0);

        case 9:
          _iteratorNormalCompletion9 = true;
          context$2$0.next = 5;
          break;

        case 12:
          context$2$0.next = 18;
          break;

        case 14:
          context$2$0.prev = 14;
          context$2$0.t0 = context$2$0['catch'](3);
          _didIteratorError9 = true;
          _iteratorError9 = context$2$0.t0;

        case 18:
          context$2$0.prev = 18;
          context$2$0.prev = 19;

          if (!_iteratorNormalCompletion9 && _iterator9['return']) {
            _iterator9['return']();
          }

        case 21:
          context$2$0.prev = 21;

          if (!_didIteratorError9) {
            context$2$0.next = 24;
            break;
          }

          throw _iteratorError9;

        case 24:
          return context$2$0.finish(21);

        case 25:
          return context$2$0.finish(18);

        case 26:
        case 'end':
          return context$2$0.stop();
      }
    }, callee$1$0, _this4, [[3, 14, 18, 26], [19,, 21, 25]]);
  })());
  var D = new _internals.Map();

  sigma.set(s, 1);
  var seen = new _internals.Map([(0, _internals.tuple2)(s, 0)]);
  // use Q as heap with (distance,node id) tuples
  var Q = new _internals.PriorityQueue();
  Q.enqueue(0, [s, s]);
  while (Q.size > 0) {
    var _Q$dequeue = Q.dequeue();

    var _Q$dequeue2 = _slicedToArray(_Q$dequeue, 2);

    var dist = _Q$dequeue2[0];

    var _Q$dequeue2$1 = _slicedToArray(_Q$dequeue2[1], 2);

    var pred = _Q$dequeue2$1[0];
    var v = _Q$dequeue2$1[1];

    if (D.has(v)) {
      continue; // already searched this node.
    }
    sigma.set(v, sigma.get(v) + sigma.get(pred)); // count paths
    S.push(v);
    D.set(v, dist);

    var _iteratorNormalCompletion10 = true;
    var _didIteratorError10 = false;
    var _iteratorError10 = undefined;

    try {
      for (var _iterator10 = _getIterator(G.get(v)), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
        var _step10$value = _slicedToArray(_step10.value, 2);

        var w = _step10$value[0];
        var edgedata = _step10$value[1];

        var vwDist = dist + (0, _internals.getDefault)(edgedata[weight], 1);
        if (!D.has(w) && (!seen.has(w) || vwDist < seen.get(w))) {
          seen.set(w, vwDist);
          Q.enqueue(vwDist, [v, w]);
          sigma.set(w, 0);
          P.set(w, [v]);
        } else if (vwDist === seen.get(w)) {
          // handle equal paths
          sigma.set(w, sigma.get(w) + sigma.get(v));
          P.get(w).push(v);
        }
      }
    } catch (err) {
      _didIteratorError10 = true;
      _iteratorError10 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion10 && _iterator10['return']) {
          _iterator10['return']();
        }
      } finally {
        if (_didIteratorError10) {
          throw _iteratorError10;
        }
      }
    }
  }
  return [S, P, sigma];
}

function accumulateBasic(betweenness, S, P, sigma, s) {
  // istanbul ignore next

  var _this5 = this;

  var delta = new _internals.Map(_regeneratorRuntime.mark(function callee$1$0() {
    var _iteratorNormalCompletion11, _didIteratorError11, _iteratorError11, _iterator11, _step11, _s;

    return _regeneratorRuntime.wrap(function callee$1$0$(context$2$0) {
      while (1) switch (context$2$0.prev = context$2$0.next) {
        case 0:
          _iteratorNormalCompletion11 = true;
          _didIteratorError11 = false;
          _iteratorError11 = undefined;
          context$2$0.prev = 3;
          _iterator11 = _getIterator(S);

        case 5:
          if (_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done) {
            context$2$0.next = 12;
            break;
          }

          _s = _step11.value;
          context$2$0.next = 9;
          return (0, _internals.tuple2)(_s, 0);

        case 9:
          _iteratorNormalCompletion11 = true;
          context$2$0.next = 5;
          break;

        case 12:
          context$2$0.next = 18;
          break;

        case 14:
          context$2$0.prev = 14;
          context$2$0.t0 = context$2$0['catch'](3);
          _didIteratorError11 = true;
          _iteratorError11 = context$2$0.t0;

        case 18:
          context$2$0.prev = 18;
          context$2$0.prev = 19;

          if (!_iteratorNormalCompletion11 && _iterator11['return']) {
            _iterator11['return']();
          }

        case 21:
          context$2$0.prev = 21;

          if (!_didIteratorError11) {
            context$2$0.next = 24;
            break;
          }

          throw _iteratorError11;

        case 24:
          return context$2$0.finish(21);

        case 25:
          return context$2$0.finish(18);

        case 26:
        case 'end':
          return context$2$0.stop();
      }
    }, callee$1$0, _this5, [[3, 14, 18, 26], [19,, 21, 25]]);
  })());

  while (S.length > 0) {
    var w = S.pop();
    var coeff = (1 + delta.get(w)) / sigma.get(w);
    /* eslint-disable no-loop-func */
    P.get(w).forEach(function (v) {
      delta.set(v, delta.get(v) + sigma.get(v) * coeff);
    });
    /* eslint-enable no-loop-func */
    // handle object nodes
    if (w !== s || typeof w === 'object' && w.toString() !== s.toString()) {
      betweenness.set(w, betweenness.get(w) + delta.get(w));
    }
  }
  return betweenness;
}

function accumulateEndpoints(betweenness, S, P, sigma, s) {
  // istanbul ignore next

  var _this6 = this;

  betweenness.set(s, betweenness.get(s) + S.length - 1);
  var delta = new _internals.Map(_regeneratorRuntime.mark(function callee$1$0() {
    var _iteratorNormalCompletion12, _didIteratorError12, _iteratorError12, _iterator12, _step12, _s2;

    return _regeneratorRuntime.wrap(function callee$1$0$(context$2$0) {
      while (1) switch (context$2$0.prev = context$2$0.next) {
        case 0:
          _iteratorNormalCompletion12 = true;
          _didIteratorError12 = false;
          _iteratorError12 = undefined;
          context$2$0.prev = 3;
          _iterator12 = _getIterator(S);

        case 5:
          if (_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done) {
            context$2$0.next = 12;
            break;
          }

          _s2 = _step12.value;
          context$2$0.next = 9;
          return (0, _internals.tuple2)(_s2, 0);

        case 9:
          _iteratorNormalCompletion12 = true;
          context$2$0.next = 5;
          break;

        case 12:
          context$2$0.next = 18;
          break;

        case 14:
          context$2$0.prev = 14;
          context$2$0.t0 = context$2$0['catch'](3);
          _didIteratorError12 = true;
          _iteratorError12 = context$2$0.t0;

        case 18:
          context$2$0.prev = 18;
          context$2$0.prev = 19;

          if (!_iteratorNormalCompletion12 && _iterator12['return']) {
            _iterator12['return']();
          }

        case 21:
          context$2$0.prev = 21;

          if (!_didIteratorError12) {
            context$2$0.next = 24;
            break;
          }

          throw _iteratorError12;

        case 24:
          return context$2$0.finish(21);

        case 25:
          return context$2$0.finish(18);

        case 26:
        case 'end':
          return context$2$0.stop();
      }
    }, callee$1$0, _this6, [[3, 14, 18, 26], [19,, 21, 25]]);
  })());

  while (S.length > 0) {
    var w = S.pop();
    var coeff = (1 + delta.get(w)) / sigma.get(w);
    /* eslint-disable no-loop-func */
    P.get(w).forEach(function (v) {
      delta.set(v, delta.get(v) + sigma.get(v) * coeff);
    });
    /* eslint-enable no-loop-func */
    // handle object nodes
    if (w !== s || typeof w === 'object' && w.toString() !== s.toString()) {
      betweenness.set(w, betweenness.get(w) + delta.get(w) + 1);
    }
  }
  return betweenness;
}

function accumulateEdges(betweenness, S, P, sigma, s) {
  // istanbul ignore next

  var _this7 = this;

  var delta = new _internals.Map(_regeneratorRuntime.mark(function callee$1$0() {
    var _iteratorNormalCompletion13, _didIteratorError13, _iteratorError13, _iterator13, _step13, _s3;

    return _regeneratorRuntime.wrap(function callee$1$0$(context$2$0) {
      while (1) switch (context$2$0.prev = context$2$0.next) {
        case 0:
          _iteratorNormalCompletion13 = true;
          _didIteratorError13 = false;
          _iteratorError13 = undefined;
          context$2$0.prev = 3;
          _iterator13 = _getIterator(S);

        case 5:
          if (_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done) {
            context$2$0.next = 12;
            break;
          }

          _s3 = _step13.value;
          context$2$0.next = 9;
          return (0, _internals.tuple2)(_s3, 0);

        case 9:
          _iteratorNormalCompletion13 = true;
          context$2$0.next = 5;
          break;

        case 12:
          context$2$0.next = 18;
          break;

        case 14:
          context$2$0.prev = 14;
          context$2$0.t0 = context$2$0['catch'](3);
          _didIteratorError13 = true;
          _iteratorError13 = context$2$0.t0;

        case 18:
          context$2$0.prev = 18;
          context$2$0.prev = 19;

          if (!_iteratorNormalCompletion13 && _iterator13['return']) {
            _iterator13['return']();
          }

        case 21:
          context$2$0.prev = 21;

          if (!_didIteratorError13) {
            context$2$0.next = 24;
            break;
          }

          throw _iteratorError13;

        case 24:
          return context$2$0.finish(21);

        case 25:
          return context$2$0.finish(18);

        case 26:
        case 'end':
          return context$2$0.stop();
      }
    }, callee$1$0, _this7, [[3, 14, 18, 26], [19,, 21, 25]]);
  })());

  while (S.length > 0) {
    var w = S.pop();
    var coeff = (1 + delta.get(w)) / sigma.get(w);
    /* eslint-disable no-loop-func */
    P.get(w).forEach(function (v) {
      var c = sigma.get(v) * coeff;
      var edge = [v, w];
      if (!betweenness.has(edge)) {
        edge = [w, v];
      }
      betweenness.set(edge, betweenness.get(edge) + c);
      delta.set(v, delta.get(v) + c);
    });
    /* eslint-enable no-loop-func */
    // handle object nodes
    if (w !== s || typeof w === 'object' && w.toString() !== s.toString()) {
      betweenness.set(w, betweenness.get(w) + delta.get(w));
    }
  }
  return betweenness;
}

function rescale(betweenness, n, optNormalized, optDirected, optK) {
  if (optDirected === undefined) optDirected = false;

  var scale;
  if (optNormalized) {
    scale = n <= 2 ? null : 1 / ((n - 1) * (n - 2));
  } else {
    // rescale by 2 for undirected graphs
    scale = !optDirected ? 1 / 2 : null;
  }
  if (scale != null) {
    if (optK != null) {
      scale = scale * n / optK;
    }
    betweenness.forEach(function (v, k) {
      return betweenness.set(k, v * scale);
    });
  }
  return betweenness;
}

function rescaleE(betweenness, n, optNormalized, optDirected) {
  var scale;
  if (optNormalized) {
    scale = n <= 1 ? null : 1 / (n * (n - 1));
  } else {
    // rescale by 2 for undirected graphs
    scale = !optDirected ? 1 / 2 : null;
  }
  if (scale != null) {
    betweenness.forEach(function (v, k) {
      return betweenness.set(k, v * scale);
    });
  }
  return betweenness;
}

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(16)['default'];

var _getIterator = __webpack_require__(8)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.eigenvectorCentrality = eigenvectorCentrality;
exports.genEigenvectorCentrality = genEigenvectorCentrality;

var _internalsDelegate = __webpack_require__(27);

var _internalsDelegate2 = _interopRequireDefault(_internalsDelegate);

var _exceptions = __webpack_require__(88);

var _internals = __webpack_require__(15);

'use strict';

/**
 * Compute the eigenvector centrality for `G`.
 *
 * Eigenvector centrality computes the centrality for a node based on the
 * centrality of its neighbors. The eigenvector centrality for node `i` is
 *
 * ```math
 * Ax = \lambda x
 * ```
 *
 * where `$A$` is the adjacency matrix of the graph `G` with eigenvalue
 * `$\lambda$`. By virtue of the Perron-Frobinus theorem, there is a unique and
 * positive solution if `$\lambda$` is the largest eigenvalue associated with
 * the eigenvector of the adjacency matrix `$A$`. ([2])
 *
 * ### Examples
 *
 * ```
 * var G = jsnx.pathGraph(4);
 * jsnx.eigenvectorCentrality(G);
 * // Map {0: 0.37, 1: 0.6, 2: 0.6, 3: 0.37}
 * ```
 *
 * ### Notes
 *
 * The measure was introduced by ([1][]).
 *
 * The eigenvector calculation is done by the power iteration method and has
 * no guarantee of convergence. The iteration will stop after `maxIter`
 * iterations or an error tolerance of `numberOfNodes(G) * tol` has been
 * reached.
 *
 * For directed graphs this is "left" eigenvector centrality which corresponds
 * to the in-edges in the graph. For out-edges eigenvector centrality
 * first reverse the graph with `G.reverse()`.
 *
 * ### References
 *
 * [1] [Phillip Bonacich:
 *     Power and Centrality: A Family of Measures.
 *     American Journal of Sociology 92(5):1170–1182, 1986](1)
 * [1]: http://www.leonidzhukov.net/hse/2014/socialnetworks/papers/Bonacich-Centrality.pdf
 * [2] Mark E. J. Newman:
 *     Networks: An Introduction.
 *     Oxford University Press, USA, 2010, pp. 169.
 *
 * @see pagerank
 * @see hits
 *
 * @param {Graph} G
 * @param {{maxIter: ?number, tolerance: ?number, nstart: ?Map, weight: ?string}} optParameters
 *   - maxIter: Maximum number of iterations in power method.
 *   - tolerance: Error tolerance used to check convergence in power method
 *     iteration.
 *   - nstart: Starting value of eigenvector iteration for each node.
 *   - weight: If not defined, all edge weights are considered equal. Otherwise
 *     holds the name of the edge attribute used as weight.
 * @return {Map} Map of nodes with eigenvector centrality as the value
 */

function eigenvectorCentrality(G) {
  var _ref = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  var _ref$maxIter = _ref.maxIter;
  var maxIter = _ref$maxIter === undefined ? 100 : _ref$maxIter;
  var _ref$tolerance = _ref.tolerance;
  var tolerance = _ref$tolerance === undefined ? 1e-6 : _ref$tolerance;
  var nstart = _ref.nstart;
  var weight = _ref.weight;

  var sqrt = Math.sqrt;
  var pow = Math.pow;
  var abs = Math.abs;

  if (G.isMultigraph()) {
    throw new _exceptions.JSNetworkXException('Not defined for multigraphs.');
  }

  if (G.order() === 0) {
    throw new _exceptions.JSNetworkXException('Empty graph.');
  }

  var x = undefined;
  var zeroMap = new _internals.Map();
  if (!nstart) {
    // choose starting vector with entries of 1/#G
    var start = 1 / G.order();
    x = new _internals.Map();
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = _getIterator(G), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var n = _step.value;

        x.set(n, start);
        zeroMap.set(n, 0);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator['return']) {
          _iterator['return']();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  } else {
    x = nstart;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = _getIterator(x.keys()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var n = _step2.value;

        zeroMap.set(n, 0);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2['return']) {
          _iterator2['return']();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }

  // normalize starting vector
  var sum = 0;
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = _getIterator(x.values()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var v = _step3.value;

      sum += v;
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3['return']) {
        _iterator3['return']();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  sum = 1 / sum;

  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = _getIterator(x), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var _step4$value = _slicedToArray(_step4.value, 2);

      var k = _step4$value[0];
      var v = _step4$value[1];

      x.set(k, v * sum);
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4['return']) {
        _iterator4['return']();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  tolerance = G.order() * tolerance;
  // make up to maxIter iterations
  for (var i = 0; i < maxIter; i++) {
    var xlast = x;
    x = new _internals.Map(zeroMap);

    // do the multiplication y^T = x^T A
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = _getIterator(x), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var _step5$value = _slicedToArray(_step5.value, 2);

        var n = _step5$value[0];
        var v = _step5$value[1];
        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
          for (var _iterator8 = _getIterator(G.get(n)), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
            var _step8$value = _slicedToArray(_step8.value, 2);

            var nbr = _step8$value[0];
            var data = _step8$value[1];

            x.set(nbr, x.get(nbr) + xlast.get(n) * (0, _internals.getDefault)(weight && data[weight], 1));
          }
        } catch (err) {
          _didIteratorError8 = true;
          _iteratorError8 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion8 && _iterator8['return']) {
              _iterator8['return']();
            }
          } finally {
            if (_didIteratorError8) {
              throw _iteratorError8;
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5['return']) {
          _iterator5['return']();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }

    // normalize vector
    var _sum = 0;
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = _getIterator(x.values()), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var v = _step6.value;

        _sum += pow(v, 2);
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6['return']) {
          _iterator6['return']();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }

    _sum = sqrt(_sum);
    // this should never be zero?
    _sum = _sum === 0 ? 1 : 1 / _sum;

    var error = 0;
    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
      for (var _iterator7 = _getIterator(x), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
        var _step7$value = _slicedToArray(_step7.value, 2);

        var n = _step7$value[0];
        var v = _step7$value[1];

        v = v * _sum;
        x.set(n, v);
        // check error convergence
        error += abs(v - xlast.get(n));
      }
    } catch (err) {
      _didIteratorError7 = true;
      _iteratorError7 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion7 && _iterator7['return']) {
          _iterator7['return']();
        }
      } finally {
        if (_didIteratorError7) {
          throw _iteratorError7;
        }
      }
    }

    if (error < tolerance) {
      return x;
    }
  }

  throw new _exceptions.JSNetworkXError('eigenvectorCentrality(): power iteration failed to converge in ' + (maxIter + ' iterations.'));
}

// not ported:
// eigenvectorCentralityNumpy

function genEigenvectorCentrality(G, _maxIter$tolerance$nstart$weight) {
  return (0, _internalsDelegate2['default'])('eigenvectorCentrality', [G, _maxIter$tolerance$nstart$weight]);
}

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(25)['default'];

var _defaults = __webpack_require__(45)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _betweenness = __webpack_require__(750);

var betweenness = _interopRequireWildcard(_betweenness);

var _eigenvector = __webpack_require__(751);

var eigenvector = _interopRequireWildcard(_eigenvector);

exports.betweenness = betweenness;
exports.eigenvector = eigenvector;

_defaults(exports, _interopRequireWildcard(_betweenness));

_defaults(exports, _interopRequireWildcard(_eigenvector));

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.isDirectedAcyclicGraph = isDirectedAcyclicGraph;
exports.genIsDirectedAcyclicGraph = genIsDirectedAcyclicGraph;
exports.topologicalSort = topologicalSort;
exports.genTopologicalSort = genTopologicalSort;
exports.topologicalSortRecursive = topologicalSortRecursive;
exports.genTopologicalSortRecursive = genTopologicalSortRecursive;
exports.isAperiodic = isAperiodic;
exports.genIsAperiodic = genIsAperiodic;

var _internalsDelegate = __webpack_require__(27);

var _internalsDelegate2 = _interopRequireDefault(_internalsDelegate);

var _exceptionsJSNetworkXError = __webpack_require__(34);

var _exceptionsJSNetworkXError2 = _interopRequireDefault(_exceptionsJSNetworkXError);

var _exceptionsJSNetworkXUnfeasible = __webpack_require__(215);

var _exceptionsJSNetworkXUnfeasible2 = _interopRequireDefault(_exceptionsJSNetworkXUnfeasible);

var _internals = __webpack_require__(15);

/*eslint max-len:[1, 83]*/
'use strict';

// TODO: descendants
// TODO: ancestors

/**
 * Return `true` if the graph G is a directed acyclic graph (DAG) or
 * `false` if not.
 *
 * @param {Graph} G A graph
 * @return {boolean} true of G is a DAG, false otherwise
 */

function isDirectedAcyclicGraph(G) {
  try {
    topologicalSort(G);
    return true;
  } catch (ex) {
    if (ex instanceof _exceptionsJSNetworkXUnfeasible2['default']) {
      return false;
    }
    throw ex;
  }
}

function genIsDirectedAcyclicGraph(G) {
  return (0, _internalsDelegate2['default'])('isDirectedAcyclicGraph', [G]);
}

/**
 * Return a list of nodes in topological sort order.
 *
 * A topological sort is a non-unique permutation of the nodes such that an edge
 * from `$u$` to `$v$` implies that `$u$` appears before `$v$` in the
 * topological sort order.
 *
 * ### Notes
 *
 * This algorithm is based on a description and proof in
 * The Algorithm Design Manual ([1][]).
 *
 * ### References
 *
 *
 * [1] [Skiena, S. S. The Algorithm Design Manual  (Springer-Verlag, 1998).][1]
 * [1]: http://www.amazon.com/exec/obidos/ASIN/0387948600/ref=ase_thealgorithmrepo/
 *
 * @see #is_directed_acyclic_graph
 *
 * @param {Graph} G A directed Graph
 * @param {Iterable=} optNbunch Explore graph in specified order given
 *    in optNbunch.
 * @return {!Array}
 */

function topologicalSort(G, optNbunch) {
  if (!G.isDirected()) {
    throw new _exceptionsJSNetworkXError2['default']('Topological sort not defined on undirected graphs.');
  }

  // nonrecursive version
  var seen = new _internals.Set();
  var orderExplored = []; // provide order and
  // fast search without more general priorityDictionary
  var explored = new _internals.Set();

  if (optNbunch == null) {
    optNbunch = G.nodesIter();
  }

  (0, _internals.forEach)(optNbunch, function (v) {
    // process all vertices in G
    if (explored.has(v)) {
      return; // continue
    }

    var fringe = [v]; // nodes yet to look at
    while (fringe.length > 0) {
      var w = fringe[fringe.length - 1]; // depth first search
      if (explored.has(w)) {
        // already looked down this branch
        fringe.pop();
        continue;
      }
      seen.add(w); // mark as seen
      // Check successors for cycles for new nodes
      var newNodes = [];
      /*eslint-disable no-loop-func*/
      G.get(w).forEach(function (_, n) {
        if (!explored.has(n)) {
          if (seen.has(n)) {
            // CYCLE !!
            throw new _exceptionsJSNetworkXUnfeasible2['default']('Graph contains a cycle.');
          }
          newNodes.push(n);
        }
      });
      /*eslint-enable no-loop-func*/
      if (newNodes.length > 0) {
        // add new nodes to fringe
        fringe.push.apply(fringe, newNodes);
      } else {
        explored.add(w);
        orderExplored.unshift(w);
      }
    }
  });

  return orderExplored;
}

function genTopologicalSort(G, optNbunch) {
  return (0, _internalsDelegate2['default'])('topologicalSort', [G, optNbunch]);
}

/**
 * Return a list of nodes in topological sort order.
 *
 * A topological sort is a non-unique permutation of the nodes such that an edge
 * from `$u$` to `$v$` implies that `$u$` appears before `$v$` in the
 * topological sort order.
 *
 * ### Notes
 *
 * This is a recursive version of topological sort.
 *
 * @see #topological_sort
 * @see #is_directed_acyclic_graph
 *
 * @param {Graph} G A directed Graph
 * @param {Iterable=} optNbunch Explore graph in specified order given
 *    in optNbunch.
 * @return {!Array}
 */

function topologicalSortRecursive(G, optNbunch) {
  if (!G.isDirected()) {
    throw new _exceptionsJSNetworkXError2['default']('Topological sort not defined on undirected graphs.');
  }

  // function for recursive dfs
  /**
   * @param {Graph} G graph
   * @param {Set} seen
   * @param {Array} explored
   * @param {string} v
   * @return {boolean}
   */
  function _dfs(G, seen, explored, v) {
    // eslint-disable-line no-shadow
    seen.add(v);
    G.get(v).forEach(function (_, w) {
      if (!seen.has(w)) {
        if (!_dfs(G, seen, explored, w)) {
          return false;
        }
      } else if (seen.has(w) && explored.indexOf(w) === -1) {
        throw new _exceptionsJSNetworkXUnfeasible2['default']('Graph contains a cycle.');
      }
    });
    explored.unshift(v);
    return true;
  }

  var seen = new _internals.Set();
  var explored = [];

  if (optNbunch == null) {
    optNbunch = G.nodesIter();
  }

  (0, _internals.forEach)(optNbunch, function (v) {
    if (explored.indexOf(v) === -1) {
      if (!_dfs(G, seen, explored, v)) {
        throw new _exceptionsJSNetworkXUnfeasible2['default']('Graph contains a cycle.');
      }
    }
  });

  return explored;
}

function genTopologicalSortRecursive(G, optNbunch) {
  return (0, _internalsDelegate2['default'])('topologicalSortRecursive', [G, optNbunch]);
}

/**
 * Return true if G is aperiodic.
 *
 * A directed graph is aperiodic if there is no integer `$k > 1$` that
 * divides the length of every cycle in the graph.
 *
 * ### Notes
 *
 * This uses the method outlined in (1), which runs in `$O(m)$` time
 * given `$m$` edges in `$G$`. Note that a graph is not aperiodic if it is
 * acyclic as every integer trivial divides length `$0$` cycles.
 *
 *
 * ### References
 *
 * [1] Jarvis, J. P.; Shier, D. R. (1996),
 *     Graph-theoretic analysis of finite Markov chains,
 *     in Shier, D. R.; Wallenius, K. T., Applied Mathematical Modeling:
 *     A Multidisciplinary Approach, CRC Press.
 *
 * @param {Graph} G
 * @return {boolean} true if the graph is aperiodic false otherwise
 */

function isAperiodic(_x) {
  var _left;

  var _again = true;

  _function: while (_again) {
    var G = _x;
    next = levels = thisLevel = g = l = nextLevel = i = u = undefined;
    _again = false;

    if (!G.isDirected()) {
      throw new _exceptionsJSNetworkXError2['default']('is_aperiodic not defined for undirected graphs.');
    }

    var next = G.nodesIter().next();
    if (next.done) {
      return true;
    }
    var levels = new _internals.Map();
    levels.set(next.value, 0);
    var thisLevel = [next.value];
    var g = 0;
    var l = 1;

    while (thisLevel.length > 0) {
      var nextLevel = [];
      for (var i = 0; i < thisLevel.length; i++) {
        var u = thisLevel[i];
        /*eslint-disable no-loop-func*/
        G.get(u).forEach(function (_, v) {
          if (levels.has(v)) {
            // non-tree edge
            g = (0, _internals.gcd)(g, levels.get(u) - levels.get(v) + 1);
          } else {
            // tree edge
            nextLevel.push(v);
            levels.set(v, l);
          }
        });
        /*eslint-enable no-loop-func*/
      }
      thisLevel = nextLevel;
      l += 1;
    }

    if (levels.size === G.numberOfNodes()) {
      return g === 1;
    }

    if (!(_left = g === 1)) {
      return _left;
    }

    _x = G.subgraph(new _internals.Set(G.nodes()).difference(levels.keys()));
    _again = true;
    continue _function;
  }
}

function genIsAperiodic(G) {
  return (0, _internalsDelegate2['default'])('isAperiodic', [G]);
}

/*jshint ignore:start*/

/*jshint ignore:end*/

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(25)['default'];

var _defaults = __webpack_require__(45)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _centrality = __webpack_require__(752);

var centrality = _interopRequireWildcard(_centrality);

var _clique = __webpack_require__(350);

var clique = _interopRequireWildcard(_clique);

var _cluster = __webpack_require__(351);

var cluster = _interopRequireWildcard(_cluster);

var _dag = __webpack_require__(753);

var dag = _interopRequireWildcard(_dag);

var _graphical = __webpack_require__(352);

var graphical = _interopRequireWildcard(_graphical);

var _isomorphism = __webpack_require__(755);

var isomorphism = _interopRequireWildcard(_isomorphism);

var _operators = __webpack_require__(758);

var operators = _interopRequireWildcard(_operators);

var _shortestPaths = __webpack_require__(760);

var shortestPaths = _interopRequireWildcard(_shortestPaths);

exports.centrality = centrality;
exports.clique = clique;
exports.cluster = cluster;
exports.dag = dag;
exports.graphical = graphical;
exports.isomorphism = isomorphism;
exports.operators = operators;
exports.shortestPaths = shortestPaths;

_defaults(exports, _interopRequireWildcard(_centrality));

_defaults(exports, _interopRequireWildcard(_clique));

_defaults(exports, _interopRequireWildcard(_cluster));

_defaults(exports, _interopRequireWildcard(_dag));

_defaults(exports, _interopRequireWildcard(_graphical));

_defaults(exports, _interopRequireWildcard(_isomorphism));

_defaults(exports, _interopRequireWildcard(_operators));

_defaults(exports, _interopRequireWildcard(_shortestPaths));

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(25)['default'];

var _defaults = __webpack_require__(45)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _isomorph = __webpack_require__(756);

var isomorph = _interopRequireWildcard(_isomorph);

exports.isomorph = isomorph;

_defaults(exports, _interopRequireWildcard(_isomorph));

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Array$from = __webpack_require__(13)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.couldBeIsomorphic = couldBeIsomorphic;
exports.genCouldBeIsomorphic = genCouldBeIsomorphic;
exports.fastCouldBeIsomorphic = fastCouldBeIsomorphic;
exports.genFastCouldBeIsomorphic = genFastCouldBeIsomorphic;
exports.fasterCouldBeIsomorphic = fasterCouldBeIsomorphic;
exports.genFasterCouldBeIsomorphic = genFasterCouldBeIsomorphic;

var _internalsDelegate = __webpack_require__(27);

var _internalsDelegate2 = _interopRequireDefault(_internalsDelegate);

var _clique = __webpack_require__(350);

var _cluster = __webpack_require__(351);

'use strict';

/**
 * Returns `false` if graphs are definitely not isomorphic.
 * `true` does **not** guarantee isomorphism.
 *
 * Checks for matching degree, triangle, and number of cliques sequences.
 *
 * @param {!Graph} G1
 * @param {!Graph} G2
 * @return {boolean}  `false` if graphs are definitely not isomorphic.
 */

function couldBeIsomorphic(G1, G2) {
  // Check global properties
  if (G1.order() !== G2.order()) {
    return false;
  }

  // Check local properties
  var degree1 = G1.degree();
  var triangles1 = (0, _cluster.triangles)(G1);
  var cliques1 = (0, _clique.numberOfCliques)(G1);
  var props1 = [];
  degree1.forEach(function (_, v) {
    props1.push([degree1.get(v), triangles1.get(v), cliques1.get(v)]);
  });
  props1.sort(function (a, b) {
    return a[0] - b[0] || a[1] - b[1] || a[2] - b[2];
  });

  var degree2 = G2.degree();
  var triangles2 = (0, _cluster.triangles)(G2);
  var cliques2 = (0, _clique.numberOfCliques)(G2);
  var props2 = [];
  degree2.forEach(function (_, v) {
    props2.push([degree2.get(v), triangles2.get(v), cliques2.get(v)]);
  });
  props2.sort(function (a, b) {
    return a[0] - b[0] || a[1] - b[1] || a[2] - b[2];
  });

  return props1.every(function (a, i) {
    var b = props2[i];
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
  });
}

function genCouldBeIsomorphic(G1, G2) {
  return (0, _internalsDelegate2['default'])('couldBeIsomorphic', [G1, G2]);
}

/**
 * Returns `false` if graphs are definitely not isomorphic.
 * `true` does **not** guarantee isomorphism.
 *
 * Checks for matching degree and triangle sequences.
 *
 * @param {!Graph} G1
 * @param {!Graph} G2
 * @return {boolean}  `false` if graphs are definitely not isomorphic.
 */

function fastCouldBeIsomorphic(G1, G2) {
  // Check global properties
  if (G1.order() !== G2.order()) {
    return false;
  }

  // Check local properties
  var degree1 = G1.degree();
  var triangles1 = (0, _cluster.triangles)(G1);
  var props1 = [];
  degree1.forEach(function (_, v) {
    props1.push([degree1.get(v), triangles1.get(v)]);
  });
  props1.sort(function (a, b) {
    return a[0] - b[0] || a[1] - b[1];
  });

  var degree2 = G2.degree();
  var triangles2 = (0, _cluster.triangles)(G2);
  var props2 = [];
  degree2.forEach(function (_, v) {
    props2.push([degree2.get(v), triangles2.get(v)]);
  });
  props2.sort(function (a, b) {
    return a[0] - b[0] || a[1] - b[1];
  });

  return props1.every(function (a, i) {
    var b = props2[i];
    return a[0] === b[0] && a[1] === b[1];
  });
}

function genFastCouldBeIsomorphic(G1, G2) {
  return (0, _internalsDelegate2['default'])('fastCouldBeIsomorphic', [G1, G2]);
}

/**
 * Returns `false` if graphs are definitely not isomorphic.
 * `true` does **not** guarantee isomorphism.
 *
 * Checks for matching degree sequences.
 *
 * @param {!Graph} G1
 * @param {!Graph} G2
 *
 * @return {boolean}  False if graphs are definitely not isomorphic.
 *
 * @export
 */

function fasterCouldBeIsomorphic(G1, G2) {
  // Check global properties
  if (G1.order() !== G2.order()) {
    return false;
  }

  // Check local properties
  var degree1 = _Array$from(G1.degree().values());
  degree1.sort(function (a, b) {
    return a - b;
  });

  var degree2 = _Array$from(G2.degree().values());
  degree2.sort(function (a, b) {
    return a - b;
  });

  return degree1.every(function (v, i) {
    return v === degree2[i];
  });
}

//TODO: is_isomorphic

function genFasterCouldBeIsomorphic(G1, G2) {
  return (0, _internalsDelegate2['default'])('fasterCouldBeIsomorphic', [G1, G2]);
}

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Object$assign = __webpack_require__(89)['default'];

var _getIterator = __webpack_require__(8)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.union = union;
exports.genUnion = genUnion;
exports.disjointUnion = disjointUnion;
exports.genDisjointUnion = genDisjointUnion;
exports.intersection = intersection;
exports.genIntersection = genIntersection;
exports.difference = difference;
exports.genDifference = genDifference;
exports.symmetricDifference = symmetricDifference;
exports.genSymmetricDifference = genSymmetricDifference;
exports.compose = compose;
exports.genCompose = genCompose;

var _internalsDelegate = __webpack_require__(27);

var _internalsDelegate2 = _interopRequireDefault(_internalsDelegate);

var _exceptionsJSNetworkXError = __webpack_require__(34);

var _exceptionsJSNetworkXError2 = _interopRequireDefault(_exceptionsJSNetworkXError);

var _relabel = __webpack_require__(363);

var _classesFunctions = __webpack_require__(357);

var _internalsSet = __webpack_require__(84);

var _internalsSet2 = _interopRequireDefault(_internalsSet);

var _internals = __webpack_require__(15);

'use strict';

function assertSameNodes(G, H) {
  var Hnodes = new _internalsSet2['default'](H);
  var Gnodes = new _internalsSet2['default'](G);
  if (Hnodes.size !== Gnodes.size || (0, _internals.someIterator)(Gnodes.values(), function (v) {
    return !Hnodes.has(v);
  })) {
    throw new _exceptionsJSNetworkXError2['default']('Node sets of graphs are not equal.');
  }
}

/**
 * Return the union of graphs `G` and `H`.
 *
 * Graphs `G` and `H` must be disjoint, otherwise an exception is raised.
 *
 * ### Notes
 *
 * To force a disjoint union with node relabeling, use `disjointUnion(G, H)` or
 * `convertNodeLabelsToIntegers()`.
 *
 * Graph, edge and node attributes are propagated from `G` and `H` to the union
 * Graph. If a graph attribute is present in both `G` and `H`, the value from
 * `H` is used.
 *
 * @see #disjointUnion
 *
 * @param {Graph} G
 * @param {Graph} H
 * @param {{rename: ?Array}} optParameters
 *   - rename: Node names `G` and `H` can be changed by specifying the tuple
 *     `['G-', 'H-']` (for example). Node `'u'` in `G` is then renamed to
 *     `'G-u'` and `'v'` in `H` is renamed to `'H-v'`.
 * @return {Graph} A union graph with the same type as G
 */

function union(G, H) {
  var _ref = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

  var _ref$rename = _ref.rename;
  var rename = _ref$rename === undefined ? [null, null] : _ref$rename;

  if (G.isMultigraph() !== H.isMultigraph()) {
    throw new _exceptionsJSNetworkXError2['default']('G and H must both be graphs or multigraphs');
  }

  // Union is same type as G
  var R = new G.constructor();
  R.name = 'union(' + G.name + ', ' + H.name + ')';

  // rename graph to obtain disjoint node labels
  function addPrefix(graph, prefix) {
    if (!prefix) {
      return graph;
    }
    return (0, _relabel.relabelNodes)(graph, function (n) {
      return prefix + n.toString();
    });
  }
  G = addPrefix(G, rename[0]);
  H = addPrefix(H, rename[1]);

  if (new _internalsSet2['default'](G).intersection(new _internalsSet2['default'](H)).size > 0) {
    throw new _exceptionsJSNetworkXError2['default']('The node sets of G and H are not disjoint. Use appropriate ' + '{rename: [Gprefix, Hprefix]} or use disjointUnion({G, H})');
  }

  // add nodes
  R.addNodesFrom(G.nodesIter(true));
  R.addNodesFrom(H.nodesIter(true));
  // add edges
  R.addEdgesFrom(G.isMultigraph() ? G.edgesIter(true, true) : G.edgesIter(true));
  R.addEdgesFrom(H.isMultigraph() ? H.edgesIter(true, true) : H.edgesIter(true));
  // add graph attributes
  _Object$assign(R.graph, G.graph, H.graph);

  return R;
}

function genUnion(G, H, _rename) {
  return (0, _internalsDelegate2['default'])('union', [G, H, _rename]);
}

/**
 * Return the disjoint union of graphs `G` and `H`.
 *
 * This algorithm forces distinct integer node labels.
 *
 * ### Notes
 *
 * A new graph is created, of the same class as `G`.  It is recommended that `G`
 * and `H` be either both directed or both undirected.
 *
 * The nodes of `G` are relabeled `0` to `numberOfNodes(G) - 1`, and the nodes
 * of `H` are relabeled `numberOfNodes(G)` to
 * `numberOfNodes(G) + numberOfNodes(H) - 1`.
 *
 * Graph, edge, and node attributes are propagated from `G` and `H` to the union
 * graph. If a graph attribute is present in both `G` and `H` the value from `H`
 * is used.
 *
 * @param {Graph} G
 * @param {Graph} H
 * @return {Graph} A union graph with the same type as G.
 */

function disjointUnion(G, H) {
  var R1 = (0, _relabel.convertNodeLabelsToIntegers)(G);
  var R2 = (0, _relabel.convertNodeLabelsToIntegers)(H, R1.order());
  var R = union(R1, R2);
  R.name = 'disjointUnion(' + G.name + ', ' + H.name + ')';
  _Object$assign(R.graph, G.graph, H.graph);
  return R;
}

function genDisjointUnion(G, H) {
  return (0, _internalsDelegate2['default'])('disjointUnion', [G, H]);
}

/**
 * Return a new graph that contains only edges that exist in both `G` and `H`.
 *
 * The node set of `H` and `G` must be the same.
 *
 * ### Notes
 *
 * Attributes from the graph, nodes and edges are not copied to the new graph.
 * If you want a new graph of the intersection of `G` and `H` with the
 * attributes, (including edge data) from `G` use `removeNode()` as follows
 *
 * ```
 * var G = jsnx.pathGraph(3);
 * var H = jsnx.pathGraph(5);
 * var R = G.copy();
 * for (var n of G) {
 *   if (!H.hasNode(n)) {
 *     R.removeNode(n);
 *   }
 * }
 * ```
 *
 * @param {Graph} G
 * @param {Graph} H
 * @return {Graph} A new graph with the same types as G
 */

function intersection(G, H) {
  if (G.isMultigraph() !== H.isMultigraph()) {
    throw new _exceptionsJSNetworkXError2['default']('G and H must both be graphs or multigraphs');
  }

  // create new graph
  var R = (0, _classesFunctions.createEmptyCopy)(G);
  R.name = 'Intersection of (' + G.name + ' and ' + H.name + ')';
  assertSameNodes(G, H);

  var graph = G.numberOfEdges() < H.numberOfEdges() ? G : H;
  var otherGraph = graph === G ? H : G;

  var edges = graph.isMultigraph() ? graph.edgesIter(false, true) : graph.edgesIter();
  var hasEdge = otherGraph.hasEdge;
  var addEdge = R.addEdge;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _getIterator(edges), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var e = _step.value;

      if (hasEdge.apply(otherGraph, e)) {
        addEdge.apply(R, e);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator['return']) {
        _iterator['return']();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return R;
}

function genIntersection(G, H) {
  return (0, _internalsDelegate2['default'])('intersection', [G, H]);
}

/**
 * Return a new graph that contains the edges that exist in `G` but not in `H`.
 *
 * The node sets of `H` and `G` must be the same.
 *
 * ### Notes
 *
 * Attributes from the graph, nodes and edges are not copied to the new graph.
 * If you want a new graph of the difference of `G` and `H` with the attributes
 * (including edge data) from `G`, use `removeNodes()` as follows:
 *
 * ```
 * var G = jsnx.pathGraph(3);
 * var H = jsnx.pathGraph(5);
 * var R = G.copy();
 * for (var n of G) {
 *   if (!H.hasNode(n)) {
 *     R.removeNode(n);
 *   }
 * }
 * ```
 *
 * @param {Graph} G
 * @param {Graph} H
 * @return {Graph} A new graph with the same types as G
 */

function difference(G, H) {
  if (G.isMultigraph() !== H.isMultigraph()) {
    throw new _exceptionsJSNetworkXError2['default']('G and H must both be graphs or multigraphs');
  }
  // create new graph
  var R = (0, _classesFunctions.createEmptyCopy)(G);
  G.name = 'Difference of (' + G.name + ' and ' + H.name + ')';
  assertSameNodes(G, H);

  var edges = G.isMultigraph() ? G.edgesIter(false, true) : G.edgesIter();
  var hasEdge = H.hasEdge;
  var addEdge = R.addEdge;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = _getIterator(edges), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var e = _step2.value;

      if (!hasEdge.apply(H, e)) {
        addEdge.apply(R, e);
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2['return']) {
        _iterator2['return']();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return R;
}

function genDifference(G, H) {
  return (0, _internalsDelegate2['default'])('difference', [G, H]);
}

/**
 * Return new graph with edges that exit in either `G` or `H` but not both.
 *
 * The node sets of `H` and `G` must be the same.
 *
 * ### Notes
 *
 * Attributes from the graph, nodes and edges are not copied to the new graph.
 *
 * @param {Graph} G
 * @param {Graph} H
 * @return {Graph} A new graph with the same types as G
 */

function symmetricDifference(G, H) {
  if (G.isMultigraph() !== H.isMultigraph()) {
    throw new _exceptionsJSNetworkXError2['default']('G and H must both be graphs or multigraphs');
  }
  var R = (0, _classesFunctions.createEmptyCopy)(G);
  R.name = 'Symmetric difference of (' + G.name + ' and ' + H.name + ')';

  assertSameNodes(G, H);
  R.addNodesFrom((0, _internalsSet.symmetricDifference)(new _internalsSet2['default'](G), new _internalsSet2['default'](H)));

  var edges = G.isMultigraph() ? G.edgesIter(false, true) : G.edgesIter();
  var addEdge = R.addEdge;
  var hasEdge = H.hasEdge;
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = _getIterator(edges), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var edge = _step3.value;

      if (!hasEdge.apply(H, edge)) {
        addEdge.apply(R, edge);
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3['return']) {
        _iterator3['return']();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  edges = H.isMultigraph() ? H.edgesIter(false, true) : H.edgesIter();
  hasEdge = H.hasEdge;
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = _getIterator(edges), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var edge = _step4.value;

      if (!hasEdge.apply(G, edge)) {
        addEdge.apply(R, edge);
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4['return']) {
        _iterator4['return']();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  return R;
}

function genSymmetricDifference(G, H) {
  return (0, _internalsDelegate2['default'])('symmetricDifference', [G, H]);
}

/**
 * Return a new graph of `G` composed with `H`.
 *
 * Composition is the simple union of the node sets and edge sets. The node sets
 * of `G` and `H` do not need to be disjoint.
 *
 * ### Notes
 *
 * It is recommended that `G` and `H` be either both directed or both
 * undirected. Attributes from `H` take precedent over attributes from `G`.
 *
 * @param {Graph} G
 * @param {Graph} H
 * @return {Graph} A new graph with the same type as G
 */

function compose(G, H) {
  if (G.isMultigraph() !== H.isMultigraph()) {
    throw new _exceptionsJSNetworkXError2['default']('G and H must both be graphs or multigraphs');
  }

  var R = new G.constructor();
  R.name = 'compose(' + G.name + ', ' + H.name + ')';
  R.addNodesFrom(G.nodesIter(true));
  R.addNodesFrom(H.nodesIter(true));
  R.addEdgesFrom(G.isMultigraph() ? G.edgesIter(true, true) : G.edgesIter(true));
  R.addEdgesFrom(H.isMultigraph() ? H.edgesIter(true, true) : H.edgesIter(true));

  // add graph attributes
  _Object$assign(R.graph, G.graph, H.graph);

  return R;
}

function genCompose(G, H) {
  return (0, _internalsDelegate2['default'])('compose', [G, H]);
}

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(25)['default'];

var _defaults = __webpack_require__(45)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _binary = __webpack_require__(757);

var binary = _interopRequireWildcard(_binary);

exports.binary = binary;

_defaults(exports, _interopRequireWildcard(_binary));

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(16)['default'];

var _getIterator = __webpack_require__(8)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.hasPath = hasPath;
exports.genHasPath = genHasPath;
exports.shortestPath = shortestPath;
exports.genShortestPath = genShortestPath;
exports.shortestPathLength = shortestPathLength;
exports.genShortestPathLength = genShortestPathLength;

var _internalsDelegate = __webpack_require__(27);

var _internalsDelegate2 = _interopRequireDefault(_internalsDelegate);

var _exceptions = __webpack_require__(88);

var _unweighted = __webpack_require__(353);

var _weighted = __webpack_require__(354);

'use strict';

/**
 * Return `true` if `G` has a path from `source to `target`, `false` otherwise.
 *
 * @param {Graph} G
 * @param {{source: Node, target: node}} parameters
 *   - source: Starting node for path
 *   - target: Ending node for path
 * @return {boolean}
 */

function hasPath(G, _ref) {
  var source = _ref.source;
  var target = _ref.target;

  try {
    shortestPath(G, { source: source, target: target });
  } catch (error) {
    if (error instanceof _exceptions.JSNetworkXNoPath) {
      return false;
    }
    throw error;
  }
  return true;
}

function genHasPath(G, _source$target) {
  return (0, _internalsDelegate2['default'])('hasPath', [G, _source$target]);
}

/**
 * Compute shortest paths in the graph.
 *
 * ### Examples
 *
 * ```
 * var G = jsnx.pathGraph(5);
 * jsnx.shortestPath(G, {source: 0, target: 4});
 * // [0, 1, 2, 3, 4]
 * var paths = jsnx.shortestPath(G, {source: 0}); // target not specified
 * paths.get(4);
 * // [0, 1, 2, 3, 4]
 * paths = jsnx.shortestPath(G {target: 4}); // source not specified
 * paths.get(0);
 * // [0, 1, 2, 3, 4]
 * paths = jsnx.shortestPath(G); // source, target not specified
 * paths.get(0).get(4);
 * // [0, 1, 2, 3, 4]
 * ```
 *
 * ### Notes
 *
 * There may be more than one shortest path between a source and a target.
 * This returns only one of them.
 *
 * @see allPairsShortestPath
 * @see allPairsDijkstraPath
 * @see singleSourceShortestPath
 * @see singleSourceDijkstraPath
 *
 * @param {Graph} G
 * @param {?{source: ?Node, target: ?Node, weight: ?string}=} optParameters
 *   - source: Starting node for path.
 *     If not specified, compute the shortest paths using all nodes as source
 *     nodes.
 *   - target: Ending node for path.
 *     If not specified, compute the shortest paths using all nodes as target
 *     nodes.
 *   - weight:
 *     If not specified, every edge has weight/distance/cost of 1.
 *     If a string, use this edge attribute as the edge weight. Any edg
 *     attribute not present defaults to 1.
 * @return {(Array|Map)} All returned paths include both the source and the
 *   target in the path.
 *
 *   If the `source` and `target` are both specified, return a single list
 *   of nodes in a shortest path from the source to the target.
 *
 *   If only the `source` is specified, return a Map keyed by
 *   targets with a list of nodes in a shortest path from the source
 *   to one of the targets.
 *
 *   If only the `target` is specified, return a Map keyed by
 *   sources with a list of nodes in a shortest path from one of the
 *   sources to the target.
 *
 *   If neither the `source` nor `target` are specified return a Map
 *   of Maps with `Map {source: Map {target: [list of nodes in path] }}`.
 */

function shortestPath(G) {
  var _ref2 = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  var source = _ref2.source;
  var target = _ref2.target;
  var weight = _ref2.weight;

  var paths;

  if (source == null) {
    if (target == null) {
      // find paths between all pairs
      if (weight == null) {
        paths = (0, _unweighted.allPairsShortestPath)(G);
      } else {
        paths = (0, _weighted.allPairsDijkstraPath)(G, { weight: weight });
      }
    } else {
      // find paths from all nodes co-accessibly to the target
      var directed = G.isDirected();
      try {
        if (directed) {
          G.reverse(false);
        }
        if (weight == null) {
          paths = (0, _unweighted.singleSourceShortestPath)(G, target);
        } else {
          paths = (0, _weighted.singleSourceDijkstraPath)(G, { target: target, weight: weight });
        }

        // now flip the paths so they go from a source to the target
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _getIterator(paths), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _step$value = _slicedToArray(_step.value, 2);

            var _target = _step$value[0];
            var path = _step$value[1];

            paths.set(_target, path.reverse());
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator['return']) {
              _iterator['return']();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } finally {
        if (directed) {
          G.reverse(false);
        }
      }
    }
  } else {
    if (target == null) {
      // find paths to all nodes accessible from the source
      if (weight == null) {
        paths = (0, _unweighted.singleSourceShortestPath)(G, source);
      } else {
        paths = (0, _weighted.singleSourceDijkstraPath)(G, { source: source, weight: weight });
      }
    } else {
      // find shortest source-target path
      if (weight == null) {
        paths = (0, _unweighted.bidirectionalShortestPath)(G, source, target);
      } else {
        paths = (0, _weighted.dijkstraPath)(G, { source: source, target: target, weight: weight });
      }
    }
  }

  return paths;
}

function genShortestPath(G, _source$target$weight) {
  return (0, _internalsDelegate2['default'])('shortestPath', [G, _source$target$weight]);
}

/**
 * Compute shortest path lengths in the graph.
 *
 * ### Examples
 *
 * ```
 * var G = jsnx.pathGraph(5);
 * jsnx.shortestPathLength(G, {source: 0, target: 4});
 * // 4
 * var paths = jsnx.shortestPathLength(G, {source: 0}); // target not specified
 * paths.get(4);
 * // 4
 * paths = jsnx.shortestPathLength(G {target: 4}); // source not specified
 * paths.get(0);
 * // 4
 * paths = jsnx.shortestPathLength(G); // source, target not specified
 * paths.get(0).get(4);
 * // 4
 * ```
 *
 * ### Notes
 *
 * The length of the path is always 1 less than the number of nodes involved in
 * the path since the length measures the number of edges followed.
 *
 * For digraphs this returns the shortest directed path length. To find path
 * lengths in the reverse directio, use `G.reverse(false)` first to flip the
 * edge orientation.
 *
 * @see allPairsShortestPathLength
 * @see allPairsDijkstraPathLength
 * @see singleSourceShortestPathLength
 * @see singleSourceDijkstraPathLength
 *
 * @param {Graph} G
 * @param {?{source: ?Node, target: ?Node, weight: ?string}=} optParameters
 *   - source: Starting node for path.
 *     If not specified, compute the shortest path lengths using all nodes as
 *     source nodes.
 *   - target: Ending node for path.
 *     If not specified, compute the shortest path length using all nodes as
 *     target nodes.
 *   - weight:
 *     If not specified, every edge has weight/distance/cost of 1.
 *     If a string, use this edge attribute as the edge weight. Any edg
 *     attribute not present defaults to 1.
 * @return {(number|Map)}
 *   If the `source` and `target` are both specified, return the length of the
 *   shortest path from the source to the target.
 *
 *   If only the `source` is specified, return a Map keyed by
 *   targets whose values are the lengths of the shortest path from the source
 *   to one of the targets.
 *
 *   If only the `target` is specified, return a Map keyed by
 *   sources whose values are the lengths of the shortest path from one of the
 *   sources to the target.
 *
 *   If neither the `source` nor `target` are specified return a Map
 *   of Maps with path[source][target]=L, where L is the length of the shortest
 *   path from source to target.
 */

function shortestPathLength(G) {
  var _ref3 = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  var source = _ref3.source;
  var target = _ref3.target;
  var weight = _ref3.weight;

  var paths;

  if (source == null) {
    if (target == null) {
      // find paths between all pairs
      if (weight == null) {
        paths = (0, _unweighted.allPairsShortestPathLength)(G);
      } else {
        paths = (0, _weighted.allPairsDijkstraPathLength)(G, { weight: weight });
      }
    } else {
      // find paths from all nodes co-accessibly to the target
      var directed = G.isDirected();
      try {
        if (directed) {
          G.reverse(false);
        }
        if (weight == null) {
          paths = (0, _unweighted.singleSourceShortestPathLength)(G, target);
        } else {
          paths = (0, _weighted.singleSourceDijkstraPathLength)(G, { target: target, weight: weight });
        }
      } finally {
        if (directed) {
          G.reverse(false);
        }
      }
    }
  } else {
    if (target == null) {
      // find paths to all nodes accessible from the source
      if (weight == null) {
        paths = (0, _unweighted.singleSourceShortestPathLength)(G, source);
      } else {
        paths = (0, _weighted.singleSourceDijkstraPathLength)(G, { source: source, weight: weight });
      }
    } else {
      // find shortest source-target path
      if (weight == null) {
        paths = (0, _unweighted.bidirectionalShortestPath)(G, source, target);
        paths = paths.length - 1;
      } else {
        paths = (0, _weighted.dijkstraPathLength)(G, { source: source, target: target, weight: weight });
      }
    }
  }

  return paths;
}

// TODO averageShortestPathLength
// TODO allShortestPaths

function genShortestPathLength(G, _source$target$weight2) {
  return (0, _internalsDelegate2['default'])('shortestPathLength', [G, _source$target$weight2]);
}

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(25)['default'];

var _defaults = __webpack_require__(45)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _generic = __webpack_require__(759);

var generic = _interopRequireWildcard(_generic);

var _unweighted = __webpack_require__(353);

var unweighted = _interopRequireWildcard(_unweighted);

var _weighted = __webpack_require__(354);

var weighted = _interopRequireWildcard(_weighted);

exports.generic = generic;
exports.unweighted = unweighted;
exports.weighted = weighted;

_defaults(exports, _interopRequireWildcard(_generic));

_defaults(exports, _interopRequireWildcard(_unweighted));

_defaults(exports, _interopRequireWildcard(_weighted));

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(16)['default'];

var _Array$from = __webpack_require__(13)['default'];

var _getIterator = __webpack_require__(8)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.toMapOfLists = toMapOfLists;
exports.fromMapOfLists = fromMapOfLists;
exports.toMapOfMaps = toMapOfMaps;
exports.fromMapOfMaps = fromMapOfMaps;

var _prepCreateUsing = __webpack_require__(359);

var _prepCreateUsing2 = _interopRequireDefault(_prepCreateUsing);

var _internals = __webpack_require__(15);

/**
 * This module provides functions to convert JSNetworkX graphs to and from
 * non-NetworkX formats.
 */

/**
 * Return adjacency representation of graph as a map of lists.
 *
 * Completely ignores edge data for `MultiGraph` and `MultiDiGraph`.
 *
 * @param {Graph} G A graph
 * @param {Iterable=} optNodelist Use only nods specified in this list.
 *
 * @return {!Map}
 */

function toMapOfLists(G, optNodelist) {
  var map = new _internals.Map();

  if (optNodelist != null) {
    _Array$from(optNodelist).forEach(function (n) {
      return map.set(n, G.neighbors(n).filter(function (v) {
        return optNodelist.indexOf(v) > -1;
      }));
    });
  } else {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = _getIterator(G), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var n = _step.value;

        map.set(n, G.neighbors(n));
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator['return']) {
          _iterator['return']();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return map;
}

/**
 * Return a graph from a map of lists.
 * *
 * @param {!Map} map A map of lists adjacency representation.
 * @param {Graph=} optCreateUsing Use specified graph for result.
 *    Otherwise a new graph is created.
 *
 * @return {!Graph}
 */

function fromMapOfLists(map, optCreateUsing) {
  var G = (0, _prepCreateUsing2['default'])(optCreateUsing);
  G.addNodesFrom(map.keys());

  if (G.isMultigraph() && !G.isDirected()) {
    // a map_of_lists can't show multiedges.  BUT for undirected graphs,
    // each edge shows up twice in the map_of_lists.
    // So we need to treat this case separately.
    var seen = new _internals.Set();

    map.forEach(function (nbrlist, node) {
      nbrlist.forEach(function (nbr) {
        if (!seen.has(nbr)) {
          G.addEdge(node, nbr);
        }
      });
      seen.add(node); // don't allow reverse edge to show up
    });
  } else {
    map.forEach(function (nbrlist, node) {
      nbrlist.forEach(function (nbr) {
        return G.addEdge(node, nbr);
      });
    });
  }

  return G;
}

/**
 * Return adjacency representation of graph as a map of maps.
 *
 * @param {Graph} G A jsnx Graph
 * @param {Iterable=} optNodelist Use only nodes specified in nodelist
 * @param {Object=} optEdgeData If provided,  the value of the map will be
 *      set to edgeData for all edges.  This is useful to make
 *      an adjacency matrix type representation with 1 as the edge data.
 *      If optEdgeData is null or undefined, the edge data in G is used to
 *      fill the values.
 *      If G is a multigraph, the edge data is a dict for each pair (u,v).
 *
 * @return {!Map}
 */

function toMapOfMaps(G, optNodelist, optEdgeData) {
  var mapOfMaps = new _internals.Map();

  if (optNodelist != null) {
    optNodelist = _Array$from(optNodelist);
    optNodelist.forEach(function (u) {
      var mapOfU = mapOfMaps.set(u, new _internals.Map());
      G.get(u).forEach(function (v, data) {
        if (optNodelist.indexOf(v) > -1) {
          mapOfU.set(v, optEdgeData == null ? data : optEdgeData);
        }
      });
    });
  } else {
    // nodelist is undefined
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      var _loop = function () {
        var _step2$value = _slicedToArray(_step2.value, 2);

        var nbrmap = _step2$value[0];
        var u = _step2$value[1];

        /*eslint no-loop-func:0*/
        var mapOfU = mapOfMaps.set(u, new _internals.Map());
        nbrmap.forEach(function (data, v) {
          mapOfU.set(v, optEdgeData == null ? data : optEdgeData);
        });
      };

      for (var _iterator2 = _getIterator(G.adjacencyIter()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        _loop();
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2['return']) {
          _iterator2['return']();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }

  return mapOfMaps;
}

/**
 * Return a graph from a map of maps.
 *
 * @param {!Map} map A map of maps adjacency representation.
 * @param {Graph=} optCreateUsing Use specified graph for result.
 *      Otherwise a new graph is created.
 * @param {boolean=} optMultigraphInput (default=False)
 *      When True, the values of the inner dict are assumed
 *      to be containers of edge data for multiple edges.
 *      Otherwise this routine assumes the edge data are singletons.
 *
 * @return {Graph}
 */

function fromMapOfMaps(map, optCreateUsing, optMultigraphInput) {
  var G = (0, _prepCreateUsing2['default'])(optCreateUsing);
  var seen = new _internals.Set(); // don't add both directions of undirected graph
  G.addNodesFrom(map.keys());

  // is map a MultiGraph or MultiDiGraph?
  if (optMultigraphInput) {
    // make a copy  of the list of edge data (but not the edge data)
    if (G.isDirected()) {
      map.forEach(function (nbrs, u) {
        if ((0, _internals.isArrayLike)(nbrs)) {
          // throw expection of not map (object)
          throw new TypeError('Value is not a map.');
        }
        nbrs.forEach(function (datadict, v) {
          for (var key in datadict) {
            var data = datadict[key];
            if (G.isMultigraph()) {
              G.addEdge(u, v, key, data);
            } else {
              G.addEdge(u, v, data);
            }
          }
        });
      });
    } else {
      // undirected
      var isMultigraph = G.isMultigraph();
      map.forEach(function (nbrs, u) {
        if ((0, _internals.isArrayLike)(nbrs)) {
          // throw exception of not map
          throw new TypeError('Not a map');
        }
        nbrs.forEach(function (datadict, v) {
          // this works because sets convert the value to their string
          // representation
          if (!seen.has((0, _internals.tuple2)(u, v))) {
            for (var key in datadict) {
              var data = datadict[key];
              if (isMultigraph) {
                G.addEdge(u, v, key, data);
              } else {
                G.addEdge(u, v, data);
              }
            }
            seen.add((0, _internals.tuple2)(v, u));
          }
        });
      });
    }
  } else {
    // not a multigraph to multigraph transfer
    if (G.isMultigraph() && !G.isDirected()) {
      // map can have both representations u-v, v-u in dict.  Only add one.
      // We don't need this check for digraphs since we add both directions,
      // or for Graph() since it is done implicitly (parallel edges not allowed)
      map.forEach(function (nbrs, u) {
        if ((0, _internals.isArrayLike)(nbrs)) {
          // throw exception of not dict (object)
          throw new TypeError('Value is not a map');
        }
        nbrs.forEach(function (data, v) {
          if (!seen.has((0, _internals.tuple2)(u, v))) {
            G.addEdge(u, v, data);
            seen.add((0, _internals.tuple2)(v, u));
          }
        });
      });
    } else {
      map.forEach(function (nbrs, u) {
        if ((0, _internals.isArrayLike)(nbrs)) {
          // throw exception of not dict (object)
          throw new TypeError('Value is not a map');
        }
        nbrs.forEach(function (data, v) {
          G.addEdge(u, v, data);
        });
      });
    }
  }

  return G;
}

/*jshint ignore:start*/

/*jshint ignore:end*/

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = __webpack_require__(56)['default'];

var _classCallCheck = __webpack_require__(24)['default'];

var _getIterator = __webpack_require__(8)['default'];

var _Array$from = __webpack_require__(13)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.observe = observe;
exports.unobserve = unobserve;
exports.isObservable = isObservable;
/**
 * A simple event object to any data can be added. It provides four methods:
 *
 * - stopPropagation to indicated that subsequent event handlers should not be
 *   executed.
 * - isPropgationStopped to test the status (internal only)
 * - preventDefault to prevent the default action
 * - isDefaultPrevented to test the status
 */

var Event = (function () {

  /**
   * @param {string} type
   * @param {*} target
   */

  function Event(type, target) {
    _classCallCheck(this, Event);

    this.type = type;
    this.target = target;
    this._defaultAction = true;
    this._propagate = true;
  }

  _createClass(Event, [{
    key: 'stopPropagation',

    /**
     * When called, should prevent the execution of subsequent handlers.
     */
    value: function stopPropagation() {
      this._propagate = false;
    }
  }, {
    key: 'isPropgationStopped',

    /**
     * Tests whether the propagation should be stopped.
     * @return {boolean}
     */
    value: function isPropgationStopped() {
      return !this._propagate;
    }
  }, {
    key: 'preventDefault',

    /**
     * When called, should prevent the default action.
     */
    value: function preventDefault() {
      this._defaultAction = false;
    }
  }, {
    key: 'isDefaultPrevented',

    /**
     * Tests whether the default action should be stopped.
     *
     * @return {boolean}
     */
    value: function isDefaultPrevented() {
      return !this._defaultAction;
    }
  }]);

  return Event;
})();

/**
 * Makes a graph observable, i.e. external code can bind event handlers to
 * be notified about changes in the graph (adding or removing nodes or edges).
 *
 * @param {Graph} G The graph to make observable
 * @return {Graph} The same graph passed as argument (not a new graph)
 */

function observe(G) {
  if (typeof G.on === 'function') {
    // graph is already observable, do nothing
    return G;
  }

  var eventHandlers = {
    'addNodes': [],
    'removeNodes': [],
    'addEdges': [],
    'removeEdges': [],
    'clear': []
  };
  var proto = G.constructor.prototype;

  /* eslint-disable no-shadow */
  function triggerHandlers(event, G, funcName, args) {
    /* eslint-enable no-shadow */
    var handlers = eventHandlers[event.type];
    if (!handlers) {
      return;
    }
    // run before handlers
    for (var i = 0, l = handlers.length; i < l && !event.isPropgationStopped(); i += 3) {
      if (handlers[i + 2]) {
        handlers[i].call(handlers[i + 1] || G, event);
      }
    }

    if (!event.isDefaultPrevented()) {
      if (args) {
        proto[funcName].apply(G, args);
      } else {
        proto[funcName].call(G);
      }
      if (!event.isPropgationStopped()) {
        // run after handlers
        for (i = 0, l = handlers.length; i < l && !event.isPropgationStopped(); i += 3) {
          if (!handlers[i + 2]) {
            handlers[i].call(handlers[i + 1] || G, event);
          }
        }
      }
    }
  }

  G.on = function (event, handler, thisObj, before) {
    if (!eventHandlers[event]) {
      throw new Error('Event "' + event + '" is not supported.');
    }
    eventHandlers[event].push(handler, thisObj, !!before);
  };

  G.off = function (event, handler, thisObj) {
    var handlers;
    var startIndex;
    var i;
    if (arguments.length === 1) {
      // Remove all event handlers
      eventHandlers[event].length = 0;
    } else if (arguments.length === 2) {
      // Remove particular handler or object only
      handlers = eventHandlers[event];
      startIndex = handlers.length - 2;
      if (typeof handler !== 'function') {
        startIndex += 1;
      }
      for (i = startIndex; i > 0; i -= 2) {
        if (handlers[i] === handler) {
          handlers.splice(i, 3);
        }
      }
    } else {
      // Remove particular handler-object combination
      handlers = eventHandlers[event];
      startIndex = handlers.length - 2;
      for (i = startIndex; i > 0; i -= 2) {
        if (handlers[i] === handler && handlers[i + 1] === thisObj) {
          handlers.splice(i, 2);
        }
      }
    }
  };

  G.addNode = function (n) {
    var newNodes = G.hasNode(n) ? [] : [n];
    var event = new Event('addNodes', this);
    event.nodes = [n];
    event.newNodes = newNodes;

    triggerHandlers(event, this, 'addNode', arguments);
  };

  G.addNodesFrom = function (nbunch) {
    var nodes = [];
    var newNodes = [];

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = _getIterator(nbunch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var bunch = _step.value;

        var v = Array.isArray(bunch) ? bunch[0] : bunch;
        nodes.push(Array.isArray(bunch) ? bunch.slice() : bunch);
        if (!G.hasNode(v)) {
          newNodes.push(v);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator['return']) {
          _iterator['return']();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    var event = new Event('addNodes', this);
    event.nodes = nodes.filter(function (v) {
      return Array.isArray(v) ? v[0] : v;
    });
    event.newNodes = newNodes;

    var args = _Array$from(arguments);
    args[0] = nodes;

    triggerHandlers(event, this, 'addNodesFrom', args);
  };

  G.addEdge = function (u, v) {
    var edges = [[u, v]];
    var newEdges = this.hasEdge(u, v) ? [] : edges;

    var event = new Event('addEdges', this);
    event.edges = edges;
    event.newEdges = newEdges;

    triggerHandlers(event, this, 'addEdge', arguments);
  };

  G.addEdgesFrom = function (ebunch) {
    var edges = [];
    var newEdges = [];
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = _getIterator(ebunch), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var bunch = _step2.value;

        edges.push(bunch.slice());
        if (!this.hasEdge(bunch[0], bunch[1])) {
          newEdges.push(bunch.slice(0, 2));
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2['return']) {
          _iterator2['return']();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    var event = new Event('addEdges', this);
    event.edges = edges;
    event.newEdges = newEdges;

    var args = _Array$from(arguments);
    args[0] = edges;

    triggerHandlers(event, this, 'addEdgesFrom', args);
  };

  G.removeNode = function (n) {
    var event = new Event('removeNodes', this);
    event.nodes = [n];

    triggerHandlers(event, this, 'removeNode', arguments);
  };

  G.removeNodesFrom = function (nbunch) {
    var nodes = [];
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = _getIterator(nbunch), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var bunch = _step3.value;

        nodes.push(Array.isArray(bunch) ? bunch.slice() : bunch);
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3['return']) {
          _iterator3['return']();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    var event = new Event('removeNodes', this);
    event.nodes = nodes;

    var args = _Array$from(arguments);
    args[0] = nodes;

    triggerHandlers(event, this, 'removeNodesFrom', args);
  };

  G.removeEdge = function (u, v) {
    var event = new Event('removeEdges', this);
    event.edges = [[u, v]];

    triggerHandlers(event, this, 'removeEdge', arguments);
  };

  G.removeEdgesFrom = function (ebunch) {
    var edges = [];
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = _getIterator(ebunch), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var bunch = _step4.value;

        edges.push(bunch.slice());
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4['return']) {
          _iterator4['return']();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    var event = new Event('removeEdges');
    event.edges = edges;

    var args = _Array$from(arguments);
    args[0] = edges;

    triggerHandlers(event, this, 'removeEdgesFrom', args);
  };

  G.clear = function () {
    triggerHandlers(new Event('clear', this), this, 'clear');
  };

  return G;
}

/**
 * Removes the properties added to a graph for event handling.
 *
 * @param {Graph} G
 * @return {Graph} The graph passed to the function
 */

function unobserve(G) {
  var proto = G.constructor.prototype;

  if (typeof G.on !== 'function') {
    // nothing to do
    return G;
  }

  G.addNode = proto.addNode;
  G.addNodesFrome = proto.addNodesFrom;
  G.addEdge = proto.addEdge;
  G.addEdgesFrome = proto.addEdgesFrom;
  G.removeNode = proto.removeNode;
  G.removeEdge = proto.removeEdge;
  G.removeNodesFrom = proto.removeNodesFrom;
  G.removeEdgesFrom = proto.removeEdgesFrom;
  G.clear = proto.clear;

  delete G.on;
  delete G.off;

  return G;
}

/**
 * Tests whether the graph is observable.
 *
 * @param {Graph} G
 * @return {boolean}
 */

function isObservable(G) {
  return typeof G.on === 'function' && typeof G.off === 'function';
}

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2)['default'];

var _defaults = __webpack_require__(45)['default'];

var _interopRequireWildcard = __webpack_require__(25)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _svg = __webpack_require__(764);

var _svg2 = _interopRequireDefault(_svg);

exports.svg = _svg2['default'];

_defaults(exports, _interopRequireWildcard(_svg));

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _slicedToArray = __webpack_require__(16)['default'];

var _getIterator = __webpack_require__(8)['default'];

var _Array$from = __webpack_require__(13)['default'];

var _regeneratorRuntime = __webpack_require__(19)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.draw = draw;
/**
 * @fileoverview
 *
 * D3(http://mbostock.github.com/d3/) is a powerful library to associate data
 * with elements and provides various helpful methods to visualize the data,
 * such as color generators, layouts and DOM manipulation methods.
 *
 * Note: D3 must be included before running these functions
 */

var _internals = __webpack_require__(15);

var nullFunction = function nullFunction() {};

function angleFor(x1, y1, x2, y2) {
  return Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI;
}

/**
 * Safely converts an iterator to an array. Because we often use tuples when
 * using generators internally, we have to be careful when converting the
 * generator to an array. Every element has to be converted explicitly.
 */
function toArray(iterator) {
  // shortcut. If the value is actually an array, we can just return it
  if (Array.isArray(iterator)) {
    return iterator;
  }
  var result = [];
  var i = 0;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _getIterator(iterator), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var value = _step.value;

      result[i++] = Array.isArray(value) ? _Array$from(value) : value;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator['return']) {
        _iterator['return']();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return result;
}

/**
 * Holds a reference to the last container element for convenience.
 *
 * @type {?(string|Element)}
 * @private
 */
var LAST_ELEMENT = null;

/**
 * Holds a reference to the last configuration for convenience.
 *
 * @type {Object}
 * @private
 */
var LAST_CONFIGURATION = null;

/**
 * A list of graph mutator methods.
 *
 * @type {Array.<string>}
 * @const
 * @private
 */
var MUTATOR_METHODS = ['addNode', 'addNodesFrom', 'addEdge', 'addEdgesFrom', 'removeNode', 'removeNodesFrom', 'removeEdge', 'removeEdgesFrom', 'clear'];

/**
 * The name of the attribute the D3 data is assigned to in the node and
 * edge data.
 *
 * @type {string}
 */
var D3_DATA_NAME = '__d3datum__';

/**
 * Keep a reference to d3.
 */
var d3 = global.d3;

/**
 * Draw graph G with D3.
 *
 * This method draws `G` with the provided `options`. If `optBind` is set to
 * `true`, changes to the graph structure will automatically update the
 * visualization.
 *
 * Returns the force layout used to compute the position of the nodes.
 *
 * The following options are available:
 *
 * - element (Element|String): This option is **required**. Specifies the
 *   container of the visualization. A string is interpreted as CSS selector.
 * - d3 (d3): Use to explicitly pass a reference to D3. If not present, the
 *   global variable d3 will be used instead.
 * - width (number): The width of the canvas in pixels. Defaults to the width
 *   of the container.
 * - height (number): The height of the canvas in pixels. Defaults to the
 *   height of the container.
 * - layoutAttr (Object): Layout options. The default layout is "force", so
 *   the options size, linkDistance, linkStrength, friction, charge, theta
 *   and gravity can be set. For example, setting `{linkDistance: 10}` will call
 *   `force.linkDistance(10)`.
 * - nodelist (Iterable): An iterable of nodes. If present, only nodes in that
 *   list will be drawn.
 * - nodeShape (string): The tag name of the SVG element to be used as nodes.
 *   Defaults to "circle".
 * - nodeAttr (Object): The attributes to set on the node SVG element. This
 *   object is passed along to D3's `.attr()` method.
 * - nodeStyle (Object): The style properties to set on the node SVG element.
 *   This object is passed along to D3's `.style()` method.
 * - edgeAttr (Object): The attributes to set on an edge SVG element. Edges are
 *   represented by SVG path elements.
 * - edgeStyle (Object): The style properties to set on the edge SVG element.
 *   Note: Even though the edge element is a SVG path element, you cannot set
 *   `stroke-width` to set the stroke width. Instead, the value of
 *   `stroke-width` is used as maximum value for the edge width.
 * - withLabels (boolean): Whether or not to draw node labels. SVG text elements
 *   are used for labels.
 * - labels (string|Object|function): The node labels to use.
 *   If `withLabels` is `true`, but `labels` is not present, defaults to the
 *   node itself.
 *   If a string is passed, the value of the property of the node data with the
 *   same name will be used.
 *   If an object is passed, the label is looked up in the object using the node
 *   as property name.
 *   If a function is passed, it gets called and passed the corresponding D3
 *   data object.
 * - labelAttr (Object): Like `nodeAttr` but for the label nodes. Labels are
 *   represented by SVG text nodes.
 * - labelStyle (Object): Like `nodeStyle` but for the label nodes. Labels are
 *   represented by SVG text nodes.
 * - withEdgeLabels (boolean): See `withLabels`, but for edges.
 * - edgeLabels (string|Object|function): See `labels`.
 * - edgeLabelAttr (Object): Like `labelAttr`.
 * - edgeLabelStyle (Object): Like `labelStyle`.
 * - weighted (boolean): Whether the edge width depends on the weight of the
 *   edge. The max and min weight are automatically computed. This is a
 *   convenience option so that you don't have to compute the edge weights
 *   yourself.
 * - weights (string|function): Specifies the weight for each edge.
 *   If `weighted` is `true` but `weights` is not present, defaults to
 *   `"weight"`.
 *   If a string is passed, the value of the property of the edge data with the
 *   same name is used as weight.
 *   If a function is passed, it gets called and passed the corresponding D3
 *   data object.
 * - edgeOffset (number|function): The distance in pixels between the edge start
 *   and the node. If not set and `nodeShape` is a `"circle"`, the offset will
 *   be automatically computed based on the radius.
 *   If a different shape for nodes is used it might be necessary to set the
 *   offset manually.
 * - edgeLabelOffset (number|function): By default edge labels are drawing in
 *   in the center of the edge. Can be used to adjust the position.
 * - panZoom (Object):
 *      - enabled (boolean): Enables panning and zooming of the canvas.
 *      - scale (boolean): Whether nodes and labels should keep their size
 *        when zooming or not.
 *
 * @param {jsnx.classes.Graph} G The graph to draw
 * @param {?Object=} config A dictionary of configuration parameters.
 * @param {?boolean=} optBind Set to true to automatically update
 *      the output upon graph manipulation. Only works for adding nodes or edges
 *      for now.
 * @return {d3.layout.force}
 */

function draw(G, config, optBind) {
  if (typeof config === 'boolean') {
    optBind = config;
    config = null;
  }

  config = config || LAST_CONFIGURATION || {};
  LAST_CONFIGURATION = config;
  if (config.d3) {
    d3 = config.d3;
  }
  config = (0, _internals.deepmerge)({}, DEFAULT_CONFIG, config);

  if (!d3) {
    throw new Error('D3 requried for draw()');
  }

  if (config.element == null && LAST_ELEMENT == null) {
    throw new Error('Output element required for draw()');
  }

  // initialize
  LAST_ELEMENT = config.element || LAST_ELEMENT;

  // remove any possible previous graph
  d3.select(LAST_ELEMENT).select('svg.jsnx').remove();

  // set up base elements
  var container = d3.select(LAST_ELEMENT);
  var d3nodes = [];
  var d3links = [];
  var canvas = container.append('svg').classed('jsnx', true).attr('pointer-events', 'all');
  var parentContainer = canvas.append('g');
  var edgeSelection = parentContainer.append('g').classed('edges', true).selectAll('g.edge');
  var nodeSelection = parentContainer.append('g').classed('nodes', true).selectAll('g.node');
  var force = d3.layout.force();
  var width = config.width || parseInt(container.style('width'), 10);
  var height = config.height || parseInt(container.style('height'), 10);
  var layoutAttr = config.layoutAttr;
  var nodelist = config.nodelist || null;
  var labelFunc;
  var edgeLabelFunc;
  var weightFunc;
  var directed = G.isDirected();
  var weighted = config.weighted;
  var selections = {
    nodeSelection: nodeSelection,
    edgeSelection: edgeSelection
  };

  // determine node label function
  if (config.withLabels) {
    var labels = config.labels;
    switch (typeof labels) {
      case 'object':
        labelFunc = function (d) {
          return (0, _internals.getDefault)(labels[d.node], '');
        };
        break;
      case 'function':
        labelFunc = labels;
        break;
      case 'string':
        labelFunc = function (d) {
          return d.data[labels];
        };
        break;
      default:
        labelFunc = function (d) {
          return d.node;
        };
    }
  }
  config.labels = labelFunc;

  // if the graph should be weighted, we need a weight function
  // these will be used as edge labels if no others are provided
  if (weighted) {
    var weights = config.weights;
    switch (typeof weigths) {
      case 'object':
        weightFunc = function (d) {
          return (0, _internals.getDefault)(weights[d.node], 1);
        };
        break;
      case 'function':
        weightFunc = weights;
        break;
      case 'string':
        weightFunc = function (d) {
          return (0, _internals.getDefault)(d.data[weights], 1);
        };
        break;
      default:
        weightFunc = function (d) {
          return 1;
        };
    }
  }

  // determine edge labels
  if (config.withEdgeLabels) {
    var elabels = config.edgeLabels;

    if (weighted && elabels == null) {
      edgeLabelFunc = weightFunc;
    } else {
      switch (typeof elabels) {
        case 'object':
          edgeLabelFunc = function (d) {
            return (0, _internals.getDefault)(labels[d.node], '');
          };
          break;
        case 'function':
          edgeLabelFunc = elabels;
          break;
        case 'string':
          edgeLabelFunc = function (d) {
            return d.data[elabels];
          };
          break;
        default:
          edgeLabelFunc = function (d) {
            return d.edge;
          };
      }
    }
    config.edgeLabels = edgeLabelFunc;
  }

  // scale the width of the edge according to the weight
  if (weighted && config.weightedStroke) {
    var maxWeight = 1;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = _getIterator(G.edgesIter(null, true)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var _step2$value = _step2.value;
        var u = _step2$value.u;
        var v = _step2$value.v;
        var data = _step2$value.data;

        var weight = weightFunc({ data: data });
        if (weight > maxWeight) {
          maxWeight = weight;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2['return']) {
          _iterator2['return']();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    var scale = d3.scale.linear().range([2, config.edgeStyle['stroke-width']]).domain([0, maxWeight]);

    config.edgeStyle['stroke-width'] = function (d) {
      return scale(weightFunc.call(this, d));
    };
  }

  // remove any possible previous graph
  canvas.select('svg.jsnx').remove();

  // set size and hide the wild movement of nodes at the beginning
  canvas.attr('width', width + 'px').attr('height', height + 'px').style('opacity', 1e-6).transition().duration(1000).style('opacity', 1);

  // initialize layout
  // don't let the user set these:
  var exclude = {
    size: true,
    nodes: true,
    links: true,
    start: true
  };

  for (var attr in layoutAttr) {
    if (exclude[attr] !== true) {
      force[attr](layoutAttr[attr]);
    }
  }
  force.nodes(d3nodes).links(d3links).size([width, height]);

  // set up zoom and pan behaviour
  var zoom = 1;
  var invScale = 1; // used to scale nodes and text accordingly

  if (config.panZoom.enabled) {
    (function () {
      var scaled = config.panZoom.scale;
      var zooming = false;
      var zoomStartScale = 1;
      var zoomStart = zoom;

      canvas.call(d3.behavior.zoom().on('zoom', function () {
        if (!d3.event.sourceEvent) {
          return;
        }
        var shiftKey = d3.event.sourceEvent.shiftKey,
            zoomed = scaled && shiftKey || !(scaled || shiftKey);

        // if the graph is zoomed, we have to keep track of the
        // ration it was zoomed by
        if (zoomed && !zooming) {
          zoomStartScale = d3.event.scale;
          zoomStart = zoom;
          zooming = true;
        } else if (!zoomed && zooming) {
          zooming = false;
        }

        zoom = zoomed ? zoomStart * (d3.event.scale / zoomStartScale) : zoom;
        invScale = !zoomed ? zoom / d3.event.scale : invScale;

        var tr = d3.event.translate;
        parentContainer.attr('transform', 'translate(' + tr[0] + ',' + tr[1] + ')scale(' + d3.event.scale + ')');
        redraw();
      }));
    })();
  }

  var updateEdgePosition = nullFunction;
  var offset = config.edgeOffset;
  var nodeRadius = config.nodeAttr.r;
  var nodeStrokeWidth = config.nodeStyle['stroke-width'];

  if (config.nodeShape === 'circle') {
    if (typeof nodeRadius !== 'function') {
      nodeRadius = function () {
        return config.nodeAttr.r;
      };
    }
    if (typeof nodeStrokeWidth !== 'function') {
      nodeStrokeWidth = function () {
        return config.nodeStyle['stroke-width'];
      };
    }
    offset = function (d) {
      return [nodeRadius(d.source) + nodeStrokeWidth(d.source), nodeRadius(d.target) + nodeStrokeWidth(d.target)];
    };
  } else {
    if (Array.isArray(offset)) {
      offset = function () {
        return config.edgeOffset;
      };
    } else if (typeof offset === 'number') {
      offset = function () {
        return [config.edgeOffset, config.edgeOffset];
      };
    }
  }
  var strw = config.edgeStyle['stroke-width'];
  if (typeof strw !== 'function') {
    strw = function () {
      return config.edgeStyle['stroke-width'];
    };
  }
  var labelOffset = config.edgeLabelOffset;

  if (directed) {
    // don't rotate labels and draw curvy lines
    updateEdgePosition = function () {
      selections.edgeSelection.each(function (d) {
        if (d.source !== d.target) {
          var $this = d3.select(this);
          var x1 = d.source.x;
          var y1 = d.source.y;
          var x2 = d.target.x;
          var y2 = d.target.y;
          var angle = angleFor(x1, y1, x2, y2);
          var dx = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
          var computedOffset = offset(d);
          computedOffset = [computedOffset[0] * invScale, computedOffset[1] * invScale];

          $this.attr('transform', ['translate(', x1, ',', y1, ')', 'rotate(', angle, ')'].join(''));

          var shift = strw(d) * invScale;
          var arrowStartPoint = dx - computedOffset[1] - 2 * shift;
          var halfShift = shift / 2;
          $this.select('.line').attr('d', ['M', computedOffset[0], 0, 'L', computedOffset[0], -halfShift, 'L', arrowStartPoint, -halfShift, 'L', arrowStartPoint, -shift, 'L', dx - computedOffset[1], 0, 'z'].join(' '));

          var edgeScale = 1 / invScale;
          $this.select('text').attr('x', labelOffset.x * edgeScale + computedOffset[0] + (dx * edgeScale - computedOffset[0] - computedOffset[1]) / 2).attr('y', -strw(d) / 2 + -labelOffset.y * edgeScale).attr('transform', 'scale(' + invScale + ')');
        }
      });
    };
  } else {
    updateEdgePosition = function () {
      selections.edgeSelection.each(function (d) {
        if (d.source !== d.target) {
          var $this = d3.select(this);
          var x1 = d.source.x;
          var y1 = d.source.y;
          var x2 = d.target.x;
          var y2 = d.target.y;
          var angle = angleFor(x1, y1, x2, y2);
          var dx = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
          var center = dx / 2;
          var computedOffset = offset(d);
          computedOffset = [computedOffset[0] * invScale, computedOffset[1] * invScale];

          var edgeScale = 1 / invScale;
          var shift = strw(d) * invScale;
          var flip = angle > 90 && angle < 279;
          $this.attr('transform', ['translate(', x1, ',', y1, ')', 'rotate(', angle, ')'].join(''));
          $this.select('.line').attr('d', ['M', computedOffset[0], shift / 4, 'L', computedOffset[0], -shift / 4, 'L', dx - computedOffset[1], -shift / 4, 'L', dx - computedOffset[1], shift / 4, 'z'].join(' '));
          if (config.withEdgeLabels) {
            $this.select('text').attr('x', (flip ? 1 : -1) * labelOffset.x * edgeScale + computedOffset[0] + (dx * edgeScale - computedOffset[0] - computedOffset[1]) / 2).attr('y', -strw(d) / 4 + -labelOffset.y * edgeScale).attr('transform', 'scale(' + invScale + ')' + (flip ? 'rotate(180,' + center * (1 / invScale) + ',0)' : ''));
          }
        }
      });
    };
  }

  var redraw = function redraw() {
    // update node position
    selections.nodeSelection.attr('transform', function (d) {
      return ['translate(', d.x, ',', d.y, ')', 'scale(', invScale, ')'].join('');
    });

    updateEdgePosition();
  };

  force.on('tick', redraw);

  var nodes = G.nodesIter();
  var edges = G.edgesIter();

  if (nodelist) {
    // limit drawn nodes, disable binding
    optBind = false;
    nodes = G.nbunch_iter(nodelist);
    edges = G.edges_iter(nodelist);
  }

  // update d3 node and link data
  selections.nodeSelection = addNodes(G, nodes, force, nodeSelection, config);

  selections.edgeSelection = addEdges(G, edges, force, edgeSelection, edgeLabelFunc);

  // apply attributes and styles
  updateNodeAttr(selections.nodeSelection, config);

  updateEdgeAttr(selections.edgeSelection, config, null, directed);

  if (optBind) {
    bind(G, force, config, selections);
  } else {
    if (isBound(G)) {
      unbind(G);
    } else {
      clean(G);
    }
  }

  force.start();

  return force;
}

/**
* Helper function to create new node objects for the force layout and
* create the necessary SVG elements.
*
* @param {Graph} G
* @param {Iterable} nodes The nodes to include from the Graph
*      default are all nodes
* @param {d3.layout.force} force The layout
* @param {d3.selection} selection D3 DOM node selection of nodes
* @param {Object} Drawing configuration
*
* @return {!d3.selection} The new selection of SVG elements.
*/
function addNodes(G, nodes, force, selection, config) {
  // Get current data
  var layoutNodes = force.nodes();
  // add new data
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = _getIterator(nodes), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var node = _step3.value;

      var data = G.node.get(node);
      var nobj = { node: node, data: data, G: G };
      layoutNodes.push(nobj);
      data[D3_DATA_NAME] = nobj;
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3['return']) {
        _iterator3['return']();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  // update data join
  selection = selection.data(layoutNodes, nodeKeyFunction);
  // create new elements
  var drag = force.drag().on('dragstart', function (d) {
    // Prevent pan if node is dragged
    d3.event.sourceEvent.stopPropagation();
    if (config.stickyDrag) {
      d.fixed = true;
      d3.select(this).classed('fixed', true);
    }
  });
  var nsel = selection.enter().append('g').classed('node', true).call(drag);

  nsel.append(config.nodeShape).classed('node-shape', true);

  if (config.labels) {
    nsel.append('text').text(config.labels);
  }

  return selection;
}

/**
* Helper function to create new edge objects for the force layout.
*
* @param {Graph} G
* @param {Iterable} edges The nodes to include from the Graph
*      default are all nodes
* @param {d3.layout.force} force
* @param {d3.selection} selection D3 DOM node selection of nodes
* @param {Function=} opt_label_func Function to extract text for labels
*
* @return {!d3.selection}
*/
function addEdges(G, edges, force, selection, optLabelFunc) {
  // Get current data
  var layoutLinks = force.links();
  // add new data
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = _getIterator(edges), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var _step4$value = _slicedToArray(_step4.value, 3);

      var u = _step4$value[0];
      var v = _step4$value[1];
      var data = _step4$value[2];

      data = data || G.getEdgeData(u, v);
      var eobj = {
        edge: [u, v],
        source: G.node.get(u)[D3_DATA_NAME],
        target: G.node.get(v)[D3_DATA_NAME],
        data: data,
        G: G
      };
      layoutLinks.push(eobj);
      data[D3_DATA_NAME] = eobj;
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4['return']) {
        _iterator4['return']();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  // update data join
  selection = selection.data(layoutLinks, edgeKeyFunction);
  // create new elements
  var esel = selection.enter().append('g').classed('edge', true);
  esel.append('path').classed('line', true);

  if (optLabelFunc) {
    esel.append('text').text(optLabelFunc);
  }
  return selection;
}

/**
* Updates attributes of nodes.
*
* @param {d3.selection} selection
* @param {Object} config
* @param {Iterable=} opt_nodes a container of nodes. If set,
*      only update these nodes.
*/
function updateNodeAttr(selection, config, optNodes) {
  if (optNodes != null) {
    var newNodes = new _internals.Set();
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = _getIterator(optNodes), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var node = _step5.value;

        newNodes.add((0, _internals.isArrayLike)(node) ? node[0] : node);
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5['return']) {
          _iterator5['return']();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }

    selection = selection.filter(function (d) {
      return newNodes.has(d.node);
    });
  }
  selection.selectAll('.node-shape').attr(config.nodeAttr).style(config.nodeStyle);

  if (config.withLabels) {
    selection.selectAll('text').attr(config.labelAttr).style(config.labelStyle);
  }
}

/**
* Updates attributes of edges.
*
* @param {d3.selection} selection
* @param {Object} config
* @param {?=} optEdges If set, only updates the styles of the provided
*      edges
* @param {boolean=} optDirected
*/
function updateEdgeAttr(selection, config, optEdges, optDirected) {
  if (optEdges != null) {
    var newEdges = new _internals.Map();
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = _getIterator(optEdges), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var _step6$value = _slicedToArray(_step6.value, 2);

        var u = _step6$value[0];
        var v = _step6$value[1];

        newEdges.set(u, v);
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6['return']) {
          _iterator6['return']();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }

    selection = selection.filter(function (_ref) {
      var edge = _ref.edge;
      return newEdges.get(edge[0]) === edge[1] || optDirected || newEdges.get(edge[1]) === edge[0];
    });
  }

  selection.selectAll('.line').attr(config.edgeAttr).style(config.edgeStyle).style('stroke-width', 0);

  if (config.withEdgeLabels) {
    selection.selectAll('text').attr(config.edgeLabelAttr).style(config.edgeLabelStyle);
  }
}

/**
* Key function to extract the join value for the SVG nodes and the data.
*
* @param {Object} d The current datum
* @return {Node}
*/
function nodeKeyFunction(d) {
  return d.node;
}

/**
* Key function to extract the join value for the SVG nodes and the data.
*
* @param {Object} d The current datum
* @return {Array}
*/
function edgeKeyFunction(d) {
  return d.edge;
}

/**
* Helper function to remove node objects for the force layout.
*
* @param {Graph} G
* @param {Iterable} nodes to remove from the graph
* @param {d3.layout.force} force The force the nodes are bound to
* @param {d3.selection} selection Selection of node elements
*
* @return {d3.selection} Updated selection
*/
function removeNodes(G, nodes, force, selection) {
  // get current data set
  var data = force.nodes();

  // remove items from data
  var _iteratorNormalCompletion7 = true;
  var _didIteratorError7 = false;
  var _iteratorError7 = undefined;

  try {
    for (var _iterator7 = _getIterator(G.nbunchIter(nodes)), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
      var node = _step7.value;

      var index = data.indexOf(G.node.get(node)[D3_DATA_NAME]);
      if (index > -1) {
        data.splice(index, 1);
      }
    }
  } catch (err) {
    _didIteratorError7 = true;
    _iteratorError7 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion7 && _iterator7['return']) {
        _iterator7['return']();
      }
    } finally {
      if (_didIteratorError7) {
        throw _iteratorError7;
      }
    }
  }

  // rebind data
  selection = selection.data(data, nodeKeyFunction);
  // remove SVG elements
  selection.exit().remove();
  return selection;
}

/**
* Helper function to remove edge objects for the force layout.
*
* @param {jsnx.classes.Graph} G
* @param {?} edges Edges to remove
* @param {d3.layout.force} force The force the edges are bound to
* @param {d3.selection} selection Selection of edge elements
*
* @return {!d3.selection} Updated selection
*/
function removeEdges(G, edges, force, selection) {
  // get current data set
  var data = force.links();
  // remove items from data
  var _iteratorNormalCompletion8 = true;
  var _didIteratorError8 = false;
  var _iteratorError8 = undefined;

  try {
    for (var _iterator8 = _getIterator(edges), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
      var _step8$value = _slicedToArray(_step8.value, 2);

      var u = _step8$value[0];
      var v = _step8$value[1];

      var index = data.indexOf(G.getEdgeData(u, v, {})[D3_DATA_NAME]);
      if (index > -1) {
        data.splice(index, 1);
      }
    }
  } catch (err) {
    _didIteratorError8 = true;
    _iteratorError8 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion8 && _iterator8['return']) {
        _iterator8['return']();
      }
    } finally {
      if (_didIteratorError8) {
        throw _iteratorError8;
      }
    }
  }

  // rebind data
  selection = selection.data(data, edgeKeyFunction);
  // remove SVG elements
  selection.exit().remove();
  return selection;
}

/**
* Binds the output to the graph. This overrides mutator methods. To "free"
* the graph, you can call jsnx.unbind (which is public)
*
* @param {Graph} G A Graph
* @param {d3.layout.force} force Force layout
* @param {Object} config The configuration for the output
* @param {{nodeSelection:d3.selection, edgeSelection:d3.selection }} selections
*   Various D3 selections
*/
function bind(G, force, config, selections) {
  unbind(G, false);

  var proto = G.constructor.prototype;
  var edgeLabelFunc = config.edgeLabels;
  var directed = G.isDirected();

  G.addNode = function (n, optAttr) {
    var newNode = !this.hasNode(n);
    proto.addNode.call(this, n, optAttr);

    if (newNode) {
      selections.nodeSelection = addNodes(this, [n], force, selections.nodeSelection, config);
    }

    // update node attributes
    updateNodeAttr(selections.nodeSelection, config, [n]);

    force.start();
  };

  G.addNodesFrom = function (nbunch, optAttr) {
    // istanbul ignore next

    var _this = this;

    nbunch = toArray(nbunch);
    var newNodes = nbunch.filter(function (node) {
      return !_this.hasNode((0, _internals.isArrayLike)(node) ? node[0] : node);
    });

    proto.addNodesFrom.call(this, nbunch, optAttr);

    if (newNodes.length > 0) {
      // add new nodes and update
      selections.nodeSelection = addNodes(this, newNodes, force, selections.nodeSelection, config);
    }

    updateNodeAttr(selections.nodeSelection, config, nbunch);
    force.start();
  };

  G.addEdge = function (u, v, optAttr) {
    // istanbul ignore next

    var _this2 = this;

    var newEdge = !this.hasEdge(u, v);
    var edges = [[u, v]];
    var newNodes = newEdge ? (u === v ? [u] : edges[0]).filter(function (node) {
      return !_this2.hasNode(node);
    }) : [];
    proto.addEdge.call(G, u, v, optAttr);

    if (newNodes.length > 0) {
      selections.nodeSelection = addNodes(this, newNodes, force, selections.nodeSelection, config);

      updateNodeAttr(selections.nodeSelection, config, newNodes);
    }

    if (newEdge) {
      selections.edgeSelection = addEdges(this, edges, force, selections.edgeSelection, edgeLabelFunc);
    }

    updateEdgeAttr(selections.edgeSelection, config, edges, directed);
    force.start();
  };

  G.addEdgesFrom = function (ebunch, optAttr) {
    var newEdges = [];
    var newNodes = [];
    var seenEdges = new _internals.Map();
    var seenNodes = new _internals.Set();

    ebunch = toArray(ebunch);

    var _iteratorNormalCompletion9 = true;
    var _didIteratorError9 = false;
    var _iteratorError9 = undefined;

    try {
      for (var _iterator9 = _getIterator(ebunch), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
        var _step9$value = _slicedToArray(_step9.value, 2);

        var u = _step9$value[0];
        var v = _step9$value[1];

        if (!this.hasEdge(u, v) && seenEdges.get(u) !== v && (directed || seenEdges.get(v) === u)) {
          newEdges.push([u, v]);
          seenEdges.set(u, v);
          if (!this.hasNode(u) && !seenNodes.has(u)) {
            newNodes.push(u);
            seenNodes.add(u);
          }
          if (!this.hasNode(v) && !seenNodes.has(v)) {
            newNodes.push(v);
            seenNodes.add(v);
          }
        }
      }
    } catch (err) {
      _didIteratorError9 = true;
      _iteratorError9 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion9 && _iterator9['return']) {
          _iterator9['return']();
        }
      } finally {
        if (_didIteratorError9) {
          throw _iteratorError9;
        }
      }
    }

    proto.addEdgesFrom.call(G, ebunch, optAttr);

    if (newNodes.length > 0) {
      selections.nodeSelection = addNodes(this, newNodes, force, selections.nodeSelection, config);

      updateNodeAttr(selections.nodeSelection, config, newNodes);
    }

    if (newEdges.length > 0) {
      selections.edgeSelection = addEdges(this, newEdges, force, selections.edgeSelection, edgeLabelFunc);
    }

    updateEdgeAttr(selections.edgeSelection, config, newEdges, directed);
    force.start();
  };

  G.removeNode = function (n) {
    if (this.hasNode(n)) {
      selections.nodeSelection = removeNodes(this, [n], force, selections.nodeSelection);
      var edges = this.edgesIter([n]);

      if (this.isDirected()) {
        edges = _regeneratorRuntime.mark(function callee$2$0(self, outEdges) {
          return _regeneratorRuntime.wrap(function callee$2$0$(context$3$0) {
            while (1) switch (context$3$0.prev = context$3$0.next) {
              case 0:
                return context$3$0.delegateYield(outEdges, 't0', 1);

              case 1:
                return context$3$0.delegateYield(self.inEdgesIter([n]), 't1', 2);

              case 2:
              case 'end':
                return context$3$0.stop();
            }
          }, callee$2$0, this);
        })(this, edges);
      }

      selections.edgeSelection = removeEdges(this, edges, force, selections.edgeSelection);

      force.resume();
    }
    proto.removeNode.call(this, n);
  };

  G.removeNodesFrom = function (nbunch) {
    nbunch = toArray(nbunch);
    selections.nodeSelection = removeNodes(this, nbunch, force, selections.nodeSelection);

    var edges = this.edgesIter(nbunch);
    if (this.isDirected()) {
      edges = _regeneratorRuntime.mark(function callee$2$0(self, outEdges) {
        return _regeneratorRuntime.wrap(function callee$2$0$(context$3$0) {
          while (1) switch (context$3$0.prev = context$3$0.next) {
            case 0:
              return context$3$0.delegateYield(outEdges, 't0', 1);

            case 1:
              return context$3$0.delegateYield(self.inEdgesIter(nbunch), 't1', 2);

            case 2:
            case 'end':
              return context$3$0.stop();
          }
        }, callee$2$0, this);
      })(this, edges);
    }

    selections.edgeSelection = removeEdges(this, edges, force, selections.edgeSelection);

    force.resume();
    proto.removeNodesFrom.call(this, nbunch);
  };

  G.removeEdge = function (u, v) {
    selections.edgeSelection = removeEdges(this, [[u, v]], force, selections.edgeSelection);

    force.resume();
    proto.removeEdge.call(this, u, v);
  };

  G.removeEdgesFrom = function (ebunch) {
    ebunch = toArray(ebunch);
    selections.edgeSelection = removeEdges(this, ebunch, force, selections.edgeSelection);

    force.resume();
    proto.removeEdgesFrom.call(G, ebunch);
  };

  G.clear = function () {
    selections.nodeSelection = selections.nodeSelection.data([], nodeKeyFunction);
    selections.nodeSelection.exit().remove();
    selections.edgeSelection = selections.edgeSelection.data([], edgeKeyFunction);
    selections.edgeSelection.exit().remove();
    force.nodes([]).links([]).resume();
    proto.clear.call(this);
  };

  /**
   * @type boolean
   */
  G.bound = true;
}

/**
* Returns True if the graph is bound to an output.
*
* @param {Graph} G A Graph
* @return {boolean}
*/
function isBound(G) {
  return G.bound;
}

/**
* Resets mutator methods to the originals
*
* @param {} G graph
* @param {boolean=} opt_clean (default=True)
*    If true, all D3 data is removed from the graph
*/
function unbind(G) {
  var optClean = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

  if (isBound(G)) {
    var proto = G.constructor.prototype;
    MUTATOR_METHODS.forEach(function (m) {
      return G[m] = proto[m];
    });
    delete G.bound;
    if (optClean) {
      clean(G);
    }
  }
}

/**
* Removes any D3 data from the Graph.
*
* @param {Graph} G A Graph
*/
function clean(G) {
  /*eslint no-unused-vars:0*/
  var _iteratorNormalCompletion10 = true;
  var _didIteratorError10 = false;
  var _iteratorError10 = undefined;

  try {
    for (var _iterator10 = _getIterator(G.nodesIter(true)), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
      var _step10$value = _slicedToArray(_step10.value, 2);

      var _ = _step10$value[0];
      var data = _step10$value[1];

      delete data[D3_DATA_NAME];
    }
  } catch (err) {
    _didIteratorError10 = true;
    _iteratorError10 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion10 && _iterator10['return']) {
        _iterator10['return']();
      }
    } finally {
      if (_didIteratorError10) {
        throw _iteratorError10;
      }
    }
  }

  var _iteratorNormalCompletion11 = true;
  var _didIteratorError11 = false;
  var _iteratorError11 = undefined;

  try {
    for (var _iterator11 = _getIterator(G.edgesIter(null, true)), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
      var _step11$value = _slicedToArray(_step11.value, 3);

      var u = _step11$value[0];
      var v = _step11$value[1];
      var data = _step11$value[2];

      delete data[D3_DATA_NAME];
    }
  } catch (err) {
    _didIteratorError11 = true;
    _iteratorError11 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion11 && _iterator11['return']) {
        _iterator11['return']();
      }
    } finally {
      if (_didIteratorError11) {
        throw _iteratorError11;
      }
    }
  }
}

/**
* Default D3 configuration.
*
* @type Object
* @private
*/
var DEFAULT_CONFIG = {
  layoutAttr: {
    charge: -120,
    linkDistance: 60
  },
  nodeShape: 'circle',
  nodeAttr: {
    r: 10 // radius of 10
  },
  nodeStyle: {
    'stroke-width': 2,
    stroke: '#333',
    fill: '#999',
    cursor: 'pointer'
  },
  edgeAttr: {},
  edgeStyle: {
    fill: '#000',
    'stroke-width': 3
  },
  labelAttr: {},
  labelStyle: {
    'text-anchor': 'middle',
    'dominant-baseline': 'central',
    cursor: 'pointer',
    '-webkit-user-select': 'none',
    fill: '#000'
  },
  edgeLabelAttr: {},
  edgeLabelStyle: {
    'font-size': '0.8em',
    'text-anchor': 'middle',
    '-webkit-user-select': 'none'
  },
  edgeLabelOffset: {
    x: 0,
    y: 0.5
  },
  withLabels: false,
  withEdgeLabels: false,
  edgeOffset: 10,
  weighted: false,
  weights: 'weight',
  weightedStroke: true,
  panZoom: {
    enabled: true,
    scale: true
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(16)['default'];

var _Array$from = __webpack_require__(13)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.havelHakimiGraph = havelHakimiGraph;
exports.genHavelHakimiGraph = genHavelHakimiGraph;

var _internalsDelegate = __webpack_require__(27);

var _internalsDelegate2 = _interopRequireDefault(_internalsDelegate);

var _exceptionsJSNetworkXError = __webpack_require__(34);

var _exceptionsJSNetworkXError2 = _interopRequireDefault(_exceptionsJSNetworkXError);

var _algorithmsGraphical = __webpack_require__(352);

var _classic = __webpack_require__(146);

var _internalsSprintf = __webpack_require__(347);

var _internalsSprintf2 = _interopRequireDefault(_internalsSprintf);

'use strict';

// TODO: configuration_model
// TODO: directed_configuration_model
// TODO: expected_degree_graph

/**
 * Return a simple graph with given degree sequence constructed
 * using the Havel-Hakimi algorithm.
 *
 * ### Notes
 *
 * The Havel-Hakimi algorithm constructs a simple graph by
 * successively connecting the node of highest degree to other nodes
 * of highest degree, resorting remaining nodes by degree, and
 * repeating the process. The resulting graph has a high
 * degree-associativity. Nodes are labeled `1,.., degreeSequence.length`,
 * corresponding to their position in `degreeSequence`.
 *
 * The basic algorithm is from Hakimi (1) and was generalized by
 * Kleitman and Wang (2).
 *
 * ### References
 *
 * [1] Hakimi S.,
 *   On Realizability of a Set of Integers as Degrees of the
 *   Vertices of a linear Graph. I,
 *   Journal of SIAM, 10(3), pp. 496-506 (1962)
 * [2] Kleitman D.J. and Wang D.L.
 *   Algorithms for Constructing Graphs and Digraphs with Given Valences and
 *   Factors,
 *   Discrete Mathematics, 6(1), pp. 79-88 (1973)
 *
 * @param {Iterable} degreeSequence list of integers
 *      Each integer corresponds to the degree of a node (need not be sorted).
 * @param {Graph} optCreateUsing
 *      Return graph of this type. The instance will be cleared.
 *      Directed graphs are not allowed.
 * @return {Graph}
 */

function havelHakimiGraph(degreeSequence, optCreateUsing) {
  degreeSequence = _Array$from(degreeSequence);
  if (!(0, _algorithmsGraphical.isValidDegreeSequence)(degreeSequence)) {
    throw new _exceptionsJSNetworkXError2['default']('Invalid degree sequence');
  }
  if (optCreateUsing != null) {
    if (optCreateUsing.isDirected()) {
      throw new _exceptionsJSNetworkXError2['default']('Directed Graph not supported');
    }
  }
  var numberOfNodes = degreeSequence.length;
  var G = (0, _classic.emptyGraph)(numberOfNodes, optCreateUsing);
  var numDegrees = new Array(numberOfNodes);
  for (var i = 0; i < numberOfNodes; i++) {
    numDegrees[i] = [];
  }

  var maxDegree = 0;
  var degreeSum = 0;
  var n = 0;

  for (i = 0; i < numberOfNodes; i++) {
    var degree = degreeSequence[i];
    // process only the non-zero integers
    if (degree > 0) {
      numDegrees[degree].push(n);
      maxDegree = Math.max(maxDegree, degree);
      degreeSum += degree;
      n += 1;
    }
  }

  // Return graph if no edges
  if (n === 0) {
    return G;
  }

  // form list of [stubs,name] for each node.
  var modstubs = new Array(maxDegree + 1);
  for (i = 0; i < maxDegree + 1; i++) {
    modstubs[i] = [0, 0];
  }
  // Successively reduce degree sequence by removing the maximum degree
  while (n > 0) {
    // Retrieve the maximum degree in the sequence
    while (numDegrees[maxDegree].length === 0) {
      maxDegree -= 1;
    }
    // If there are not enough stubs to connect to, then the sequence is not
    // graphical
    if (maxDegree > n - 1) {
      throw new _exceptionsJSNetworkXError2['default']('Non-graphical integer sequence');
    }
    // Remove largest stub in list
    var source = numDegrees[maxDegree].pop();
    n -= 1;
    // Reduce the next maxDegree largest stubs
    var mslen = 0;
    var k = maxDegree;
    for (i = 0; i < maxDegree; i++) {
      while (numDegrees[k].length === 0) {
        k -= 1;
      }
      var target = numDegrees[k].pop();
      G.addEdge(source, target);
      n -= 1;
      if (k > 1) {
        modstubs[mslen] = [k - 1, target];
        mslen += 1;
      }
    }
    // Add back to the list any nonzero stubs that were removed
    for (i = 0; i < mslen; i++) {
      var _modstubs$i = _slicedToArray(modstubs[i], 2);

      var stubval = _modstubs$i[0];
      var stubtarget = _modstubs$i[1];

      numDegrees[stubval].push(stubtarget);
      n += 1;
    }
  }

  G.name = (0, _internalsSprintf2['default'])('havelHakimiGraph %s nodes %d edges', G.order(), G.size());
  return G;
}

// TODO: directed_havel_hakimi_graph
// TODO: degree_sequence_tree
// TODO: random_degree_sequence_graph
// TODO: DegreeSequenceRandomGraph

function genHavelHakimiGraph(degreeSequence, optCreateUsing) {
  return (0, _internalsDelegate2['default'])('havelHakimiGraph', [degreeSequence, optCreateUsing]);
}

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(25)['default'];

var _defaults = __webpack_require__(45)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _classic = __webpack_require__(146);

var classic = _interopRequireWildcard(_classic);

var _degreeSequence = __webpack_require__(765);

var degreeSequence = _interopRequireWildcard(_degreeSequence);

var _randomGraphs = __webpack_require__(767);

var randomGraphs = _interopRequireWildcard(_randomGraphs);

var _small = __webpack_require__(768);

var small = _interopRequireWildcard(_small);

var _social = __webpack_require__(769);

var social = _interopRequireWildcard(_social);

exports.classic = classic;
exports.degreeSequence = degreeSequence;
exports.randomGraphs = randomGraphs;
exports.small = small;
exports.social = social;

_defaults(exports, _interopRequireWildcard(_classic));

_defaults(exports, _interopRequireWildcard(_degreeSequence));

_defaults(exports, _interopRequireWildcard(_randomGraphs));

_defaults(exports, _interopRequireWildcard(_small));

_defaults(exports, _interopRequireWildcard(_social));

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _getIterator = __webpack_require__(8)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.fastGnpRandomGraph = fastGnpRandomGraph;
exports.genFastGnpRandomGraph = genFastGnpRandomGraph;
exports.gnpRandomGraph = gnpRandomGraph;
exports.genGnpRandomGraph = genGnpRandomGraph;
exports.binomialGraph = binomialGraph;
exports.genBinomialGraph = genBinomialGraph;
exports.erdosRenyiGraph = erdosRenyiGraph;
exports.genErdosRenyiGraph = genErdosRenyiGraph;

var _internalsDelegate = __webpack_require__(27);

var _internalsDelegate2 = _interopRequireDefault(_internalsDelegate);

var _classesDiGraph = __webpack_require__(114);

var _classesDiGraph2 = _interopRequireDefault(_classesDiGraph);

var _classesGraph = __webpack_require__(71);

var _classesGraph2 = _interopRequireDefault(_classesGraph);

var _classic = __webpack_require__(146);

var _internals = __webpack_require__(15);

'use strict';

//
//-------------------------------------------------------------------------
//  Some Famous Random Graphs
//-------------------------------------------------------------------------

/**
 * Return a random graph `$G_{n,p}$` (Erdős-Rényi graph, binomial graph).
 *
 * The `$G_{n,p}$` graph algorithm chooses each of the `$[n(n-1)]/2$`
 * (undirected) or `$n(n-1)$` (directed) possible edges with probability `$p$`.
 *
 * This algorithm is `$O(n+m)$` where `$m$` is the expected number of
 * edges `$m = p*n*(n-1)/2$`.
 *
 * It should be faster than `gnpRandomGraph` when `p` is small and
 * the expected number of edges is small (sparse graph).
 *
 * ### References
 *
 * [1] Vladimir Batagelj and Ulrik Brandes,
 *     "Efficient generation of large random networks",
 *     Phys. Rev. E, 71, 036113, 2005.
 *
 * @param {number} n The number of nodes
 * @param {number} p Probability for edge creation
 * @param {boolean} optDirected If true return a directed graph
 * @return {Graph}
 */

function fastGnpRandomGraph(n, p) {
  var optDirected = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

  var G = (0, _classic.emptyGraph)(n);
  G.name = (0, _internals.sprintf)('fastGnpRandomGraph(%s, %s)', n, p);

  if (p <= 0 || p >= 1) {
    return gnpRandomGraph(n, p, optDirected);
  }
  var v;
  var w = -1;
  var lp = Math.log(1 - p);
  var lr;

  if (optDirected) {
    // Nodes in graph are from 0,n-1 (start with v as the first node index).
    v = 0;
    G = new _classesDiGraph2['default'](G);
    while (v < n) {
      lr = Math.log(1 - Math.random());
      w = w + 1 + Math.floor(lr / lp);
      if (v === w) {
        // avoid self loops
        w = w + 1;
      }
      while (w >= n && v < n) {
        w = w - n;
        v = v + 1;
        if (v === w) {
          // avoid self loops
          w = w + 1;
        }
      }
      if (v < n) {
        G.addEdge(v, w);
      }
    }
  } else {
    v = 1; // Nodes in graph are from 0, n-1 (this is the second node index).
    while (v < n) {
      lr = Math.log(1 - Math.random());
      w = w + 1 + Math.floor(lr / lp);
      while (w >= v && v < n) {
        w = w - v;
        v = v + 1;
      }
      if (v < n) {
        G.addEdge(v, w);
      }
    }
  }
  return G;
}

function genFastGnpRandomGraph(n, p, optDirected) {
  return (0, _internalsDelegate2['default'])('fastGnpRandomGraph', [n, p, optDirected]);
}

/**
 * Return a random graph `$G_{n,p}$` (Erdős-Rényi graph, binomial graph).
 *
 * Chooses each of the possible edges with probability `p.
 *
 * This is also called `binomialGraph` and `erdosRenyiGraph`.
 *
 * This is an `$O(n^2)$` algorithm.  For sparse graphs (small `$p$`) see
 * `fastGnpRandomGraph for a faster algorithm.
 *
 * @param {number} n The number of nodes
 * @param {number} p Probability for edge creation
 * @param {boolean} optDirected
 *  If true returns a directed graph
 * @return {Graph}
 */

function gnpRandomGraph(n, p) {
  var optDirected = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

  var G = optDirected ? new _classesDiGraph2['default']() : new _classesGraph2['default']();
  var edges;
  var rangeN = (0, _internals.range)(n);

  G.addNodesFrom(rangeN);
  G.name = (0, _internals.sprintf)('gnpRandomGraph(%s, %s)', n, p);
  if (p <= 0) {
    return G;
  }
  if (p >= 1) {
    return (0, _classic.completeGraph)(n, G);
  }

  edges = G.isDirected() ? (0, _internals.genPermutations)(rangeN, 2) : (0, _internals.genCombinations)(rangeN, 2);

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _getIterator(edges), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var edge = _step.value;

      if (Math.random() < p) {
        G.addEdge(edge[0], edge[1]);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator['return']) {
        _iterator['return']();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return G;
}

function genGnpRandomGraph(n, p, optDirected) {
  return (0, _internalsDelegate2['default'])('gnpRandomGraph', [n, p, optDirected]);
}

/**
 * @alias gnpRandomGraph
 */

function binomialGraph(n, p, optDirected) {
  return gnpRandomGraph(n, p, optDirected);
}

function genBinomialGraph(n, p, optDirected) {
  return (0, _internalsDelegate2['default'])('binomialGraph', [n, p, optDirected]);
}

/**
 * @alias gnpRandomGraph
 */

function erdosRenyiGraph(n, p, optDirected) {
  return gnpRandomGraph(n, p, optDirected);
}

//TODO: newman_watts_strogatz_graph
//TODO: watts_strogatz_graph
//TODO: connected_watts_strogatz_graph
//TODO: random_regular_graph
//TODO: _random_subset
//TODO: barabasi_albert_graph
//TODO: powerlaw_cluster_graph
//TODO: random_lobster
//TODO: random_shell_graph
//TODO: random_powerlaw_tree
//TODO: random_powerlaw_tree_sequence

function genErdosRenyiGraph(n, p, optDirected) {
  return (0, _internalsDelegate2['default'])('erdosRenyiGraph', [n, p, optDirected]);
}

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(16)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.makeSmallUndirectedGraph = makeSmallUndirectedGraph;
exports.makeSmallGraph = makeSmallGraph;
exports.bullGraph = bullGraph;
exports.krackhardtKiteGraph = krackhardtKiteGraph;

var _exceptionsJSNetworkXError = __webpack_require__(34);

var _exceptionsJSNetworkXError2 = _interopRequireDefault(_exceptionsJSNetworkXError);

var _classic = __webpack_require__(146);

var _internals = __webpack_require__(15);

/**
 * Return a small undirected graph described by `graphDescription`.
 *
 * @see makeSmallGraph.
 *
 * @param {Array} graphDescription
 *    Description of the graph to create in the form `{type, name, n, list}`.
 * @param {Graph=}
 *    optCreateUsing Graph instance to empty and add nodes to.
 * @return {Graph}
 */

function makeSmallUndirectedGraph(graphDescription, optCreateUsing) {
  if (optCreateUsing != null && optCreateUsing.isDirected()) {
    throw new _exceptionsJSNetworkXError2['default']('Directed Graph not supported');
  }
  return makeSmallGraph(graphDescription, optCreateUsing);
}

/**
 * Return the small graph described by graph_description.
 *
 * `graphDescription` is a list of the form `{type, name, n, list}`.
 *
 * Here `ltype` is one of `"adjacencylist"` or `"edgelist"`,
 * `name` is the name of the graph and `n` the number of nodes.
 * This constructs a graph of `n` nodes with integer labels 0,..,n-1.
 *
 * If `ltype="adjacencylist"` then `xlist` is an adjacency list
 * with exactly `n` entries, in with the `j`'th entry (which can be empty)
 * specifies the nodes connected to vertex `j`.
 *
 * E.g. the "square" graph `$C_4$` can be obtained by
 *
 * ```
 * var G = makeSmallGraph({
 *   type: "adjacencylist",
 *   name: "C_4",
 *   n: 4,
 *   list: [[2,4],[1,3],[2,4],[1,3]]
 * });
 * ```
 *
 * or, since we do not need to add edges twice,
 *
 * ```
 * var G = makeSmallGraph({
 *   type: "adjacencylist",
 *   name: "C_4",
 *   n: 4,
 *   list: [[2,4],[3],[4],[]]]
 * });
 * ```
 *
 * If `ltype="edgelist"` then `xlist` is an edge list written as
 * `[[v1,w2],[v2,w2],...,[vk,wk]]`, where `vj` and `wj` integers in the range
 * 1,..,n
 *
 * E.g. the "square" graph `$C_4$` can be obtained by
 *
 * ```
 * var G = makeSmallGraph({
 *   type: "edgelist",
 *   name: "C_4",
 *   n: 4,
 *   list: [[1,2],[3,4],[2,3],[4,1]]]
 * });
 * ```
 *
 * Use the `optCreateUsing` argument to choose the graph class/type.
 *
 * @param {Array} graphDescription
 *    Description of the graph to create in the form `{type, name, n, list}`.
 * @param {Graph=} optCreateUsing Graph instance to empty and add nodes to.
 * @return {Graph}
 */

function makeSmallGraph(_ref, optCreateUsing) {
  var type = _ref.type;
  var name = _ref.name;
  var n = _ref.n;
  var list = _ref.list;

  var G = (0, _classic.emptyGraph)(n, optCreateUsing);
  var nodes = G.nodes();

  if (type === 'adjacencylist') {
    if (list.length !== n) {
      throw new _exceptionsJSNetworkXError2['default']('invalid graphDescription');
    }
    nodes.forEach(function (v) {
      (0, _internals.forEach)(list[v], function (u) {
        return G.addEdge(u - 1, v);
      });
    });
  } else if (type === 'edgelist') {
    (0, _internals.forEach)(list, function (_ref2) {
      var _ref22 = _slicedToArray(_ref2, 2);

      var v = _ref22[0];
      var u = _ref22[1];

      v -= 1;
      u -= 1;
      if (v < 0 || v > n - 1 || u < 0 || u > n - 1) {
        throw new _exceptionsJSNetworkXError2['default']('invalid graphDescription');
      } else {
        G.addEdge(v, u);
      }
    });
  }
  G.name = name;
  return G;
}

// TODO: LCF_graph

/**
 * Return the Bull graph.
 *
 * @param {Graph=} optCreateUsing  Graph instance to empty and add nodes to.
 * @return {Graph}
 */

function bullGraph(optCreateUsing) {
  var type = 'adjacencylist';
  var name = 'Bull Graph';
  var n = 5;
  var list = [[2, 3], [1, 3, 4], [1, 2, 5], [2], [3]];

  return makeSmallUndirectedGraph({ type: type, name: name, n: n, list: list }, optCreateUsing);
}

// TODO: chvatal_graph
// TODO: cubical_graph
// TODO: desargues_graph
// TODO: diamond_graph
// TODO: dodecahedral_graph
// TODO: frucht_graph
// TODO: heawood_graph
// TODO: house_graph
// TODO: house_x_graph
// TODO: icosahedral_graph

/**
 * Return the Krackhardt Kite Social Network.
 *
 * A 10 actor social network introduced by David Krackhardt
 * to illustrate: degree, betweenness, centrality, closeness, etc.
 * The traditional labeling is:
 * Andre=1, Beverley=2, Carol=3, Diane=4,
 * Ed=5, Fernando=6, Garth=7, Heather=8, Ike=9, Jane=10.
 *
 * @param {Graph=} opt_create_using Graph instance to empty and add nodes to.
 * @return {Graph}
 */

function krackhardtKiteGraph(optCreateUsing) {
  var type = 'adjacencylist';
  var name = 'Krackhardt Kite Social Network';
  var n = 10;
  var list = [[2, 3, 4, 6], [1, 4, 5, 7], [1, 4, 6], [1, 2, 3, 5, 6, 7], [2, 4, 7], [1, 3, 4, 7, 8], [2, 4, 5, 6, 8], [6, 7, 9], [8, 10], [9]];

  return makeSmallUndirectedGraph({ type: type, name: name, n: n, list: list }, optCreateUsing);
}

// TODO: moebius_kantor_graph
// TODO: octahedral_graph
// TODO: pappus_graph
// TODO: petersen_graph
// TODO: sedgewick_maze_graph
// TODO: tetrahedral_graph
// TODO: truncated_cube_graph
// TODO: truncated_tetrahedron_graph
// TODO: tutte_graph

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.karateClubGraph = karateClubGraph;
exports.davisSouthernWomenGraph = davisSouthernWomenGraph;
exports.florentineFamiliesGraph = florentineFamiliesGraph;
/**
 * @fileoverview Famous social networkx
 */

var _classesGraph = __webpack_require__(71);

var _classesGraph2 = _interopRequireDefault(_classesGraph);

var _internalsRange = __webpack_require__(145);

var _internalsRange2 = _interopRequireDefault(_internalsRange);

/**
 * Return Zachary's Karate club graph.
 *
 * ### References
 *
 * [1] Zachary W.
 *     An information flow model for conflict and fission in small groups.
 *     Journal of Anthropological Research, 33, 452-473, (1977).
 *
 * [2] Data file from:
 *     <http://vlado.fmf.uni-lj.si/pub/networks/data/Ucinet/UciData.htm>
 *
 * @return {Graph}
 */

function karateClubGraph() {
  var G = new _classesGraph2['default']();
  G.addNodesFrom((0, _internalsRange2['default'])(34));
  G.name = 'Zachary\'s Karate Club';

  var zacharyData = ['0 1 1 1 1 1 1 1 1 0 1 1 1 1 0 0 0 1 0 1 0 1 0 0 0 0 0 0 0 0 0 1 0 0', '1 0 1 1 0 0 0 1 0 0 0 0 0 1 0 0 0 1 0 1 0 1 0 0 0 0 0 0 0 0 1 0 0 0', '1 1 0 1 0 0 0 1 1 1 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 0 0 0 1 0', '1 1 1 0 0 0 0 1 0 0 0 0 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0', '1 0 0 0 0 0 1 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0', '1 0 0 0 0 0 1 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0', '1 0 0 0 1 1 0 0 0 0 0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0', '1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0', '1 0 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0 1 1', '0 0 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1', '1 0 0 0 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0', '1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0', '1 0 0 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0', '1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1', '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1', '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1', '0 0 0 0 0 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0', '1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0', '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1', '1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1', '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1', '1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0', '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1', '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0 1 0 1 0 0 1 1', '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0 1 0 0 0 1 0 0', '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 0 0 0 0 0 0 1 0 0', '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0 0 0 1', '0 0 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 0 0 0 0 0 0 0 0 1', '0 0 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0 1', '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0 0 1 0 0 0 0 0 1 1', '0 1 0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1', '1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 0 0 1 0 0 0 1 1', '0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 1 0 0 1 0 1 0 1 1 0 0 0 0 0 1 1 1 0 1', '0 0 0 0 0 0 0 0 1 1 0 0 0 1 1 1 0 0 1 1 1 0 1 1 0 0 1 1 1 1 1 1 1 0'];

  zacharyData.forEach(function (line, row) {
    var thisrow = line.split(' ');
    thisrow.forEach(function (val, col) {
      if (val === '1') {
        G.addEdge(row, col); // col goes from 0,33
      }
    });
  });

  G.addNodesFrom([0, 1, 2, 3, 4, 5, 6, 7, 8, 10, 11, 12, 13, 16, 17, 19, 21], { club: 'Mr. Hi' });
  G.addNodesFrom([9, 14, 15, 18, 20, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33], { club: 'Officer' });

  return G;
}

/**
 * Return Davis Southern women social network.
 *
 * This is a bipartite graph.
 *
 * ### References
 *
 * [1] A. Davis, Gardner, B. B., Gardner, M. R., 1941. Deep South.
 * University of Chicago Press, Chicago, IL.
 *
 * @return {Graph}
 */

function davisSouthernWomenGraph() {
  var G = new _classesGraph2['default']();
  // top nodes
  G.addNodesFrom(['Evelyn Jefferson', 'Laura Mandeville', 'Theresa Anderson', 'Brenda Rogers', 'Charlotte McDowd', 'Frances Anderson', 'Eleanor Nye', 'Pearl Oglethorpe', 'Ruth DeSand', 'Verne Sanderson', 'Myra Liddel', 'Katherina Rogers', 'Sylvia Avondale', 'Nora Fayette', 'Helen Lloyd', 'Dorothy Murchison', 'Olivia Carleton', 'Flora Price'], { bipartite: 0 });

  // bottom nodes
  G.addNodesFrom(['E1', 'E2', 'E3', 'E4', 'E5', 'E6', 'E7', 'E8', 'E9', 'E10', 'E11', 'E12', 'E13', 'E14'], { bipartite: 1 });

  G.add_edges_from([['Evelyn Jefferson', 'E1'], ['Evelyn Jefferson', 'E2'], ['Evelyn Jefferson', 'E3'], ['Evelyn Jefferson', 'E4'], ['Evelyn Jefferson', 'E5'], ['Evelyn Jefferson', 'E6'], ['Evelyn Jefferson', 'E8'], ['Evelyn Jefferson', 'E9'], ['Laura Mandeville', 'E1'], ['Laura Mandeville', 'E2'], ['Laura Mandeville', 'E3'], ['Laura Mandeville', 'E5'], ['Laura Mandeville', 'E6'], ['Laura Mandeville', 'E7'], ['Laura Mandeville', 'E8'], ['Theresa Anderson', 'E2'], ['Theresa Anderson', 'E3'], ['Theresa Anderson', 'E4'], ['Theresa Anderson', 'E5'], ['Theresa Anderson', 'E6'], ['Theresa Anderson', 'E7'], ['Theresa Anderson', 'E8'], ['Theresa Anderson', 'E9'], ['Brenda Rogers', 'E1'], ['Brenda Rogers', 'E3'], ['Brenda Rogers', 'E4'], ['Brenda Rogers', 'E5'], ['Brenda Rogers', 'E6'], ['Brenda Rogers', 'E7'], ['Brenda Rogers', 'E8'], ['Charlotte McDowd', 'E3'], ['Charlotte McDowd', 'E4'], ['Charlotte McDowd', 'E5'], ['Charlotte McDowd', 'E7'], ['Frances Anderson', 'E3'], ['Frances Anderson', 'E5'], ['Frances Anderson', 'E6'], ['Frances Anderson', 'E8'], ['Eleanor Nye', 'E5'], ['Eleanor Nye', 'E6'], ['Eleanor Nye', 'E7'], ['Eleanor Nye', 'E8'], ['Pearl Oglethorpe', 'E6'], ['Pearl Oglethorpe', 'E8'], ['Pearl Oglethorpe', 'E9'], ['Ruth DeSand', 'E5'], ['Ruth DeSand', 'E7'], ['Ruth DeSand', 'E8'], ['Ruth DeSand', 'E9'], ['Verne Sanderson', 'E7'], ['Verne Sanderson', 'E8'], ['Verne Sanderson', 'E9'], ['Verne Sanderson', 'E12'], ['Myra Liddel', 'E8'], ['Myra Liddel', 'E9'], ['Myra Liddel', 'E10'], ['Myra Liddel', 'E12'], ['Katherina Rogers', 'E8'], ['Katherina Rogers', 'E9'], ['Katherina Rogers', 'E10'], ['Katherina Rogers', 'E12'], ['Katherina Rogers', 'E13'], ['Katherina Rogers', 'E14'], ['Sylvia Avondale', 'E7'], ['Sylvia Avondale', 'E8'], ['Sylvia Avondale', 'E9'], ['Sylvia Avondale', 'E10'], ['Sylvia Avondale', 'E12'], ['Sylvia Avondale', 'E13'], ['Sylvia Avondale', 'E14'], ['Nora Fayette', 'E6'], ['Nora Fayette', 'E7'], ['Nora Fayette', 'E9'], ['Nora Fayette', 'E10'], ['Nora Fayette', 'E11'], ['Nora Fayette', 'E12'], ['Nora Fayette', 'E13'], ['Nora Fayette', 'E14'], ['Helen Lloyd', 'E7'], ['Helen Lloyd', 'E8'], ['Helen Lloyd', 'E10'], ['Helen Lloyd', 'E11'], ['Helen Lloyd', 'E12'], ['Dorothy Murchison', 'E8'], ['Dorothy Murchison', 'E9'], ['Olivia Carleton', 'E9'], ['Olivia Carleton', 'E11'], ['Flora Price', 'E9'], ['Flora Price', 'E11']]);

  return G;
}

/**
 * Return Florentine families graph.
 *
 * ### References
 *
 * [1] Ronald L. Breiger and Philippa E. Pattison
 * Cumulated social roles: The duality of persons and their algebras,1
 * Social Networks, Volume 8, Issue 3, September 1986, Pages 215-256
 *
 * @return {Graph}
 */

function florentineFamiliesGraph() {
  var G = new _classesGraph2['default']();
  G.addEdge('Acciaiuoli', 'Medici');
  G.addEdge('Castellani', 'Peruzzi');
  G.addEdge('Castellani', 'Strozzi');
  G.addEdge('Castellani', 'Barbadori');
  G.addEdge('Medici', 'Barbadori');
  G.addEdge('Medici', 'Ridolfi');
  G.addEdge('Medici', 'Tornabuoni');
  G.addEdge('Medici', 'Albizzi');
  G.addEdge('Medici', 'Salviati');
  G.addEdge('Salviati', 'Pazzi');
  G.addEdge('Peruzzi', 'Strozzi');
  G.addEdge('Peruzzi', 'Bischeri');
  G.addEdge('Strozzi', 'Ridolfi');
  G.addEdge('Strozzi', 'Bischeri');
  G.addEdge('Ridolfi', 'Tornabuoni');
  G.addEdge('Tornabuoni', 'Guadagni');
  G.addEdge('Albizzi', 'Ginori');
  G.addEdge('Albizzi', 'Guadagni');
  G.addEdge('Bischeri', 'Guadagni');
  G.addEdge('Guadagni', 'Lamberteschi');
  return G;
}

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Array$from = __webpack_require__(13)['default'];

var _interopRequireWildcard = __webpack_require__(25)['default'];

var _interopRequireDefault = __webpack_require__(2)['default'];

var _defaults = __webpack_require__(45)['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _algorithms = __webpack_require__(754);

var algorithms = _interopRequireWildcard(_algorithms);

var _classes = __webpack_require__(358);

var classes = _interopRequireWildcard(_classes);

var _convert = __webpack_require__(213);

var convert = _interopRequireWildcard(_convert);

var _drawing = __webpack_require__(763);

var drawing = _interopRequireWildcard(_drawing);

var _exceptions = __webpack_require__(88);

var exceptions = _interopRequireWildcard(_exceptions);

var _generators = __webpack_require__(766);

var generators = _interopRequireWildcard(_generators);

var _relabel = __webpack_require__(363);

var relabel = _interopRequireWildcard(_relabel);

var _internalsMap = __webpack_require__(70);

var _internalsMap2 = _interopRequireDefault(_internalsMap);

var _internalsSet = __webpack_require__(84);

var _internalsSet2 = _interopRequireDefault(_internalsSet);

var _internalsForEach = __webpack_require__(211);

var _internalsForEach2 = _interopRequireDefault(_internalsForEach);

exports.Map = _internalsMap2['default'];
exports.Set = _internalsSet2['default'];
exports.forEach = _internalsForEach2['default'];
exports.algorithms = algorithms;
exports.classes = classes;
exports.convert = convert;
exports.drawing = drawing;
exports.exceptions = exceptions;
exports.generators = generators;
exports.relabel = relabel;
var toArray = _Array$from;
exports.toArray = toArray;

_defaults(exports, _interopRequireWildcard(_algorithms));

_defaults(exports, _interopRequireWildcard(_classes));

_defaults(exports, _interopRequireWildcard(_convert));

_defaults(exports, _interopRequireWildcard(_drawing));

var _contribObserver = __webpack_require__(762);

_defaults(exports, _interopRequireWildcard(_contribObserver));

_defaults(exports, _interopRequireWildcard(_exceptions));

_defaults(exports, _interopRequireWildcard(_generators));

_defaults(exports, _interopRequireWildcard(_relabel));

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(522), __esModule: true };

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(523), __esModule: true };

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(532), __esModule: true };

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */



var _Symbol = __webpack_require__(773)["default"];

var _Object$create = __webpack_require__(115)["default"];

var _Object$setPrototypeOf = __webpack_require__(367)["default"];

var _Promise = __webpack_require__(217)["default"];

!(function (global) {
  "use strict";

  var hasOwn = Object.prototype.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof _Symbol === "function" ? _Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided, then outerFn.prototype instanceof Generator.
    var generator = _Object$create((outerFn || Generator).prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      prototype[method] = function (arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction ||
    // For the native GeneratorFunction constructor, the best we can
    // do is to check its .name property.
    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };

  runtime.mark = function (genFun) {
    if (_Object$setPrototypeOf) {
      _Object$setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = _Object$create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `value instanceof AwaitArgument` to determine if the yielded value is
  // meant to be awaited. Some may consider the name of this method too
  // cutesy, but they are curmudgeons.
  runtime.awrap = function (arg) {
    return new AwaitArgument(arg);
  };

  function AwaitArgument(arg) {
    this.arg = arg;
  }

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value instanceof AwaitArgument) {
          return _Promise.resolve(value.arg).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return _Promise.resolve(value).then(function (unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof process === "object" && process.domain) {
      invoke = process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new _Promise(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
      // If enqueue has been called before, then we want to wait until
      // all previous Promises have been resolved before calling invoke,
      // so that results are always delivered in the correct order. If
      // enqueue has not been called before, then it is important to
      // call invoke immediately, without waiting on a callback to fire,
      // so that the async generator function has the opportunity to do
      // any necessary setup in a predictable way. This predictability
      // is why the Promise constructor synchronously invokes its
      // executor callback, and why async functions synchronously
      // execute code before the first await. Since we implement simple
      // async functions in terms of async generators, it is especially
      // important to get this right, even though it requires care.
      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
      // Avoid propagating failures to Promises returned by later
      // invocations of the iterator.
      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function (innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));

    return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
    : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          if (method === "return" || method === "throw" && delegate.iterator[method] === undefined) {
            // A return or throw (when the delegate iterator has no throw
            // method) always terminates the yield* loop.
            context.delegate = null;

            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            var returnMethod = delegate.iterator["return"];
            if (returnMethod) {
              var record = tryCatch(returnMethod, delegate.iterator, arg);
              if (record.type === "throw") {
                // If the return method threw an exception, let that
                // exception prevail over the original return or throw.
                method = "throw";
                arg = record.arg;
                continue;
              }
            }

            if (method === "return") {
              // Continue with the outer return, now that the delegate
              // iterator has been terminated.
              continue;
            }
          }

          var record = tryCatch(delegate.iterator[method], delegate.iterator, arg);

          if (record.type === "throw") {
            context.delegate = null;

            // Like returning generator.throw(uncaught), but without the
            // overhead of an extra function call.
            method = "throw";
            arg = record.arg;
            continue;
          }

          // Delegate generator ran and handled its own exceptions so
          // regardless of what the method was, we continue as if it is
          // "next" with an undefined arg.
          method = "next";
          arg = undefined;

          var info = record.arg;
          if (info.done) {
            context[delegate.resultName] = info.value;
            context.next = delegate.nextLoc;
          } else {
            state = GenStateSuspendedYield;
            return info;
          }

          context.delegate = null;
        }

        if (method === "next") {
          if (state === GenStateSuspendedYield) {
            context.sent = arg;
          } else {
            context.sent = undefined;
          }
        } else if (method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw arg;
          }

          if (context.dispatchException(arg)) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            method = "next";
            arg = undefined;
          }
        } else if (method === "return") {
          context.abrupt("return", arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;

          var info = {
            value: record.arg,
            done: context.done
          };

          if (record.arg === ContinueSentinel) {
            if (context.delegate && method === "next") {
              // Deliberately forget the last sent value so that we don't
              // accidentally pass it on to the delegate.
              arg = undefined;
            }
          } else {
            return info;
          }
        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(arg) call above.
          method = "throw";
          arg = record.arg;
        }
      }
    };
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[iteratorSymbol] = function () {
    return this;
  };

  Gp[toStringTagSymbol] = "Generator";

  Gp.toString = function () {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function (object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      this.sent = undefined;
      this.done = false;
      this.delegate = null;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function stop() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;
        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.next = finallyEntry.finallyLoc;
      } else {
        this.complete(record);
      }

      return ContinueSentinel;
    },

    complete: function complete(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = record.arg;
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }
    },

    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      return ContinueSentinel;
    }
  };
})(
// Among the various tricks for obtaining a reference to the global
// object, this seems to be the most reliable technique that does not
// use indirect eval (which violates Content Security Policy).
typeof global === "object" ? global : typeof window === "object" ? window : typeof self === "object" ? self : undefined);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60), __webpack_require__(234)))

/***/ }),
/* 775 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array ? array.length : 0;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

var sample = __webpack_require__(368);

/** Used as references for `-Infinity` and `Infinity`. */
var POSITIVE_INFINITY = Number.POSITIVE_INFINITY;

/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @category Collection
 * @param {Array|Object|string} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */
function shuffle(collection) {
  return sample(collection, POSITIVE_INFINITY);
}

module.exports = shuffle;


/***/ }),
/* 777 */
/***/ (function(module, exports) {

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Native method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that invokes `func` with the `this` binding of the
 * created function and arguments from `start` and beyond provided as an array.
 *
 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/Web/JavaScript/Reference/Functions/rest_parameters).
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var say = _.restParam(function(what, names) {
 *   return what + ' ' + _.initial(names).join(', ') +
 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
 * });
 *
 * say('hello', 'fred', 'barney', 'pebbles');
 * // => 'hello fred, barney, & pebbles'
 */
function restParam(func, start) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        rest = Array(length);

    while (++index < length) {
      rest[index] = args[start + index];
    }
    switch (start) {
      case 0: return func.call(this, rest);
      case 1: return func.call(this, args[0], rest);
      case 2: return func.call(this, args[0], args[1], rest);
    }
    var otherArgs = Array(start + 1);
    index = -1;
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = rest;
    return func.apply(this, otherArgs);
  };
}

module.exports = restParam;


/***/ }),
/* 778 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

var baseCopy = __webpack_require__(372),
    keys = __webpack_require__(74);

/**
 * The base implementation of `_.assign` without support for argument juggling,
 * multiple sources, and `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return source == null
    ? object
    : baseCopy(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(784),
    baseMatchesProperty = __webpack_require__(785),
    bindCallback = __webpack_require__(220),
    identity = __webpack_require__(386),
    property = __webpack_require__(813);

/**
 * The base implementation of `_.callback` which supports specifying the
 * number of arguments to provide to `func`.
 *
 * @private
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {number} [argCount] The number of arguments to provide to `func`.
 * @returns {Function} Returns the callback.
 */
function baseCallback(func, thisArg, argCount) {
  var type = typeof func;
  if (type == 'function') {
    return thisArg === undefined
      ? func
      : bindCallback(func, thisArg, argCount);
  }
  if (func == null) {
    return identity;
  }
  if (type == 'object') {
    return baseMatches(func);
  }
  return thisArg === undefined
    ? property(func)
    : baseMatchesProperty(func, thisArg);
}

module.exports = baseCallback;


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(373),
    keysIn = __webpack_require__(225);

/**
 * The base implementation of `_.forIn` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForIn(object, iteratee) {
  return baseFor(object, iteratee, keysIn);
}

module.exports = baseForIn;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

var equalArrays = __webpack_require__(797),
    equalByTag = __webpack_require__(798),
    equalObjects = __webpack_require__(799),
    isArray = __webpack_require__(50),
    isTypedArray = __webpack_require__(224);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparing objects.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA=[]] Tracks traversed `value` objects.
 * @param {Array} [stackB=[]] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = objToString.call(object);
    if (objTag == argsTag) {
      objTag = objectTag;
    } else if (objTag != objectTag) {
      objIsArr = isTypedArray(object);
    }
  }
  if (!othIsArr) {
    othTag = objToString.call(other);
    if (othTag == argsTag) {
      othTag = objectTag;
    } else if (othTag != objectTag) {
      othIsArr = isTypedArray(other);
    }
  }
  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && !(objIsArr || objIsObj)) {
    return equalByTag(object, other, objTag);
  }
  if (!isLoose) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
    }
  }
  if (!isSameTag) {
    return false;
  }
  // Assume cyclic values are equal.
  // For more information on detecting circular references see https://es5.github.io/#JO.
  stackA || (stackA = []);
  stackB || (stackB = []);

  var length = stackA.length;
  while (length--) {
    if (stackA[length] == object) {
      return stackB[length] == other;
    }
  }
  // Add `object` and `other` to the stack of traversed objects.
  stackA.push(object);
  stackB.push(other);

  var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);

  stackA.pop();
  stackB.pop();

  return result;
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(376),
    toObject = __webpack_require__(73);

/**
 * The base implementation of `_.isMatch` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Array} matchData The propery names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparing objects.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = toObject(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var result = customizer ? customizer(objValue, srcValue, key) : undefined;
      if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(783),
    getMatchData = __webpack_require__(800),
    toObject = __webpack_require__(73);

/**
 * The base implementation of `_.matches` which does not clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    var key = matchData[0][0],
        value = matchData[0][1];

    return function(object) {
      if (object == null) {
        return false;
      }
      return object[key] === value && (value !== undefined || (key in toObject(object)));
    };
  }
  return function(object) {
    return baseIsMatch(object, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(375),
    baseIsEqual = __webpack_require__(376),
    baseSlice = __webpack_require__(790),
    isArray = __webpack_require__(50),
    isKey = __webpack_require__(379),
    isStrictComparable = __webpack_require__(380),
    last = __webpack_require__(775),
    toObject = __webpack_require__(73),
    toPath = __webpack_require__(381);

/**
 * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to compare.
 * @returns {Function} Returns the new function.
 */
function baseMatchesProperty(path, srcValue) {
  var isArr = isArray(path),
      isCommon = isKey(path) && isStrictComparable(srcValue),
      pathKey = (path + '');

  path = toPath(path);
  return function(object) {
    if (object == null) {
      return false;
    }
    var key = pathKey;
    object = toObject(object);
    if ((isArr || !isCommon) && !(key in object)) {
      object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
      if (object == null) {
        return false;
      }
      key = last(path);
      object = toObject(object);
    }
    return object[key] === srcValue
      ? (srcValue !== undefined || (key in object))
      : baseIsEqual(srcValue, object[key], undefined, true);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(370),
    baseMergeDeep = __webpack_require__(787),
    isArray = __webpack_require__(50),
    isArrayLike = __webpack_require__(90),
    isObject = __webpack_require__(35),
    isObjectLike = __webpack_require__(49),
    isTypedArray = __webpack_require__(224),
    keys = __webpack_require__(74);

/**
 * The base implementation of `_.merge` without support for argument juggling,
 * multiple sources, and `this` binding `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Array} [stackA=[]] Tracks traversed source objects.
 * @param {Array} [stackB=[]] Associates values with source counterparts.
 * @returns {Object} Returns `object`.
 */
function baseMerge(object, source, customizer, stackA, stackB) {
  if (!isObject(object)) {
    return object;
  }
  var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
      props = isSrcArr ? undefined : keys(source);

  arrayEach(props || source, function(srcValue, key) {
    if (props) {
      key = srcValue;
      srcValue = source[key];
    }
    if (isObjectLike(srcValue)) {
      stackA || (stackA = []);
      stackB || (stackB = []);
      baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
    }
    else {
      var value = object[key],
          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
          isCommon = result === undefined;

      if (isCommon) {
        result = srcValue;
      }
      if ((result !== undefined || (isSrcArr && !(key in object))) &&
          (isCommon || (result === result ? (result !== value) : (value === value)))) {
        object[key] = result;
      }
    }
  });
  return object;
}

module.exports = baseMerge;


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

var arrayCopy = __webpack_require__(219),
    isArguments = __webpack_require__(148),
    isArray = __webpack_require__(50),
    isArrayLike = __webpack_require__(90),
    isPlainObject = __webpack_require__(149),
    isTypedArray = __webpack_require__(224),
    toPlainObject = __webpack_require__(810);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Array} [stackA=[]] Tracks traversed source objects.
 * @param {Array} [stackB=[]] Associates values with source counterparts.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
  var length = stackA.length,
      srcValue = source[key];

  while (length--) {
    if (stackA[length] == srcValue) {
      object[key] = stackB[length];
      return;
    }
  }
  var value = object[key],
      result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
      isCommon = result === undefined;

  if (isCommon) {
    result = srcValue;
    if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
      result = isArray(value)
        ? value
        : (isArrayLike(value) ? arrayCopy(value) : []);
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      result = isArguments(value)
        ? toPlainObject(value)
        : (isPlainObject(value) ? value : {});
    }
    else {
      isCommon = false;
    }
  }
  // Add the source value to the stack of traversed objects and associate
  // it with its merged value.
  stackA.push(srcValue);
  stackB.push(result);

  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
  } else if (result === result ? (result !== value) : (value === value)) {
    object[key] = result;
  }
}

module.exports = baseMergeDeep;


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(375),
    toPath = __webpack_require__(381);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new function.
 */
function basePropertyDeep(path) {
  var pathKey = (path + '');
  path = toPath(path);
  return function(object) {
    return baseGet(object, path, pathKey);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 789 */
/***/ (function(module, exports) {

/* Native method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for argument juggling
 * and returning floating-point numbers.
 *
 * @private
 * @param {number} min The minimum possible value.
 * @param {number} max The maximum possible value.
 * @returns {number} Returns the random number.
 */
function baseRandom(min, max) {
  return min + nativeFloor(nativeRandom() * (max - min + 1));
}

module.exports = baseRandom;


/***/ }),
/* 790 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  start = start == null ? 0 : (+start || 0);
  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = (end === undefined || end > length) ? length : (+end || 0);
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 791 */
/***/ (function(module, exports) {

/**
 * Converts `value` to a string if it's not one. An empty string is returned
 * for `null` or `undefined` values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  return value == null ? '' : (value + '');
}

module.exports = baseToString;


/***/ }),
/* 792 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  var index = -1,
      length = props.length,
      result = Array(length);

  while (++index < length) {
    result[index] = object[props[index]];
  }
  return result;
}

module.exports = baseValues;


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Native method references. */
var ArrayBuffer = global.ArrayBuffer,
    Uint8Array = global.Uint8Array;

/**
 * Creates a clone of the given array buffer.
 *
 * @private
 * @param {ArrayBuffer} buffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function bufferClone(buffer) {
  var result = new ArrayBuffer(buffer.byteLength),
      view = new Uint8Array(result);

  view.set(new Uint8Array(buffer));
  return result;
}

module.exports = bufferClone;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

var bindCallback = __webpack_require__(220),
    isIterateeCall = __webpack_require__(223),
    restParam = __webpack_require__(777);

/**
 * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return restParam(function(object, sources) {
    var index = -1,
        length = object == null ? 0 : sources.length,
        customizer = length > 2 ? sources[length - 2] : undefined,
        guard = length > 2 ? sources[2] : undefined,
        thisArg = length > 1 ? sources[length - 1] : undefined;

    if (typeof customizer == 'function') {
      customizer = bindCallback(customizer, thisArg, 5);
      length -= 2;
    } else {
      customizer = typeof thisArg == 'function' ? thisArg : undefined;
      length -= (customizer ? 1 : 0);
    }
    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var toObject = __webpack_require__(73);

/**
 * Creates a base function for `_.forIn` or `_.forInRight`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var iterable = toObject(object),
        props = keysFunc(object),
        length = props.length,
        index = fromRight ? length : -1;

    while ((fromRight ? index-- : ++index < length)) {
      var key = props[index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var baseCallback = __webpack_require__(780),
    baseForOwn = __webpack_require__(374);

/**
 * Creates a function for `_.mapKeys` or `_.mapValues`.
 *
 * @private
 * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
 * @returns {Function} Returns the new map function.
 */
function createObjectMapper(isMapKeys) {
  return function(object, iteratee, thisArg) {
    var result = {};
    iteratee = baseCallback(iteratee, thisArg, 3);

    baseForOwn(object, function(value, key, object) {
      var mapped = iteratee(value, key, object);
      key = isMapKeys ? mapped : key;
      value = isMapKeys ? value : mapped;
      result[key] = value;
    });
    return result;
  };
}

module.exports = createObjectMapper;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(778);

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparing arrays.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA] Tracks traversed `value` objects.
 * @param {Array} [stackB] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
  var index = -1,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
    return false;
  }
  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index],
        result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;

    if (result !== undefined) {
      if (result) {
        continue;
      }
      return false;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (isLoose) {
      if (!arraySome(other, function(othValue) {
            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
          })) {
        return false;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
      return false;
    }
  }
  return true;
}

module.exports = equalArrays;


/***/ }),
/* 798 */
/***/ (function(module, exports) {

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    stringTag = '[object String]';

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag) {
  switch (tag) {
    case boolTag:
    case dateTag:
      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
      return +object == +other;

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case numberTag:
      // Treat `NaN` vs. `NaN` as equal.
      return (object != +object)
        ? other != +other
        : object == +other;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings primitives and string
      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
      return object == (other + '');
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

var keys = __webpack_require__(74);

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparing values.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA] Tracks traversed `value` objects.
 * @param {Array} [stackB] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
  var objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isLoose) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  var skipCtor = isLoose;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key],
        result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;

    // Recursively compare objects (susceptible to call stack limits).
    if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
      return false;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (!skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      return false;
    }
  }
  return true;
}

module.exports = equalObjects;


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(380),
    pairs = __webpack_require__(812);

/**
 * Gets the propery names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = pairs(object),
      length = result.length;

  while (length--) {
    result[length][2] = isStrictComparable(result[length][1]);
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 801 */
/***/ (function(module, exports) {

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add array properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

var bufferClone = __webpack_require__(793);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    stringTag = '[object String]';

var arrayBufferTag = '[object ArrayBuffer]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return bufferClone(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      var buffer = object.buffer;
      return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      var result = new Ctor(object.source, reFlags.exec(object));
      result.lastIndex = object.lastIndex;
  }
  return result;
}

module.exports = initCloneByTag;


/***/ }),
/* 803 */
/***/ (function(module, exports) {

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  var Ctor = object.constructor;
  if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
    Ctor = Object;
  }
  return new Ctor;
}

module.exports = initCloneObject;


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

var isArguments = __webpack_require__(148),
    isArray = __webpack_require__(50),
    isIndex = __webpack_require__(222),
    isLength = __webpack_require__(72),
    keysIn = __webpack_require__(225);

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A fallback implementation of `Object.keys` which creates an array of the
 * own enumerable property names of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function shimKeys(object) {
  var props = keysIn(object),
      propsLength = props.length,
      length = propsLength && object.length;

  var allowIndexes = !!length && isLength(length) &&
    (isArray(object) || isArguments(object));

  var index = -1,
      result = [];

  while (++index < propsLength) {
    var key = props[index];
    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = shimKeys;


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(90),
    isObject = __webpack_require__(35),
    values = __webpack_require__(385);

/**
 * Converts `value` to an array-like object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Array|Object} Returns the array-like object.
 */
function toIterable(value) {
  if (value == null) {
    return [];
  }
  if (!isArrayLike(value)) {
    return values(value);
  }
  return isObject(value) ? value : Object(value);
}

module.exports = toIterable;


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(371),
    bindCallback = __webpack_require__(220),
    isIterateeCall = __webpack_require__(223);

/**
 * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
 * otherwise they are assigned by reference. If `customizer` is provided it's
 * invoked to produce the cloned values. If `customizer` returns `undefined`
 * cloning is handled by the method instead. The `customizer` is bound to
 * `thisArg` and invoked with up to three argument; (value [, index|key, object]).
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
 * The enumerable properties of `arguments` objects and objects created by
 * constructors other than `Object` are cloned to plain `Object` objects. An
 * empty object is returned for uncloneable values such as functions, DOM nodes,
 * Maps, Sets, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {Function} [customizer] The function to customize cloning values.
 * @param {*} [thisArg] The `this` binding of `customizer`.
 * @returns {*} Returns the cloned value.
 * @example
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * var shallow = _.clone(users);
 * shallow[0] === users[0];
 * // => true
 *
 * var deep = _.clone(users, true);
 * deep[0] === users[0];
 * // => false
 *
 * // using a customizer callback
 * var el = _.clone(document.body, function(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(false);
 *   }
 * });
 *
 * el === document.body
 * // => false
 * el.nodeName
 * // => BODY
 * el.childNodes.length;
 * // => 0
 */
function clone(value, isDeep, customizer, thisArg) {
  if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
    isDeep = false;
  }
  else if (typeof isDeep == 'function') {
    thisArg = customizer;
    customizer = isDeep;
    isDeep = false;
  }
  return typeof customizer == 'function'
    ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 3))
    : baseClone(value, isDeep);
}

module.exports = clone;


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(383),
    isObjectLike = __webpack_require__(49);

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isNative;


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

var isObjectLike = __webpack_require__(49);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/** Used for native method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

var arrayCopy = __webpack_require__(219),
    getLength = __webpack_require__(221),
    isLength = __webpack_require__(72),
    values = __webpack_require__(385);

/**
 * Converts `value` to an array.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * (function() {
 *   return _.toArray(arguments).slice(1);
 * }(1, 2, 3));
 * // => [2, 3]
 */
function toArray(value) {
  var length = value ? getLength(value) : 0;
  if (!isLength(length)) {
    return values(value);
  }
  if (!length) {
    return [];
  }
  return arrayCopy(value);
}

module.exports = toArray;


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

var baseCopy = __webpack_require__(372),
    keysIn = __webpack_require__(225);

/**
 * Converts `value` to a plain object flattening inherited enumerable
 * properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return baseCopy(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(786),
    createAssigner = __webpack_require__(794);

/**
 * Recursively merges own enumerable properties of the source object(s), that
 * don't resolve to `undefined` into the destination object. Subsequent sources
 * overwrite property assignments of previous sources. If `customizer` is
 * provided it's invoked to produce the merged values of the destination and
 * source properties. If `customizer` returns `undefined` merging is handled
 * by the method instead. The `customizer` is bound to `thisArg` and invoked
 * with five arguments: (objectValue, sourceValue, key, object, source).
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {*} [thisArg] The `this` binding of `customizer`.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var users = {
 *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
 * };
 *
 * var ages = {
 *   'data': [{ 'age': 36 }, { 'age': 40 }]
 * };
 *
 * _.merge(users, ages);
 * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
 *
 * // using a customizer callback
 * var object = {
 *   'fruits': ['apple'],
 *   'vegetables': ['beet']
 * };
 *
 * var other = {
 *   'fruits': ['banana'],
 *   'vegetables': ['carrot']
 * };
 *
 * _.merge(object, other, function(a, b) {
 *   if (_.isArray(a)) {
 *     return a.concat(b);
 *   }
 * });
 * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
 */
var merge = createAssigner(baseMerge);

module.exports = merge;


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

var keys = __webpack_require__(74),
    toObject = __webpack_require__(73);

/**
 * Creates a two dimensional array of the key-value pairs for `object`,
 * e.g. `[[key1, value1], [key2, value2]]`.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the new array of key-value pairs.
 * @example
 *
 * _.pairs({ 'barney': 36, 'fred': 40 });
 * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
 */
function pairs(object) {
  object = toObject(object);

  var index = -1,
      props = keys(object),
      length = props.length,
      result = Array(length);

  while (++index < length) {
    var key = props[index];
    result[index] = [key, object[key]];
  }
  return result;
}

module.exports = pairs;


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(377),
    basePropertyDeep = __webpack_require__(788),
    isKey = __webpack_require__(379);

/**
 * Creates a function that returns the property value at `path` on a
 * given object.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': { 'c': 2 } } },
 *   { 'a': { 'b': { 'c': 1 } } }
 * ];
 *
 * _.map(objects, _.property('a.b.c'));
 * // => [2, 1]
 *
 * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = camelCase;
var regExp = /([A-Z])/g;

/**
 * Replace a string passed from String#replace.
 * @param {String} str
 * @return {String}
 */
function replace(str) {
  return "-" + str.toLowerCase();
}

/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */
function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    converted[prop.replace(regExp, replace)] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}

/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */
function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }
      return style;
    }

    return convertCase(style);
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = jssCompose;

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Set selector.
 *
 * @param {Object} original rule
 * @param {String} className class string
 * @return {Boolean} flag, indicating function was successfull or not
 */
function registerClass(rule, className) {
  // Skip falsy values
  if (!className) return true;

  // Support array of class names `{composes: ['foo', 'bar']}`
  if (Array.isArray(className)) {
    for (var index = 0; index < className.length; index++) {
      var isSetted = registerClass(rule, className[index]);
      if (!isSetted) return false;
    }

    return true;
  }

  // Support space separated class names `{composes: 'foo bar'}`
  if (className.indexOf(' ') > -1) {
    return registerClass(rule, className.split(' '));
  }

  var parent = rule.options.parent;

  // It is a ref to a local rule.

  if (className[0] === '$') {
    var refRule = parent.getRule(className.substr(1));

    if (!refRule) {
      (0, _warning2.default)(false, '[JSS] Referenced rule is not defined. \r\n%s', rule);
      return false;
    }

    if (refRule === rule) {
      (0, _warning2.default)(false, '[JSS] Cyclic composition detected. \r\n%s', rule);
      return false;
    }

    parent.classes[rule.key] += ' ' + parent.classes[refRule.key];

    return true;
  }

  rule.options.parent.classes[rule.key] += ' ' + className;

  return true;
}

/**
 * Convert compose property to additional class, remove property from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssCompose() {
  function onProcessStyle(style, rule) {
    if (!style.composes) return style;
    registerClass(rule, style.composes);
    // Remove composes property to prevent infinite loop.
    delete style.composes;
    return style;
  }
  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Generated jss-default-unit CSS property units
 *
 * @type object
 */
exports['default'] = {
  'animation-delay': 'ms',
  'animation-duration': 'ms',
  'background-position': 'px',
  'background-position-x': 'px',
  'background-position-y': 'px',
  'background-size': 'px',
  border: 'px',
  'border-bottom': 'px',
  'border-bottom-left-radius': 'px',
  'border-bottom-right-radius': 'px',
  'border-bottom-width': 'px',
  'border-left': 'px',
  'border-left-width': 'px',
  'border-radius': 'px',
  'border-right': 'px',
  'border-right-width': 'px',
  'border-spacing': 'px',
  'border-top': 'px',
  'border-top-left-radius': 'px',
  'border-top-right-radius': 'px',
  'border-top-width': 'px',
  'border-width': 'px',
  'border-after-width': 'px',
  'border-before-width': 'px',
  'border-end-width': 'px',
  'border-horizontal-spacing': 'px',
  'border-start-width': 'px',
  'border-vertical-spacing': 'px',
  bottom: 'px',
  'box-shadow': 'px',
  'column-gap': 'px',
  'column-rule': 'px',
  'column-rule-width': 'px',
  'column-width': 'px',
  'flex-basis': 'px',
  'font-size': 'px',
  'font-size-delta': 'px',
  height: 'px',
  left: 'px',
  'letter-spacing': 'px',
  'logical-height': 'px',
  'logical-width': 'px',
  margin: 'px',
  'margin-after': 'px',
  'margin-before': 'px',
  'margin-bottom': 'px',
  'margin-left': 'px',
  'margin-right': 'px',
  'margin-top': 'px',
  'max-height': 'px',
  'max-width': 'px',
  'margin-end': 'px',
  'margin-start': 'px',
  'mask-position-x': 'px',
  'mask-position-y': 'px',
  'mask-size': 'px',
  'max-logical-height': 'px',
  'max-logical-width': 'px',
  'min-height': 'px',
  'min-width': 'px',
  'min-logical-height': 'px',
  'min-logical-width': 'px',
  motion: 'px',
  'motion-offset': 'px',
  outline: 'px',
  'outline-offset': 'px',
  'outline-width': 'px',
  padding: 'px',
  'padding-bottom': 'px',
  'padding-left': 'px',
  'padding-right': 'px',
  'padding-top': 'px',
  'padding-after': 'px',
  'padding-before': 'px',
  'padding-end': 'px',
  'padding-start': 'px',
  'perspective-origin-x': '%',
  'perspective-origin-y': '%',
  perspective: 'px',
  right: 'px',
  'shape-margin': 'px',
  size: 'px',
  'text-indent': 'px',
  'text-stroke': 'px',
  'text-stroke-width': 'px',
  top: 'px',
  'transform-origin': '%',
  'transform-origin-x': '%',
  'transform-origin-y': '%',
  'transform-origin-z': '%',
  'transition-delay': 'ms',
  'transition-duration': 'ms',
  'vertical-align': 'px',
  width: 'px',
  'word-spacing': 'px',
  // Not existing properties.
  // Used to avoid issues with jss-expand intergration.
  'box-shadow-x': 'px',
  'box-shadow-y': 'px',
  'box-shadow-blur': 'px',
  'box-shadow-spread': 'px',
  'font-line-height': 'px',
  'text-shadow-x': 'px',
  'text-shadow-y': 'px',
  'text-shadow-blur': 'px'
};

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = defaultUnit;

var _defaultUnits = __webpack_require__(816);

var _defaultUnits2 = _interopRequireDefault(_defaultUnits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Clones the object and adds a camel cased property version.
 */
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;
  var replace = function replace(str) {
    return str[1].toUpperCase();
  };
  var newObj = {};
  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }
  return newObj;
}

var units = addCamelCasedVersion(_defaultUnits2['default']);

/**
 * Recursive deep style passing function
 *
 * @param {String} current property
 * @param {(Object|Array|Number|String)} property value
 * @param {Object} options
 * @return {(Object|Array|Number|String)} resulting value
 */
function iterate(prop, value, options) {
  if (!value) return value;

  var convertedValue = value;

  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  if (type === 'object' && Array.isArray(value)) type = 'array';

  switch (type) {
    case 'object':
      if (prop === 'fallbacks') {
        for (var innerProp in value) {
          value[innerProp] = iterate(innerProp, value[innerProp], options);
        }
        break;
      }
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + '-' + _innerProp, value[_innerProp], options);
      }
      break;
    case 'array':
      for (var i = 0; i < value.length; i++) {
        value[i] = iterate(prop, value[i], options);
      }
      break;
    case 'number':
      if (value !== 0) {
        convertedValue = value + (options[prop] || units[prop] || '');
      }
      break;
    default:
      break;
  }

  return convertedValue;
}

/**
 * Add unit to numeric values.
 */
function defaultUnit() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = jssExpand;

var _props = __webpack_require__(819);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Map values by given prop.
 *
 * @param {Array} array of values
 * @param {String} original property
 * @param {String} original rule
 * @return {String} mapped values
 */
function mapValuesByProp(value, prop, rule) {
  return value.map(function (item) {
    return objectToString(item, prop, rule);
  });
}

/**
 * Convert array to string.
 *
 * @param {Array} array of values
 * @param {String} original property
 * @param {Object} sheme, for converting arrays in strings
 * @param {Object} original rule
 * @return {String} converted string
 */
function arrayToString(value, prop, scheme, rule) {
  if (scheme[prop] == null) return value.join(',');
  if (value.length === 0) return '';
  if (Array.isArray(value[0])) return arrayToString(value[0], prop, scheme);
  if (_typeof(value[0]) === 'object') return mapValuesByProp(value, prop, rule);
  return value.join(' ');
}

/**
 * Convert object to string.
 *
 * @param {Object} object of values
 * @param {String} original property
 * @param {Object} original rule
 * @param {Boolean} is fallback prop
 * @return {String} converted string
 */
function objectToString(value, prop, rule, isFallback) {
  if (!(_props.propObj[prop] || _props.customPropObj[prop])) return '';

  var result = [];

  // Check if exists any non-standart property
  if (_props.customPropObj[prop]) {
    value = customPropsToStyle(value, rule, _props.customPropObj[prop], isFallback);
  }

  // Pass throught all standart props
  if (Object.keys(value).length) {
    for (var baseProp in _props.propObj[prop]) {
      if (value[baseProp]) {
        if (Array.isArray(value[baseProp])) {
          result.push(arrayToString(value[baseProp], baseProp, _props.propArrayInObj));
        } else result.push(value[baseProp]);
        continue;
      }

      // Add default value from props config.
      if (_props.propObj[prop][baseProp] != null) {
        result.push(_props.propObj[prop][baseProp]);
      }
    }
  }

  return result.join(' ');
}

/**
 * Convert custom properties values to styles adding them to rule directly
 *
 * @param {Object} object of values
 * @param {Object} original rule
 * @param {String} property, that contain partial custom properties
 * @param {Boolean} is fallback prop
 * @return {Object} value without custom properties, that was already added to rule
 */
function customPropsToStyle(value, rule, customProps, isFallback) {
  for (var prop in customProps) {
    var propName = customProps[prop];

    // If current property doesn't exist already in rule - add new one
    if (typeof value[prop] !== 'undefined' && (isFallback || !rule.prop(propName))) {
      var appendedValue = styleDetector(_defineProperty({}, propName, value[prop]), rule)[propName];

      // Add style directly in rule
      if (isFallback) rule.style.fallbacks[propName] = appendedValue;else rule.style[propName] = appendedValue;
    }
    // Delete converted property to avoid double converting
    delete value[prop];
  }

  return value;
}

/**
 * Detect if a style needs to be converted.
 *
 * @param {Object} style
 * @param {Object} rule
 * @param {Boolean} is fallback prop
 * @return {Object} convertedStyle
 */
function styleDetector(style, rule, isFallback) {
  for (var prop in style) {
    var value = style[prop];

    if (Array.isArray(value)) {
      // Check double arrays to avoid recursion.
      if (!Array.isArray(value[0])) {
        if (prop === 'fallbacks') {
          for (var index = 0; index < style.fallbacks.length; index++) {
            style.fallbacks[index] = styleDetector(style.fallbacks[index], rule, true);
          }
          continue;
        }

        style[prop] = arrayToString(value, prop, _props.propArray);
        // Avoid creating properties with empty values
        if (!style[prop]) delete style[prop];
      }
    } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      if (prop === 'fallbacks') {
        style.fallbacks = styleDetector(style.fallbacks, rule, true);
        continue;
      }

      style[prop] = objectToString(value, prop, rule, isFallback);
      // Avoid creating properties with empty values
      if (!style[prop]) delete style[prop];
    }

    // Maybe a computed value resulting in an empty string
    else if (style[prop] === '') delete style[prop];
  }

  return style;
}

/**
 * Adds possibility to write expanded styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssExpand() {
  function onProcessStyle(style, rule) {
    if (!style || rule.type !== 'style') return style;

    if (Array.isArray(style)) {
      // Pass rules one by one and reformat them
      for (var index = 0; index < style.length; index++) {
        style[index] = styleDetector(style[index], rule);
      }
      return style;
    }

    return styleDetector(style, rule);
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * A scheme for converting properties from array to regular style.
 * All properties listed below will be transformed to a string separated by space.
 */
var propArray = exports.propArray = {
  'background-size': true,
  'background-position': true,
  border: true,
  'border-bottom': true,
  'border-left': true,
  'border-top': true,
  'border-right': true,
  'border-radius': true,
  'box-shadow': true,
  flex: true,
  margin: true,
  padding: true,
  outline: true,
  'transform-origin': true,
  transform: true,
  transition: true
};

/**
 * A scheme for converting arrays to regular styles inside of objects.
 * For e.g.: "{position: [0, 0]}" => "background-position: 0 0;".
 */
var propArrayInObj = exports.propArrayInObj = {
  position: true, // background-position
  size: true // background-size
};

/**
 * A scheme for parsing and building correct styles from passed objects.
 */
var propObj = exports.propObj = {
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  margin: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  background: {
    attachment: null,
    color: null,
    image: null,
    position: null,
    repeat: null
  },
  border: {
    width: null,
    style: null,
    color: null
  },
  'border-top': {
    width: null,
    style: null,
    color: null
  },
  'border-right': {
    width: null,
    style: null,
    color: null
  },
  'border-bottom': {
    width: null,
    style: null,
    color: null
  },
  'border-left': {
    width: null,
    style: null,
    color: null
  },
  outline: {
    width: null,
    style: null,
    color: null
  },
  'list-style': {
    type: null,
    position: null,
    image: null
  },
  transition: {
    property: null,
    duration: null,
    'timing-function': null,
    timingFunction: null, // Needed for avoiding comilation issues with jss-camel-case
    delay: null
  },
  animation: {
    name: null,
    duration: null,
    'timing-function': null,
    timingFunction: null, // Needed to avoid compilation issues with jss-camel-case
    delay: null,
    'iteration-count': null,
    iterationCount: null, // Needed to avoid compilation issues with jss-camel-case
    direction: null,
    'fill-mode': null,
    fillMode: null, // Needed to avoid compilation issues with jss-camel-case
    'play-state': null,
    playState: null // Needed to avoid compilation issues with jss-camel-case
  },
  'box-shadow': {
    x: 0,
    y: 0,
    blur: 0,
    spread: 0,
    color: null,
    inset: null
  },
  'text-shadow': {
    x: 0,
    y: 0,
    blur: null,
    color: null
  }
};

/**
 * A scheme for converting non-standart properties inside object.
 * For e.g.: include 'border-radius' property inside 'border' object.
 */
var customPropObj = exports.customPropObj = {
  border: {
    radius: 'border-radius'
  },
  background: {
    size: 'background-size',
    image: 'background-image'
  },
  font: {
    style: 'font-style',
    variant: 'font-variant',
    weight: 'font-weight',
    stretch: 'font-stretch',
    size: 'font-size',
    family: 'font-family',
    lineHeight: 'line-height', // Needed to avoid compilation issues with jss-camel-case
    'line-height': 'line-height'
  },
  flex: {
    grow: 'flex-grow',
    basis: 'flex-basis',
    direction: 'flex-direction',
    wrap: 'flex-wrap',
    flow: 'flex-flow',
    shrink: 'flex-shrink'
  },
  align: {
    self: 'align-self',
    items: 'align-items',
    content: 'align-content'
  }
};

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = jssExtend;

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var isObject = function isObject(obj) {
  return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && !Array.isArray(obj);
};

/**
 * Recursively extend styles.
 */
function extend(style, rule, sheet) {
  var newStyle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (typeof style.extend === 'string') {
    if (sheet) {
      var refRule = sheet.getRule(style.extend);
      if (refRule) {
        if (refRule === rule) (0, _warning2['default'])(false, '[JSS] A rule tries to extend itself \r\n%s', rule);else if (refRule.options.parent) {
          var originalStyle = refRule.options.parent.rules.raw[style.extend];
          extend(originalStyle, rule, sheet, newStyle);
        }
      }
    }
  } else if (Array.isArray(style.extend)) {
    for (var index = 0; index < style.extend.length; index++) {
      extend(style.extend[index], rule, sheet, newStyle);
    }
  } else {
    for (var prop in style.extend) {
      if (prop === 'extend') {
        extend(style.extend.extend, rule, sheet, newStyle);
      } else if (isObject(style.extend[prop])) {
        if (!newStyle[prop]) newStyle[prop] = {};
        extend(style.extend[prop], rule, sheet, newStyle[prop]);
      } else {
        newStyle[prop] = style.extend[prop];
      }
    }
  }
  // Copy base style.
  for (var _prop in style) {
    if (_prop === 'extend') continue;
    if (isObject(newStyle[_prop]) && isObject(style[_prop])) {
      extend(style[_prop], rule, sheet, newStyle[_prop]);
    } else if (isObject(style[_prop])) {
      newStyle[_prop] = extend(style[_prop], rule, sheet);
    } else {
      newStyle[_prop] = style[_prop];
    }
  }

  return newStyle;
}

/**
 * Handle `extend` property.
 *
 * @param {Rule} rule
 * @api public
 */
function jssExtend() {
  function onProcessStyle(style, rule, sheet) {
    return style.extend ? extend(style, rule, sheet) : style;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports['default'] = jssGlobal;

var _jss = __webpack_require__(390);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var propKey = '@global';
var prefixKey = '@global ';

var GlobalContainerRule = function () {
  function GlobalContainerRule(key, styles, options) {
    _classCallCheck(this, GlobalContainerRule);

    this.type = 'global';

    this.key = key;
    this.options = options;
    this.rules = new _jss.RuleList(_extends({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector], { selector: selector });
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(GlobalContainerRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      return this.rules.toString();
    }
  }]);

  return GlobalContainerRule;
}();

var GlobalPrefixedRule = function () {
  function GlobalPrefixedRule(name, style, options) {
    _classCallCheck(this, GlobalPrefixedRule);

    this.name = name;
    this.options = options;
    var selector = name.substr(prefixKey.length);
    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
      parent: this,
      selector: selector
    }));
  }

  _createClass(GlobalPrefixedRule, [{
    key: 'toString',
    value: function toString(options) {
      return this.rule.toString(options);
    }
  }]);

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';
  for (var i = 0; i < parts.length; i++) {
    scoped += scope + ' ' + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }
  return scoped;
}

function handleNestedGlobalContainerRule(rule) {
  var options = rule.options,
      style = rule.style;

  var rules = style[propKey];

  if (!rules) return;

  for (var name in rules) {
    options.sheet.addRule(name, rules[name], _extends({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[propKey];
}

function handlePrefixedGlobalRule(rule) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop.substr(0, propKey.length) !== propKey) continue;

    var selector = addScope(prop.substr(propKey.length), rule.selector);
    options.sheet.addRule(selector, style[prop], _extends({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (name === propKey) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, prefixKey.length) === prefixKey) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;


    if (parent) {
      if (parent.type === 'global' || parent.options.parent.type === 'global') {
        options.global = true;
      }
    }

    if (options.global) options.selector = name;

    return null;
  }

  function onProcessRule(rule) {
    if (rule.type !== 'style') return;

    handleNestedGlobalContainerRule(rule);
    handlePrefixedGlobalRule(rule);
  }

  return { onCreateRule: onCreateRule, onProcessRule: onProcessRule };
}

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = jssNested;

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container) {
    return function (match, key) {
      var rule = container.getRule(key);
      if (rule) return rule.selector;
      (0, _warning2.default)(false, '[JSS] Could not find the referenced rule %s in %s.', key, container.options.meta || container);
      return key;
    };
  }

  var hasAnd = function hasAnd(str) {
    return str.indexOf('&') !== -1;
  };

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);

    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', ';
        // Replace all & by the parent or prefix & with the parent.
        result += hasAnd(nested) ? nested.replace(parentRegExp, parent) : parent + ' ' + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, options) {
    // Options has been already created, now we only increase index.
    if (options) return _extends({}, options, { index: options.index + 1 });

    var nestingLevel = rule.options.nestingLevel;

    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    return _extends({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1
    });
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    var container = rule.options.parent;
    var options = void 0;
    var replaceRef = void 0;
    for (var prop in style) {
      var isNested = hasAnd(prop);
      var isNestedConditional = prop[0] === '@';

      if (!isNested && !isNestedConditional) continue;

      options = getOptions(rule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, rule.selector
        // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.
        );if (!replaceRef) replaceRef = getReplaceRef(container
        // Replace all $refs.
        );selector = selector.replace(refRegExp, replaceRef);

        container.addRule(selector, style[prop], _extends({}, options, { selector: selector }));
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, _defineProperty({}, rule.key, style[prop]), options);
      }

      delete style[prop];
    }

    return style;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jssExtend = __webpack_require__(820);

var _jssExtend2 = _interopRequireDefault(_jssExtend);

var _jssNested = __webpack_require__(822);

var _jssNested2 = _interopRequireDefault(_jssNested);

var _jssCamelCase = __webpack_require__(814);

var _jssCamelCase2 = _interopRequireDefault(_jssCamelCase);

var _jssDefaultUnit = __webpack_require__(817);

var _jssDefaultUnit2 = _interopRequireDefault(_jssDefaultUnit);

var _jssVendorPrefixer = __webpack_require__(825);

var _jssVendorPrefixer2 = _interopRequireDefault(_jssVendorPrefixer);

var _jssPropsSort = __webpack_require__(824);

var _jssPropsSort2 = _interopRequireDefault(_jssPropsSort);

var _jssCompose = __webpack_require__(815);

var _jssCompose2 = _interopRequireDefault(_jssCompose);

var _jssExpand = __webpack_require__(818);

var _jssExpand2 = _interopRequireDefault(_jssExpand);

var _jssGlobal = __webpack_require__(821);

var _jssGlobal2 = _interopRequireDefault(_jssGlobal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    plugins: [(0, _jssGlobal2.default)(options.global), (0, _jssExtend2.default)(options.extend), (0, _jssNested2.default)(options.nested), (0, _jssCompose2.default)(options.compose), (0, _jssCamelCase2.default)(options.camelCase), (0, _jssDefaultUnit2.default)(options.defaultUnit), (0, _jssExpand2.default)(options.expand), (0, _jssVendorPrefixer2.default)(options.vendorPrefixer), (0, _jssPropsSort2.default)(options.propsSort)]
  };
};

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssPropsSort;
/**
 * Sort props by length.
 */
function jssPropsSort() {
  function sort(prop0, prop1) {
    return prop0.length - prop1.length;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    var newStyle = {};
    var props = Object.keys(style).sort(sort);
    for (var prop in props) {
      newStyle[props[prop]] = style[props[prop]];
    }
    return newStyle;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssVendorPrefixer;

var _cssVendor = __webpack_require__(566);

var vendor = _interopRequireWildcard(_cssVendor);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 * Add vendor prefix to a property name when needed.
 *
 * @param {Rule} rule
 * @api public
 */
function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      rule.key = '@' + vendor.prefix.css + rule.key.substr(1);
    }
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      var value = style[prop];

      var changeProp = false;
      var supportedProp = vendor.supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;

      var changeValue = false;
      var supportedValue = vendor.supportedValue(supportedProp, value);
      if (supportedValue && supportedValue !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue || value;
      }
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return vendor.supportedValue(prop, value);
  }

  return { onProcessRule: onProcessRule, onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PluginsRegistry = function () {
  function PluginsRegistry() {
    _classCallCheck(this, PluginsRegistry);

    this.hooks = {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: []

      /**
       * Call `onCreateRule` hooks and return an object if returned by a hook.
       */
    };
  }

  _createClass(PluginsRegistry, [{
    key: 'onCreateRule',
    value: function onCreateRule(name, decl, options) {
      for (var i = 0; i < this.hooks.onCreateRule.length; i++) {
        var rule = this.hooks.onCreateRule[i](name, decl, options);
        if (rule) return rule;
      }
      return null;
    }

    /**
     * Call `onProcessRule` hooks.
     */

  }, {
    key: 'onProcessRule',
    value: function onProcessRule(rule) {
      if (rule.isProcessed) return;
      var sheet = rule.options.sheet;

      for (var i = 0; i < this.hooks.onProcessRule.length; i++) {
        this.hooks.onProcessRule[i](rule, sheet);
      }

      // $FlowFixMe
      if (rule.style) this.onProcessStyle(rule.style, rule, sheet);

      rule.isProcessed = true;
    }

    /**
     * Call `onProcessStyle` hooks.
     */

  }, {
    key: 'onProcessStyle',
    value: function onProcessStyle(style, rule, sheet) {
      var nextStyle = style;

      for (var i = 0; i < this.hooks.onProcessStyle.length; i++) {
        nextStyle = this.hooks.onProcessStyle[i](nextStyle, rule, sheet);
        // $FlowFixMe
        rule.style = nextStyle;
      }
    }

    /**
     * Call `onProcessSheet` hooks.
     */

  }, {
    key: 'onProcessSheet',
    value: function onProcessSheet(sheet) {
      for (var i = 0; i < this.hooks.onProcessSheet.length; i++) {
        this.hooks.onProcessSheet[i](sheet);
      }
    }

    /**
     * Call `onChangeValue` hooks.
     */

  }, {
    key: 'onChangeValue',
    value: function onChangeValue(value, prop, rule) {
      var processedValue = value;
      for (var i = 0; i < this.hooks.onChangeValue.length; i++) {
        processedValue = this.hooks.onChangeValue[i](processedValue, prop, rule);
      }
      return processedValue;
    }

    /**
     * Register a plugin.
     * If function is passed, it is a shortcut for `{onProcessRule}`.
     */

  }, {
    key: 'use',
    value: function use(plugin) {
      for (var name in plugin) {
        if (this.hooks[name]) this.hooks[name].push(plugin[name]);else (0, _warning2['default'])(false, '[JSS] Unknown hook "%s".', name);
      }
    }
  }]);

  return PluginsRegistry;
}();

exports['default'] = PluginsRegistry;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleRule = __webpack_require__(394);

var _SimpleRule2 = _interopRequireDefault(_SimpleRule);

var _KeyframesRule = __webpack_require__(393);

var _KeyframesRule2 = _interopRequireDefault(_KeyframesRule);

var _ConditionalRule = __webpack_require__(391);

var _ConditionalRule2 = _interopRequireDefault(_ConditionalRule);

var _FontFaceRule = __webpack_require__(392);

var _FontFaceRule2 = _interopRequireDefault(_FontFaceRule);

var _ViewportRule = __webpack_require__(395);

var _ViewportRule2 = _interopRequireDefault(_ViewportRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var classes = {
  '@charset': _SimpleRule2['default'],
  '@import': _SimpleRule2['default'],
  '@namespace': _SimpleRule2['default'],
  '@keyframes': _KeyframesRule2['default'],
  '@media': _ConditionalRule2['default'],
  '@supports': _ConditionalRule2['default'],
  '@font-face': _FontFaceRule2['default'],
  '@viewport': _ViewportRule2['default'],
  '@-ms-viewport': _ViewportRule2['default']

  /**
   * Generate plugins which will register all rules.
   */
};
exports['default'] = Object.keys(classes).map(function (key) {
  // https://jsperf.com/indexof-vs-substr-vs-regex-at-the-beginning-3
  var re = new RegExp('^' + key);
  var onCreateRule = function onCreateRule(name, decl, options) {
    return re.test(name) ? new classes[key](name, decl, options) : null;
  };
  return { onCreateRule: onCreateRule };
});

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

var _sheets = __webpack_require__(228);

var _sheets2 = _interopRequireDefault(_sheets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Get a style property.
 */
function getStyle(rule, prop) {
  try {
    return rule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
}

/**
 * Set a style property.
 */
function setStyle(rule, prop, value) {
  try {
    rule.style.setProperty(prop, value);
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }
  return true;
}

function extractSelector(cssText) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  return cssText.substr(from, cssText.indexOf('{') - 1);
}

var CSSRuleTypes = {
  STYLE_RULE: 1,
  KEYFRAMES_RULE: 7

  /**
   * Get the selector.
   */
};function getSelector(rule) {
  if (rule.type === CSSRuleTypes.STYLE_RULE) return rule.selectorText;
  if (rule.type === CSSRuleTypes.KEYFRAMES_RULE) {
    var name = rule.name;

    if (name) return '@keyframes ' + name;

    // There is no rule.name in the following browsers:
    // - IE 9
    // - Safari 7.1.8
    // - Mobile Safari 9.0.0
    var cssText = rule.cssText;

    return '@' + extractSelector(cssText, cssText.indexOf('keyframes'));
  }

  return extractSelector(rule.cssText);
}

/**
 * Set the selector.
 */
function setSelector(rule, selectorText) {
  rule.selectorText = selectorText;

  // Return false if setter was not successful.
  // Currently works in chrome only.
  return rule.selectorText === selectorText;
}

/**
 * Gets the `head` element upon the first call and caches it.
 */
var getHead = function () {
  var head = void 0;
  return function () {
    if (!head) head = document.head || document.getElementsByTagName('head')[0];
    return head;
  };
}();

/**
 * Find attached sheet with an index higher than the passed one.
 */
function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find attached sheet with the highest index.
 */
function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find a comment with "jss" inside.
 */
function findCommentNode(text) {
  var head = getHead();
  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];
    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }
  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry = _sheets2['default'].registry;


  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);
    if (sheet) return sheet.renderer.element;

    // Otherwise insert after the last attached.
    sheet = findHighestSheet(registry, options);
    if (sheet) return sheet.renderer.element.nextElementSibling;
  }

  // Try to find a comment placeholder if registry is empty.
  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);
    if (comment) return comment.nextSibling;
    // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.
    (0, _warning2['default'])(insertionPoint === 'jss', '[JSS] Insertion point "%s" not found.', insertionPoint);
  }

  return null;
}

/**
 * Insert style element into the DOM.
 */
function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;

  var prevNode = findPrevNode(options);

  if (prevNode) {
    var parentNode = prevNode.parentNode;

    if (parentNode) parentNode.insertBefore(style, prevNode);
    return;
  }

  // Works with iframes and any node types.
  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var _parentNode = insertionPointElement.parentNode;

    if (_parentNode) _parentNode.insertBefore(style, insertionPointElement.nextSibling);else (0, _warning2['default'])(false, '[JSS] Insertion point is not in the DOM.');
    return;
  }

  getHead().insertBefore(style, prevNode);
}

var DomRenderer = function () {
  function DomRenderer(sheet) {
    _classCallCheck(this, DomRenderer);

    this.getStyle = getStyle;
    this.setStyle = setStyle;
    this.setSelector = setSelector;
    this.getSelector = getSelector;
    this.hasInsertedRules = false;

    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) _sheets2['default'].add(sheet);

    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || document.createElement('style');
    this.element.type = 'text/css';
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
  }

  /**
   * Insert style element into render tree.
   */


  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696


  _createClass(DomRenderer, [{
    key: 'attach',
    value: function attach() {
      // In the case the element node is external and it is already in the DOM.
      if (this.element.parentNode || !this.sheet) return;

      // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
      // browsers remove those rules.
      // TODO figure out if its a bug and if it is known.
      // Workaround is to redeploy the sheet before attaching as a string.
      if (this.hasInsertedRules) {
        this.deploy();
        this.hasInsertedRules = false;
      }

      insertStyle(this.element, this.sheet.options);
    }

    /**
     * Remove style element from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      this.element.parentNode.removeChild(this.element);
    }

    /**
     * Inject CSS string into element.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      if (!this.sheet) return;
      this.element.textContent = '\n' + this.sheet.toString() + '\n';
    }

    /**
     * Insert a rule into element.
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule) {
      var sheet = this.element.sheet;
      var cssRules = sheet.cssRules;

      var index = cssRules.length;
      var str = rule.toString();

      if (!str) return false;

      try {
        sheet.insertRule(str, index);
      } catch (err) {
        (0, _warning2['default'])(false, '[JSS] Can not insert an unsupported rule \n\r%s', rule);
        return false;
      }

      this.hasInsertedRules = true;

      return cssRules[index];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(rule) {
      var sheet = this.element.sheet;
      var cssRules = sheet.cssRules;

      for (var _index = 0; _index < cssRules.length; _index++) {
        if (rule === cssRules[_index]) {
          sheet.deleteRule(_index);
          return true;
        }
      }
      return false;
    }

    /**
     * Get all rules elements.
     */

  }, {
    key: 'getRules',
    value: function getRules() {
      return this.element.sheet.cssRules;
    }
  }]);

  return DomRenderer;
}();

exports['default'] = DomRenderer;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */

/**
 * Rendering backend to do nothing in nodejs.
 */
var VirtualRenderer = function () {
  function VirtualRenderer() {
    _classCallCheck(this, VirtualRenderer);
  }

  _createClass(VirtualRenderer, [{
    key: 'setStyle',
    value: function setStyle() {
      return true;
    }
  }, {
    key: 'getStyle',
    value: function getStyle() {
      return '';
    }
  }, {
    key: 'setSelector',
    value: function setSelector() {
      return true;
    }
  }, {
    key: 'getSelector',
    value: function getSelector() {
      return '';
    }
  }, {
    key: 'attach',
    value: function attach() {}
  }, {
    key: 'detach',
    value: function detach() {}
  }, {
    key: 'deploy',
    value: function deploy() {}
  }, {
    key: 'insertRule',
    value: function insertRule() {
      return false;
    }
  }, {
    key: 'deleteRule',
    value: function deleteRule() {
      return true;
    }
  }, {
    key: 'getRules',
    value: function getRules() {}
  }]);

  return VirtualRenderer;
}();

exports['default'] = VirtualRenderer;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = cloneStyle;
var isArray = Array.isArray;
function cloneStyle(style) {
  // Support empty values in case user ends up with them by accident.
  if (style == null) return style;

  // Support string value for SimpleRule.
  var typeOfStyle = typeof style === 'undefined' ? 'undefined' : _typeof(style);
  if (typeOfStyle === 'string' || typeOfStyle === 'number') return style;

  // Support array for FontFaceRule.
  if (isArray(style)) return style.map(cloneStyle);

  var newStyle = {};
  for (var name in style) {
    var value = style[name];
    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      newStyle[name] = cloneStyle(value);
      continue;
    }
    newStyle[name] = value;
  }

  return newStyle;
}

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = findRenderer;

var _isInBrowser = __webpack_require__(144);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _DomRenderer = __webpack_require__(828);

var _DomRenderer2 = _interopRequireDefault(_DomRenderer);

var _VirtualRenderer = __webpack_require__(829);

var _VirtualRenderer2 = _interopRequireDefault(_VirtualRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Find proper renderer.
 * Option `virtual` is used to force use of VirtualRenderer even if DOM is
 * detected, used for testing only.
 */
function findRenderer() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (options.Renderer) return options.Renderer;
  var useVirtual = options.virtual || !_isInBrowser2['default'];
  return useVirtual ? _VirtualRenderer2['default'] : _DomRenderer2['default'];
}

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Extracts a styles object with only props that contain function values.
 */
exports['default'] = function (styles) {
  // eslint-disable-next-line no-shadow
  function extract(styles) {
    var to = null;

    for (var key in styles) {
      var value = styles[key];
      var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

      if (type === 'function') {
        if (!to) to = {};
        to[key] = value;
      } else if (type === 'object' && value !== null && !Array.isArray(value)) {
        var extracted = extract(value);
        if (extracted) {
          if (!to) to = {};
          to[key] = extracted;
        }
      }
    }

    return to;
  }

  return extract(styles);
};

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports['default'] = function (rule, data, RuleList) {
  if (rule.type === 'style') {
    for (var prop in rule.style) {
      var value = rule.style[prop];
      if (typeof value === 'function') {
        rule.prop(prop, value(data));
      }
    }
  } else if (rule.rules instanceof RuleList) {
    rule.rules.update(data);
  }
};

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(402),
    getRawTag = __webpack_require__(836),
    objectToString = __webpack_require__(837);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(402);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 837 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(404),
    now = __webpack_require__(841),
    toNumber = __webpack_require__(842);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 839 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(834),
    isObjectLike = __webpack_require__(839);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(403);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(404),
    isSymbol = __webpack_require__(840);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _ref;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(11);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _colorManipulator = __webpack_require__(410);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_Element = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_Element || __webpack_require__(0).any;

var babelPluginFlowReactPropTypes_proptype_ElementType = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_ElementType || __webpack_require__(0).any;

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      width: 40,
      height: 40,
      fontFamily: theme.typography.fontFamily,
      fontSize: 20,
      borderRadius: '50%',
      overflow: 'hidden',
      userSelect: 'none'
    },
    colorDefault: {
      color: theme.palette.background.default,
      backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.background.default, 0.26)
    },
    img: {
      maxWidth: '100%',
      width: '100%',
      height: 'auto'
    }
  };
};

var babelPluginFlowReactPropTypes_proptype_Props = {
  alt: __webpack_require__(0).string,
  children: typeof babelPluginFlowReactPropTypes_proptype_Element === 'function' ? babelPluginFlowReactPropTypes_proptype_Element : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Element),
  childrenClassName: __webpack_require__(0).string,
  classes: __webpack_require__(0).object,
  className: __webpack_require__(0).string,
  component: typeof babelPluginFlowReactPropTypes_proptype_ElementType === 'function' ? babelPluginFlowReactPropTypes_proptype_ElementType : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_ElementType),
  imgProps: __webpack_require__(0).object,
  sizes: __webpack_require__(0).string,
  src: __webpack_require__(0).string,
  srcSet: __webpack_require__(0).string
};


function Avatar(props) {
  var alt = props.alt,
      classes = props.classes,
      classNameProp = props.className,
      childrenProp = props.children,
      childrenClassNameProp = props.childrenClassName,
      ComponentProp = props.component,
      imgProps = props.imgProps,
      sizes = props.sizes,
      src = props.src,
      srcSet = props.srcSet,
      other = (0, _objectWithoutProperties3.default)(props, ['alt', 'classes', 'className', 'children', 'childrenClassName', 'component', 'imgProps', 'sizes', 'src', 'srcSet']);


  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.colorDefault, childrenProp && !src && !srcSet), classNameProp);
  var children = null;

  if (childrenProp) {
    if (childrenClassNameProp && _react2.default.isValidElement(childrenProp)) {
      var _childrenClassName = (0, _classnames2.default)(childrenClassNameProp, childrenProp.props.className);
      children = _react2.default.cloneElement(childrenProp, { className: _childrenClassName });
    } else {
      children = childrenProp;
    }
  } else if (src || srcSet) {
    children = _react2.default.createElement('img', (0, _extends3.default)({
      alt: alt,
      src: src,
      srcSet: srcSet,
      sizes: sizes,
      className: classes.img
    }, imgProps));
  }

  return _react2.default.createElement(
    ComponentProp,
    (0, _extends3.default)({ className: className }, other),
    children
  );
}

Avatar.propTypes =  false ? (_ref = {
  classes: require('prop-types').object.isRequired,
  component: require('prop-types').string.isRequired,
  alt: require('prop-types').string,
  children: typeof babelPluginFlowReactPropTypes_proptype_Element === 'function' ? babelPluginFlowReactPropTypes_proptype_Element : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Element),
  childrenClassName: require('prop-types').string
}, (0, _defineProperty3.default)(_ref, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref, 'className', require('prop-types').string), (0, _defineProperty3.default)(_ref, 'component', typeof babelPluginFlowReactPropTypes_proptype_ElementType === 'function' ? babelPluginFlowReactPropTypes_proptype_ElementType : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_ElementType)), (0, _defineProperty3.default)(_ref, 'imgProps', require('prop-types').object), (0, _defineProperty3.default)(_ref, 'sizes', require('prop-types').string), (0, _defineProperty3.default)(_ref, 'src', require('prop-types').string), (0, _defineProperty3.default)(_ref, 'srcSet', require('prop-types').string), _ref) : {};
Avatar.defaultProps = {
  component: 'div'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiAvatar' })(Avatar);

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Avatar = __webpack_require__(843);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Avatar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(37);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(38);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(39);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(41);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(40);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(117);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _keycode = __webpack_require__(401);

var _keycode2 = _interopRequireDefault(_keycode);

var _withStyles = __webpack_require__(11);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _keyboardFocus = __webpack_require__(895);

var _TouchRipple = __webpack_require__(847);

var _TouchRipple2 = _interopRequireDefault(_TouchRipple);

var _createRippleHandler = __webpack_require__(848);

var _createRippleHandler2 = _interopRequireDefault(_createRippleHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_Node = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_Node || __webpack_require__(0).any; //  weak

var babelPluginFlowReactPropTypes_proptype_ElementType = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_ElementType || __webpack_require__(0).any;

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      // Remove grey highlight
      WebkitTapHighlightColor: theme.palette.common.transparent,
      backgroundColor: 'transparent', // Reset default value
      outline: 'none',
      border: 0,
      cursor: 'pointer',
      userSelect: 'none',
      appearance: 'none',
      textDecoration: 'none',
      // So we take precedent over the style of a native <a /> element.
      color: 'inherit'
    },
    disabled: {
      pointerEvents: 'none', // Disable link interactions
      cursor: 'default'
    }
  };
};

var babelPluginFlowReactPropTypes_proptype_Props = {
  centerRipple: __webpack_require__(0).bool,
  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Node),
  classes: __webpack_require__(0).object,
  className: __webpack_require__(0).string,
  component: typeof babelPluginFlowReactPropTypes_proptype_ElementType === 'function' ? babelPluginFlowReactPropTypes_proptype_ElementType : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_ElementType),
  disabled: __webpack_require__(0).bool,
  disableRipple: __webpack_require__(0).bool,
  focusRipple: __webpack_require__(0).bool,
  keyboardFocusedClassName: __webpack_require__(0).string,
  onBlur: __webpack_require__(0).func,
  onClick: __webpack_require__(0).func,
  onFocus: __webpack_require__(0).func,
  onKeyboardFocus: __webpack_require__(0).func,
  onKeyDown: __webpack_require__(0).func,
  onKeyUp: __webpack_require__(0).func,
  onMouseDown: __webpack_require__(0).func,
  onMouseLeave: __webpack_require__(0).func,
  onMouseUp: __webpack_require__(0).func,
  onTouchEnd: __webpack_require__(0).func,
  onTouchStart: __webpack_require__(0).func,
  role: __webpack_require__(0).string,
  rootRef: __webpack_require__(0).func,
  tabIndex: __webpack_require__(0).oneOfType([__webpack_require__(0).number, __webpack_require__(0).string]),
  type: __webpack_require__(0).string.isRequired
};

var ButtonBase = function (_React$Component) {
  (0, _inherits3.default)(ButtonBase, _React$Component);

  function ButtonBase() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ButtonBase);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ButtonBase.__proto__ || (0, _getPrototypeOf2.default)(ButtonBase)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      keyboardFocused: false
    }, _this.ripple = null, _this.keyDown = false, _this.button = null, _this.keyboardFocusTimeout = null, _this.keyboardFocusCheckTime = 40, _this.keyboardFocusMaxCheckTimes = 5, _this.handleKeyDown = function (event) {
      var _this$props = _this.props,
          component = _this$props.component,
          focusRipple = _this$props.focusRipple,
          onKeyDown = _this$props.onKeyDown,
          onClick = _this$props.onClick;

      var key = (0, _keycode2.default)(event);

      // Check if key is already down to avoid repeats being counted as multiple activations
      if (focusRipple && !_this.keyDown && _this.state.keyboardFocused && key === 'space') {
        _this.keyDown = true;
        event.persist();
        _this.ripple.stop(event, function () {
          _this.ripple.start(event);
        });
      }

      if (onKeyDown) {
        onKeyDown(event);
      }

      // Keyboard accessibility for non interactive elements
      if (event.target === _this.button && onClick && component && component !== 'a' && component !== 'button' && (key === 'space' || key === 'enter')) {
        event.preventDefault();
        onClick(event);
      }
    }, _this.handleKeyUp = function (event) {
      if (_this.props.focusRipple && (0, _keycode2.default)(event) === 'space' && _this.state.keyboardFocused) {
        _this.keyDown = false;
        event.persist();
        _this.ripple.stop(event, function () {
          return _this.ripple.pulsate(event);
        });
      }
      if (_this.props.onKeyUp) {
        _this.props.onKeyUp(event);
      }
    }, _this.handleMouseDown = (0, _createRippleHandler2.default)(_this, 'MouseDown', 'start', function () {
      clearTimeout(_this.keyboardFocusTimeout);
      (0, _keyboardFocus.focusKeyPressed)(false);
      if (_this.state.keyboardFocused) {
        _this.setState({ keyboardFocused: false });
      }
    }), _this.handleMouseUp = (0, _createRippleHandler2.default)(_this, 'MouseUp', 'stop'), _this.handleMouseLeave = (0, _createRippleHandler2.default)(_this, 'MouseLeave', 'stop', function (event) {
      if (_this.state.keyboardFocused) {
        event.preventDefault();
      }
    }), _this.handleTouchStart = (0, _createRippleHandler2.default)(_this, 'TouchStart', 'start'), _this.handleTouchEnd = (0, _createRippleHandler2.default)(_this, 'TouchEnd', 'stop'), _this.handleBlur = (0, _createRippleHandler2.default)(_this, 'Blur', 'stop', function () {
      _this.setState({ keyboardFocused: false });
    }), _this.handleFocus = function (event) {
      if (_this.props.disabled) {
        return;
      }

      if (_this.button) {
        event.persist();

        var keyboardFocusCallback = _this.onKeyboardFocusHandler.bind(_this, event);
        (0, _keyboardFocus.detectKeyboardFocus)(_this, _this.button, keyboardFocusCallback);
      }

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _this.onKeyboardFocusHandler = function (event) {
      _this.keyDown = false;
      _this.setState({ keyboardFocused: true });

      if (_this.props.onKeyboardFocus) {
        _this.props.onKeyboardFocus(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ButtonBase, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.button = (0, _reactDom.findDOMNode)(this);
      (0, _keyboardFocus.listenForFocusKeys)();
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      if (this.props.focusRipple && nextState.keyboardFocused && !this.state.keyboardFocused && !this.props.disableRipple) {
        this.ripple.pulsate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.button = null;
      clearTimeout(this.keyboardFocusTimeout);
    } // Used to help track keyboard activation keyDown

  }, {
    key: 'renderRipple',
    value: function renderRipple() {
      var _this2 = this;

      if (!this.props.disableRipple && !this.props.disabled) {
        return _react2.default.createElement(_TouchRipple2.default, {
          innerRef: function innerRef(node) {
            _this2.ripple = node;
          },
          center: this.props.centerRipple
        });
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          centerRipple = _props.centerRipple,
          children = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          component = _props.component,
          disabled = _props.disabled,
          disableRipple = _props.disableRipple,
          focusRipple = _props.focusRipple,
          keyboardFocusedClassName = _props.keyboardFocusedClassName,
          onBlur = _props.onBlur,
          onFocus = _props.onFocus,
          onKeyboardFocus = _props.onKeyboardFocus,
          onKeyDown = _props.onKeyDown,
          onKeyUp = _props.onKeyUp,
          onMouseDown = _props.onMouseDown,
          onMouseLeave = _props.onMouseLeave,
          onMouseUp = _props.onMouseUp,
          onTouchEnd = _props.onTouchEnd,
          onTouchStart = _props.onTouchStart,
          rootRef = _props.rootRef,
          tabIndex = _props.tabIndex,
          type = _props.type,
          other = (0, _objectWithoutProperties3.default)(_props, ['centerRipple', 'children', 'classes', 'className', 'component', 'disabled', 'disableRipple', 'focusRipple', 'keyboardFocusedClassName', 'onBlur', 'onFocus', 'onKeyboardFocus', 'onKeyDown', 'onKeyUp', 'onMouseDown', 'onMouseLeave', 'onMouseUp', 'onTouchEnd', 'onTouchStart', 'rootRef', 'tabIndex', 'type']);


      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, keyboardFocusedClassName, keyboardFocusedClassName && this.state.keyboardFocused), _classNames), classNameProp);

      var buttonProps = {};

      var ComponentProp = component;

      if (!ComponentProp) {
        if (other.href) {
          ComponentProp = 'a';
        } else {
          ComponentProp = 'button';
        }
      }

      if (ComponentProp === 'button') {
        buttonProps.type = type || 'button';
      }

      if (ComponentProp !== 'a') {
        buttonProps.role = buttonProps.role || 'button';
        buttonProps.disabled = disabled;
      }

      return _react2.default.createElement(
        ComponentProp,
        (0, _extends3.default)({
          onBlur: this.handleBlur,
          onFocus: this.handleFocus,
          onKeyDown: this.handleKeyDown,
          onKeyUp: this.handleKeyUp,
          onMouseDown: this.handleMouseDown,
          onMouseLeave: this.handleMouseLeave,
          onMouseUp: this.handleMouseUp,
          onTouchEnd: this.handleTouchEnd,
          onTouchStart: this.handleTouchStart,
          ref: rootRef,
          tabIndex: disabled ? -1 : tabIndex,
          className: className
        }, buttonProps, other),
        children,
        this.renderRipple()
      );
    }
  }]);
  return ButtonBase;
}(_react2.default.Component);

ButtonBase.defaultProps = {
  centerRipple: false,
  focusRipple: false,
  disableRipple: false,
  tabIndex: 0,
  type: 'button'
};
exports.default = (0, _withStyles2.default)(styles, { name: 'MuiButtonBase' })(ButtonBase);

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(37);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(38);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(39);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(41);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(40);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _Transition = __webpack_require__(980);

var _Transition2 = _interopRequireDefault(_Transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_Props = {
  classes: __webpack_require__(0).object.isRequired,
  className: __webpack_require__(0).string,
  pulsate: __webpack_require__(0).bool,
  rippleSize: __webpack_require__(0).number.isRequired,
  rippleX: __webpack_require__(0).number.isRequired,
  rippleY: __webpack_require__(0).number.isRequired
}; //  weak

/**
 * @ignore - internal component.
 */
var Ripple = function (_React$Component) {
  (0, _inherits3.default)(Ripple, _React$Component);

  function Ripple() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Ripple);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Ripple.__proto__ || (0, _getPrototypeOf2.default)(Ripple)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      rippleVisible: false,
      rippleLeaving: false
    }, _this.handleEnter = function () {
      _this.setState({
        rippleVisible: true
      });
    }, _this.handleExit = function () {
      _this.setState({
        rippleLeaving: true
      });
    }, _this.getRippleStyles = function (props) {
      var rippleSize = props.rippleSize,
          rippleX = props.rippleX,
          rippleY = props.rippleY;


      return {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
      };
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Ripple, [{
    key: 'render',
    value: function render() {
      var _classNames, _classNames2;

      var _props = this.props,
          classes = _props.classes,
          classNameProp = _props.className,
          pulsate = _props.pulsate,
          rippleX = _props.rippleX,
          rippleY = _props.rippleY,
          rippleSize = _props.rippleSize,
          other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'className', 'pulsate', 'rippleX', 'rippleY', 'rippleSize']);
      var _state = this.state,
          rippleVisible = _state.rippleVisible,
          rippleLeaving = _state.rippleLeaving;


      var className = (0, _classnames2.default)(classes.wrapper, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.wrapperLeaving, rippleLeaving), (0, _defineProperty3.default)(_classNames, classes.wrapperPulsating, pulsate), _classNames), classNameProp);

      var rippleClassName = (0, _classnames2.default)(classes.ripple, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.rippleVisible, rippleVisible), (0, _defineProperty3.default)(_classNames2, classes.rippleFast, pulsate), _classNames2));

      return _react2.default.createElement(
        _Transition2.default,
        (0, _extends3.default)({ onEnter: this.handleEnter, onExit: this.handleExit }, other),
        _react2.default.createElement(
          'span',
          { className: className },
          _react2.default.createElement('span', { className: rippleClassName, style: this.getRippleStyles(this.props) })
        )
      );
    }
  }]);
  return Ripple;
}(_react2.default.Component);

Ripple.defaultProps = {
  pulsate: false
};
Ripple.propTypes =  false ? {
  classes: require('prop-types').object.isRequired,
  className: require('prop-types').string,
  pulsate: require('prop-types').bool,
  rippleSize: require('prop-types').number.isRequired,
  rippleX: require('prop-types').number.isRequired,
  rippleY: require('prop-types').number.isRequired
} : {};
exports.default = Ripple;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toConsumableArray2 = __webpack_require__(470);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(37);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(38);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(39);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(41);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(40);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(117);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _TransitionGroup = __webpack_require__(981);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(11);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Ripple = __webpack_require__(846);

var _Ripple2 = _interopRequireDefault(_Ripple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  weak

var DURATION = 550;

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'block',
      position: 'absolute',
      overflow: 'hidden',
      borderRadius: 'inherit',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      pointerEvents: 'none',
      zIndex: 0
    },
    wrapper: {
      opacity: 1
    },
    wrapperLeaving: {
      opacity: 0,
      animation: 'mui-ripple-exit ' + DURATION + 'ms ' + theme.transitions.easing.easeInOut
    },
    wrapperPulsating: {
      position: 'absolute',
      left: 0,
      top: 0,
      display: 'block',
      width: '100%',
      height: '100%',
      animation: 'mui-ripple-pulsate 1500ms ' + theme.transitions.easing.easeInOut + ' 200ms infinite',
      rippleVisible: {
        opacity: 0.2
      }
    },
    '@keyframes mui-ripple-enter': {
      '0%': {
        transform: 'scale(0)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    },
    '@keyframes mui-ripple-exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes mui-ripple-pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.9)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    },
    ripple: {
      width: 50,
      height: 50,
      left: 0,
      top: 0,
      opacity: 0,
      position: 'absolute',
      borderRadius: '50%',
      background: 'currentColor'
    },
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: 'mui-ripple-enter ' + DURATION + 'ms ' + theme.transitions.easing.easeInOut
    },
    rippleFast: {
      animationDuration: '200ms'
    }
  };
};

var babelPluginFlowReactPropTypes_proptype_Props = {
  center: __webpack_require__(0).bool,
  classes: __webpack_require__(0).object,
  className: __webpack_require__(0).string
};

/**
 * @ignore - internal component.
 */
var TouchRipple = function (_React$Component) {
  (0, _inherits3.default)(TouchRipple, _React$Component);

  function TouchRipple() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TouchRipple);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TouchRipple.__proto__ || (0, _getPrototypeOf2.default)(TouchRipple)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      nextKey: 0,
      ripples: []
    }, _this.ignoringMouseDown = false, _this.pulsate = function () {
      _this.start({}, { pulsate: true });
    }, _this.start = function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments[2];
      var _options$pulsate = options.pulsate,
          pulsate = _options$pulsate === undefined ? false : _options$pulsate,
          _options$center = options.center,
          center = _options$center === undefined ? _this.props.center || options.pulsate : _options$center;


      if (event.type === 'mousedown' && _this.ignoringMouseDown) {
        _this.ignoringMouseDown = false;
        return;
      }

      if (event.type === 'touchstart') {
        _this.ignoringMouseDown = true;
      }

      var ripples = _this.state.ripples;

      var element = _reactDom2.default.findDOMNode(_this);
      var rect = element ? // $FlowFixMe
      element.getBoundingClientRect() : {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      };

      // Get the size of the ripple
      var rippleX = void 0;
      var rippleY = void 0;
      var rippleSize = void 0;

      if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
        rippleX = Math.round(rect.width / 2);
        rippleY = Math.round(rect.height / 2);
      } else {
        var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
        var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
        rippleX = Math.round(clientX - rect.left);
        rippleY = Math.round(clientY - rect.top);
      }

      if (center) {
        rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3);

        // For some reason the animation is broken on Mobile Chrome if the size if even.
        if (rippleSize % 2 === 0) {
          rippleSize += 1;
        }
      } else {
        var sizeX = Math.max(
        // $FlowFixMe
        Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
        var sizeY = Math.max(
        // $FlowFixMe
        Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
        rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
      }

      // Add a ripple to the ripples array
      ripples = [].concat((0, _toConsumableArray3.default)(ripples), [_react2.default.createElement(_Ripple2.default, {
        key: _this.state.nextKey,
        classes: _this.props.classes,
        timeout: {
          exit: DURATION,
          enter: DURATION
        },
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
      })]);

      _this.setState({
        nextKey: _this.state.nextKey + 1,
        ripples: ripples
      }, cb);
    }, _this.stop = function (event, cb) {
      var ripples = _this.state.ripples;

      if (ripples && ripples.length) {
        _this.setState({
          ripples: ripples.slice(1)
        }, cb);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  // Used to filter out mouse emulated events on mobile.


  (0, _createClass3.default)(TouchRipple, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          center = _props.center,
          classes = _props.classes,
          className = _props.className,
          other = (0, _objectWithoutProperties3.default)(_props, ['center', 'classes', 'className']);


      return _react2.default.createElement(
        _TransitionGroup2.default,
        (0, _extends3.default)({
          component: 'span',
          enter: true,
          exit: true,
          className: (0, _classnames2.default)(classes.root, className)
        }, other),
        this.state.ripples
      );
    }
  }]);
  return TouchRipple;
}(_react2.default.Component);

TouchRipple.defaultProps = {
  center: false
};
exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTouchRipple' })(TouchRipple);

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function createRippleHandler(instance, eventName, action, cb) {
  return function handleEvent(event) {
    if (cb) {
      cb.call(instance, event);
    }

    if (event.defaultPrevented) {
      return false;
    }

    if (instance.ripple) {
      instance.ripple[action](event);
    }

    if (instance.props && typeof instance.props['on' + eventName] === 'function') {
      instance.props['on' + eventName](event);
    }

    return true;
  };
}

exports.default = createRippleHandler;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Paper = __webpack_require__(409);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent Paper

var babelPluginFlowReactPropTypes_proptype_Props = {
  className: __webpack_require__(0).string,
  raised: __webpack_require__(0).bool
};


function Card(props) {
  var raised = props.raised,
      other = (0, _objectWithoutProperties3.default)(props, ['raised']);


  return _react2.default.createElement(_Paper2.default, (0, _extends3.default)({ elevation: raised ? 8 : 2 }, other));
}

Card.propTypes =  false ? (0, _defineProperty3.default)({
  raised: require('prop-types').bool.isRequired,
  className: require('prop-types').string
}, 'raised', require('prop-types').bool) : {};
Card.defaultProps = {
  raised: false
};

exports.default = Card;

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _ref;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(11);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _reactHelpers = __webpack_require__(233);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_ChildrenArray = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_ChildrenArray || __webpack_require__(0).any;

var styles = exports.styles = {
  root: {
    height: 52,
    display: 'flex',
    alignItems: 'center',
    padding: '2px 4px'
  },
  actionSpacing: {
    margin: '0 4px'
  }
};

var babelPluginFlowReactPropTypes_proptype_Props = {
  children: typeof babelPluginFlowReactPropTypes_proptype_ChildrenArray === 'function' ? babelPluginFlowReactPropTypes_proptype_ChildrenArray : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_ChildrenArray),
  classes: __webpack_require__(0).object,
  className: __webpack_require__(0).string,
  disableActionSpacing: __webpack_require__(0).bool
};


function CardActions(props) {
  var disableActionSpacing = props.disableActionSpacing,
      children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['disableActionSpacing', 'children', 'classes', 'className']);


  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
    disableActionSpacing ? children : (0, _reactHelpers.cloneChildrenWithClassName)(children, classes.actionSpacing)
  );
}

CardActions.propTypes =  false ? (_ref = {
  classes: require('prop-types').object.isRequired,
  disableActionSpacing: require('prop-types').bool.isRequired,
  children: typeof babelPluginFlowReactPropTypes_proptype_ChildrenArray === 'function' ? babelPluginFlowReactPropTypes_proptype_ChildrenArray : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_ChildrenArray)
}, (0, _defineProperty3.default)(_ref, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref, 'className', require('prop-types').string), (0, _defineProperty3.default)(_ref, 'disableActionSpacing', require('prop-types').bool), _ref) : {};
CardActions.defaultProps = {
  disableActionSpacing: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCardActions' })(CardActions);

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _ref;
// @inheritedComponent CardContent

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(11);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Typography = __webpack_require__(232);

var _Typography2 = _interopRequireDefault(_Typography);

var _CardContent = __webpack_require__(406);

var _CardContent2 = _interopRequireDefault(_CardContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_Node = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_Node || __webpack_require__(0).any;

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      alignItems: 'center'
    },
    avatar: {
      flex: '0 0 auto',
      marginRight: theme.spacing.unit * 2
    },
    content: {
      flex: '1 1 auto'
    },
    title: {},
    subheader: {}
  };
};

var babelPluginFlowReactPropTypes_proptype_Props = {
  avatar: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Node),
  classes: __webpack_require__(0).object,
  className: __webpack_require__(0).string,
  subheader: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Node),
  title: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Node)
};


function CardHeader(props) {
  var avatar = props.avatar,
      classes = props.classes,
      classNameProp = props.className,
      subheader = props.subheader,
      title = props.title,
      other = (0, _objectWithoutProperties3.default)(props, ['avatar', 'classes', 'className', 'subheader', 'title']);


  var className = (0, _classnames2.default)(classes.root, classNameProp);

  // Adjustments that depend on the presence of an avatar
  var titleType = avatar ? 'body2' : 'headline';
  var subheaderType = avatar ? 'body2' : 'body1';

  return _react2.default.createElement(
    _CardContent2.default,
    (0, _extends3.default)({ className: className }, other),
    avatar && _react2.default.createElement(
      'div',
      { className: classes.avatar },
      avatar
    ),
    _react2.default.createElement(
      'div',
      { className: classes.content },
      _react2.default.createElement(
        _Typography2.default,
        { type: titleType, component: 'span', className: classes.title },
        title
      ),
      _react2.default.createElement(
        _Typography2.default,
        {
          type: subheaderType,
          component: 'span',
          color: 'secondary',
          className: classes.subheader
        },
        subheader
      )
    )
  );
}

CardHeader.propTypes =  false ? (_ref = {
  classes: require('prop-types').object.isRequired,
  avatar: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Node)
}, (0, _defineProperty3.default)(_ref, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref, 'className', require('prop-types').string), (0, _defineProperty3.default)(_ref, 'subheader', typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Node)), (0, _defineProperty3.default)(_ref, 'title', typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Node)), _ref) : {};
exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCardHeader' })(CardHeader);

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _ref;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(11);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = {
  root: {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  }
};

var babelPluginFlowReactPropTypes_proptype_Props = {
  classes: __webpack_require__(0).object,
  className: __webpack_require__(0).string,
  image: __webpack_require__(0).string.isRequired,
  style: __webpack_require__(0).object
};


function CardMedia(props) {
  var classes = props.classes,
      className = props.className,
      image = props.image,
      style = props.style,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'image', 'style']);

  var composedStyle = (0, _extends3.default)({ backgroundImage: 'url(' + image + ')' }, style);

  return _react2.default.createElement('div', (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className), style: composedStyle }, other));
}

CardMedia.propTypes =  false ? (_ref = {
  classes: require('prop-types').object.isRequired
}, (0, _defineProperty3.default)(_ref, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref, 'className', require('prop-types').string), (0, _defineProperty3.default)(_ref, 'image', require('prop-types').string.isRequired), (0, _defineProperty3.default)(_ref, 'style', require('prop-types').object), _ref) : {};
exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCardMedia' })(CardMedia);

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Card = __webpack_require__(849);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Card).default;
  }
});

var _CardContent = __webpack_require__(406);

Object.defineProperty(exports, 'CardContent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CardContent).default;
  }
});

var _CardActions = __webpack_require__(850);

Object.defineProperty(exports, 'CardActions', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CardActions).default;
  }
});

var _CardMedia = __webpack_require__(852);

Object.defineProperty(exports, 'CardMedia', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CardMedia).default;
  }
});

var _CardHeader = __webpack_require__(851);

Object.defineProperty(exports, 'CardHeader', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CardHeader).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _withStyles = __webpack_require__(11);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _SwitchBase = __webpack_require__(880);

var _SwitchBase2 = _interopRequireDefault(_SwitchBase);

var _IndeterminateCheckBox = __webpack_require__(893);

var _IndeterminateCheckBox2 = _interopRequireDefault(_IndeterminateCheckBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_Node = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_Node || __webpack_require__(0).any;

var styles = exports.styles = function styles(theme) {
  return {
    default: {
      color: theme.palette.text.secondary
    },
    checked: {
      color: theme.palette.primary[500]
    },
    disabled: {
      color: theme.palette.action.disabled
    }
  };
};

var SwitchBase = (0, _SwitchBase2.default)();

var babelPluginFlowReactPropTypes_proptype_Props = {
  checked: __webpack_require__(0).oneOfType([__webpack_require__(0).bool, __webpack_require__(0).string]),
  checkedClassName: __webpack_require__(0).string,
  checkedIcon: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Node),
  classes: __webpack_require__(0).object,
  className: __webpack_require__(0).string,
  defaultChecked: __webpack_require__(0).bool,
  disabled: __webpack_require__(0).bool,
  disabledClassName: __webpack_require__(0).string,
  disableRipple: __webpack_require__(0).bool,
  icon: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Node),
  indeterminate: __webpack_require__(0).bool,
  indeterminateIcon: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Node),
  inputProps: __webpack_require__(0).object,
  inputRef: __webpack_require__(0).func,
  name: __webpack_require__(0).string,
  onChange: __webpack_require__(0).func,
  tabIndex: __webpack_require__(0).oneOfType([__webpack_require__(0).number, __webpack_require__(0).string]),
  value: __webpack_require__(0).string
};


function Checkbox(props) {
  var checkedIcon = props.checkedIcon,
      icon = props.icon,
      indeterminate = props.indeterminate,
      indeterminateIcon = props.indeterminateIcon,
      other = (0, _objectWithoutProperties3.default)(props, ['checkedIcon', 'icon', 'indeterminate', 'indeterminateIcon']);


  return _react2.default.createElement(SwitchBase, (0, _extends3.default)({
    checkedIcon: indeterminate ? indeterminateIcon : checkedIcon,
    icon: indeterminate ? indeterminateIcon : icon
  }, other));
}

Checkbox.propTypes =  false ? babelPluginFlowReactPropTypes_proptype_Props : {};
Checkbox.defaultProps = {
  indeterminate: false,
  indeterminateIcon: _react2.default.createElement(_IndeterminateCheckBox2.default, null)
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCheckbox' })(Checkbox);

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Checkbox = __webpack_require__(854);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Checkbox).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _ref;
// A grid component using the following libs as inspiration.
//
// For the implementation:
// - http://v4-alpha.getbootstrap.com/layout/flexbox-grid/
// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
// - https://github.com/roylee0704/react-flexbox-grid
// - https://material.angularjs.org/latest/layout/introduction
//
// Follow this flexbox Guide to better understand the underlying model:
// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(11);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _createBreakpoints = __webpack_require__(59);

var _requirePropFactory = __webpack_require__(896);

var _requirePropFactory2 = _interopRequireDefault(_requirePropFactory);

var _Hidden = __webpack_require__(860);

var _Hidden2 = _interopRequireDefault(_Hidden);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_Node = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_Node || __webpack_require__(0).any;

var babelPluginFlowReactPropTypes_proptype_ElementType = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_ElementType || __webpack_require__(0).any;

var babelPluginFlowReactPropTypes_proptype_HiddenProps = __webpack_require__(230).babelPluginFlowReactPropTypes_proptype_HiddenProps || __webpack_require__(0).any;

var GUTTERS = [0, 8, 16, 24, 40];
var GRID_SIZES = [true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

function generateGrid(globalStyles, theme, breakpoint) {
  // For the auto layouting
  var styles = (0, _defineProperty3.default)({}, 'grid-' + breakpoint, {
    flexBasis: 0,
    flexGrow: 1,
    maxWidth: '100%'
  });

  GRID_SIZES.forEach(function (size) {
    if (typeof size === 'boolean') {
      // Skip the first one as handle above.
      return;
    }

    // Only keep 6 significant numbers.
    var width = Math.round(size / 12 * Math.pow(10, 6)) / Math.pow(10, 4) + '%';

    /* eslint-disable max-len */
    // Close to the bootstrap implementation:
    // https://github.com/twbs/bootstrap/blob/b0508a975d711d6b24c01f57dd5445c22699fac4/scss/mixins/_grid.scss#L69
    /* eslint-enable max-len */
    styles['grid-' + breakpoint + '-' + size] = {
      flexBasis: width,
      maxWidth: width
    };
  });

  // No need for a media query for the first size.
  if (breakpoint === 'xs') {
    (0, _extends3.default)(globalStyles, styles);
  } else {
    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
  }
}

function generateGutter(theme, breakpoint) {
  var styles = {};

  GUTTERS.forEach(function (spacing, index) {
    if (index === 0) {
      // Skip the default style.
      return;
    }

    styles['spacing-' + breakpoint + '-' + spacing] = {
      margin: -spacing / 2,
      width: 'calc(100% + ' + spacing + 'px)',
      '& > $typeItem': {
        padding: spacing / 2
      }
    };
  });

  return styles;
}

// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
var styles = exports.styles = function styles(theme) {
  return (0, _extends3.default)({
    typeContainer: {
      boxSizing: 'border-box',
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%'
    },
    typeItem: {
      boxSizing: 'border-box',
      flex: '0 0 auto',
      margin: '0' // For instance, it's useful when used with a `figure` element.
    },
    'direction-xs-column': {
      flexDirection: 'column'
    },
    'direction-xs-column-reverse': {
      flexDirection: 'column-reverse'
    },
    'direction-xs-row-reverse': {
      flexDirection: 'row-reverse'
    },
    'wrap-xs-nowrap': {
      flexWrap: 'nowrap'
    },
    'align-xs-center': {
      alignItems: 'center'
    },
    'align-xs-flex-start': {
      alignItems: 'flex-start'
    },
    'align-xs-flex-end': {
      alignItems: 'flex-end'
    },
    'align-xs-baseline': {
      alignItems: 'baseline'
    },
    'justify-xs-center': {
      justifyContent: 'center'
    },
    'justify-xs-flex-end': {
      justifyContent: 'flex-end'
    },
    'justify-xs-space-between': {
      justifyContent: 'space-between'
    },
    'justify-xs-space-around': {
      justifyContent: 'space-around'
    }
  }, generateGutter(theme, 'xs'), _createBreakpoints.keys.reduce(function (accumulator, key) {
    // Use side effect over immutability for better performance.
    generateGrid(accumulator, theme, key);
    return accumulator;
  }, {}));
};

var babelPluginFlowReactPropTypes_proptype_Props = {
  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Node),
  classes: __webpack_require__(0).object,
  className: __webpack_require__(0).string,
  component: typeof babelPluginFlowReactPropTypes_proptype_ElementType === 'function' ? babelPluginFlowReactPropTypes_proptype_ElementType : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_ElementType),
  container: __webpack_require__(0).bool,
  item: __webpack_require__(0).bool,
  align: __webpack_require__(0).oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),
  direction: __webpack_require__(0).oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
  spacing: __webpack_require__(0).oneOf([0, 8, 16, 24, 40]),
  hidden: typeof babelPluginFlowReactPropTypes_proptype_HiddenProps === 'function' ? babelPluginFlowReactPropTypes_proptype_HiddenProps : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_HiddenProps),
  justify: __webpack_require__(0).oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around']),
  wrap: __webpack_require__(0).oneOf(['nowrap', 'wrap', 'wrap-reverse']),
  xs: __webpack_require__(0).oneOfType([__webpack_require__(0).bool, __webpack_require__(0).oneOf([1]), __webpack_require__(0).oneOf([2]), __webpack_require__(0).oneOf([3]), __webpack_require__(0).oneOf([4]), __webpack_require__(0).oneOf([5]), __webpack_require__(0).oneOf([6]), __webpack_require__(0).oneOf([7]), __webpack_require__(0).oneOf([8]), __webpack_require__(0).oneOf([9]), __webpack_require__(0).oneOf([10]), __webpack_require__(0).oneOf([11]), __webpack_require__(0).oneOf([12])]),
  sm: __webpack_require__(0).oneOfType([__webpack_require__(0).bool, __webpack_require__(0).oneOf([1]), __webpack_require__(0).oneOf([2]), __webpack_require__(0).oneOf([3]), __webpack_require__(0).oneOf([4]), __webpack_require__(0).oneOf([5]), __webpack_require__(0).oneOf([6]), __webpack_require__(0).oneOf([7]), __webpack_require__(0).oneOf([8]), __webpack_require__(0).oneOf([9]), __webpack_require__(0).oneOf([10]), __webpack_require__(0).oneOf([11]), __webpack_require__(0).oneOf([12])]),
  md: __webpack_require__(0).oneOfType([__webpack_require__(0).bool, __webpack_require__(0).oneOf([1]), __webpack_require__(0).oneOf([2]), __webpack_require__(0).oneOf([3]), __webpack_require__(0).oneOf([4]), __webpack_require__(0).oneOf([5]), __webpack_require__(0).oneOf([6]), __webpack_require__(0).oneOf([7]), __webpack_require__(0).oneOf([8]), __webpack_require__(0).oneOf([9]), __webpack_require__(0).oneOf([10]), __webpack_require__(0).oneOf([11]), __webpack_require__(0).oneOf([12])]),
  lg: __webpack_require__(0).oneOfType([__webpack_require__(0).bool, __webpack_require__(0).oneOf([1]), __webpack_require__(0).oneOf([2]), __webpack_require__(0).oneOf([3]), __webpack_require__(0).oneOf([4]), __webpack_require__(0).oneOf([5]), __webpack_require__(0).oneOf([6]), __webpack_require__(0).oneOf([7]), __webpack_require__(0).oneOf([8]), __webpack_require__(0).oneOf([9]), __webpack_require__(0).oneOf([10]), __webpack_require__(0).oneOf([11]), __webpack_require__(0).oneOf([12])]),
  xl: __webpack_require__(0).oneOfType([__webpack_require__(0).bool, __webpack_require__(0).oneOf([1]), __webpack_require__(0).oneOf([2]), __webpack_require__(0).oneOf([3]), __webpack_require__(0).oneOf([4]), __webpack_require__(0).oneOf([5]), __webpack_require__(0).oneOf([6]), __webpack_require__(0).oneOf([7]), __webpack_require__(0).oneOf([8]), __webpack_require__(0).oneOf([9]), __webpack_require__(0).oneOf([10]), __webpack_require__(0).oneOf([11]), __webpack_require__(0).oneOf([12])])
};


function Grid(props) {
  var _classNames;

  var classes = props.classes,
      classNameProp = props.className,
      ComponentProp = props.component,
      container = props.container,
      item = props.item,
      align = props.align,
      direction = props.direction,
      spacing = props.spacing,
      hidden = props.hidden,
      justify = props.justify,
      wrap = props.wrap,
      xs = props.xs,
      sm = props.sm,
      md = props.md,
      lg = props.lg,
      xl = props.xl,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'component', 'container', 'item', 'align', 'direction', 'spacing', 'hidden', 'justify', 'wrap', 'xs', 'sm', 'md', 'lg', 'xl']);


  var className = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.typeContainer, container), (0, _defineProperty3.default)(_classNames, classes.typeItem, item), (0, _defineProperty3.default)(_classNames, classes['spacing-xs-' + String(spacing)], container && spacing !== 0), (0, _defineProperty3.default)(_classNames, classes['direction-xs-' + String(direction)], direction !== Grid.defaultProps.direction), (0, _defineProperty3.default)(_classNames, classes['wrap-xs-' + String(wrap)], wrap !== Grid.defaultProps.wrap), (0, _defineProperty3.default)(_classNames, classes['align-xs-' + String(align)], align !== Grid.defaultProps.align), (0, _defineProperty3.default)(_classNames, classes['justify-xs-' + String(justify)], justify !== Grid.defaultProps.justify), (0, _defineProperty3.default)(_classNames, classes['grid-xs'], xs === true), (0, _defineProperty3.default)(_classNames, classes['grid-xs-' + String(xs)], xs && xs !== true), (0, _defineProperty3.default)(_classNames, classes['grid-sm'], sm === true), (0, _defineProperty3.default)(_classNames, classes['grid-sm-' + String(sm)], sm && sm !== true), (0, _defineProperty3.default)(_classNames, classes['grid-md'], md === true), (0, _defineProperty3.default)(_classNames, classes['grid-md-' + String(md)], md && md !== true), (0, _defineProperty3.default)(_classNames, classes['grid-lg'], lg === true), (0, _defineProperty3.default)(_classNames, classes['grid-lg-' + String(lg)], lg && lg !== true), (0, _defineProperty3.default)(_classNames, classes['grid-xl'], xl === true), (0, _defineProperty3.default)(_classNames, classes['grid-xl-' + String(xl)], xl && xl !== true), _classNames), classNameProp);
  var gridProps = (0, _extends3.default)({ className: className }, other);

  if (hidden) {
    return _react2.default.createElement(
      _Hidden2.default,
      hidden,
      _react2.default.createElement(ComponentProp, gridProps)
    );
  }

  return _react2.default.createElement(ComponentProp, gridProps);
}

Grid.propTypes =  false ? (_ref = {
  classes: require('prop-types').object.isRequired,
  component: typeof babelPluginFlowReactPropTypes_proptype_ElementType === 'function' ? babelPluginFlowReactPropTypes_proptype_ElementType.isRequired ? babelPluginFlowReactPropTypes_proptype_ElementType.isRequired : babelPluginFlowReactPropTypes_proptype_ElementType : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_ElementType).isRequired,
  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Node)
}, (0, _defineProperty3.default)(_ref, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref, 'className', require('prop-types').string), (0, _defineProperty3.default)(_ref, 'component', typeof babelPluginFlowReactPropTypes_proptype_ElementType === 'function' ? babelPluginFlowReactPropTypes_proptype_ElementType : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_ElementType)), (0, _defineProperty3.default)(_ref, 'container', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'item', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'align', require('prop-types').oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline'])), (0, _defineProperty3.default)(_ref, 'direction', require('prop-types').oneOf(['row', 'row-reverse', 'column', 'column-reverse'])), (0, _defineProperty3.default)(_ref, 'spacing', require('prop-types').oneOf([0, 8, 16, 24, 40])), (0, _defineProperty3.default)(_ref, 'hidden', typeof babelPluginFlowReactPropTypes_proptype_HiddenProps === 'function' ? babelPluginFlowReactPropTypes_proptype_HiddenProps : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_HiddenProps)), (0, _defineProperty3.default)(_ref, 'justify', require('prop-types').oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around'])), (0, _defineProperty3.default)(_ref, 'wrap', require('prop-types').oneOf(['nowrap', 'wrap', 'wrap-reverse'])), (0, _defineProperty3.default)(_ref, 'xs', require('prop-types').oneOfType([require('prop-types').bool, require('prop-types').oneOf([1]), require('prop-types').oneOf([2]), require('prop-types').oneOf([3]), require('prop-types').oneOf([4]), require('prop-types').oneOf([5]), require('prop-types').oneOf([6]), require('prop-types').oneOf([7]), require('prop-types').oneOf([8]), require('prop-types').oneOf([9]), require('prop-types').oneOf([10]), require('prop-types').oneOf([11]), require('prop-types').oneOf([12])])), (0, _defineProperty3.default)(_ref, 'sm', require('prop-types').oneOfType([require('prop-types').bool, require('prop-types').oneOf([1]), require('prop-types').oneOf([2]), require('prop-types').oneOf([3]), require('prop-types').oneOf([4]), require('prop-types').oneOf([5]), require('prop-types').oneOf([6]), require('prop-types').oneOf([7]), require('prop-types').oneOf([8]), require('prop-types').oneOf([9]), require('prop-types').oneOf([10]), require('prop-types').oneOf([11]), require('prop-types').oneOf([12])])), (0, _defineProperty3.default)(_ref, 'md', require('prop-types').oneOfType([require('prop-types').bool, require('prop-types').oneOf([1]), require('prop-types').oneOf([2]), require('prop-types').oneOf([3]), require('prop-types').oneOf([4]), require('prop-types').oneOf([5]), require('prop-types').oneOf([6]), require('prop-types').oneOf([7]), require('prop-types').oneOf([8]), require('prop-types').oneOf([9]), require('prop-types').oneOf([10]), require('prop-types').oneOf([11]), require('prop-types').oneOf([12])])), (0, _defineProperty3.default)(_ref, 'lg', require('prop-types').oneOfType([require('prop-types').bool, require('prop-types').oneOf([1]), require('prop-types').oneOf([2]), require('prop-types').oneOf([3]), require('prop-types').oneOf([4]), require('prop-types').oneOf([5]), require('prop-types').oneOf([6]), require('prop-types').oneOf([7]), require('prop-types').oneOf([8]), require('prop-types').oneOf([9]), require('prop-types').oneOf([10]), require('prop-types').oneOf([11]), require('prop-types').oneOf([12])])), (0, _defineProperty3.default)(_ref, 'xl', require('prop-types').oneOfType([require('prop-types').bool, require('prop-types').oneOf([1]), require('prop-types').oneOf([2]), require('prop-types').oneOf([3]), require('prop-types').oneOf([4]), require('prop-types').oneOf([5]), require('prop-types').oneOf([6]), require('prop-types').oneOf([7]), require('prop-types').oneOf([8]), require('prop-types').oneOf([9]), require('prop-types').oneOf([10]), require('prop-types').oneOf([11]), require('prop-types').oneOf([12])])), _ref) : {};
Grid.defaultProps = {
  align: 'stretch',
  component: 'div',
  container: false,
  direction: 'row',
  hidden: undefined,
  item: false,
  justify: 'flex-start',
  spacing: 16,
  wrap: 'wrap'
};

// Add a wrapper component to generate some helper messages in the development
// environment.
var GridWrapper = Grid; // eslint-disable-line import/no-mutable-exports

if (false) {
  var requireProp = (0, _requirePropFactory2.default)('Grid');

  GridWrapper = function GridWrapper(props) {
    return _react2.default.createElement(Grid, props);
  };

  GridWrapper.propTypes = {
    align: requireProp('container'),
    direction: requireProp('container'),
    justify: requireProp('container'),
    lg: requireProp('item'),
    md: requireProp('item'),
    sm: requireProp('item'),
    spacing: requireProp('container'),
    wrap: requireProp('container'),
    xs: requireProp('item')
  };
}

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiGrid' })(GridWrapper);

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Grid = __webpack_require__(856);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Grid).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _HiddenJs = __webpack_require__(407);

var _HiddenJs2 = _interopRequireDefault(_HiddenJs);

var _HiddenCss = __webpack_require__(859);

var _HiddenCss2 = _interopRequireDefault(_HiddenCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_Node = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_Node || __webpack_require__(0).any;

var babelPluginFlowReactPropTypes_proptype_Breakpoint = __webpack_require__(59).babelPluginFlowReactPropTypes_proptype_Breakpoint || __webpack_require__(0).any;

var babelPluginFlowReactPropTypes_proptype_Props = {
  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Node),
  className: __webpack_require__(0).string,
  only: __webpack_require__(0).oneOfType([typeof babelPluginFlowReactPropTypes_proptype_Breakpoint === 'function' ? babelPluginFlowReactPropTypes_proptype_Breakpoint : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Breakpoint), __webpack_require__(0).arrayOf(typeof babelPluginFlowReactPropTypes_proptype_Breakpoint === 'function' ? babelPluginFlowReactPropTypes_proptype_Breakpoint : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Breakpoint))]),
  xsUp: __webpack_require__(0).bool,
  smUp: __webpack_require__(0).bool,
  mdUp: __webpack_require__(0).bool,
  lgUp: __webpack_require__(0).bool,
  xlUp: __webpack_require__(0).bool,
  xsDown: __webpack_require__(0).bool,
  smDown: __webpack_require__(0).bool,
  mdDown: __webpack_require__(0).bool,
  lgDown: __webpack_require__(0).bool,
  xlDown: __webpack_require__(0).bool,
  implementation: __webpack_require__(0).oneOf(['js', 'css'])
};


/**
 * Responsively hides children based on the selected implementation.
 */
function Hidden(props) {
  var implementation = props.implementation,
      other = (0, _objectWithoutProperties3.default)(props, ['implementation']);


  if (implementation === 'js') {
    return _react2.default.createElement(_HiddenJs2.default, other);
  }

  return _react2.default.createElement(_HiddenCss2.default, other);
}

Hidden.propTypes =  false ? babelPluginFlowReactPropTypes_proptype_Props : {};
Hidden.defaultProps = {
  implementation: 'js',
  xsUp: false,
  smUp: false,
  mdUp: false,
  lgUp: false,
  xlUp: false,
  xsDown: false,
  smDown: false,
  mdDown: false,
  lgDown: false,
  xlDown: false
};

exports.default = Hidden;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(53);

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

var _createBreakpoints = __webpack_require__(59);

var _helpers = __webpack_require__(116);

var _withStyles = __webpack_require__(11);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_HiddenProps = __webpack_require__(230).babelPluginFlowReactPropTypes_proptype_HiddenProps || __webpack_require__(0).any; /* eslint-disable flowtype/require-valid-file-annotation */

var babelPluginFlowReactPropTypes_proptype_Props = (0, _extends3.default)({}, babelPluginFlowReactPropTypes_proptype_HiddenProps === __webpack_require__(0).any ? {} : babelPluginFlowReactPropTypes_proptype_HiddenProps, {
  classes: __webpack_require__(0).object
});


function generateStyles(theme) {
  var hidden = {
    display: 'none'
  };

  return _createBreakpoints.keys.reduce(function (styles, key) {
    styles['only' + (0, _helpers.capitalizeFirstLetter)(key)] = (0, _defineProperty3.default)({}, theme.breakpoints.only(key), hidden);
    styles[key + 'Up'] = (0, _defineProperty3.default)({}, theme.breakpoints.up(key), hidden);
    styles[key + 'Down'] = (0, _defineProperty3.default)({}, theme.breakpoints.down(key), hidden);

    return styles;
  }, {});
}

var styles = function styles(theme) {
  return generateStyles(theme);
};

/**
 * @ignore - internal component.
 */
function HiddenCss(props) {
  var children = props.children,
      classes = props.classes,
      only = props.only,
      xsUp = props.xsUp,
      smUp = props.smUp,
      mdUp = props.mdUp,
      lgUp = props.lgUp,
      xlUp = props.xlUp,
      xsDown = props.xsDown,
      smDown = props.smDown,
      mdDown = props.mdDown,
      lgDown = props.lgDown,
      xlDown = props.xlDown,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'only', 'xsUp', 'smUp', 'mdUp', 'lgUp', 'xlUp', 'xsDown', 'smDown', 'mdDown', 'lgDown', 'xlDown']);


   false ? (0, _warning2.default)((0, _keys2.default)(other).length === 0 || (0, _keys2.default)(other).length === 1 && other.hasOwnProperty('ref'), 'Material-UI: unsupported properties received ' + (0, _keys2.default)(other).join(', ') + ' by `<Hidden />`.') : void 0;

  var className = [];

  for (var i = 0; i < _createBreakpoints.keys.length; i += 1) {
    var breakpoint = _createBreakpoints.keys[i];
    var breakpointUp = props[breakpoint + 'Up'];
    var breakpointDown = props[breakpoint + 'Down'];

    if (breakpointUp) {
      className.push(classes[breakpoint + 'Up']);
    }
    if (breakpointDown) {
      className.push(classes[breakpoint + 'Down']);
    }
  }

  if (only) {
    className.push(classes['only' + (0, _helpers.capitalizeFirstLetter)(only)]);
  }

  return _react2.default.createElement(
    'span',
    { className: className },
    children
  );
}

HiddenCss.propTypes =  false ? (0, _extends3.default)({}, {
  classes: require('prop-types').object.isRequired
}, (0, _extends3.default)({}, babelPluginFlowReactPropTypes_proptype_HiddenProps === require('prop-types').any ? {} : babelPluginFlowReactPropTypes_proptype_HiddenProps, {
  classes: require('prop-types').object
})) : {};
exports.default = (0, _withStyles2.default)(styles, { name: 'MuiHiddenCss' })(HiddenCss);

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Hidden = __webpack_require__(858);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Hidden).default;
  }
});

var _HiddenJs = __webpack_require__(407);

Object.defineProperty(exports, 'HiddenJs', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_HiddenJs).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _ref;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(11);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(116);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_Node = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_Node || __webpack_require__(0).any;

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      userSelect: 'none'
    },
    colorAccent: {
      color: theme.palette.secondary.A200
    },
    colorAction: {
      color: theme.palette.action.active
    },
    colorContrast: {
      color: theme.palette.getContrastText(theme.palette.primary[500])
    },
    colorDisabled: {
      color: theme.palette.action.disabled
    },
    colorError: {
      color: theme.palette.error[500]
    },
    colorPrimary: {
      color: theme.palette.primary[500]
    }
  };
};

var babelPluginFlowReactPropTypes_proptype_Props = {
  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Node),
  classes: __webpack_require__(0).object,
  className: __webpack_require__(0).string,
  color: __webpack_require__(0).oneOf(['inherit', 'accent', 'action', 'contrast', 'disabled', 'error', 'primary'])
};


function Icon(props) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color']);


  var className = (0, _classnames2.default)('material-icons', classes.root, (0, _defineProperty3.default)({}, classes['color' + (0, _helpers.capitalizeFirstLetter)(color)], color !== 'inherit'), classNameProp);

  return _react2.default.createElement(
    'span',
    (0, _extends3.default)({ className: className, 'aria-hidden': 'true' }, other),
    children
  );
}

Icon.propTypes =  false ? (_ref = {
  classes: require('prop-types').object.isRequired,
  color: require('prop-types').oneOf(['inherit']).isRequired,
  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Node)
}, (0, _defineProperty3.default)(_ref, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref, 'className', require('prop-types').string), (0, _defineProperty3.default)(_ref, 'color', require('prop-types').oneOf(['inherit', 'accent', 'action', 'contrast', 'disabled', 'error', 'primary'])), _ref) : {};
Icon.defaultProps = {
  color: 'inherit'
};

Icon.muiName = 'Icon';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiIcon' })(Icon);

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(11);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ButtonBase = __webpack_require__(405);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

var _helpers = __webpack_require__(116);

var _Icon = __webpack_require__(408);

var _Icon2 = _interopRequireDefault(_Icon);

var _reactHelpers = __webpack_require__(233);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  weak
// @inheritedComponent ButtonBase

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: 24,
      width: theme.spacing.unit * 6,
      height: theme.spacing.unit * 6,
      padding: 0,
      borderRadius: '50%',
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      })
    },
    colorAccent: {
      color: theme.palette.secondary.A200
    },
    colorContrast: {
      color: theme.palette.getContrastText(theme.palette.primary[500])
    },
    colorPrimary: {
      color: theme.palette.primary[500]
    },
    colorInherit: {
      color: 'inherit'
    },
    disabled: {
      color: theme.palette.action.disabled
    },
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },
    icon: {
      width: '1em',
      height: '1em'
    },
    keyboardFocused: {
      backgroundColor: theme.palette.text.divider
    }
  };
};

/**
 * Refer to the [Icons](/style/icons) section of the documentation
 * regarding the available icon options.
 */
function IconButton(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      disabled = props.disabled,
      rootRef = props.rootRef,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color', 'disabled', 'rootRef']);


  return _react2.default.createElement(
    _ButtonBase2.default,
    (0, _extends3.default)({
      className: (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['color' + (0, _helpers.capitalizeFirstLetter)(color)], color !== 'default'), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), _classNames), className),
      centerRipple: true,
      keyboardFocusedClassName: classes.keyboardFocused,
      disabled: disabled,
      ref: rootRef
    }, other),
    _react2.default.createElement(
      'span',
      { className: classes.label },
      typeof children === 'string' ? _react2.default.createElement(
        _Icon2.default,
        { className: classes.icon },
        children
      ) : _react2.default.Children.map(children, function (child) {
        if ((0, _reactHelpers.isMuiElement)(child, ['Icon'])) {
          return _react2.default.cloneElement(child, {
            className: (0, _classnames2.default)(classes.icon, child.props.className)
          });
        }

        return child;
      })
    )
  );
}

IconButton.propTypes =  false ? {
  /**
   * The icon element.
   * If a string is provided, it will be used as an icon font ligature.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It's using the theme palette when that makes sense.
   */
  color: _propTypes2.default.oneOf(['default', 'inherit', 'primary', 'contrast', 'accent']),
  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the ripple will be disabled.
   */
  disableRipple: _propTypes2.default.bool,
  /**
   * Use that property to pass a ref callback to the root component.
   */
  rootRef: _propTypes2.default.func
} : {};

IconButton.defaultProps = {
  color: 'default',
  disabled: false,
  disableRipple: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiIconButton' })(IconButton);

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IconButton = __webpack_require__(862);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_IconButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(37);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(38);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(39);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(41);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(40);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(11);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_Node = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_Node || __webpack_require__(0).any;

var babelPluginFlowReactPropTypes_proptype_ElementType = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_ElementType || __webpack_require__(0).any;

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      flex: '1 1 auto',
      listStyle: 'none',
      margin: 0,
      padding: 0,
      position: 'relative'
    },
    padding: {
      paddingTop: theme.spacing.unit,
      paddingBottom: theme.spacing.unit
    },
    dense: {
      paddingTop: theme.spacing.unit / 2,
      paddingBottom: theme.spacing.unit / 2
    },
    subheader: {
      paddingTop: 0
    }
  };
};

var babelPluginFlowReactPropTypes_proptype_Props = {
  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Node),
  classes: __webpack_require__(0).object,
  className: __webpack_require__(0).string,
  component: typeof babelPluginFlowReactPropTypes_proptype_ElementType === 'function' ? babelPluginFlowReactPropTypes_proptype_ElementType : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_ElementType),
  dense: __webpack_require__(0).bool,
  disablePadding: __webpack_require__(0).bool,
  rootRef: __webpack_require__(0).func,
  subheader: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Node)
};

var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List() {
    (0, _classCallCheck3.default)(this, List);
    return (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).apply(this, arguments));
  }

  (0, _createClass3.default)(List, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        dense: this.props.dense
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          classes = _props.classes,
          classNameProp = _props.className,
          ComponentProp = _props.component,
          disablePadding = _props.disablePadding,
          children = _props.children,
          dense = _props.dense,
          subheader = _props.subheader,
          rootRef = _props.rootRef,
          other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'className', 'component', 'disablePadding', 'children', 'dense', 'subheader', 'rootRef']);

      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.dense, dense && !disablePadding), (0, _defineProperty3.default)(_classNames, classes.padding, !disablePadding), (0, _defineProperty3.default)(_classNames, classes.subheader, subheader), _classNames), classNameProp);

      return _react2.default.createElement(
        ComponentProp,
        (0, _extends3.default)({ ref: rootRef, className: className }, other),
        subheader,
        children
      );
    }
  }]);
  return List;
}(_react2.default.Component);

List.defaultProps = {
  component: 'ul',
  dense: false,
  disablePadding: false
};


List.childContextTypes = {
  dense: _propTypes2.default.bool
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiList' })(List);

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(37);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(38);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(39);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(41);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(40);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(11);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ButtonBase = __webpack_require__(405);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

var _reactHelpers = __webpack_require__(233);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_Node = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_Node || __webpack_require__(0).any;

var babelPluginFlowReactPropTypes_proptype_ElementType = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_ElementType || __webpack_require__(0).any;

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'initial',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none'
    },
    container: {
      position: 'relative'
    },
    keyboardFocused: {
      background: theme.palette.text.divider
    },
    default: {
      paddingTop: 12,
      paddingBottom: 12
    },
    dense: {
      paddingTop: theme.spacing.unit,
      paddingBottom: theme.spacing.unit
    },
    disabled: {
      opacity: 0.5
    },
    divider: {
      borderBottom: '1px solid ' + theme.palette.text.lightDivider
    },
    gutters: {
      paddingLeft: theme.spacing.unit * 2,
      paddingRight: theme.spacing.unit * 2
    },
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.text.divider,
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      }
    },
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positionned.
      paddingRight: theme.spacing.unit * 4
    }
  };
};

var babelPluginFlowReactPropTypes_proptype_Props = {
  button: __webpack_require__(0).bool,
  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Node),
  classes: __webpack_require__(0).object,
  className: __webpack_require__(0).string,
  component: typeof babelPluginFlowReactPropTypes_proptype_ElementType === 'function' ? babelPluginFlowReactPropTypes_proptype_ElementType : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_ElementType),
  dense: __webpack_require__(0).bool,
  disabled: __webpack_require__(0).bool,
  disableGutters: __webpack_require__(0).bool,
  divider: __webpack_require__(0).bool
};

var ListItem = function (_React$Component) {
  (0, _inherits3.default)(ListItem, _React$Component);

  function ListItem() {
    (0, _classCallCheck3.default)(this, ListItem);
    return (0, _possibleConstructorReturn3.default)(this, (ListItem.__proto__ || (0, _getPrototypeOf2.default)(ListItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(ListItem, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        dense: this.props.dense || this.context.dense || false
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          button = _props.button,
          childrenProp = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          componentProp = _props.component,
          dense = _props.dense,
          disabled = _props.disabled,
          divider = _props.divider,
          disableGutters = _props.disableGutters,
          other = (0, _objectWithoutProperties3.default)(_props, ['button', 'children', 'classes', 'className', 'component', 'dense', 'disabled', 'divider', 'disableGutters']);

      var isDense = dense || this.context.dense || false;
      var children = _react2.default.Children.toArray(childrenProp);

      var hasAvatar = children.some(function (value) {
        return (0, _reactHelpers.isMuiElement)(value, ['ListItemAvatar']);
      });
      var hasSecondaryAction = children.length && (0, _reactHelpers.isMuiElement)(children[children.length - 1], ['ListItemSecondaryAction']);

      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.gutters, !disableGutters), (0, _defineProperty3.default)(_classNames, classes.divider, divider), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.button, button), (0, _defineProperty3.default)(_classNames, classes.secondaryAction, hasSecondaryAction), (0, _defineProperty3.default)(_classNames, isDense || hasAvatar ? classes.dense : classes.default, true), _classNames), classNameProp);

      var listItemProps = (0, _extends3.default)({ className: className, disabled: disabled }, other);
      var ComponentMain = componentProp;

      if (button) {
        ComponentMain = _ButtonBase2.default;
        listItemProps.component = componentProp || 'li';
        listItemProps.keyboardFocusedClassName = classes.keyboardFocused;
      }

      if (hasSecondaryAction) {
        return _react2.default.createElement(
          'div',
          { className: classes.container },
          _react2.default.createElement(
            ComponentMain,
            listItemProps,
            children
          ),
          children.pop()
        );
      }

      return _react2.default.createElement(
        ComponentMain,
        listItemProps,
        children
      );
    }
  }]);
  return ListItem;
}(_react2.default.Component);

ListItem.defaultProps = {
  button: false,
  component: 'li',
  dense: false,
  disabled: false,
  disableGutters: false,
  divider: false
};


ListItem.contextTypes = {
  dense: _propTypes2.default.bool
};

ListItem.childContextTypes = {
  dense: _propTypes2.default.bool
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItem' })(ListItem);

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

var _withStyles = __webpack_require__(11);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_Element = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_Element || __webpack_require__(0).any;

var styles = exports.styles = {
  root: {
    width: 36,
    height: 36,
    fontSize: 18,
    marginRight: 4
  },
  icon: {
    width: 20,
    height: 20
  }
};

var babelPluginFlowReactPropTypes_proptype_Props = {
  children: typeof babelPluginFlowReactPropTypes_proptype_Element === 'function' ? babelPluginFlowReactPropTypes_proptype_Element.isRequired ? babelPluginFlowReactPropTypes_proptype_Element.isRequired : babelPluginFlowReactPropTypes_proptype_Element : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Element).isRequired,
  classes: __webpack_require__(0).object,
  className: __webpack_require__(0).string
};


/**
 * It's a simple wrapper to apply the `dense` mode styles to `Avatar`.
 */
function ListItemAvatar(props, context) {
  if (context.dense === undefined) {
     false ? (0, _warning2.default)(false, 'Material-UI: <ListItemAvatar> is a simple wrapper to apply the dense styles\n      to <Avatar>. You do not need it unless you are controlling the <List> dense property.') : void 0;
    return props.children;
  }

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);


  return _react2.default.cloneElement(children, (0, _extends3.default)({
    className: (0, _classnames2.default)((0, _defineProperty3.default)({}, classes.root, context.dense), classNameProp, children.props.className),
    childrenClassName: (0, _classnames2.default)((0, _defineProperty3.default)({}, classes.icon, context.dense), children.props.childrenClassName)
  }, other));
}

ListItemAvatar.contextTypes = {
  dense: _propTypes2.default.bool
};

ListItemAvatar.muiName = 'ListItemAvatar';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItemAvatar' })(ListItemAvatar);

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(11);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_Element = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_Element || __webpack_require__(0).any;

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      height: 24,
      marginRight: theme.spacing.unit * 2,
      width: 24,
      color: theme.palette.action.active,
      flexShrink: 0
    }
  };
};

var babelPluginFlowReactPropTypes_proptype_Props = {
  children: typeof babelPluginFlowReactPropTypes_proptype_Element === 'function' ? babelPluginFlowReactPropTypes_proptype_Element.isRequired ? babelPluginFlowReactPropTypes_proptype_Element.isRequired : babelPluginFlowReactPropTypes_proptype_Element : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Element).isRequired,
  classes: __webpack_require__(0).object,
  className: __webpack_require__(0).string
};


/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */
function ListItemIcon(props) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);


  return _react2.default.cloneElement(children, (0, _extends3.default)({
    className: (0, _classnames2.default)(classes.root, classNameProp, children.props.className)
  }, other));
}

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItemIcon' })(ListItemIcon);

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _ref; //  weak

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(11);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_Node = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_Node || __webpack_require__(0).any;

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      position: 'absolute',
      right: 4,
      top: '50%',
      marginTop: -theme.spacing.unit * 3
    }
  };
};

var babelPluginFlowReactPropTypes_proptype_Props = {
  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Node),
  classes: __webpack_require__(0).object,
  className: __webpack_require__(0).string
};


function ListItemSecondaryAction(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className;


  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(classes.root, className) },
    children
  );
}

ListItemSecondaryAction.propTypes =  false ? (_ref = {
  classes: require('prop-types').object.isRequired,
  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Node)
}, (0, _defineProperty3.default)(_ref, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref, 'className', require('prop-types').string), _ref) : {};
ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItemSecondaryAction' })(ListItemSecondaryAction);

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(11);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Typography = __webpack_require__(232);

var _Typography2 = _interopRequireDefault(_Typography);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      flex: '1 1 auto',
      padding: '0 16px',
      '&:first-child': {
        paddingLeft: 0
      }
    },
    inset: {
      '&:first-child': {
        paddingLeft: theme.spacing.unit * 7
      }
    },
    dense: {
      fontSize: 13
    },
    text: {}, // Present to allow external customization
    textDense: {
      fontSize: 'inherit'
    }
  };
}; //  weak

function ListItemText(props, context) {
  var _classNames;

  var classes = props.classes,
      classNameProp = props.className,
      disableTypography = props.disableTypography,
      primary = props.primary,
      secondary = props.secondary,
      inset = props.inset,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'disableTypography', 'primary', 'secondary', 'inset']);
  var dense = context.dense;

  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.dense, dense), (0, _defineProperty3.default)(_classNames, classes.inset, inset), _classNames), classNameProp);

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: className }, other),
    primary && (disableTypography ? primary : _react2.default.createElement(
      _Typography2.default,
      {
        type: 'subheading',
        className: (0, _classnames2.default)(classes.text, (0, _defineProperty3.default)({}, classes.textDense, dense))
      },
      primary
    )),
    secondary && (disableTypography ? secondary : _react2.default.createElement(
      _Typography2.default,
      {
        color: 'secondary',
        type: 'body1',
        className: (0, _classnames2.default)(classes.text, (0, _defineProperty3.default)({}, classes.textDense, dense))
      },
      secondary
    ))
  );
}

ListItemText.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, the children won't be wrapped by a typography component.
   * For instance, that can be useful to can render an h4 instead of a
   */
  disableTypography: _propTypes2.default.bool,
  /**
   * If `true`, the children will be indented.
   * This should be used if there is no left avatar or left icon.
   */
  inset: _propTypes2.default.bool,
  primary: _propTypes2.default.node,
  secondary: _propTypes2.default.node
} : {};

ListItemText.defaultProps = {
  disableTypography: false,
  primary: false,
  secondary: false,
  inset: false
};

ListItemText.contextTypes = {
  dense: _propTypes2.default.bool
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItemText' })(ListItemText);

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(11);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(116);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      boxSizing: 'border-box',
      lineHeight: '48px',
      paddingLeft: theme.spacing.unit * 2,
      paddingRight: theme.spacing.unit * 2,
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.fontSize
    },
    colorPrimary: {
      color: theme.palette.primary[500]
    },
    colorInherit: {
      color: 'inherit'
    },
    inset: {
      paddingLeft: theme.spacing.unit * 9
    },
    sticky: {
      position: 'sticky',
      top: 0,
      zIndex: 1,
      backgroundColor: 'inherit'
    }
  };
}; //  weak

function ListSubheader(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      disableSticky = props.disableSticky,
      inset = props.inset,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color', 'disableSticky', 'inset']);

  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['color' + (0, _helpers.capitalizeFirstLetter)(color)], color !== 'default'), (0, _defineProperty3.default)(_classNames, classes.inset, inset), (0, _defineProperty3.default)(_classNames, classes.sticky, !disableSticky), _classNames), classNameProp);

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: className }, other),
    children
  );
}

ListSubheader.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It's using the theme palette when that makes sense.
   */
  color: _propTypes2.default.oneOf(['default', 'primary', 'inherit']),
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   */
  disableSticky: _propTypes2.default.bool,
  /**
   * If `true`, the List Subheader will be indented.
   */
  inset: _propTypes2.default.bool
} : {};

ListSubheader.defaultProps = {
  color: 'default',
  disableSticky: false,
  inset: false
};

ListSubheader.muiName = 'ListSubheader';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListSubheader' })(ListSubheader);

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _List = __webpack_require__(864);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_List).default;
  }
});

var _ListItem = __webpack_require__(865);

Object.defineProperty(exports, 'ListItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListItem).default;
  }
});

var _ListItemAvatar = __webpack_require__(866);

Object.defineProperty(exports, 'ListItemAvatar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListItemAvatar).default;
  }
});

var _ListItemText = __webpack_require__(869);

Object.defineProperty(exports, 'ListItemText', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListItemText).default;
  }
});

var _ListItemIcon = __webpack_require__(867);

Object.defineProperty(exports, 'ListItemIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListItemIcon).default;
  }
});

var _ListItemSecondaryAction = __webpack_require__(868);

Object.defineProperty(exports, 'ListItemSecondaryAction', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListItemSecondaryAction).default;
  }
});

var _ListSubheader = __webpack_require__(870);

Object.defineProperty(exports, 'ListSubheader', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListSubheader).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _ref;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

var _withStyles = __webpack_require__(11);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_ElementType = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_ElementType || __webpack_require__(0).any;

var styles = exports.styles = function styles(theme) {
  var shadows = {};

  theme.shadows.forEach(function (shadow, index) {
    shadows['shadow' + index] = {
      boxShadow: shadow
    };
  });

  return (0, _extends3.default)({
    root: {
      backgroundColor: theme.palette.background.paper
    },
    rounded: {
      borderRadius: 2
    }
  }, shadows);
};

var babelPluginFlowReactPropTypes_proptype_Props = {
  classes: __webpack_require__(0).object,
  className: __webpack_require__(0).string,
  component: typeof babelPluginFlowReactPropTypes_proptype_ElementType === 'function' ? babelPluginFlowReactPropTypes_proptype_ElementType : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_ElementType),
  elevation: __webpack_require__(0).number,
  square: __webpack_require__(0).bool
};


function Paper(props) {
  var classes = props.classes,
      classNameProp = props.className,
      ComponentProp = props.component,
      square = props.square,
      elevation = props.elevation,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'component', 'square', 'elevation']);


   false ? (0, _warning2.default)(elevation >= 0 && elevation < 25, 'Material-UI: this elevation `' + elevation + '` is not implemented.') : void 0;

  var className = (0, _classnames2.default)(classes.root, classes['shadow' + (elevation >= 0 ? elevation : 0)], (0, _defineProperty3.default)({}, classes.rounded, !square), classNameProp);

  return _react2.default.createElement(ComponentProp, (0, _extends3.default)({ className: className }, other));
}

Paper.propTypes =  false ? (_ref = {
  classes: require('prop-types').object.isRequired,
  component: require('prop-types').string.isRequired,
  elevation: require('prop-types').number.isRequired,
  square: require('prop-types').bool.isRequired
}, (0, _defineProperty3.default)(_ref, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref, 'className', require('prop-types').string), (0, _defineProperty3.default)(_ref, 'component', typeof babelPluginFlowReactPropTypes_proptype_ElementType === 'function' ? babelPluginFlowReactPropTypes_proptype_ElementType : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_ElementType)), (0, _defineProperty3.default)(_ref, 'elevation', require('prop-types').number), (0, _defineProperty3.default)(_ref, 'square', require('prop-types').bool), _ref) : {};
Paper.defaultProps = {
  component: 'div',
  elevation: 2,
  square: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiPaper' })(Paper);

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(11);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  weak

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'inline-block',
      fill: 'currentColor',
      height: 24,
      width: 24,
      userSelect: 'none',
      flexShrink: 0,
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    }
  };
};

function SvgIcon(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      titleAccess = props.titleAccess,
      viewBox = props.viewBox,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'titleAccess', 'viewBox']);


  return _react2.default.createElement(
    'svg',
    (0, _extends3.default)({
      className: (0, _classnames2.default)(classes.root, className),
      focusable: 'false',
      viewBox: viewBox,
      'aria-hidden': titleAccess ? 'false' : 'true'
    }, other),
    titleAccess ? _react2.default.createElement(
      'title',
      null,
      titleAccess
    ) : null,
    children
  );
}

SvgIcon.propTypes =  false ? {
  /**
   * Elements passed into the SVG Icon.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: _propTypes2.default.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an svg element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the svg will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: _propTypes2.default.string
} : {};

SvgIcon.defaultProps = {
  viewBox: '0 0 24 24'
};

SvgIcon.muiName = 'SvgIcon';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiSvgIcon' })(SvgIcon);

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _ref;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(11);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(116);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_Node = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_Node || __webpack_require__(0).any;

var babelPluginFlowReactPropTypes_proptype_ElementType = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_ElementType || __webpack_require__(0).any;

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'block',
      margin: 0
    },
    display4: theme.typography.display4,
    display3: theme.typography.display3,
    display2: theme.typography.display2,
    display1: theme.typography.display1,
    headline: theme.typography.headline,
    title: theme.typography.title,
    subheading: theme.typography.subheading,
    body2: theme.typography.body2,
    body1: theme.typography.body1,
    caption: theme.typography.caption,
    button: theme.typography.button,
    alignLeft: {
      textAlign: 'left'
    },
    alignCenter: {
      textAlign: 'center'
    },
    alignRight: {
      textAlign: 'right'
    },
    alignJustify: {
      textAlign: 'justify'
    },
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    gutterBottom: {
      marginBottom: '0.35em'
    },
    paragraph: {
      marginBottom: theme.spacing.unit * 2
    },
    colorInherit: {
      color: 'inherit'
    },
    colorSecondary: {
      color: theme.palette.text.secondary
    },
    colorAccent: {
      color: theme.palette.secondary.A400
    }
  };
};

var babelPluginFlowReactPropTypes_proptype_Props = {
  align: __webpack_require__(0).oneOf(['inherit', 'left', 'center', 'right', 'justify']),
  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Node),
  classes: __webpack_require__(0).object,
  className: __webpack_require__(0).string,
  component: typeof babelPluginFlowReactPropTypes_proptype_ElementType === 'function' ? babelPluginFlowReactPropTypes_proptype_ElementType : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_ElementType),
  color: __webpack_require__(0).oneOf(['inherit', 'secondary', 'accent', 'default']),
  gutterBottom: __webpack_require__(0).bool,
  headlineMapping: __webpack_require__(0).shape({}),
  noWrap: __webpack_require__(0).bool,
  paragraph: __webpack_require__(0).bool,
  type: __webpack_require__(0).oneOf(['display4', 'display3', 'display2', 'display1', 'headline', 'title', 'subheading', 'body2', 'body1', 'caption', 'button'])
};


function Typography(props) {
  var _classNames;

  var align = props.align,
      classes = props.classes,
      classNameProp = props.className,
      componentProp = props.component,
      color = props.color,
      gutterBottom = props.gutterBottom,
      headlineMapping = props.headlineMapping,
      noWrap = props.noWrap,
      paragraph = props.paragraph,
      type = props.type,
      other = (0, _objectWithoutProperties3.default)(props, ['align', 'classes', 'className', 'component', 'color', 'gutterBottom', 'headlineMapping', 'noWrap', 'paragraph', 'type']);


  var className = (0, _classnames2.default)(classes.root, classes[type], (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['color' + (0, _helpers.capitalizeFirstLetter)(color)], color !== 'default'), (0, _defineProperty3.default)(_classNames, classes.noWrap, noWrap), (0, _defineProperty3.default)(_classNames, classes.gutterBottom, gutterBottom), (0, _defineProperty3.default)(_classNames, classes.paragraph, paragraph), (0, _defineProperty3.default)(_classNames, classes['align' + (0, _helpers.capitalizeFirstLetter)(align)], align !== 'inherit'), _classNames), classNameProp);

  var Component = componentProp || (paragraph ? 'p' : headlineMapping[type]) || 'span';

  return _react2.default.createElement(Component, (0, _extends3.default)({ className: className }, other));
}

Typography.propTypes =  false ? (_ref = {
  classes: require('prop-types').object.isRequired,
  headlineMapping: require('prop-types').shape({}).isRequired,
  type: require('prop-types').oneOf(['display4', 'display3', 'display2', 'display1', 'headline', 'title', 'subheading', 'body2', 'body1', 'caption', 'button']).isRequired,
  align: require('prop-types').oneOf(['inherit', 'left', 'center', 'right', 'justify']),
  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Node)
}, (0, _defineProperty3.default)(_ref, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref, 'className', require('prop-types').string), (0, _defineProperty3.default)(_ref, 'component', typeof babelPluginFlowReactPropTypes_proptype_ElementType === 'function' ? babelPluginFlowReactPropTypes_proptype_ElementType : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_ElementType)), (0, _defineProperty3.default)(_ref, 'color', require('prop-types').oneOf(['inherit', 'secondary', 'accent', 'default'])), (0, _defineProperty3.default)(_ref, 'gutterBottom', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'headlineMapping', require('prop-types').shape({})), (0, _defineProperty3.default)(_ref, 'noWrap', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'paragraph', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'type', require('prop-types').oneOf(['display4', 'display3', 'display2', 'display1', 'headline', 'title', 'subheading', 'body2', 'body1', 'caption', 'button'])), _ref) : {};
Typography.defaultProps = {
  align: 'inherit',
  color: 'default',
  gutterBottom: false,
  headlineMapping: {
    display4: 'h1',
    display3: 'h1',
    display2: 'h1',
    display1: 'h1',
    headline: 'h1',
    title: 'h2',
    subheading: 'h3',
    body2: 'aside',
    body1: 'p'
  },
  noWrap: false,
  paragraph: false,
  type: 'body1'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTypography' })(Typography);

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var common = {
  black: '#000',
  white: '#fff',
  transparent: 'rgba(0, 0, 0, 0)',
  fullBlack: 'rgba(0, 0, 0, 1)',
  darkBlack: 'rgba(0, 0, 0, 0.87)',
  lightBlack: 'rgba(0, 0, 0, 0.54)',
  minBlack: 'rgba(0, 0, 0, 0.26)',
  faintBlack: 'rgba(0, 0, 0, 0.12)',
  fullWhite: 'rgba(255, 255, 255, 1)',
  darkWhite: 'rgba(255, 255, 255, 0.87)',
  lightWhite: 'rgba(255, 255, 255, 0.54)'
};

exports.default = common;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Wait https://github.com/facebook/flow/issues/380 to be fixed
/* eslint-disable flowtype/require-valid-file-annotation */

var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161',
  contrastDefaultColor: 'dark'
};

exports.default = grey;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Wait https://github.com/facebook/flow/issues/380 to be fixed
/* eslint-disable flowtype/require-valid-file-annotation */

var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe',
  contrastDefaultColor: 'light'
};

exports.default = indigo;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Wait https://github.com/facebook/flow/issues/380 to be fixed
/* eslint-disable flowtype/require-valid-file-annotation */

var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162',
  contrastDefaultColor: 'light'
};

exports.default = pink;

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Wait https://github.com/facebook/flow/issues/380 to be fixed
/* eslint-disable flowtype/require-valid-file-annotation */

var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000',
  contrastDefaultColor: 'light'
};

exports.default = red;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(37);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(38);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(39);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(41);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(40);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = createSwitch;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(11);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _IconButton = __webpack_require__(863);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _CheckBoxOutlineBlank = __webpack_require__(892);

var _CheckBoxOutlineBlank2 = _interopRequireDefault(_CheckBoxOutlineBlank);

var _CheckBox = __webpack_require__(891);

var _CheckBox2 = _interopRequireDefault(_CheckBox);

var _Icon = __webpack_require__(408);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_Element = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_Element || __webpack_require__(0).any;

var babelPluginFlowReactPropTypes_proptype_Node = __webpack_require__(1).babelPluginFlowReactPropTypes_proptype_Node || __webpack_require__(0).any;

var styles = exports.styles = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    transition: 'none'
  },
  input: {
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0
  },
  default: {},
  checked: {},
  disabled: {}
};

var babelPluginFlowReactPropTypes_proptype_Props = {
  checked: __webpack_require__(0).oneOfType([__webpack_require__(0).bool, __webpack_require__(0).string]),
  checkedClassName: __webpack_require__(0).string,
  checkedIcon: typeof babelPluginFlowReactPropTypes_proptype_Element === 'function' ? babelPluginFlowReactPropTypes_proptype_Element : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Element),
  classes: __webpack_require__(0).object,
  className: __webpack_require__(0).string,
  defaultChecked: __webpack_require__(0).bool,
  disabled: __webpack_require__(0).bool,
  disabledClassName: __webpack_require__(0).string,
  disableRipple: __webpack_require__(0).bool,
  icon: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Node),
  indeterminate: __webpack_require__(0).bool,
  indeterminateIcon: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(0).shape(babelPluginFlowReactPropTypes_proptype_Node),
  inputProps: __webpack_require__(0).object,
  inputRef: __webpack_require__(0).func,
  name: __webpack_require__(0).string,
  onChange: __webpack_require__(0).func,
  tabIndex: __webpack_require__(0).oneOfType([__webpack_require__(0).number, __webpack_require__(0).string]),
  value: __webpack_require__(0).string
};

// NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.

var _ref2 = _react2.default.createElement(_CheckBoxOutlineBlank2.default, null);

var _ref3 = _react2.default.createElement(_CheckBox2.default, null);

function createSwitch() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$defaultIcon = _ref.defaultIcon,
      defaultIcon = _ref$defaultIcon === undefined ? _ref2 : _ref$defaultIcon,
      _ref$defaultCheckedIc = _ref.defaultCheckedIcon,
      defaultCheckedIcon = _ref$defaultCheckedIc === undefined ? _ref3 : _ref$defaultCheckedIc,
      _ref$inputType = _ref.inputType,
      inputType = _ref$inputType === undefined ? 'checkbox' : _ref$inputType;

  /**
   * @ignore - internal component.
   */
  var SwitchBase = function (_React$Component) {
    (0, _inherits3.default)(SwitchBase, _React$Component);

    function SwitchBase() {
      var _ref4;

      var _temp, _this, _ret;

      (0, _classCallCheck3.default)(this, SwitchBase);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref4 = SwitchBase.__proto__ || (0, _getPrototypeOf2.default)(SwitchBase)).call.apply(_ref4, [this].concat(args))), _this), _this.state = {}, _this.input = null, _this.button = null, _this.isControlled = null, _this.handleInputChange = function (event) {
        var newChecked = void 0;

        if (_this.isControlled) {
          newChecked = !_this.props.checked;
        } else {
          newChecked = !_this.state.checked;
          if (_this.input && _this.input.checked !== newChecked) {
            _this.input.checked = newChecked;
          }
          _this.setState({ checked: !_this.state.checked });
        }

        if (_this.props.onChange) {
          _this.props.onChange(event, newChecked);
        }
      }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(SwitchBase, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        var props = this.props;


        this.isControlled = props.checked !== undefined;

        if (!this.isControlled) {
          // not controlled, use internal state
          this.setState({
            checked: props.defaultChecked !== undefined ? props.defaultChecked : false
          });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _classNames,
            _this2 = this;

        var _props = this.props,
            checkedProp = _props.checked,
            classes = _props.classes,
            classNameProp = _props.className,
            checkedClassName = _props.checkedClassName,
            checkedIcon = _props.checkedIcon,
            disabled = _props.disabled,
            disabledClassName = _props.disabledClassName,
            iconProp = _props.icon,
            inputProps = _props.inputProps,
            inputRef = _props.inputRef,
            name = _props.name,
            onChange = _props.onChange,
            tabIndex = _props.tabIndex,
            value = _props.value,
            other = (0, _objectWithoutProperties3.default)(_props, ['checked', 'classes', 'className', 'checkedClassName', 'checkedIcon', 'disabled', 'disabledClassName', 'icon', 'inputProps', 'inputRef', 'name', 'onChange', 'tabIndex', 'value']);


        var checked = this.isControlled ? checkedProp : this.state.checked;
        var className = (0, _classnames2.default)(classes.root, classes.default, classNameProp, (_classNames = {}, (0, _defineProperty3.default)(_classNames, (0, _classnames2.default)(classes.checked, checkedClassName), checked), (0, _defineProperty3.default)(_classNames, (0, _classnames2.default)(classes.disabled, disabledClassName), disabled), _classNames));

        var icon = checked ? checkedIcon : iconProp;

        if (typeof icon === 'string') {
          icon = _react2.default.createElement(
            _Icon2.default,
            null,
            icon
          );
        }

        return _react2.default.createElement(
          _IconButton2.default,
          (0, _extends3.default)({
            component: 'span',
            className: className,
            disabled: disabled,
            tabIndex: null,
            role: undefined,
            rootRef: function rootRef(node) {
              _this2.button = node;
            }
          }, other),
          icon,
          _react2.default.createElement('input', (0, _extends3.default)({
            ref: function ref(node) {
              _this2.input = node;
              if (inputRef) {
                inputRef(node);
              }
            },
            type: inputType,
            name: name,
            checked: this.isControlled ? checkedProp : undefined,
            onChange: this.handleInputChange,
            className: classes.input,
            disabled: disabled,
            tabIndex: tabIndex,
            value: value
          }, inputProps))
        );
      }
    }]);
    return SwitchBase;
  }(_react2.default.Component);

  SwitchBase.defaultProps = {
    checkedIcon: defaultCheckedIcon,
    disableRipple: false,
    icon: defaultIcon
  };


  return (0, _withStyles2.default)(styles, { name: 'MuiSwitchBase' })(SwitchBase);
}

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createGenerateClassName;

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_StyleSheet = __webpack_require__(226).babelPluginFlowReactPropTypes_proptype_StyleSheet || __webpack_require__(0).any;

var babelPluginFlowReactPropTypes_proptype_generateClassName = __webpack_require__(396).babelPluginFlowReactPropTypes_proptype_generateClassName || __webpack_require__(0).any;

var babelPluginFlowReactPropTypes_proptype_Rule = __webpack_require__(396).babelPluginFlowReactPropTypes_proptype_Rule || __webpack_require__(0).any;

var generatorCounter = 0;

// Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's an improved version of
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js
function createGenerateClassName() {
  var ruleCounter = 0;

  if ("production" !== 'test' && typeof window !== 'undefined') {
    generatorCounter += 1;

     false ? (0, _warning2.default)(generatorCounter === 1, ['Material-UI: You can only instantiate one class name generator on the client side.', 'If you do otherwise, you take the risk to have conflicting class names in production.'].join('\n')) : void 0;
  }

  return function (rule, sheet) {
    ruleCounter += 1;
     false ? (0, _warning2.default)(ruleCounter < 1e10, ['Material-UI: you might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join('')) : void 0;

    if (true) {
      return 'c' + ruleCounter;
    }

    if (sheet && sheet.options.meta) {
      return sheet.options.meta + '-' + rule.key + '-' + ruleCounter;
    }

    return rule.key + '-' + ruleCounter;
  };
}

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = createMixins;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return (0, _extends3.default)({
    gutters: function gutters(styles) {
      styles.paddingLeft = spacing.unit * 2;
      styles.paddingRight = spacing.unit * 2;
      styles[breakpoints.up('sm')] = {
        paddingLeft: spacing.unit * 3,
        paddingRight: spacing.unit * 3
      };
      return styles;
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, (0, _defineProperty3.default)(_toolbar, breakpoints.up('xs') + ' and (orientation: landscape)', {
      minHeight: 48
    }), (0, _defineProperty3.default)(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dark = exports.light = undefined;

var _keys = __webpack_require__(53);

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = createPalette;

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

var _deepmerge = __webpack_require__(142);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _indigo = __webpack_require__(877);

var _indigo2 = _interopRequireDefault(_indigo);

var _pink = __webpack_require__(878);

var _pink2 = _interopRequireDefault(_pink);

var _grey = __webpack_require__(876);

var _grey2 = _interopRequireDefault(_grey);

var _red = __webpack_require__(879);

var _red2 = _interopRequireDefault(_red);

var _common = __webpack_require__(875);

var _common2 = _interopRequireDefault(_common);

var _colorManipulator = __webpack_require__(410);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// < 1kb payload overhead when lodash/merge is > 3kb.
var light = exports.light = {
  text: {
    primary: 'rgba(0, 0, 0, 0.87)',
    secondary: 'rgba(0, 0, 0, 0.54)',
    disabled: 'rgba(0, 0, 0, 0.38)',
    hint: 'rgba(0, 0, 0, 0.38)',
    icon: 'rgba(0, 0, 0, 0.38)',
    divider: 'rgba(0, 0, 0, 0.12)',
    lightDivider: 'rgba(0, 0, 0, 0.075)'
  },
  input: {
    bottomLine: 'rgba(0, 0, 0, 0.42)',
    helperText: 'rgba(0, 0, 0, 0.54)',
    labelText: 'rgba(0, 0, 0, 0.54)',
    inputText: 'rgba(0, 0, 0, 0.87)',
    disabled: 'rgba(0, 0, 0, 0.42)'
  },
  action: {
    active: 'rgba(0, 0, 0, 0.54)',
    disabled: 'rgba(0, 0, 0, 0.26)'
  },
  background: {
    default: _grey2.default[50],
    paper: _common2.default.white,
    appBar: _grey2.default[100],
    contentFrame: _grey2.default[200]
  }
};

var dark = exports.dark = {
  text: {
    primary: 'rgba(255, 255, 255, 1)',
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)',
    divider: 'rgba(255, 255, 255, 0.12)',
    lightDivider: 'rgba(255, 255, 255, 0.075)'
  },
  input: {
    bottomLine: 'rgba(255, 255, 255, 0.7)',
    helperText: 'rgba(255, 255, 255, 0.7)',
    labelText: 'rgba(255, 255, 255, 0.7)',
    inputText: 'rgba(255, 255, 255, 1)',
    disabled: 'rgba(255, 255, 255, 0.5)'
  },
  action: {
    active: 'rgba(255, 255, 255, 1)',
    disabled: 'rgba(255, 255, 255, 0.3)'
  },
  background: {
    default: '#303030',
    paper: _grey2.default[800],
    appBar: _grey2.default[900],
    contentFrame: _grey2.default[900],
    status: _common2.default.black
  }
};

function getContrastText(color) {
  if ((0, _colorManipulator.getContrastRatio)(color, _common2.default.black) < 7) {
    return dark.text.primary;
  }
  return light.text.primary;
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === undefined ? _indigo2.default : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === undefined ? _pink2.default : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === undefined ? _red2.default : _palette$error,
      _palette$type = palette.type,
      type = _palette$type === undefined ? 'light' : _palette$type,
      other = (0, _objectWithoutProperties3.default)(palette, ['primary', 'secondary', 'error', 'type']);

  var shades = { dark: dark, light: light };

   false ? (0, _warning2.default)(shades[type], 'Material-UI: the palette type `' + type + '` is not supported.') : void 0;

  var paletteOutput = (0, _deepmerge2.default)({
    common: _common2.default,
    type: type,
    primary: primary,
    secondary: secondary,
    error: error,
    grey: _grey2.default,
    shades: shades,
    text: shades[type].text,
    input: shades[type].input,
    action: shades[type].action,
    background: shades[type].background,
    getContrastText: getContrastText
  }, other);

  // Dev warnings
  if (false) {
    var difference = function difference(base, compare) {
      if (!compare) {
        compare = {};
      }

      return (0, _keys2.default)(base).filter(function (hue) {
        return !compare[hue];
      });
    };

    var paletteColorError = function paletteColorError(name, base, compare) {
      var missing = difference(base, compare);
      process.env.NODE_ENV !== "production" ? (0, _warning2.default)(missing.length === 0, ['Material-UI: ' + name + ' color is missing the following hues: ' + missing.join(','), 'See the default colors, indigo, or pink, as exported from material-ui/colors.'].join('\n')) : void 0;
    };

    paletteColorError('primary', _indigo2.default, paletteOutput.primary);
    paletteColorError('secondary', _pink2.default, paletteOutput.secondary);
    paletteColorError('error', _red2.default, paletteOutput.error);
    paletteColorError('grey', _red2.default, paletteOutput.grey);
  }

  return paletteOutput;
}

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = createTypography;

var _deepmerge = __webpack_require__(142);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// < 1kb payload overhead when lodash/merge is > 3kb.

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === undefined ? '"Roboto", "Helvetica", "Arial", sans-serif' : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === undefined ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === undefined ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === undefined ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === undefined ? 500 : _ref$fontWeightMedium,
      other = (0, _objectWithoutProperties3.default)(_ref, ['fontFamily', 'fontSize', 'fontWeightLight', 'fontWeightRegular', 'fontWeightMedium']);

  return (0, _deepmerge2.default)({
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    display4: {
      fontSize: 112,
      fontWeight: fontWeightLight,
      fontFamily: fontFamily,
      letterSpacing: '-.04em',
      lineHeight: 1,
      color: palette.text.secondary
    },
    display3: {
      fontSize: 56,
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      letterSpacing: '-.02em',
      lineHeight: 1.35,
      color: palette.text.secondary
    },
    display2: {
      fontSize: 45,
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: '48px',
      color: palette.text.secondary
    },
    display1: {
      fontSize: 34,
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: '40px',
      color: palette.text.secondary
    },
    headline: {
      fontSize: 24,
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: '32px',
      color: palette.text.primary
    },
    title: {
      fontSize: 21,
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: 1,
      color: palette.text.primary
    },
    subheading: {
      fontSize: 16,
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: '24px',
      color: palette.text.primary
    },
    body2: {
      fontSize: 14,
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: '24px',
      color: palette.text.primary
    },
    body1: {
      fontSize: 14,
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: '20px',
      color: palette.text.primary
    },
    caption: {
      fontSize: 12,
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: 1,
      color: palette.text.secondary
    },
    button: {
      fontSize: fontSize,
      textTransform: 'uppercase',
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily
    }
  }, other);
}

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(53);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

var _deepmerge = __webpack_require__(142);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// < 1kb payload overhead when lodash/merge is > 3kb.

function getStylesCreator(stylesOrCreator) {
  function create(theme, name) {
    var styles = typeof stylesOrCreator === 'function' ? stylesOrCreator(theme) : stylesOrCreator;

    if (!theme.overrides || !theme.overrides[name]) {
      return styles;
    }

    var overrides = theme.overrides[name];
    var stylesWithOverrides = (0, _extends3.default)({}, styles);

    (0, _keys2.default)(overrides).forEach(function (key) {
       false ? (0, _warning2.default)(stylesWithOverrides[key], 'You are trying to overrides a style that do not exist.') : void 0;
      stylesWithOverrides[key] = (0, _deepmerge2.default)(stylesWithOverrides[key], overrides[key], {
        clone: true // We don't want to mutate the input
      });
    });

    return stylesWithOverrides;
  }

  return {
    create: create,
    options: {
      index: undefined
    },
    themingEnabled: typeof stylesOrCreator === 'function'
  };
}

exports.default = getStylesCreator;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return [(arguments.length <= 0 ? undefined : arguments[0]) + 'px ' + (arguments.length <= 1 ? undefined : arguments[1]) + 'px ' + (arguments.length <= 2 ? undefined : arguments[2]) + 'px ' + (arguments.length <= 3 ? undefined : arguments[3]) + 'px rgba(0, 0, 0, ' + shadowKeyUmbraOpacity + ')', (arguments.length <= 4 ? undefined : arguments[4]) + 'px ' + (arguments.length <= 5 ? undefined : arguments[5]) + 'px ' + (arguments.length <= 6 ? undefined : arguments[6]) + 'px ' + (arguments.length <= 7 ? undefined : arguments[7]) + 'px rgba(0, 0, 0, ' + shadowKeyPenumbraOpacity + ')', (arguments.length <= 8 ? undefined : arguments[8]) + 'px ' + (arguments.length <= 9 ? undefined : arguments[9]) + 'px ' + (arguments.length <= 10 ? undefined : arguments[10]) + 'px ' + (arguments.length <= 11 ? undefined : arguments[11]) + 'px rgba(0, 0, 0, ' + shadowAmbientShadowOpacity + ')'].join(',');
}

var shadows = ['none', createShadow(0, 1, 3, 0, 0, 1, 1, 0, 0, 2, 1, -1), createShadow(0, 1, 5, 0, 0, 2, 2, 0, 0, 3, 1, -2), createShadow(0, 1, 8, 0, 0, 3, 4, 0, 0, 3, 3, -2), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];

exports.default = shadows;

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  // All components align to an 8dp square baseline grid for mobile, tablet, and desktop.
  // https://material.io/guidelines/layout/metrics-keylines.html#metrics-keylines-baseline-grids
  unit: 8
};

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNumber = exports.isString = exports.formatMs = exports.duration = exports.easing = undefined;

var _keys = __webpack_require__(53);

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = exports.easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};

// Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

/* eslint-disable no-param-reassign */

var duration = exports.duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

var formatMs = exports.formatMs = function formatMs(milliseconds) {
  return Math.round(milliseconds) + 'ms';
};
var isString = exports.isString = function isString(value) {
  return typeof value === 'string';
};
var isNumber = exports.isNumber = function isNumber(value) {
  return !isNaN(parseFloat(value));
};

/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */
exports.default = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$duration = options.duration,
        durationOption = _options$duration === undefined ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === undefined ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === undefined ? 0 : _options$delay,
        other = (0, _objectWithoutProperties3.default)(options, ['duration', 'easing', 'delay']);


     false ? (0, _warning2.default)(isString(props) || Array.isArray(props), 'Material-UI: argument "props" must be a string or Array') : void 0;
     false ? (0, _warning2.default)(isNumber(durationOption), 'Material-UI: argument "duration" must be a number but found ' + durationOption) : void 0;
     false ? (0, _warning2.default)(isString(easingOption), 'Material-UI: argument "easing" must be a string') : void 0;
     false ? (0, _warning2.default)(isNumber(delay), 'Material-UI: argument "delay" must be a string') : void 0;
     false ? (0, _warning2.default)((0, _keys2.default)(other).length === 0, 'Material-UI: unrecognized argument(s) [' + (0, _keys2.default)(other).join(',') + ']') : void 0;

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return animatedProp + ' ' + formatMs(durationOption) + ' ' + easingOption + ' ' + formatMs(delay);
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36;

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(37);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(38);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(39);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(41);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(40);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = withTheme;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _createEagerFactory = __webpack_require__(157);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

var _wrapDisplayName = __webpack_require__(123);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _createMuiTheme = __webpack_require__(411);

var _createMuiTheme2 = _interopRequireDefault(_createMuiTheme);

var _themeListener = __webpack_require__(412);

var _themeListener2 = _interopRequireDefault(_themeListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_ComponentType = __webpack_require__(0).func; //  weak

var defaultTheme = void 0;

function getDefaultTheme() {
  if (defaultTheme) {
    return defaultTheme;
  }

  defaultTheme = (0, _createMuiTheme2.default)();
  return defaultTheme;
}

// Provide the theme object as a property to the input component.
function withTheme(BaseComponent) {
  var factory = (0, _createEagerFactory2.default)(BaseComponent);

  var WithTheme = function (_React$Component) {
    (0, _inherits3.default)(WithTheme, _React$Component);

    function WithTheme(props, context) {
      (0, _classCallCheck3.default)(this, WithTheme);

      var _this = (0, _possibleConstructorReturn3.default)(this, (WithTheme.__proto__ || (0, _getPrototypeOf2.default)(WithTheme)).call(this, props, context));

      _this.state = {};
      _this.unsubscribeId = null;

      _this.state = {
        // We use || as it's lazy evaluated.
        theme: _themeListener2.default.initial(context) || getDefaultTheme()
      };
      return _this;
    }

    // Exposed for test purposes.


    (0, _createClass3.default)(WithTheme, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.unsubscribeId = _themeListener2.default.subscribe(this.context, function (theme) {
          _this2.setState({ theme: theme });
        });
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.unsubscribeId !== null) {
          _themeListener2.default.unsubscribe(this.context, this.unsubscribeId);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return factory((0, _extends3.default)({ theme: this.state.theme }, this.props));
      }
    }]);
    return WithTheme;
  }(_react2.default.Component);

  WithTheme.displayName = (0, _wrapDisplayName2.default)(BaseComponent, 'withTheme');
  WithTheme.Naked = BaseComponent;


  WithTheme.contextTypes = _themeListener2.default.contextTypes;

  return WithTheme;
}

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


// Needed as the zIndex works with absolute values.
exports.default = {
  mobileStepper: 900,
  menu: 1000,
  appBar: 1100,
  drawerOverlay: 1200,
  navDrawer: 1300,
  dialogOverlay: 1400,
  dialog: 1500,
  layer: 2000,
  popover: 2100,
  snackbar: 2900,
  tooltip: 3000
};

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(251);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(231);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' });

var CheckBox = function CheckBox(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};
CheckBox = (0, _pure2.default)(CheckBox);
CheckBox.muiName = 'SvgIcon';

exports.default = CheckBox;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(251);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(231);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' });

var CheckBoxOutlineBlank = function CheckBoxOutlineBlank(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};
CheckBoxOutlineBlank = (0, _pure2.default)(CheckBoxOutlineBlank);
CheckBoxOutlineBlank.muiName = 'SvgIcon';

exports.default = CheckBoxOutlineBlank;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(251);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(231);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z' });

var IndeterminateCheckBox = function IndeterminateCheckBox(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};
IndeterminateCheckBox = (0, _pure2.default)(IndeterminateCheckBox);
IndeterminateCheckBox.muiName = 'SvgIcon';

exports.default = IndeterminateCheckBox;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (node, event, handler, capture) {
  (0, _on2.default)(node, event, handler, capture);
  return {
    remove: function remove() {
      (0, _off2.default)(node, event, handler, capture);
    }
  };
};

var _on = __webpack_require__(709);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(708);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusKeyPressed = focusKeyPressed;
exports.detectKeyboardFocus = detectKeyboardFocus;
exports.listenForFocusKeys = listenForFocusKeys;

var _keycode = __webpack_require__(401);

var _keycode2 = _interopRequireDefault(_keycode);

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

var _contains = __webpack_require__(710);

var _contains2 = _interopRequireDefault(_contains);

var _addEventListener = __webpack_require__(894);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  weak

var FOCUS_KEYS = ['tab', 'enter', 'space', 'esc', 'up', 'down', 'left', 'right'];

var internal = {
  listening: false,
  focusKeyPressed: false
};

function isFocusKey(event) {
  return FOCUS_KEYS.indexOf((0, _keycode2.default)(event)) !== -1;
}

function focusKeyPressed(pressed) {
  if (typeof pressed !== 'undefined') {
    internal.focusKeyPressed = Boolean(pressed);
  }

  return internal.focusKeyPressed;
}

function detectKeyboardFocus(instance, element, callback) {
  var attempt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

   false ? (0, _warning2.default)(instance.keyboardFocusCheckTime, 'Material-UI: missing instance.keyboardFocusCheckTime') : void 0;
   false ? (0, _warning2.default)(instance.keyboardFocusMaxCheckTimes, 'Material-UI: missing instance.keyboardFocusMaxCheckTimes') : void 0;

  instance.keyboardFocusTimeout = setTimeout(function () {
    if (focusKeyPressed() && (document.activeElement === element || (0, _contains2.default)(element, document.activeElement))) {
      callback();
    } else if (attempt < instance.keyboardFocusMaxCheckTimes) {
      detectKeyboardFocus(instance, element, callback, attempt + 1);
    }
  }, instance.keyboardFocusCheckTime);
}

function listenForFocusKeys() {
  if (!internal.listening) {
    (0, _addEventListener2.default)(window, 'keyup', function (event) {
      if (isFocusKey(event)) {
        internal.focusKeyPressed = true;
      }
    });
    internal.listening = true;
  }
}

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//  weak

var requirePropFactory = function requirePropFactory(componentNameInError) {
  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error('The property `' + propFullNameSafe + '` of ' + ('`' + componentNameInError + '` must be used on `' + requiredProp + '`.'));
      }

      return null;
    };
  };
  return requireProp;
};

exports.default = requirePropFactory;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isWidthDown = exports.isWidthUp = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(37);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(38);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(39);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(41);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(40);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactEventListener = __webpack_require__(969);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _debounce = __webpack_require__(838);

var _debounce2 = _interopRequireDefault(_debounce);

var _createEagerFactory = __webpack_require__(157);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

var _wrapDisplayName = __webpack_require__(123);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _withTheme = __webpack_require__(889);

var _withTheme2 = _interopRequireDefault(_withTheme);

var _createBreakpoints = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_ComponentType = __webpack_require__(0).func; //  weak

/**
 * By default, returns true if screen width is the same or greater than the given breakpoint.
 *
 * @param screenWidth
 * @param breakpoint
 * @param inclusive - defaults to true
 */
var babelPluginFlowReactPropTypes_proptype_Breakpoint = __webpack_require__(59).babelPluginFlowReactPropTypes_proptype_Breakpoint || __webpack_require__(0).any;

var isWidthUp = exports.isWidthUp = function isWidthUp(breakpoint, screenWidth) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return _createBreakpoints.keys.indexOf(breakpoint) <= _createBreakpoints.keys.indexOf(screenWidth);
  }
  return _createBreakpoints.keys.indexOf(breakpoint) < _createBreakpoints.keys.indexOf(screenWidth);
};

/**
 * By default, returns true if screen width is the same or less than the given breakpoint.
 *
 * @param screenWidth
 * @param breakpoint
 * @param inclusive - defaults to true
 */
var isWidthDown = exports.isWidthDown = function isWidthDown(breakpoint, screenWidth) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return _createBreakpoints.keys.indexOf(screenWidth) <= _createBreakpoints.keys.indexOf(breakpoint);
  }
  return _createBreakpoints.keys.indexOf(screenWidth) < _createBreakpoints.keys.indexOf(breakpoint);
};

function withWidth() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$resizeInterv = options.resizeInterval,
      resizeInterval = _options$resizeInterv === undefined ? 166 : _options$resizeInterv;


  function enhance(BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);

    var Width = function (_React$Component) {
      (0, _inherits3.default)(Width, _React$Component);

      function Width() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Width);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Width.__proto__ || (0, _getPrototypeOf2.default)(Width)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          width: undefined
        }, _this.handleResize = (0, _debounce2.default)(function () {
          _this.updateWidth(window.innerWidth);
        }, resizeInterval), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
      }

      (0, _createClass3.default)(Width, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.updateWidth(window.innerWidth);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.handleResize.cancel();
        }
      }, {
        key: 'updateWidth',
        value: function updateWidth(innerWidth) {
          var breakpoints = this.props.theme.breakpoints;
          var width = null;

          /**
           * Start with the slowest value as low end devices often have a small screen.
           *
           * innerWidth |0      xs      sm      md      lg      xl
           *            |-------|-------|-------|-------|-------|------>
           * width      |  xs   |  xs   |  sm   |  md   |  lg   |  xl
           */
          var index = 1;
          while (width === null && index < _createBreakpoints.keys.length) {
            var currentWidth = _createBreakpoints.keys[index];

            // @media are inclusive, so reproduce the behavior here.
            if (innerWidth < breakpoints.values[currentWidth]) {
              width = _createBreakpoints.keys[index - 1];
              break;
            }

            index += 1;
          }

          width = width || 'xl';

          if (width !== this.state.width) {
            this.setState({
              width: width
            });
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var _props = this.props,
              initialWidth = _props.initialWidth,
              theme = _props.theme,
              width = _props.width,
              other = (0, _objectWithoutProperties3.default)(_props, ['initialWidth', 'theme', 'width']);

          var props = (0, _extends3.default)({
            width: width || this.state.width || initialWidth
          }, other);

          /**
           * When rendering the component on the server,
           * we have no idea about the client browser screen width.
           * In order to prevent blinks and help the reconciliation of the React tree
           * we are not rendering the child component.
           *
           * An alternative is to use the `initialWidth` property.
           */
          if (props.width === undefined) {
            return null;
          }

          return _react2.default.createElement(
            _reactEventListener2.default,
            { target: 'window', onResize: this.handleResize },
            factory(props)
          );
        }
      }]);
      return Width;
    }(_react2.default.Component);

    if (false) {
      Width.displayName = (0, _wrapDisplayName2.default)(BaseComponent, 'withWidth');
    }

    return (0, _withTheme2.default)(Width);
  }

  enhance.propTypes =  false ? babelPluginFlowReactPropTypes_proptype_ComponentType === require('prop-types').any ? {} : babelPluginFlowReactPropTypes_proptype_ComponentType : {};
  return enhance;
}

exports.default = withWidth;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
//! version : 2.18.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    var k;
    for (k in obj) {
        // even if its not own property I'd still call it non-empty
        return false;
    }
    return true;
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

var some$1 = some;

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var keys$1 = keys;

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid()) {
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

var indexOf$1 = indexOf;

function daysInMonth(year, month) {
    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
            // because defineLocale currently also sets the global locale, we
            // want to undo that for lazy loaded locales
            getSetGlobalLocale(oldLocale);
        } catch (e) { }
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, parentConfig = baseConfig;
        // MERGE
        if (locales[name] != null) {
            parentConfig = locales[name]._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys$1(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var string, match, dayFormat,
        dateFormat, timeFormat, tzFormat;
    var timezones = {
        ' GMT': ' +0000',
        ' EDT': ' -0400',
        ' EST': ' -0500',
        ' CDT': ' -0500',
        ' CST': ' -0600',
        ' MDT': ' -0600',
        ' MST': ' -0700',
        ' PDT': ' -0700',
        ' PST': ' -0800'
    };
    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
    var timezone, timezoneIndex;

    string = config._i
        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
    match = basicRfcRegex.exec(string);

    if (match) {
        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');

        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        if (match[1]) { // day of week given
            var momentDate = new Date(match[2]);
            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];

            if (match[1].substr(0,3) !== momentDay) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return;
            }
        }

        switch (match[5].length) {
            case 2: // military
                if (timezoneIndex === 0) {
                    timezone = ' +0000';
                } else {
                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
                }
                break;
            case 4: // Zone
                timezone = timezones[match[5]];
                break;
            default: // UT or +/-9999
                timezone = timezones[' GMT'];
        }
        match[5] = timezone;
        config._i = match.splice(1).join('');
        tzFormat = ' ZZ';
        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
        configFromStringAndFormat(config);
        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    if (units === 'year' || units === 'month' || units === 'quarter') {
        output = monthDiff(this, that);
        if (units === 'quarter') {
            output = output / 3;
        } else if (units === 'year') {
            output = output / 12;
        }
    } else {
        delta = this - that;
        output = units === 'second' ? delta / 1e3 : // 1000
            units === 'minute' ? delta / 6e4 : // 1000 * 60
            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
            delta;
    }
    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds;
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    return (total < 0 ? '-' : '') +
        'P' +
        (Y ? Y + 'Y' : '') +
        (M ? M + 'M' : '') +
        (D ? D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? h + 'H' : '') +
        (m ? m + 'M' : '') +
        (s ? s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.18.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1003)(module)))

/***/ }),
/* 899 */
/***/ (function(module, exports) {

(function() {
  var PriorityQueue;



  exports.PriorityQueue = PriorityQueue = (function() {
    PriorityQueue.prototype._cmp = function(a, b) {
      return a - b;
    };

    PriorityQueue.prototype._get_key = function(a) {
      return a.key;
    };

    PriorityQueue.prototype._get_pri = function(a) {
      return a.priority;
    };

    PriorityQueue.prototype._set_pri = function(a, v) {
      return a.priority = v;
    };

    function PriorityQueue(opts) {
      var cmp, get_key, get_pri, set_pri;
      if (opts == null) {
        opts = {};
      }
      cmp = opts.cmp, get_key = opts.get_key, get_pri = opts.get_pri, set_pri = opts.set_pri;
      if (cmp != null) {
        this._cmp = cmp;
      }
      if (typeof key !== "undefined" && key !== null) {
        this._get_key = key;
      }
      if (set_pri != null) {
        this._set_pri = set_pri;
      }
      if (get_pri != null) {
        this._get_pri = get_pri;
      }
      this._elements = [];
      this._index = {};
    }

    PriorityQueue.prototype.is_empty = function() {
      return this.size() === 0;
    };

    PriorityQueue.prototype.size = function() {
      return this._elements.length;
    };

    PriorityQueue.prototype.peek = function() {
      if (this.is_empty()) {
        throw new Error("PriorityQueue is empty");
      }
      return this._elements[0];
    };

    PriorityQueue.prototype._lchild = function(i) {
      return 2 * i + 1;
    };

    PriorityQueue.prototype._rchild = function(i) {
      return 2 * i + 2;
    };

    PriorityQueue.prototype._parent = function(i) {
      return (i - 1) >> 1;
    };

    PriorityQueue.prototype._i_cmp = function(i, j) {
      return this._cmp(this._i_get_pri(i), this._i_get_pri(j));
    };

    PriorityQueue.prototype._i_get_key = function(i) {
      return this._get_key(this._elements[i]);
    };

    PriorityQueue.prototype._i_get_pri = function(i) {
      return this._get_pri(this._elements[i]);
    };

    PriorityQueue.prototype._i_set_pri = function(i, v) {
      return this._set_pri(this._elements[i], v);
    };

    PriorityQueue.prototype._indexify = function(i) {
      return this._index[this._i_get_key(i)] = i;
    };

    PriorityQueue.prototype._set = function(i, val) {
      this._elements[i] = val;
      return this._indexify(i);
    };

    PriorityQueue.prototype._swap = function(i, j) {
      var tmp;
      tmp = this._elements[i];
      this._set(i, this._elements[j]);
      this._set(j, tmp);
      return i;
    };

    PriorityQueue.prototype._bubble_up = function(c) {
      var p;
      while ((c > 0) && this._i_cmp((p = this._parent(c)), c) > 0) {
        c = this._swap(p, c);
      }
      return true;
    };

    PriorityQueue.prototype._bubble_down = function(c) {
      var l, min, r, size, _results;
      size = this.size();
      _results = [];
      while ((0 <= c && c < size)) {
        min = c;
        if ((l = this._lchild(c)) < size && this._i_cmp(l, min) < 0) {
          min = l;
        }
        if ((r = this._rchild(c)) < size && this._i_cmp(r, min) < 0) {
          min = r;
        }
        if (min === c) {
          _results.push(c = -1);
        } else {
          _results.push(c = this._swap(min, c));
        }
      }
      return _results;
    };

    PriorityQueue.prototype.deq = function() {
      var first, last;
      first = this.peek();
      last = this._elements.pop();
      delete this._index[this._get_key(first)];
      if (!this.is_empty()) {
        this._set(0, last);
        this._bubble_down(0);
      }
      return first;
    };

    PriorityQueue.prototype.enq = function(el) {
      var current, size;
      size = this._elements.push(el);
      current = size - 1;
      this._indexify(current);
      this._bubble_up(current);
      return size;
    };

    PriorityQueue.prototype.lookup = function(key) {
      return this._elements[this._index[key]];
    };

    PriorityQueue.prototype.check = function() {
      return this._check(0);
    };

    PriorityQueue.prototype._check = function(i) {
      var l, r;
      l = this._lchild(i);
      r = this._rchild(i);
      if (l < this.size()) {
        if ((this._i_cmp(i, l)) > 0) {
          throw new Error("misordering at " + i + " v " + l);
        }
        this._check(l);
      }
      if (r < this.size()) {
        if ((this._i_cmp(i, r)) > 0) {
          throw new Error("misordering at " + i + " v " + r);
        }
        return this._check(r);
      }
    };

    PriorityQueue.prototype.change_key = function(key, val) {
      var c, cmp;
      if ((c = this._index[key]) != null) {
        cmp = this._cmp(val, this._i_get_pri(c));
        this._i_set_pri(c, val);
        if (cmp > 0) {
          this._bubble_down(c);
        } else {
          this._bubble_up(c);
        }
        return true;
      } else {
        return false;
      }
    };

    return PriorityQueue;

  })();

}).call(this);


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(413);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._81 = 1;
  p._65 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._81 === 3) {
            val = val._65;
          }
          if (val._81 === 1) return res(i, val._65);
          if (val._81 === 2) reject(val._65);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(413);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._10 = null;
  Promise._97 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._10 = function (promise) {
    if (
      promise._81 === 2 && // IS REJECTED
      rejections[promise._72]
    ) {
      if (rejections[promise._72].logged) {
        onHandled(promise._72);
      } else {
        clearTimeout(rejections[promise._72].timeout);
      }
      delete rejections[promise._72];
    }
  };
  Promise._97 = function (promise, err) {
    if (promise._45 === 0) { // not yet handled
      promise._72 = id++;
      rejections[promise._72] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._72),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(29);
var invariant = __webpack_require__(3);
var ReactPropTypesSecret = __webpack_require__(415);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(29);
var invariant = __webpack_require__(3);
var warning = __webpack_require__(6);

var ReactPropTypesSecret = __webpack_require__(415);
var checkPropTypes = __webpack_require__(902);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(14);

var focusNode = __webpack_require__(337);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(119);
var ExecutionEnvironment = __webpack_require__(23);
var FallbackCompositionState = __webpack_require__(913);
var SyntheticCompositionEvent = __webpack_require__(950);
var SyntheticInputEvent = __webpack_require__(953);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(416);
var ExecutionEnvironment = __webpack_require__(23);
var ReactInstrumentation = __webpack_require__(36);

var camelizeStyleName = __webpack_require__(716);
var dangerousStyleValue = __webpack_require__(959);
var hyphenateStyleName = __webpack_require__(723);
var memoizeStringOnly = __webpack_require__(726);
var warning = __webpack_require__(6);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(118);
var EventPropagators = __webpack_require__(119);
var ExecutionEnvironment = __webpack_require__(23);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactUpdates = __webpack_require__(46);
var SyntheticEvent = __webpack_require__(51);

var inputValueTracking = __webpack_require__(432);
var getEventTarget = __webpack_require__(247);
var isEventSupported = __webpack_require__(248);
var isTextInputElement = __webpack_require__(434);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var DOMLazyTree = __webpack_require__(91);
var ExecutionEnvironment = __webpack_require__(23);

var createNodesFromMarkup = __webpack_require__(719);
var emptyFunction = __webpack_require__(29);
var invariant = __webpack_require__(3);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(119);
var ReactDOMComponentTree = __webpack_require__(14);
var SyntheticMouseEvent = __webpack_require__(152);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(12);

var PooledClass = __webpack_require__(75);

var getTextContentAccessor = __webpack_require__(431);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(92);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactReconciler = __webpack_require__(93);

var instantiateReactComponent = __webpack_require__(433);
var KeyEscapeUtils = __webpack_require__(239);
var shouldUpdateReactComponent = __webpack_require__(249);
var traverseAllChildren = __webpack_require__(436);
var warning = __webpack_require__(6);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":"/sven"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(443);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(234)))

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(235);
var ReactDOMIDOperations = __webpack_require__(923);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(12);

var React = __webpack_require__(94);
var ReactComponentEnvironment = __webpack_require__(241);
var ReactCurrentOwner = __webpack_require__(52);
var ReactErrorUtils = __webpack_require__(242);
var ReactInstanceMap = __webpack_require__(120);
var ReactInstrumentation = __webpack_require__(36);
var ReactNodeTypes = __webpack_require__(426);
var ReactReconciler = __webpack_require__(93);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(143);
var invariant = __webpack_require__(3);
var shallowEqual = __webpack_require__(113);
var shouldUpdateReactComponent = __webpack_require__(249);
var warning = __webpack_require__(6);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(14);
var ReactDefaultInjection = __webpack_require__(931);
var ReactMount = __webpack_require__(425);
var ReactReconciler = __webpack_require__(93);
var ReactUpdates = __webpack_require__(46);
var ReactVersion = __webpack_require__(944);

var findDOMNode = __webpack_require__(960);
var getHostComponentFromComposite = __webpack_require__(430);
var renderSubtreeIntoContainer = __webpack_require__(967);
var warning = __webpack_require__(6);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(12);

var AutoFocusUtils = __webpack_require__(906);
var CSSPropertyOperations = __webpack_require__(908);
var DOMLazyTree = __webpack_require__(91);
var DOMNamespaces = __webpack_require__(236);
var DOMProperty = __webpack_require__(92);
var DOMPropertyOperations = __webpack_require__(418);
var EventPluginHub = __webpack_require__(118);
var EventPluginRegistry = __webpack_require__(237);
var ReactBrowserEventEmitter = __webpack_require__(151);
var ReactDOMComponentFlags = __webpack_require__(419);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactDOMInput = __webpack_require__(924);
var ReactDOMOption = __webpack_require__(925);
var ReactDOMSelect = __webpack_require__(420);
var ReactDOMTextarea = __webpack_require__(928);
var ReactInstrumentation = __webpack_require__(36);
var ReactMultiChild = __webpack_require__(937);
var ReactServerRenderingTransaction = __webpack_require__(942);

var emptyFunction = __webpack_require__(29);
var escapeTextContentForBrowser = __webpack_require__(154);
var invariant = __webpack_require__(3);
var isEventSupported = __webpack_require__(248);
var shallowEqual = __webpack_require__(113);
var inputValueTracking = __webpack_require__(432);
var validateDOMNesting = __webpack_require__(250);
var warning = __webpack_require__(6);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var validateDOMNesting = __webpack_require__(250);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(12);

var DOMLazyTree = __webpack_require__(91);
var ReactDOMComponentTree = __webpack_require__(14);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(235);
var ReactDOMComponentTree = __webpack_require__(14);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(12);

var DOMPropertyOperations = __webpack_require__(418);
var LinkedValueUtils = __webpack_require__(240);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactUpdates = __webpack_require__(46);

var invariant = __webpack_require__(3);
var warning = __webpack_require__(6);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(12);

var React = __webpack_require__(94);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactDOMSelect = __webpack_require__(420);

var warning = __webpack_require__(6);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(23);

var getNodeForCharacterOffset = __webpack_require__(964);
var getTextContentAccessor = __webpack_require__(431);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(12);

var DOMChildrenOperations = __webpack_require__(235);
var DOMLazyTree = __webpack_require__(91);
var ReactDOMComponentTree = __webpack_require__(14);

var escapeTextContentForBrowser = __webpack_require__(154);
var invariant = __webpack_require__(3);
var validateDOMNesting = __webpack_require__(250);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7),
    _assign = __webpack_require__(12);

var LinkedValueUtils = __webpack_require__(240);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactUpdates = __webpack_require__(46);

var invariant = __webpack_require__(3);
var warning = __webpack_require__(6);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(3);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(12);

var ReactUpdates = __webpack_require__(46);
var Transaction = __webpack_require__(153);

var emptyFunction = __webpack_require__(29);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(905);
var BeforeInputEventPlugin = __webpack_require__(907);
var ChangeEventPlugin = __webpack_require__(909);
var DefaultEventPluginOrder = __webpack_require__(911);
var EnterLeaveEventPlugin = __webpack_require__(912);
var HTMLDOMPropertyConfig = __webpack_require__(914);
var ReactComponentBrowserEnvironment = __webpack_require__(916);
var ReactDOMComponent = __webpack_require__(919);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactDOMEmptyComponent = __webpack_require__(921);
var ReactDOMTreeTraversal = __webpack_require__(929);
var ReactDOMTextComponent = __webpack_require__(927);
var ReactDefaultBatchingStrategy = __webpack_require__(930);
var ReactEventListener = __webpack_require__(934);
var ReactInjection = __webpack_require__(935);
var ReactReconcileTransaction = __webpack_require__(940);
var SVGDOMPropertyConfig = __webpack_require__(945);
var SelectEventPlugin = __webpack_require__(946);
var SimpleEventPlugin = __webpack_require__(947);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(118);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(12);

var EventListener = __webpack_require__(336);
var ExecutionEnvironment = __webpack_require__(23);
var PooledClass = __webpack_require__(75);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactUpdates = __webpack_require__(46);

var getEventTarget = __webpack_require__(247);
var getUnboundedScrollPosition = __webpack_require__(721);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(92);
var EventPluginHub = __webpack_require__(118);
var EventPluginUtils = __webpack_require__(238);
var ReactComponentEnvironment = __webpack_require__(241);
var ReactEmptyComponent = __webpack_require__(421);
var ReactBrowserEventEmitter = __webpack_require__(151);
var ReactHostComponent = __webpack_require__(423);
var ReactUpdates = __webpack_require__(46);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var adler32 = __webpack_require__(958);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var ReactComponentEnvironment = __webpack_require__(241);
var ReactInstanceMap = __webpack_require__(120);
var ReactInstrumentation = __webpack_require__(36);

var ReactCurrentOwner = __webpack_require__(52);
var ReactReconciler = __webpack_require__(93);
var ReactChildReconciler = __webpack_require__(915);

var emptyFunction = __webpack_require__(29);
var flattenChildren = __webpack_require__(961);
var invariant = __webpack_require__(3);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var invariant = __webpack_require__(3);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(12);

var CallbackQueue = __webpack_require__(417);
var PooledClass = __webpack_require__(75);
var ReactBrowserEventEmitter = __webpack_require__(151);
var ReactInputSelection = __webpack_require__(424);
var ReactInstrumentation = __webpack_require__(36);
var Transaction = __webpack_require__(153);
var ReactUpdateQueue = __webpack_require__(243);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactOwner = __webpack_require__(938);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(12);

var PooledClass = __webpack_require__(75);
var Transaction = __webpack_require__(153);
var ReactInstrumentation = __webpack_require__(36);
var ReactServerUpdateQueue = __webpack_require__(943);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(243);

var warning = __webpack_require__(6);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(119);
var ExecutionEnvironment = __webpack_require__(23);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactInputSelection = __webpack_require__(424);
var SyntheticEvent = __webpack_require__(51);

var getActiveElement = __webpack_require__(338);
var isTextInputElement = __webpack_require__(434);
var shallowEqual = __webpack_require__(113);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(7);

var EventListener = __webpack_require__(336);
var EventPropagators = __webpack_require__(119);
var ReactDOMComponentTree = __webpack_require__(14);
var SyntheticAnimationEvent = __webpack_require__(948);
var SyntheticClipboardEvent = __webpack_require__(949);
var SyntheticEvent = __webpack_require__(51);
var SyntheticFocusEvent = __webpack_require__(952);
var SyntheticKeyboardEvent = __webpack_require__(954);
var SyntheticMouseEvent = __webpack_require__(152);
var SyntheticDragEvent = __webpack_require__(951);
var SyntheticTouchEvent = __webpack_require__(955);
var SyntheticTransitionEvent = __webpack_require__(956);
var SyntheticUIEvent = __webpack_require__(121);
var SyntheticWheelEvent = __webpack_require__(957);

var emptyFunction = __webpack_require__(29);
var getEventCharCode = __webpack_require__(245);
var invariant = __webpack_require__(3);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(51);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(51);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(51);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(152);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(121);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(51);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(121);

var getEventCharCode = __webpack_require__(245);
var getEventKey = __webpack_require__(962);
var getEventModifierState = __webpack_require__(246);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(121);

var getEventModifierState = __webpack_require__(246);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(51);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(152);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(416);
var warning = __webpack_require__(6);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(7);

var ReactCurrentOwner = __webpack_require__(52);
var ReactDOMComponentTree = __webpack_require__(14);
var ReactInstanceMap = __webpack_require__(120);

var getHostComponentFromComposite = __webpack_require__(430);
var invariant = __webpack_require__(3);
var warning = __webpack_require__(6);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(239);
var traverseAllChildren = __webpack_require__(436);
var warning = __webpack_require__(6);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":"/sven"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(443);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(234)))

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var getEventCharCode = __webpack_require__(245);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(23);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(154);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactMount = __webpack_require__(425);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(158);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

exports.default = defineProperty;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  weak

function defineProperty(o, p, attr) {
  return (0, _defineProperty2.default)(o, p, attr);
}

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(37);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(38);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(39);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(41);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(40);

var _inherits3 = _interopRequireDefault(_inherits2);

var _typeof2 = __webpack_require__(124);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(53);

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _assign = __webpack_require__(253);

var _assign2 = _interopRequireDefault(_assign);

exports.withOptions = withOptions;

var _react = __webpack_require__(1);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _shallowEqual = __webpack_require__(113);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _warning = __webpack_require__(17);

var _warning2 = _interopRequireDefault(_warning);

var _supports = __webpack_require__(970);

var supports = _interopRequireWildcard(_supports);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultEventOptions = {
  capture: false,
  passive: false
};
/* eslint-disable prefer-spread */

function mergeDefaultEventOptions(options) {
  return (0, _assign2.default)({}, defaultEventOptions, options);
}

function getEventListenerArgs(eventName, callback, options) {
  var args = [eventName, callback];
  args.push(supports.passiveOption ? options : options.capture);
  return args;
}

function on(target, eventName, callback, options) {
  if (supports.addEventListener) {
    target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
  } else if (supports.attachEvent) {
    // IE8+ Support
    target.attachEvent('on' + eventName, function () {
      callback.call(target);
    });
  }
}

function off(target, eventName, callback, options) {
  if (supports.removeEventListener) {
    target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
  } else if (supports.detachEvent) {
    // IE8+ Support
    target.detachEvent('on' + eventName, callback);
  }
}

function forEachListener(props, iteratee) {
  var children = props.children,
      target = props.target,
      eventProps = (0, _objectWithoutProperties3.default)(props, ['children', 'target']);


  (0, _keys2.default)(eventProps).forEach(function (name) {
    if (name.substring(0, 2) !== 'on') {
      return;
    }

    var prop = eventProps[name];
    var type = typeof prop === 'undefined' ? 'undefined' : (0, _typeof3.default)(prop);
    var isObject = type === 'object';
    var isFunction = type === 'function';

    if (!isObject && !isFunction) {
      return;
    }

    var capture = name.substr(-7).toLowerCase() === 'capture';
    var eventName = name.substring(2).toLowerCase();
    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;

    if (isObject) {
      iteratee(eventName, prop.handler, prop.options);
    } else {
      iteratee(eventName, prop, mergeDefaultEventOptions({ capture: capture }));
    }
  });
}

function withOptions(handler, options) {
   false ? (0, _warning2.default)(options, 'react-event-listener: Should be specified options in withOptions.') : void 0;

  return {
    handler: handler,
    options: mergeDefaultEventOptions(options)
  };
}

var EventListener = function (_Component) {
  (0, _inherits3.default)(EventListener, _Component);

  function EventListener() {
    (0, _classCallCheck3.default)(this, EventListener);
    return (0, _possibleConstructorReturn3.default)(this, (EventListener.__proto__ || (0, _getPrototypeOf2.default)(EventListener)).apply(this, arguments));
  }

  (0, _createClass3.default)(EventListener, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.addListeners();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _shallowEqual2.default)(this.props, nextProps);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {
      this.removeListeners();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.addListeners();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeListeners();
    }
  }, {
    key: 'addListeners',
    value: function addListeners() {
      this.applyListeners(on);
    }
  }, {
    key: 'removeListeners',
    value: function removeListeners() {
      this.applyListeners(off);
    }
  }, {
    key: 'applyListeners',
    value: function applyListeners(onOrOff) {
      var target = this.props.target;


      if (target) {
        var element = target;

        if (typeof target === 'string') {
          element = window[target];
        }

        forEachListener(this.props, onOrOff.bind(null, element));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children || null;
    }
  }]);
  return EventListener;
}(_react.Component);

EventListener.propTypes =  false ? {
  /**
   * You can provide a single child too.
   */
  children: _propTypes2.default.element,
  /**
   * The DOM target to listen to.
   */
  target: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired
} : {};
exports.default = EventListener;

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.passiveOption = exports.detachEvent = exports.attachEvent = exports.removeEventListener = exports.addEventListener = exports.canUseDOM = undefined;

var _defineProperty = __webpack_require__(968);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Inspired by https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/ExecutionEnvironment.js
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = canUseDOM && 'addEventListener' in window;
var removeEventListener = exports.removeEventListener = canUseDOM && 'removeEventListener' in window;

// IE8+ Support
var attachEvent = exports.attachEvent = canUseDOM && 'attachEvent' in window;
var detachEvent = exports.detachEvent = canUseDOM && 'detachEvent' in window;

// Passive options
// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js
var passiveOption = exports.passiveOption = function () {
  var cache = null;

  return function () {
    if (cache !== null) {
      return cache;
    }

    var supportsPassiveOption = false;

    try {
      window.addEventListener('test', null, (0, _defineProperty2.default)({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      }));
    } catch (e) {} // eslint-disable-line no-empty

    cache = supportsPassiveOption;

    return supportsPassiveOption;
  }();
}();

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(0);
var createClass = __webpack_require__(564);

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var AutosizeInput = createClass({
	propTypes: {
		className: PropTypes.string, // className for the outer element
		defaultValue: PropTypes.any, // default field value
		inputClassName: PropTypes.string, // className for the input element
		inputRef: PropTypes.func, // ref callback for the input element
		inputStyle: PropTypes.object, // css styles for the input element
		minWidth: PropTypes.oneOfType([// minimum width for input element
		PropTypes.number, PropTypes.string]),
		onAutosize: PropTypes.func, // onAutosize handler: function(newWidth) {}
		onChange: PropTypes.func, // onChange handler: function(newValue) {}
		placeholder: PropTypes.string, // placeholder text
		placeholderIsMinWidth: PropTypes.bool, // don't collapse size to less than the placeholder
		style: PropTypes.object, // css styles for the outer element
		value: PropTypes.any },
	// field value
	getDefaultProps: function getDefaultProps() {
		return {
			minWidth: 1
		};
	},
	getInitialState: function getInitialState() {
		return {
			inputWidth: this.props.minWidth,
			inputId: '_' + Math.random().toString(36).substr(2, 12)
		};
	},
	componentDidMount: function componentDidMount() {
		this.mounted = true;
		this.copyInputStyles();
		this.updateInputWidth();
	},
	componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
		if (prevState.inputWidth !== this.state.inputWidth) {
			if (typeof this.props.onAutosize === 'function') {
				this.props.onAutosize(this.state.inputWidth);
			}
		}
		this.updateInputWidth();
	},
	componentWillUnmount: function componentWillUnmount() {
		this.mounted = false;
	},
	inputRef: function inputRef(el) {
		this.input = el;
		if (typeof this.props.inputRef === 'function') {
			this.props.inputRef(el);
		}
	},
	placeHolderSizerRef: function placeHolderSizerRef(el) {
		this.placeHolderSizer = el;
	},
	sizerRef: function sizerRef(el) {
		this.sizer = el;
	},
	copyInputStyles: function copyInputStyles() {
		if (!this.mounted || !window.getComputedStyle) {
			return;
		}
		var inputStyle = this.input && window.getComputedStyle(this.input);
		if (!inputStyle) {
			return;
		}
		var widthNode = this.sizer;
		widthNode.style.fontSize = inputStyle.fontSize;
		widthNode.style.fontFamily = inputStyle.fontFamily;
		widthNode.style.fontWeight = inputStyle.fontWeight;
		widthNode.style.fontStyle = inputStyle.fontStyle;
		widthNode.style.letterSpacing = inputStyle.letterSpacing;
		widthNode.style.textTransform = inputStyle.textTransform;
		if (this.props.placeholder) {
			var placeholderNode = this.placeHolderSizer;
			placeholderNode.style.fontSize = inputStyle.fontSize;
			placeholderNode.style.fontFamily = inputStyle.fontFamily;
			placeholderNode.style.fontWeight = inputStyle.fontWeight;
			placeholderNode.style.fontStyle = inputStyle.fontStyle;
			placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
			placeholderNode.style.textTransform = inputStyle.textTransform;
		}
	},
	updateInputWidth: function updateInputWidth() {
		if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
			return;
		}
		var newInputWidth = undefined;
		if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
			newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
		} else {
			newInputWidth = this.sizer.scrollWidth + 2;
		}
		if (newInputWidth < this.props.minWidth) {
			newInputWidth = this.props.minWidth;
		}
		if (newInputWidth !== this.state.inputWidth) {
			this.setState({
				inputWidth: newInputWidth
			});
		}
	},
	getInput: function getInput() {
		return this.input;
	},
	focus: function focus() {
		this.input.focus();
	},
	blur: function blur() {
		this.input.blur();
	},
	select: function select() {
		this.input.select();
	},
	render: function render() {
		var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
			if (previousValue !== null && previousValue !== undefined) {
				return previousValue;
			}
			return currentValue;
		});

		var wrapperStyle = this.props.style || {};
		if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
		var inputStyle = _extends({}, this.props.inputStyle);
		inputStyle.width = this.state.inputWidth + 'px';
		inputStyle.boxSizing = 'content-box';
		var inputProps = _extends({}, this.props);
		inputProps.className = this.props.inputClassName;
		inputProps.style = inputStyle;
		// ensure props meant for `AutosizeInput` don't end up on the `input`
		delete inputProps.inputClassName;
		delete inputProps.inputStyle;
		delete inputProps.minWidth;
		delete inputProps.onAutosize;
		delete inputProps.placeholderIsMinWidth;
		delete inputProps.inputRef;
		return React.createElement(
			'div',
			{ className: this.props.className, style: wrapperStyle },
			React.createElement('style', { dangerouslySetInnerHTML: {
					__html: ['input#' + this.state.id + '::-ms-clear {display: none;}'].join('\n')
				} }),
			React.createElement('input', _extends({ id: this.state.id }, inputProps, { ref: this.inputRef })),
			React.createElement(
				'div',
				{ ref: this.sizerRef, style: sizerStyle },
				sizerValue
			),
			this.props.placeholder ? React.createElement(
				'div',
				{ ref: this.placeHolderSizerRef, style: sizerStyle },
				this.props.placeholder
			) : null
		);
	}
});

module.exports = AutosizeInput;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ns$jss$ns$sheetOptio;

var _propTypes = __webpack_require__(0);

var _jss = __webpack_require__(437);

var _jss2 = _interopRequireDefault(_jss);

var _ns = __webpack_require__(438);

var ns = _interopRequireWildcard(_ns);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports['default'] = (_ns$jss$ns$sheetOptio = {}, _defineProperty(_ns$jss$ns$sheetOptio, ns.jss, (0, _propTypes.instanceOf)(_jss2['default'].constructor)), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetOptions, _propTypes.object), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetsRegistry, (0, _propTypes.instanceOf)(_jss.SheetsRegistry)), _defineProperty(_ns$jss$ns$sheetOptio, ns.providerId, _propTypes.number), _ns$jss$ns$sheetOptio);

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(156);

var _Select2 = _interopRequireDefault(_Select);

var _stripDiacritics = __webpack_require__(441);

var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
	autoload: _react2.default.PropTypes.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: _react2.default.PropTypes.any, // object to use to cache results; set to null/false to disable caching
	children: _react2.default.PropTypes.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: _react2.default.PropTypes.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: _react2.default.PropTypes.bool, // perform case-insensitive filtering; defaults to true
	loadingPlaceholder: _react2.default.PropTypes.oneOfType([// replaces the placeholder while options are loading
	_react2.default.PropTypes.string, _react2.default.PropTypes.node]),
	loadOptions: _react2.default.PropTypes.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	multi: _react2.default.PropTypes.bool, // multi-value input
	options: _react.PropTypes.array.isRequired, // array of options
	placeholder: _react2.default.PropTypes.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	_react2.default.PropTypes.string, _react2.default.PropTypes.node]),
	noResultsText: _react2.default.PropTypes.oneOfType([// field noResultsText, displayed when no options come back from the server
	_react2.default.PropTypes.string, _react2.default.PropTypes.node]),
	onChange: _react2.default.PropTypes.func, // onChange handler: function (newValue) {}
	searchPromptText: _react2.default.PropTypes.oneOfType([// label to prompt for search input
	_react2.default.PropTypes.string, _react2.default.PropTypes.node]),
	onInputChange: _react2.default.PropTypes.func, // optional for keeping track of what is being typed
	value: _react2.default.PropTypes.any };

var defaultCache = {};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	_inherits(Async, _Component);

	function Async(props, context) {
		_classCallCheck(this, Async);

		var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			isLoading: false,
			options: props.options
		};

		_this._onInputChange = _this._onInputChange.bind(_this);
		return _this;
	}

	_createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillUpdate',
		value: function componentWillUpdate(nextProps, nextState) {
			var _this2 = this;

			var propertiesToSync = ['options'];
			propertiesToSync.forEach(function (prop) {
				if (_this2.props[prop] !== nextProps[prop]) {
					_this2.setState(_defineProperty({}, prop, nextProps[prop]));
				}
			});
		}
	}, {
		key: 'clearOptions',
		value: function clearOptions() {
			this.setState({ options: [] });
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this3 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && cache.hasOwnProperty(inputValue)) {
				this.setState({
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				if (callback === _this3._callback) {
					_this3._callback = null;

					var options = data && data.options || [];

					if (cache) {
						cache[inputValue] = options;
					}

					_this3.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}

			return inputValue;
		}
	}, {
		key: '_onInputChange',
		value: function _onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;


			if (ignoreAccents) {
				inputValue = (0, _stripDiacritics2.default)(inputValue);
			}

			if (ignoreCase) {
				inputValue = inputValue.toLowerCase();
			}

			if (onInputChange) {
				onInputChange(inputValue);
			}

			return this.loadOptions(inputValue);
		}
	}, {
		key: 'inputValue',
		value: function inputValue() {
			if (this.select) {
				return this.select.state.inputValue;
			}
			return '';
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var isLoading = this.state.isLoading;


			var inputValue = this.inputValue();

			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this4 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    placeholder = _props3.placeholder;
			var _state = this.state,
			    isLoading = _state.isLoading,
			    options = _state.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this4.select = _ref;
				},
				onChange: function onChange(newValues) {
					if (_this4.props.multi && _this4.props.value && newValues.length > _this4.props.value.length) {
						_this4.clearOptions();
					}
					_this4.props.onChange(newValues);
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this._onInputChange
			}));
		}
	}]);

	return Async;
}(_react.Component);

exports.default = Async;


Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

function defaultChildren(props) {
	return _react2.default.createElement(_Select2.default, props);
};
module.exports = exports['default'];

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(156);

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reduce(obj) {
	var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	return Object.keys(obj).reduce(function (props, key) {
		var value = obj[key];
		if (value !== undefined) props[key] = value;
		return props;
	}, props);
}

var AsyncCreatable = _react2.default.createClass({
	displayName: 'AsyncCreatableSelect',

	focus: function focus() {
		this.select.focus();
	},
	render: function render() {
		var _this = this;

		return _react2.default.createElement(
			_Select2.default.Async,
			this.props,
			function (asyncProps) {
				return _react2.default.createElement(
					_Select2.default.Creatable,
					_this.props,
					function (creatableProps) {
						return _react2.default.createElement(_Select2.default, _extends({}, reduce(asyncProps, reduce(creatableProps, {})), {
							onInputChange: function onInputChange(input) {
								creatableProps.onInputChange(input);
								return asyncProps.onInputChange(input);
							},
							ref: function ref(_ref) {
								_this.select = _ref;
								creatableProps.ref(_ref);
								asyncProps.ref(_ref);
							}
						}));
					}
				);
			}
		);
	}
});

module.exports = AsyncCreatable;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(156);

var _Select2 = _interopRequireDefault(_Select);

var _defaultFilterOptions = __webpack_require__(439);

var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);

var _defaultMenuRenderer = __webpack_require__(440);

var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Creatable = _react2.default.createClass({
  displayName: 'CreatableSelect',

  propTypes: {
    // Child function responsible for creating the inner Select component
    // This component can be used to compose HOCs (eg Creatable and Async)
    // (props: Object): PropTypes.element
    children: _react2.default.PropTypes.func,

    // See Select.propTypes.filterOptions
    filterOptions: _react2.default.PropTypes.any,

    // Searches for any matching option within the set of options.
    // This function prevents duplicate options from being created.
    // ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
    isOptionUnique: _react2.default.PropTypes.func,

    // Determines if the current input text represents a valid option.
    // ({ label: string }): boolean
    isValidNewOption: _react2.default.PropTypes.func,

    // See Select.propTypes.menuRenderer
    menuRenderer: _react2.default.PropTypes.any,

    // Factory to create new option.
    // ({ label: string, labelKey: string, valueKey: string }): Object
    newOptionCreator: _react2.default.PropTypes.func,

    // input change handler: function (inputValue) {}
    onInputChange: _react2.default.PropTypes.func,

    // input keyDown handler: function (event) {}
    onInputKeyDown: _react2.default.PropTypes.func,

    // new option click handler: function (option) {}
    onNewOptionClick: _react2.default.PropTypes.func,

    // See Select.propTypes.options
    options: _react2.default.PropTypes.array,

    // Creates prompt/placeholder option text.
    // (filterText: string): string
    promptTextCreator: _react2.default.PropTypes.func,

    // Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
    shouldKeyDownEventCreateNewOption: _react2.default.PropTypes.func,
    showNewOptionAtTop: _react2.default.PropTypes.bool
  },

  // Default prop methods
  statics: {
    isOptionUnique: isOptionUnique,
    isValidNewOption: isValidNewOption,
    newOptionCreator: newOptionCreator,
    promptTextCreator: promptTextCreator,
    shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
  },

  getDefaultProps: function getDefaultProps() {
    return {
      filterOptions: _defaultFilterOptions2.default,
      isOptionUnique: isOptionUnique,
      isValidNewOption: isValidNewOption,
      menuRenderer: _defaultMenuRenderer2.default,
      newOptionCreator: newOptionCreator,
      promptTextCreator: promptTextCreator,
      showNewOptionAtTop: true,
      shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
    };
  },
  createNewOption: function createNewOption() {
    var _props = this.props,
        isValidNewOption = _props.isValidNewOption,
        newOptionCreator = _props.newOptionCreator,
        onNewOptionClick = _props.onNewOptionClick,
        _props$options = _props.options,
        options = _props$options === undefined ? [] : _props$options,
        shouldKeyDownEventCreateNewOption = _props.shouldKeyDownEventCreateNewOption;


    if (isValidNewOption({ label: this.inputValue })) {
      var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
      var _isOptionUnique = this.isOptionUnique({ option: option });

      // Don't add the same option twice.
      if (_isOptionUnique) {
        if (onNewOptionClick) {
          onNewOptionClick(option);
        } else {
          options.unshift(option);

          this.select.selectValue(option);
        }
      }
    }
  },
  filterOptions: function filterOptions() {
    var _props2 = this.props,
        filterOptions = _props2.filterOptions,
        isValidNewOption = _props2.isValidNewOption,
        options = _props2.options,
        promptTextCreator = _props2.promptTextCreator,
        showNewOptionAtTop = _props2.showNewOptionAtTop;

    // TRICKY Check currently selected options as well.
    // Don't display a create-prompt for a value that's selected.
    // This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

    var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

    var filteredOptions = filterOptions.apply(undefined, arguments) || [];

    if (isValidNewOption({ label: this.inputValue })) {
      var _newOptionCreator = this.props.newOptionCreator;


      var option = _newOptionCreator({
        label: this.inputValue,
        labelKey: this.labelKey,
        valueKey: this.valueKey
      });

      // TRICKY Compare to all options (not just filtered options) in case option has already been selected).
      // For multi-selects, this would remove it from the filtered list.
      var _isOptionUnique2 = this.isOptionUnique({
        option: option,
        options: excludeOptions.concat(filteredOptions)
      });

      if (_isOptionUnique2) {
        var prompt = promptTextCreator(this.inputValue);

        this._createPlaceholderOption = _newOptionCreator({
          label: prompt,
          labelKey: this.labelKey,
          valueKey: this.valueKey
        });

        if (showNewOptionAtTop) {
          filteredOptions.unshift(this._createPlaceholderOption);
        } else {
          filteredOptions.push(this._createPlaceholderOption);
        }
      }
    }

    return filteredOptions;
  },
  isOptionUnique: function isOptionUnique(_ref) {
    var option = _ref.option,
        options = _ref.options;
    var isOptionUnique = this.props.isOptionUnique;


    options = options || this.select.filterOptions();

    return isOptionUnique({
      labelKey: this.labelKey,
      option: option,
      options: options,
      valueKey: this.valueKey
    });
  },
  menuRenderer: function menuRenderer(params) {
    var menuRenderer = this.props.menuRenderer;


    return menuRenderer(_extends({}, params, {
      onSelect: this.onOptionSelect,
      selectValue: this.onOptionSelect
    }));
  },
  onInputChange: function onInputChange(inputValue) {
    var onInputChange = this.props.onInputChange;


    if (onInputChange) {
      inputValue = onInputChange(inputValue) || '';
    }

    // This value may be needed in between Select mounts (when this.select is null)
    this.inputValue = inputValue;
    return inputValue;
  },
  onInputKeyDown: function onInputKeyDown(event) {
    var _props3 = this.props,
        shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
        onInputKeyDown = _props3.onInputKeyDown;

    var focusedOption = this.select.getFocusedOption();

    if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
      this.createNewOption();

      // Prevent decorated Select from doing anything additional with this keyDown event
      event.preventDefault();
    } else if (onInputKeyDown) {
      onInputKeyDown(event);
    }
  },
  onOptionSelect: function onOptionSelect(option, event) {
    if (option === this._createPlaceholderOption) {
      this.createNewOption();
    } else {
      this.select.selectValue(option);
    }
  },
  focus: function focus() {
    this.select.focus();
  },
  render: function render() {
    var _this = this;

    var _props4 = this.props,
        newOptionCreator = _props4.newOptionCreator,
        shouldKeyDownEventCreateNewOption = _props4.shouldKeyDownEventCreateNewOption,
        refProp = _props4.refProp,
        restProps = _objectWithoutProperties(_props4, ['newOptionCreator', 'shouldKeyDownEventCreateNewOption', 'refProp']);

    var children = this.props.children;

    // We can't use destructuring default values to set the children,
    // because it won't apply work if `children` is null. A falsy check is
    // more reliable in real world use-cases.

    if (!children) {
      children = defaultChildren;
    }

    var props = _extends({}, restProps, {
      allowCreate: true,
      filterOptions: this.filterOptions,
      menuRenderer: this.menuRenderer,
      onInputChange: this.onInputChange,
      onInputKeyDown: this.onInputKeyDown,
      ref: function ref(_ref2) {
        _this.select = _ref2;

        // These values may be needed in between Select mounts (when this.select is null)
        if (_ref2) {
          _this.labelKey = _ref2.props.labelKey;
          _this.valueKey = _ref2.props.valueKey;
        }
        if (refProp) {
          refProp(_ref2);
        }
      }
    });

    return children(props);
  }
});

function defaultChildren(props) {
  return _react2.default.createElement(_Select2.default, props);
};

function isOptionUnique(_ref3) {
  var option = _ref3.option,
      options = _ref3.options,
      labelKey = _ref3.labelKey,
      valueKey = _ref3.valueKey;

  return options.filter(function (existingOption) {
    return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
  }).length === 0;
};

function isValidNewOption(_ref4) {
  var label = _ref4.label;

  return !!label;
};

function newOptionCreator(_ref5) {
  var label = _ref5.label,
      labelKey = _ref5.labelKey,
      valueKey = _ref5.valueKey;

  var option = {};
  option[valueKey] = label;
  option[labelKey] = label;
  option.className = 'Select-create-option-placeholder';
  return option;
};

function promptTextCreator(label) {
  return 'Create option "' + label + '"';
}

function shouldKeyDownEventCreateNewOption(_ref6) {
  var keyCode = _ref6.keyCode;

  switch (keyCode) {
    case 9: // TAB
    case 13: // ENTER
    case 188:
      // COMMA
      return true;
  }

  return false;
};

module.exports = Creatable;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = _react2.default.createClass({
	displayName: 'Option',

	propTypes: {
		children: _react2.default.PropTypes.node,
		className: _react2.default.PropTypes.string, // className (based on mouse position)
		instancePrefix: _react2.default.PropTypes.string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _react2.default.PropTypes.bool, // the option is disabled
		isFocused: _react2.default.PropTypes.bool, // the option is focused
		isSelected: _react2.default.PropTypes.bool, // the option is selected
		onFocus: _react2.default.PropTypes.func, // method to handle mouseEnter on option element
		onSelect: _react2.default.PropTypes.func, // method to handle click on option element
		onUnfocus: _react2.default.PropTypes.func, // method to handle mouseLeave on option element
		option: _react2.default.PropTypes.object.isRequired, // object that is base for that option
		optionIndex: _react2.default.PropTypes.number },
	blockEvent: function blockEvent(event) {
		event.preventDefault();
		event.stopPropagation();
		if (event.target.tagName !== 'A' || !('href' in event.target)) {
			return;
		}
		if (event.target.target) {
			window.open(event.target.href, event.target.target);
		} else {
			window.location.href = event.target.href;
		}
	},
	handleMouseDown: function handleMouseDown(event) {
		event.preventDefault();
		event.stopPropagation();
		this.props.onSelect(this.props.option, event);
	},
	handleMouseEnter: function handleMouseEnter(event) {
		this.onFocus(event);
	},
	handleMouseMove: function handleMouseMove(event) {
		this.onFocus(event);
	},
	handleTouchEnd: function handleTouchEnd(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		this.handleMouseDown(event);
	},
	handleTouchMove: function handleTouchMove(event) {
		// Set a flag that the view is being dragged
		this.dragging = true;
	},
	handleTouchStart: function handleTouchStart(event) {
		// Set a flag that the view is not being dragged
		this.dragging = false;
	},
	onFocus: function onFocus(event) {
		if (!this.props.isFocused) {
			this.props.onFocus(this.props.option, event);
		}
	},
	render: function render() {
		var _props = this.props,
		    option = _props.option,
		    instancePrefix = _props.instancePrefix,
		    optionIndex = _props.optionIndex;

		var className = (0, _classnames2.default)(this.props.className, option.className);

		return option.disabled ? _react2.default.createElement(
			'div',
			{ className: className,
				onMouseDown: this.blockEvent,
				onClick: this.blockEvent },
			this.props.children
		) : _react2.default.createElement(
			'div',
			{ className: className,
				style: option.style,
				role: 'option',
				onMouseDown: this.handleMouseDown,
				onMouseEnter: this.handleMouseEnter,
				onMouseMove: this.handleMouseMove,
				onTouchStart: this.handleTouchStart,
				onTouchMove: this.handleTouchMove,
				onTouchEnd: this.handleTouchEnd,
				id: instancePrefix + '-option-' + optionIndex,
				title: option.title },
			this.props.children
		);
	}
});

module.exports = Option;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Value = _react2.default.createClass({

	displayName: 'Value',

	propTypes: {
		children: _react2.default.PropTypes.node,
		disabled: _react2.default.PropTypes.bool, // disabled prop passed to ReactSelect
		id: _react2.default.PropTypes.string, // Unique id for the value - used for aria
		onClick: _react2.default.PropTypes.func, // method to handle click on value label
		onRemove: _react2.default.PropTypes.func, // method to handle removal of the value
		value: _react2.default.PropTypes.object.isRequired },

	handleMouseDown: function handleMouseDown(event) {
		if (event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		if (this.props.onClick) {
			event.stopPropagation();
			this.props.onClick(this.props.value, event);
			return;
		}
		if (this.props.value.href) {
			event.stopPropagation();
		}
	},
	onRemove: function onRemove(event) {
		event.preventDefault();
		event.stopPropagation();
		this.props.onRemove(this.props.value);
	},
	handleTouchEndRemove: function handleTouchEndRemove(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		// Fire the mouse events
		this.onRemove(event);
	},
	handleTouchMove: function handleTouchMove(event) {
		// Set a flag that the view is being dragged
		this.dragging = true;
	},
	handleTouchStart: function handleTouchStart(event) {
		// Set a flag that the view is not being dragged
		this.dragging = false;
	},
	renderRemoveIcon: function renderRemoveIcon() {
		if (this.props.disabled || !this.props.onRemove) return;
		return _react2.default.createElement(
			'span',
			{ className: 'Select-value-icon',
				'aria-hidden': 'true',
				onMouseDown: this.onRemove,
				onTouchEnd: this.handleTouchEndRemove,
				onTouchStart: this.handleTouchStart,
				onTouchMove: this.handleTouchMove },
			'\xD7'
		);
	},
	renderLabel: function renderLabel() {
		var className = 'Select-value-label';
		return this.props.onClick || this.props.value.href ? _react2.default.createElement(
			'a',
			{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
			this.props.children
		) : _react2.default.createElement(
			'span',
			{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
			this.props.children
		);
	},
	render: function render() {
		return _react2.default.createElement(
			'div',
			{ className: (0, _classnames2.default)('Select-value', this.props.value.className),
				style: this.props.value.style,
				title: this.props.value.title
			},
			this.renderRemoveIcon(),
			this.renderLabel()
		);
	}
});

module.exports = Value;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = arrowRenderer;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return _react2.default.createElement("span", {
		className: "Select-arrow",
		onMouseDown: onMouseDown
	});
};
module.exports = exports["default"];

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = clearRenderer;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function clearRenderer() {
	return _react2.default.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};
module.exports = exports['default'];

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__(0);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(117);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _PropTypes = __webpack_require__(983);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm A fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `ENTERING`
 *  - `ENTERED`
 *  - `EXITING`
 *  - `EXITED`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state= { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;
    _this.nextStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.nextStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null }; // allows for nested Transitions
  };

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true);
  };

  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var status = this.state.status;


    if (nextProps.in) {
      if (status === UNMOUNTED) {
        this.setState({ status: EXITED });
      }
      if (status !== ENTERING && status !== ENTERED) {
        this.nextStatus = ENTERING;
      }
    } else {
      if (status === ENTERING || status === ENTERED) {
        this.nextStatus = EXITING;
      }
    }
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateStatus();
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;


    if (this.nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (this.nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }

      this.nextStatus = null;
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    this.setState(nextState, this.setNextCallback(callback));
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `apprear` only an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration for the transition, in milliseconds.
   * Required unless `addEventListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occuring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occuring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "enter" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occuring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};

// Name the function so it is clearer in the documentation
function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = Transition;

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ChildMapping = __webpack_require__(982);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes = {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   */
  component: _propTypes2.default.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them throguh if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes2.default.node,

  /**
   * A convenience prop that enables or disabled appear animations
   * for all children. Note that specifiying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disabled enter animations
   * for all children. Note that specifiying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes2.default.bool,
  /**
    * A convenience prop that enables or disabled exit animations
    * for all children. Note that specifiying this will override any defaults set
    * on individual children Transitions.
    */
  exit: _propTypes2.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes2.default.func
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};

/**
 * The `<TransitionGroup>` component manages a set of `<Transition>` components
 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
 * state machine for managing the mounting and unmounting of components over
 * time.
 *
 * Consider the example below using the `Fade` CSS transition from before.
 * As items are removed or added to the TodoList the `in` prop is toggled
 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
 * component in a `<TransitionGroup>`, not just css.
 *
 * ```jsx
 * import TransitionGroup from 'react-transition-group/TransitionGroup';
 *
 * class TodoList extends React.Component {
 *   constructor(props) {
 *     super(props)
 *     this.state = {items: ['hello', 'world', 'click', 'me']}
 *   }
 *   handleAdd() {
 *     const newItems = this.state.items.concat([
 *       prompt('Enter some text')
 *     ]);
 *     this.setState({ items: newItems });
 *   }
 *   handleRemove(i) {
 *     let newItems = this.state.items.slice();
 *     newItems.splice(i, 1);
 *     this.setState({items: newItems});
 *   }
 *   render() {
 *     return (
 *       <div>
 *         <button onClick={() => this.handleAdd()}>Add Item</button>
 *         <TransitionGroup>
 *           {this.state.items.map((item, i) => (
 *             <FadeTransition key={item}>
 *               <div>
 *                 {item}{' '}
 *                 <button onClick={() => this.handleRemove(i)}>
 *                   remove
 *                 </button>
 *               </div>
 *             </FadeTransition>
 *           ))}
 *         </TransitionGroup>
 *       </div>
 *     );
 *   }
 * }
 * ```
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual `<Transition>`
 * components. This means you can mix and match animations across different
 * list items.
 */

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    // Initial children should all be entering, dependent on appear
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleExited = function (key, node, originalHandler) {
      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (key in currentChildMapping) return;

      if (originalHandler) originalHandler(node);

      _this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[key];
        return { children: children };
      });
    };

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children, function (child) {
        var onExited = function onExited(node) {
          _this.handleExited(child.key, node, child.props.onExited);
        };

        return (0, _react.cloneElement)(child, {
          onExited: onExited,
          in: true,
          appear: _this.getProp(child, 'appear'),
          enter: _this.getProp(child, 'enter'),
          exit: _this.getProp(child, 'exit')
        });
      })
    };
    return _this;
  }

  TransitionGroup.prototype.getChildContext = function getChildContext() {
    return {
      transitionGroup: { isMounting: !this.appeared }
    };
  };
  // use child config unless explictly set by the Group


  TransitionGroup.prototype.getProp = function getProp(child, prop) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;

    return props[prop] != null ? props[prop] : child.props[prop];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var prevChildMapping = this.state.children;
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);

    var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);

    Object.keys(children).forEach(function (key) {
      var child = children[key];

      if (!(0, _react.isValidElement)(child)) return;

      var onExited = function onExited(node) {
        _this2.handleExited(child.key, node, child.props.onExited);
      };

      var hasPrev = key in prevChildMapping;
      var hasNext = key in nextChildMapping;

      var prevChild = prevChildMapping[key];
      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;

      // item is new (entering)
      if (hasNext && (!hasPrev || isLeaving)) {
        // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
          onExited: onExited,
          in: true,
          exit: _this2.getProp(child, 'exit', nextProps),
          enter: _this2.getProp(child, 'enter', nextProps)
        });
      }
      // item is old (exiting)
      else if (!hasNext && hasPrev && !isLeaving) {
          // console.log('leaving', key)
          children[key] = (0, _react.cloneElement)(child, { in: false });
        }
        // item hasn't changed transition states
        // copy over the last transition props;
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
            // console.log('unchanged', key)
            children[key] = (0, _react.cloneElement)(child, {
              onExited: onExited,
              in: prevChild.props.in,
              exit: _this2.getProp(child, 'exit', nextProps),
              enter: _this2.getProp(child, 'enter', nextProps)
            });
          }
    });

    this.setState({ children: children });
  };

  TransitionGroup.prototype.render = function render() {
    var _props = this.props,
        Component = _props.component,
        childFactory = _props.childFactory,
        props = _objectWithoutProperties(_props, ['component', 'childFactory']);

    var children = this.state.children;


    delete props.appear;
    delete props.enter;
    delete props.exit;

    return _react2.default.createElement(
      Component,
      props,
      values(children).map(childFactory)
    );
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes2.default.object.isRequired
};


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(1);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = Object.create(null);

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(122);

var invariant = __webpack_require__(3);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(985);
var ReactElement = __webpack_require__(95);

var emptyFunction = __webpack_require__(29);
var traverseAllChildren = __webpack_require__(995);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(95);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(95),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(414);

module.exports = factory(isValidElement);

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(442),
    Component = _require.Component;

var _require2 = __webpack_require__(95),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(445);
var factory = __webpack_require__(283);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(122);

var ReactElement = __webpack_require__(95);

var invariant = __webpack_require__(3);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(122);

var ReactCurrentOwner = __webpack_require__(52);
var REACT_ELEMENT_TYPE = __webpack_require__(444);

var getIteratorFn = __webpack_require__(991);
var invariant = __webpack_require__(3);
var KeyEscapeUtils = __webpack_require__(984);
var warning = __webpack_require__(6);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object');
};

exports.default = isClassComponent;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isClassComponent = __webpack_require__(996);

var _isClassComponent2 = _interopRequireDefault(_isClassComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
  return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes && ("production" === 'production' || !Component.propTypes));
};

exports.default = isReferentiallyTransparentFunctionComponent;

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

exports.default = setStatic;

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shallowEqual = __webpack_require__(113);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shallowEqual2.default;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _setDisplayName = __webpack_require__(448);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(123);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _createEagerFactory = __webpack_require__(157);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);

    var ShouldUpdate = function (_Component) {
      _inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        _classCallCheck(this, ShouldUpdate);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

exports.default = shouldUpdate;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
  if (!hasKey && isReferentiallyTransparent) {
    if (children) {
      return type(_extends({}, props, { children: children }));
    }
    return type(props);
  }

  var Component = type;

  if (children) {
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  }

  return _react2.default.createElement(Component, props);
};

exports.default = createEagerElementUtil;

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

/**
 * sprintf implementation. Get pretty indented monospace strings.
 * @param {String} str - the string to parse
 * @param {...*} args - arguments, used in order, or referenced by n$
 * @returns {String}
 * @example
 * // Type casting...
 * sprintf('%s', 10); // '10'
 * sprintf('%s', 'abc'); // 'abc'
 *
 * // Escape anything else
 * sprintf('%%', 1); // '%'
 * sprintf('%T', 'abc'); // 'T'
 *
 * // Limit length
 * sprintf("%.5s", 'abcdef'); // 'bcdef'
 * sprintf("%-.5s", 'abcdef'); // 'abcde'
 *
 * // Indent to length
 * sprintf("%5s", 'a'); // '    a'
 * sprintf("%-5s", 'a'); // 'a    '
 * sprintf("%5.4s", 'abc'); // ' abc'
 * sprintf("%-5.4s", 'abc'); // 'abc '
 *
 * // Use pad chars
 * sprintf("%04s", 10); // "0010"
 * sprintf("%'#4s", 10); // "##10"
 *
 * // Use arguments in order
 * sprintf("%1$s, %2$s, %2$s, %1$s!", 'left', 'right'); // 'left, right, right, left!'
 */

var undefined,
	/* method vars */
	r = /%(\+)?(\d+\$)?(0|'.)?(-)?(\d+)?(\.\d+)?(.)/g,
	s = function(str) {
		var value,
			index = 1,
			execMatch,
			tempVar1,
			tempVar2,
			tempVar3;
		while (execMatch = r.exec(str)) {
			value = execMatch[7];

			// arg from index
			if ((tempVar2 = execMatch[2]) && tempVar2[(tempVar1 = tempVar2.length - 1)] == "$") {
				tempVar2 = tempVar2.substr(0, tempVar1);
			}

			if (s[tempVar1 = value.toLowerCase()] &&
				(tempVar3 = s[tempVar1](arguments[tempVar2 || index], /[A-Z]/.test(value), execMatch[1])) !== undefined) {

				value=''+tempVar3;

				// pad char
				if (tempVar1 = execMatch[3]) {
					if (tempVar1[0] == "'") {
						tempVar1 = tempVar1[1];
					}
				} else {
					tempVar1 = ' ';
				}
				if (tempVar2 = execMatch[5]) while (value.length < tempVar2) {
					value = execMatch[4] ? (value + tempVar1) : (tempVar1 + value);
				}

				if ((tempVar1 = execMatch[6] && execMatch[6].substr(1)) && value.length > tempVar1) {
					value = execMatch[4] ? value.substr(0, tempVar1) : value.substr(value.length - tempVar1);
				}
				index++;
			}
			str = str.substr(0, tempVar1 = execMatch.index) + value + str.substr(r.lastIndex);
			r.lastIndex = value.length + tempVar1;
		}
		return str;
	};

/**
 * Returns string value only if lowercase s.
 * @param {*} value
 * @param {Boolean} caps
 * @returns {String|undefined}
 */
s.s=function(value, caps) {
	return caps ? undefined : value+'';
};

module.exports = s;

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 1004 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports = {
	"101": "Facilities",
	"104": "Facilities",
	"105": "Facilities",
	"106": "Facilities",
	"107": "Facilities",
	"Alcazar, Lucas": "Information Technology",
	"Azada, Lars": "Engineering",
	"Balas, Felix": "Engineering",
	"Barranco, Ingrid": "Executive",
	"Baza, Isak": "Information Technology",
	"Bergen, Linnea": "Information Technology",
	"Bodrogi, Loreto": "Security",
	"Borrasca, Isande": "Engineering",
	"Calixto, Nils": "Information Technology",
	"Calzas, Axel": "Engineering",
	"Campo-Corrente, Ada": "Executive",
	"Cazar, Gustav": "Engineering",
	"Cocinaro, Hideki": "Security",
	"Dedos, Lidelse": "Engineering",
	"Ferro, Inga": "Security",
	"Flecha, Sven": "Information Technology",
	"Frente, Birgitta": "Engineering",
	"Frente, Vira": "Engineering",
	"Fusil, Stenig": "Security",
	"Herrero, Kanon": "Security",
	"Lagos, Varja": "Security",
	"Mies, Minke": "Security",
	"Nubarron, Adra": "Engineering",
	"Onda, Marin": "Engineering",
	"Orilla, Elsa": "Engineering",
	"Orilla, Kare": "Engineering",
	"Osvaldo, Hennie": "Security",
	"Ovan, Bertrand": "Facilities",
	"Resumir, Felix": "Security",
	"Sanjorge Jr., Sten": "Executive",
	"Strum, Orhan": "Executive",
	"Tempestad, Brand": "Engineering",
	"Vann, Edvard": "Security",
	"Vann, Isia": "Security",
	"Vasco-Pais, Willem": "Executive"
};

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

module.exports = [
	{
		"date": "2014-01-06 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Shopping",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Shopping",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Alcazar, Lucas",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Azada, Lars",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Azada, Lars",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Azada, Lars",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Azada, Lars",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Balas, Felix",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Balas, Felix",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Balas, Felix",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Balas, Felix",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Balas, Felix",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Balas, Felix",
		"activity": "Gas",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Balas, Felix",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Balas, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Coffee",
		"hour": 6
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Coffee",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Shopping",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Shopping",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Recreation",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Recreation",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Recreation",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Shopping",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Recreation",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Recreation",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Recreation",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Barranco, Ingrid",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Baza, Isak",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Baza, Isak",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Baza, Isak",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Baza, Isak",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Baza, Isak",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Baza, Isak",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Baza, Isak",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Baza, Isak",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Baza, Isak",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Baza, Isak",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Baza, Isak",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Baza, Isak",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Baza, Isak",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Baza, Isak",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Baza, Isak",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Baza, Isak",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Shopping",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Coffee",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Coffee",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Shopping",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Shopping",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bergen, Linnea",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Lodging",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Lodging",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Lodging",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Lodging",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Coffee",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Dining",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Lodging",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Lodging",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Lodging",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Lodging",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Lodging",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Shopping",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Shopping",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Borrasca, Isande",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calixto, Nils",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Unknown",
		"hour": 20
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calixto, Nils",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Unknown",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Unknown",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Unknown",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Unknown",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Unknown",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Unknown",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Shopping",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Shopping",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Shopping",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Shopping",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Shopping",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Shopping",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Shopping",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Shopping",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Shopping",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Shopping",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Shopping",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Shopping",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Unknown",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Unknown",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Unknown",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Unknown",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Unknown",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Unknown",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calzas, Axel",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Shopping",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Shopping",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Unknown",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Calzas, Axel",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Coffee",
		"hour": 6
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Recreation",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Recreation",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Recreation",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Shopping",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Shopping",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Recreation",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Recreation",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Recreation",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Campo-Corrente, Ada",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Shopping",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cazar, Gustav",
		"activity": "Unknown",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Cocinaro, Hideki",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Shopping",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ferro, Inga",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ferro, Inga",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Dining",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Shopping",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Coffee",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Dedos, Lidelse",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Gas",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Recreation",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Recreation",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Bodrogi, Loreto",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Isia",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Isia",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Isia",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Isia",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Isia",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Isia",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Isia",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Isia",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Isia",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Isia",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Isia",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Isia",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Isia",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Isia",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Isia",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Isia",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Isia",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Isia",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Isia",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Isia",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Isia",
		"activity": "Shopping",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Isia",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Isia",
		"activity": "Shopping",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Isia",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Flecha, Sven",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Recreation",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Recreation",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Recreation",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Recreation",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Flecha, Sven",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Coffee",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Birgitta",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 6
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Vira",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Vira",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Vira",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Vira",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Vira",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Vira",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Vira",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Vira",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Vira",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Vira",
		"activity": "Shopping",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Vira",
		"activity": "Shopping",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Vira",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Vira",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Vira",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Vira",
		"activity": "Shopping",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Frente, Vira",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Shopping",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Fusil, Stenig",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Unknown",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Unknown",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Unknown",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Unknown",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Osvaldo, Hennie",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Shopping",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Recreation",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Recreation",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Recreation",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Recreation",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Recreation",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Recreation",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Recreation",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Recreation",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Recreation",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Herrero, Kanon",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Gas",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Shopping",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Lagos, Varja",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Shopping",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Lagos, Varja",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Mies, Minke",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Mies, Minke",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Mies, Minke",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Mies, Minke",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Mies, Minke",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Mies, Minke",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Mies, Minke",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Mies, Minke",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Mies, Minke",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Mies, Minke",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Mies, Minke",
		"activity": "Shopping",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Mies, Minke",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Mies, Minke",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Mies, Minke",
		"activity": "Shopping",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Mies, Minke",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Mies, Minke",
		"activity": "Shopping",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Mies, Minke",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Mies, Minke",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Mies, Minke",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Mies, Minke",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Mies, Minke",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Mies, Minke",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Mies, Minke",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Mies, Minke",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Mies, Minke",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Mies, Minke",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Mies, Minke",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Mies, Minke",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Mies, Minke",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Mies, Minke",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Mies, Minke",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Mies, Minke",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Mies, Minke",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Shopping",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Shopping",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Recreation",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Recreation",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Recreation",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Recreation",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Recreation",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Recreation",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Recreation",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Recreation",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Recreation",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Recreation",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Recreation",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Recreation",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Recreation",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Recreation",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Recreation",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Recreation",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Recreation",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Unknown",
		"hour": 20
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Recreation",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Recreation",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Recreation",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Recreation",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Recreation",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Recreation",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Shopping",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Nubarron, Adra",
		"activity": "Recreation",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Onda, Marin",
		"activity": "Shopping",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Onda, Marin",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Onda, Marin",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Onda, Marin",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Onda, Marin",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Onda, Marin",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Onda, Marin",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Onda, Marin",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Onda, Marin",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Onda, Marin",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Onda, Marin",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Onda, Marin",
		"activity": "Shopping",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Onda, Marin",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Onda, Marin",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Onda, Marin",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Onda, Marin",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Onda, Marin",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Onda, Marin",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Onda, Marin",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Onda, Marin",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Onda, Marin",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Onda, Marin",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Onda, Marin",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Onda, Marin",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Onda, Marin",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Onda, Marin",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Coffee",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Kare",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Coffee",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Kare",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 20
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Orilla, Elsa",
		"activity": "Unknown",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Gas",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Dining",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Shopping",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Shopping",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Shopping",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Coffee",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Ovan, Bertrand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Recreation",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Recreation",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Recreation",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Recreation",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Recreation",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Resumir, Felix",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Resumir, Felix",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Recreation",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Recreation",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Recreation",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Sanjorge Jr., Sten",
		"activity": "Lodging",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Shopping",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Shopping",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Shopping",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Dining",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Dining",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Strum, Orhan",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Shopping",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Shopping",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Shopping",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Recreation",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Recreation",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Recreation",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Recreation",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Recreation",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Recreation",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Strum, Orhan",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Lodging",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Lodging",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Lodging",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Lodging",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Recreation",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Recreation",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Recreation",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Recreation",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Recreation",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Lodging",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Lodging",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Lodging",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Lodging",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Lodging",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Lodging",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Tempestad, Brand",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Shopping",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Recreation",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Recreation",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Recreation",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Recreation",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Coffee",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Coffee",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Edvard",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Recreation",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Recreation",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Recreation",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Recreation",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Recreation",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Shopping",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Shopping",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vann, Edvard",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Coffee",
		"hour": 6
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Coffee",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Coffee",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Recreation",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Recreation",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Recreation",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Recreation",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Recreation",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Recreation",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Shopping",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Shopping",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Coffee",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 21
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Coffee",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 21
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 20
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 13
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 18
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Shopping",
		"hour": 15
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 23
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Shopping",
		"hour": 14
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-18 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 22
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 11
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 0
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 10
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 12
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 6
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 5
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 16
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 20
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Recreation",
		"hour": 14
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 3
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 4
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 7
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 9
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Dining",
		"hour": 19
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 8
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Recreation",
		"hour": 13
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 18
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 2
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 17
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Recreation",
		"hour": 15
	},
	{
		"date": "2014-01-19 00:00:00",
		"name": "Vasco-Pais, Willem",
		"activity": "Home",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "101",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "101",
		"activity": "Public",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "101",
		"activity": "Public",
		"hour": 7
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "101",
		"activity": "Public",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "101",
		"activity": "Public",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "101",
		"activity": "Public",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "101",
		"activity": "Public",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "101",
		"activity": "Dining",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "101",
		"activity": "Public",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "101",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "101",
		"activity": "Public",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "101",
		"activity": "Public",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "101",
		"activity": "Public",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "101",
		"activity": "Unknown",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "101",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "101",
		"activity": "Industrial",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "101",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "104",
		"activity": "Unknown",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "104",
		"activity": "Unknown",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "104",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "104",
		"activity": "Unknown",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "104",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "104",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "104",
		"activity": "Public",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "105",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "105",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "105",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "105",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "105",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "105",
		"activity": "Coffee",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "105",
		"activity": "Unknown",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "105",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "105",
		"activity": "Industrial",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "105",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "106",
		"activity": "Public",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "106",
		"activity": "Industrial",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "106",
		"activity": "Industrial",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "106",
		"activity": "Industrial",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "106",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "106",
		"activity": "Industrial",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "106",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "106",
		"activity": "Industrial",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "106",
		"activity": "Industrial",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "106",
		"activity": "Industrial",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "106",
		"activity": "Industrial",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "106",
		"activity": "Industrial",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "106",
		"activity": "Industrial",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "106",
		"activity": "Industrial",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "106",
		"activity": "Industrial",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "106",
		"activity": "Industrial",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "106",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "106",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "106",
		"activity": "Industrial",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "106",
		"activity": "Industrial",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "106",
		"activity": "Industrial",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "106",
		"activity": "Unknown",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "106",
		"activity": "Industrial",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "106",
		"activity": "Unknown",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "106",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "106",
		"activity": "Industrial",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "106",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 9
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 8
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-06 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 21
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 20
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 13
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 18
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 15
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 23
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 14
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 19
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 9
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 17
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 16
	},
	{
		"date": "2014-01-07 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 22
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 21
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 5
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 20
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 3
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 8
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 13
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 18
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 15
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 1
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 0
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 6
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 23
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 14
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 19
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 4
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 7
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 9
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 2
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 17
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 16
	},
	{
		"date": "2014-01-08 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 22
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 21
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 5
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 20
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 3
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 8
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 13
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 18
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 15
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 1
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 0
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 6
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 23
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 14
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 19
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 4
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 7
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 9
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 2
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 17
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 16
	},
	{
		"date": "2014-01-09 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 22
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 5
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 3
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 8
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 1
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 0
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 6
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 4
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 7
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 9
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 2
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-10 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-11 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 10
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 11
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 9
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-12 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 9
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-13 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 9
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-14 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 21
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 20
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 18
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 15
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 1
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 23
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 14
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 19
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 9
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "107",
		"activity": "Unknown",
		"hour": 17
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 16
	},
	{
		"date": "2014-01-15 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 22
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 21
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 5
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 20
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 3
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 8
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 13
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 18
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 15
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 1
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 0
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 12
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 6
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 23
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 14
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 19
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 4
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 7
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 9
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 2
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 17
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 16
	},
	{
		"date": "2014-01-16 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 22
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 11
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 0
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 10
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "107",
		"activity": "Unknown",
		"hour": 12
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 6
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 5
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 16
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 14
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 3
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 4
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 7
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 9
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 8
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "107",
		"activity": "Unknown",
		"hour": 13
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 2
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 17
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "107",
		"activity": "Industrial",
		"hour": 15
	},
	{
		"date": "2014-01-17 00:00:00",
		"name": "107",
		"activity": "GASTech",
		"hour": 1
	}
];

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(449);
module.exports = __webpack_require__(450);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.63bdced6.js